/*! For license information please see main.js.LICENSE.txt */
!(function () {
    var e = {
            1983: function (e, t, i) {
                "use strict";
                i(6266), i(990), i(911), i(4160), i(6197), i(6728), i(4039), i(3568), i(8051), i(8250), i(5434), i(4952), i(6337), i(5666);
            },
            8252: function (e, t, i) {
                "use strict";
                i.r(t),
                    i.d(t, {
                        Carousel: function () {
                            return K;
                        },
                        Fancybox: function () {
                            return at;
                        },
                        Panzoom: function () {
                            return z;
                        },
                    });
                const n = (e, t = 1e4) => ((e = parseFloat(e + "") || 0), Math.round((e + Number.EPSILON) * t) / t),
                    r = function (e) {
                        if (!(e && e instanceof Element && e.offsetParent)) return !1;
                        const t = e.scrollHeight > e.clientHeight,
                            i = window.getComputedStyle(e).overflowY,
                            n = -1 !== i.indexOf("hidden"),
                            r = -1 !== i.indexOf("visible");
                        return t && !n && !r;
                    },
                    s = function (e, t = void 0) {
                        return !(!e || e === document.body || (t && e === t)) && (r(e) ? e : s(e.parentElement, t));
                    },
                    o = function (e) {
                        var t = new DOMParser().parseFromString(e, "text/html").body;
                        if (t.childElementCount > 1) {
                            for (var i = document.createElement("div"); t.firstChild; ) i.appendChild(t.firstChild);
                            return i;
                        }
                        return t.firstChild;
                    },
                    a = (e) => `${e || ""}`.split(" ").filter((e) => !!e),
                    l = (e, t, i) => {
                        e &&
                            a(t).forEach((t) => {
                                e.classList.toggle(t, i || !1);
                            });
                    };
                class c {
                    constructor(e) {
                        Object.defineProperty(this, "pageX", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "pageY", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "clientX", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "clientY", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "id", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "time", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "nativePointer", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            (this.nativePointer = e),
                            (this.pageX = e.pageX),
                            (this.pageY = e.pageY),
                            (this.clientX = e.clientX),
                            (this.clientY = e.clientY),
                            (this.id = self.Touch && e instanceof Touch ? e.identifier : -1),
                            (this.time = Date.now());
                    }
                }
                const u = { passive: !1 };
                class d {
                    constructor(e, { start: t = () => !0, move: i = () => {}, end: n = () => {} }) {
                        Object.defineProperty(this, "element", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "startCallback", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "moveCallback", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "endCallback", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "currentPointers", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            Object.defineProperty(this, "startPointers", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            (this.element = e),
                            (this.startCallback = t),
                            (this.moveCallback = i),
                            (this.endCallback = n);
                        for (const e of ["onPointerStart", "onTouchStart", "onMove", "onTouchEnd", "onPointerEnd", "onWindowBlur"]) this[e] = this[e].bind(this);
                        this.element.addEventListener("mousedown", this.onPointerStart, u),
                            this.element.addEventListener("touchstart", this.onTouchStart, u),
                            this.element.addEventListener("touchmove", this.onMove, u),
                            this.element.addEventListener("touchend", this.onTouchEnd),
                            this.element.addEventListener("touchcancel", this.onTouchEnd);
                    }
                    onPointerStart(e) {
                        if (!e.buttons || 0 !== e.button) return;
                        const t = new c(e);
                        this.currentPointers.some((e) => e.id === t.id) ||
                            (this.triggerPointerStart(t, e) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur)));
                    }
                    onTouchStart(e) {
                        for (const t of Array.from(e.changedTouches || [])) this.triggerPointerStart(new c(t), e);
                        window.addEventListener("blur", this.onWindowBlur);
                    }
                    onMove(e) {
                        const t = this.currentPointers.slice(),
                            i = "changedTouches" in e ? Array.from(e.changedTouches || []).map((e) => new c(e)) : [new c(e)],
                            n = [];
                        for (const e of i) {
                            const t = this.currentPointers.findIndex((t) => t.id === e.id);
                            t < 0 || (n.push(e), (this.currentPointers[t] = e));
                        }
                        n.length && this.moveCallback(e, this.currentPointers.slice(), t);
                    }
                    onPointerEnd(e) {
                        (e.buttons > 0 && 0 !== e.button) ||
                            (this.triggerPointerEnd(e, new c(e)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
                    }
                    onTouchEnd(e) {
                        for (const t of Array.from(e.changedTouches || [])) this.triggerPointerEnd(e, new c(t));
                    }
                    triggerPointerStart(e, t) {
                        return !!this.startCallback(t, e, this.currentPointers.slice()) && (this.currentPointers.push(e), this.startPointers.push(e), !0);
                    }
                    triggerPointerEnd(e, t) {
                        const i = this.currentPointers.findIndex((e) => e.id === t.id);
                        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(e, t, this.currentPointers.slice()));
                    }
                    onWindowBlur() {
                        this.clear();
                    }
                    clear() {
                        for (; this.currentPointers.length; ) {
                            const e = this.currentPointers[this.currentPointers.length - 1];
                            this.currentPointers.splice(this.currentPointers.length - 1, 1),
                                this.startPointers.splice(this.currentPointers.length - 1, 1),
                                this.endCallback(new Event("touchend", { bubbles: !0, cancelable: !0, clientX: e.clientX, clientY: e.clientY }), e, this.currentPointers.slice());
                        }
                    }
                    stop() {
                        this.element.removeEventListener("mousedown", this.onPointerStart, u),
                            this.element.removeEventListener("touchstart", this.onTouchStart, u),
                            this.element.removeEventListener("touchmove", this.onMove, u),
                            this.element.removeEventListener("touchend", this.onTouchEnd),
                            this.element.removeEventListener("touchcancel", this.onTouchEnd),
                            window.removeEventListener("mousemove", this.onMove),
                            window.removeEventListener("mouseup", this.onPointerEnd),
                            window.removeEventListener("blur", this.onWindowBlur);
                    }
                }
                function h(e, t) {
                    return t ? Math.sqrt(Math.pow(t.clientX - e.clientX, 2) + Math.pow(t.clientY - e.clientY, 2)) : 0;
                }
                function f(e, t) {
                    return t ? { clientX: (e.clientX + t.clientX) / 2, clientY: (e.clientY + t.clientY) / 2 } : e;
                }
                const p = (e) => "object" == typeof e && null !== e && e.constructor === Object && "[object Object]" === Object.prototype.toString.call(e),
                    m = (e, ...t) => {
                        const i = t.length;
                        for (let n = 0; n < i; n++) {
                            const i = t[n] || {};
                            Object.entries(i).forEach(([t, i]) => {
                                const n = Array.isArray(i) ? [] : {};
                                e[t] || Object.assign(e, { [t]: n }), p(i) ? Object.assign(e[t], m(n, i)) : Array.isArray(i) ? Object.assign(e, { [t]: [...i] }) : Object.assign(e, { [t]: i });
                            });
                        }
                        return e;
                    },
                    g = function (e, t) {
                        return e.split(".").reduce((e, t) => ("object" == typeof e ? e[t] : void 0), t);
                    };
                class v {
                    constructor(e = {}) {
                        Object.defineProperty(this, "options", { enumerable: !0, configurable: !0, writable: !0, value: e }),
                            Object.defineProperty(this, "events", { enumerable: !0, configurable: !0, writable: !0, value: new Map() }),
                            this.setOptions(e);
                        for (const e of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) e.startsWith("on") && "function" == typeof this[e] && (this[e] = this[e].bind(this));
                    }
                    setOptions(e) {
                        this.options = e ? m({}, this.constructor.defaults, e) : {};
                        for (const [e, t] of Object.entries(this.option("on") || {})) this.on(e, t);
                    }
                    option(e, ...t) {
                        let i = g(e, this.options);
                        return i && "function" == typeof i && (i = i.call(this, this, ...t)), i;
                    }
                    optionFor(e, t, i, ...n) {
                        let r = g(t, e);
                        var s;
                        "string" != typeof (s = r) || isNaN(s) || isNaN(parseFloat(s)) || (r = parseFloat(r)), "true" === r && (r = !0), "false" === r && (r = !1), r && "function" == typeof r && (r = r.call(this, this, e, ...n));
                        let o = g(t, this.options);
                        return o && "function" == typeof o ? (r = o.call(this, this, e, ...n, r)) : void 0 === r && (r = o), void 0 === r ? i : r;
                    }
                    cn(e) {
                        const t = this.options.classes;
                        return (t && t[e]) || "";
                    }
                    localize(e, t = []) {
                        e = String(e).replace(/\{\{(\w+).?(\w+)?\}\}/g, (e, t, i) => {
                            let n = "";
                            return i ? (n = this.option(`${t[0] + t.toLowerCase().substring(1)}.l10n.${i}`)) : t && (n = this.option(`l10n.${t}`)), n || (n = e), n;
                        });
                        for (let i = 0; i < t.length; i++) e = e.split(t[i][0]).join(t[i][1]);
                        return e.replace(/\{\{(.*?)\}\}/g, (e, t) => t);
                    }
                    on(e, t) {
                        let i = [];
                        "string" == typeof e ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
                            this.events || (this.events = new Map()),
                            i.forEach((e) => {
                                let i = this.events.get(e);
                                i || (this.events.set(e, []), (i = [])), i.includes(t) || i.push(t), this.events.set(e, i);
                            });
                    }
                    off(e, t) {
                        let i = [];
                        "string" == typeof e ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
                            i.forEach((e) => {
                                const i = this.events.get(e);
                                if (Array.isArray(i)) {
                                    const e = i.indexOf(t);
                                    e > -1 && i.splice(e, 1);
                                }
                            });
                    }
                    emit(e, ...t) {
                        [...(this.events.get(e) || [])].forEach((e) => e(this, ...t)), "*" !== e && this.emit("*", e, ...t);
                    }
                }
                Object.defineProperty(v, "version", { enumerable: !0, configurable: !0, writable: !0, value: "5.0.27" }), Object.defineProperty(v, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: {} });
                class b extends v {
                    constructor(e = {}) {
                        super(e), Object.defineProperty(this, "plugins", { enumerable: !0, configurable: !0, writable: !0, value: {} });
                    }
                    attachPlugins(e = {}) {
                        const t = new Map();
                        for (const [i, n] of Object.entries(e)) {
                            const e = this.option(i),
                                r = this.plugins[i];
                            r || !1 === e ? r && !1 === e && (r.detach(), delete this.plugins[i]) : t.set(i, new n(this, e || {}));
                        }
                        for (const [e, i] of t) (this.plugins[e] = i), i.attach();
                    }
                    detachPlugins(e) {
                        e = e || Object.keys(this.plugins);
                        for (const t of e) {
                            const e = this.plugins[t];
                            e && e.detach(), delete this.plugins[t];
                        }
                        return this.emit("detachPlugins"), this;
                    }
                }
                var y;
                !(function (e) {
                    (e[(e.Init = 0)] = "Init"), (e[(e.Error = 1)] = "Error"), (e[(e.Ready = 2)] = "Ready"), (e[(e.Panning = 3)] = "Panning"), (e[(e.Mousemove = 4)] = "Mousemove"), (e[(e.Destroy = 5)] = "Destroy");
                })(y || (y = {}));
                const w = ["a", "b", "c", "d", "e", "f"],
                    x = {
                        PANUP: "Move up",
                        PANDOWN: "Move down",
                        PANLEFT: "Move left",
                        PANRIGHT: "Move right",
                        ZOOMIN: "Zoom in",
                        ZOOMOUT: "Zoom out",
                        TOGGLEZOOM: "Toggle zoom level",
                        TOGGLE1TO1: "Toggle zoom level",
                        ITERATEZOOM: "Toggle zoom level",
                        ROTATECCW: "Rotate counterclockwise",
                        ROTATECW: "Rotate clockwise",
                        FLIPX: "Flip horizontally",
                        FLIPY: "Flip vertically",
                        FITX: "Fit horizontally",
                        FITY: "Fit vertically",
                        RESET: "Reset",
                        TOGGLEFS: "Toggle fullscreen",
                    },
                    S = {
                        content: null,
                        width: "auto",
                        height: "auto",
                        panMode: "drag",
                        touch: !0,
                        dragMinThreshold: 3,
                        lockAxis: !1,
                        mouseMoveFactor: 1,
                        mouseMoveFriction: 0.12,
                        zoom: !0,
                        pinchToZoom: !0,
                        panOnlyZoomed: "auto",
                        minScale: 1,
                        maxScale: 2,
                        friction: 0.25,
                        dragFriction: 0.35,
                        decelFriction: 0.05,
                        click: "toggleZoom",
                        dblClick: !1,
                        wheel: "zoom",
                        wheelLimit: 7,
                        spinner: !0,
                        bounds: "auto",
                        infinite: !1,
                        rubberband: !0,
                        bounce: !0,
                        maxVelocity: 75,
                        transformParent: !1,
                        classes: {
                            content: "f-panzoom__content",
                            isLoading: "is-loading",
                            canZoomIn: "can-zoom_in",
                            canZoomOut: "can-zoom_out",
                            isDraggable: "is-draggable",
                            isDragging: "is-dragging",
                            inFullscreen: "in-fullscreen",
                            htmlHasFullscreen: "with-panzoom-in-fullscreen",
                        },
                        l10n: x,
                    },
                    E = '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>',
                    _ = (e) => e && null !== e && e instanceof Element && "nodeType" in e,
                    T = (e, t) => {
                        e &&
                            a(t).forEach((t) => {
                                e.classList.remove(t);
                            });
                    },
                    M = (e, t) => {
                        e &&
                            a(t).forEach((t) => {
                                e.classList.add(t);
                            });
                    },
                    P = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 },
                    C = 1e4,
                    O = "mousemove",
                    L = "drag",
                    k = "content";
                let A = null,
                    I = null;
                class z extends b {
                    get fits() {
                        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
                    }
                    get isTouchDevice() {
                        return null === I && (I = window.matchMedia("(hover: none)").matches), I;
                    }
                    get isMobile() {
                        return null === A && (A = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), A;
                    }
                    get panMode() {
                        return this.options.panMode !== O || this.isTouchDevice ? L : O;
                    }
                    get panOnlyZoomed() {
                        const e = this.options.panOnlyZoomed;
                        return "auto" === e ? this.isTouchDevice : e;
                    }
                    get isInfinite() {
                        return this.option("infinite");
                    }
                    get angle() {
                        return (180 * Math.atan2(this.current.b, this.current.a)) / Math.PI || 0;
                    }
                    get targetAngle() {
                        return (180 * Math.atan2(this.target.b, this.target.a)) / Math.PI || 0;
                    }
                    get scale() {
                        const { a: e, b: t } = this.current;
                        return Math.sqrt(e * e + t * t) || 1;
                    }
                    get targetScale() {
                        const { a: e, b: t } = this.target;
                        return Math.sqrt(e * e + t * t) || 1;
                    }
                    get minScale() {
                        return this.option("minScale") || 1;
                    }
                    get fullScale() {
                        const { contentRect: e } = this;
                        return e.fullWidth / e.fitWidth || 1;
                    }
                    get maxScale() {
                        return this.fullScale * (this.option("maxScale") || 1) || 1;
                    }
                    get coverScale() {
                        const { containerRect: e, contentRect: t } = this,
                            i = Math.max(e.height / t.fitHeight, e.width / t.fitWidth) || 1;
                        return Math.min(this.fullScale, i);
                    }
                    get isScaling() {
                        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
                    }
                    get isContentLoading() {
                        const e = this.content;
                        return !!(e && e instanceof HTMLImageElement) && !e.complete;
                    }
                    get isResting() {
                        if (this.isBouncingX || this.isBouncingY) return !1;
                        for (const e of w) {
                            const t = "e" == e || "f" === e ? 1e-4 : 1e-5;
                            if (Math.abs(this.target[e] - this.current[e]) > t) return !1;
                        }
                        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
                    }
                    constructor(e, t = {}, i = {}) {
                        var n;
                        if (
                            (super(t),
                            Object.defineProperty(this, "pointerTracker", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "resizeObserver", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "updateTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "clickTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "rAF", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "isTicking", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "ignoreBounds", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "isBouncingX", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "isBouncingY", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "clicks", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "trackingPoints", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            Object.defineProperty(this, "pwt", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "cwd", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "pmme", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "friction", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: y.Init }),
                            Object.defineProperty(this, "isDragging", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "content", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "spinner", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "containerRect", { enumerable: !0, configurable: !0, writable: !0, value: { width: 0, height: 0, innerWidth: 0, innerHeight: 0 } }),
                            Object.defineProperty(this, "contentRect", {
                                enumerable: !0,
                                configurable: !0,
                                writable: !0,
                                value: { top: 0, right: 0, bottom: 0, left: 0, fullWidth: 0, fullHeight: 0, fitWidth: 0, fitHeight: 0, width: 0, height: 0 },
                            }),
                            Object.defineProperty(this, "dragStart", { enumerable: !0, configurable: !0, writable: !0, value: { x: 0, y: 0, top: 0, left: 0, time: 0 } }),
                            Object.defineProperty(this, "dragOffset", { enumerable: !0, configurable: !0, writable: !0, value: { x: 0, y: 0, time: 0 } }),
                            Object.defineProperty(this, "current", { enumerable: !0, configurable: !0, writable: !0, value: Object.assign({}, P) }),
                            Object.defineProperty(this, "target", { enumerable: !0, configurable: !0, writable: !0, value: Object.assign({}, P) }),
                            Object.defineProperty(this, "velocity", { enumerable: !0, configurable: !0, writable: !0, value: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0 } }),
                            Object.defineProperty(this, "lockedAxis", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            !e)
                        )
                            throw new Error("Container Element Not Found");
                        (this.container = e), this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, z.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
                        const r = this.content;
                        if ((r.addEventListener("load", this.onLoad), r.addEventListener("error", this.onError), this.isContentLoading)) {
                            if (this.option("spinner")) {
                                e.classList.add(this.cn("isLoading"));
                                const t = o(E);
                                !e.contains(r) || r.parentElement instanceof HTMLPictureElement ? (this.spinner = e.appendChild(t)) : (this.spinner = (null === (n = r.parentElement) || void 0 === n ? void 0 : n.insertBefore(t, r)) || null);
                            }
                            this.emit("beforeLoad");
                        } else
                            queueMicrotask(() => {
                                this.enable();
                            });
                    }
                    initContent() {
                        const { container: e } = this,
                            t = this.cn(k);
                        let i = this.option(k) || e.querySelector(`.${t}`);
                        if ((i || ((i = e.querySelector("img,picture") || e.firstElementChild), i && M(i, t)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i)) throw new Error("No content found");
                        this.content = i;
                    }
                    onLoad() {
                        const { spinner: e, container: t, state: i } = this;
                        e && (e.remove(), (this.spinner = null)), this.option("spinner") && t.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === y.Init ? this.enable() : this.updateMetrics();
                    }
                    onError() {
                        this.state !== y.Destroy && (this.spinner && (this.spinner.remove(), (this.spinner = null)), this.stop(), this.detachEvents(), (this.state = y.Error), this.emit("error"));
                    }
                    attachObserver() {
                        var e;
                        const t = () => {
                            const { container: e, containerRect: t } = this;
                            return Math.abs(t.width - e.getBoundingClientRect().width) > 0.1 || Math.abs(t.height - e.getBoundingClientRect().height) > 0.1;
                        };
                        this.resizeObserver ||
                            void 0 === window.ResizeObserver ||
                            (this.resizeObserver = new ResizeObserver(() => {
                                this.updateTimer ||
                                    (t()
                                        ? (this.onResize(),
                                          this.isMobile &&
                                              (this.updateTimer = setTimeout(() => {
                                                  t() && this.onResize(), (this.updateTimer = null);
                                              }, 500)))
                                        : this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null)));
                            })),
                            null === (e = this.resizeObserver) || void 0 === e || e.observe(this.container);
                    }
                    detachObserver() {
                        var e;
                        null === (e = this.resizeObserver) || void 0 === e || e.disconnect();
                    }
                    attachEvents() {
                        const { container: e } = this;
                        e.addEventListener("click", this.onClick, { passive: !1, capture: !1 }),
                            e.addEventListener("wheel", this.onWheel, { passive: !1 }),
                            (this.pointerTracker = new d(e, { start: this.onPointerDown, move: this.onPointerMove, end: this.onPointerUp })),
                            document.addEventListener(O, this.onMouseMove);
                    }
                    detachEvents() {
                        var e;
                        const { container: t } = this;
                        t.removeEventListener("click", this.onClick, { passive: !1, capture: !1 }),
                            t.removeEventListener("wheel", this.onWheel, { passive: !1 }),
                            null === (e = this.pointerTracker) || void 0 === e || e.stop(),
                            (this.pointerTracker = null),
                            document.removeEventListener(O, this.onMouseMove),
                            document.removeEventListener("keydown", this.onKeydown, !0),
                            this.clickTimer && (clearTimeout(this.clickTimer), (this.clickTimer = null)),
                            this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null));
                    }
                    animate() {
                        this.setTargetForce();
                        const e = this.friction,
                            t = this.option("maxVelocity");
                        for (const i of w)
                            e ? ((this.velocity[i] *= 1 - e), t && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], t), -1 * t)), (this.current[i] += this.velocity[i])) : (this.current[i] = this.target[i]);
                        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? (this.rAF = requestAnimationFrame(() => this.animate())) : this.stop("current");
                    }
                    setTargetForce() {
                        for (const e of w) ("e" === e && this.isBouncingX) || ("f" === e && this.isBouncingY) || (this.velocity[e] = (1 / (1 - this.friction) - 1) * (this.target[e] - this.current[e]));
                    }
                    checkBounds(e = 0, t = 0) {
                        const { current: i } = this,
                            n = i.e + e,
                            r = i.f + t,
                            s = this.getBounds(),
                            { x: o, y: a } = s,
                            l = o.min,
                            c = o.max,
                            u = a.min,
                            d = a.max;
                        let h = 0,
                            f = 0;
                        return (
                            l !== 1 / 0 && n < l ? (h = l - n) : c !== 1 / 0 && n > c && (h = c - n),
                            u !== 1 / 0 && r < u ? (f = u - r) : d !== 1 / 0 && r > d && (f = d - r),
                            Math.abs(h) < 1e-4 && (h = 0),
                            Math.abs(f) < 1e-4 && (f = 0),
                            Object.assign(Object.assign({}, s), { xDiff: h, yDiff: f, inBounds: !h && !f })
                        );
                    }
                    clampTargetBounds() {
                        const { target: e } = this,
                            { x: t, y: i } = this.getBounds();
                        t.min !== 1 / 0 && (e.e = Math.max(e.e, t.min)), t.max !== 1 / 0 && (e.e = Math.min(e.e, t.max)), i.min !== 1 / 0 && (e.f = Math.max(e.f, i.min)), i.max !== 1 / 0 && (e.f = Math.min(e.f, i.max));
                    }
                    calculateContentDim(e = this.current) {
                        const { content: t, contentRect: i } = this,
                            { fitWidth: n, fitHeight: r, fullWidth: s, fullHeight: o } = i;
                        let a = s,
                            l = o;
                        if (this.option("zoom") || 0 !== this.angle) {
                            const i = !(t instanceof HTMLImageElement || ("none" !== window.getComputedStyle(t).maxWidth && "none" !== window.getComputedStyle(t).maxHeight)),
                                c = i ? s : n,
                                u = i ? o : r,
                                d = this.getMatrix(e),
                                h = new DOMPoint(0, 0).matrixTransform(d),
                                f = new DOMPoint(0 + c, 0).matrixTransform(d),
                                p = new DOMPoint(0 + c, 0 + u).matrixTransform(d),
                                m = new DOMPoint(0, 0 + u).matrixTransform(d),
                                g = Math.abs(p.x - h.x),
                                v = Math.abs(p.y - h.y),
                                b = Math.abs(m.x - f.x),
                                y = Math.abs(m.y - f.y);
                            (a = Math.max(g, b)), (l = Math.max(v, y));
                        }
                        return { contentWidth: a, contentHeight: l };
                    }
                    setEdgeForce() {
                        if (this.ignoreBounds || this.isDragging || this.panMode === O || this.targetScale < this.scale) return (this.isBouncingX = !1), void (this.isBouncingY = !1);
                        const { target: e } = this,
                            { x: t, y: i, xDiff: n, yDiff: r } = this.checkBounds(),
                            s = this.option("maxVelocity");
                        let o = this.velocity.e,
                            a = this.velocity.f;
                        0 !== n
                            ? ((this.isBouncingX = !0),
                              n * o <= 0 ? (o += 0.14 * n) : ((o = 0.14 * n), t.min !== 1 / 0 && (this.target.e = Math.max(e.e, t.min)), t.max !== 1 / 0 && (this.target.e = Math.min(e.e, t.max))),
                              s && (o = Math.max(Math.min(o, s), -1 * s)))
                            : (this.isBouncingX = !1),
                            0 !== r
                                ? ((this.isBouncingY = !0),
                                  r * a <= 0 ? (a += 0.14 * r) : ((a = 0.14 * r), i.min !== 1 / 0 && (this.target.f = Math.max(e.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(e.f, i.max))),
                                  s && (a = Math.max(Math.min(a, s), -1 * s)))
                                : (this.isBouncingY = !1),
                            this.isBouncingX && (this.velocity.e = o),
                            this.isBouncingY && (this.velocity.f = a);
                    }
                    enable() {
                        const { content: e } = this,
                            t = new DOMMatrixReadOnly(window.getComputedStyle(e).transform);
                        for (const e of w) this.current[e] = this.target[e] = t[e];
                        this.updateMetrics(), this.attachObserver(), this.attachEvents(), (this.state = y.Ready), this.emit("ready");
                    }
                    onClick(e) {
                        var t;
                        "click" === e.type && 0 === e.detail && ((this.dragOffset.x = 0), (this.dragOffset.y = 0)),
                            this.isDragging && (null === (t = this.pointerTracker) || void 0 === t || t.clear(), (this.trackingPoints = []), this.startDecelAnim());
                        const i = e.target;
                        if (!i || e.defaultPrevented) return;
                        if (i.hasAttribute("disabled")) return e.preventDefault(), void e.stopPropagation();
                        if (
                            (() => {
                                const e = window.getSelection();
                                return e && "Range" === e.type;
                            })() &&
                            !i.closest("button")
                        )
                            return;
                        const n = i.closest("[data-panzoom-action]"),
                            r = i.closest("[data-panzoom-change]"),
                            s = n || r,
                            o = s && _(s) ? s.dataset : null;
                        if (o) {
                            const t = o.panzoomChange,
                                i = o.panzoomAction;
                            if (((t || i) && e.preventDefault(), t)) {
                                let i = {};
                                try {
                                    i = JSON.parse(t);
                                } catch (e) {
                                    console && console.warn("The given data was not valid JSON");
                                }
                                return void this.applyChange(i);
                            }
                            if (i) return void (this[i] && this[i]());
                        }
                        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return e.preventDefault(), void e.stopPropagation();
                        if (i.closest("[data-fancybox]")) return;
                        const a = this.content.getBoundingClientRect(),
                            l = this.dragStart;
                        if (l.time && !this.canZoomOut() && (Math.abs(a.x - l.x) > 2 || Math.abs(a.y - l.y) > 2)) return;
                        this.dragStart.time = 0;
                        const c = (t) => {
                                this.option("zoom", e) &&
                                    t &&
                                    "string" == typeof t &&
                                    /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(t) &&
                                    "function" == typeof this[t] &&
                                    (e.preventDefault(), this[t]({ event: e }));
                            },
                            u = this.option("click", e),
                            d = this.option("dblClick", e);
                        d
                            ? (this.clicks++,
                              1 == this.clicks &&
                                  (this.clickTimer = setTimeout(() => {
                                      1 === this.clicks ? (this.emit("click", e), !e.defaultPrevented && u && c(u)) : (this.emit("dblClick", e), e.defaultPrevented || c(d)), (this.clicks = 0), (this.clickTimer = null);
                                  }, 350)))
                            : (this.emit("click", e), !e.defaultPrevented && u && c(u));
                    }
                    addTrackingPoint(e) {
                        const t = this.trackingPoints.filter((e) => e.time > Date.now() - 100);
                        t.push(e), (this.trackingPoints = t);
                    }
                    onPointerDown(e, t, i) {
                        var n;
                        if (!1 === this.option("touch", e)) return !1;
                        (this.pwt = 0), (this.dragOffset = { x: 0, y: 0, time: 0 }), (this.trackingPoints = []);
                        const r = this.content.getBoundingClientRect();
                        if (((this.dragStart = { x: r.x, y: r.y, top: r.top, left: r.left, time: Date.now() }), this.clickTimer)) return !1;
                        if (this.panMode === O && this.targetScale > 1) return e.preventDefault(), e.stopPropagation(), !1;
                        const s = e.composedPath()[0];
                        if (!i.length) {
                            if (
                                ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO", "IFRAME"].includes(s.nodeName) ||
                                s.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")
                            )
                                return !1;
                            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
                        }
                        if ("mousedown" === e.type) ["A", "BUTTON"].includes(s.nodeName) || e.preventDefault();
                        else if (Math.abs(this.velocity.a) > 0.3) return !1;
                        return (this.target.e = this.current.e), (this.target.f = this.current.f), this.stop(), this.isDragging || ((this.isDragging = !0), this.addTrackingPoint(t), this.emit("touchStart", e)), !0;
                    }
                    onPointerMove(e, t, i) {
                        if (!1 === this.option("touch", e)) return;
                        if (!this.isDragging) return;
                        if (t.length < 2 && this.panOnlyZoomed && n(this.targetScale) <= n(this.minScale)) return;
                        if ((this.emit("touchMove", e), e.defaultPrevented)) return;
                        this.addTrackingPoint(t[0]);
                        const { content: r } = this,
                            o = f(i[0], i[1]),
                            a = f(t[0], t[1]);
                        let l = 0,
                            c = 0;
                        if (t.length > 1) {
                            const e = r.getBoundingClientRect();
                            (l = o.clientX - e.left - 0.5 * e.width), (c = o.clientY - e.top - 0.5 * e.height);
                        }
                        const u = h(i[0], i[1]),
                            d = h(t[0], t[1]);
                        let p = u ? d / u : 1,
                            m = a.clientX - o.clientX,
                            g = a.clientY - o.clientY;
                        (this.dragOffset.x += m), (this.dragOffset.y += g), (this.dragOffset.time = Date.now() - this.dragStart.time);
                        let v = n(this.targetScale) === n(this.minScale) && this.option("lockAxis");
                        if (v && !this.lockedAxis)
                            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                                const t = Math.abs((180 * Math.atan2(this.dragOffset.y, this.dragOffset.x)) / Math.PI);
                                (this.lockedAxis = t > 45 && t < 135 ? "y" : "x"), (this.dragOffset.x = 0), (this.dragOffset.y = 0), (m = 0), (g = 0);
                            } else this.lockedAxis = v;
                        if ((s(e.target, this.content) && ((v = "x"), (this.dragOffset.y = 0)), v && "xy" !== v && this.lockedAxis !== v && n(this.targetScale) === n(this.minScale))) return;
                        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
                        const b = this.checkBounds(m, g);
                        this.option("rubberband")
                            ? ("x" !== this.isInfinite && ((b.xDiff > 0 && m < 0) || (b.xDiff < 0 && m > 0)) && (m *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitWidth) * b.xDiff))),
                              "y" !== this.isInfinite && ((b.yDiff > 0 && g < 0) || (b.yDiff < 0 && g > 0)) && (g *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitHeight) * b.yDiff))))
                            : (b.xDiff && (m = 0), b.yDiff && (g = 0));
                        const y = this.targetScale,
                            w = this.minScale,
                            x = this.maxScale;
                        y < 0.5 * w && (p = Math.max(p, w)),
                            y > 1.5 * x && (p = Math.min(p, x)),
                            "y" === this.lockedAxis && n(y) === n(w) && (m = 0),
                            "x" === this.lockedAxis && n(y) === n(w) && (g = 0),
                            this.applyChange({ originX: l, originY: c, panX: m, panY: g, scale: p, friction: this.option("dragFriction"), ignoreBounds: !0 });
                    }
                    onPointerUp(e, t, i) {
                        if (i.length) return (this.dragOffset.x = 0), (this.dragOffset.y = 0), void (this.trackingPoints = []);
                        this.container.classList.remove(this.cn("isDragging")),
                            this.isDragging &&
                                (this.addTrackingPoint(t),
                                this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []),
                                s(e.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []),
                                this.emit("touchEnd", e),
                                (this.isDragging = !1),
                                (this.lockedAxis = !1),
                                this.state !== y.Destroy && (e.defaultPrevented || this.startDecelAnim()));
                    }
                    startDecelAnim() {
                        var e;
                        const t = this.isScaling;
                        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)), (this.isBouncingX = !1), (this.isBouncingY = !1);
                        for (const e of w) this.velocity[e] = 0;
                        (this.target.e = this.current.e), (this.target.f = this.current.f), T(this.container, "is-scaling"), T(this.container, "is-animating"), (this.isTicking = !1);
                        const { trackingPoints: i } = this,
                            r = i[0],
                            s = i[i.length - 1];
                        let o = 0,
                            a = 0,
                            l = 0;
                        s && r && ((o = s.clientX - r.clientX), (a = s.clientY - r.clientY), (l = s.time - r.time));
                        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
                        1 !== c && ((o *= c), (a *= c));
                        let u = 0,
                            d = 0,
                            h = 0,
                            f = 0,
                            p = this.option("decelFriction");
                        const m = this.targetScale;
                        if (l > 0) {
                            (h = Math.abs(o) > 3 ? o / (l / 30) : 0), (f = Math.abs(a) > 3 ? a / (l / 30) : 0);
                            const e = this.option("maxVelocity");
                            e && ((h = Math.max(Math.min(h, e), -1 * e)), (f = Math.max(Math.min(f, e), -1 * e)));
                        }
                        h && (u = h / (1 / (1 - p) - 1)),
                            f && (d = f / (1 / (1 - p) - 1)),
                            ("y" === this.option("lockAxis") || ("xy" === this.option("lockAxis") && "y" === this.lockedAxis && n(m) === this.minScale)) && (u = h = 0),
                            ("x" === this.option("lockAxis") || ("xy" === this.option("lockAxis") && "x" === this.lockedAxis && n(m) === this.minScale)) && (d = f = 0);
                        const g = this.dragOffset.x,
                            v = this.dragOffset.y,
                            b = this.option("dragMinThreshold") || 0;
                        Math.abs(g) < b && Math.abs(v) < b && ((u = d = 0), (h = f = 0)),
                            ((this.option("zoom") && (m < this.minScale - 1e-5 || m > this.maxScale + 1e-5)) || (t && !u && !d)) && (p = 0.35),
                            this.applyChange({ panX: u, panY: d, friction: p }),
                            this.emit("decel", h, f, g, v);
                    }
                    onWheel(e) {
                        var t = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
                            return Math.abs(t) > Math.abs(e) ? t : e;
                        });
                        const i = Math.max(-1, Math.min(1, t));
                        if ((this.emit("wheel", e, i), this.panMode === O)) return;
                        if (e.defaultPrevented) return;
                        const n = this.option("wheel");
                        "pan" === n
                            ? (e.preventDefault(), (this.panOnlyZoomed && !this.canZoomOut()) || this.applyChange({ panX: 2 * -e.deltaX, panY: 2 * -e.deltaY, bounce: !1 }))
                            : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(e);
                    }
                    onMouseMove(e) {
                        this.panWithMouse(e);
                    }
                    onKeydown(e) {
                        "Escape" === e.key && this.toggleFS();
                    }
                    onResize() {
                        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
                    }
                    setTransform() {
                        this.emit("beforeTransform");
                        const { current: e, target: t, content: i, contentRect: r } = this,
                            s = Object.assign({}, P);
                        for (const i of w) {
                            const r = "e" == i || "f" === i ? C : 1e5;
                            (s[i] = n(e[i], r)), Math.abs(t[i] - e[i]) < ("e" == i || "f" === i ? 0.51 : 0.001) && (e[i] = t[i]);
                        }
                        let { a: o, b: a, c: l, d: c, e: u, f: d } = s,
                            h = `matrix(${o}, ${a}, ${l}, ${c}, ${u}, ${d})`,
                            f = i.parentElement instanceof HTMLPictureElement ? i.parentElement : i;
                        if ((this.option("transformParent") && (f = f.parentElement || f), f.style.transform === h)) return;
                        f.style.transform = h;
                        const { contentWidth: p, contentHeight: m } = this.calculateContentDim();
                        (r.width = p), (r.height = m), this.emit("afterTransform");
                    }
                    updateMetrics(e = !1) {
                        var t;
                        if (!this || this.state === y.Destroy) return;
                        if (this.isContentLoading) return;
                        const i = Math.max(1, (null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1),
                            { container: r, content: s } = this,
                            o = s instanceof HTMLImageElement,
                            a = r.getBoundingClientRect(),
                            l = getComputedStyle(this.container);
                        let c = a.width * i,
                            u = a.height * i;
                        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom),
                            h = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)),
                            f = u - d;
                        this.containerRect = { width: c, height: u, innerWidth: h, innerHeight: f };
                        let p = this.option("width") || "auto",
                            m = this.option("height") || "auto";
                        "auto" === p &&
                            (p =
                                parseFloat(s.dataset.width || "") ||
                                ((e) => {
                                    let t = 0;
                                    return (t = e instanceof HTMLImageElement ? e.naturalWidth : e instanceof SVGElement ? e.width.baseVal.value : Math.max(e.offsetWidth, e.scrollWidth)), t || 0;
                                })(s)),
                            "auto" === m &&
                                (m =
                                    parseFloat(s.dataset.height || "") ||
                                    ((e) => {
                                        let t = 0;
                                        return (t = e instanceof HTMLImageElement ? e.naturalHeight : e instanceof SVGElement ? e.height.baseVal.value : Math.max(e.offsetHeight, e.scrollHeight)), t || 0;
                                    })(s));
                        let g = s.parentElement instanceof HTMLPictureElement ? s.parentElement : s;
                        this.option("transformParent") && (g = g.parentElement || g);
                        const v = g.getAttribute("style") || "";
                        g.style.setProperty("transform", "none", "important"), o && ((g.style.width = ""), (g.style.height = "")), g.offsetHeight;
                        const b = s.getBoundingClientRect();
                        let w = b.width * i,
                            x = b.height * i,
                            S = 0,
                            E = 0;
                        o &&
                            (Math.abs(p - w) > 1 || Math.abs(m - x) > 1) &&
                            ({ width: w, height: x, top: S, left: E } = ((e, t, i, n) => {
                                const r = i / n;
                                return r > e / t ? ((i = e), (n = e / r)) : ((i = t * r), (n = t)), { width: i, height: n, top: 0.5 * (t - n), left: 0.5 * (e - i) };
                            })(w, x, p, m)),
                            (this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
                                top: b.top - a.top + S,
                                bottom: a.bottom - b.bottom + S,
                                left: b.left - a.left + E,
                                right: a.right - b.right + E,
                                fitWidth: w,
                                fitHeight: x,
                                width: w,
                                height: x,
                                fullWidth: p,
                                fullHeight: m,
                            })),
                            (g.style.cssText = v),
                            o && ((g.style.width = `${w}px`), (g.style.height = `${x}px`)),
                            this.setTransform(),
                            !0 !== e && this.emit("refresh"),
                            this.ignoreBounds ||
                                (n(this.targetScale) < n(this.minScale)
                                    ? this.zoomTo(this.minScale, { friction: 0 })
                                    : this.targetScale > this.maxScale
                                    ? this.zoomTo(this.maxScale, { friction: 0 })
                                    : this.state === y.Init || this.checkBounds().inBounds || this.requestTick()),
                            this.updateControls();
                    }
                    calculateBounds() {
                        const { contentWidth: e, contentHeight: t } = this.calculateContentDim(this.target),
                            { targetScale: i, lockedAxis: r } = this,
                            { fitWidth: s, fitHeight: o } = this.contentRect;
                        let a = 0,
                            l = 0,
                            c = 0,
                            u = 0;
                        const d = this.option("infinite");
                        if (!0 === d || (r && d === r)) (a = -1 / 0), (c = 1 / 0), (l = -1 / 0), (u = 1 / 0);
                        else {
                            let { containerRect: r, contentRect: d } = this,
                                h = n(s * i, C),
                                f = n(o * i, C),
                                { innerWidth: p, innerHeight: m } = r;
                            if ((r.width === h && (p = r.width), r.width === f && (m = r.height), e > p)) {
                                (c = 0.5 * (e - p)), (a = -1 * c);
                                let t = 0.5 * (d.right - d.left);
                                (a += t), (c += t);
                            }
                            if ((s > p && e < p && ((a -= 0.5 * (s - p)), (c -= 0.5 * (s - p))), t > m)) {
                                (u = 0.5 * (t - m)), (l = -1 * u);
                                let e = 0.5 * (d.bottom - d.top);
                                (l += e), (u += e);
                            }
                            o > m && t < m && ((a -= 0.5 * (o - m)), (c -= 0.5 * (o - m)));
                        }
                        return { x: { min: a, max: c }, y: { min: l, max: u } };
                    }
                    getBounds() {
                        const e = this.option("bounds");
                        return "auto" !== e ? e : this.calculateBounds();
                    }
                    updateControls() {
                        const e = this,
                            t = e.container,
                            { panMode: i, contentRect: r, fullScale: s, targetScale: o, coverScale: a, maxScale: c, minScale: u } = e;
                        let d = { toggleMax: o - u < 0.5 * (c - u) ? c : u, toggleCover: o - u < 0.5 * (a - u) ? a : u, toggleZoom: o - u < 0.5 * (s - u) ? s : u }[e.option("click") || ""] || u,
                            h = e.canZoomIn(),
                            f = e.canZoomOut(),
                            p = i === L && !!this.option("touch"),
                            m = f && p;
                        if (
                            (p && (n(o) < n(u) && !this.panOnlyZoomed && (m = !0), (n(r.width, 1) > n(r.fitWidth, 1) || n(r.height, 1) > n(r.fitHeight, 1)) && (m = !0)),
                            n(r.width * o, 1) < n(r.fitWidth, 1) && (m = !1),
                            i === O && (m = !1),
                            l(t, this.cn("isDraggable"), m),
                            !this.option("zoom"))
                        )
                            return;
                        let g = h && n(d) > n(o),
                            v = !g && !m && f && n(d) < n(o);
                        l(t, this.cn("canZoomIn"), g), l(t, this.cn("canZoomOut"), v);
                        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]')) h ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
                        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]')) f ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
                        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
                            h || f ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
                            const t = e.querySelector("g");
                            t && (t.style.display = h ? "" : "none");
                        }
                    }
                    panTo({
                        x: e = this.target.e,
                        y: t = this.target.f,
                        scale: i = this.targetScale,
                        friction: n = this.option("friction"),
                        angle: r = 0,
                        originX: s = 0,
                        originY: o = 0,
                        flipX: a = !1,
                        flipY: l = !1,
                        ignoreBounds: c = !1,
                    }) {
                        this.state !== y.Destroy && this.applyChange({ panX: e - this.target.e, panY: t - this.target.f, scale: i / this.targetScale, angle: r, originX: s, originY: o, friction: n, flipX: a, flipY: l, ignoreBounds: c });
                    }
                    applyChange({
                        panX: e = 0,
                        panY: t = 0,
                        scale: i = 1,
                        angle: r = 0,
                        originX: s = -this.current.e,
                        originY: o = -this.current.f,
                        friction: a = this.option("friction"),
                        flipX: l = !1,
                        flipY: c = !1,
                        ignoreBounds: u = !1,
                        bounce: d = this.option("bounce"),
                    }) {
                        const h = this.state;
                        if (h === y.Destroy) return;
                        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)), (this.friction = a || 0), (this.ignoreBounds = u);
                        const { current: f } = this,
                            p = f.e,
                            m = f.f,
                            g = this.getMatrix(this.target);
                        let v = new DOMMatrix().translate(p, m).translate(s, o).translate(e, t);
                        if (this.option("zoom")) {
                            if (!u) {
                                const e = this.targetScale,
                                    t = this.minScale,
                                    n = this.maxScale;
                                e * i < t && (i = t / e), e * i > n && (i = n / e);
                            }
                            v = v.scale(i);
                        }
                        (v = v.translate(-s, -o).translate(-p, -m).multiply(g)), r && (v = v.rotate(r)), l && (v = v.scale(-1, 1)), c && (v = v.scale(1, -1));
                        for (const e of w) "e" !== e && "f" !== e && (v[e] > this.minScale + 1e-5 || v[e] < this.minScale - 1e-5) ? (this.target[e] = v[e]) : (this.target[e] = n(v[e], C));
                        (this.targetScale < this.scale || Math.abs(i - 1) > 0.1 || this.panMode === O || !1 === d) && !u && this.clampTargetBounds(),
                            h === y.Init ? this.animate() : this.isResting || ((this.state = y.Panning), this.requestTick());
                    }
                    stop(e = !1) {
                        if (this.state === y.Init || this.state === y.Destroy) return;
                        const t = this.isTicking;
                        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)), (this.isBouncingX = !1), (this.isBouncingY = !1);
                        for (const t of w) (this.velocity[t] = 0), "current" === e ? (this.current[t] = this.target[t]) : "target" === e && (this.target[t] = this.current[t]);
                        this.setTransform(), T(this.container, "is-scaling"), T(this.container, "is-animating"), (this.isTicking = !1), (this.state = y.Ready), t && (this.emit("endAnimation"), this.updateControls());
                    }
                    requestTick() {
                        this.isTicking || (this.emit("startAnimation"), this.updateControls(), M(this.container, "is-animating"), this.isScaling && M(this.container, "is-scaling")),
                            (this.isTicking = !0),
                            this.rAF || (this.rAF = requestAnimationFrame(() => this.animate()));
                    }
                    panWithMouse(e, t = this.option("mouseMoveFriction")) {
                        if (((this.pmme = e), this.panMode !== O || !e)) return;
                        if (n(this.targetScale) <= n(this.minScale)) return;
                        this.emit("mouseMove", e);
                        const { container: i, containerRect: r, contentRect: s } = this,
                            o = r.width,
                            a = r.height,
                            l = i.getBoundingClientRect(),
                            c = (e.clientX || 0) - l.left,
                            u = (e.clientY || 0) - l.top;
                        let { contentWidth: d, contentHeight: h } = this.calculateContentDim(this.target);
                        const f = this.option("mouseMoveFactor");
                        f > 1 && (d !== o && (d *= f), h !== a && (h *= f));
                        let p = 0.5 * (d - o) - (((c / o) * 100) / 100) * (d - o);
                        p += 0.5 * (s.right - s.left);
                        let m = 0.5 * (h - a) - (((u / a) * 100) / 100) * (h - a);
                        (m += 0.5 * (s.bottom - s.top)), this.applyChange({ panX: p - this.target.e, panY: m - this.target.f, friction: t });
                    }
                    zoomWithWheel(e) {
                        if (this.state === y.Destroy || this.state === y.Init) return;
                        const t = Date.now();
                        if (t - this.pwt < 45) return void e.preventDefault();
                        this.pwt = t;
                        var i = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
                            return Math.abs(t) > Math.abs(e) ? t : e;
                        });
                        const r = Math.max(-1, Math.min(1, i)),
                            { targetScale: s, maxScale: o, minScale: a } = this;
                        let l = (s * (100 + 45 * r)) / 100;
                        n(l) < n(a) && n(s) <= n(a) ? ((this.cwd += Math.abs(r)), (l = a)) : n(l) > n(o) && n(s) >= n(o) ? ((this.cwd += Math.abs(r)), (l = o)) : ((this.cwd = 0), (l = Math.max(Math.min(l, o), a))),
                            this.cwd > this.option("wheelLimit") || (e.preventDefault(), n(l) !== n(s) && this.zoomTo(l, { event: e }));
                    }
                    canZoomIn() {
                        return this.option("zoom") && (n(this.contentRect.width, 1) < n(this.contentRect.fitWidth, 1) || n(this.targetScale) < n(this.maxScale));
                    }
                    canZoomOut() {
                        return this.option("zoom") && n(this.targetScale) > n(this.minScale);
                    }
                    zoomIn(e = 1.25, t) {
                        this.zoomTo(this.targetScale * e, t);
                    }
                    zoomOut(e = 0.8, t) {
                        this.zoomTo(this.targetScale * e, t);
                    }
                    zoomToFit(e) {
                        this.zoomTo("fit", e);
                    }
                    zoomToCover(e) {
                        this.zoomTo("cover", e);
                    }
                    zoomToFull(e) {
                        this.zoomTo("full", e);
                    }
                    zoomToMax(e) {
                        this.zoomTo("max", e);
                    }
                    toggleZoom(e) {
                        this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.fullScale - this.minScale) ? "full" : "fit", e);
                    }
                    toggleMax(e) {
                        this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.maxScale - this.minScale) ? "max" : "fit", e);
                    }
                    toggleCover(e) {
                        this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.coverScale - this.minScale) ? "cover" : "fit", e);
                    }
                    iterateZoom(e) {
                        this.zoomTo("next", e);
                    }
                    zoomTo(e = 1, { friction: t = "auto", originX: i = "auto", originY: n = "auto", event: r } = {}) {
                        if (this.isContentLoading || this.state === y.Destroy) return;
                        const { targetScale: s } = this;
                        this.stop();
                        let o = 1;
                        if ((this.panMode === O && (r = this.pmme || r), r || "auto" === i || "auto" === n)) {
                            const e = this.content.getBoundingClientRect(),
                                t = this.container.getBoundingClientRect(),
                                s = r ? r.clientX : t.left + 0.5 * t.width,
                                o = r ? r.clientY : t.top + 0.5 * t.height;
                            (i = s - e.left - 0.5 * e.width), (n = o - e.top - 0.5 * e.height);
                        }
                        const a = this.fullScale,
                            l = this.maxScale,
                            c = this.coverScale;
                        if ("number" == typeof e) o = e / s || 1;
                        else if ("full" === e) o = a / s || 1;
                        else if ("cover" === e) o = c / s || 1;
                        else if ("max" === e) o = l / s || 1;
                        else if ("fit" === e) o = 1 / s || 1;
                        else if ("next" === e) {
                            let e = [1, a, l].sort((e, t) => e - t),
                                t = e.findIndex((e) => e > s + 1e-5);
                            o = e[t] / s || 1 / s;
                        }
                        (t = "auto" === t ? (o > 1 ? 0.15 : 0.25) : t), this.applyChange({ scale: o, originX: i, originY: n, friction: t }), r && this.panMode === O && this.panWithMouse(r, t);
                    }
                    rotateCCW() {
                        this.applyChange({ angle: -90 });
                    }
                    rotateCW() {
                        this.applyChange({ angle: 90 });
                    }
                    flipX() {
                        this.applyChange({ flipX: !0 });
                    }
                    flipY() {
                        this.applyChange({ flipY: !0 });
                    }
                    fitX() {
                        this.stop("target");
                        const { containerRect: e, contentRect: t, target: i } = this;
                        this.applyChange({
                            panX: 0.5 * e.width - (t.left + 0.5 * t.fitWidth) - i.e,
                            panY: 0.5 * e.height - (t.top + 0.5 * t.fitHeight) - i.f,
                            scale: e.width / t.fitWidth / this.targetScale,
                            originX: 0,
                            originY: 0,
                            ignoreBounds: !0,
                        });
                    }
                    fitY() {
                        this.stop("target");
                        const { containerRect: e, contentRect: t, target: i } = this;
                        this.applyChange({
                            panX: 0.5 * e.width - (t.left + 0.5 * t.fitWidth) - i.e,
                            panY: 0.5 * e.innerHeight - (t.top + 0.5 * t.fitHeight) - i.f,
                            scale: e.height / t.fitHeight / this.targetScale,
                            originX: 0,
                            originY: 0,
                            ignoreBounds: !0,
                        });
                    }
                    toggleFS() {
                        const { container: e } = this,
                            t = this.cn("inFullscreen"),
                            i = this.cn("htmlHasFullscreen");
                        e.classList.toggle(t);
                        const n = e.classList.contains(t);
                        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)),
                            this.updateMetrics(),
                            this.emit(n ? "enterFS" : "exitFS");
                    }
                    getMatrix(e = this.current) {
                        const { a: t, b: i, c: n, d: r, e: s, f: o } = e;
                        return new DOMMatrix([t, i, n, r, s, o]);
                    }
                    reset(e) {
                        if (this.state !== y.Init && this.state !== y.Destroy) {
                            this.stop("current");
                            for (const e of w) this.target[e] = P[e];
                            (this.target.a = this.minScale),
                                (this.target.d = this.minScale),
                                this.clampTargetBounds(),
                                this.isResting || ((this.friction = void 0 === e ? this.option("friction") : e), (this.state = y.Panning), this.requestTick());
                        }
                    }
                    destroy() {
                        this.stop(), (this.state = y.Destroy), this.detachEvents(), this.detachObserver();
                        const { container: e, content: t } = this,
                            i = this.option("classes") || {};
                        for (const t of Object.values(i)) e.classList.remove(t + "");
                        t && (t.removeEventListener("load", this.onLoad), t.removeEventListener("error", this.onError)), this.detachPlugins();
                    }
                }
                Object.defineProperty(z, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: S }), Object.defineProperty(z, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: {} });
                const D = function (e, t) {
                        let i = !0;
                        return (...n) => {
                            i &&
                                ((i = !1),
                                e(...n),
                                setTimeout(() => {
                                    i = !0;
                                }, t));
                        };
                    },
                    j = (e, t) => {
                        let i = [];
                        return (
                            e.childNodes.forEach((e) => {
                                e.nodeType !== Node.ELEMENT_NODE || (t && !e.matches(t)) || i.push(e);
                            }),
                            i
                        );
                    };
                var R;
                !(function (e) {
                    (e[(e.Init = 0)] = "Init"), (e[(e.Ready = 1)] = "Ready"), (e[(e.Destroy = 2)] = "Destroy");
                })(R || (R = {}));
                const F = (e) => {
                        if ("string" == typeof e || e instanceof HTMLElement) e = { html: e };
                        else {
                            const t = e.thumb;
                            void 0 !== t && ("string" == typeof t && (e.thumbSrc = t), t instanceof HTMLImageElement && ((e.thumbEl = t), (e.thumbElSrc = t.src), (e.thumbSrc = t.src)), delete e.thumb);
                        }
                        return Object.assign({ html: "", el: null, isDom: !1, class: "", customClass: "", index: -1, dim: 0, gap: 0, pos: 0, transition: !1 }, e);
                    },
                    $ = (e = {}) => Object.assign({ index: -1, slides: [], dim: 0, pos: -1 }, e);
                class N extends v {
                    constructor(e, t) {
                        super(t), Object.defineProperty(this, "instance", { enumerable: !0, configurable: !0, writable: !0, value: e });
                    }
                    attach() {}
                    detach() {}
                }
                class B extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "isDynamic", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "list", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    onRefresh() {
                        this.refresh();
                    }
                    build() {
                        let e = this.list;
                        return e || ((e = document.createElement("ul")), M(e, this.cn("list")), e.setAttribute("role", "tablist"), this.instance.container.appendChild(e), M(this.instance.container, this.cn("hasDots")), (this.list = e)), e;
                    }
                    refresh() {
                        var e;
                        const t = this.instance.pages.length,
                            i = Math.min(2, this.option("minCount")),
                            n = Math.max(2e3, this.option("maxCount")),
                            r = this.option("dynamicFrom");
                        if (t < i || t > n) return void this.cleanup();
                        const s = "number" == typeof r && t > 5 && t >= r,
                            o = !this.list || this.isDynamic !== s || this.list.children.length !== t;
                        o && this.cleanup();
                        const a = this.build();
                        if ((l(a, this.cn("isDynamic"), !!s), o)) for (let e = 0; e < t; e++) a.append(this.createItem(e));
                        let c,
                            u = 0;
                        for (const t of [...a.children]) {
                            const i = u === this.instance.page;
                            i && (c = t), l(t, this.cn("isCurrent"), i), null === (e = t.children[0]) || void 0 === e || e.setAttribute("aria-selected", i ? "true" : "false");
                            for (const e of ["isBeforePrev", "isPrev", "isNext", "isAfterNext"]) T(t, this.cn(e));
                            u++;
                        }
                        if (((c = c || a.firstChild), s && c)) {
                            const e = c.previousElementSibling,
                                t = e && e.previousElementSibling;
                            M(e, this.cn("isPrev")), M(t, this.cn("isBeforePrev"));
                            const i = c.nextElementSibling,
                                n = i && i.nextElementSibling;
                            M(i, this.cn("isNext")), M(n, this.cn("isAfterNext"));
                        }
                        this.isDynamic = s;
                    }
                    createItem(e = 0) {
                        var t;
                        const i = document.createElement("li");
                        i.setAttribute("role", "presentation");
                        const n = o(this.instance.localize(this.option("dotTpl"), [["%d", e + 1]]).replace(/\%i/g, e + ""));
                        return i.appendChild(n), null === (t = i.children[0]) || void 0 === t || t.setAttribute("role", "tab"), i;
                    }
                    cleanup() {
                        this.list && (this.list.remove(), (this.list = null)), (this.isDynamic = !1), T(this.instance.container, this.cn("hasDots"));
                    }
                    attach() {
                        this.instance.on(["refresh", "change"], this.onRefresh);
                    }
                    detach() {
                        this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
                    }
                }
                Object.defineProperty(B, "defaults", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: {
                        classes: {
                            list: "f-carousel__dots",
                            isDynamic: "is-dynamic",
                            hasDots: "has-dots",
                            dot: "f-carousel__dot",
                            isBeforePrev: "is-before-prev",
                            isPrev: "is-prev",
                            isCurrent: "is-current",
                            isNext: "is-next",
                            isAfterNext: "is-after-next",
                        },
                        dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
                        dynamicFrom: 11,
                        maxCount: 1 / 0,
                        minCount: 2,
                    },
                });
                const H = "disabled",
                    q = "next",
                    V = "prev";
                class Y extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "prev", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "next", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    onRefresh() {
                        const e = this.instance,
                            t = e.pages.length,
                            i = e.page;
                        if (t < 2) return void this.cleanup();
                        this.build();
                        let n = this.prev,
                            r = this.next;
                        n && r && (n.removeAttribute(H), r.removeAttribute(H), e.isInfinite || (i <= 0 && n.setAttribute(H, ""), i >= t - 1 && r.setAttribute(H, "")));
                    }
                    createButton(e) {
                        const t = this.instance,
                            i = document.createElement("button");
                        i.setAttribute("tabindex", "0"), i.setAttribute("title", t.localize(`{{${e.toUpperCase()}}}`)), M(i, this.cn("button") + " " + this.cn(e === q ? "isNext" : "isPrev"));
                        const n = t.isRTL ? (e === q ? V : q) : e;
                        var r;
                        return (i.innerHTML = t.localize(this.option(`${n}Tpl`))), (i.dataset[`carousel${((r = e), r ? (r.match("^[a-z]") ? r.charAt(0).toUpperCase() + r.substring(1) : r) : "")}`] = "true"), i;
                    }
                    build() {
                        let e = this.container;
                        e || ((this.container = e = document.createElement("div")), M(e, this.cn("container")), this.instance.container.appendChild(e)),
                            this.next || (this.next = e.appendChild(this.createButton(q))),
                            this.prev || (this.prev = e.appendChild(this.createButton(V)));
                    }
                    cleanup() {
                        this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove(), (this.prev = null), (this.next = null), (this.container = null);
                    }
                    attach() {
                        this.instance.on(["refresh", "change"], this.onRefresh);
                    }
                    detach() {
                        this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
                    }
                }
                Object.defineProperty(Y, "defaults", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: {
                        classes: { container: "f-carousel__nav", button: "f-button", isNext: "is-next", isPrev: "is-prev" },
                        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
                        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
                    },
                });
                class W extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "selectedIndex", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "target", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "nav", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    addAsTargetFor(e) {
                        (this.target = this.instance), (this.nav = e), this.attachEvents();
                    }
                    addAsNavFor(e) {
                        (this.nav = this.instance), (this.target = e), this.attachEvents();
                    }
                    attachEvents() {
                        const { nav: e, target: t } = this;
                        e &&
                            t &&
                            ((e.options.initialSlide = t.options.initialPage), e.state === R.Ready ? this.onNavReady(e) : e.on("ready", this.onNavReady), t.state === R.Ready ? this.onTargetReady(t) : t.on("ready", this.onTargetReady));
                    }
                    onNavReady(e) {
                        e.on("createSlide", this.onNavCreateSlide), e.on("Panzoom.click", this.onNavClick), e.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
                    }
                    onTargetReady(e) {
                        e.on("change", this.onTargetChange), e.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
                    }
                    onNavClick(e, t, i) {
                        this.onNavTouch(e, e.panzoom, i);
                    }
                    onNavTouch(e, t, i) {
                        var n, r;
                        if (Math.abs(t.dragOffset.x) > 3 || Math.abs(t.dragOffset.y) > 3) return;
                        const s = i.target,
                            { nav: o, target: a } = this;
                        if (!o || !a || !s) return;
                        const l = s.closest("[data-index]");
                        if ((i.stopPropagation(), i.preventDefault(), !l)) return;
                        const c = parseInt(l.dataset.index || "", 10) || 0,
                            u = a.getPageForSlide(c),
                            d = o.getPageForSlide(c);
                        o.slideTo(d), a.slideTo(u, { friction: (null === (r = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === r ? void 0 : r.Sync.option("friction")) || 0 }), this.markSelectedSlide(c);
                    }
                    onNavCreateSlide(e, t) {
                        t.index === this.selectedIndex && this.markSelectedSlide(t.index);
                    }
                    onTargetChange() {
                        var e, t;
                        const { target: i, nav: n } = this;
                        if (!i || !n) return;
                        if (n.state !== R.Ready || i.state !== R.Ready) return;
                        const r = null === (t = null === (e = i.pages[i.page]) || void 0 === e ? void 0 : e.slides[0]) || void 0 === t ? void 0 : t.index,
                            s = n.getPageForSlide(r);
                        this.markSelectedSlide(r), n.slideTo(s, null === n.prevPage && null === i.prevPage ? { friction: 0 } : void 0);
                    }
                    markSelectedSlide(e) {
                        const t = this.nav;
                        t &&
                            t.state === R.Ready &&
                            ((this.selectedIndex = e),
                            [...t.slides].map((t) => {
                                t.el && t.el.classList[t.index === e ? "add" : "remove"]("is-nav-selected");
                            }));
                    }
                    attach() {
                        const e = this;
                        let t = e.options.target,
                            i = e.options.nav;
                        t ? e.addAsNavFor(t) : i && e.addAsTargetFor(i);
                    }
                    detach() {
                        const e = this,
                            t = e.nav,
                            i = e.target;
                        t && (t.off("ready", e.onNavReady), t.off("createSlide", e.onNavCreateSlide), t.off("Panzoom.click", e.onNavClick), t.off("Panzoom.touchEnd", e.onNavTouch)),
                            (e.nav = null),
                            i && (i.off("ready", e.onTargetReady), i.off("refresh", e.onTargetChange), i.off("change", e.onTargetChange)),
                            (e.target = null);
                    }
                }
                Object.defineProperty(W, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: { friction: 0.35 } });
                const X = { Navigation: Y, Dots: B, Sync: W },
                    G = "animationend",
                    U = "isSelected",
                    Z = "slide";
                class K extends b {
                    get axis() {
                        return this.isHorizontal ? "e" : "f";
                    }
                    get isEnabled() {
                        return this.state === R.Ready;
                    }
                    get isInfinite() {
                        let e = !1;
                        const { contentDim: t, viewportDim: i, pages: n, slides: r } = this,
                            s = r[0];
                        return n.length >= 2 && s && t + s.dim >= i && (e = this.option("infinite")), e;
                    }
                    get isRTL() {
                        return "rtl" === this.option("direction");
                    }
                    get isHorizontal() {
                        return "x" === this.option("axis");
                    }
                    constructor(e, t = {}, i = {}) {
                        if (
                            (super(),
                            Object.defineProperty(this, "bp", { enumerable: !0, configurable: !0, writable: !0, value: "" }),
                            Object.defineProperty(this, "lp", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "userOptions", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
                            Object.defineProperty(this, "userPlugins", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: R.Init }),
                            Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "prevPage", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "viewport", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "track", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "slides", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            Object.defineProperty(this, "pages", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            Object.defineProperty(this, "panzoom", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "inTransition", { enumerable: !0, configurable: !0, writable: !0, value: new Set() }),
                            Object.defineProperty(this, "contentDim", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "viewportDim", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            "string" == typeof e && (e = document.querySelector(e)),
                            !e || !_(e))
                        )
                            throw new Error("No Element found");
                        (this.container = e),
                            (this.slideNext = D(this.slideNext.bind(this), 150)),
                            (this.slidePrev = D(this.slidePrev.bind(this), 150)),
                            (this.userOptions = t),
                            (this.userPlugins = i),
                            queueMicrotask(() => {
                                this.processOptions();
                            });
                    }
                    processOptions() {
                        var e, t;
                        const i = m({}, K.defaults, this.userOptions);
                        let n = "";
                        const r = i.breakpoints;
                        if (r && p(r)) for (const [e, t] of Object.entries(r)) window.matchMedia(e).matches && p(t) && ((n += e), m(i, t));
                        (n === this.bp && this.state !== R.Init) ||
                            ((this.bp = n),
                            this.state === R.Ready && (i.initialSlide = (null === (t = null === (e = this.pages[this.page]) || void 0 === e ? void 0 : e.slides[0]) || void 0 === t ? void 0 : t.index) || 0),
                            this.state !== R.Init && this.destroy(),
                            super.setOptions(i),
                            !1 === this.option("enabled")
                                ? this.attachEvents()
                                : setTimeout(() => {
                                      this.init();
                                  }, 0));
                    }
                    init() {
                        (this.state = R.Init),
                            this.emit("init"),
                            this.attachPlugins(Object.assign(Object.assign({}, K.Plugins), this.userPlugins)),
                            this.emit("attachPlugins"),
                            this.initLayout(),
                            this.initSlides(),
                            this.updateMetrics(),
                            this.setInitialPosition(),
                            this.initPanzoom(),
                            this.attachEvents(),
                            (this.state = R.Ready),
                            this.emit("ready");
                    }
                    initLayout() {
                        const { container: e } = this,
                            t = this.option("classes");
                        M(e, this.cn("container")), l(e, t.isLTR, !this.isRTL), l(e, t.isRTL, this.isRTL), l(e, t.isVertical, !this.isHorizontal), l(e, t.isHorizontal, this.isHorizontal);
                        let i = this.option("viewport") || e.querySelector(`.${t.viewport}`);
                        i || ((i = document.createElement("div")), M(i, t.viewport), i.append(...j(e, `.${t.slide}`)), e.prepend(i)), i.addEventListener("scroll", this.onScroll);
                        let n = this.option("track") || e.querySelector(`.${t.track}`);
                        n || ((n = document.createElement("div")), M(n, t.track), n.append(...Array.from(i.childNodes))),
                            n.setAttribute("aria-live", "polite"),
                            i.contains(n) || i.prepend(n),
                            (this.viewport = i),
                            (this.track = n),
                            this.emit("initLayout");
                    }
                    initSlides() {
                        const { track: e } = this;
                        if (!e) return;
                        const t = [...this.slides],
                            i = [];
                        [...j(e, `.${this.cn(Z)}`)].forEach((e) => {
                            if (_(e)) {
                                const t = F({ el: e, isDom: !0, index: this.slides.length });
                                i.push(t);
                            }
                        });
                        for (let e of [...(this.option("slides", []) || []), ...t]) {
                            const t = F(e);
                            i.push(t);
                        }
                        this.slides = i;
                        for (let e = 0; e < this.slides.length; e++) this.slides[e].index = e;
                        for (const e of i) this.emit("beforeInitSlide", e, e.index), this.emit("initSlide", e, e.index);
                        this.emit("initSlides");
                    }
                    setInitialPage() {
                        const e = this.option("initialSlide");
                        this.page = "number" == typeof e ? this.getPageForSlide(e) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
                    }
                    setInitialPosition() {
                        const { track: e, pages: t, isHorizontal: i } = this;
                        if (!e || !t.length) return;
                        let n = this.page;
                        t[n] || (this.page = n = 0);
                        const r = (t[n].pos || 0) * (this.isRTL && i ? 1 : -1),
                            s = i ? `${r}px` : "0",
                            o = i ? "0" : `${r}px`;
                        (e.style.transform = `translate3d(${s}, ${o}, 0) scale(1)`), this.option("adaptiveHeight") && this.setViewportHeight();
                    }
                    initPanzoom() {
                        this.panzoom && (this.panzoom.destroy(), (this.panzoom = null));
                        const e = this.option("Panzoom") || {};
                        (this.panzoom = new z(
                            this.viewport,
                            m(
                                {},
                                {
                                    content: this.track,
                                    zoom: !1,
                                    panOnlyZoomed: !1,
                                    lockAxis: this.isHorizontal ? "x" : "y",
                                    infinite: this.isInfinite,
                                    click: !1,
                                    dblClick: !1,
                                    touch: (e) => !(this.pages.length < 2 && !e.options.infinite),
                                    bounds: () => this.getBounds(),
                                    maxVelocity: (e) => (Math.abs(e.target[this.axis] - e.current[this.axis]) < 2 * this.viewportDim ? 100 : 0),
                                },
                                e
                            )
                        )),
                            this.panzoom.on("*", (e, t, ...i) => {
                                this.emit(`Panzoom.${t}`, e, ...i);
                            }),
                            this.panzoom.on("decel", this.onDecel),
                            this.panzoom.on("refresh", this.onRefresh),
                            this.panzoom.on("beforeTransform", this.onBeforeTransform),
                            this.panzoom.on("endAnimation", this.onEndAnimation);
                    }
                    attachEvents() {
                        const e = this.container;
                        e && (e.addEventListener("click", this.onClick, { passive: !1, capture: !1 }), e.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
                    }
                    createPages() {
                        let e = [];
                        const { contentDim: t, viewportDim: i } = this;
                        let n = this.option("slidesPerPage");
                        n = ("auto" === n || t <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
                        let r = 0,
                            s = 0,
                            o = 0;
                        for (const t of this.slides) (!e.length || s + t.dim - i > 0.05 || o >= n) && (e.push($()), (r = e.length - 1), (s = 0), (o = 0)), e[r].slides.push(t), (s += t.dim + t.gap), o++;
                        return e;
                    }
                    processPages() {
                        const e = this.pages,
                            { contentDim: t, viewportDim: i, isInfinite: r } = this,
                            s = this.option("center"),
                            o = this.option("fill"),
                            a = o && s && t > i && !r;
                        if (
                            (e.forEach((e, n) => {
                                var r;
                                (e.index = n), (e.pos = (null === (r = e.slides[0]) || void 0 === r ? void 0 : r.pos) || 0), (e.dim = 0);
                                for (const [t, i] of e.slides.entries()) (e.dim += i.dim), t < e.slides.length - 1 && (e.dim += i.gap);
                                a && e.pos + 0.5 * e.dim < 0.5 * i ? (e.pos = 0) : a && e.pos + 0.5 * e.dim >= t - 0.5 * i ? (e.pos = t - i) : s && (e.pos += -0.5 * (i - e.dim));
                            }),
                            e.forEach((e, s) => {
                                o && !r && t > i && ((e.pos = Math.max(e.pos, 0)), (e.pos = Math.min(e.pos, t - i))), (e.pos = n(e.pos, 1e3)), (e.dim = n(e.dim, 1e3)), Math.abs(e.pos) <= 0.1 && (e.pos = 0);
                            }),
                            r)
                        )
                            return e;
                        const l = [];
                        let c;
                        return (
                            e.forEach((e) => {
                                const t = Object.assign({}, e);
                                c && t.pos === c.pos ? ((c.dim += t.dim), (c.slides = [...c.slides, ...t.slides])) : ((t.index = l.length), (c = t), l.push(t));
                            }),
                            l
                        );
                    }
                    getPageFromIndex(e = 0) {
                        const t = this.pages.length;
                        let i;
                        return (e = parseInt((e || 0).toString()) || 0), (i = this.isInfinite ? ((e % t) + t) % t : Math.max(Math.min(e, t - 1), 0)), i;
                    }
                    getSlideMetrics(e) {
                        var t, i;
                        const r = this.isHorizontal ? "width" : "height";
                        let s = 0,
                            o = 0,
                            a = e.el;
                        const l = a && !a.parentNode;
                        if (
                            (a ? (s = parseFloat(a.dataset[r] || "") || 0) : ((a = document.createElement("div")), (a.style.visibility = "hidden"), (this.track || document.body).prepend(a)),
                            M(a, this.cn(Z) + " " + e.class + " " + e.customClass),
                            s)
                        )
                            (a.style[r] = `${s}px`), (a.style["width" === r ? "height" : "width"] = "");
                        else {
                            l && (this.track || document.body).prepend(a);
                            const e = Math.max(1, (null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1);
                            s = a.getBoundingClientRect()[r] * e;
                        }
                        const c = getComputedStyle(a);
                        return (
                            "content-box" === c.boxSizing &&
                                (this.isHorizontal ? ((s += parseFloat(c.paddingLeft) || 0), (s += parseFloat(c.paddingRight) || 0)) : ((s += parseFloat(c.paddingTop) || 0), (s += parseFloat(c.paddingBottom) || 0))),
                            (o = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0),
                            l ? null === (i = a.parentElement) || void 0 === i || i.removeChild(a) : e.el || a.remove(),
                            { dim: n(s, 1e3), gap: n(o, 1e3) }
                        );
                    }
                    getBounds() {
                        const { isInfinite: e, isRTL: t, isHorizontal: i, pages: n } = this;
                        let r = { min: 0, max: 0 };
                        if (e) r = { min: -1 / 0, max: 1 / 0 };
                        else if (n.length) {
                            const e = n[0].pos,
                                s = n[n.length - 1].pos;
                            r = t && i ? { min: e, max: s } : { min: -1 * s, max: -1 * e };
                        }
                        return { x: i ? r : { min: 0, max: 0 }, y: i ? { min: 0, max: 0 } : r };
                    }
                    repositionSlides() {
                        let e,
                            { isHorizontal: t, isRTL: i, isInfinite: r, viewport: s, viewportDim: o, contentDim: a, page: l, pages: c, slides: u, panzoom: d } = this,
                            h = 0,
                            f = 0,
                            p = 0,
                            m = 0;
                        d ? (m = -1 * d.current[this.axis]) : c[l] && (m = c[l].pos || 0), (e = t ? (i ? "right" : "left") : "top"), i && t && (m *= -1);
                        for (const t of u) {
                            const i = t.el;
                            i
                                ? ("top" === e ? ((i.style.right = ""), (i.style.left = "")) : (i.style.top = ""), t.index !== h ? (i.style[e] = 0 === f ? "" : `${n(f, 1e3)}px`) : (i.style[e] = ""), (p += t.dim + t.gap), h++)
                                : (f += t.dim + t.gap);
                        }
                        if (r && p && s) {
                            let i = getComputedStyle(s),
                                r = "padding",
                                l = t ? "Right" : "Bottom",
                                c = parseFloat(i[r + (t ? "Left" : "Top")]);
                            (m -= c), (o += c), (o += parseFloat(i[r + l]));
                            for (const t of u)
                                t.el &&
                                    (n(t.pos) < n(o) && n(t.pos + t.dim + t.gap) < n(m) && n(m) > n(a - o) && (t.el.style[e] = `${n(f + p, 1e3)}px`),
                                    n(t.pos + t.gap) >= n(a - o) && n(t.pos) > n(m + o) && n(m) < n(o) && (t.el.style[e] = `-${n(p, 1e3)}px`));
                        }
                        let g,
                            v,
                            b = [...this.inTransition];
                        if ((b.length > 1 && ((g = c[b[0]]), (v = c[b[1]])), g && v)) {
                            let t = 0;
                            for (const i of u) i.el ? this.inTransition.has(i.index) && g.slides.indexOf(i) < 0 && (i.el.style[e] = `${n(t + (g.pos - v.pos), 1e3)}px`) : (t += i.dim + i.gap);
                        }
                    }
                    createSlideEl(e) {
                        const { track: t, slides: i } = this;
                        if (!t || !e) return;
                        if (e.el && e.el.parentNode) return;
                        const n = e.el || document.createElement("div");
                        M(n, this.cn(Z)), M(n, e.class), M(n, e.customClass);
                        const r = e.html;
                        r && (r instanceof HTMLElement ? n.appendChild(r) : (n.innerHTML = e.html + ""));
                        const s = [];
                        i.forEach((e, t) => {
                            e.el && s.push(t);
                        });
                        const o = e.index;
                        let a = null;
                        s.length && (a = i[s.reduce((e, t) => (Math.abs(t - o) < Math.abs(e - o) ? t : e))]);
                        const l = a && a.el && a.el.parentNode ? (a.index < e.index ? a.el.nextSibling : a.el) : null;
                        t.insertBefore(n, t.contains(l) ? l : null), (e.el = n), this.emit("createSlide", e);
                    }
                    removeSlideEl(e, t = !1) {
                        const i = e.el;
                        if (!i || !i.parentNode) return;
                        const n = this.cn(U);
                        if ((i.classList.contains(n) && (T(i, n), this.emit("unselectSlide", e)), e.isDom && !t)) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
                        this.emit("removeSlide", e);
                        const r = new CustomEvent(G);
                        i.dispatchEvent(r), e.el && (e.el.remove(), (e.el = null));
                    }
                    transitionTo(e = 0, t = this.option("transition")) {
                        var i, n, r, s;
                        if (!t) return !1;
                        const { pages: o, panzoom: a } = this;
                        e = parseInt((e || 0).toString()) || 0;
                        const l = this.getPageFromIndex(e);
                        if (!a || !o[l] || o.length < 2 || Math.abs(((null === (n = null === (i = o[this.page]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
                        const c = e > this.page ? 1 : -1,
                            u = this.pages[l].pos * (this.isRTL ? 1 : -1);
                        if (this.page === l && Math.abs(u - a.target[this.axis]) < 1) return !1;
                        this.clearTransitions();
                        const d = a.isResting;
                        M(this.container, this.cn("inTransition"));
                        const h = (null === (r = this.pages[this.page]) || void 0 === r ? void 0 : r.slides[0]) || null,
                            f = (null === (s = this.pages[l]) || void 0 === s ? void 0 : s.slides[0]) || null;
                        this.inTransition.add(f.index), this.createSlideEl(f);
                        let p = h.el,
                            m = f.el;
                        d || t === Z || ((t = "fadeFast"), (p = null));
                        const g = this.isRTL ? "next" : "prev",
                            v = this.isRTL ? "prev" : "next";
                        return (
                            p && (this.inTransition.add(h.index), (h.transition = t), p.addEventListener(G, this.onAnimationEnd), p.classList.add(`f-${t}Out`, `to-${c > 0 ? v : g}`)),
                            m && ((f.transition = t), m.addEventListener(G, this.onAnimationEnd), m.classList.add(`f-${t}In`, `from-${c > 0 ? g : v}`)),
                            (a.current[this.axis] = u),
                            (a.target[this.axis] = u),
                            a.requestTick(),
                            this.onChange(l),
                            !0
                        );
                    }
                    manageSlideVisiblity() {
                        const e = new Set(),
                            t = new Set(),
                            i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
                        for (const n of this.slides) i.has(n) ? e.add(n) : t.add(n);
                        for (const t of this.inTransition) e.add(this.slides[t]);
                        for (const t of e) this.createSlideEl(t), this.lazyLoadSlide(t);
                        for (const i of t) e.has(i) || this.removeSlideEl(i);
                        this.markSelectedSlides(), this.repositionSlides();
                    }
                    markSelectedSlides() {
                        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
                        const e = "aria-hidden";
                        let t = this.cn(U);
                        if (t)
                            for (const i of this.slides) {
                                const n = i.el;
                                n &&
                                    ((n.dataset.index = `${i.index}`),
                                    n.classList.contains("f-thumbs__slide")
                                        ? this.getVisibleSlides(0).has(i)
                                            ? n.removeAttribute(e)
                                            : n.setAttribute(e, "true")
                                        : this.pages[this.page].slides.includes(i)
                                        ? (n.classList.contains(t) || (M(n, t), this.emit("selectSlide", i)), n.removeAttribute(e))
                                        : (n.classList.contains(t) && (T(n, t), this.emit("unselectSlide", i)), n.setAttribute(e, "true")));
                            }
                    }
                    flipInfiniteTrack() {
                        const e = this.panzoom;
                        if (!e || !this.isInfinite) return;
                        const t = "x" === this.option("axis") ? "e" : "f",
                            { viewportDim: i, contentDim: n } = this;
                        let r = e.current[t],
                            s = e.target[t] - r,
                            o = 0,
                            a = 0.5 * i,
                            l = n;
                        this.isRTL && this.isHorizontal ? (r < -a && ((o = -1), (r += l)), r > l - a && ((o = 1), (r -= l))) : (r > a && ((o = 1), (r -= l)), r < -l + a && ((o = -1), (r += l))),
                            o && ((e.current[t] = r), (e.target[t] = r + s));
                    }
                    lazyLoadSlide(e) {
                        const t = this,
                            i = e && e.el;
                        if (!i) return;
                        const n = new Set(),
                            r = "f-fadeIn";
                        i.querySelectorAll("[data-lazy-srcset]").forEach((e) => {
                            e instanceof HTMLImageElement && n.add(e);
                        });
                        let s = Array.from(i.querySelectorAll("[data-lazy-src]"));
                        i.dataset.lazySrc && s.push(i),
                            s.map((e) => {
                                e instanceof HTMLImageElement ? n.add(e) : _(e) && ((e.style.backgroundImage = `url('${e.dataset.lazySrc || ""}')`), delete e.dataset.lazySrc);
                            });
                        const a = (e, i, n) => {
                            n && (n.remove(), (n = null)),
                                i.complete &&
                                    (i.classList.add(r),
                                    setTimeout(() => {
                                        i.classList.remove(r);
                                    }, 350),
                                    (i.style.visibility = "")),
                                this.option("adaptiveHeight") && e.el && this.pages[this.page].slides.indexOf(e) > -1 && (t.updateMetrics(), t.setViewportHeight()),
                                this.emit("load", e);
                        };
                        for (const t of n) {
                            let i = null;
                            (t.src = t.dataset.lazySrcset || t.dataset.lazySrc || ""),
                                delete t.dataset.lazySrc,
                                delete t.dataset.lazySrcset,
                                (t.style.visibility = "hidden"),
                                t.addEventListener("error", () => {
                                    a(e, t, i);
                                }),
                                t.addEventListener("load", () => {
                                    a(e, t, i);
                                }),
                                setTimeout(() => {
                                    t.parentNode && e.el && (t.complete ? a(e, t, i) : ((i = o(E)), t.parentNode.insertBefore(i, t)));
                                }, 300);
                        }
                    }
                    onAnimationEnd(e) {
                        var t;
                        const i = e.target,
                            n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1,
                            r = this.slides[n],
                            s = e.animationName;
                        if (!i || !r || !s) return;
                        const o = !!this.inTransition.has(n) && r.transition;
                        o && s.substring(0, o.length + 2) === `f-${o}` && this.inTransition.delete(n),
                            this.inTransition.size || this.clearTransitions(),
                            n === this.page && (null === (t = this.panzoom) || void 0 === t ? void 0 : t.isResting) && this.emit("settle");
                    }
                    onDecel(e, t = 0, i = 0, n = 0, r = 0) {
                        const { isRTL: s, isHorizontal: o, axis: a, pages: l } = this,
                            c = l.length,
                            u = Math.abs(Math.atan2(i, t) / (Math.PI / 180));
                        let d = 0;
                        if (((d = u > 45 && u < 135 ? (o ? 0 : i) : o ? t : 0), !c)) return;
                        const h = this.option("dragFree");
                        let f = this.page,
                            p = s && o ? 1 : -1;
                        const m = e.target[a] * p,
                            g = e.current[a] * p;
                        let { pageIndex: v } = this.getPageFromPosition(m),
                            { pageIndex: b } = this.getPageFromPosition(g);
                        h
                            ? this.onChange(v)
                            : (Math.abs(d) > 5
                                  ? (l[f].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (f = b), (f = s && o ? (d < 0 ? f - 1 : f + 1) : d < 0 ? f + 1 : f - 1))
                                  : (f = 0 === n && 0 === r ? f : b),
                              this.slideTo(f, { transition: !1, friction: e.option("decelFriction") }));
                    }
                    onClick(e) {
                        const t = e.target,
                            i = t && _(t) ? t.dataset : null;
                        let n, r;
                        i && (void 0 !== i.carouselPage ? ((r = "slideTo"), (n = i.carouselPage)) : void 0 !== i.carouselNext ? (r = "slideNext") : void 0 !== i.carouselPrev && (r = "slidePrev")),
                            r ? (e.preventDefault(), e.stopPropagation(), t && !t.hasAttribute("disabled") && this[r](n)) : this.emit("click", e);
                    }
                    onSlideTo(e) {
                        const t = e.detail || 0;
                        this.slideTo(this.getPageForSlide(t), { friction: 0 });
                    }
                    onChange(e, t = 0) {
                        const i = this.page;
                        (this.prevPage = i), (this.page = e), this.option("adaptiveHeight") && this.setViewportHeight(), e !== i && (this.markSelectedSlides(), this.emit("change", e, i, t));
                    }
                    onRefresh() {
                        let e = this.contentDim,
                            t = this.viewportDim;
                        this.updateMetrics(), (this.contentDim === e && this.viewportDim === t) || this.slideTo(this.page, { friction: 0, transition: !1 });
                    }
                    onScroll() {
                        var e;
                        null === (e = this.viewport) || void 0 === e || e.scroll(0, 0);
                    }
                    onResize() {
                        this.option("breakpoints") && this.processOptions();
                    }
                    onBeforeTransform(e) {
                        this.lp !== e.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), (this.lp = e.current.e);
                    }
                    onEndAnimation() {
                        this.inTransition.size || this.emit("settle");
                    }
                    reInit(e = null, t = null) {
                        this.destroy(), (this.state = R.Init), (this.userOptions = e || this.userOptions), (this.userPlugins = t || this.userPlugins), this.processOptions();
                    }
                    slideTo(e = 0, { friction: t = this.option("friction"), transition: i = this.option("transition") } = {}) {
                        if (this.state === R.Destroy) return;
                        e = parseInt((e || 0).toString()) || 0;
                        const n = this.getPageFromIndex(e),
                            { axis: r, isHorizontal: s, isRTL: o, pages: a, panzoom: l } = this,
                            c = a.length,
                            u = o && s ? 1 : -1;
                        if (!l || !c) return;
                        if (this.page !== n) {
                            const t = new Event("beforeChange", { bubbles: !0, cancelable: !0 });
                            if ((this.emit("beforeChange", t, e), t.defaultPrevented)) return;
                        }
                        if (this.transitionTo(e, i)) return;
                        let d = a[n].pos;
                        if (this.isInfinite) {
                            const t = this.contentDim,
                                i = l.target[r] * u;
                            2 === c
                                ? (d += t * Math.floor(parseFloat(e + "") / 2))
                                : (d = [d, d - t, d + t].reduce(function (e, t) {
                                      return Math.abs(t - i) < Math.abs(e - i) ? t : e;
                                  }));
                        }
                        (d *= u), Math.abs(l.target[r] - d) < 1 || (l.panTo({ x: s ? d : 0, y: s ? 0 : d, friction: t }), this.onChange(n));
                    }
                    slideToClosest(e) {
                        if (this.panzoom) {
                            const { pageIndex: t } = this.getPageFromPosition(this.panzoom.current[this.isHorizontal ? "e" : "f"]);
                            this.slideTo(t, e);
                        }
                    }
                    slideNext() {
                        this.slideTo(this.page + 1);
                    }
                    slidePrev() {
                        this.slideTo(this.page - 1);
                    }
                    clearTransitions() {
                        this.inTransition.clear(), T(this.container, this.cn("inTransition"));
                        const e = ["to-prev", "to-next", "from-prev", "from-next"];
                        for (const t of this.slides) {
                            const i = t.el;
                            if (i) {
                                i.removeEventListener(G, this.onAnimationEnd), i.classList.remove(...e);
                                const n = t.transition;
                                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
                            }
                        }
                        this.manageSlideVisiblity();
                    }
                    addSlide(e, t) {
                        var i, n, r, s;
                        const o = this.panzoom,
                            a = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0,
                            l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0,
                            c = this.contentDim < this.viewportDim;
                        let u = Array.isArray(t) ? t : [t];
                        const d = [];
                        for (const e of u) d.push(F(e));
                        this.slides.splice(e, 0, ...d);
                        for (let e = 0; e < this.slides.length; e++) this.slides[e].index = e;
                        for (const e of d) this.emit("beforeInitSlide", e, e.index);
                        if ((this.page >= e && (this.page += d.length), this.updateMetrics(), o)) {
                            const t = (null === (r = this.pages[this.page]) || void 0 === r ? void 0 : r.pos) || 0,
                                i = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.dim) || 0,
                                n = this.pages.length || 1,
                                u = this.isRTL ? l - i : i - l,
                                d = this.isRTL ? a - t : t - a;
                            c && 1 === n
                                ? (e <= this.page && ((o.current[this.axis] -= u), (o.target[this.axis] -= u)), o.panTo({ [this.isHorizontal ? "x" : "y"]: -1 * t }))
                                : d && e <= this.page && ((o.target[this.axis] -= d), (o.current[this.axis] -= d), o.requestTick());
                        }
                        for (const e of d) this.emit("initSlide", e, e.index);
                    }
                    prependSlide(e) {
                        this.addSlide(0, e);
                    }
                    appendSlide(e) {
                        this.addSlide(this.slides.length, e);
                    }
                    removeSlide(e) {
                        const t = this.slides.length;
                        (e = ((e % t) + t) % t), this.removeSlideEl(this.slides[e], !0), this.slides.splice(e, 1);
                        for (let e = 0; e < this.slides.length; e++) this.slides[e].index = e;
                        this.updateMetrics(), this.slideTo(this.page, { friction: 0, transition: !1 });
                    }
                    updateMetrics() {
                        const { panzoom: e, viewport: t, track: i, slides: r, isHorizontal: s, isInfinite: o } = this;
                        if (!i) return;
                        const a = s ? "width" : "height",
                            l = s ? "offsetWidth" : "offsetHeight";
                        if (t) {
                            let e = Math.max(t[l], n(t.getBoundingClientRect()[a], 1e3)),
                                i = getComputedStyle(t),
                                r = "padding",
                                o = s ? "Right" : "Bottom";
                            (e -= parseFloat(i[r + (s ? "Left" : "Top")]) + parseFloat(i[r + o])), (this.viewportDim = e);
                        }
                        let c,
                            u = 0;
                        for (const [e, t] of r.entries()) {
                            let i = 0,
                                s = 0;
                            !t.el && c ? ((i = c.dim), (s = c.gap)) : (({ dim: i, gap: s } = this.getSlideMetrics(t)), (c = t)),
                                (i = n(i, 1e3)),
                                (s = n(s, 1e3)),
                                (t.dim = i),
                                (t.gap = s),
                                (t.pos = u),
                                (u += i),
                                (o || e < r.length - 1) && (u += s);
                        }
                        (u = n(u, 1e3)),
                            (this.contentDim = u),
                            e && ((e.contentRect[a] = u), (e.contentRect["e" === this.axis ? "fullWidth" : "fullHeight"] = u)),
                            (this.pages = this.createPages()),
                            (this.pages = this.processPages()),
                            this.state === R.Init && this.setInitialPage(),
                            (this.page = Math.max(0, Math.min(this.page, this.pages.length - 1))),
                            this.manageSlideVisiblity(),
                            this.emit("refresh");
                    }
                    getProgress(e, t = !1, i = !1) {
                        void 0 === e && (e = this.page);
                        const r = this,
                            s = r.panzoom,
                            o = r.contentDim,
                            a = r.pages[e] || 0;
                        if (!a || !s) return e > this.page ? -1 : 1;
                        let l = -1 * s.current.e,
                            c = n((l - a.pos) / (1 * a.dim), 1e3),
                            u = c,
                            d = c;
                        this.isInfinite && !0 !== i && ((u = n((l - a.pos + o) / (1 * a.dim), 1e3)), (d = n((l - a.pos - o) / (1 * a.dim), 1e3)));
                        let h = [c, u, d].reduce(function (e, t) {
                            return Math.abs(t) < Math.abs(e) ? t : e;
                        });
                        return t ? h : h > 1 ? 1 : h < -1 ? -1 : h;
                    }
                    setViewportHeight() {
                        const { page: e, pages: t, viewport: i, isHorizontal: n } = this;
                        if (!i || !t[e]) return;
                        let r = 0;
                        n &&
                            this.track &&
                            ((this.track.style.height = "auto"),
                            t[e].slides.forEach((e) => {
                                e.el && (r = Math.max(r, e.el.offsetHeight));
                            })),
                            (i.style.height = r ? `${r}px` : "");
                    }
                    getPageForSlide(e) {
                        for (const t of this.pages) for (const i of t.slides) if (i.index === e) return t.index;
                        return -1;
                    }
                    getVisibleSlides(e = 0) {
                        var t;
                        const i = new Set();
                        let { contentDim: n, viewportDim: r, pages: s, page: o } = this;
                        n = n + (null === (t = this.slides[this.slides.length - 1]) || void 0 === t ? void 0 : t.gap) || 0;
                        let a = 0;
                        (a = this.panzoom && this.panzoom.state !== y.Init && this.panzoom.state !== y.Destroy ? -1 * this.panzoom.current[this.axis] : (s[o] && s[o].pos) || 0),
                            this.isInfinite && (a -= Math.floor(a / n) * n),
                            this.isRTL && this.isHorizontal && (a *= -1);
                        const l = a - r * e,
                            c = a + r * (e + 1),
                            u = this.isInfinite ? [-1, 0, 1] : [0];
                        for (const e of this.slides)
                            for (const t of u) {
                                const r = e.pos + t * n,
                                    s = r + e.dim + e.gap;
                                r < c && s > l && i.add(e);
                            }
                        return i;
                    }
                    getPageFromPosition(e) {
                        var t;
                        const { viewportDim: i, contentDim: n } = this,
                            r = this.pages.length,
                            s = this.slides.length,
                            o = this.slides[s - 1];
                        let a = 0,
                            l = 0,
                            c = 0;
                        const u = this.option("center");
                        u && (e += 0.5 * i), this.isInfinite || (e = Math.max((null === (t = this.slides[0]) || void 0 === t ? void 0 : t.pos) || 0, Math.min(e, o.pos)));
                        const d = n + o.gap;
                        (c = Math.floor(e / d) || 0), (e -= c * d);
                        let h = o,
                            f = this.slides.find((t) => {
                                const i = e + (h && !u ? 0.5 * h.dim : 0);
                                return (h = t), t.pos <= i && t.pos + t.dim + t.gap > i;
                            });
                        return f || (f = o), (l = this.getPageForSlide(f.index)), (a = l + c * r), { page: a, pageIndex: l };
                    }
                    destroy() {
                        if ([R.Destroy].includes(this.state)) return;
                        this.state = R.Destroy;
                        const { container: e, viewport: t, track: i, slides: n, panzoom: r } = this,
                            s = this.option("classes");
                        e.removeEventListener("click", this.onClick, { passive: !1, capture: !1 }),
                            e.removeEventListener("slideTo", this.onSlideTo),
                            window.removeEventListener("resize", this.onResize),
                            r && (r.destroy(), (this.panzoom = null)),
                            n &&
                                n.forEach((e) => {
                                    this.removeSlideEl(e);
                                }),
                            this.detachPlugins(),
                            t && (t.removeEventListener("scroll", this.onScroll), t.offsetParent && i && i.offsetParent && t.replaceWith(...i.childNodes));
                        for (const [t, i] of Object.entries(s)) "container" !== t && i && e.classList.remove(i);
                        (this.track = null), (this.viewport = null), (this.page = 0), (this.slides = []);
                        const o = this.events.get("ready");
                        (this.events = new Map()), o && this.events.set("ready", o);
                    }
                }
                Object.defineProperty(K, "Panzoom", { enumerable: !0, configurable: !0, writable: !0, value: z }),
                    Object.defineProperty(K, "defaults", {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: {
                            viewport: null,
                            track: null,
                            enabled: !0,
                            slides: [],
                            axis: "x",
                            transition: "fade",
                            preload: 1,
                            slidesPerPage: "auto",
                            initialPage: 0,
                            friction: 0.12,
                            Panzoom: { decelFriction: 0.12 },
                            center: !0,
                            infinite: !0,
                            fill: !0,
                            dragFree: !1,
                            adaptiveHeight: !1,
                            direction: "ltr",
                            classes: {
                                container: "f-carousel",
                                viewport: "f-carousel__viewport",
                                track: "f-carousel__track",
                                slide: "f-carousel__slide",
                                isLTR: "is-ltr",
                                isRTL: "is-rtl",
                                isHorizontal: "is-horizontal",
                                isVertical: "is-vertical",
                                inTransition: "in-transition",
                                isSelected: "is-selected",
                            },
                            l10n: { NEXT: "Next slide", PREV: "Previous slide", GOTO: "Go to slide #%d" },
                        },
                    }),
                    Object.defineProperty(K, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: X });
                const J = function (e) {
                        const t = window.pageYOffset,
                            i = window.pageYOffset + window.innerHeight;
                        if (!_(e)) return 0;
                        const n = e.getBoundingClientRect(),
                            r = n.y + window.pageYOffset,
                            s = n.y + n.height + window.pageYOffset;
                        if (t > s || i < r) return 0;
                        if (t < r && i > s) return 100;
                        if (r < t && s > i) return 100;
                        let o = n.height;
                        r < t && (o -= window.pageYOffset - r), s > i && (o -= s - i);
                        const a = (o / window.innerHeight) * 100;
                        return Math.round(a);
                    },
                    Q = !("undefined" == typeof window || !window.document || !window.document.createElement);
                let ee;
                const te = [
                        "a[href]",
                        "area[href]",
                        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                        "select:not([disabled]):not([aria-hidden])",
                        "textarea:not([disabled]):not([aria-hidden])",
                        "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
                        "iframe",
                        "object",
                        "embed",
                        "video",
                        "audio",
                        "[contenteditable]",
                        '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])',
                    ].join(","),
                    ie = (e) => {
                        if (e && Q) {
                            void 0 === ee &&
                                document.createElement("div").focus({
                                    get preventScroll() {
                                        return (ee = !0), !1;
                                    },
                                });
                            try {
                                if (ee) e.focus({ preventScroll: !0 });
                                else {
                                    const t = window.pageXOffset || document.body.scrollTop,
                                        i = window.pageYOffset || document.body.scrollLeft;
                                    e.focus(), document.body.scrollTo({ top: t, left: i, behavior: "auto" });
                                }
                            } catch (e) {}
                        }
                    },
                    ne = {
                        dragToClose: !0,
                        hideScrollbar: !0,
                        Carousel: { classes: { container: "fancybox__carousel", viewport: "fancybox__viewport", track: "fancybox__track", slide: "fancybox__slide" } },
                        contentClick: "toggleZoom",
                        contentDblClick: !1,
                        backdropClick: "close",
                        animated: !0,
                        idle: 3500,
                        showClass: "f-zoomInUp",
                        hideClass: "f-fadeOut",
                        commonCaption: !1,
                        parentEl: null,
                        startIndex: 0,
                        l10n: Object.assign(Object.assign({}, x), {
                            CLOSE: "Close",
                            NEXT: "Next",
                            PREV: "Previous",
                            MODAL: "You can close this modal content with the ESC key",
                            ERROR: "Something Went Wrong, Please Try Again Later",
                            IMAGE_ERROR: "Image Not Found",
                            ELEMENT_NOT_FOUND: "HTML Element Not Found",
                            AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
                            AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
                            IFRAME_ERROR: "Error Loading Page",
                            TOGGLE_ZOOM: "Toggle zoom level",
                            TOGGLE_THUMBS: "Toggle thumbnails",
                            TOGGLE_SLIDESHOW: "Toggle slideshow",
                            TOGGLE_FULLSCREEN: "Toggle full-screen mode",
                            DOWNLOAD: "Download",
                        }),
                        tpl: {
                            closeButton:
                                '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
                            main:
                                '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>',
                        },
                        groupAll: !1,
                        groupAttr: "data-fancybox",
                        defaultType: "image",
                        defaultDisplay: "block",
                        autoFocus: !0,
                        trapFocus: !0,
                        placeFocusBack: !0,
                        closeButton: "auto",
                        keyboard: { Escape: "close", Delete: "close", Backspace: "close", PageUp: "next", PageDown: "prev", ArrowUp: "prev", ArrowDown: "next", ArrowRight: "next", ArrowLeft: "prev" },
                        Fullscreen: { autoStart: !1 },
                        compact: () => window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
                        wheel: "zoom",
                    };
                var re, se;
                !(function (e) {
                    (e[(e.Init = 0)] = "Init"), (e[(e.Ready = 1)] = "Ready"), (e[(e.Closing = 2)] = "Closing"), (e[(e.CustomClosing = 3)] = "CustomClosing"), (e[(e.Destroy = 4)] = "Destroy");
                })(re || (re = {})),
                    (function (e) {
                        (e[(e.Loading = 0)] = "Loading"), (e[(e.Opening = 1)] = "Opening"), (e[(e.Ready = 2)] = "Ready"), (e[(e.Closing = 3)] = "Closing");
                    })(se || (se = {}));
                const oe = () => {
                    queueMicrotask(() => {
                        (() => {
                            const { slug: e, index: t } = ae.parseURL(),
                                i = at.getInstance();
                            if (i && !1 !== i.option("Hash")) {
                                const n = i.carousel;
                                if (e && n) {
                                    for (let t of n.slides) if (t.slug && t.slug === e) return n.slideTo(t.index);
                                    if (e === i.option("slug")) return n.slideTo(t - 1);
                                    const r = i.getSlide(),
                                        s = r && r.triggerEl && r.triggerEl.dataset;
                                    if (s && s.fancybox === e) return n.slideTo(t - 1);
                                }
                                (ae.hasSilentClose = !0), i.close();
                            }
                            ae.startFromUrl();
                        })();
                    });
                };
                class ae extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "origHash", { enumerable: !0, configurable: !0, writable: !0, value: "" }),
                            Object.defineProperty(this, "timer", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    onChange() {
                        const e = this.instance,
                            t = e.carousel;
                        this.timer && clearTimeout(this.timer);
                        const i = e.getSlide();
                        if (!t || !i) return;
                        const n = e.isOpeningSlide(i),
                            r = new URL(document.URL).hash;
                        let s,
                            o = i.slug || void 0,
                            a = i.triggerEl || void 0;
                        (s = o || this.instance.option("slug")), !s && a && a.dataset && (s = a.dataset.fancybox);
                        let l = "";
                        s && "true" !== s && (l = "#" + s + (!o && t.slides.length > 1 ? "-" + (i.index + 1) : "")),
                            n && (this.origHash = r !== l ? r : ""),
                            l &&
                                r !== l &&
                                (this.timer = setTimeout(() => {
                                    try {
                                        e.state === re.Ready && window.history[n ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + l);
                                    } catch (e) {}
                                }, 300));
                    }
                    onClose() {
                        if ((this.timer && clearTimeout(this.timer), !0 !== ae.hasSilentClose))
                            try {
                                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
                            } catch (e) {}
                    }
                    attach() {
                        const e = this.instance;
                        e.on(["Carousel.ready", "Carousel.change"], this.onChange), e.on("close", this.onClose);
                    }
                    detach() {
                        const e = this.instance;
                        e.off(["Carousel.ready", "Carousel.change"], this.onChange), e.off("close", this.onClose);
                    }
                    static parseURL() {
                        const e = window.location.hash.slice(1),
                            t = e.split("-"),
                            i = t[t.length - 1],
                            n = (i && /^\+?\d+$/.test(i) && parseInt(t.pop() || "1", 10)) || 1;
                        return { hash: e, slug: t.join("-"), index: n };
                    }
                    static startFromUrl() {
                        if (((ae.hasSilentClose = !1), at.getInstance() || !1 === at.defaults.Hash)) return;
                        const { hash: e, slug: t, index: i } = ae.parseURL();
                        if (!t) return;
                        let n = document.querySelector(`[data-slug="${e}"]`);
                        if ((n && n.dispatchEvent(new CustomEvent("click", { bubbles: !0, cancelable: !0 })), at.getInstance())) return;
                        const r = document.querySelectorAll(`[data-fancybox="${t}"]`);
                        r.length && ((n = r[i - 1]), n && n.dispatchEvent(new CustomEvent("click", { bubbles: !0, cancelable: !0 })));
                    }
                    static destroy() {
                        window.removeEventListener("hashchange", oe, !1);
                    }
                }
                function le() {
                    window.addEventListener("hashchange", oe, !1),
                        setTimeout(() => {
                            ae.startFromUrl();
                        }, 500);
                }
                Object.defineProperty(ae, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
                    Object.defineProperty(ae, "hasSilentClose", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                    Q && (/complete|interactive|loaded/.test(document.readyState) ? le() : document.addEventListener("DOMContentLoaded", le));
                const ce = "is-zooming-in";
                class ue extends N {
                    onCreateSlide(e, t, i) {
                        const n = this.instance.optionFor(i, "src") || "";
                        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
                    }
                    onRemoveSlide(e, t, i) {
                        i.panzoom && i.panzoom.destroy(), (i.panzoom = void 0), (i.imageEl = void 0);
                    }
                    onChange(e, t, i, n) {
                        T(this.instance.container, ce);
                        for (const e of t.slides) {
                            const t = e.panzoom;
                            t && e.index !== i && t.reset(0.35);
                        }
                    }
                    onClose() {
                        var e;
                        const t = this.instance,
                            i = t.container,
                            n = t.getSlide();
                        if (!i || !i.parentElement || !n) return;
                        const { el: r, contentEl: s, panzoom: o, thumbElSrc: a } = n;
                        if (!r || !a || !s || !o || o.isContentLoading || o.state === y.Init || o.state === y.Destroy) return;
                        o.updateMetrics();
                        let l = this.getZoomInfo(n);
                        if (!l) return;
                        (this.instance.state = re.CustomClosing), i.classList.remove(ce), i.classList.add("is-zooming-out"), (s.style.backgroundImage = `url('${a}')`);
                        const c = i.getBoundingClientRect();
                        1 === ((null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1) &&
                            Object.assign(i.style, { position: "absolute", top: `${window.scrollY}px`, left: `${window.scrollX}px`, bottom: "auto", right: "auto", width: `${c.width}px`, height: `${c.height}px`, overflow: "hidden" });
                        const { x: u, y: d, scale: h, opacity: f } = l;
                        if (f) {
                            const e = ((e, t, i, n) => {
                                const r = t - e;
                                return (t) => 1 + (((t - e) / r) * -1 || 0);
                            })(o.scale, h);
                            o.on("afterTransform", () => {
                                s.style.opacity = e(o.scale) + "";
                            });
                        }
                        o.on("endAnimation", () => {
                            t.destroy();
                        }),
                            (o.target.a = h),
                            (o.target.b = 0),
                            (o.target.c = 0),
                            (o.target.d = h),
                            o.panTo({ x: u, y: d, scale: h, friction: f ? 0.2 : 0.33, ignoreBounds: !0 }),
                            o.isResting && t.destroy();
                    }
                    setImage(e, t) {
                        const i = this.instance;
                        (e.src = t),
                            this.process(e, t).then(
                                (t) => {
                                    const { contentEl: n, imageEl: r, thumbElSrc: s, el: o } = e;
                                    if (i.isClosing() || !n || !r) return;
                                    n.offsetHeight;
                                    const a = !!i.isOpeningSlide(e) && this.getZoomInfo(e);
                                    if (this.option("protected") && o) {
                                        o.addEventListener("contextmenu", (e) => {
                                            e.preventDefault();
                                        });
                                        const e = document.createElement("div");
                                        M(e, "fancybox-protected"), n.appendChild(e);
                                    }
                                    if (s && a) {
                                        const r = t.contentRect,
                                            o = Math.max(r.fullWidth, r.fullHeight);
                                        let c = null;
                                        !a.opacity && o > 1200 && ((c = document.createElement("img")), M(c, "fancybox-ghost"), (c.src = s), n.appendChild(c));
                                        const u = () => {
                                            c &&
                                                (M(c, "f-fadeFastOut"),
                                                setTimeout(() => {
                                                    c && (c.remove(), (c = null));
                                                }, 200));
                                        };
                                        ((l = s),
                                        new Promise((e, t) => {
                                            const i = new Image();
                                            (i.onload = e), (i.onerror = t), (i.src = l);
                                        })).then(
                                            () => {
                                                i.hideLoading(e),
                                                    (e.state = se.Opening),
                                                    this.instance.emit("reveal", e),
                                                    this.zoomIn(e).then(
                                                        () => {
                                                            u(), this.instance.done(e);
                                                        },
                                                        () => {}
                                                    ),
                                                    c &&
                                                        setTimeout(
                                                            () => {
                                                                u();
                                                            },
                                                            o > 2500 ? 800 : 200
                                                        );
                                            },
                                            () => {
                                                i.hideLoading(e), i.revealContent(e);
                                            }
                                        );
                                    } else {
                                        const n = this.optionFor(e, "initialSize"),
                                            r = this.optionFor(e, "zoom"),
                                            s = { event: i.prevMouseMoveEvent || i.options.event, friction: r ? 0.12 : 0 };
                                        let o = i.optionFor(e, "showClass") || void 0,
                                            a = !0;
                                        i.isOpeningSlide(e) && ("full" === n ? t.zoomToFull(s) : "cover" === n ? t.zoomToCover(s) : "max" === n ? t.zoomToMax(s) : (a = !1), t.stop("current")),
                                            a && o && (o = t.isDragging ? "f-fadeIn" : ""),
                                            i.hideLoading(e),
                                            i.revealContent(e, o);
                                    }
                                    var l;
                                },
                                () => {
                                    i.setError(e, "{{IMAGE_ERROR}}");
                                }
                            );
                    }
                    process(e, t) {
                        return new Promise((i, n) => {
                            var r;
                            const s = this.instance,
                                a = e.el;
                            s.clearContent(e), s.showLoading(e);
                            let l = this.optionFor(e, "content");
                            if (("string" == typeof l && (l = o(l)), !l || !_(l))) {
                                if (((l = document.createElement("img")), l instanceof HTMLImageElement)) {
                                    let i = "",
                                        n = e.caption;
                                    (i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${e.index + 1} of ${null === (r = s.carousel) || void 0 === r ? void 0 : r.pages.length}`),
                                        (l.src = t || ""),
                                        (l.alt = i),
                                        (l.draggable = !1),
                                        e.srcset && l.setAttribute("srcset", e.srcset),
                                        this.instance.isOpeningSlide(e) && (l.fetchPriority = "high");
                                }
                                e.sizes && l.setAttribute("sizes", e.sizes);
                            }
                            M(l, "fancybox-image"),
                                (e.imageEl = l),
                                s.setContent(e, l, !1),
                                (e.panzoom = new z(
                                    a,
                                    m({ transformParent: !0 }, this.option("Panzoom") || {}, {
                                        content: l,
                                        width: s.optionFor(e, "width", "auto"),
                                        height: s.optionFor(e, "height", "auto"),
                                        wheel: () => {
                                            const e = s.option("wheel");
                                            return ("zoom" === e || "pan" == e) && e;
                                        },
                                        click: (t, i) => {
                                            var n, r;
                                            if (s.isCompact || s.isClosing()) return !1;
                                            if (e.index !== (null === (n = s.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                                            if (i) {
                                                const e = i.composedPath()[0];
                                                if (["A", "BUTTON", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].includes(e.nodeName)) return !1;
                                            }
                                            let o = !i || (i.target && (null === (r = e.contentEl) || void 0 === r ? void 0 : r.contains(i.target)));
                                            return s.option(o ? "contentClick" : "backdropClick") || !1;
                                        },
                                        dblClick: () => (s.isCompact ? "toggleZoom" : s.option("contentDblClick") || !1),
                                        spinner: !1,
                                        panOnlyZoomed: !0,
                                        wheelLimit: 1 / 0,
                                        on: {
                                            ready: (e) => {
                                                i(e);
                                            },
                                            error: () => {
                                                n();
                                            },
                                            destroy: () => {
                                                n();
                                            },
                                        },
                                    })
                                ));
                        });
                    }
                    zoomIn(e) {
                        return new Promise((t, i) => {
                            const n = this.instance,
                                r = n.container,
                                { panzoom: s, contentEl: o, el: a } = e;
                            s && s.updateMetrics();
                            const l = this.getZoomInfo(e);
                            if (!(l && a && o && s && r)) return void i();
                            const { x: c, y: u, scale: d, opacity: h } = l,
                                f = () => {
                                    e.state !== se.Closing && (h && (o.style.opacity = Math.max(Math.min(1, 1 - (1 - s.scale) / (1 - d)), 0) + ""), s.scale >= 1 && s.scale > s.targetScale - 0.1 && t(s));
                                },
                                p = (e) => {
                                    ((e.scale < 0.99 || e.scale > 1.01) && !e.isDragging) || (T(r, ce), (o.style.opacity = ""), e.off("endAnimation", p), e.off("touchStart", p), e.off("afterTransform", f), t(e));
                                };
                            s.on("endAnimation", p),
                                s.on("touchStart", p),
                                s.on("afterTransform", f),
                                s.on(["error", "destroy"], () => {
                                    i();
                                }),
                                s.panTo({ x: c, y: u, scale: d, friction: 0, ignoreBounds: !0 }),
                                s.stop("current");
                            const m = { event: "mousemove" === s.panMode ? n.prevMouseMoveEvent || n.options.event : void 0 },
                                g = this.optionFor(e, "initialSize");
                            M(r, ce), n.hideLoading(e), "full" === g ? s.zoomToFull(m) : "cover" === g ? s.zoomToCover(m) : "max" === g ? s.zoomToMax(m) : s.reset(0.172);
                        });
                    }
                    getZoomInfo(e) {
                        var t;
                        const { el: i, imageEl: n, thumbEl: r, panzoom: s } = e;
                        if (!i || !n || !r || !s || J(r) < 3 || !this.optionFor(e, "zoom") || this.instance.state === re.Destroy) return !1;
                        if (1 !== ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1)) return !1;
                        let { top: o, left: a, width: l, height: c } = r.getBoundingClientRect(),
                            { top: u, left: d, fitWidth: h, fitHeight: f } = s.contentRect;
                        if (!(l && c && h && f)) return !1;
                        const p = s.container.getBoundingClientRect();
                        (d += p.left), (u += p.top);
                        const m = -1 * (d + 0.5 * h - (a + 0.5 * l)),
                            g = -1 * (u + 0.5 * f - (o + 0.5 * c)),
                            v = l / h;
                        let b = this.option("zoomOpacity") || !1;
                        return "auto" === b && (b = Math.abs(l / c - h / f) > 0.1), { x: m, y: g, scale: v, opacity: b };
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("Carousel.change", e.onChange), t.on("Carousel.createSlide", e.onCreateSlide), t.on("Carousel.removeSlide", e.onRemoveSlide), t.on("close", e.onClose);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("Carousel.change", e.onChange), t.off("Carousel.createSlide", e.onCreateSlide), t.off("Carousel.removeSlide", e.onRemoveSlide), t.off("close", e.onClose);
                    }
                }
                Object.defineProperty(ue, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: { initialSize: "fit", Panzoom: { maxScale: 1 }, protected: !1, zoom: !0, zoomOpacity: "auto" } }),
                    "function" == typeof SuppressedError && SuppressedError;
                const de = "html",
                    he = "image",
                    fe = "map",
                    pe = "youtube",
                    me = "vimeo",
                    ge = "html5video",
                    ve = (e, t = {}) => {
                        const i = new URL(e),
                            n = new URLSearchParams(i.search),
                            r = new URLSearchParams();
                        for (const [e, i] of [...n, ...Object.entries(t)]) {
                            let t = i.toString();
                            "t" === e ? r.set("start", parseInt(t).toString()) : r.set(e, t);
                        }
                        let s = r.toString(),
                            o = e.match(/#t=((.*)?\d+s)/);
                        return o && (s += `#t=${o[1]}`), s;
                    },
                    be = ["image", "html", "ajax", "inline", "clone", "iframe", "map", "pdf", "html5video", "youtube", "vimeo"];
                class ye extends N {
                    onBeforeInitSlide(e, t, i) {
                        this.processType(i);
                    }
                    onCreateSlide(e, t, i) {
                        this.setContent(i);
                    }
                    onClearContent(e, t) {
                        t.xhr && (t.xhr.abort(), (t.xhr = null));
                        const i = t.iframeEl;
                        i && ((i.onload = i.onerror = null), (i.src = "//about:blank"), (t.iframeEl = null));
                        const n = t.contentEl,
                            r = t.placeholderEl;
                        if ("inline" === t.type && n && r)
                            n.classList.remove("fancybox__content"), "none" !== n.style.display && (n.style.display = "none"), r.parentNode && r.parentNode.insertBefore(n, r), r.remove(), (t.contentEl = void 0), (t.placeholderEl = void 0);
                        else for (; t.el && t.el.firstChild; ) t.el.removeChild(t.el.firstChild);
                    }
                    onSelectSlide(e, t, i) {
                        i.state === se.Ready && this.playVideo();
                    }
                    onUnselectSlide(e, t, i) {
                        var n, r;
                        if (i.type === ge) {
                            try {
                                null === (r = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === r || r.pause();
                            } catch (e) {}
                            return;
                        }
                        let s;
                        i.type === me ? (s = { method: "pause", value: "true" }) : i.type === pe && (s = { event: "command", func: "pauseVideo" }),
                            s && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(s), "*"),
                            i.poller && clearTimeout(i.poller);
                    }
                    onDone(e, t) {
                        e.isCurrentSlide(t) && !e.isClosing() && this.playVideo();
                    }
                    onRefresh(e, t) {
                        t.slides.forEach((e) => {
                            e.el && (this.resizeIframe(e), this.setAspectRatio(e));
                        });
                    }
                    onMessage(e) {
                        try {
                            let t = JSON.parse(e.data);
                            if ("https://player.vimeo.com" === e.origin) {
                                if ("ready" === t.event) for (let t of Array.from(document.getElementsByClassName("fancybox__iframe"))) t instanceof HTMLIFrameElement && t.contentWindow === e.source && (t.dataset.ready = "true");
                            } else if (e.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === t.event) {
                                const e = document.getElementById(t.id);
                                e && (e.dataset.ready = "true");
                            }
                        } catch (e) {}
                    }
                    loadAjaxContent(e) {
                        const t = this.instance.optionFor(e, "src") || "";
                        this.instance.showLoading(e);
                        const i = this.instance,
                            n = new XMLHttpRequest();
                        i.showLoading(e),
                            (n.onreadystatechange = function () {
                                n.readyState === XMLHttpRequest.DONE &&
                                    i.state === re.Ready &&
                                    (i.hideLoading(e), 200 === n.status ? i.setContent(e, n.responseText) : i.setError(e, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
                            });
                        const r = e.ajax || null;
                        n.open(r ? "POST" : "GET", t + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(r), (e.xhr = n);
                    }
                    setInlineContent(e) {
                        let t = null;
                        if (_(e.src)) t = e.src;
                        else if ("string" == typeof e.src) {
                            const i = e.src.split("#", 2).pop();
                            t = i ? document.getElementById(i) : null;
                        }
                        if (t) {
                            if ("clone" === e.type || t.closest(".fancybox__slide")) {
                                t = t.cloneNode(!0);
                                const i = t.dataset.animationName;
                                i && (t.classList.remove(i), delete t.dataset.animationName);
                                let n = t.getAttribute("id");
                                (n = n ? `${n}--clone` : `clone-${this.instance.id}-${e.index}`), t.setAttribute("id", n);
                            } else if (t.parentNode) {
                                const i = document.createElement("div");
                                i.classList.add("fancybox-placeholder"), t.parentNode.insertBefore(i, t), (e.placeholderEl = i);
                            }
                            this.instance.setContent(e, t);
                        } else this.instance.setError(e, "{{ELEMENT_NOT_FOUND}}");
                    }
                    setIframeContent(e) {
                        const { src: t, el: i } = e;
                        if (!t || "string" != typeof t || !i) return;
                        i.classList.add("is-loading");
                        const n = this.instance,
                            r = document.createElement("iframe");
                        (r.className = "fancybox__iframe"), r.setAttribute("id", `fancybox__iframe_${n.id}_${e.index}`);
                        for (const [t, i] of Object.entries(this.optionFor(e, "iframeAttr") || {})) r.setAttribute(t, i);
                        (r.onerror = () => {
                            n.setError(e, "{{IFRAME_ERROR}}");
                        }),
                            (e.iframeEl = r);
                        const s = this.optionFor(e, "preload");
                        if ("iframe" !== e.type || !1 === s) return r.setAttribute("src", e.src + ""), n.setContent(e, r, !1), this.resizeIframe(e), void n.revealContent(e);
                        n.showLoading(e),
                            (r.onload = () => {
                                if (!r.src.length) return;
                                const t = "true" !== r.dataset.ready;
                                (r.dataset.ready = "true"), this.resizeIframe(e), t ? n.revealContent(e) : n.hideLoading(e);
                            }),
                            r.setAttribute("src", t),
                            n.setContent(e, r, !1);
                    }
                    resizeIframe(e) {
                        const { type: t, iframeEl: i } = e;
                        if (t === pe || t === me) return;
                        const n = null == i ? void 0 : i.parentElement;
                        if (!i || !n) return;
                        let r = e.autoSize;
                        void 0 === r && (r = this.optionFor(e, "autoSize"));
                        let s = e.width || 0,
                            o = e.height || 0;
                        s && o && (r = !1);
                        const a = n && n.style;
                        if (!1 !== e.preload && !1 !== r && a)
                            try {
                                const e = window.getComputedStyle(n),
                                    t = parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                                    r = parseFloat(e.paddingTop) + parseFloat(e.paddingBottom),
                                    l = i.contentWindow;
                                if (l) {
                                    const e = l.document,
                                        i = e.getElementsByTagName(de)[0],
                                        n = e.body;
                                    (a.width = ""),
                                        (n.style.overflow = "hidden"),
                                        (s = s || i.scrollWidth + t),
                                        (a.width = `${s}px`),
                                        (n.style.overflow = ""),
                                        (a.flex = "0 0 auto"),
                                        (a.height = `${n.scrollHeight}px`),
                                        (o = i.scrollHeight + r);
                                }
                            } catch (e) {}
                        if (s || o) {
                            const e = { flex: "0 1 auto", width: "", height: "" };
                            s && "auto" !== s && (e.width = `${s}px`), o && "auto" !== o && (e.height = `${o}px`), Object.assign(a, e);
                        }
                    }
                    playVideo() {
                        const e = this.instance.getSlide();
                        if (!e) return;
                        const { el: t } = e;
                        if (!t || !t.offsetParent) return;
                        if (!this.optionFor(e, "videoAutoplay")) return;
                        if (e.type === ge)
                            try {
                                const e = t.querySelector("video");
                                if (e) {
                                    const t = e.play();
                                    void 0 !== t &&
                                        t
                                            .then(() => {})
                                            .catch((t) => {
                                                (e.muted = !0), e.play();
                                            });
                                }
                            } catch (e) {}
                        if (e.type !== pe && e.type !== me) return;
                        const i = () => {
                            if (e.iframeEl && e.iframeEl.contentWindow) {
                                let t;
                                if ("true" === e.iframeEl.dataset.ready)
                                    return (t = e.type === pe ? { event: "command", func: "playVideo" } : { method: "play", value: "true" }), t && e.iframeEl.contentWindow.postMessage(JSON.stringify(t), "*"), void (e.poller = void 0);
                                e.type === pe && ((t = { event: "listening", id: e.iframeEl.getAttribute("id") }), e.iframeEl.contentWindow.postMessage(JSON.stringify(t), "*"));
                            }
                            e.poller = setTimeout(i, 250);
                        };
                        i();
                    }
                    processType(e) {
                        if (e.html) return (e.type = de), (e.src = e.html), void (e.html = "");
                        const t = this.instance.optionFor(e, "src", "");
                        if (!t || "string" != typeof t) return;
                        let i = e.type,
                            n = null;
                        if ((n = t.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i))) {
                            const r = this.optionFor(e, pe),
                                { nocookie: s } = r,
                                o = (function (e, t) {
                                    var i = {};
                                    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
                                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                                        var r = 0;
                                        for (n = Object.getOwnPropertySymbols(e); r < n.length; r++) t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (i[n[r]] = e[n[r]]);
                                    }
                                    return i;
                                })(r, ["nocookie"]),
                                a = `www.youtube${s ? "-nocookie" : ""}.com`,
                                l = ve(t, o),
                                c = encodeURIComponent(n[2]);
                            (e.videoId = c), (e.src = `https://${a}/embed/${c}?${l}`), (e.thumbSrc = e.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`), (i = pe);
                        } else if ((n = t.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/))) {
                            const r = ve(t, this.optionFor(e, me)),
                                s = encodeURIComponent(n[1]),
                                o = n[4] || "";
                            (e.videoId = s), (e.src = `https://player.vimeo.com/video/${s}?${o ? `h=${o}${r ? "&" : ""}` : ""}${r}`), (i = me);
                        }
                        if (!i && e.triggerEl) {
                            const t = e.triggerEl.dataset.type;
                            be.includes(t) && (i = t);
                        }
                        i ||
                            ("string" == typeof t &&
                                ("#" === t.charAt(0)
                                    ? (i = "inline")
                                    : (n = t.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                                    ? ((i = ge), (e.videoFormat = e.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])))
                                    : t.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)
                                    ? (i = he)
                                    : t.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf"))),
                            (n = t.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i))
                                ? ((e.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${
                                      n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"
                                  }`),
                                  (i = fe))
                                : (n = t.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) &&
                                  ((e.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`), (i = fe)),
                            (i = i || this.instance.option("defaultType")),
                            (e.type = i),
                            i === he && (e.thumbSrc = e.thumbSrc || e.src);
                    }
                    setContent(e) {
                        const t = this.instance.optionFor(e, "src") || "";
                        if (e && e.type && t) {
                            switch (e.type) {
                                case de:
                                    this.instance.setContent(e, t);
                                    break;
                                case ge:
                                    const i = this.option("videoTpl");
                                    i &&
                                        this.instance.setContent(
                                            e,
                                            i
                                                .replace(/\{\{src\}\}/gi, t + "")
                                                .replace(/\{\{format\}\}/gi, this.optionFor(e, "videoFormat") || "")
                                                .replace(/\{\{poster\}\}/gi, e.poster || e.thumbSrc || "")
                                        );
                                    break;
                                case "inline":
                                case "clone":
                                    this.setInlineContent(e);
                                    break;
                                case "ajax":
                                    this.loadAjaxContent(e);
                                    break;
                                case "pdf":
                                case fe:
                                case pe:
                                case me:
                                    e.preload = !1;
                                case "iframe":
                                    this.setIframeContent(e);
                            }
                            this.setAspectRatio(e);
                        }
                    }
                    setAspectRatio(e) {
                        const t = e.contentEl;
                        if (!(e.el && t && e.type && [pe, me, ge].includes(e.type))) return;
                        let i,
                            n = e.width || "auto",
                            r = e.height || "auto";
                        if ("auto" === n || "auto" === r) {
                            i = this.optionFor(e, "videoRatio");
                            const t = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
                            i = t && t.length > 2 ? parseFloat(t[1]) / parseFloat(t[2]) : parseFloat(i + "");
                        } else n && r && (i = n / r);
                        if (!i) return;
                        (t.style.aspectRatio = ""), (t.style.width = ""), (t.style.height = ""), t.offsetHeight;
                        const s = t.getBoundingClientRect(),
                            o = s.width || 1,
                            a = s.height || 1;
                        (t.style.aspectRatio = i + ""),
                            i < o / a ? ((r = "auto" === r ? a : Math.min(a, r)), (t.style.width = "auto"), (t.style.height = `${r}px`)) : ((n = "auto" === n ? o : Math.min(o, n)), (t.style.width = `${n}px`), (t.style.height = "auto"));
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("Carousel.beforeInitSlide", e.onBeforeInitSlide),
                            t.on("Carousel.createSlide", e.onCreateSlide),
                            t.on("Carousel.selectSlide", e.onSelectSlide),
                            t.on("Carousel.unselectSlide", e.onUnselectSlide),
                            t.on("Carousel.Panzoom.refresh", e.onRefresh),
                            t.on("done", e.onDone),
                            t.on("clearContent", e.onClearContent),
                            window.addEventListener("message", e.onMessage);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("Carousel.beforeInitSlide", e.onBeforeInitSlide),
                            t.off("Carousel.createSlide", e.onCreateSlide),
                            t.off("Carousel.selectSlide", e.onSelectSlide),
                            t.off("Carousel.unselectSlide", e.onUnselectSlide),
                            t.off("Carousel.Panzoom.refresh", e.onRefresh),
                            t.off("done", e.onDone),
                            t.off("clearContent", e.onClearContent),
                            window.removeEventListener("message", e.onMessage);
                    }
                }
                Object.defineProperty(ye, "defaults", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: {
                        ajax: null,
                        autoSize: !0,
                        iframeAttr: { allow: "autoplay; fullscreen", scrolling: "auto" },
                        preload: !0,
                        videoAutoplay: !0,
                        videoRatio: 16 / 9,
                        videoTpl:
                            '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
                        videoFormat: "",
                        vimeo: { byline: 1, color: "00adef", controls: 1, dnt: 1, muted: 0 },
                        youtube: { controls: 1, enablejsapi: 1, nocookie: 1, rel: 0, fs: 1 },
                    },
                });
                const we = "play",
                    xe = "pause",
                    Se = "ready";
                class Ee extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: Se }),
                            Object.defineProperty(this, "inHover", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "timer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "progressBar", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    get isActive() {
                        return this.state !== Se;
                    }
                    onReady(e) {
                        this.option("autoStart") && (e.isInfinite || e.page < e.pages.length - 1) && this.start();
                    }
                    onChange() {
                        var e;
                        (null === (e = this.instance.panzoom) || void 0 === e ? void 0 : e.isResting) || (this.removeProgressBar(), this.pause());
                    }
                    onSettle() {
                        this.resume();
                    }
                    onVisibilityChange() {
                        "visible" === document.visibilityState ? this.resume() : this.pause();
                    }
                    onMouseEnter() {
                        (this.inHover = !0), this.pause();
                    }
                    onMouseLeave() {
                        var e;
                        (this.inHover = !1), (null === (e = this.instance.panzoom) || void 0 === e ? void 0 : e.isResting) && this.resume();
                    }
                    onTimerEnd() {
                        const e = this.instance;
                        "play" === this.state && (e.isInfinite || e.page !== e.pages.length - 1 ? e.slideNext() : e.slideTo(0));
                    }
                    removeProgressBar() {
                        this.progressBar && (this.progressBar.remove(), (this.progressBar = null));
                    }
                    createProgressBar() {
                        var e;
                        if (!this.option("showProgress")) return null;
                        this.removeProgressBar();
                        const t = this.instance,
                            i = (null === (e = t.pages[t.page]) || void 0 === e ? void 0 : e.slides) || [];
                        let n = this.option("progressParentEl");
                        if ((n || (n = (1 === i.length ? i[0].el : null) || t.viewport), !n)) return null;
                        const r = document.createElement("div");
                        return M(r, "f-progress"), n.prepend(r), (this.progressBar = r), r.offsetHeight, r;
                    }
                    set() {
                        const e = this,
                            t = e.instance;
                        if (t.pages.length < 2) return;
                        if (e.timer) return;
                        const i = e.option("timeout");
                        (e.state = we), M(t.container, "has-autoplay");
                        let n = e.createProgressBar();
                        n && ((n.style.transitionDuration = `${i}ms`), (n.style.transform = "scaleX(1)")),
                            (e.timer = setTimeout(() => {
                                (e.timer = null), e.inHover || e.onTimerEnd();
                            }, i)),
                            e.emit("set");
                    }
                    clear() {
                        const e = this;
                        e.timer && (clearTimeout(e.timer), (e.timer = null)), e.removeProgressBar();
                    }
                    start() {
                        const e = this;
                        if ((e.set(), e.state !== Se)) {
                            if (e.option("pauseOnHover")) {
                                const t = e.instance.container;
                                t.addEventListener("mouseenter", e.onMouseEnter, !1), t.addEventListener("mouseleave", e.onMouseLeave, !1);
                            }
                            document.addEventListener("visibilitychange", e.onVisibilityChange, !1), e.emit("start");
                        }
                    }
                    stop() {
                        const e = this,
                            t = e.state,
                            i = e.instance.container;
                        e.clear(),
                            (e.state = Se),
                            i.removeEventListener("mouseenter", e.onMouseEnter, !1),
                            i.removeEventListener("mouseleave", e.onMouseLeave, !1),
                            document.removeEventListener("visibilitychange", e.onVisibilityChange, !1),
                            T(i, "has-autoplay"),
                            t !== Se && e.emit("stop");
                    }
                    pause() {
                        const e = this;
                        e.state === we && ((e.state = xe), e.clear(), e.emit(xe));
                    }
                    resume() {
                        const e = this,
                            t = e.instance;
                        if (t.isInfinite || t.page !== t.pages.length - 1)
                            if (e.state !== we) {
                                if (e.state === xe && !e.inHover) {
                                    const t = new Event("resume", { bubbles: !0, cancelable: !0 });
                                    e.emit("resume", t), t.defaultPrevented || e.set();
                                }
                            } else e.set();
                        else e.stop();
                    }
                    toggle() {
                        this.state === we || this.state === xe ? this.stop() : this.start();
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("ready", e.onReady), t.on("Panzoom.startAnimation", e.onChange), t.on("Panzoom.endAnimation", e.onSettle), t.on("Panzoom.touchMove", e.onChange);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("ready", e.onReady), t.off("Panzoom.startAnimation", e.onChange), t.off("Panzoom.endAnimation", e.onSettle), t.off("Panzoom.touchMove", e.onChange), e.stop();
                    }
                }
                Object.defineProperty(Ee, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: { autoStart: !0, pauseOnHover: !0, progressParentEl: null, showProgress: !0, timeout: 3e3 } });
                class _e extends N {
                    constructor() {
                        super(...arguments), Object.defineProperty(this, "ref", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    onPrepare(e) {
                        const t = e.carousel;
                        if (!t) return;
                        const i = e.container;
                        i &&
                            ((t.options.Autoplay = m({ autoStart: !1 }, this.option("Autoplay") || {}, {
                                pauseOnHover: !1,
                                timeout: this.option("timeout"),
                                progressParentEl: () => this.option("progressParentEl") || null,
                                on: {
                                    start: () => {
                                        e.emit("startSlideshow");
                                    },
                                    set: (t) => {
                                        var n;
                                        i.classList.add("has-slideshow"), (null === (n = e.getSlide()) || void 0 === n ? void 0 : n.state) !== se.Ready && t.pause();
                                    },
                                    stop: () => {
                                        i.classList.remove("has-slideshow"), e.isCompact || e.endIdle(), e.emit("endSlideshow");
                                    },
                                    resume: (t, i) => {
                                        var n, r, s;
                                        !i ||
                                            !i.cancelable ||
                                            ((null === (n = e.getSlide()) || void 0 === n ? void 0 : n.state) === se.Ready &&
                                                (null === (s = null === (r = e.carousel) || void 0 === r ? void 0 : r.panzoom) || void 0 === s ? void 0 : s.isResting)) ||
                                            i.preventDefault();
                                    },
                                },
                            })),
                            t.attachPlugins({ Autoplay: Ee }),
                            (this.ref = t.plugins.Autoplay));
                    }
                    onReady(e) {
                        const t = e.carousel,
                            i = this.ref;
                        i && t && this.option("playOnStart") && (t.isInfinite || t.page < t.pages.length - 1) && i.start();
                    }
                    onDone(e, t) {
                        const i = this.ref,
                            n = e.carousel;
                        if (!i || !n) return;
                        const r = t.panzoom;
                        r &&
                            r.on("startAnimation", () => {
                                e.isCurrentSlide(t) && i.stop();
                            }),
                            e.isCurrentSlide(t) && i.resume();
                    }
                    onKeydown(e, t) {
                        var i;
                        const n = this.ref;
                        n && t === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("Carousel.init", e.onPrepare), t.on("Carousel.ready", e.onReady), t.on("done", e.onDone), t.on("keydown", e.onKeydown);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("Carousel.init", e.onPrepare), t.off("Carousel.ready", e.onReady), t.off("done", e.onDone), t.off("keydown", e.onKeydown);
                    }
                }
                Object.defineProperty(_e, "defaults", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: {
                        key: " ",
                        playOnStart: !1,
                        progressParentEl: (e) => {
                            var t;
                            return (null === (t = e.instance.container) || void 0 === t ? void 0 : t.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || e.instance.container;
                        },
                        timeout: 3e3,
                    },
                });
                const Te = {
                    classes: {
                        container: "f-thumbs f-carousel__thumbs",
                        viewport: "f-thumbs__viewport",
                        track: "f-thumbs__track",
                        slide: "f-thumbs__slide",
                        isResting: "is-resting",
                        isSelected: "is-selected",
                        isLoading: "is-loading",
                        hasThumbs: "has-thumbs",
                    },
                    minCount: 2,
                    parentEl: null,
                    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
                    type: "modern",
                };
                var Me;
                !(function (e) {
                    (e[(e.Init = 0)] = "Init"), (e[(e.Ready = 1)] = "Ready"), (e[(e.Hidden = 2)] = "Hidden");
                })(Me || (Me = {}));
                const Pe = "isResting",
                    Ce = "thumbWidth",
                    Oe = "thumbHeight",
                    Le = "thumbClipWidth";
                let ke = class extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "type", { enumerable: !0, configurable: !0, writable: !0, value: "modern" }),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "track", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "carousel", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "thumbWidth", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "thumbClipWidth", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "thumbHeight", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "thumbGap", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "thumbExtraGap", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: Me.Init });
                    }
                    get isModern() {
                        return "modern" === this.type;
                    }
                    onInitSlide(e, t) {
                        const i = t.el ? t.el.dataset : void 0;
                        i && ((t.thumbSrc = i.thumbSrc || t.thumbSrc || ""), (t[Le] = parseFloat(i[Le] || "") || t[Le] || 0), (t[Oe] = parseFloat(i.thumbHeight || "") || t[Oe] || 0)), this.addSlide(t);
                    }
                    onInitSlides() {
                        this.build();
                    }
                    onChange() {
                        var e;
                        if (!this.isModern) return;
                        const t = this.container,
                            i = this.instance,
                            n = i.panzoom,
                            r = this.carousel,
                            s = r ? r.panzoom : null,
                            o = i.page;
                        if (n && r && s) {
                            if (n.isDragging) {
                                T(t, this.cn(Pe));
                                let n = (null === (e = r.pages[o]) || void 0 === e ? void 0 : e.pos) || 0;
                                n += i.getProgress(o) * (this[Le] + this.thumbGap);
                                let a = s.getBounds();
                                -1 * n > a.x.min && -1 * n < a.x.max && s.panTo({ x: -1 * n, friction: 0.12 });
                            } else l(t, this.cn(Pe), n.isResting);
                            this.shiftModern();
                        }
                    }
                    onRefresh() {
                        this.updateProps();
                        for (const e of this.instance.slides || []) this.resizeModernSlide(e);
                        this.shiftModern();
                    }
                    isDisabled() {
                        const e = this.option("minCount") || 0;
                        if (e) {
                            const t = this.instance;
                            let i = 0;
                            for (const e of t.slides || []) e.thumbSrc && i++;
                            if (i < e) return !0;
                        }
                        const t = this.option("type");
                        return ["modern", "classic"].indexOf(t) < 0;
                    }
                    getThumb(e) {
                        const t = this.option("thumbTpl") || "";
                        return {
                            html: this.instance.localize(t, [
                                ["%i", e.index],
                                ["%d", e.index + 1],
                                ["%s", e.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"],
                            ]),
                        };
                    }
                    addSlide(e) {
                        const t = this.carousel;
                        t && t.addSlide(e.index, this.getThumb(e));
                    }
                    getSlides() {
                        const e = [];
                        for (const t of this.instance.slides || []) e.push(this.getThumb(t));
                        return e;
                    }
                    resizeModernSlide(e) {
                        this.isModern && (e[Ce] = e[Le] && e[Oe] ? Math.round(this[Oe] * (e[Le] / e[Oe])) : this[Ce]);
                    }
                    updateProps() {
                        const e = this.container;
                        if (!e) return;
                        const t = (t) => parseFloat(getComputedStyle(e).getPropertyValue("--f-thumb-" + t)) || 0;
                        (this.thumbGap = t("gap")), (this.thumbExtraGap = t("extra-gap")), (this[Ce] = t("width") || 40), (this[Le] = t("clip-width") || 40), (this[Oe] = t("height") || 40);
                    }
                    build() {
                        if (this.state !== Me.Init) return;
                        if (this.isDisabled()) return;
                        const e = this.instance,
                            t = e.container,
                            i = this.getSlides(),
                            n = this.option("type");
                        this.type = n;
                        const r = document.createElement("div");
                        M(r, this.cn("container")), M(r, `is-${n}`);
                        const s = this.option("parentEl");
                        s ? s.appendChild(r) : t.after(r), M(t, this.cn("hasThumbs")), (this.container = r), this.updateProps();
                        const o = document.createElement("div");
                        M(o, this.cn("track")), r.appendChild(o), (this.track = o);
                        const a = m(
                                {},
                                {
                                    track: o,
                                    infinite: !1,
                                    center: !0,
                                    fill: "classic" === n,
                                    dragFree: !0,
                                    slidesPerPage: 1,
                                    transition: !1,
                                    preload: 0.25,
                                    friction: 0.12,
                                    Panzoom: { maxVelocity: 0 },
                                    Dots: !1,
                                    Navigation: !1,
                                    classes: { container: "f-thumbs", viewport: "f-thumbs__viewport", track: "f-thumbs__track", slide: "f-thumbs__slide" },
                                },
                                this.option("Carousel") || {},
                                { Sync: { target: e }, slides: i }
                            ),
                            l = new e.constructor(r, a);
                        l.on("createSlide", (e, t) => {
                            this.setProps(t.index), this.emit("createSlide", t, t.el);
                        }),
                            l.on("ready", () => {
                                this.shiftModern(), this.emit("ready");
                            }),
                            l.on("refresh", () => {
                                this.shiftModern();
                            }),
                            l.on("Panzoom.click", (e, t, i) => {
                                this.onClick(i);
                            }),
                            (this.carousel = l),
                            (this.state = Me.Ready);
                    }
                    onClick(e) {
                        e.preventDefault(), e.stopPropagation();
                        const t = this.instance,
                            { pages: i, page: n } = t,
                            r = (e) => {
                                if (e) {
                                    const t = e.closest("[data-carousel-index]");
                                    if (t) return [parseInt(t.dataset.carouselIndex || "", 10) || 0, t];
                                }
                                return [-1, void 0];
                            },
                            s = (e, t) => {
                                const i = document.elementFromPoint(e, t);
                                return i ? r(i) : [-1, void 0];
                            };
                        let [o, a] = r(e.target);
                        if (o > -1) return;
                        const l = this[Le],
                            c = e.clientX,
                            u = e.clientY;
                        let [d, h] = s(c - l, u),
                            [f, p] = s(c + l, u);
                        h && p ? ((o = Math.abs(c - h.getBoundingClientRect().right) < Math.abs(c - p.getBoundingClientRect().left) ? d : f), o === n && (o = o === d ? f : d)) : h ? (o = d) : p && (o = f), o > -1 && i[o] && t.slideTo(o);
                    }
                    getShift(e) {
                        var t;
                        const { instance: i } = this,
                            n = this.carousel;
                        if (!i || !n) return 0;
                        const r = this[Ce],
                            s = this[Le],
                            o = this.thumbGap,
                            a = this.thumbExtraGap;
                        if (!(null === (t = n.slides[e]) || void 0 === t ? void 0 : t.el)) return 0;
                        const l = 0.5 * (r - s),
                            c = i.pages.length - 1;
                        let u = i.getProgress(0),
                            d = i.getProgress(c),
                            h = i.getProgress(e, !1, !0),
                            f = 0,
                            p = l + a + o;
                        const m = u < 0 && u > -1,
                            g = d > 0 && d < 1;
                        return (
                            0 === e
                                ? ((f = p * Math.abs(u)), g && 1 === u && (f -= p * Math.abs(d)))
                                : e === c
                                ? ((f = p * Math.abs(d) * -1), m && -1 === d && (f += p * Math.abs(u)))
                                : m || g
                                ? ((f = -1 * p), (f += p * Math.abs(u)), (f += p * (1 - Math.abs(d))))
                                : (f = p * h),
                            f
                        );
                    }
                    setProps(e) {
                        if (!this.isModern) return;
                        const { instance: t } = this,
                            i = this.carousel;
                        if (t && i) {
                            const r = i.slides[e].el;
                            if (r && r.childNodes.length) {
                                let i = n(1 - Math.abs(t.getProgress(e))),
                                    s = n(this.getShift(e));
                                r.style.setProperty("--progress", i ? i + "" : ""), r.style.setProperty("--shift", s + "");
                            }
                        }
                    }
                    shiftModern() {
                        if (!this.isModern) return;
                        const { instance: e, track: t } = this,
                            i = e.panzoom,
                            n = this.carousel;
                        if (!(e && t && i && n)) return;
                        if (i.state === y.Init || i.state === y.Destroy) return;
                        for (const t of e.slides) this.setProps(t.index);
                        let r = (this[Le] + this.thumbGap) * (n.slides.length || 0);
                        t.style.setProperty("--width", r + "");
                    }
                    cleanup() {
                        this.carousel && this.carousel.destroy(),
                            (this.carousel = null),
                            this.container && this.container.remove(),
                            (this.container = null),
                            this.track && this.track.remove(),
                            (this.track = null),
                            (this.state = Me.Init),
                            T(this.instance.container, this.cn("hasThumbs"));
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("initSlide", e.onInitSlide), t.state === R.Init ? t.on("initSlides", e.onInitSlides) : e.onInitSlides(), t.on(["change", "Panzoom.afterTransform"], e.onChange), t.on("Panzoom.refresh", e.onRefresh);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("initSlide", e.onInitSlide), t.off("initSlides", e.onInitSlides), t.off(["change", "Panzoom.afterTransform"], e.onChange), t.off("Panzoom.refresh", e.onRefresh), e.cleanup();
                    }
                };
                Object.defineProperty(ke, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: Te });
                const Ae = Object.assign(Object.assign({}, Te), { key: "t", showOnStart: !0, parentEl: null }),
                    Ie = "is-masked",
                    ze = "aria-hidden";
                class De extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "ref", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "hidden", { enumerable: !0, configurable: !0, writable: !0, value: !1 });
                    }
                    get isEnabled() {
                        const e = this.ref;
                        return e && !e.isDisabled();
                    }
                    get isHidden() {
                        return this.hidden;
                    }
                    onClick(e, t) {
                        t.stopPropagation();
                    }
                    onCreateSlide(e, t) {
                        var i, n, r;
                        const s = (null === (r = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[t.index]) || void 0 === r ? void 0 : r.type) || "",
                            o = t.el;
                        if (o && s) {
                            let e = `for-${s}`;
                            ["video", "youtube", "vimeo", "html5video"].includes(s) && (e += " for-video"), M(o, e);
                        }
                    }
                    onInit() {
                        var e;
                        const t = this,
                            i = t.instance,
                            n = i.carousel;
                        if (t.ref || !n) return;
                        const r = t.option("parentEl") || i.footer || i.container;
                        if (!r) return;
                        const s = m({}, t.options, {
                            parentEl: r,
                            classes: { container: "f-thumbs fancybox__thumbs" },
                            Carousel: { Sync: { friction: i.option("Carousel.friction") || 0 } },
                            on: {
                                ready: (e) => {
                                    const i = e.container;
                                    i &&
                                        this.hidden &&
                                        (t.refresh(),
                                        (i.style.transition = "none"),
                                        t.hide(),
                                        i.offsetHeight,
                                        queueMicrotask(() => {
                                            (i.style.transition = ""), t.show();
                                        }));
                                },
                            },
                        });
                        (s.Carousel = s.Carousel || {}),
                            (s.Carousel.on = m((null === (e = t.options.Carousel) || void 0 === e ? void 0 : e.on) || {}, { click: this.onClick, createSlide: this.onCreateSlide })),
                            (n.options.Thumbs = s),
                            n.attachPlugins({ Thumbs: ke }),
                            (t.ref = n.plugins.Thumbs),
                            t.option("showOnStart") || ((t.ref.state = Me.Hidden), (t.hidden = !0));
                    }
                    onResize() {
                        var e;
                        const t = null === (e = this.ref) || void 0 === e ? void 0 : e.container;
                        t && (t.style.maxHeight = "");
                    }
                    onKeydown(e, t) {
                        const i = this.option("key");
                        i && i === t && this.toggle();
                    }
                    toggle() {
                        const e = this.ref;
                        if (e && !e.isDisabled()) return e.state === Me.Hidden ? ((e.state = Me.Init), void e.build()) : void (this.hidden ? this.show() : this.hide());
                    }
                    show() {
                        const e = this.ref;
                        if (!e || e.isDisabled()) return;
                        const t = e.container;
                        t && (this.refresh(), t.offsetHeight, t.removeAttribute(ze), t.classList.remove(Ie), (this.hidden = !1));
                    }
                    hide() {
                        const e = this.ref,
                            t = e && e.container;
                        t && (this.refresh(), t.offsetHeight, t.classList.add(Ie), t.setAttribute(ze, "true")), (this.hidden = !0);
                    }
                    refresh() {
                        const e = this.ref;
                        if (!e || !e.state) return;
                        const t = e.container,
                            i = (null == t ? void 0 : t.firstChild) || null;
                        t && i && i.childNodes.length && (t.style.maxHeight = `${i.getBoundingClientRect().height}px`);
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.state === re.Init ? t.on("Carousel.init", e.onInit) : e.onInit(), t.on("resize", e.onResize), t.on("keydown", e.onKeydown);
                    }
                    detach() {
                        var e;
                        const t = this,
                            i = t.instance;
                        i.off("Carousel.init", t.onInit), i.off("resize", t.onResize), i.off("keydown", t.onKeydown), null === (e = i.carousel) || void 0 === e || e.detachPlugins(["Thumbs"]), (t.ref = null);
                    }
                }
                Object.defineProperty(De, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: Ae });
                const je = {
                    panLeft: { icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>', change: { panX: -100 } },
                    panRight: { icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>', change: { panX: 100 } },
                    panUp: { icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>', change: { panY: -100 } },
                    panDown: { icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>', change: { panY: 100 } },
                    zoomIn: { icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>', action: "zoomIn" },
                    zoomOut: { icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "zoomOut" },
                    toggle1to1: {
                        icon:
                            '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
                        action: "toggleZoom",
                    },
                    toggleZoom: { icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "toggleZoom" },
                    iterateZoom: { icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "iterateZoom" },
                    rotateCCW: { icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>', action: "rotateCCW" },
                    rotateCW: { icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>', action: "rotateCW" },
                    flipX: { icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>', action: "flipX" },
                    flipY: { icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>', action: "flipY" },
                    fitX: { icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>', action: "fitX" },
                    fitY: { icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>', action: "fitY" },
                    reset: { icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>', action: "reset" },
                    toggleFS: { icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>', action: "toggleFS" },
                };
                var Re;
                !(function (e) {
                    (e[(e.Init = 0)] = "Init"), (e[(e.Ready = 1)] = "Ready"), (e[(e.Disabled = 2)] = "Disabled");
                })(Re || (Re = {}));
                const Fe = { tabindex: "-1", width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" };
                class $e extends N {
                    constructor() {
                        super(...arguments),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: Re.Init }),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null });
                    }
                    onReady(e) {
                        var t;
                        if (!e.carousel) return;
                        let i = this.option("display"),
                            n = this.option("absolute"),
                            r = this.option("enabled");
                        if ("auto" === r) {
                            const e = this.instance.carousel;
                            let t = 0;
                            if (e) for (const i of e.slides) (i.panzoom || "image" === i.type) && t++;
                            t || (r = !1);
                        }
                        r || (i = void 0);
                        let s = 0;
                        const o = { left: [], middle: [], right: [] };
                        if (i)
                            for (const e of ["left", "middle", "right"])
                                for (const n of i[e]) {
                                    const i = this.createEl(n);
                                    i && (null === (t = o[e]) || void 0 === t || t.push(i), s++);
                                }
                        let a = null;
                        if ((s && (a = this.createContainer()), a)) {
                            for (const [e, t] of Object.entries(o)) {
                                const i = document.createElement("div");
                                M(i, "fancybox__toolbar__column is-" + e);
                                for (const e of t) i.appendChild(e);
                                "auto" !== n || "middle" !== e || t.length || (n = !0), a.appendChild(i);
                            }
                            !0 === n && M(a, "is-absolute"), (this.state = Re.Ready), this.onRefresh();
                        } else this.state = Re.Disabled;
                    }
                    onClick(e) {
                        var t, i;
                        const n = this.instance,
                            r = n.getSlide(),
                            s = null == r ? void 0 : r.panzoom,
                            o = e.target,
                            a = o && _(o) ? o.dataset : null;
                        if (!a) return;
                        if (void 0 !== a.fancyboxToggleThumbs) return e.preventDefault(), e.stopPropagation(), void (null === (t = n.plugins.Thumbs) || void 0 === t || t.toggle());
                        if (void 0 !== a.fancyboxToggleFullscreen) return e.preventDefault(), e.stopPropagation(), void this.instance.toggleFullscreen();
                        if (void 0 !== a.fancyboxToggleSlideshow) {
                            e.preventDefault(), e.stopPropagation();
                            const t = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
                            let r = t.isActive;
                            return s && "mousemove" === s.panMode && !r && s.reset(), void (r ? t.stop() : t.start());
                        }
                        const l = a.panzoomAction,
                            c = a.panzoomChange;
                        if (((c || l) && (e.preventDefault(), e.stopPropagation()), c)) {
                            let t = {};
                            try {
                                t = JSON.parse(c);
                            } catch (e) {}
                            s && s.applyChange(t);
                        } else l && s && s[l] && s[l]();
                    }
                    onChange() {
                        this.onRefresh();
                    }
                    onRefresh() {
                        if (this.instance.isClosing()) return;
                        const e = this.container;
                        if (!e) return;
                        const t = this.instance.getSlide();
                        if (!t || t.state !== se.Ready) return;
                        const i = t && !t.error && t.panzoom;
                        for (const t of e.querySelectorAll("[data-panzoom-action]")) i ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
                        let n = i && i.canZoomIn(),
                            r = i && i.canZoomOut();
                        for (const t of e.querySelectorAll('[data-panzoom-action="zoomIn"]')) n ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
                        for (const t of e.querySelectorAll('[data-panzoom-action="zoomOut"]')) r ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
                        for (const t of e.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
                            r || n ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
                            const e = t.querySelector("g");
                            e && (e.style.display = n ? "" : "none");
                        }
                    }
                    onDone(e, t) {
                        var i;
                        null === (i = t.panzoom) ||
                            void 0 === i ||
                            i.on("afterTransform", () => {
                                this.instance.isCurrentSlide(t) && this.onRefresh();
                            }),
                            this.instance.isCurrentSlide(t) && this.onRefresh();
                    }
                    createContainer() {
                        const e = this.instance.container;
                        if (!e) return null;
                        const t = this.option("parentEl") || e,
                            i = document.createElement("div");
                        return M(i, "fancybox__toolbar"), t.prepend(i), i.addEventListener("click", this.onClick, { passive: !1, capture: !0 }), e && M(e, "has-toolbar"), (this.container = i), i;
                    }
                    createEl(e) {
                        const t = this.instance,
                            i = t.carousel;
                        if (!i) return null;
                        if ("toggleFS" === e) return null;
                        if ("fullscreen" === e && !t.fsAPI) return null;
                        let n = null;
                        const r = i.slides.length || 0;
                        let s = 0,
                            a = 0;
                        for (const e of i.slides) (e.panzoom || "image" === e.type) && s++, ("image" === e.type || e.downloadSrc) && a++;
                        if (r < 2 && ["infobar", "prev", "next"].includes(e)) return n;
                        if (void 0 !== je[e] && !s) return null;
                        if ("download" === e && !a) return null;
                        if ("thumbs" === e) {
                            const e = t.plugins.Thumbs;
                            if (!e || !e.isEnabled) return null;
                        }
                        if ("slideshow" === e && (!i.plugins.Autoplay || r < 2)) return null;
                        if (void 0 !== je[e]) {
                            const t = je[e];
                            (n = document.createElement("button")),
                                n.setAttribute("title", this.instance.localize(`{{${e.toUpperCase()}}}`)),
                                M(n, "f-button"),
                                t.action && (n.dataset.panzoomAction = t.action),
                                t.change && (n.dataset.panzoomChange = JSON.stringify(t.change)),
                                n.appendChild(o(this.instance.localize(t.icon)));
                        } else {
                            const t = (this.option("items") || [])[e];
                            t &&
                                ((n = o(this.instance.localize(t.tpl))),
                                "function" == typeof t.click &&
                                    n.addEventListener("click", (e) => {
                                        e.preventDefault(), e.stopPropagation(), "function" == typeof t.click && t.click.call(this, this, e);
                                    }));
                        }
                        const l = null == n ? void 0 : n.querySelector("svg");
                        if (l) for (const [e, t] of Object.entries(Fe)) l.getAttribute(e) || l.setAttribute(e, String(t));
                        return n;
                    }
                    removeContainer() {
                        const e = this.container;
                        e && e.remove(), (this.container = null), (this.state = Re.Disabled);
                        const t = this.instance.container;
                        t && T(t, "has-toolbar");
                    }
                    attach() {
                        const e = this,
                            t = e.instance;
                        t.on("Carousel.initSlides", e.onReady), t.on("done", e.onDone), t.on(["reveal", "Carousel.change"], e.onChange), e.onReady(e.instance);
                    }
                    detach() {
                        const e = this,
                            t = e.instance;
                        t.off("Carousel.initSlides", e.onReady), t.off("done", e.onDone), t.off(["reveal", "Carousel.change"], e.onChange), e.removeContainer();
                    }
                }
                Object.defineProperty($e, "defaults", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: {
                        absolute: "auto",
                        display: { left: ["infobar"], middle: [], right: ["iterateZoom", "slideshow", "fullscreen", "thumbs", "close"] },
                        enabled: "auto",
                        items: {
                            infobar: { tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>' },
                            download: { tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>' },
                            prev: { tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>' },
                            next: { tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>' },
                            slideshow: { tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>' },
                            fullscreen: {
                                tpl:
                                    '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>',
                            },
                            thumbs: {
                                tpl:
                                    '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>',
                            },
                            close: { tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>' },
                        },
                        parentEl: null,
                    },
                });
                const Ne = { Hash: ae, Html: ye, Images: ue, Slideshow: _e, Thumbs: De, Toolbar: $e },
                    Be = "with-fancybox",
                    He = "hide-scrollbar",
                    qe = "--fancybox-scrollbar-compensate",
                    Ve = "--fancybox-body-margin",
                    Ye = "is-using-tab",
                    We = "is-animated",
                    Xe = "is-compact",
                    Ge = "is-loading",
                    Ue = "has-caption",
                    Ze = "disabled",
                    Ke = "tabindex",
                    Je = "download",
                    Qe = "href",
                    et = "src",
                    tt = (e) => "string" == typeof e,
                    it = function () {
                        var e = window.getSelection();
                        return e && "Range" === e.type;
                    };
                let nt = null,
                    rt = null;
                const st = new Map();
                let ot = 0;
                class at extends b {
                    get isIdle() {
                        return this.idle;
                    }
                    get isCompact() {
                        return this.option("compact");
                    }
                    constructor(e = [], t = {}, i = {}) {
                        super(t),
                            Object.defineProperty(this, "userSlides", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
                            Object.defineProperty(this, "userPlugins", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
                            Object.defineProperty(this, "idle", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "idleTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "clickTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "pwt", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "ignoreFocusChange", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
                            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: re.Init }),
                            Object.defineProperty(this, "id", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
                            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "footer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "carousel", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "lastFocus", { enumerable: !0, configurable: !0, writable: !0, value: null }),
                            Object.defineProperty(this, "prevMouseMoveEvent", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            Object.defineProperty(this, "fsAPI", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
                            (this.fsAPI = (() => {
                                let e,
                                    t = "",
                                    i = "",
                                    n = "";
                                return (
                                    document.fullscreenEnabled
                                        ? ((t = "requestFullscreen"), (i = "exitFullscreen"), (n = "fullscreenElement"))
                                        : document.webkitFullscreenEnabled && ((t = "webkitRequestFullscreen"), (i = "webkitExitFullscreen"), (n = "webkitFullscreenElement")),
                                    t &&
                                        (e = {
                                            request: function (e) {
                                                return "webkitRequestFullscreen" === t ? e[t](Element.ALLOW_KEYBOARD_INPUT) : e[t]();
                                            },
                                            exit: function () {
                                                return document[n] && document[i]();
                                            },
                                            isFullscreen: function () {
                                                return document[n];
                                            },
                                        }),
                                    e
                                );
                            })()),
                            (this.id = t.id || ++ot),
                            st.set(this.id, this),
                            (this.userSlides = e),
                            (this.userPlugins = i),
                            queueMicrotask(() => {
                                this.init();
                            });
                    }
                    init() {
                        if (this.state === re.Destroy) return;
                        (this.state = re.Init),
                            this.attachPlugins(Object.assign(Object.assign({}, at.Plugins), this.userPlugins)),
                            this.emit("init"),
                            this.emit("attachPlugins"),
                            !0 === this.option("hideScrollbar") &&
                                (() => {
                                    if (!Q) return;
                                    const e = document,
                                        t = e.body,
                                        i = e.documentElement;
                                    if (t.classList.contains(He)) return;
                                    let n = window.innerWidth - i.getBoundingClientRect().width;
                                    const r = parseFloat(window.getComputedStyle(t).marginRight);
                                    n < 0 && (n = 0), i.style.setProperty(qe, `${n}px`), r && t.style.setProperty(Ve, `${r}px`), t.classList.add(He);
                                })(),
                            this.initLayout(),
                            this.scale();
                        const e = () => {
                                this.initCarousel(this.userSlides),
                                    (this.state = re.Ready),
                                    this.attachEvents(),
                                    this.emit("ready"),
                                    setTimeout(() => {
                                        this.container && this.container.setAttribute("aria-hidden", "false");
                                    }, 16);
                            },
                            t = this.fsAPI;
                        this.option("Fullscreen.autoStart") && t && !t.isFullscreen()
                            ? t
                                  .request(this.container)
                                  .then(() => e())
                                  .catch(() => e())
                            : e();
                    }
                    initLayout() {
                        var e, t;
                        const i = this.option("parentEl") || document.body,
                            n = o(this.localize(this.option("tpl.main") || ""));
                        n &&
                            (n.setAttribute("id", `fancybox-${this.id}`),
                            n.setAttribute("aria-label", this.localize("{{MODAL}}")),
                            n.classList.toggle(Xe, this.isCompact),
                            M(n, this.option("mainClass") || ""),
                            (this.container = n),
                            (this.footer = n.querySelector(".fancybox__footer")),
                            i.appendChild(n),
                            M(document.documentElement, Be),
                            (nt && rt) ||
                                ((nt = document.createElement("span")),
                                M(nt, "fancybox-focus-guard"),
                                nt.setAttribute(Ke, "0"),
                                nt.setAttribute("aria-hidden", "true"),
                                nt.setAttribute("aria-label", "Focus guard"),
                                (rt = nt.cloneNode()),
                                null === (e = n.parentElement) || void 0 === e || e.insertBefore(nt, n),
                                null === (t = n.parentElement) || void 0 === t || t.append(rt)),
                            n.addEventListener("mousedown", () => {
                                T(n, Ye);
                            }),
                            this.option("animated") &&
                                (M(n, We),
                                setTimeout(() => {
                                    this.isClosing() || T(n, We);
                                }, 350)),
                            this.emit("initLayout"));
                    }
                    initCarousel(e) {
                        const t = this.container;
                        if (!t) return;
                        const i = t.querySelector(".fancybox__carousel");
                        if (!i) return;
                        const n = (this.carousel = new K(
                            i,
                            m(
                                {},
                                {
                                    slides: e,
                                    transition: "fade",
                                    Panzoom: { lockAxis: this.option("dragToClose") ? "xy" : "x", infinite: !!this.option("dragToClose") && "y" },
                                    Dots: !1,
                                    Navigation: { classes: { container: "fancybox__nav", button: "f-button", isNext: "is-next", isPrev: "is-prev" } },
                                    initialPage: this.option("startIndex"),
                                    l10n: this.option("l10n"),
                                },
                                this.option("Carousel") || {}
                            )
                        ));
                        n.on("*", (e, t, ...i) => {
                            this.emit(`Carousel.${t}`, e, ...i);
                        }),
                            n.on(["ready", "change"], () => {
                                this.manageCaption();
                            }),
                            this.on("Carousel.removeSlide", (e, t, i) => {
                                this.clearContent(i), (i.state = void 0);
                            }),
                            n.on("Panzoom.touchStart", () => {
                                var e, t;
                                this.isCompact || this.endIdle(), (null === (e = document.activeElement) || void 0 === e ? void 0 : e.closest(".f-thumbs")) && (null === (t = this.container) || void 0 === t || t.focus());
                            }),
                            n.on("settle", () => {
                                this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
                            }),
                            this.option("dragToClose") &&
                                (n.on("Panzoom.afterTransform", (e, t) => {
                                    const i = this.getSlide();
                                    if (i && r(i.el)) return;
                                    const n = this.container;
                                    if (n) {
                                        const e = Math.abs(t.current.f),
                                            i = e < 1 ? "" : Math.max(0.5, Math.min(1, 1 - (e / t.contentRect.fitHeight) * 1.5));
                                        n.style.setProperty("--fancybox-ts", i ? "0s" : ""), n.style.setProperty("--fancybox-opacity", i + "");
                                    }
                                }),
                                n.on("Panzoom.touchEnd", (e, t, i) => {
                                    var n;
                                    const s = this.getSlide();
                                    if (s && r(s.el)) return;
                                    if (t.isMobile && document.activeElement && -1 !== ["TEXTAREA", "INPUT"].indexOf(null === (n = document.activeElement) || void 0 === n ? void 0 : n.nodeName)) return;
                                    const o = Math.abs(t.dragOffset.y);
                                    "y" === t.lockedAxis && (o >= 200 || (o >= 50 && t.dragOffset.time < 300)) && (i && i.cancelable && i.preventDefault(), this.close(i, "f-throwOut" + (t.current.f < 0 ? "Up" : "Down")));
                                })),
                            n.on("change", (e) => {
                                var t;
                                let i = null === (t = this.getSlide()) || void 0 === t ? void 0 : t.triggerEl;
                                if (i) {
                                    const t = new CustomEvent("slideTo", { bubbles: !0, cancelable: !0, detail: e.page });
                                    i.dispatchEvent(t);
                                }
                            }),
                            n.on(["refresh", "change"], (e) => {
                                const t = this.container;
                                if (!t) return;
                                for (const i of t.querySelectorAll("[data-fancybox-current-index]")) i.innerHTML = e.page + 1;
                                for (const i of t.querySelectorAll("[data-fancybox-count]")) i.innerHTML = e.pages.length;
                                if (!e.isInfinite) {
                                    for (const i of t.querySelectorAll("[data-fancybox-next]")) e.page < e.pages.length - 1 ? (i.removeAttribute(Ze), i.removeAttribute(Ke)) : (i.setAttribute(Ze, ""), i.setAttribute(Ke, "-1"));
                                    for (const i of t.querySelectorAll("[data-fancybox-prev]")) e.page > 0 ? (i.removeAttribute(Ze), i.removeAttribute(Ke)) : (i.setAttribute(Ze, ""), i.setAttribute(Ke, "-1"));
                                }
                                const i = this.getSlide();
                                if (!i) return;
                                let n = i.downloadSrc || "";
                                n || "image" !== i.type || i.error || !tt(i[et]) || (n = i[et]);
                                for (const e of t.querySelectorAll("[data-fancybox-download]")) {
                                    const t = i.downloadFilename;
                                    n
                                        ? (e.removeAttribute(Ze), e.removeAttribute(Ke), e.setAttribute(Qe, n), e.setAttribute(Je, t || n), e.setAttribute("target", "_blank"))
                                        : (e.setAttribute(Ze, ""), e.setAttribute(Ke, "-1"), e.removeAttribute(Qe), e.removeAttribute(Je));
                                }
                            }),
                            this.emit("initCarousel");
                    }
                    attachEvents() {
                        const e = this,
                            t = e.container;
                        if (!t) return;
                        t.addEventListener("click", e.onClick, { passive: !1, capture: !1 }),
                            t.addEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
                            document.addEventListener("keydown", e.onKeydown, { passive: !1, capture: !0 }),
                            document.addEventListener("visibilitychange", e.onVisibilityChange, !1),
                            document.addEventListener("mousemove", e.onMousemove),
                            e.option("trapFocus") && document.addEventListener("focus", e.onFocus, !0),
                            window.addEventListener("resize", e.onResize);
                        const i = window.visualViewport;
                        i && (i.addEventListener("scroll", e.onResize), i.addEventListener("resize", e.onResize));
                    }
                    detachEvents() {
                        const e = this,
                            t = e.container;
                        if (!t) return;
                        document.removeEventListener("keydown", e.onKeydown, { passive: !1, capture: !0 }),
                            t.removeEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
                            t.removeEventListener("click", e.onClick, { passive: !1, capture: !1 }),
                            document.removeEventListener("mousemove", e.onMousemove),
                            window.removeEventListener("resize", e.onResize);
                        const i = window.visualViewport;
                        i && (i.removeEventListener("resize", e.onResize), i.removeEventListener("scroll", e.onResize)),
                            document.removeEventListener("visibilitychange", e.onVisibilityChange, !1),
                            document.removeEventListener("focus", e.onFocus, !0);
                    }
                    scale() {
                        const e = this.container;
                        if (!e) return;
                        const t = window.visualViewport,
                            i = Math.max(1, (null == t ? void 0 : t.scale) || 1);
                        let n = "",
                            r = "",
                            s = "";
                        if (t && i > 1) {
                            let e = `${t.offsetLeft}px`,
                                o = `${t.offsetTop}px`;
                            (n = t.width * i + "px"), (r = t.height * i + "px"), (s = `translate3d(${e}, ${o}, 0) scale(${1 / i})`);
                        }
                        (e.style.transform = s), (e.style.width = n), (e.style.height = r);
                    }
                    onClick(e) {
                        var t, i;
                        const { container: n, isCompact: r } = this;
                        if (!n || this.isClosing()) return;
                        !r && this.option("idle") && this.resetIdle();
                        const s = e.composedPath()[0];
                        if (s.closest(".f-spinner") || s.closest("[data-fancybox-close]")) return e.preventDefault(), void this.close(e);
                        if (s.closest("[data-fancybox-prev]")) return e.preventDefault(), void this.prev();
                        if (s.closest("[data-fancybox-next]")) return e.preventDefault(), void this.next();
                        const o = document.activeElement;
                        if (it() && o && n.contains(o)) return;
                        if (s === (null === (t = this.carousel) || void 0 === t ? void 0 : t.container)) return;
                        if (r && "image" === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.type))
                            return void (this.clickTimer
                                ? (clearTimeout(this.clickTimer), (this.clickTimer = null))
                                : (this.clickTimer = setTimeout(() => {
                                      this.toggleIdle(), (this.clickTimer = null);
                                  }, 350)));
                        if ((this.emit("click", e), e.defaultPrevented)) return;
                        let a = !1;
                        if (s.closest(".fancybox__content")) {
                            if (o) {
                                if (o.closest("[contenteditable]")) return;
                                s.matches(te) || o.blur();
                            }
                            if (it()) return;
                            a = this.option("contentClick");
                        } else s.closest(".fancybox__carousel") && !s.matches(te) && (a = this.option("backdropClick"));
                        "close" === a ? (e.preventDefault(), this.close(e)) : "next" === a ? (e.preventDefault(), this.next()) : "prev" === a && (e.preventDefault(), this.prev());
                    }
                    onWheel(e) {
                        const t = e.target;
                        let i = this.option("wheel", e);
                        t.closest(".fancybox__thumbs") && (i = "slide");
                        const n = "slide" === i,
                            r = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
                                return Math.abs(t) > Math.abs(e) ? t : e;
                            }),
                            o = Math.max(-1, Math.min(1, r)),
                            a = Date.now();
                        this.pwt && a - this.pwt < 300
                            ? n && e.preventDefault()
                            : ((this.pwt = a), this.emit("wheel", e, o), e.defaultPrevented || ("close" === i ? (e.preventDefault(), this.close(e)) : "slide" === i && (s(t) || (e.preventDefault(), this[o > 0 ? "prev" : "next"]()))));
                    }
                    onKeydown(e) {
                        if (!this.isTopmost()) return;
                        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
                        const t = e.key,
                            i = this.option("keyboard");
                        if (!i) return;
                        const n = e.composedPath()[0],
                            r = document.activeElement && document.activeElement.classList,
                            s = (r && r.contains("f-button")) || n.dataset.carouselPage || n.dataset.carouselIndex;
                        if ("Escape" !== t && !s && _(n) && (n.isContentEditable || -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(n.nodeName))) return;
                        if (("Tab" === e.key ? M(this.container, Ye) : T(this.container, Ye), e.ctrlKey || e.altKey || e.shiftKey)) return;
                        this.emit("keydown", t, e);
                        const o = i[t];
                        o && "function" == typeof this[o] && (e.preventDefault(), this[o]());
                    }
                    onResize() {
                        const e = this.container;
                        if (!e) return;
                        const t = this.isCompact;
                        e.classList.toggle(Xe, t), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
                    }
                    onFocus(e) {
                        this.isTopmost() && this.checkFocus(e);
                    }
                    onMousemove(e) {
                        (this.prevMouseMoveEvent = e), !this.isCompact && this.option("idle") && this.resetIdle();
                    }
                    onVisibilityChange() {
                        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
                    }
                    manageCloseBtn(e) {
                        const t = this.optionFor(e, "closeButton") || !1;
                        if ("auto" === t) {
                            const e = this.plugins.Toolbar;
                            if (e && e.state === Re.Ready) return;
                        }
                        if (!t) return;
                        if (!e.contentEl || e.closeBtnEl) return;
                        const i = this.option("tpl.closeButton");
                        if (i) {
                            const t = o(this.localize(i));
                            (e.closeBtnEl = e.contentEl.appendChild(t)), e.el && M(e.el, "has-close-btn");
                        }
                    }
                    manageCaption(e = void 0) {
                        var t, i;
                        const n = "fancybox__caption",
                            r = this.container;
                        if (!r) return;
                        T(r, Ue);
                        const s = this.isCompact || this.option("commonCaption"),
                            o = !s;
                        if ((this.caption && this.stop(this.caption), o && this.caption && (this.caption.remove(), (this.caption = null)), s && !this.caption))
                            for (const e of (null === (t = this.carousel) || void 0 === t ? void 0 : t.slides) || [])
                                e.captionEl && (e.captionEl.remove(), (e.captionEl = void 0), T(e.el, Ue), null === (i = e.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
                        if ((e || (e = this.getSlide()), !e || (s && !this.isCurrentSlide(e)))) return;
                        const a = e.el;
                        let l = this.optionFor(e, "caption", "");
                        if (!l)
                            return void (
                                s &&
                                this.caption &&
                                this.animate(this.caption, "f-fadeOut", () => {
                                    this.caption && (this.caption.innerHTML = "");
                                })
                            );
                        let c = null;
                        if (o) {
                            if (((c = e.captionEl || null), a && !c)) {
                                const t = n + `_${this.id}_${e.index}`;
                                (c = document.createElement("div")), M(c, n), c.setAttribute("id", t), (e.captionEl = a.appendChild(c)), M(a, Ue), a.setAttribute("aria-labelledby", t);
                            }
                        } else (c = this.caption), c || (c = r.querySelector("." + n)), c || ((c = document.createElement("div")), (c.dataset.fancyboxCaption = ""), M(c, n), (this.footer || r).prepend(c)), M(r, Ue), (this.caption = c);
                        c && ((c.innerHTML = ""), tt(l) || "number" == typeof l ? (c.innerHTML = l + "") : l instanceof HTMLElement && c.appendChild(l));
                    }
                    checkFocus(e) {
                        this.focus(e);
                    }
                    focus(e) {
                        var t;
                        if (this.ignoreFocusChange) return;
                        const i = document.activeElement || null,
                            n = (null == e ? void 0 : e.target) || null,
                            r = this.container,
                            s = this.getSlide();
                        if (!r || !(null === (t = this.carousel) || void 0 === t ? void 0 : t.viewport)) return;
                        if (!e && i && r.contains(i)) return;
                        const o = s && s.state === se.Ready ? s.el : null;
                        if (!o || o.contains(i) || r === i) return;
                        e && e.cancelable && e.preventDefault(), (this.ignoreFocusChange = !0);
                        const a = Array.from(r.querySelectorAll(te));
                        let l = [],
                            c = null;
                        for (let e of a) {
                            const t = !e.offsetParent || !!e.closest('[aria-hidden="true"]'),
                                i = o && o.contains(e),
                                n = !this.carousel.viewport.contains(e);
                            if (e === r || ((i || n) && !t)) {
                                l.push(e);
                                const t = e.dataset.origTabindex;
                                void 0 !== t && t && (e.tabIndex = parseFloat(t)), e.removeAttribute("data-orig-tabindex"), (!e.hasAttribute("autoFocus") && c) || (c = e);
                            } else {
                                const t = void 0 === e.dataset.origTabindex ? e.getAttribute("tabindex") || "" : e.dataset.origTabindex;
                                t && (e.dataset.origTabindex = t), (e.tabIndex = -1);
                            }
                        }
                        let u = null;
                        e ? (!n || l.indexOf(n) < 0) && ((u = c || r), l.length && (i === rt ? (u = l[0]) : (this.lastFocus !== r && i !== nt) || (u = l[l.length - 1]))) : (u = s && "image" === s.type ? r : c || r),
                            u && ie(u),
                            (this.lastFocus = document.activeElement),
                            (this.ignoreFocusChange = !1);
                    }
                    next() {
                        const e = this.carousel;
                        e && e.pages.length > 1 && e.slideNext();
                    }
                    prev() {
                        const e = this.carousel;
                        e && e.pages.length > 1 && e.slidePrev();
                    }
                    jumpTo(...e) {
                        this.carousel && this.carousel.slideTo(...e);
                    }
                    isTopmost() {
                        var e;
                        return (null === (e = at.getInstance()) || void 0 === e ? void 0 : e.id) == this.id;
                    }
                    animate(e = null, t = "", i) {
                        if (!e || !t) return void (i && i());
                        this.stop(e);
                        const n = (r) => {
                            r.target === e && e.dataset.animationName && (e.removeEventListener("animationend", n), delete e.dataset.animationName, i && i(), T(e, t));
                        };
                        (e.dataset.animationName = t), e.addEventListener("animationend", n), M(e, t);
                    }
                    stop(e) {
                        e && e.dispatchEvent(new CustomEvent("animationend", { bubbles: !1, cancelable: !0, currentTarget: e }));
                    }
                    setContent(e, t = "", i = !0) {
                        if (this.isClosing()) return;
                        const n = e.el;
                        if (!n) return;
                        let r = null;
                        if ((_(t) ? (r = t) : ((r = o(t + "")), _(r) || ((r = document.createElement("div")), (r.innerHTML = t + ""))), ["img", "picture", "iframe", "video", "audio"].includes(r.nodeName.toLowerCase()))) {
                            const e = document.createElement("div");
                            e.appendChild(r), (r = e);
                        }
                        _(r) && e.filter && !e.error && (r = r.querySelector(e.filter)),
                            r && _(r)
                                ? (M(r, "fancybox__content"),
                                  e.id && r.setAttribute("id", e.id),
                                  ("none" !== r.style.display && "none" !== getComputedStyle(r).getPropertyValue("display")) || (r.style.display = e.display || this.option("defaultDisplay") || "flex"),
                                  n.classList.add(`has-${e.error ? "error" : e.type || "unknown"}`),
                                  n.prepend(r),
                                  (e.contentEl = r),
                                  i && this.revealContent(e),
                                  this.manageCloseBtn(e),
                                  this.manageCaption(e))
                                : this.setError(e, "{{ELEMENT_NOT_FOUND}}");
                    }
                    revealContent(e, t) {
                        const i = e.el,
                            n = e.contentEl;
                        i &&
                            n &&
                            (this.emit("reveal", e),
                            this.hideLoading(e),
                            (e.state = se.Opening),
                            (t = this.isOpeningSlide(e) ? (void 0 === t ? this.optionFor(e, "showClass") : t) : "f-fadeIn")
                                ? this.animate(n, t, () => {
                                      this.done(e);
                                  })
                                : this.done(e));
                    }
                    done(e) {
                        this.isClosing() ||
                            ((e.state = se.Ready),
                            this.emit("done", e),
                            M(e.el, "is-done"),
                            this.isCurrentSlide(e) &&
                                this.option("autoFocus") &&
                                queueMicrotask(() => {
                                    var t;
                                    null === (t = e.panzoom) || void 0 === t || t.updateControls(), this.option("autoFocus") && (this.option("autoFocus") ? this.focus() : this.checkFocus());
                                }),
                            this.isOpeningSlide(e) && !this.isCompact && this.option("idle") && this.setIdle());
                    }
                    isCurrentSlide(e) {
                        const t = this.getSlide();
                        return !(!e || !t) && t.index === e.index;
                    }
                    isOpeningSlide(e) {
                        var t, i;
                        return null === (null === (t = this.carousel) || void 0 === t ? void 0 : t.prevPage) && e.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
                    }
                    showLoading(e) {
                        e.state = se.Loading;
                        const t = e.el;
                        t &&
                            (M(t, Ge),
                            this.emit("loading", e),
                            e.spinnerEl ||
                                setTimeout(() => {
                                    if (!this.isClosing() && !e.spinnerEl && e.state === se.Loading) {
                                        let i = o(E);
                                        (e.spinnerEl = i), t.prepend(i), this.animate(i, "f-fadeIn");
                                    }
                                }, 250));
                    }
                    hideLoading(e) {
                        const t = e.el;
                        if (!t) return;
                        const i = e.spinnerEl;
                        this.isClosing()
                            ? null == i || i.remove()
                            : (T(t, Ge),
                              i &&
                                  this.animate(i, "f-fadeOut", () => {
                                      i.remove();
                                  }),
                              e.state === se.Loading && (this.emit("loaded", e), (e.state = se.Ready)));
                    }
                    setError(e, t) {
                        if (this.isClosing()) return;
                        const i = new Event("error", { bubbles: !0, cancelable: !0 });
                        if ((this.emit("error", i, e), i.defaultPrevented)) return;
                        (e.error = t), this.hideLoading(e), this.clearContent(e);
                        const n = document.createElement("div");
                        n.classList.add("fancybox-error"), (n.innerHTML = this.localize(t || "<p>{{ERROR}}</p>")), this.setContent(e, n);
                    }
                    clearContent(e) {
                        if (void 0 === e.state) return;
                        this.emit("clearContent", e), e.contentEl && (e.contentEl.remove(), (e.contentEl = void 0));
                        const t = e.el;
                        t && (T(t, "has-error"), T(t, "has-unknown"), T(t, `has-${e.type || "unknown"}`)),
                            e.closeBtnEl && e.closeBtnEl.remove(),
                            (e.closeBtnEl = void 0),
                            e.captionEl && e.captionEl.remove(),
                            (e.captionEl = void 0),
                            e.spinnerEl && e.spinnerEl.remove(),
                            (e.spinnerEl = void 0);
                    }
                    getSlide() {
                        var e;
                        const t = this.carousel;
                        return (null === (e = null == t ? void 0 : t.pages[null == t ? void 0 : t.page]) || void 0 === e ? void 0 : e.slides[0]) || void 0;
                    }
                    close(e, t) {
                        if (this.isClosing()) return;
                        const i = new Event("shouldClose", { bubbles: !0, cancelable: !0 });
                        if ((this.emit("shouldClose", i, e), i.defaultPrevented)) return;
                        e && e.cancelable && (e.preventDefault(), e.stopPropagation());
                        const n = this.fsAPI,
                            r = () => {
                                this.proceedClose(e, t);
                            };
                        n && n.isFullscreen() === this.container ? Promise.resolve(n.exit()).then(() => r()) : r();
                    }
                    clearIdle() {
                        this.idleTimer && clearTimeout(this.idleTimer), (this.idleTimer = null);
                    }
                    setIdle(e = !1) {
                        const t = () => {
                            this.clearIdle(), (this.idle = !0), M(this.container, "is-idle"), this.emit("setIdle");
                        };
                        if ((this.clearIdle(), !this.isClosing()))
                            if (e) t();
                            else {
                                const e = this.option("idle");
                                e && (this.idleTimer = setTimeout(t, e));
                            }
                    }
                    endIdle() {
                        this.clearIdle(), this.idle && !this.isClosing() && ((this.idle = !1), T(this.container, "is-idle"), this.emit("endIdle"));
                    }
                    resetIdle() {
                        this.endIdle(), this.setIdle();
                    }
                    toggleIdle() {
                        this.idle ? this.endIdle() : this.setIdle(!0);
                    }
                    toggleFullscreen() {
                        const e = this.fsAPI;
                        e && (e.isFullscreen() ? e.exit() : this.container && e.request(this.container));
                    }
                    isClosing() {
                        return [re.Closing, re.CustomClosing, re.Destroy].includes(this.state);
                    }
                    proceedClose(e, t) {
                        var i, n;
                        (this.state = re.Closing), this.clearIdle(), this.detachEvents();
                        const r = this.container,
                            s = this.carousel,
                            o = this.getSlide(),
                            a = o && this.option("placeFocusBack") ? o.triggerEl || this.option("triggerEl") : null;
                        if ((a && (J(a) ? ie(a) : a.focus()), r && (M(r, "is-closing"), r.setAttribute("aria-hidden", "true"), this.option("animated") && M(r, We), (r.style.pointerEvents = "none")), s)) {
                            s.clearTransitions(), null === (i = s.panzoom) || void 0 === i || i.destroy(), null === (n = s.plugins.Navigation) || void 0 === n || n.detach();
                            for (const e of s.slides) {
                                (e.state = se.Closing), this.hideLoading(e);
                                const t = e.contentEl;
                                t && this.stop(t);
                                const i = null == e ? void 0 : e.panzoom;
                                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(e) || s.emit("removeSlide", e);
                            }
                        }
                        this.emit("close", e),
                            this.state !== re.CustomClosing
                                ? (void 0 === t && o && (t = this.optionFor(o, "hideClass")),
                                  t && o
                                      ? (this.animate(o.contentEl, t, () => {
                                            s && s.emit("removeSlide", o);
                                        }),
                                        setTimeout(() => {
                                            this.destroy();
                                        }, 500))
                                      : this.destroy())
                                : setTimeout(() => {
                                      this.destroy();
                                  }, 500);
                    }
                    destroy() {
                        var e;
                        if (this.state === re.Destroy) return;
                        (this.state = re.Destroy), null === (e = this.carousel) || void 0 === e || e.destroy();
                        const t = this.container;
                        t && t.remove(), st.delete(this.id);
                        const i = at.getInstance();
                        i
                            ? i.focus()
                            : (nt && (nt.remove(), (nt = null)),
                              rt && (rt.remove(), (rt = null)),
                              T(document.documentElement, Be),
                              (() => {
                                  if (!Q) return;
                                  const e = document,
                                      t = e.body;
                                  t.classList.remove(He), t.style.setProperty(Ve, ""), e.documentElement.style.setProperty(qe, "");
                              })(),
                              this.emit("destroy"));
                    }
                    static bind(e, t, i) {
                        if (!Q) return;
                        let n,
                            r = "",
                            s = {};
                        if ((void 0 === e ? (n = document.body) : tt(e) ? ((n = document.body), (r = e), "object" == typeof t && (s = t || {})) : ((n = e), tt(t) && (r = t), "object" == typeof i && (s = i || {})), !n || !_(n))) return;
                        r = r || "[data-fancybox]";
                        const o = at.openers.get(n) || new Map();
                        o.set(r, s), at.openers.set(n, o), 1 === o.size && n.addEventListener("click", at.fromEvent);
                    }
                    static unbind(e, t) {
                        let i,
                            n = "";
                        if ((tt(e) ? ((i = document.body), (n = e)) : ((i = e), tt(t) && (n = t)), !i)) return;
                        const r = at.openers.get(i);
                        r && n && r.delete(n), (n && r) || (at.openers.delete(i), i.removeEventListener("click", at.fromEvent));
                    }
                    static destroy() {
                        let e;
                        for (; (e = at.getInstance()); ) e.destroy();
                        for (const e of at.openers.keys()) e.removeEventListener("click", at.fromEvent);
                        at.openers = new Map();
                    }
                    static fromEvent(e) {
                        if (e.defaultPrevented) return;
                        if (e.button && 0 !== e.button) return;
                        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
                        let t = e.composedPath()[0];
                        const i = t.closest("[data-fancybox-trigger]");
                        if (i) {
                            const e = i.dataset.fancyboxTrigger || "",
                                n = document.querySelectorAll(`[data-fancybox="${e}"]`),
                                r = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
                            t = n[r] || t;
                        }
                        if (!(t && t instanceof Element)) return;
                        let n, r, s, o;
                        if (
                            ([...at.openers].reverse().find(
                                ([e, i]) =>
                                    !(
                                        !e.contains(t) ||
                                        ![...i].reverse().find(([i, a]) => {
                                            let l = t.closest(i);
                                            return !!l && ((n = e), (r = i), (s = l), (o = a), !0);
                                        })
                                    )
                            ),
                            !n || !r || !s)
                        )
                            return;
                        (o = o || {}), e.preventDefault(), (t = s);
                        let a = [],
                            l = m({}, ne, o);
                        (l.event = e), (l.triggerEl = t), (l.delegate = i);
                        const c = l.groupAll,
                            u = l.groupAttr,
                            d = u && t ? t.getAttribute(`${u}`) : "";
                        if (((!t || d || c) && (a = [].slice.call(n.querySelectorAll(r))), t && !c && (a = d ? a.filter((e) => e.getAttribute(`${u}`) === d) : [t]), !a.length)) return;
                        const h = at.getInstance();
                        return h && h.options.triggerEl && a.indexOf(h.options.triggerEl) > -1 ? void 0 : (t && (l.startIndex = a.indexOf(t)), at.fromNodes(a, l));
                    }
                    static fromSelector(e, t, i) {
                        let n = null,
                            r = "",
                            s = {};
                        if ((tt(e) ? ((n = document.body), (r = e), "object" == typeof t && (s = t || {})) : e instanceof HTMLElement && tt(t) && ((n = e), (r = t), "object" == typeof i && (s = i || {})), !n || !r)) return !1;
                        const o = at.openers.get(n);
                        return !!o && ((s = m({}, o.get(r) || {}, s)), !!s && at.fromNodes(Array.from(n.querySelectorAll(r)), s));
                    }
                    static fromNodes(e, t) {
                        t = m({}, ne, t || {});
                        const i = [];
                        for (const n of e) {
                            const e = n.dataset || {},
                                r = e[et] || n.getAttribute(Qe) || n.getAttribute("currentSrc") || n.getAttribute(et) || void 0;
                            let s;
                            const o = t.delegate;
                            let a;
                            o && i.length === t.startIndex && (s = o instanceof HTMLImageElement ? o : o.querySelector("img:not([aria-hidden])")),
                                s || (s = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")),
                                s && ((a = s.currentSrc || s[et] || void 0), !a && s.dataset && (a = s.dataset.lazySrc || s.dataset[et] || void 0));
                            const l = { src: r, triggerEl: n, thumbEl: s, thumbElSrc: a, thumbSrc: a };
                            for (const t in e) {
                                let i = e[t] + "";
                                (i = "false" !== i && ("true" === i || i)), (l[t] = i);
                            }
                            i.push(l);
                        }
                        return new at(i, t);
                    }
                    static getInstance(e) {
                        return e
                            ? st.get(e)
                            : Array.from(st.values())
                                  .reverse()
                                  .find((e) => !e.isClosing() && e) || null;
                    }
                    static getSlide() {
                        var e;
                        return (null === (e = at.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || null;
                    }
                    static show(e = [], t = {}) {
                        return new at(e, t);
                    }
                    static next() {
                        const e = at.getInstance();
                        e && e.next();
                    }
                    static prev() {
                        const e = at.getInstance();
                        e && e.prev();
                    }
                    static close(e = !0, ...t) {
                        if (e) for (const e of st.values()) e.close(...t);
                        else {
                            const e = at.getInstance();
                            e && e.close(...t);
                        }
                    }
                }
                Object.defineProperty(at, "version", { enumerable: !0, configurable: !0, writable: !0, value: "5.0.27" }),
                    Object.defineProperty(at, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: ne }),
                    Object.defineProperty(at, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: Ne }),
                    Object.defineProperty(at, "openers", { enumerable: !0, configurable: !0, writable: !0, value: new Map() });
            },
            6266: function (e, t, i) {
                i(5767),
                    i(8132),
                    i(8388),
                    i(7470),
                    i(4882),
                    i(1520),
                    i(7476),
                    i(9622),
                    i(9375),
                    i(3533),
                    i(4672),
                    i(4157),
                    i(5095),
                    i(9892),
                    i(5115),
                    i(9176),
                    i(8838),
                    i(6253),
                    i(9730),
                    i(6059),
                    i(8377),
                    i(1084),
                    i(4299),
                    i(1246),
                    i(726),
                    i(1901),
                    i(5972),
                    i(3403),
                    i(2516),
                    i(9371),
                    i(6479),
                    i(1736),
                    i(1889),
                    i(5177),
                    i(6943),
                    i(6503),
                    i(6786),
                    i(932),
                    i(7526),
                    i(1591),
                    i(9073),
                    i(347),
                    i(579),
                    i(4669),
                    i(7710),
                    i(5789),
                    i(3514),
                    i(9978),
                    i(8472),
                    i(6946),
                    i(5068),
                    i(413),
                    i(191),
                    i(8306),
                    i(4564),
                    i(9115),
                    i(9539),
                    i(6620),
                    i(2850),
                    i(823),
                    i(7732),
                    i(856),
                    i(703),
                    i(1539),
                    i(5292),
                    i(6629),
                    i(3694),
                    i(7648),
                    i(7795),
                    i(4531),
                    i(3605),
                    i(6780),
                    i(9937),
                    i(511),
                    i(1822),
                    i(9977),
                    i(1031),
                    i(6331),
                    i(1560),
                    i(774),
                    i(522),
                    i(8295),
                    i(7842),
                    i(110),
                    i(75),
                    i(4336),
                    i(1802),
                    i(8837),
                    i(6773),
                    i(5745),
                    i(3057),
                    i(3750),
                    i(3369),
                    i(9564),
                    i(2e3),
                    i(8977),
                    i(2310),
                    i(4899),
                    i(1842),
                    i(6997),
                    i(3946),
                    i(8269),
                    i(6108),
                    i(6774),
                    i(1466),
                    i(9357),
                    i(6142),
                    i(1876),
                    i(851),
                    i(8416),
                    i(8184),
                    i(147),
                    i(9192),
                    i(142),
                    i(1786),
                    i(5368),
                    i(6964),
                    i(2152),
                    i(4821),
                    i(9103),
                    i(1303),
                    i(3318),
                    i(162),
                    i(3834),
                    i(1572),
                    i(2139),
                    i(685),
                    i(5535),
                    i(7347),
                    i(3049),
                    i(6633),
                    i(8989),
                    i(8270),
                    i(4510),
                    i(3984),
                    i(5769),
                    i(55),
                    i(6014),
                    (e.exports = i(5645));
            },
            911: function (e, t, i) {
                i(1268), (e.exports = i(5645).Array.flatMap);
            },
            990: function (e, t, i) {
                i(2773), (e.exports = i(5645).Array.includes);
            },
            5434: function (e, t, i) {
                i(3276), (e.exports = i(5645).Object.entries);
            },
            8051: function (e, t, i) {
                i(8351), (e.exports = i(5645).Object.getOwnPropertyDescriptors);
            },
            8250: function (e, t, i) {
                i(6409), (e.exports = i(5645).Object.values);
            },
            4952: function (e, t, i) {
                "use strict";
                i(851), i(9865), (e.exports = i(5645).Promise.finally);
            },
            6197: function (e, t, i) {
                i(2770), (e.exports = i(5645).String.padEnd);
            },
            4160: function (e, t, i) {
                i(1784), (e.exports = i(5645).String.padStart);
            },
            4039: function (e, t, i) {
                i(4325), (e.exports = i(5645).String.trimRight);
            },
            6728: function (e, t, i) {
                i(5869), (e.exports = i(5645).String.trimLeft);
            },
            3568: function (e, t, i) {
                i(9665), (e.exports = i(8787).f("asyncIterator"));
            },
            115: function (e, t, i) {
                i(4579), (e.exports = i(1327).global);
            },
            5663: function (e) {
                e.exports = function (e) {
                    if ("function" != typeof e) throw TypeError(e + " is not a function!");
                    return e;
                };
            },
            2159: function (e, t, i) {
                var n = i(6727);
                e.exports = function (e) {
                    if (!n(e)) throw TypeError(e + " is not an object!");
                    return e;
                };
            },
            1327: function (e) {
                var t = (e.exports = { version: "2.6.12" });
                "number" == typeof __e && (__e = t);
            },
            9216: function (e, t, i) {
                var n = i(5663);
                e.exports = function (e, t, i) {
                    if ((n(e), void 0 === t)) return e;
                    switch (i) {
                        case 1:
                            return function (i) {
                                return e.call(t, i);
                            };
                        case 2:
                            return function (i, n) {
                                return e.call(t, i, n);
                            };
                        case 3:
                            return function (i, n, r) {
                                return e.call(t, i, n, r);
                            };
                    }
                    return function () {
                        return e.apply(t, arguments);
                    };
                };
            },
            9666: function (e, t, i) {
                e.exports = !i(7929)(function () {
                    return (
                        7 !=
                        Object.defineProperty({}, "a", {
                            get: function () {
                                return 7;
                            },
                        }).a
                    );
                });
            },
            7467: function (e, t, i) {
                var n = i(6727),
                    r = i(3938).document,
                    s = n(r) && n(r.createElement);
                e.exports = function (e) {
                    return s ? r.createElement(e) : {};
                };
            },
            3856: function (e, t, i) {
                var n = i(3938),
                    r = i(1327),
                    s = i(9216),
                    o = i(1818),
                    a = i(7069),
                    l = "prototype",
                    c = function (e, t, i) {
                        var u,
                            d,
                            h,
                            f = e & c.F,
                            p = e & c.G,
                            m = e & c.S,
                            g = e & c.P,
                            v = e & c.B,
                            b = e & c.W,
                            y = p ? r : r[t] || (r[t] = {}),
                            w = y[l],
                            x = p ? n : m ? n[t] : (n[t] || {})[l];
                        for (u in (p && (i = t), i))
                            ((d = !f && x && void 0 !== x[u]) && a(y, u)) ||
                                ((h = d ? x[u] : i[u]),
                                (y[u] =
                                    p && "function" != typeof x[u]
                                        ? i[u]
                                        : v && d
                                        ? s(h, n)
                                        : b && x[u] == h
                                        ? (function (e) {
                                              var t = function (t, i, n) {
                                                  if (this instanceof e) {
                                                      switch (arguments.length) {
                                                          case 0:
                                                              return new e();
                                                          case 1:
                                                              return new e(t);
                                                          case 2:
                                                              return new e(t, i);
                                                      }
                                                      return new e(t, i, n);
                                                  }
                                                  return e.apply(this, arguments);
                                              };
                                              return (t[l] = e[l]), t;
                                          })(h)
                                        : g && "function" == typeof h
                                        ? s(Function.call, h)
                                        : h),
                                g && (((y.virtual || (y.virtual = {}))[u] = h), e & c.R && w && !w[u] && o(w, u, h)));
                    };
                (c.F = 1), (c.G = 2), (c.S = 4), (c.P = 8), (c.B = 16), (c.W = 32), (c.U = 64), (c.R = 128), (e.exports = c);
            },
            7929: function (e) {
                e.exports = function (e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            3938: function (e) {
                var t = (e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")());
                "number" == typeof __g && (__g = t);
            },
            7069: function (e) {
                var t = {}.hasOwnProperty;
                e.exports = function (e, i) {
                    return t.call(e, i);
                };
            },
            1818: function (e, t, i) {
                var n = i(4743),
                    r = i(3101);
                e.exports = i(9666)
                    ? function (e, t, i) {
                          return n.f(e, t, r(1, i));
                      }
                    : function (e, t, i) {
                          return (e[t] = i), e;
                      };
            },
            3758: function (e, t, i) {
                e.exports =
                    !i(9666) &&
                    !i(7929)(function () {
                        return (
                            7 !=
                            Object.defineProperty(i(7467)("div"), "a", {
                                get: function () {
                                    return 7;
                                },
                            }).a
                        );
                    });
            },
            6727: function (e) {
                e.exports = function (e) {
                    return "object" == typeof e ? null !== e : "function" == typeof e;
                };
            },
            4743: function (e, t, i) {
                var n = i(2159),
                    r = i(3758),
                    s = i(3206),
                    o = Object.defineProperty;
                t.f = i(9666)
                    ? Object.defineProperty
                    : function (e, t, i) {
                          if ((n(e), (t = s(t, !0)), n(i), r))
                              try {
                                  return o(e, t, i);
                              } catch (e) {}
                          if ("get" in i || "set" in i) throw TypeError("Accessors not supported!");
                          return "value" in i && (e[t] = i.value), e;
                      };
            },
            3101: function (e) {
                e.exports = function (e, t) {
                    return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
                };
            },
            3206: function (e, t, i) {
                var n = i(6727);
                e.exports = function (e, t) {
                    if (!n(e)) return e;
                    var i, r;
                    if (t && "function" == typeof (i = e.toString) && !n((r = i.call(e)))) return r;
                    if ("function" == typeof (i = e.valueOf) && !n((r = i.call(e)))) return r;
                    if (!t && "function" == typeof (i = e.toString) && !n((r = i.call(e)))) return r;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            4579: function (e, t, i) {
                var n = i(3856);
                n(n.G, { global: i(3938) });
            },
            4963: function (e) {
                e.exports = function (e) {
                    if ("function" != typeof e) throw TypeError(e + " is not a function!");
                    return e;
                };
            },
            3365: function (e, t, i) {
                var n = i(2032);
                e.exports = function (e, t) {
                    if ("number" != typeof e && "Number" != n(e)) throw TypeError(t);
                    return +e;
                };
            },
            7722: function (e, t, i) {
                var n = i(6314)("unscopables"),
                    r = Array.prototype;
                null == r[n] && i(7728)(r, n, {}),
                    (e.exports = function (e) {
                        r[n][e] = !0;
                    });
            },
            6793: function (e, t, i) {
                "use strict";
                var n = i(4496)(!0);
                e.exports = function (e, t, i) {
                    return t + (i ? n(e, t).length : 1);
                };
            },
            3328: function (e) {
                e.exports = function (e, t, i, n) {
                    if (!(e instanceof t) || (void 0 !== n && n in e)) throw TypeError(i + ": incorrect invocation!");
                    return e;
                };
            },
            7007: function (e, t, i) {
                var n = i(5286);
                e.exports = function (e) {
                    if (!n(e)) throw TypeError(e + " is not an object!");
                    return e;
                };
            },
            5216: function (e, t, i) {
                "use strict";
                var n = i(508),
                    r = i(2337),
                    s = i(875);
                e.exports =
                    [].copyWithin ||
                    function (e, t) {
                        var i = n(this),
                            o = s(i.length),
                            a = r(e, o),
                            l = r(t, o),
                            c = arguments.length > 2 ? arguments[2] : void 0,
                            u = Math.min((void 0 === c ? o : r(c, o)) - l, o - a),
                            d = 1;
                        for (l < a && a < l + u && ((d = -1), (l += u - 1), (a += u - 1)); u-- > 0; ) l in i ? (i[a] = i[l]) : delete i[a], (a += d), (l += d);
                        return i;
                    };
            },
            6852: function (e, t, i) {
                "use strict";
                var n = i(508),
                    r = i(2337),
                    s = i(875);
                e.exports = function (e) {
                    for (var t = n(this), i = s(t.length), o = arguments.length, a = r(o > 1 ? arguments[1] : void 0, i), l = o > 2 ? arguments[2] : void 0, c = void 0 === l ? i : r(l, i); c > a; ) t[a++] = e;
                    return t;
                };
            },
            9315: function (e, t, i) {
                var n = i(2110),
                    r = i(875),
                    s = i(2337);
                e.exports = function (e) {
                    return function (t, i, o) {
                        var a,
                            l = n(t),
                            c = r(l.length),
                            u = s(o, c);
                        if (e && i != i) {
                            for (; c > u; ) if ((a = l[u++]) != a) return !0;
                        } else for (; c > u; u++) if ((e || u in l) && l[u] === i) return e || u || 0;
                        return !e && -1;
                    };
                };
            },
            50: function (e, t, i) {
                var n = i(741),
                    r = i(9797),
                    s = i(508),
                    o = i(875),
                    a = i(6886);
                e.exports = function (e, t) {
                    var i = 1 == e,
                        l = 2 == e,
                        c = 3 == e,
                        u = 4 == e,
                        d = 6 == e,
                        h = 5 == e || d,
                        f = t || a;
                    return function (t, a, p) {
                        for (var m, g, v = s(t), b = r(v), y = n(a, p, 3), w = o(b.length), x = 0, S = i ? f(t, w) : l ? f(t, 0) : void 0; w > x; x++)
                            if ((h || x in b) && ((g = y((m = b[x]), x, v)), e))
                                if (i) S[x] = g;
                                else if (g)
                                    switch (e) {
                                        case 3:
                                            return !0;
                                        case 5:
                                            return m;
                                        case 6:
                                            return x;
                                        case 2:
                                            S.push(m);
                                    }
                                else if (u) return !1;
                        return d ? -1 : c || u ? u : S;
                    };
                };
            },
            7628: function (e, t, i) {
                var n = i(4963),
                    r = i(508),
                    s = i(9797),
                    o = i(875);
                e.exports = function (e, t, i, a, l) {
                    n(t);
                    var c = r(e),
                        u = s(c),
                        d = o(c.length),
                        h = l ? d - 1 : 0,
                        f = l ? -1 : 1;
                    if (i < 2)
                        for (;;) {
                            if (h in u) {
                                (a = u[h]), (h += f);
                                break;
                            }
                            if (((h += f), l ? h < 0 : d <= h)) throw TypeError("Reduce of empty array with no initial value");
                        }
                    for (; l ? h >= 0 : d > h; h += f) h in u && (a = t(a, u[h], h, c));
                    return a;
                };
            },
            2736: function (e, t, i) {
                var n = i(5286),
                    r = i(4302),
                    s = i(6314)("species");
                e.exports = function (e) {
                    var t;
                    return r(e) && ("function" != typeof (t = e.constructor) || (t !== Array && !r(t.prototype)) || (t = void 0), n(t) && null === (t = t[s]) && (t = void 0)), void 0 === t ? Array : t;
                };
            },
            6886: function (e, t, i) {
                var n = i(2736);
                e.exports = function (e, t) {
                    return new (n(e))(t);
                };
            },
            4398: function (e, t, i) {
                "use strict";
                var n = i(4963),
                    r = i(5286),
                    s = i(7242),
                    o = [].slice,
                    a = {};
                e.exports =
                    Function.bind ||
                    function (e) {
                        var t = n(this),
                            i = o.call(arguments, 1),
                            l = function () {
                                var n = i.concat(o.call(arguments));
                                return this instanceof l
                                    ? (function (e, t, i) {
                                          if (!(t in a)) {
                                              for (var n = [], r = 0; r < t; r++) n[r] = "a[" + r + "]";
                                              a[t] = Function("F,a", "return new F(" + n.join(",") + ")");
                                          }
                                          return a[t](e, i);
                                      })(t, n.length, n)
                                    : s(t, n, e);
                            };
                        return r(t.prototype) && (l.prototype = t.prototype), l;
                    };
            },
            1488: function (e, t, i) {
                var n = i(2032),
                    r = i(6314)("toStringTag"),
                    s =
                        "Arguments" ==
                        n(
                            (function () {
                                return arguments;
                            })()
                        );
                e.exports = function (e) {
                    var t, i, o;
                    return void 0 === e
                        ? "Undefined"
                        : null === e
                        ? "Null"
                        : "string" ==
                          typeof (i = (function (e, t) {
                              try {
                                  return e[t];
                              } catch (e) {}
                          })((t = Object(e)), r))
                        ? i
                        : s
                        ? n(t)
                        : "Object" == (o = n(t)) && "function" == typeof t.callee
                        ? "Arguments"
                        : o;
                };
            },
            2032: function (e) {
                var t = {}.toString;
                e.exports = function (e) {
                    return t.call(e).slice(8, -1);
                };
            },
            9824: function (e, t, i) {
                "use strict";
                var n = i(9275).f,
                    r = i(2503),
                    s = i(4408),
                    o = i(741),
                    a = i(3328),
                    l = i(3531),
                    c = i(2923),
                    u = i(5436),
                    d = i(2974),
                    h = i(7057),
                    f = i(4728).fastKey,
                    p = i(1616),
                    m = h ? "_s" : "size",
                    g = function (e, t) {
                        var i,
                            n = f(t);
                        if ("F" !== n) return e._i[n];
                        for (i = e._f; i; i = i.n) if (i.k == t) return i;
                    };
                e.exports = {
                    getConstructor: function (e, t, i, c) {
                        var u = e(function (e, n) {
                            a(e, u, t, "_i"), (e._t = t), (e._i = r(null)), (e._f = void 0), (e._l = void 0), (e[m] = 0), null != n && l(n, i, e[c], e);
                        });
                        return (
                            s(u.prototype, {
                                clear: function () {
                                    for (var e = p(this, t), i = e._i, n = e._f; n; n = n.n) (n.r = !0), n.p && (n.p = n.p.n = void 0), delete i[n.i];
                                    (e._f = e._l = void 0), (e[m] = 0);
                                },
                                delete: function (e) {
                                    var i = p(this, t),
                                        n = g(i, e);
                                    if (n) {
                                        var r = n.n,
                                            s = n.p;
                                        delete i._i[n.i], (n.r = !0), s && (s.n = r), r && (r.p = s), i._f == n && (i._f = r), i._l == n && (i._l = s), i[m]--;
                                    }
                                    return !!n;
                                },
                                forEach: function (e) {
                                    p(this, t);
                                    for (var i, n = o(e, arguments.length > 1 ? arguments[1] : void 0, 3); (i = i ? i.n : this._f); ) for (n(i.v, i.k, this); i && i.r; ) i = i.p;
                                },
                                has: function (e) {
                                    return !!g(p(this, t), e);
                                },
                            }),
                            h &&
                                n(u.prototype, "size", {
                                    get: function () {
                                        return p(this, t)[m];
                                    },
                                }),
                            u
                        );
                    },
                    def: function (e, t, i) {
                        var n,
                            r,
                            s = g(e, t);
                        return s ? (s.v = i) : ((e._l = s = { i: (r = f(t, !0)), k: t, v: i, p: (n = e._l), n: void 0, r: !1 }), e._f || (e._f = s), n && (n.n = s), e[m]++, "F" !== r && (e._i[r] = s)), e;
                    },
                    getEntry: g,
                    setStrong: function (e, t, i) {
                        c(
                            e,
                            t,
                            function (e, i) {
                                (this._t = p(e, t)), (this._k = i), (this._l = void 0);
                            },
                            function () {
                                for (var e = this, t = e._k, i = e._l; i && i.r; ) i = i.p;
                                return e._t && (e._l = i = i ? i.n : e._t._f) ? u(0, "keys" == t ? i.k : "values" == t ? i.v : [i.k, i.v]) : ((e._t = void 0), u(1));
                            },
                            i ? "entries" : "values",
                            !i,
                            !0
                        ),
                            d(t);
                    },
                };
            },
            3657: function (e, t, i) {
                "use strict";
                var n = i(4408),
                    r = i(4728).getWeak,
                    s = i(7007),
                    o = i(5286),
                    a = i(3328),
                    l = i(3531),
                    c = i(50),
                    u = i(9181),
                    d = i(1616),
                    h = c(5),
                    f = c(6),
                    p = 0,
                    m = function (e) {
                        return e._l || (e._l = new g());
                    },
                    g = function () {
                        this.a = [];
                    },
                    v = function (e, t) {
                        return h(e.a, function (e) {
                            return e[0] === t;
                        });
                    };
                (g.prototype = {
                    get: function (e) {
                        var t = v(this, e);
                        if (t) return t[1];
                    },
                    has: function (e) {
                        return !!v(this, e);
                    },
                    set: function (e, t) {
                        var i = v(this, e);
                        i ? (i[1] = t) : this.a.push([e, t]);
                    },
                    delete: function (e) {
                        var t = f(this.a, function (t) {
                            return t[0] === e;
                        });
                        return ~t && this.a.splice(t, 1), !!~t;
                    },
                }),
                    (e.exports = {
                        getConstructor: function (e, t, i, s) {
                            var c = e(function (e, n) {
                                a(e, c, t, "_i"), (e._t = t), (e._i = p++), (e._l = void 0), null != n && l(n, i, e[s], e);
                            });
                            return (
                                n(c.prototype, {
                                    delete: function (e) {
                                        if (!o(e)) return !1;
                                        var i = r(e);
                                        return !0 === i ? m(d(this, t)).delete(e) : i && u(i, this._i) && delete i[this._i];
                                    },
                                    has: function (e) {
                                        if (!o(e)) return !1;
                                        var i = r(e);
                                        return !0 === i ? m(d(this, t)).has(e) : i && u(i, this._i);
                                    },
                                }),
                                c
                            );
                        },
                        def: function (e, t, i) {
                            var n = r(s(t), !0);
                            return !0 === n ? m(e).set(t, i) : (n[e._i] = i), e;
                        },
                        ufstore: m,
                    });
            },
            5795: function (e, t, i) {
                "use strict";
                var n = i(3816),
                    r = i(2985),
                    s = i(7234),
                    o = i(4408),
                    a = i(4728),
                    l = i(3531),
                    c = i(3328),
                    u = i(5286),
                    d = i(4253),
                    h = i(7462),
                    f = i(2943),
                    p = i(266);
                e.exports = function (e, t, i, m, g, v) {
                    var b = n[e],
                        y = b,
                        w = g ? "set" : "add",
                        x = y && y.prototype,
                        S = {},
                        E = function (e) {
                            var t = x[e];
                            s(
                                x,
                                e,
                                "delete" == e || "has" == e
                                    ? function (e) {
                                          return !(v && !u(e)) && t.call(this, 0 === e ? 0 : e);
                                      }
                                    : "get" == e
                                    ? function (e) {
                                          return v && !u(e) ? void 0 : t.call(this, 0 === e ? 0 : e);
                                      }
                                    : "add" == e
                                    ? function (e) {
                                          return t.call(this, 0 === e ? 0 : e), this;
                                      }
                                    : function (e, i) {
                                          return t.call(this, 0 === e ? 0 : e, i), this;
                                      }
                            );
                        };
                    if (
                        "function" == typeof y &&
                        (v ||
                            (x.forEach &&
                                !d(function () {
                                    new y().entries().next();
                                })))
                    ) {
                        var _ = new y(),
                            T = _[w](v ? {} : -0, 1) != _,
                            M = d(function () {
                                _.has(1);
                            }),
                            P = h(function (e) {
                                new y(e);
                            }),
                            C =
                                !v &&
                                d(function () {
                                    for (var e = new y(), t = 5; t--; ) e[w](t, t);
                                    return !e.has(-0);
                                });
                        P ||
                            (((y = t(function (t, i) {
                                c(t, y, e);
                                var n = p(new b(), t, y);
                                return null != i && l(i, g, n[w], n), n;
                            })).prototype = x),
                            (x.constructor = y)),
                            (M || C) && (E("delete"), E("has"), g && E("get")),
                            (C || T) && E(w),
                            v && x.clear && delete x.clear;
                    } else (y = m.getConstructor(t, e, g, w)), o(y.prototype, i), (a.NEED = !0);
                    return f(y, e), (S[e] = y), r(r.G + r.W + r.F * (y != b), S), v || m.setStrong(y, e, g), y;
                };
            },
            5645: function (e) {
                var t = (e.exports = { version: "2.6.12" });
                "number" == typeof __e && (__e = t);
            },
            2811: function (e, t, i) {
                "use strict";
                var n = i(9275),
                    r = i(681);
                e.exports = function (e, t, i) {
                    t in e ? n.f(e, t, r(0, i)) : (e[t] = i);
                };
            },
            741: function (e, t, i) {
                var n = i(4963);
                e.exports = function (e, t, i) {
                    if ((n(e), void 0 === t)) return e;
                    switch (i) {
                        case 1:
                            return function (i) {
                                return e.call(t, i);
                            };
                        case 2:
                            return function (i, n) {
                                return e.call(t, i, n);
                            };
                        case 3:
                            return function (i, n, r) {
                                return e.call(t, i, n, r);
                            };
                    }
                    return function () {
                        return e.apply(t, arguments);
                    };
                };
            },
            3537: function (e, t, i) {
                "use strict";
                var n = i(4253),
                    r = Date.prototype.getTime,
                    s = Date.prototype.toISOString,
                    o = function (e) {
                        return e > 9 ? e : "0" + e;
                    };
                e.exports =
                    n(function () {
                        return "0385-07-25T07:06:39.999Z" != s.call(new Date(-50000000000001));
                    }) ||
                    !n(function () {
                        s.call(new Date(NaN));
                    })
                        ? function () {
                              if (!isFinite(r.call(this))) throw RangeError("Invalid time value");
                              var e = this,
                                  t = e.getUTCFullYear(),
                                  i = e.getUTCMilliseconds(),
                                  n = t < 0 ? "-" : t > 9999 ? "+" : "";
                              return (
                                  n +
                                  ("00000" + Math.abs(t)).slice(n ? -6 : -4) +
                                  "-" +
                                  o(e.getUTCMonth() + 1) +
                                  "-" +
                                  o(e.getUTCDate()) +
                                  "T" +
                                  o(e.getUTCHours()) +
                                  ":" +
                                  o(e.getUTCMinutes()) +
                                  ":" +
                                  o(e.getUTCSeconds()) +
                                  "." +
                                  (i > 99 ? i : "0" + o(i)) +
                                  "Z"
                              );
                          }
                        : s;
            },
            870: function (e, t, i) {
                "use strict";
                var n = i(7007),
                    r = i(1689),
                    s = "number";
                e.exports = function (e) {
                    if ("string" !== e && e !== s && "default" !== e) throw TypeError("Incorrect hint");
                    return r(n(this), e != s);
                };
            },
            1355: function (e) {
                e.exports = function (e) {
                    if (null == e) throw TypeError("Can't call method on  " + e);
                    return e;
                };
            },
            7057: function (e, t, i) {
                e.exports = !i(4253)(function () {
                    return (
                        7 !=
                        Object.defineProperty({}, "a", {
                            get: function () {
                                return 7;
                            },
                        }).a
                    );
                });
            },
            2457: function (e, t, i) {
                var n = i(5286),
                    r = i(3816).document,
                    s = n(r) && n(r.createElement);
                e.exports = function (e) {
                    return s ? r.createElement(e) : {};
                };
            },
            4430: function (e) {
                e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
            },
            5541: function (e, t, i) {
                var n = i(7184),
                    r = i(4548),
                    s = i(4682);
                e.exports = function (e) {
                    var t = n(e),
                        i = r.f;
                    if (i) for (var o, a = i(e), l = s.f, c = 0; a.length > c; ) l.call(e, (o = a[c++])) && t.push(o);
                    return t;
                };
            },
            2985: function (e, t, i) {
                var n = i(3816),
                    r = i(5645),
                    s = i(7728),
                    o = i(7234),
                    a = i(741),
                    l = "prototype",
                    c = function (e, t, i) {
                        var u,
                            d,
                            h,
                            f,
                            p = e & c.F,
                            m = e & c.G,
                            g = e & c.S,
                            v = e & c.P,
                            b = e & c.B,
                            y = m ? n : g ? n[t] || (n[t] = {}) : (n[t] || {})[l],
                            w = m ? r : r[t] || (r[t] = {}),
                            x = w[l] || (w[l] = {});
                        for (u in (m && (i = t), i))
                            (h = ((d = !p && y && void 0 !== y[u]) ? y : i)[u]),
                                (f = b && d ? a(h, n) : v && "function" == typeof h ? a(Function.call, h) : h),
                                y && o(y, u, h, e & c.U),
                                w[u] != h && s(w, u, f),
                                v && x[u] != h && (x[u] = h);
                    };
                (n.core = r), (c.F = 1), (c.G = 2), (c.S = 4), (c.P = 8), (c.B = 16), (c.W = 32), (c.U = 64), (c.R = 128), (e.exports = c);
            },
            8852: function (e, t, i) {
                var n = i(6314)("match");
                e.exports = function (e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (i) {
                        try {
                            return (t[n] = !1), !"/./"[e](t);
                        } catch (e) {}
                    }
                    return !0;
                };
            },
            4253: function (e) {
                e.exports = function (e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            8082: function (e, t, i) {
                "use strict";
                i(8269);
                var n = i(7234),
                    r = i(7728),
                    s = i(4253),
                    o = i(1355),
                    a = i(6314),
                    l = i(1165),
                    c = a("species"),
                    u = !s(function () {
                        var e = /./;
                        return (
                            (e.exec = function () {
                                var e = [];
                                return (e.groups = { a: "7" }), e;
                            }),
                            "7" !== "".replace(e, "$<a>")
                        );
                    }),
                    d = (function () {
                        var e = /(?:)/,
                            t = e.exec;
                        e.exec = function () {
                            return t.apply(this, arguments);
                        };
                        var i = "ab".split(e);
                        return 2 === i.length && "a" === i[0] && "b" === i[1];
                    })();
                e.exports = function (e, t, i) {
                    var h = a(e),
                        f = !s(function () {
                            var t = {};
                            return (
                                (t[h] = function () {
                                    return 7;
                                }),
                                7 != ""[e](t)
                            );
                        }),
                        p = f
                            ? !s(function () {
                                  var t = !1,
                                      i = /a/;
                                  return (
                                      (i.exec = function () {
                                          return (t = !0), null;
                                      }),
                                      "split" === e &&
                                          ((i.constructor = {}),
                                          (i.constructor[c] = function () {
                                              return i;
                                          })),
                                      i[h](""),
                                      !t
                                  );
                              })
                            : void 0;
                    if (!f || !p || ("replace" === e && !u) || ("split" === e && !d)) {
                        var m = /./[h],
                            g = i(o, h, ""[e], function (e, t, i, n, r) {
                                return t.exec === l ? (f && !r ? { done: !0, value: m.call(t, i, n) } : { done: !0, value: e.call(i, t, n) }) : { done: !1 };
                            }),
                            v = g[0],
                            b = g[1];
                        n(String.prototype, e, v),
                            r(
                                RegExp.prototype,
                                h,
                                2 == t
                                    ? function (e, t) {
                                          return b.call(e, this, t);
                                      }
                                    : function (e) {
                                          return b.call(e, this);
                                      }
                            );
                    }
                };
            },
            3218: function (e, t, i) {
                "use strict";
                var n = i(7007);
                e.exports = function () {
                    var e = n(this),
                        t = "";
                    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
                };
            },
            3325: function (e, t, i) {
                "use strict";
                var n = i(4302),
                    r = i(5286),
                    s = i(875),
                    o = i(741),
                    a = i(6314)("isConcatSpreadable");
                e.exports = function e(t, i, l, c, u, d, h, f) {
                    for (var p, m, g = u, v = 0, b = !!h && o(h, f, 3); v < c; ) {
                        if (v in l) {
                            if (((p = b ? b(l[v], v, i) : l[v]), (m = !1), r(p) && (m = void 0 !== (m = p[a]) ? !!m : n(p)), m && d > 0)) g = e(t, i, p, s(p.length), g, d - 1) - 1;
                            else {
                                if (g >= 9007199254740991) throw TypeError();
                                t[g] = p;
                            }
                            g++;
                        }
                        v++;
                    }
                    return g;
                };
            },
            3531: function (e, t, i) {
                var n = i(741),
                    r = i(8851),
                    s = i(6555),
                    o = i(7007),
                    a = i(875),
                    l = i(9002),
                    c = {},
                    u = {},
                    d = (e.exports = function (e, t, i, d, h) {
                        var f,
                            p,
                            m,
                            g,
                            v = h
                                ? function () {
                                      return e;
                                  }
                                : l(e),
                            b = n(i, d, t ? 2 : 1),
                            y = 0;
                        if ("function" != typeof v) throw TypeError(e + " is not iterable!");
                        if (s(v)) {
                            for (f = a(e.length); f > y; y++) if ((g = t ? b(o((p = e[y]))[0], p[1]) : b(e[y])) === c || g === u) return g;
                        } else for (m = v.call(e); !(p = m.next()).done; ) if ((g = r(m, b, p.value, t)) === c || g === u) return g;
                    });
                (d.BREAK = c), (d.RETURN = u);
            },
            18: function (e, t, i) {
                e.exports = i(3825)("native-function-to-string", Function.toString);
            },
            3816: function (e) {
                var t = (e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")());
                "number" == typeof __g && (__g = t);
            },
            9181: function (e) {
                var t = {}.hasOwnProperty;
                e.exports = function (e, i) {
                    return t.call(e, i);
                };
            },
            7728: function (e, t, i) {
                var n = i(9275),
                    r = i(681);
                e.exports = i(7057)
                    ? function (e, t, i) {
                          return n.f(e, t, r(1, i));
                      }
                    : function (e, t, i) {
                          return (e[t] = i), e;
                      };
            },
            639: function (e, t, i) {
                var n = i(3816).document;
                e.exports = n && n.documentElement;
            },
            1734: function (e, t, i) {
                e.exports =
                    !i(7057) &&
                    !i(4253)(function () {
                        return (
                            7 !=
                            Object.defineProperty(i(2457)("div"), "a", {
                                get: function () {
                                    return 7;
                                },
                            }).a
                        );
                    });
            },
            266: function (e, t, i) {
                var n = i(5286),
                    r = i(7375).set;
                e.exports = function (e, t, i) {
                    var s,
                        o = t.constructor;
                    return o !== i && "function" == typeof o && (s = o.prototype) !== i.prototype && n(s) && r && r(e, s), e;
                };
            },
            7242: function (e) {
                e.exports = function (e, t, i) {
                    var n = void 0 === i;
                    switch (t.length) {
                        case 0:
                            return n ? e() : e.call(i);
                        case 1:
                            return n ? e(t[0]) : e.call(i, t[0]);
                        case 2:
                            return n ? e(t[0], t[1]) : e.call(i, t[0], t[1]);
                        case 3:
                            return n ? e(t[0], t[1], t[2]) : e.call(i, t[0], t[1], t[2]);
                        case 4:
                            return n ? e(t[0], t[1], t[2], t[3]) : e.call(i, t[0], t[1], t[2], t[3]);
                    }
                    return e.apply(i, t);
                };
            },
            9797: function (e, t, i) {
                var n = i(2032);
                e.exports = Object("z").propertyIsEnumerable(0)
                    ? Object
                    : function (e) {
                          return "String" == n(e) ? e.split("") : Object(e);
                      };
            },
            6555: function (e, t, i) {
                var n = i(2803),
                    r = i(6314)("iterator"),
                    s = Array.prototype;
                e.exports = function (e) {
                    return void 0 !== e && (n.Array === e || s[r] === e);
                };
            },
            4302: function (e, t, i) {
                var n = i(2032);
                e.exports =
                    Array.isArray ||
                    function (e) {
                        return "Array" == n(e);
                    };
            },
            8367: function (e, t, i) {
                var n = i(5286),
                    r = Math.floor;
                e.exports = function (e) {
                    return !n(e) && isFinite(e) && r(e) === e;
                };
            },
            5286: function (e) {
                e.exports = function (e) {
                    return "object" == typeof e ? null !== e : "function" == typeof e;
                };
            },
            5364: function (e, t, i) {
                var n = i(5286),
                    r = i(2032),
                    s = i(6314)("match");
                e.exports = function (e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" == r(e));
                };
            },
            8851: function (e, t, i) {
                var n = i(7007);
                e.exports = function (e, t, i, r) {
                    try {
                        return r ? t(n(i)[0], i[1]) : t(i);
                    } catch (t) {
                        var s = e.return;
                        throw (void 0 !== s && n(s.call(e)), t);
                    }
                };
            },
            9988: function (e, t, i) {
                "use strict";
                var n = i(2503),
                    r = i(681),
                    s = i(2943),
                    o = {};
                i(7728)(o, i(6314)("iterator"), function () {
                    return this;
                }),
                    (e.exports = function (e, t, i) {
                        (e.prototype = n(o, { next: r(1, i) })), s(e, t + " Iterator");
                    });
            },
            2923: function (e, t, i) {
                "use strict";
                var n = i(4461),
                    r = i(2985),
                    s = i(7234),
                    o = i(7728),
                    a = i(2803),
                    l = i(9988),
                    c = i(2943),
                    u = i(468),
                    d = i(6314)("iterator"),
                    h = !([].keys && "next" in [].keys()),
                    f = "keys",
                    p = "values",
                    m = function () {
                        return this;
                    };
                e.exports = function (e, t, i, g, v, b, y) {
                    l(i, t, g);
                    var w,
                        x,
                        S,
                        E = function (e) {
                            if (!h && e in P) return P[e];
                            switch (e) {
                                case f:
                                case p:
                                    return function () {
                                        return new i(this, e);
                                    };
                            }
                            return function () {
                                return new i(this, e);
                            };
                        },
                        _ = t + " Iterator",
                        T = v == p,
                        M = !1,
                        P = e.prototype,
                        C = P[d] || P["@@iterator"] || (v && P[v]),
                        O = C || E(v),
                        L = v ? (T ? E("entries") : O) : void 0,
                        k = ("Array" == t && P.entries) || C;
                    if (
                        (k && (S = u(k.call(new e()))) !== Object.prototype && S.next && (c(S, _, !0), n || "function" == typeof S[d] || o(S, d, m)),
                        T &&
                            C &&
                            C.name !== p &&
                            ((M = !0),
                            (O = function () {
                                return C.call(this);
                            })),
                        (n && !y) || (!h && !M && P[d]) || o(P, d, O),
                        (a[t] = O),
                        (a[_] = m),
                        v)
                    )
                        if (((w = { values: T ? O : E(p), keys: b ? O : E(f), entries: L }), y)) for (x in w) x in P || s(P, x, w[x]);
                        else r(r.P + r.F * (h || M), t, w);
                    return w;
                };
            },
            7462: function (e, t, i) {
                var n = i(6314)("iterator"),
                    r = !1;
                try {
                    var s = [7][n]();
                    (s.return = function () {
                        r = !0;
                    }),
                        Array.from(s, function () {
                            throw 2;
                        });
                } catch (e) {}
                e.exports = function (e, t) {
                    if (!t && !r) return !1;
                    var i = !1;
                    try {
                        var s = [7],
                            o = s[n]();
                        (o.next = function () {
                            return { done: (i = !0) };
                        }),
                            (s[n] = function () {
                                return o;
                            }),
                            e(s);
                    } catch (e) {}
                    return i;
                };
            },
            5436: function (e) {
                e.exports = function (e, t) {
                    return { value: t, done: !!e };
                };
            },
            2803: function (e) {
                e.exports = {};
            },
            4461: function (e) {
                e.exports = !1;
            },
            3086: function (e) {
                var t = Math.expm1;
                e.exports =
                    !t || t(10) > 22025.465794806718 || t(10) < 22025.465794806718 || -2e-17 != t(-2e-17)
                        ? function (e) {
                              return 0 == (e = +e) ? e : e > -1e-6 && e < 1e-6 ? e + (e * e) / 2 : Math.exp(e) - 1;
                          }
                        : t;
            },
            4934: function (e, t, i) {
                var n = i(1801),
                    r = Math.pow,
                    s = r(2, -52),
                    o = r(2, -23),
                    a = r(2, 127) * (2 - o),
                    l = r(2, -126);
                e.exports =
                    Math.fround ||
                    function (e) {
                        var t,
                            i,
                            r = Math.abs(e),
                            c = n(e);
                        return r < l ? c * (r / l / o + 1 / s - 1 / s) * l * o : (i = (t = (1 + o / s) * r) - (t - r)) > a || i != i ? c * (1 / 0) : c * i;
                    };
            },
            6206: function (e) {
                e.exports =
                    Math.log1p ||
                    function (e) {
                        return (e = +e) > -1e-8 && e < 1e-8 ? e - (e * e) / 2 : Math.log(1 + e);
                    };
            },
            1801: function (e) {
                e.exports =
                    Math.sign ||
                    function (e) {
                        return 0 == (e = +e) || e != e ? e : e < 0 ? -1 : 1;
                    };
            },
            4728: function (e, t, i) {
                var n = i(3953)("meta"),
                    r = i(5286),
                    s = i(9181),
                    o = i(9275).f,
                    a = 0,
                    l =
                        Object.isExtensible ||
                        function () {
                            return !0;
                        },
                    c = !i(4253)(function () {
                        return l(Object.preventExtensions({}));
                    }),
                    u = function (e) {
                        o(e, n, { value: { i: "O" + ++a, w: {} } });
                    },
                    d = (e.exports = {
                        KEY: n,
                        NEED: !1,
                        fastKey: function (e, t) {
                            if (!r(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
                            if (!s(e, n)) {
                                if (!l(e)) return "F";
                                if (!t) return "E";
                                u(e);
                            }
                            return e[n].i;
                        },
                        getWeak: function (e, t) {
                            if (!s(e, n)) {
                                if (!l(e)) return !0;
                                if (!t) return !1;
                                u(e);
                            }
                            return e[n].w;
                        },
                        onFreeze: function (e) {
                            return c && d.NEED && l(e) && !s(e, n) && u(e), e;
                        },
                    });
            },
            4351: function (e, t, i) {
                var n = i(3816),
                    r = i(4193).set,
                    s = n.MutationObserver || n.WebKitMutationObserver,
                    o = n.process,
                    a = n.Promise,
                    l = "process" == i(2032)(o);
                e.exports = function () {
                    var e,
                        t,
                        i,
                        c = function () {
                            var n, r;
                            for (l && (n = o.domain) && n.exit(); e; ) {
                                (r = e.fn), (e = e.next);
                                try {
                                    r();
                                } catch (n) {
                                    throw (e ? i() : (t = void 0), n);
                                }
                            }
                            (t = void 0), n && n.enter();
                        };
                    if (l)
                        i = function () {
                            o.nextTick(c);
                        };
                    else if (!s || (n.navigator && n.navigator.standalone))
                        if (a && a.resolve) {
                            var u = a.resolve(void 0);
                            i = function () {
                                u.then(c);
                            };
                        } else
                            i = function () {
                                r.call(n, c);
                            };
                    else {
                        var d = !0,
                            h = document.createTextNode("");
                        new s(c).observe(h, { characterData: !0 }),
                            (i = function () {
                                h.data = d = !d;
                            });
                    }
                    return function (n) {
                        var r = { fn: n, next: void 0 };
                        t && (t.next = r), e || ((e = r), i()), (t = r);
                    };
                };
            },
            3499: function (e, t, i) {
                "use strict";
                var n = i(4963);
                function r(e) {
                    var t, i;
                    (this.promise = new e(function (e, n) {
                        if (void 0 !== t || void 0 !== i) throw TypeError("Bad Promise constructor");
                        (t = e), (i = n);
                    })),
                        (this.resolve = n(t)),
                        (this.reject = n(i));
                }
                e.exports.f = function (e) {
                    return new r(e);
                };
            },
            5345: function (e, t, i) {
                "use strict";
                var n = i(7057),
                    r = i(7184),
                    s = i(4548),
                    o = i(4682),
                    a = i(508),
                    l = i(9797),
                    c = Object.assign;
                e.exports =
                    !c ||
                    i(4253)(function () {
                        var e = {},
                            t = {},
                            i = Symbol(),
                            n = "abcdefghijklmnopqrst";
                        return (
                            (e[i] = 7),
                            n.split("").forEach(function (e) {
                                t[e] = e;
                            }),
                            7 != c({}, e)[i] || Object.keys(c({}, t)).join("") != n
                        );
                    })
                        ? function (e, t) {
                              for (var i = a(e), c = arguments.length, u = 1, d = s.f, h = o.f; c > u; )
                                  for (var f, p = l(arguments[u++]), m = d ? r(p).concat(d(p)) : r(p), g = m.length, v = 0; g > v; ) (f = m[v++]), (n && !h.call(p, f)) || (i[f] = p[f]);
                              return i;
                          }
                        : c;
            },
            2503: function (e, t, i) {
                var n = i(7007),
                    r = i(5588),
                    s = i(4430),
                    o = i(9335)("IE_PROTO"),
                    a = function () {},
                    l = "prototype",
                    c = function () {
                        var e,
                            t = i(2457)("iframe"),
                            n = s.length;
                        for (t.style.display = "none", i(639).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object</script>"), e.close(), c = e.F; n--; ) delete c[l][s[n]];
                        return c();
                    };
                e.exports =
                    Object.create ||
                    function (e, t) {
                        var i;
                        return null !== e ? ((a[l] = n(e)), (i = new a()), (a[l] = null), (i[o] = e)) : (i = c()), void 0 === t ? i : r(i, t);
                    };
            },
            9275: function (e, t, i) {
                var n = i(7007),
                    r = i(1734),
                    s = i(1689),
                    o = Object.defineProperty;
                t.f = i(7057)
                    ? Object.defineProperty
                    : function (e, t, i) {
                          if ((n(e), (t = s(t, !0)), n(i), r))
                              try {
                                  return o(e, t, i);
                              } catch (e) {}
                          if ("get" in i || "set" in i) throw TypeError("Accessors not supported!");
                          return "value" in i && (e[t] = i.value), e;
                      };
            },
            5588: function (e, t, i) {
                var n = i(9275),
                    r = i(7007),
                    s = i(7184);
                e.exports = i(7057)
                    ? Object.defineProperties
                    : function (e, t) {
                          r(e);
                          for (var i, o = s(t), a = o.length, l = 0; a > l; ) n.f(e, (i = o[l++]), t[i]);
                          return e;
                      };
            },
            8693: function (e, t, i) {
                var n = i(4682),
                    r = i(681),
                    s = i(2110),
                    o = i(1689),
                    a = i(9181),
                    l = i(1734),
                    c = Object.getOwnPropertyDescriptor;
                t.f = i(7057)
                    ? c
                    : function (e, t) {
                          if (((e = s(e)), (t = o(t, !0)), l))
                              try {
                                  return c(e, t);
                              } catch (e) {}
                          if (a(e, t)) return r(!n.f.call(e, t), e[t]);
                      };
            },
            9327: function (e, t, i) {
                var n = i(2110),
                    r = i(616).f,
                    s = {}.toString,
                    o = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function (e) {
                    return o && "[object Window]" == s.call(e)
                        ? (function (e) {
                              try {
                                  return r(e);
                              } catch (e) {
                                  return o.slice();
                              }
                          })(e)
                        : r(n(e));
                };
            },
            616: function (e, t, i) {
                var n = i(189),
                    r = i(4430).concat("length", "prototype");
                t.f =
                    Object.getOwnPropertyNames ||
                    function (e) {
                        return n(e, r);
                    };
            },
            4548: function (e, t) {
                t.f = Object.getOwnPropertySymbols;
            },
            468: function (e, t, i) {
                var n = i(9181),
                    r = i(508),
                    s = i(9335)("IE_PROTO"),
                    o = Object.prototype;
                e.exports =
                    Object.getPrototypeOf ||
                    function (e) {
                        return (e = r(e)), n(e, s) ? e[s] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? o : null;
                    };
            },
            189: function (e, t, i) {
                var n = i(9181),
                    r = i(2110),
                    s = i(9315)(!1),
                    o = i(9335)("IE_PROTO");
                e.exports = function (e, t) {
                    var i,
                        a = r(e),
                        l = 0,
                        c = [];
                    for (i in a) i != o && n(a, i) && c.push(i);
                    for (; t.length > l; ) n(a, (i = t[l++])) && (~s(c, i) || c.push(i));
                    return c;
                };
            },
            7184: function (e, t, i) {
                var n = i(189),
                    r = i(4430);
                e.exports =
                    Object.keys ||
                    function (e) {
                        return n(e, r);
                    };
            },
            4682: function (e, t) {
                t.f = {}.propertyIsEnumerable;
            },
            3160: function (e, t, i) {
                var n = i(2985),
                    r = i(5645),
                    s = i(4253);
                e.exports = function (e, t) {
                    var i = (r.Object || {})[e] || Object[e],
                        o = {};
                    (o[e] = t(i)),
                        n(
                            n.S +
                                n.F *
                                    s(function () {
                                        i(1);
                                    }),
                            "Object",
                            o
                        );
                };
            },
            1131: function (e, t, i) {
                var n = i(7057),
                    r = i(7184),
                    s = i(2110),
                    o = i(4682).f;
                e.exports = function (e) {
                    return function (t) {
                        for (var i, a = s(t), l = r(a), c = l.length, u = 0, d = []; c > u; ) (i = l[u++]), (n && !o.call(a, i)) || d.push(e ? [i, a[i]] : a[i]);
                        return d;
                    };
                };
            },
            7643: function (e, t, i) {
                var n = i(616),
                    r = i(4548),
                    s = i(7007),
                    o = i(3816).Reflect;
                e.exports =
                    (o && o.ownKeys) ||
                    function (e) {
                        var t = n.f(s(e)),
                            i = r.f;
                        return i ? t.concat(i(e)) : t;
                    };
            },
            7743: function (e, t, i) {
                var n = i(3816).parseFloat,
                    r = i(9599).trim;
                e.exports =
                    1 / n(i(4644) + "-0") != -1 / 0
                        ? function (e) {
                              var t = r(String(e), 3),
                                  i = n(t);
                              return 0 === i && "-" == t.charAt(0) ? -0 : i;
                          }
                        : n;
            },
            5960: function (e, t, i) {
                var n = i(3816).parseInt,
                    r = i(9599).trim,
                    s = i(4644),
                    o = /^[-+]?0[xX]/;
                e.exports =
                    8 !== n(s + "08") || 22 !== n(s + "0x16")
                        ? function (e, t) {
                              var i = r(String(e), 3);
                              return n(i, t >>> 0 || (o.test(i) ? 16 : 10));
                          }
                        : n;
            },
            188: function (e) {
                e.exports = function (e) {
                    try {
                        return { e: !1, v: e() };
                    } catch (e) {
                        return { e: !0, v: e };
                    }
                };
            },
            94: function (e, t, i) {
                var n = i(7007),
                    r = i(5286),
                    s = i(3499);
                e.exports = function (e, t) {
                    if ((n(e), r(t) && t.constructor === e)) return t;
                    var i = s.f(e);
                    return (0, i.resolve)(t), i.promise;
                };
            },
            681: function (e) {
                e.exports = function (e, t) {
                    return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
                };
            },
            4408: function (e, t, i) {
                var n = i(7234);
                e.exports = function (e, t, i) {
                    for (var r in t) n(e, r, t[r], i);
                    return e;
                };
            },
            7234: function (e, t, i) {
                var n = i(3816),
                    r = i(7728),
                    s = i(9181),
                    o = i(3953)("src"),
                    a = i(18),
                    l = "toString",
                    c = ("" + a).split(l);
                (i(5645).inspectSource = function (e) {
                    return a.call(e);
                }),
                    (e.exports = function (e, t, i, a) {
                        var l = "function" == typeof i;
                        l && (s(i, "name") || r(i, "name", t)), e[t] !== i && (l && (s(i, o) || r(i, o, e[t] ? "" + e[t] : c.join(String(t)))), e === n ? (e[t] = i) : a ? (e[t] ? (e[t] = i) : r(e, t, i)) : (delete e[t], r(e, t, i)));
                    })(Function.prototype, l, function () {
                        return ("function" == typeof this && this[o]) || a.call(this);
                    });
            },
            7787: function (e, t, i) {
                "use strict";
                var n = i(1488),
                    r = RegExp.prototype.exec;
                e.exports = function (e, t) {
                    var i = e.exec;
                    if ("function" == typeof i) {
                        var s = i.call(e, t);
                        if ("object" != typeof s) throw new TypeError("RegExp exec method returned something other than an Object or null");
                        return s;
                    }
                    if ("RegExp" !== n(e)) throw new TypeError("RegExp#exec called on incompatible receiver");
                    return r.call(e, t);
                };
            },
            1165: function (e, t, i) {
                "use strict";
                var n,
                    r,
                    s = i(3218),
                    o = RegExp.prototype.exec,
                    a = String.prototype.replace,
                    l = o,
                    c = "lastIndex",
                    u = ((n = /a/), (r = /b*/g), o.call(n, "a"), o.call(r, "a"), 0 !== n[c] || 0 !== r[c]),
                    d = void 0 !== /()??/.exec("")[1];
                (u || d) &&
                    (l = function (e) {
                        var t,
                            i,
                            n,
                            r,
                            l = this;
                        return (
                            d && (i = new RegExp("^" + l.source + "$(?!\\s)", s.call(l))),
                            u && (t = l[c]),
                            (n = o.call(l, e)),
                            u && n && (l[c] = l.global ? n.index + n[0].length : t),
                            d &&
                                n &&
                                n.length > 1 &&
                                a.call(n[0], i, function () {
                                    for (r = 1; r < arguments.length - 2; r++) void 0 === arguments[r] && (n[r] = void 0);
                                }),
                            n
                        );
                    }),
                    (e.exports = l);
            },
            7195: function (e) {
                e.exports =
                    Object.is ||
                    function (e, t) {
                        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
                    };
            },
            7375: function (e, t, i) {
                var n = i(5286),
                    r = i(7007),
                    s = function (e, t) {
                        if ((r(e), !n(t) && null !== t)) throw TypeError(t + ": can't set as prototype!");
                    };
                e.exports = {
                    set:
                        Object.setPrototypeOf ||
                        ("__proto__" in {}
                            ? (function (e, t, n) {
                                  try {
                                      (n = i(741)(Function.call, i(8693).f(Object.prototype, "__proto__").set, 2))(e, []), (t = !(e instanceof Array));
                                  } catch (e) {
                                      t = !0;
                                  }
                                  return function (e, i) {
                                      return s(e, i), t ? (e.__proto__ = i) : n(e, i), e;
                                  };
                              })({}, !1)
                            : void 0),
                    check: s,
                };
            },
            2974: function (e, t, i) {
                "use strict";
                var n = i(3816),
                    r = i(9275),
                    s = i(7057),
                    o = i(6314)("species");
                e.exports = function (e) {
                    var t = n[e];
                    s &&
                        t &&
                        !t[o] &&
                        r.f(t, o, {
                            configurable: !0,
                            get: function () {
                                return this;
                            },
                        });
                };
            },
            2943: function (e, t, i) {
                var n = i(9275).f,
                    r = i(9181),
                    s = i(6314)("toStringTag");
                e.exports = function (e, t, i) {
                    e && !r((e = i ? e : e.prototype), s) && n(e, s, { configurable: !0, value: t });
                };
            },
            9335: function (e, t, i) {
                var n = i(3825)("keys"),
                    r = i(3953);
                e.exports = function (e) {
                    return n[e] || (n[e] = r(e));
                };
            },
            3825: function (e, t, i) {
                var n = i(5645),
                    r = i(3816),
                    s = "__core-js_shared__",
                    o = r[s] || (r[s] = {});
                (e.exports = function (e, t) {
                    return o[e] || (o[e] = void 0 !== t ? t : {});
                })("versions", []).push({ version: n.version, mode: i(4461) ? "pure" : "global", copyright: "© 2020 Denis Pushkarev (zloirock.ru)" });
            },
            8364: function (e, t, i) {
                var n = i(7007),
                    r = i(4963),
                    s = i(6314)("species");
                e.exports = function (e, t) {
                    var i,
                        o = n(e).constructor;
                    return void 0 === o || null == (i = n(o)[s]) ? t : r(i);
                };
            },
            7717: function (e, t, i) {
                "use strict";
                var n = i(4253);
                e.exports = function (e, t) {
                    return (
                        !!e &&
                        n(function () {
                            t ? e.call(null, function () {}, 1) : e.call(null);
                        })
                    );
                };
            },
            4496: function (e, t, i) {
                var n = i(1467),
                    r = i(1355);
                e.exports = function (e) {
                    return function (t, i) {
                        var s,
                            o,
                            a = String(r(t)),
                            l = n(i),
                            c = a.length;
                        return l < 0 || l >= c
                            ? e
                                ? ""
                                : void 0
                            : (s = a.charCodeAt(l)) < 55296 || s > 56319 || l + 1 === c || (o = a.charCodeAt(l + 1)) < 56320 || o > 57343
                            ? e
                                ? a.charAt(l)
                                : s
                            : e
                            ? a.slice(l, l + 2)
                            : o - 56320 + ((s - 55296) << 10) + 65536;
                    };
                };
            },
            2094: function (e, t, i) {
                var n = i(5364),
                    r = i(1355);
                e.exports = function (e, t, i) {
                    if (n(t)) throw TypeError("String#" + i + " doesn't accept regex!");
                    return String(r(e));
                };
            },
            9395: function (e, t, i) {
                var n = i(2985),
                    r = i(4253),
                    s = i(1355),
                    o = /"/g,
                    a = function (e, t, i, n) {
                        var r = String(s(e)),
                            a = "<" + t;
                        return "" !== i && (a += " " + i + '="' + String(n).replace(o, "&quot;") + '"'), a + ">" + r + "</" + t + ">";
                    };
                e.exports = function (e, t) {
                    var i = {};
                    (i[e] = t(a)),
                        n(
                            n.P +
                                n.F *
                                    r(function () {
                                        var t = ""[e]('"');
                                        return t !== t.toLowerCase() || t.split('"').length > 3;
                                    }),
                            "String",
                            i
                        );
                };
            },
            5442: function (e, t, i) {
                var n = i(875),
                    r = i(8595),
                    s = i(1355);
                e.exports = function (e, t, i, o) {
                    var a = String(s(e)),
                        l = a.length,
                        c = void 0 === i ? " " : String(i),
                        u = n(t);
                    if (u <= l || "" == c) return a;
                    var d = u - l,
                        h = r.call(c, Math.ceil(d / c.length));
                    return h.length > d && (h = h.slice(0, d)), o ? h + a : a + h;
                };
            },
            8595: function (e, t, i) {
                "use strict";
                var n = i(1467),
                    r = i(1355);
                e.exports = function (e) {
                    var t = String(r(this)),
                        i = "",
                        s = n(e);
                    if (s < 0 || s == 1 / 0) throw RangeError("Count can't be negative");
                    for (; s > 0; (s >>>= 1) && (t += t)) 1 & s && (i += t);
                    return i;
                };
            },
            9599: function (e, t, i) {
                var n = i(2985),
                    r = i(1355),
                    s = i(4253),
                    o = i(4644),
                    a = "[" + o + "]",
                    l = RegExp("^" + a + a + "*"),
                    c = RegExp(a + a + "*$"),
                    u = function (e, t, i) {
                        var r = {},
                            a = s(function () {
                                return !!o[e]() || "​" != "​"[e]();
                            }),
                            l = (r[e] = a ? t(d) : o[e]);
                        i && (r[i] = l), n(n.P + n.F * a, "String", r);
                    },
                    d = (u.trim = function (e, t) {
                        return (e = String(r(e))), 1 & t && (e = e.replace(l, "")), 2 & t && (e = e.replace(c, "")), e;
                    });
                e.exports = u;
            },
            4644: function (e) {
                e.exports = "\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";
            },
            4193: function (e, t, i) {
                var n,
                    r,
                    s,
                    o = i(741),
                    a = i(7242),
                    l = i(639),
                    c = i(2457),
                    u = i(3816),
                    d = u.process,
                    h = u.setImmediate,
                    f = u.clearImmediate,
                    p = u.MessageChannel,
                    m = u.Dispatch,
                    g = 0,
                    v = {},
                    b = "onreadystatechange",
                    y = function () {
                        var e = +this;
                        if (v.hasOwnProperty(e)) {
                            var t = v[e];
                            delete v[e], t();
                        }
                    },
                    w = function (e) {
                        y.call(e.data);
                    };
                (h && f) ||
                    ((h = function (e) {
                        for (var t = [], i = 1; arguments.length > i; ) t.push(arguments[i++]);
                        return (
                            (v[++g] = function () {
                                a("function" == typeof e ? e : Function(e), t);
                            }),
                            n(g),
                            g
                        );
                    }),
                    (f = function (e) {
                        delete v[e];
                    }),
                    "process" == i(2032)(d)
                        ? (n = function (e) {
                              d.nextTick(o(y, e, 1));
                          })
                        : m && m.now
                        ? (n = function (e) {
                              m.now(o(y, e, 1));
                          })
                        : p
                        ? ((s = (r = new p()).port2), (r.port1.onmessage = w), (n = o(s.postMessage, s, 1)))
                        : u.addEventListener && "function" == typeof postMessage && !u.importScripts
                        ? ((n = function (e) {
                              u.postMessage(e + "", "*");
                          }),
                          u.addEventListener("message", w, !1))
                        : (n =
                              b in c("script")
                                  ? function (e) {
                                        l.appendChild(c("script"))[b] = function () {
                                            l.removeChild(this), y.call(e);
                                        };
                                    }
                                  : function (e) {
                                        setTimeout(o(y, e, 1), 0);
                                    })),
                    (e.exports = { set: h, clear: f });
            },
            2337: function (e, t, i) {
                var n = i(1467),
                    r = Math.max,
                    s = Math.min;
                e.exports = function (e, t) {
                    return (e = n(e)) < 0 ? r(e + t, 0) : s(e, t);
                };
            },
            4843: function (e, t, i) {
                var n = i(1467),
                    r = i(875);
                e.exports = function (e) {
                    if (void 0 === e) return 0;
                    var t = n(e),
                        i = r(t);
                    if (t !== i) throw RangeError("Wrong length!");
                    return i;
                };
            },
            1467: function (e) {
                var t = Math.ceil,
                    i = Math.floor;
                e.exports = function (e) {
                    return isNaN((e = +e)) ? 0 : (e > 0 ? i : t)(e);
                };
            },
            2110: function (e, t, i) {
                var n = i(9797),
                    r = i(1355);
                e.exports = function (e) {
                    return n(r(e));
                };
            },
            875: function (e, t, i) {
                var n = i(1467),
                    r = Math.min;
                e.exports = function (e) {
                    return e > 0 ? r(n(e), 9007199254740991) : 0;
                };
            },
            508: function (e, t, i) {
                var n = i(1355);
                e.exports = function (e) {
                    return Object(n(e));
                };
            },
            1689: function (e, t, i) {
                var n = i(5286);
                e.exports = function (e, t) {
                    if (!n(e)) return e;
                    var i, r;
                    if (t && "function" == typeof (i = e.toString) && !n((r = i.call(e)))) return r;
                    if ("function" == typeof (i = e.valueOf) && !n((r = i.call(e)))) return r;
                    if (!t && "function" == typeof (i = e.toString) && !n((r = i.call(e)))) return r;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            8440: function (e, t, i) {
                "use strict";
                if (i(7057)) {
                    var n = i(4461),
                        r = i(3816),
                        s = i(4253),
                        o = i(2985),
                        a = i(9383),
                        l = i(1125),
                        c = i(741),
                        u = i(3328),
                        d = i(681),
                        h = i(7728),
                        f = i(4408),
                        p = i(1467),
                        m = i(875),
                        g = i(4843),
                        v = i(2337),
                        b = i(1689),
                        y = i(9181),
                        w = i(1488),
                        x = i(5286),
                        S = i(508),
                        E = i(6555),
                        _ = i(2503),
                        T = i(468),
                        M = i(616).f,
                        P = i(9002),
                        C = i(3953),
                        O = i(6314),
                        L = i(50),
                        k = i(9315),
                        A = i(8364),
                        I = i(6997),
                        z = i(2803),
                        D = i(7462),
                        j = i(2974),
                        R = i(6852),
                        F = i(5216),
                        $ = i(9275),
                        N = i(8693),
                        B = $.f,
                        H = N.f,
                        q = r.RangeError,
                        V = r.TypeError,
                        Y = r.Uint8Array,
                        W = "ArrayBuffer",
                        X = "Shared" + W,
                        G = "BYTES_PER_ELEMENT",
                        U = "prototype",
                        Z = Array[U],
                        K = l.ArrayBuffer,
                        J = l.DataView,
                        Q = L(0),
                        ee = L(2),
                        te = L(3),
                        ie = L(4),
                        ne = L(5),
                        re = L(6),
                        se = k(!0),
                        oe = k(!1),
                        ae = I.values,
                        le = I.keys,
                        ce = I.entries,
                        ue = Z.lastIndexOf,
                        de = Z.reduce,
                        he = Z.reduceRight,
                        fe = Z.join,
                        pe = Z.sort,
                        me = Z.slice,
                        ge = Z.toString,
                        ve = Z.toLocaleString,
                        be = O("iterator"),
                        ye = O("toStringTag"),
                        we = C("typed_constructor"),
                        xe = C("def_constructor"),
                        Se = a.CONSTR,
                        Ee = a.TYPED,
                        _e = a.VIEW,
                        Te = "Wrong length!",
                        Me = L(1, function (e, t) {
                            return ke(A(e, e[xe]), t);
                        }),
                        Pe = s(function () {
                            return 1 === new Y(new Uint16Array([1]).buffer)[0];
                        }),
                        Ce =
                            !!Y &&
                            !!Y[U].set &&
                            s(function () {
                                new Y(1).set({});
                            }),
                        Oe = function (e, t) {
                            var i = p(e);
                            if (i < 0 || i % t) throw q("Wrong offset!");
                            return i;
                        },
                        Le = function (e) {
                            if (x(e) && Ee in e) return e;
                            throw V(e + " is not a typed array!");
                        },
                        ke = function (e, t) {
                            if (!x(e) || !(we in e)) throw V("It is not a typed array constructor!");
                            return new e(t);
                        },
                        Ae = function (e, t) {
                            return Ie(A(e, e[xe]), t);
                        },
                        Ie = function (e, t) {
                            for (var i = 0, n = t.length, r = ke(e, n); n > i; ) r[i] = t[i++];
                            return r;
                        },
                        ze = function (e, t, i) {
                            B(e, t, {
                                get: function () {
                                    return this._d[i];
                                },
                            });
                        },
                        De = function (e) {
                            var t,
                                i,
                                n,
                                r,
                                s,
                                o,
                                a = S(e),
                                l = arguments.length,
                                u = l > 1 ? arguments[1] : void 0,
                                d = void 0 !== u,
                                h = P(a);
                            if (null != h && !E(h)) {
                                for (o = h.call(a), n = [], t = 0; !(s = o.next()).done; t++) n.push(s.value);
                                a = n;
                            }
                            for (d && l > 2 && (u = c(u, arguments[2], 2)), t = 0, i = m(a.length), r = ke(this, i); i > t; t++) r[t] = d ? u(a[t], t) : a[t];
                            return r;
                        },
                        je = function () {
                            for (var e = 0, t = arguments.length, i = ke(this, t); t > e; ) i[e] = arguments[e++];
                            return i;
                        },
                        Re =
                            !!Y &&
                            s(function () {
                                ve.call(new Y(1));
                            }),
                        Fe = function () {
                            return ve.apply(Re ? me.call(Le(this)) : Le(this), arguments);
                        },
                        $e = {
                            copyWithin: function (e, t) {
                                return F.call(Le(this), e, t, arguments.length > 2 ? arguments[2] : void 0);
                            },
                            every: function (e) {
                                return ie(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            fill: function (e) {
                                return R.apply(Le(this), arguments);
                            },
                            filter: function (e) {
                                return Ae(this, ee(Le(this), e, arguments.length > 1 ? arguments[1] : void 0));
                            },
                            find: function (e) {
                                return ne(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            findIndex: function (e) {
                                return re(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            forEach: function (e) {
                                Q(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            indexOf: function (e) {
                                return oe(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            includes: function (e) {
                                return se(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            join: function (e) {
                                return fe.apply(Le(this), arguments);
                            },
                            lastIndexOf: function (e) {
                                return ue.apply(Le(this), arguments);
                            },
                            map: function (e) {
                                return Me(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            reduce: function (e) {
                                return de.apply(Le(this), arguments);
                            },
                            reduceRight: function (e) {
                                return he.apply(Le(this), arguments);
                            },
                            reverse: function () {
                                for (var e, t = this, i = Le(t).length, n = Math.floor(i / 2), r = 0; r < n; ) (e = t[r]), (t[r++] = t[--i]), (t[i] = e);
                                return t;
                            },
                            some: function (e) {
                                return te(Le(this), e, arguments.length > 1 ? arguments[1] : void 0);
                            },
                            sort: function (e) {
                                return pe.call(Le(this), e);
                            },
                            subarray: function (e, t) {
                                var i = Le(this),
                                    n = i.length,
                                    r = v(e, n);
                                return new (A(i, i[xe]))(i.buffer, i.byteOffset + r * i.BYTES_PER_ELEMENT, m((void 0 === t ? n : v(t, n)) - r));
                            },
                        },
                        Ne = function (e, t) {
                            return Ae(this, me.call(Le(this), e, t));
                        },
                        Be = function (e) {
                            Le(this);
                            var t = Oe(arguments[1], 1),
                                i = this.length,
                                n = S(e),
                                r = m(n.length),
                                s = 0;
                            if (r + t > i) throw q(Te);
                            for (; s < r; ) this[t + s] = n[s++];
                        },
                        He = {
                            entries: function () {
                                return ce.call(Le(this));
                            },
                            keys: function () {
                                return le.call(Le(this));
                            },
                            values: function () {
                                return ae.call(Le(this));
                            },
                        },
                        qe = function (e, t) {
                            return x(e) && e[Ee] && "symbol" != typeof t && t in e && String(+t) == String(t);
                        },
                        Ve = function (e, t) {
                            return qe(e, (t = b(t, !0))) ? d(2, e[t]) : H(e, t);
                        },
                        Ye = function (e, t, i) {
                            return !(qe(e, (t = b(t, !0))) && x(i) && y(i, "value")) || y(i, "get") || y(i, "set") || i.configurable || (y(i, "writable") && !i.writable) || (y(i, "enumerable") && !i.enumerable)
                                ? B(e, t, i)
                                : ((e[t] = i.value), e);
                        };
                    Se || ((N.f = Ve), ($.f = Ye)),
                        o(o.S + o.F * !Se, "Object", { getOwnPropertyDescriptor: Ve, defineProperty: Ye }),
                        s(function () {
                            ge.call({});
                        }) &&
                            (ge = ve = function () {
                                return fe.call(this);
                            });
                    var We = f({}, $e);
                    f(We, He),
                        h(We, be, He.values),
                        f(We, { slice: Ne, set: Be, constructor: function () {}, toString: ge, toLocaleString: Fe }),
                        ze(We, "buffer", "b"),
                        ze(We, "byteOffset", "o"),
                        ze(We, "byteLength", "l"),
                        ze(We, "length", "e"),
                        B(We, ye, {
                            get: function () {
                                return this[Ee];
                            },
                        }),
                        (e.exports = function (e, t, i, l) {
                            var c = e + ((l = !!l) ? "Clamped" : "") + "Array",
                                d = "get" + e,
                                f = "set" + e,
                                p = r[c],
                                v = p || {},
                                b = p && T(p),
                                y = !p || !a.ABV,
                                S = {},
                                E = p && p[U],
                                P = function (e, i) {
                                    B(e, i, {
                                        get: function () {
                                            return (function (e, i) {
                                                var n = e._d;
                                                return n.v[d](i * t + n.o, Pe);
                                            })(this, i);
                                        },
                                        set: function (e) {
                                            return (function (e, i, n) {
                                                var r = e._d;
                                                l && (n = (n = Math.round(n)) < 0 ? 0 : n > 255 ? 255 : 255 & n), r.v[f](i * t + r.o, n, Pe);
                                            })(this, i, e);
                                        },
                                        enumerable: !0,
                                    });
                                };
                            y
                                ? ((p = i(function (e, i, n, r) {
                                      u(e, p, c, "_d");
                                      var s,
                                          o,
                                          a,
                                          l,
                                          d = 0,
                                          f = 0;
                                      if (x(i)) {
                                          if (!(i instanceof K || (l = w(i)) == W || l == X)) return Ee in i ? Ie(p, i) : De.call(p, i);
                                          (s = i), (f = Oe(n, t));
                                          var v = i.byteLength;
                                          if (void 0 === r) {
                                              if (v % t) throw q(Te);
                                              if ((o = v - f) < 0) throw q(Te);
                                          } else if ((o = m(r) * t) + f > v) throw q(Te);
                                          a = o / t;
                                      } else (a = g(i)), (s = new K((o = a * t)));
                                      for (h(e, "_d", { b: s, o: f, l: o, e: a, v: new J(s) }); d < a; ) P(e, d++);
                                  })),
                                  (E = p[U] = _(We)),
                                  h(E, "constructor", p))
                                : (s(function () {
                                      p(1);
                                  }) &&
                                      s(function () {
                                          new p(-1);
                                      }) &&
                                      D(function (e) {
                                          new p(), new p(null), new p(1.5), new p(e);
                                      }, !0)) ||
                                  ((p = i(function (e, i, n, r) {
                                      var s;
                                      return (
                                          u(e, p, c),
                                          x(i) ? (i instanceof K || (s = w(i)) == W || s == X ? (void 0 !== r ? new v(i, Oe(n, t), r) : void 0 !== n ? new v(i, Oe(n, t)) : new v(i)) : Ee in i ? Ie(p, i) : De.call(p, i)) : new v(g(i))
                                      );
                                  })),
                                  Q(b !== Function.prototype ? M(v).concat(M(b)) : M(v), function (e) {
                                      e in p || h(p, e, v[e]);
                                  }),
                                  (p[U] = E),
                                  n || (E.constructor = p));
                            var C = E[be],
                                O = !!C && ("values" == C.name || null == C.name),
                                L = He.values;
                            h(p, we, !0),
                                h(E, Ee, c),
                                h(E, _e, !0),
                                h(E, xe, p),
                                (l ? new p(1)[ye] == c : ye in E) ||
                                    B(E, ye, {
                                        get: function () {
                                            return c;
                                        },
                                    }),
                                (S[c] = p),
                                o(o.G + o.W + o.F * (p != v), S),
                                o(o.S, c, { BYTES_PER_ELEMENT: t }),
                                o(
                                    o.S +
                                        o.F *
                                            s(function () {
                                                v.of.call(p, 1);
                                            }),
                                    c,
                                    { from: De, of: je }
                                ),
                                G in E || h(E, G, t),
                                o(o.P, c, $e),
                                j(c),
                                o(o.P + o.F * Ce, c, { set: Be }),
                                o(o.P + o.F * !O, c, He),
                                n || E.toString == ge || (E.toString = ge),
                                o(
                                    o.P +
                                        o.F *
                                            s(function () {
                                                new p(1).slice();
                                            }),
                                    c,
                                    { slice: Ne }
                                ),
                                o(
                                    o.P +
                                        o.F *
                                            (s(function () {
                                                return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
                                            }) ||
                                                !s(function () {
                                                    E.toLocaleString.call([1, 2]);
                                                })),
                                    c,
                                    { toLocaleString: Fe }
                                ),
                                (z[c] = O ? C : L),
                                n || O || h(E, be, L);
                        });
                } else e.exports = function () {};
            },
            1125: function (e, t, i) {
                "use strict";
                var n = i(3816),
                    r = i(7057),
                    s = i(4461),
                    o = i(9383),
                    a = i(7728),
                    l = i(4408),
                    c = i(4253),
                    u = i(3328),
                    d = i(1467),
                    h = i(875),
                    f = i(4843),
                    p = i(616).f,
                    m = i(9275).f,
                    g = i(6852),
                    v = i(2943),
                    b = "ArrayBuffer",
                    y = "DataView",
                    w = "prototype",
                    x = "Wrong index!",
                    S = n[b],
                    E = n[y],
                    _ = n.Math,
                    T = n.RangeError,
                    M = n.Infinity,
                    P = S,
                    C = _.abs,
                    O = _.pow,
                    L = _.floor,
                    k = _.log,
                    A = _.LN2,
                    I = "buffer",
                    z = "byteLength",
                    D = "byteOffset",
                    j = r ? "_b" : I,
                    R = r ? "_l" : z,
                    F = r ? "_o" : D;
                function $(e, t, i) {
                    var n,
                        r,
                        s,
                        o = new Array(i),
                        a = 8 * i - t - 1,
                        l = (1 << a) - 1,
                        c = l >> 1,
                        u = 23 === t ? O(2, -24) - O(2, -77) : 0,
                        d = 0,
                        h = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0;
                    for (
                        (e = C(e)) != e || e === M
                            ? ((r = e != e ? 1 : 0), (n = l))
                            : ((n = L(k(e) / A)),
                              e * (s = O(2, -n)) < 1 && (n--, (s *= 2)),
                              (e += n + c >= 1 ? u / s : u * O(2, 1 - c)) * s >= 2 && (n++, (s /= 2)),
                              n + c >= l ? ((r = 0), (n = l)) : n + c >= 1 ? ((r = (e * s - 1) * O(2, t)), (n += c)) : ((r = e * O(2, c - 1) * O(2, t)), (n = 0)));
                        t >= 8;
                        o[d++] = 255 & r, r /= 256, t -= 8
                    );
                    for (n = (n << t) | r, a += t; a > 0; o[d++] = 255 & n, n /= 256, a -= 8);
                    return (o[--d] |= 128 * h), o;
                }
                function N(e, t, i) {
                    var n,
                        r = 8 * i - t - 1,
                        s = (1 << r) - 1,
                        o = s >> 1,
                        a = r - 7,
                        l = i - 1,
                        c = e[l--],
                        u = 127 & c;
                    for (c >>= 7; a > 0; u = 256 * u + e[l], l--, a -= 8);
                    for (n = u & ((1 << -a) - 1), u >>= -a, a += t; a > 0; n = 256 * n + e[l], l--, a -= 8);
                    if (0 === u) u = 1 - o;
                    else {
                        if (u === s) return n ? NaN : c ? -M : M;
                        (n += O(2, t)), (u -= o);
                    }
                    return (c ? -1 : 1) * n * O(2, u - t);
                }
                function B(e) {
                    return (e[3] << 24) | (e[2] << 16) | (e[1] << 8) | e[0];
                }
                function H(e) {
                    return [255 & e];
                }
                function q(e) {
                    return [255 & e, (e >> 8) & 255];
                }
                function V(e) {
                    return [255 & e, (e >> 8) & 255, (e >> 16) & 255, (e >> 24) & 255];
                }
                function Y(e) {
                    return $(e, 52, 8);
                }
                function W(e) {
                    return $(e, 23, 4);
                }
                function X(e, t, i) {
                    m(e[w], t, {
                        get: function () {
                            return this[i];
                        },
                    });
                }
                function G(e, t, i, n) {
                    var r = f(+i);
                    if (r + t > e[R]) throw T(x);
                    var s = e[j]._b,
                        o = r + e[F],
                        a = s.slice(o, o + t);
                    return n ? a : a.reverse();
                }
                function U(e, t, i, n, r, s) {
                    var o = f(+i);
                    if (o + t > e[R]) throw T(x);
                    for (var a = e[j]._b, l = o + e[F], c = n(+r), u = 0; u < t; u++) a[l + u] = c[s ? u : t - u - 1];
                }
                if (o.ABV) {
                    if (
                        !c(function () {
                            S(1);
                        }) ||
                        !c(function () {
                            new S(-1);
                        }) ||
                        c(function () {
                            return new S(), new S(1.5), new S(NaN), S.name != b;
                        })
                    ) {
                        for (
                            var Z,
                                K = ((S = function (e) {
                                    return u(this, S), new P(f(e));
                                })[w] = P[w]),
                                J = p(P),
                                Q = 0;
                            J.length > Q;

                        )
                            (Z = J[Q++]) in S || a(S, Z, P[Z]);
                        s || (K.constructor = S);
                    }
                    var ee = new E(new S(2)),
                        te = E[w].setInt8;
                    ee.setInt8(0, 2147483648),
                        ee.setInt8(1, 2147483649),
                        (!ee.getInt8(0) && ee.getInt8(1)) ||
                            l(
                                E[w],
                                {
                                    setInt8: function (e, t) {
                                        te.call(this, e, (t << 24) >> 24);
                                    },
                                    setUint8: function (e, t) {
                                        te.call(this, e, (t << 24) >> 24);
                                    },
                                },
                                !0
                            );
                } else
                    (S = function (e) {
                        u(this, S, b);
                        var t = f(e);
                        (this._b = g.call(new Array(t), 0)), (this[R] = t);
                    }),
                        (E = function (e, t, i) {
                            u(this, E, y), u(e, S, y);
                            var n = e[R],
                                r = d(t);
                            if (r < 0 || r > n) throw T("Wrong offset!");
                            if (r + (i = void 0 === i ? n - r : h(i)) > n) throw T("Wrong length!");
                            (this[j] = e), (this[F] = r), (this[R] = i);
                        }),
                        r && (X(S, z, "_l"), X(E, I, "_b"), X(E, z, "_l"), X(E, D, "_o")),
                        l(E[w], {
                            getInt8: function (e) {
                                return (G(this, 1, e)[0] << 24) >> 24;
                            },
                            getUint8: function (e) {
                                return G(this, 1, e)[0];
                            },
                            getInt16: function (e) {
                                var t = G(this, 2, e, arguments[1]);
                                return (((t[1] << 8) | t[0]) << 16) >> 16;
                            },
                            getUint16: function (e) {
                                var t = G(this, 2, e, arguments[1]);
                                return (t[1] << 8) | t[0];
                            },
                            getInt32: function (e) {
                                return B(G(this, 4, e, arguments[1]));
                            },
                            getUint32: function (e) {
                                return B(G(this, 4, e, arguments[1])) >>> 0;
                            },
                            getFloat32: function (e) {
                                return N(G(this, 4, e, arguments[1]), 23, 4);
                            },
                            getFloat64: function (e) {
                                return N(G(this, 8, e, arguments[1]), 52, 8);
                            },
                            setInt8: function (e, t) {
                                U(this, 1, e, H, t);
                            },
                            setUint8: function (e, t) {
                                U(this, 1, e, H, t);
                            },
                            setInt16: function (e, t) {
                                U(this, 2, e, q, t, arguments[2]);
                            },
                            setUint16: function (e, t) {
                                U(this, 2, e, q, t, arguments[2]);
                            },
                            setInt32: function (e, t) {
                                U(this, 4, e, V, t, arguments[2]);
                            },
                            setUint32: function (e, t) {
                                U(this, 4, e, V, t, arguments[2]);
                            },
                            setFloat32: function (e, t) {
                                U(this, 4, e, W, t, arguments[2]);
                            },
                            setFloat64: function (e, t) {
                                U(this, 8, e, Y, t, arguments[2]);
                            },
                        });
                v(S, b), v(E, y), a(E[w], o.VIEW, !0), (t[b] = S), (t[y] = E);
            },
            9383: function (e, t, i) {
                for (
                    var n,
                        r = i(3816),
                        s = i(7728),
                        o = i(3953),
                        a = o("typed_array"),
                        l = o("view"),
                        c = !(!r.ArrayBuffer || !r.DataView),
                        u = c,
                        d = 0,
                        h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");
                    d < 9;

                )
                    (n = r[h[d++]]) ? (s(n.prototype, a, !0), s(n.prototype, l, !0)) : (u = !1);
                e.exports = { ABV: c, CONSTR: u, TYPED: a, VIEW: l };
            },
            3953: function (e) {
                var t = 0,
                    i = Math.random();
                e.exports = function (e) {
                    return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++t + i).toString(36));
                };
            },
            575: function (e, t, i) {
                var n = i(3816).navigator;
                e.exports = (n && n.userAgent) || "";
            },
            1616: function (e, t, i) {
                var n = i(5286);
                e.exports = function (e, t) {
                    if (!n(e) || e._t !== t) throw TypeError("Incompatible receiver, " + t + " required!");
                    return e;
                };
            },
            6074: function (e, t, i) {
                var n = i(3816),
                    r = i(5645),
                    s = i(4461),
                    o = i(8787),
                    a = i(9275).f;
                e.exports = function (e) {
                    var t = r.Symbol || (r.Symbol = s ? {} : n.Symbol || {});
                    "_" == e.charAt(0) || e in t || a(t, e, { value: o.f(e) });
                };
            },
            8787: function (e, t, i) {
                t.f = i(6314);
            },
            6314: function (e, t, i) {
                var n = i(3825)("wks"),
                    r = i(3953),
                    s = i(3816).Symbol,
                    o = "function" == typeof s;
                (e.exports = function (e) {
                    return n[e] || (n[e] = (o && s[e]) || (o ? s : r)("Symbol." + e));
                }).store = n;
            },
            9002: function (e, t, i) {
                var n = i(1488),
                    r = i(6314)("iterator"),
                    s = i(2803);
                e.exports = i(5645).getIteratorMethod = function (e) {
                    if (null != e) return e[r] || e["@@iterator"] || s[n(e)];
                };
            },
            2e3: function (e, t, i) {
                var n = i(2985);
                n(n.P, "Array", { copyWithin: i(5216) }), i(7722)("copyWithin");
            },
            5745: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(4);
                n(n.P + n.F * !i(7717)([].every, !0), "Array", {
                    every: function (e) {
                        return r(this, e, arguments[1]);
                    },
                });
            },
            8977: function (e, t, i) {
                var n = i(2985);
                n(n.P, "Array", { fill: i(6852) }), i(7722)("fill");
            },
            8837: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(2);
                n(n.P + n.F * !i(7717)([].filter, !0), "Array", {
                    filter: function (e) {
                        return r(this, e, arguments[1]);
                    },
                });
            },
            4899: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(6),
                    s = "findIndex",
                    o = !0;
                s in [] &&
                    Array(1)[s](function () {
                        o = !1;
                    }),
                    n(n.P + n.F * o, "Array", {
                        findIndex: function (e) {
                            return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
                        },
                    }),
                    i(7722)(s);
            },
            2310: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(5),
                    s = "find",
                    o = !0;
                s in [] &&
                    Array(1)[s](function () {
                        o = !1;
                    }),
                    n(n.P + n.F * o, "Array", {
                        find: function (e) {
                            return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
                        },
                    }),
                    i(7722)(s);
            },
            4336: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(0),
                    s = i(7717)([].forEach, !0);
                n(n.P + n.F * !s, "Array", {
                    forEach: function (e) {
                        return r(this, e, arguments[1]);
                    },
                });
            },
            522: function (e, t, i) {
                "use strict";
                var n = i(741),
                    r = i(2985),
                    s = i(508),
                    o = i(8851),
                    a = i(6555),
                    l = i(875),
                    c = i(2811),
                    u = i(9002);
                r(
                    r.S +
                        r.F *
                            !i(7462)(function (e) {
                                Array.from(e);
                            }),
                    "Array",
                    {
                        from: function (e) {
                            var t,
                                i,
                                r,
                                d,
                                h = s(e),
                                f = "function" == typeof this ? this : Array,
                                p = arguments.length,
                                m = p > 1 ? arguments[1] : void 0,
                                g = void 0 !== m,
                                v = 0,
                                b = u(h);
                            if ((g && (m = n(m, p > 2 ? arguments[2] : void 0, 2)), null == b || (f == Array && a(b)))) for (i = new f((t = l(h.length))); t > v; v++) c(i, v, g ? m(h[v], v) : h[v]);
                            else for (d = b.call(h), i = new f(); !(r = d.next()).done; v++) c(i, v, g ? o(d, m, [r.value, v], !0) : r.value);
                            return (i.length = v), i;
                        },
                    }
                );
            },
            3369: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(9315)(!1),
                    s = [].indexOf,
                    o = !!s && 1 / [1].indexOf(1, -0) < 0;
                n(n.P + n.F * (o || !i(7717)(s)), "Array", {
                    indexOf: function (e) {
                        return o ? s.apply(this, arguments) || 0 : r(this, e, arguments[1]);
                    },
                });
            },
            774: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Array", { isArray: i(4302) });
            },
            6997: function (e, t, i) {
                "use strict";
                var n = i(7722),
                    r = i(5436),
                    s = i(2803),
                    o = i(2110);
                (e.exports = i(2923)(
                    Array,
                    "Array",
                    function (e, t) {
                        (this._t = o(e)), (this._i = 0), (this._k = t);
                    },
                    function () {
                        var e = this._t,
                            t = this._k,
                            i = this._i++;
                        return !e || i >= e.length ? ((this._t = void 0), r(1)) : r(0, "keys" == t ? i : "values" == t ? e[i] : [i, e[i]]);
                    },
                    "values"
                )),
                    (s.Arguments = s.Array),
                    n("keys"),
                    n("values"),
                    n("entries");
            },
            7842: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(2110),
                    s = [].join;
                n(n.P + n.F * (i(9797) != Object || !i(7717)(s)), "Array", {
                    join: function (e) {
                        return s.call(r(this), void 0 === e ? "," : e);
                    },
                });
            },
            9564: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(2110),
                    s = i(1467),
                    o = i(875),
                    a = [].lastIndexOf,
                    l = !!a && 1 / [1].lastIndexOf(1, -0) < 0;
                n(n.P + n.F * (l || !i(7717)(a)), "Array", {
                    lastIndexOf: function (e) {
                        if (l) return a.apply(this, arguments) || 0;
                        var t = r(this),
                            i = o(t.length),
                            n = i - 1;
                        for (arguments.length > 1 && (n = Math.min(n, s(arguments[1]))), n < 0 && (n = i + n); n >= 0; n--) if (n in t && t[n] === e) return n || 0;
                        return -1;
                    },
                });
            },
            1802: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(1);
                n(n.P + n.F * !i(7717)([].map, !0), "Array", {
                    map: function (e) {
                        return r(this, e, arguments[1]);
                    },
                });
            },
            8295: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(2811);
                n(
                    n.S +
                        n.F *
                            i(4253)(function () {
                                function e() {}
                                return !(Array.of.call(e) instanceof e);
                            }),
                    "Array",
                    {
                        of: function () {
                            for (var e = 0, t = arguments.length, i = new ("function" == typeof this ? this : Array)(t); t > e; ) r(i, e, arguments[e++]);
                            return (i.length = t), i;
                        },
                    }
                );
            },
            3750: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(7628);
                n(n.P + n.F * !i(7717)([].reduceRight, !0), "Array", {
                    reduceRight: function (e) {
                        return r(this, e, arguments.length, arguments[1], !0);
                    },
                });
            },
            3057: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(7628);
                n(n.P + n.F * !i(7717)([].reduce, !0), "Array", {
                    reduce: function (e) {
                        return r(this, e, arguments.length, arguments[1], !1);
                    },
                });
            },
            110: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(639),
                    s = i(2032),
                    o = i(2337),
                    a = i(875),
                    l = [].slice;
                n(
                    n.P +
                        n.F *
                            i(4253)(function () {
                                r && l.call(r);
                            }),
                    "Array",
                    {
                        slice: function (e, t) {
                            var i = a(this.length),
                                n = s(this);
                            if (((t = void 0 === t ? i : t), "Array" == n)) return l.call(this, e, t);
                            for (var r = o(e, i), c = o(t, i), u = a(c - r), d = new Array(u), h = 0; h < u; h++) d[h] = "String" == n ? this.charAt(r + h) : this[r + h];
                            return d;
                        },
                    }
                );
            },
            6773: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(50)(3);
                n(n.P + n.F * !i(7717)([].some, !0), "Array", {
                    some: function (e) {
                        return r(this, e, arguments[1]);
                    },
                });
            },
            75: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(4963),
                    s = i(508),
                    o = i(4253),
                    a = [].sort,
                    l = [1, 2, 3];
                n(
                    n.P +
                        n.F *
                            (o(function () {
                                l.sort(void 0);
                            }) ||
                                !o(function () {
                                    l.sort(null);
                                }) ||
                                !i(7717)(a)),
                    "Array",
                    {
                        sort: function (e) {
                            return void 0 === e ? a.call(s(this)) : a.call(s(this), r(e));
                        },
                    }
                );
            },
            1842: function (e, t, i) {
                i(2974)("Array");
            },
            1822: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Date", {
                    now: function () {
                        return new Date().getTime();
                    },
                });
            },
            1031: function (e, t, i) {
                var n = i(2985),
                    r = i(3537);
                n(n.P + n.F * (Date.prototype.toISOString !== r), "Date", { toISOString: r });
            },
            9977: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(508),
                    s = i(1689);
                n(
                    n.P +
                        n.F *
                            i(4253)(function () {
                                return (
                                    null !== new Date(NaN).toJSON() ||
                                    1 !==
                                        Date.prototype.toJSON.call({
                                            toISOString: function () {
                                                return 1;
                                            },
                                        })
                                );
                            }),
                    "Date",
                    {
                        toJSON: function (e) {
                            var t = r(this),
                                i = s(t);
                            return "number" != typeof i || isFinite(i) ? t.toISOString() : null;
                        },
                    }
                );
            },
            1560: function (e, t, i) {
                var n = i(6314)("toPrimitive"),
                    r = Date.prototype;
                n in r || i(7728)(r, n, i(870));
            },
            6331: function (e, t, i) {
                var n = Date.prototype,
                    r = "Invalid Date",
                    s = "toString",
                    o = n[s],
                    a = n.getTime;
                new Date(NaN) + "" != r &&
                    i(7234)(n, s, function () {
                        var e = a.call(this);
                        return e == e ? o.call(this) : r;
                    });
            },
            9730: function (e, t, i) {
                var n = i(2985);
                n(n.P, "Function", { bind: i(4398) });
            },
            8377: function (e, t, i) {
                "use strict";
                var n = i(5286),
                    r = i(468),
                    s = i(6314)("hasInstance"),
                    o = Function.prototype;
                s in o ||
                    i(9275).f(o, s, {
                        value: function (e) {
                            if ("function" != typeof this || !n(e)) return !1;
                            if (!n(this.prototype)) return e instanceof this;
                            for (; (e = r(e)); ) if (this.prototype === e) return !0;
                            return !1;
                        },
                    });
            },
            6059: function (e, t, i) {
                var n = i(9275).f,
                    r = Function.prototype,
                    s = /^\s*function ([^ (]*)/,
                    o = "name";
                o in r ||
                    (i(7057) &&
                        n(r, o, {
                            configurable: !0,
                            get: function () {
                                try {
                                    return ("" + this).match(s)[1];
                                } catch (e) {
                                    return "";
                                }
                            },
                        }));
            },
            8416: function (e, t, i) {
                "use strict";
                var n = i(9824),
                    r = i(1616),
                    s = "Map";
                e.exports = i(5795)(
                    s,
                    function (e) {
                        return function () {
                            return e(this, arguments.length > 0 ? arguments[0] : void 0);
                        };
                    },
                    {
                        get: function (e) {
                            var t = n.getEntry(r(this, s), e);
                            return t && t.v;
                        },
                        set: function (e, t) {
                            return n.def(r(this, s), 0 === e ? 0 : e, t);
                        },
                    },
                    n,
                    !0
                );
            },
            6503: function (e, t, i) {
                var n = i(2985),
                    r = i(6206),
                    s = Math.sqrt,
                    o = Math.acosh;
                n(n.S + n.F * !(o && 710 == Math.floor(o(Number.MAX_VALUE)) && o(1 / 0) == 1 / 0), "Math", {
                    acosh: function (e) {
                        return (e = +e) < 1 ? NaN : e > 94906265.62425156 ? Math.log(e) + Math.LN2 : r(e - 1 + s(e - 1) * s(e + 1));
                    },
                });
            },
            6786: function (e, t, i) {
                var n = i(2985),
                    r = Math.asinh;
                n(n.S + n.F * !(r && 1 / r(0) > 0), "Math", {
                    asinh: function e(t) {
                        return isFinite((t = +t)) && 0 != t ? (t < 0 ? -e(-t) : Math.log(t + Math.sqrt(t * t + 1))) : t;
                    },
                });
            },
            932: function (e, t, i) {
                var n = i(2985),
                    r = Math.atanh;
                n(n.S + n.F * !(r && 1 / r(-0) < 0), "Math", {
                    atanh: function (e) {
                        return 0 == (e = +e) ? e : Math.log((1 + e) / (1 - e)) / 2;
                    },
                });
            },
            7526: function (e, t, i) {
                var n = i(2985),
                    r = i(1801);
                n(n.S, "Math", {
                    cbrt: function (e) {
                        return r((e = +e)) * Math.pow(Math.abs(e), 1 / 3);
                    },
                });
            },
            1591: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", {
                    clz32: function (e) {
                        return (e >>>= 0) ? 31 - Math.floor(Math.log(e + 0.5) * Math.LOG2E) : 32;
                    },
                });
            },
            9073: function (e, t, i) {
                var n = i(2985),
                    r = Math.exp;
                n(n.S, "Math", {
                    cosh: function (e) {
                        return (r((e = +e)) + r(-e)) / 2;
                    },
                });
            },
            347: function (e, t, i) {
                var n = i(2985),
                    r = i(3086);
                n(n.S + n.F * (r != Math.expm1), "Math", { expm1: r });
            },
            579: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", { fround: i(4934) });
            },
            4669: function (e, t, i) {
                var n = i(2985),
                    r = Math.abs;
                n(n.S, "Math", {
                    hypot: function (e, t) {
                        for (var i, n, s = 0, o = 0, a = arguments.length, l = 0; o < a; ) l < (i = r(arguments[o++])) ? ((s = s * (n = l / i) * n + 1), (l = i)) : (s += i > 0 ? (n = i / l) * n : i);
                        return l === 1 / 0 ? 1 / 0 : l * Math.sqrt(s);
                    },
                });
            },
            7710: function (e, t, i) {
                var n = i(2985),
                    r = Math.imul;
                n(
                    n.S +
                        n.F *
                            i(4253)(function () {
                                return -5 != r(4294967295, 5) || 2 != r.length;
                            }),
                    "Math",
                    {
                        imul: function (e, t) {
                            var i = 65535,
                                n = +e,
                                r = +t,
                                s = i & n,
                                o = i & r;
                            return 0 | (s * o + ((((i & (n >>> 16)) * o + s * (i & (r >>> 16))) << 16) >>> 0));
                        },
                    }
                );
            },
            5789: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", {
                    log10: function (e) {
                        return Math.log(e) * Math.LOG10E;
                    },
                });
            },
            3514: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", { log1p: i(6206) });
            },
            9978: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", {
                    log2: function (e) {
                        return Math.log(e) / Math.LN2;
                    },
                });
            },
            8472: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", { sign: i(1801) });
            },
            6946: function (e, t, i) {
                var n = i(2985),
                    r = i(3086),
                    s = Math.exp;
                n(
                    n.S +
                        n.F *
                            i(4253)(function () {
                                return -2e-17 != !Math.sinh(-2e-17);
                            }),
                    "Math",
                    {
                        sinh: function (e) {
                            return Math.abs((e = +e)) < 1 ? (r(e) - r(-e)) / 2 : (s(e - 1) - s(-e - 1)) * (Math.E / 2);
                        },
                    }
                );
            },
            5068: function (e, t, i) {
                var n = i(2985),
                    r = i(3086),
                    s = Math.exp;
                n(n.S, "Math", {
                    tanh: function (e) {
                        var t = r((e = +e)),
                            i = r(-e);
                        return t == 1 / 0 ? 1 : i == 1 / 0 ? -1 : (t - i) / (s(e) + s(-e));
                    },
                });
            },
            413: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Math", {
                    trunc: function (e) {
                        return (e > 0 ? Math.floor : Math.ceil)(e);
                    },
                });
            },
            1246: function (e, t, i) {
                "use strict";
                var n = i(3816),
                    r = i(9181),
                    s = i(2032),
                    o = i(266),
                    a = i(1689),
                    l = i(4253),
                    c = i(616).f,
                    u = i(8693).f,
                    d = i(9275).f,
                    h = i(9599).trim,
                    f = "Number",
                    p = n[f],
                    m = p,
                    g = p.prototype,
                    v = s(i(2503)(g)) == f,
                    b = "trim" in String.prototype,
                    y = function (e) {
                        var t = a(e, !1);
                        if ("string" == typeof t && t.length > 2) {
                            var i,
                                n,
                                r,
                                s = (t = b ? t.trim() : h(t, 3)).charCodeAt(0);
                            if (43 === s || 45 === s) {
                                if (88 === (i = t.charCodeAt(2)) || 120 === i) return NaN;
                            } else if (48 === s) {
                                switch (t.charCodeAt(1)) {
                                    case 66:
                                    case 98:
                                        (n = 2), (r = 49);
                                        break;
                                    case 79:
                                    case 111:
                                        (n = 8), (r = 55);
                                        break;
                                    default:
                                        return +t;
                                }
                                for (var o, l = t.slice(2), c = 0, u = l.length; c < u; c++) if ((o = l.charCodeAt(c)) < 48 || o > r) return NaN;
                                return parseInt(l, n);
                            }
                        }
                        return +t;
                    };
                if (!p(" 0o1") || !p("0b1") || p("+0x1")) {
                    p = function (e) {
                        var t = arguments.length < 1 ? 0 : e,
                            i = this;
                        return i instanceof p &&
                            (v
                                ? l(function () {
                                      g.valueOf.call(i);
                                  })
                                : s(i) != f)
                            ? o(new m(y(t)), i, p)
                            : y(t);
                    };
                    for (
                        var w,
                            x = i(7057) ? c(m) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),
                            S = 0;
                        x.length > S;
                        S++
                    )
                        r(m, (w = x[S])) && !r(p, w) && d(p, w, u(m, w));
                    (p.prototype = g), (g.constructor = p), i(7234)(n, f, p);
                }
            },
            5972: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Number", { EPSILON: Math.pow(2, -52) });
            },
            3403: function (e, t, i) {
                var n = i(2985),
                    r = i(3816).isFinite;
                n(n.S, "Number", {
                    isFinite: function (e) {
                        return "number" == typeof e && r(e);
                    },
                });
            },
            2516: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Number", { isInteger: i(8367) });
            },
            9371: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Number", {
                    isNaN: function (e) {
                        return e != e;
                    },
                });
            },
            6479: function (e, t, i) {
                var n = i(2985),
                    r = i(8367),
                    s = Math.abs;
                n(n.S, "Number", {
                    isSafeInteger: function (e) {
                        return r(e) && s(e) <= 9007199254740991;
                    },
                });
            },
            1736: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 });
            },
            1889: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 });
            },
            5177: function (e, t, i) {
                var n = i(2985),
                    r = i(7743);
                n(n.S + n.F * (Number.parseFloat != r), "Number", { parseFloat: r });
            },
            6943: function (e, t, i) {
                var n = i(2985),
                    r = i(5960);
                n(n.S + n.F * (Number.parseInt != r), "Number", { parseInt: r });
            },
            726: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(1467),
                    s = i(3365),
                    o = i(8595),
                    a = (1).toFixed,
                    l = Math.floor,
                    c = [0, 0, 0, 0, 0, 0],
                    u = "Number.toFixed: incorrect invocation!",
                    d = "0",
                    h = function (e, t) {
                        for (var i = -1, n = t; ++i < 6; ) (n += e * c[i]), (c[i] = n % 1e7), (n = l(n / 1e7));
                    },
                    f = function (e) {
                        for (var t = 6, i = 0; --t >= 0; ) (i += c[t]), (c[t] = l(i / e)), (i = (i % e) * 1e7);
                    },
                    p = function () {
                        for (var e = 6, t = ""; --e >= 0; )
                            if ("" !== t || 0 === e || 0 !== c[e]) {
                                var i = String(c[e]);
                                t = "" === t ? i : t + o.call(d, 7 - i.length) + i;
                            }
                        return t;
                    },
                    m = function (e, t, i) {
                        return 0 === t ? i : t % 2 == 1 ? m(e, t - 1, i * e) : m(e * e, t / 2, i);
                    };
                n(
                    n.P +
                        n.F *
                            ((!!a && ("0.000" !== (8e-5).toFixed(3) || "1" !== (0.9).toFixed(0) || "1.25" !== (1.255).toFixed(2) || "1000000000000000128" !== (0xde0b6b3a7640080).toFixed(0))) ||
                                !i(4253)(function () {
                                    a.call({});
                                })),
                    "Number",
                    {
                        toFixed: function (e) {
                            var t,
                                i,
                                n,
                                a,
                                l = s(this, u),
                                c = r(e),
                                g = "",
                                v = d;
                            if (c < 0 || c > 20) throw RangeError(u);
                            if (l != l) return "NaN";
                            if (l <= -1e21 || l >= 1e21) return String(l);
                            if ((l < 0 && ((g = "-"), (l = -l)), l > 1e-21))
                                if (
                                    ((t =
                                        (function (e) {
                                            for (var t = 0, i = e; i >= 4096; ) (t += 12), (i /= 4096);
                                            for (; i >= 2; ) (t += 1), (i /= 2);
                                            return t;
                                        })(l * m(2, 69, 1)) - 69),
                                    (i = t < 0 ? l * m(2, -t, 1) : l / m(2, t, 1)),
                                    (i *= 4503599627370496),
                                    (t = 52 - t) > 0)
                                ) {
                                    for (h(0, i), n = c; n >= 7; ) h(1e7, 0), (n -= 7);
                                    for (h(m(10, n, 1), 0), n = t - 1; n >= 23; ) f(1 << 23), (n -= 23);
                                    f(1 << n), h(1, 1), f(2), (v = p());
                                } else h(0, i), h(1 << -t, 0), (v = p() + o.call(d, c));
                            return c > 0 ? g + ((a = v.length) <= c ? "0." + o.call(d, c - a) + v : v.slice(0, a - c) + "." + v.slice(a - c)) : g + v;
                        },
                    }
                );
            },
            1901: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(4253),
                    s = i(3365),
                    o = (1).toPrecision;
                n(
                    n.P +
                        n.F *
                            (r(function () {
                                return "1" !== o.call(1, void 0);
                            }) ||
                                !r(function () {
                                    o.call({});
                                })),
                    "Number",
                    {
                        toPrecision: function (e) {
                            var t = s(this, "Number#toPrecision: incorrect invocation!");
                            return void 0 === e ? o.call(t) : o.call(t, e);
                        },
                    }
                );
            },
            5115: function (e, t, i) {
                var n = i(2985);
                n(n.S + n.F, "Object", { assign: i(5345) });
            },
            8132: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Object", { create: i(2503) });
            },
            7470: function (e, t, i) {
                var n = i(2985);
                n(n.S + n.F * !i(7057), "Object", { defineProperties: i(5588) });
            },
            8388: function (e, t, i) {
                var n = i(2985);
                n(n.S + n.F * !i(7057), "Object", { defineProperty: i(9275).f });
            },
            9375: function (e, t, i) {
                var n = i(5286),
                    r = i(4728).onFreeze;
                i(3160)("freeze", function (e) {
                    return function (t) {
                        return e && n(t) ? e(r(t)) : t;
                    };
                });
            },
            4882: function (e, t, i) {
                var n = i(2110),
                    r = i(8693).f;
                i(3160)("getOwnPropertyDescriptor", function () {
                    return function (e, t) {
                        return r(n(e), t);
                    };
                });
            },
            9622: function (e, t, i) {
                i(3160)("getOwnPropertyNames", function () {
                    return i(9327).f;
                });
            },
            1520: function (e, t, i) {
                var n = i(508),
                    r = i(468);
                i(3160)("getPrototypeOf", function () {
                    return function (e) {
                        return r(n(e));
                    };
                });
            },
            9892: function (e, t, i) {
                var n = i(5286);
                i(3160)("isExtensible", function (e) {
                    return function (t) {
                        return !!n(t) && (!e || e(t));
                    };
                });
            },
            4157: function (e, t, i) {
                var n = i(5286);
                i(3160)("isFrozen", function (e) {
                    return function (t) {
                        return !n(t) || (!!e && e(t));
                    };
                });
            },
            5095: function (e, t, i) {
                var n = i(5286);
                i(3160)("isSealed", function (e) {
                    return function (t) {
                        return !n(t) || (!!e && e(t));
                    };
                });
            },
            9176: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Object", { is: i(7195) });
            },
            7476: function (e, t, i) {
                var n = i(508),
                    r = i(7184);
                i(3160)("keys", function () {
                    return function (e) {
                        return r(n(e));
                    };
                });
            },
            4672: function (e, t, i) {
                var n = i(5286),
                    r = i(4728).onFreeze;
                i(3160)("preventExtensions", function (e) {
                    return function (t) {
                        return e && n(t) ? e(r(t)) : t;
                    };
                });
            },
            3533: function (e, t, i) {
                var n = i(5286),
                    r = i(4728).onFreeze;
                i(3160)("seal", function (e) {
                    return function (t) {
                        return e && n(t) ? e(r(t)) : t;
                    };
                });
            },
            8838: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Object", { setPrototypeOf: i(7375).set });
            },
            6253: function (e, t, i) {
                "use strict";
                var n = i(1488),
                    r = {};
                (r[i(6314)("toStringTag")] = "z"),
                    r + "" != "[object z]" &&
                        i(7234)(
                            Object.prototype,
                            "toString",
                            function () {
                                return "[object " + n(this) + "]";
                            },
                            !0
                        );
            },
            4299: function (e, t, i) {
                var n = i(2985),
                    r = i(7743);
                n(n.G + n.F * (parseFloat != r), { parseFloat: r });
            },
            1084: function (e, t, i) {
                var n = i(2985),
                    r = i(5960);
                n(n.G + n.F * (parseInt != r), { parseInt: r });
            },
            851: function (e, t, i) {
                "use strict";
                var n,
                    r,
                    s,
                    o,
                    a = i(4461),
                    l = i(3816),
                    c = i(741),
                    u = i(1488),
                    d = i(2985),
                    h = i(5286),
                    f = i(4963),
                    p = i(3328),
                    m = i(3531),
                    g = i(8364),
                    v = i(4193).set,
                    b = i(4351)(),
                    y = i(3499),
                    w = i(188),
                    x = i(575),
                    S = i(94),
                    E = "Promise",
                    _ = l.TypeError,
                    T = l.process,
                    M = T && T.versions,
                    P = (M && M.v8) || "",
                    C = l[E],
                    O = "process" == u(T),
                    L = function () {},
                    k = (r = y.f),
                    A = !!(function () {
                        try {
                            var e = C.resolve(1),
                                t = ((e.constructor = {})[i(6314)("species")] = function (e) {
                                    e(L, L);
                                });
                            return (O || "function" == typeof PromiseRejectionEvent) && e.then(L) instanceof t && 0 !== P.indexOf("6.6") && -1 === x.indexOf("Chrome/66");
                        } catch (e) {}
                    })(),
                    I = function (e) {
                        var t;
                        return !(!h(e) || "function" != typeof (t = e.then)) && t;
                    },
                    z = function (e, t) {
                        if (!e._n) {
                            e._n = !0;
                            var i = e._c;
                            b(function () {
                                for (
                                    var n = e._v,
                                        r = 1 == e._s,
                                        s = 0,
                                        o = function (t) {
                                            var i,
                                                s,
                                                o,
                                                a = r ? t.ok : t.fail,
                                                l = t.resolve,
                                                c = t.reject,
                                                u = t.domain;
                                            try {
                                                a
                                                    ? (r || (2 == e._h && R(e), (e._h = 1)),
                                                      !0 === a ? (i = n) : (u && u.enter(), (i = a(n)), u && (u.exit(), (o = !0))),
                                                      i === t.promise ? c(_("Promise-chain cycle")) : (s = I(i)) ? s.call(i, l, c) : l(i))
                                                    : c(n);
                                            } catch (e) {
                                                u && !o && u.exit(), c(e);
                                            }
                                        };
                                    i.length > s;

                                )
                                    o(i[s++]);
                                (e._c = []), (e._n = !1), t && !e._h && D(e);
                            });
                        }
                    },
                    D = function (e) {
                        v.call(l, function () {
                            var t,
                                i,
                                n,
                                r = e._v,
                                s = j(e);
                            if (
                                (s &&
                                    ((t = w(function () {
                                        O ? T.emit("unhandledRejection", r, e) : (i = l.onunhandledrejection) ? i({ promise: e, reason: r }) : (n = l.console) && n.error && n.error("Unhandled promise rejection", r);
                                    })),
                                    (e._h = O || j(e) ? 2 : 1)),
                                (e._a = void 0),
                                s && t.e)
                            )
                                throw t.v;
                        });
                    },
                    j = function (e) {
                        return 1 !== e._h && 0 === (e._a || e._c).length;
                    },
                    R = function (e) {
                        v.call(l, function () {
                            var t;
                            O ? T.emit("rejectionHandled", e) : (t = l.onrejectionhandled) && t({ promise: e, reason: e._v });
                        });
                    },
                    F = function (e) {
                        var t = this;
                        t._d || ((t._d = !0), ((t = t._w || t)._v = e), (t._s = 2), t._a || (t._a = t._c.slice()), z(t, !0));
                    },
                    $ = function (e) {
                        var t,
                            i = this;
                        if (!i._d) {
                            (i._d = !0), (i = i._w || i);
                            try {
                                if (i === e) throw _("Promise can't be resolved itself");
                                (t = I(e))
                                    ? b(function () {
                                          var n = { _w: i, _d: !1 };
                                          try {
                                              t.call(e, c($, n, 1), c(F, n, 1));
                                          } catch (e) {
                                              F.call(n, e);
                                          }
                                      })
                                    : ((i._v = e), (i._s = 1), z(i, !1));
                            } catch (e) {
                                F.call({ _w: i, _d: !1 }, e);
                            }
                        }
                    };
                A ||
                    ((C = function (e) {
                        p(this, C, E, "_h"), f(e), n.call(this);
                        try {
                            e(c($, this, 1), c(F, this, 1));
                        } catch (e) {
                            F.call(this, e);
                        }
                    }),
                    ((n = function (e) {
                        (this._c = []), (this._a = void 0), (this._s = 0), (this._d = !1), (this._v = void 0), (this._h = 0), (this._n = !1);
                    }).prototype = i(4408)(C.prototype, {
                        then: function (e, t) {
                            var i = k(g(this, C));
                            return (i.ok = "function" != typeof e || e), (i.fail = "function" == typeof t && t), (i.domain = O ? T.domain : void 0), this._c.push(i), this._a && this._a.push(i), this._s && z(this, !1), i.promise;
                        },
                        catch: function (e) {
                            return this.then(void 0, e);
                        },
                    })),
                    (s = function () {
                        var e = new n();
                        (this.promise = e), (this.resolve = c($, e, 1)), (this.reject = c(F, e, 1));
                    }),
                    (y.f = k = function (e) {
                        return e === C || e === o ? new s(e) : r(e);
                    })),
                    d(d.G + d.W + d.F * !A, { Promise: C }),
                    i(2943)(C, E),
                    i(2974)(E),
                    (o = i(5645)[E]),
                    d(d.S + d.F * !A, E, {
                        reject: function (e) {
                            var t = k(this);
                            return (0, t.reject)(e), t.promise;
                        },
                    }),
                    d(d.S + d.F * (a || !A), E, {
                        resolve: function (e) {
                            return S(a && this === o ? C : this, e);
                        },
                    }),
                    d(
                        d.S +
                            d.F *
                                !(
                                    A &&
                                    i(7462)(function (e) {
                                        C.all(e).catch(L);
                                    })
                                ),
                        E,
                        {
                            all: function (e) {
                                var t = this,
                                    i = k(t),
                                    n = i.resolve,
                                    r = i.reject,
                                    s = w(function () {
                                        var i = [],
                                            s = 0,
                                            o = 1;
                                        m(e, !1, function (e) {
                                            var a = s++,
                                                l = !1;
                                            i.push(void 0),
                                                o++,
                                                t.resolve(e).then(function (e) {
                                                    l || ((l = !0), (i[a] = e), --o || n(i));
                                                }, r);
                                        }),
                                            --o || n(i);
                                    });
                                return s.e && r(s.v), i.promise;
                            },
                            race: function (e) {
                                var t = this,
                                    i = k(t),
                                    n = i.reject,
                                    r = w(function () {
                                        m(e, !1, function (e) {
                                            t.resolve(e).then(i.resolve, n);
                                        });
                                    });
                                return r.e && n(r.v), i.promise;
                            },
                        }
                    );
            },
            1572: function (e, t, i) {
                var n = i(2985),
                    r = i(4963),
                    s = i(7007),
                    o = (i(3816).Reflect || {}).apply,
                    a = Function.apply;
                n(
                    n.S +
                        n.F *
                            !i(4253)(function () {
                                o(function () {});
                            }),
                    "Reflect",
                    {
                        apply: function (e, t, i) {
                            var n = r(e),
                                l = s(i);
                            return o ? o(n, t, l) : a.call(n, t, l);
                        },
                    }
                );
            },
            2139: function (e, t, i) {
                var n = i(2985),
                    r = i(2503),
                    s = i(4963),
                    o = i(7007),
                    a = i(5286),
                    l = i(4253),
                    c = i(4398),
                    u = (i(3816).Reflect || {}).construct,
                    d = l(function () {
                        function e() {}
                        return !(u(function () {}, [], e) instanceof e);
                    }),
                    h = !l(function () {
                        u(function () {});
                    });
                n(n.S + n.F * (d || h), "Reflect", {
                    construct: function (e, t) {
                        s(e), o(t);
                        var i = arguments.length < 3 ? e : s(arguments[2]);
                        if (h && !d) return u(e, t, i);
                        if (e == i) {
                            switch (t.length) {
                                case 0:
                                    return new e();
                                case 1:
                                    return new e(t[0]);
                                case 2:
                                    return new e(t[0], t[1]);
                                case 3:
                                    return new e(t[0], t[1], t[2]);
                                case 4:
                                    return new e(t[0], t[1], t[2], t[3]);
                            }
                            var n = [null];
                            return n.push.apply(n, t), new (c.apply(e, n))();
                        }
                        var l = i.prototype,
                            f = r(a(l) ? l : Object.prototype),
                            p = Function.apply.call(e, f, t);
                        return a(p) ? p : f;
                    },
                });
            },
            685: function (e, t, i) {
                var n = i(9275),
                    r = i(2985),
                    s = i(7007),
                    o = i(1689);
                r(
                    r.S +
                        r.F *
                            i(4253)(function () {
                                Reflect.defineProperty(n.f({}, 1, { value: 1 }), 1, { value: 2 });
                            }),
                    "Reflect",
                    {
                        defineProperty: function (e, t, i) {
                            s(e), (t = o(t, !0)), s(i);
                            try {
                                return n.f(e, t, i), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                    }
                );
            },
            5535: function (e, t, i) {
                var n = i(2985),
                    r = i(8693).f,
                    s = i(7007);
                n(n.S, "Reflect", {
                    deleteProperty: function (e, t) {
                        var i = r(s(e), t);
                        return !(i && !i.configurable) && delete e[t];
                    },
                });
            },
            7347: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(7007),
                    s = function (e) {
                        (this._t = r(e)), (this._i = 0);
                        var t,
                            i = (this._k = []);
                        for (t in e) i.push(t);
                    };
                i(9988)(s, "Object", function () {
                    var e,
                        t = this,
                        i = t._k;
                    do {
                        if (t._i >= i.length) return { value: void 0, done: !0 };
                    } while (!((e = i[t._i++]) in t._t));
                    return { value: e, done: !1 };
                }),
                    n(n.S, "Reflect", {
                        enumerate: function (e) {
                            return new s(e);
                        },
                    });
            },
            6633: function (e, t, i) {
                var n = i(8693),
                    r = i(2985),
                    s = i(7007);
                r(r.S, "Reflect", {
                    getOwnPropertyDescriptor: function (e, t) {
                        return n.f(s(e), t);
                    },
                });
            },
            8989: function (e, t, i) {
                var n = i(2985),
                    r = i(468),
                    s = i(7007);
                n(n.S, "Reflect", {
                    getPrototypeOf: function (e) {
                        return r(s(e));
                    },
                });
            },
            3049: function (e, t, i) {
                var n = i(8693),
                    r = i(468),
                    s = i(9181),
                    o = i(2985),
                    a = i(5286),
                    l = i(7007);
                o(o.S, "Reflect", {
                    get: function e(t, i) {
                        var o,
                            c,
                            u = arguments.length < 3 ? t : arguments[2];
                        return l(t) === u ? t[i] : (o = n.f(t, i)) ? (s(o, "value") ? o.value : void 0 !== o.get ? o.get.call(u) : void 0) : a((c = r(t))) ? e(c, i, u) : void 0;
                    },
                });
            },
            8270: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Reflect", {
                    has: function (e, t) {
                        return t in e;
                    },
                });
            },
            4510: function (e, t, i) {
                var n = i(2985),
                    r = i(7007),
                    s = Object.isExtensible;
                n(n.S, "Reflect", {
                    isExtensible: function (e) {
                        return r(e), !s || s(e);
                    },
                });
            },
            3984: function (e, t, i) {
                var n = i(2985);
                n(n.S, "Reflect", { ownKeys: i(7643) });
            },
            5769: function (e, t, i) {
                var n = i(2985),
                    r = i(7007),
                    s = Object.preventExtensions;
                n(n.S, "Reflect", {
                    preventExtensions: function (e) {
                        r(e);
                        try {
                            return s && s(e), !0;
                        } catch (e) {
                            return !1;
                        }
                    },
                });
            },
            6014: function (e, t, i) {
                var n = i(2985),
                    r = i(7375);
                r &&
                    n(n.S, "Reflect", {
                        setPrototypeOf: function (e, t) {
                            r.check(e, t);
                            try {
                                return r.set(e, t), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                    });
            },
            55: function (e, t, i) {
                var n = i(9275),
                    r = i(8693),
                    s = i(468),
                    o = i(9181),
                    a = i(2985),
                    l = i(681),
                    c = i(7007),
                    u = i(5286);
                a(a.S, "Reflect", {
                    set: function e(t, i, a) {
                        var d,
                            h,
                            f = arguments.length < 4 ? t : arguments[3],
                            p = r.f(c(t), i);
                        if (!p) {
                            if (u((h = s(t)))) return e(h, i, a, f);
                            p = l(0);
                        }
                        if (o(p, "value")) {
                            if (!1 === p.writable || !u(f)) return !1;
                            if ((d = r.f(f, i))) {
                                if (d.get || d.set || !1 === d.writable) return !1;
                                (d.value = a), n.f(f, i, d);
                            } else n.f(f, i, l(0, a));
                            return !0;
                        }
                        return void 0 !== p.set && (p.set.call(f, a), !0);
                    },
                });
            },
            3946: function (e, t, i) {
                var n = i(3816),
                    r = i(266),
                    s = i(9275).f,
                    o = i(616).f,
                    a = i(5364),
                    l = i(3218),
                    c = n.RegExp,
                    u = c,
                    d = c.prototype,
                    h = /a/g,
                    f = /a/g,
                    p = new c(h) !== h;
                if (
                    i(7057) &&
                    (!p ||
                        i(4253)(function () {
                            return (f[i(6314)("match")] = !1), c(h) != h || c(f) == f || "/a/i" != c(h, "i");
                        }))
                ) {
                    c = function (e, t) {
                        var i = this instanceof c,
                            n = a(e),
                            s = void 0 === t;
                        return !i && n && e.constructor === c && s ? e : r(p ? new u(n && !s ? e.source : e, t) : u((n = e instanceof c) ? e.source : e, n && s ? l.call(e) : t), i ? this : d, c);
                    };
                    for (
                        var m = function (e) {
                                (e in c) ||
                                    s(c, e, {
                                        configurable: !0,
                                        get: function () {
                                            return u[e];
                                        },
                                        set: function (t) {
                                            u[e] = t;
                                        },
                                    });
                            },
                            g = o(u),
                            v = 0;
                        g.length > v;

                    )
                        m(g[v++]);
                    (d.constructor = c), (c.prototype = d), i(7234)(n, "RegExp", c);
                }
                i(2974)("RegExp");
            },
            8269: function (e, t, i) {
                "use strict";
                var n = i(1165);
                i(2985)({ target: "RegExp", proto: !0, forced: n !== /./.exec }, { exec: n });
            },
            6774: function (e, t, i) {
                i(7057) && "g" != /./g.flags && i(9275).f(RegExp.prototype, "flags", { configurable: !0, get: i(3218) });
            },
            1466: function (e, t, i) {
                "use strict";
                var n = i(7007),
                    r = i(875),
                    s = i(6793),
                    o = i(7787);
                i(8082)("match", 1, function (e, t, i, a) {
                    return [
                        function (i) {
                            var n = e(this),
                                r = null == i ? void 0 : i[t];
                            return void 0 !== r ? r.call(i, n) : new RegExp(i)[t](String(n));
                        },
                        function (e) {
                            var t = a(i, e, this);
                            if (t.done) return t.value;
                            var l = n(e),
                                c = String(this);
                            if (!l.global) return o(l, c);
                            var u = l.unicode;
                            l.lastIndex = 0;
                            for (var d, h = [], f = 0; null !== (d = o(l, c)); ) {
                                var p = String(d[0]);
                                (h[f] = p), "" === p && (l.lastIndex = s(c, r(l.lastIndex), u)), f++;
                            }
                            return 0 === f ? null : h;
                        },
                    ];
                });
            },
            9357: function (e, t, i) {
                "use strict";
                var n = i(7007),
                    r = i(508),
                    s = i(875),
                    o = i(1467),
                    a = i(6793),
                    l = i(7787),
                    c = Math.max,
                    u = Math.min,
                    d = Math.floor,
                    h = /\$([$&`']|\d\d?|<[^>]*>)/g,
                    f = /\$([$&`']|\d\d?)/g;
                i(8082)("replace", 2, function (e, t, i, p) {
                    return [
                        function (n, r) {
                            var s = e(this),
                                o = null == n ? void 0 : n[t];
                            return void 0 !== o ? o.call(n, s, r) : i.call(String(s), n, r);
                        },
                        function (e, t) {
                            var r = p(i, e, this, t);
                            if (r.done) return r.value;
                            var d = n(e),
                                h = String(this),
                                f = "function" == typeof t;
                            f || (t = String(t));
                            var g = d.global;
                            if (g) {
                                var v = d.unicode;
                                d.lastIndex = 0;
                            }
                            for (var b = []; ; ) {
                                var y = l(d, h);
                                if (null === y) break;
                                if ((b.push(y), !g)) break;
                                "" === String(y[0]) && (d.lastIndex = a(h, s(d.lastIndex), v));
                            }
                            for (var w, x = "", S = 0, E = 0; E < b.length; E++) {
                                y = b[E];
                                for (var _ = String(y[0]), T = c(u(o(y.index), h.length), 0), M = [], P = 1; P < y.length; P++) M.push(void 0 === (w = y[P]) ? w : String(w));
                                var C = y.groups;
                                if (f) {
                                    var O = [_].concat(M, T, h);
                                    void 0 !== C && O.push(C);
                                    var L = String(t.apply(void 0, O));
                                } else L = m(_, h, T, M, C, t);
                                T >= S && ((x += h.slice(S, T) + L), (S = T + _.length));
                            }
                            return x + h.slice(S);
                        },
                    ];
                    function m(e, t, n, s, o, a) {
                        var l = n + e.length,
                            c = s.length,
                            u = f;
                        return (
                            void 0 !== o && ((o = r(o)), (u = h)),
                            i.call(a, u, function (i, r) {
                                var a;
                                switch (r.charAt(0)) {
                                    case "$":
                                        return "$";
                                    case "&":
                                        return e;
                                    case "`":
                                        return t.slice(0, n);
                                    case "'":
                                        return t.slice(l);
                                    case "<":
                                        a = o[r.slice(1, -1)];
                                        break;
                                    default:
                                        var u = +r;
                                        if (0 === u) return i;
                                        if (u > c) {
                                            var h = d(u / 10);
                                            return 0 === h ? i : h <= c ? (void 0 === s[h - 1] ? r.charAt(1) : s[h - 1] + r.charAt(1)) : i;
                                        }
                                        a = s[u - 1];
                                }
                                return void 0 === a ? "" : a;
                            })
                        );
                    }
                });
            },
            6142: function (e, t, i) {
                "use strict";
                var n = i(7007),
                    r = i(7195),
                    s = i(7787);
                i(8082)("search", 1, function (e, t, i, o) {
                    return [
                        function (i) {
                            var n = e(this),
                                r = null == i ? void 0 : i[t];
                            return void 0 !== r ? r.call(i, n) : new RegExp(i)[t](String(n));
                        },
                        function (e) {
                            var t = o(i, e, this);
                            if (t.done) return t.value;
                            var a = n(e),
                                l = String(this),
                                c = a.lastIndex;
                            r(c, 0) || (a.lastIndex = 0);
                            var u = s(a, l);
                            return r(a.lastIndex, c) || (a.lastIndex = c), null === u ? -1 : u.index;
                        },
                    ];
                });
            },
            1876: function (e, t, i) {
                "use strict";
                var n = i(5364),
                    r = i(7007),
                    s = i(8364),
                    o = i(6793),
                    a = i(875),
                    l = i(7787),
                    c = i(1165),
                    u = i(4253),
                    d = Math.min,
                    h = [].push,
                    f = "split",
                    p = "length",
                    m = "lastIndex",
                    g = 4294967295,
                    v = !u(function () {
                        RegExp(g, "y");
                    });
                i(8082)("split", 2, function (e, t, i, u) {
                    var b;
                    return (
                        (b =
                            "c" == "abbc"[f](/(b)*/)[1] || 4 != "test"[f](/(?:)/, -1)[p] || 2 != "ab"[f](/(?:ab)*/)[p] || 4 != "."[f](/(.?)(.?)/)[p] || "."[f](/()()/)[p] > 1 || ""[f](/.?/)[p]
                                ? function (e, t) {
                                      var r = String(this);
                                      if (void 0 === e && 0 === t) return [];
                                      if (!n(e)) return i.call(r, e, t);
                                      for (
                                          var s,
                                              o,
                                              a,
                                              l = [],
                                              u = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""),
                                              d = 0,
                                              f = void 0 === t ? g : t >>> 0,
                                              v = new RegExp(e.source, u + "g");
                                          (s = c.call(v, r)) && !((o = v[m]) > d && (l.push(r.slice(d, s.index)), s[p] > 1 && s.index < r[p] && h.apply(l, s.slice(1)), (a = s[0][p]), (d = o), l[p] >= f));

                                      )
                                          v[m] === s.index && v[m]++;
                                      return d === r[p] ? (!a && v.test("")) || l.push("") : l.push(r.slice(d)), l[p] > f ? l.slice(0, f) : l;
                                  }
                                : "0"[f](void 0, 0)[p]
                                ? function (e, t) {
                                      return void 0 === e && 0 === t ? [] : i.call(this, e, t);
                                  }
                                : i),
                        [
                            function (i, n) {
                                var r = e(this),
                                    s = null == i ? void 0 : i[t];
                                return void 0 !== s ? s.call(i, r, n) : b.call(String(r), i, n);
                            },
                            function (e, t) {
                                var n = u(b, e, this, t, b !== i);
                                if (n.done) return n.value;
                                var c = r(e),
                                    h = String(this),
                                    f = s(c, RegExp),
                                    p = c.unicode,
                                    m = (c.ignoreCase ? "i" : "") + (c.multiline ? "m" : "") + (c.unicode ? "u" : "") + (v ? "y" : "g"),
                                    y = new f(v ? c : "^(?:" + c.source + ")", m),
                                    w = void 0 === t ? g : t >>> 0;
                                if (0 === w) return [];
                                if (0 === h.length) return null === l(y, h) ? [h] : [];
                                for (var x = 0, S = 0, E = []; S < h.length; ) {
                                    y.lastIndex = v ? S : 0;
                                    var _,
                                        T = l(y, v ? h : h.slice(S));
                                    if (null === T || (_ = d(a(y.lastIndex + (v ? 0 : S)), h.length)) === x) S = o(h, S, p);
                                    else {
                                        if ((E.push(h.slice(x, S)), E.length === w)) return E;
                                        for (var M = 1; M <= T.length - 1; M++) if ((E.push(T[M]), E.length === w)) return E;
                                        S = x = _;
                                    }
                                }
                                return E.push(h.slice(x)), E;
                            },
                        ]
                    );
                });
            },
            6108: function (e, t, i) {
                "use strict";
                i(6774);
                var n = i(7007),
                    r = i(3218),
                    s = i(7057),
                    o = "toString",
                    a = /./[o],
                    l = function (e) {
                        i(7234)(RegExp.prototype, o, e, !0);
                    };
                i(4253)(function () {
                    return "/a/b" != a.call({ source: "a", flags: "b" });
                })
                    ? l(function () {
                          var e = n(this);
                          return "/".concat(e.source, "/", "flags" in e ? e.flags : !s && e instanceof RegExp ? r.call(e) : void 0);
                      })
                    : a.name != o &&
                      l(function () {
                          return a.call(this);
                      });
            },
            8184: function (e, t, i) {
                "use strict";
                var n = i(9824),
                    r = i(1616);
                e.exports = i(5795)(
                    "Set",
                    function (e) {
                        return function () {
                            return e(this, arguments.length > 0 ? arguments[0] : void 0);
                        };
                    },
                    {
                        add: function (e) {
                            return n.def(r(this, "Set"), (e = 0 === e ? 0 : e), e);
                        },
                    },
                    n
                );
            },
            856: function (e, t, i) {
                "use strict";
                i(9395)("anchor", function (e) {
                    return function (t) {
                        return e(this, "a", "name", t);
                    };
                });
            },
            703: function (e, t, i) {
                "use strict";
                i(9395)("big", function (e) {
                    return function () {
                        return e(this, "big", "", "");
                    };
                });
            },
            1539: function (e, t, i) {
                "use strict";
                i(9395)("blink", function (e) {
                    return function () {
                        return e(this, "blink", "", "");
                    };
                });
            },
            5292: function (e, t, i) {
                "use strict";
                i(9395)("bold", function (e) {
                    return function () {
                        return e(this, "b", "", "");
                    };
                });
            },
            9539: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(4496)(!1);
                n(n.P, "String", {
                    codePointAt: function (e) {
                        return r(this, e);
                    },
                });
            },
            6620: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(875),
                    s = i(2094),
                    o = "endsWith",
                    a = ""[o];
                n(n.P + n.F * i(8852)(o), "String", {
                    endsWith: function (e) {
                        var t = s(this, e, o),
                            i = arguments.length > 1 ? arguments[1] : void 0,
                            n = r(t.length),
                            l = void 0 === i ? n : Math.min(r(i), n),
                            c = String(e);
                        return a ? a.call(t, c, l) : t.slice(l - c.length, l) === c;
                    },
                });
            },
            6629: function (e, t, i) {
                "use strict";
                i(9395)("fixed", function (e) {
                    return function () {
                        return e(this, "tt", "", "");
                    };
                });
            },
            3694: function (e, t, i) {
                "use strict";
                i(9395)("fontcolor", function (e) {
                    return function (t) {
                        return e(this, "font", "color", t);
                    };
                });
            },
            7648: function (e, t, i) {
                "use strict";
                i(9395)("fontsize", function (e) {
                    return function (t) {
                        return e(this, "font", "size", t);
                    };
                });
            },
            191: function (e, t, i) {
                var n = i(2985),
                    r = i(2337),
                    s = String.fromCharCode,
                    o = String.fromCodePoint;
                n(n.S + n.F * (!!o && 1 != o.length), "String", {
                    fromCodePoint: function (e) {
                        for (var t, i = [], n = arguments.length, o = 0; n > o; ) {
                            if (((t = +arguments[o++]), r(t, 1114111) !== t)) throw RangeError(t + " is not a valid code point");
                            i.push(t < 65536 ? s(t) : s(55296 + ((t -= 65536) >> 10), (t % 1024) + 56320));
                        }
                        return i.join("");
                    },
                });
            },
            2850: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(2094),
                    s = "includes";
                n(n.P + n.F * i(8852)(s), "String", {
                    includes: function (e) {
                        return !!~r(this, e, s).indexOf(e, arguments.length > 1 ? arguments[1] : void 0);
                    },
                });
            },
            7795: function (e, t, i) {
                "use strict";
                i(9395)("italics", function (e) {
                    return function () {
                        return e(this, "i", "", "");
                    };
                });
            },
            9115: function (e, t, i) {
                "use strict";
                var n = i(4496)(!0);
                i(2923)(
                    String,
                    "String",
                    function (e) {
                        (this._t = String(e)), (this._i = 0);
                    },
                    function () {
                        var e,
                            t = this._t,
                            i = this._i;
                        return i >= t.length ? { value: void 0, done: !0 } : ((e = n(t, i)), (this._i += e.length), { value: e, done: !1 });
                    }
                );
            },
            4531: function (e, t, i) {
                "use strict";
                i(9395)("link", function (e) {
                    return function (t) {
                        return e(this, "a", "href", t);
                    };
                });
            },
            8306: function (e, t, i) {
                var n = i(2985),
                    r = i(2110),
                    s = i(875);
                n(n.S, "String", {
                    raw: function (e) {
                        for (var t = r(e.raw), i = s(t.length), n = arguments.length, o = [], a = 0; i > a; ) o.push(String(t[a++])), a < n && o.push(String(arguments[a]));
                        return o.join("");
                    },
                });
            },
            823: function (e, t, i) {
                var n = i(2985);
                n(n.P, "String", { repeat: i(8595) });
            },
            3605: function (e, t, i) {
                "use strict";
                i(9395)("small", function (e) {
                    return function () {
                        return e(this, "small", "", "");
                    };
                });
            },
            7732: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(875),
                    s = i(2094),
                    o = "startsWith",
                    a = ""[o];
                n(n.P + n.F * i(8852)(o), "String", {
                    startsWith: function (e) {
                        var t = s(this, e, o),
                            i = r(Math.min(arguments.length > 1 ? arguments[1] : void 0, t.length)),
                            n = String(e);
                        return a ? a.call(t, n, i) : t.slice(i, i + n.length) === n;
                    },
                });
            },
            6780: function (e, t, i) {
                "use strict";
                i(9395)("strike", function (e) {
                    return function () {
                        return e(this, "strike", "", "");
                    };
                });
            },
            9937: function (e, t, i) {
                "use strict";
                i(9395)("sub", function (e) {
                    return function () {
                        return e(this, "sub", "", "");
                    };
                });
            },
            511: function (e, t, i) {
                "use strict";
                i(9395)("sup", function (e) {
                    return function () {
                        return e(this, "sup", "", "");
                    };
                });
            },
            4564: function (e, t, i) {
                "use strict";
                i(9599)("trim", function (e) {
                    return function () {
                        return e(this, 3);
                    };
                });
            },
            5767: function (e, t, i) {
                "use strict";
                var n = i(3816),
                    r = i(9181),
                    s = i(7057),
                    o = i(2985),
                    a = i(7234),
                    l = i(4728).KEY,
                    c = i(4253),
                    u = i(3825),
                    d = i(2943),
                    h = i(3953),
                    f = i(6314),
                    p = i(8787),
                    m = i(6074),
                    g = i(5541),
                    v = i(4302),
                    b = i(7007),
                    y = i(5286),
                    w = i(508),
                    x = i(2110),
                    S = i(1689),
                    E = i(681),
                    _ = i(2503),
                    T = i(9327),
                    M = i(8693),
                    P = i(4548),
                    C = i(9275),
                    O = i(7184),
                    L = M.f,
                    k = C.f,
                    A = T.f,
                    I = n.Symbol,
                    z = n.JSON,
                    D = z && z.stringify,
                    j = "prototype",
                    R = f("_hidden"),
                    F = f("toPrimitive"),
                    $ = {}.propertyIsEnumerable,
                    N = u("symbol-registry"),
                    B = u("symbols"),
                    H = u("op-symbols"),
                    q = Object[j],
                    V = "function" == typeof I && !!P.f,
                    Y = n.QObject,
                    W = !Y || !Y[j] || !Y[j].findChild,
                    X =
                        s &&
                        c(function () {
                            return (
                                7 !=
                                _(
                                    k({}, "a", {
                                        get: function () {
                                            return k(this, "a", { value: 7 }).a;
                                        },
                                    })
                                ).a
                            );
                        })
                            ? function (e, t, i) {
                                  var n = L(q, t);
                                  n && delete q[t], k(e, t, i), n && e !== q && k(q, t, n);
                              }
                            : k,
                    G = function (e) {
                        var t = (B[e] = _(I[j]));
                        return (t._k = e), t;
                    },
                    U =
                        V && "symbol" == typeof I.iterator
                            ? function (e) {
                                  return "symbol" == typeof e;
                              }
                            : function (e) {
                                  return e instanceof I;
                              },
                    Z = function (e, t, i) {
                        return (
                            e === q && Z(H, t, i),
                            b(e),
                            (t = S(t, !0)),
                            b(i),
                            r(B, t) ? (i.enumerable ? (r(e, R) && e[R][t] && (e[R][t] = !1), (i = _(i, { enumerable: E(0, !1) }))) : (r(e, R) || k(e, R, E(1, {})), (e[R][t] = !0)), X(e, t, i)) : k(e, t, i)
                        );
                    },
                    K = function (e, t) {
                        b(e);
                        for (var i, n = g((t = x(t))), r = 0, s = n.length; s > r; ) Z(e, (i = n[r++]), t[i]);
                        return e;
                    },
                    J = function (e) {
                        var t = $.call(this, (e = S(e, !0)));
                        return !(this === q && r(B, e) && !r(H, e)) && (!(t || !r(this, e) || !r(B, e) || (r(this, R) && this[R][e])) || t);
                    },
                    Q = function (e, t) {
                        if (((e = x(e)), (t = S(t, !0)), e !== q || !r(B, t) || r(H, t))) {
                            var i = L(e, t);
                            return !i || !r(B, t) || (r(e, R) && e[R][t]) || (i.enumerable = !0), i;
                        }
                    },
                    ee = function (e) {
                        for (var t, i = A(x(e)), n = [], s = 0; i.length > s; ) r(B, (t = i[s++])) || t == R || t == l || n.push(t);
                        return n;
                    },
                    te = function (e) {
                        for (var t, i = e === q, n = A(i ? H : x(e)), s = [], o = 0; n.length > o; ) !r(B, (t = n[o++])) || (i && !r(q, t)) || s.push(B[t]);
                        return s;
                    };
                V ||
                    ((I = function () {
                        if (this instanceof I) throw TypeError("Symbol is not a constructor!");
                        var e = h(arguments.length > 0 ? arguments[0] : void 0),
                            t = function (i) {
                                this === q && t.call(H, i), r(this, R) && r(this[R], e) && (this[R][e] = !1), X(this, e, E(1, i));
                            };
                        return s && W && X(q, e, { configurable: !0, set: t }), G(e);
                    }),
                    a(I[j], "toString", function () {
                        return this._k;
                    }),
                    (M.f = Q),
                    (C.f = Z),
                    (i(616).f = T.f = ee),
                    (i(4682).f = J),
                    (P.f = te),
                    s && !i(4461) && a(q, "propertyIsEnumerable", J, !0),
                    (p.f = function (e) {
                        return G(f(e));
                    })),
                    o(o.G + o.W + o.F * !V, { Symbol: I });
                for (var ie = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; ie.length > ne; ) f(ie[ne++]);
                for (var re = O(f.store), se = 0; re.length > se; ) m(re[se++]);
                o(o.S + o.F * !V, "Symbol", {
                    for: function (e) {
                        return r(N, (e += "")) ? N[e] : (N[e] = I(e));
                    },
                    keyFor: function (e) {
                        if (!U(e)) throw TypeError(e + " is not a symbol!");
                        for (var t in N) if (N[t] === e) return t;
                    },
                    useSetter: function () {
                        W = !0;
                    },
                    useSimple: function () {
                        W = !1;
                    },
                }),
                    o(o.S + o.F * !V, "Object", {
                        create: function (e, t) {
                            return void 0 === t ? _(e) : K(_(e), t);
                        },
                        defineProperty: Z,
                        defineProperties: K,
                        getOwnPropertyDescriptor: Q,
                        getOwnPropertyNames: ee,
                        getOwnPropertySymbols: te,
                    });
                var oe = c(function () {
                    P.f(1);
                });
                o(o.S + o.F * oe, "Object", {
                    getOwnPropertySymbols: function (e) {
                        return P.f(w(e));
                    },
                }),
                    z &&
                        o(
                            o.S +
                                o.F *
                                    (!V ||
                                        c(function () {
                                            var e = I();
                                            return "[null]" != D([e]) || "{}" != D({ a: e }) || "{}" != D(Object(e));
                                        })),
                            "JSON",
                            {
                                stringify: function (e) {
                                    for (var t, i, n = [e], r = 1; arguments.length > r; ) n.push(arguments[r++]);
                                    if (((i = t = n[1]), (y(t) || void 0 !== e) && !U(e)))
                                        return (
                                            v(t) ||
                                                (t = function (e, t) {
                                                    if (("function" == typeof i && (t = i.call(this, e, t)), !U(t))) return t;
                                                }),
                                            (n[1] = t),
                                            D.apply(z, n)
                                        );
                                },
                            }
                        ),
                    I[j][F] || i(7728)(I[j], F, I[j].valueOf),
                    d(I, "Symbol"),
                    d(Math, "Math", !0),
                    d(n.JSON, "JSON", !0);
            },
            142: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(9383),
                    s = i(1125),
                    o = i(7007),
                    a = i(2337),
                    l = i(875),
                    c = i(5286),
                    u = i(3816).ArrayBuffer,
                    d = i(8364),
                    h = s.ArrayBuffer,
                    f = s.DataView,
                    p = r.ABV && u.isView,
                    m = h.prototype.slice,
                    g = r.VIEW,
                    v = "ArrayBuffer";
                n(n.G + n.W + n.F * (u !== h), { ArrayBuffer: h }),
                    n(n.S + n.F * !r.CONSTR, v, {
                        isView: function (e) {
                            return (p && p(e)) || (c(e) && g in e);
                        },
                    }),
                    n(
                        n.P +
                            n.U +
                            n.F *
                                i(4253)(function () {
                                    return !new h(2).slice(1, void 0).byteLength;
                                }),
                        v,
                        {
                            slice: function (e, t) {
                                if (void 0 !== m && void 0 === t) return m.call(o(this), e);
                                for (var i = o(this).byteLength, n = a(e, i), r = a(void 0 === t ? i : t, i), s = new (d(this, h))(l(r - n)), c = new f(this), u = new f(s), p = 0; n < r; ) u.setUint8(p++, c.getUint8(n++));
                                return s;
                            },
                        }
                    ),
                    i(2974)(v);
            },
            1786: function (e, t, i) {
                var n = i(2985);
                n(n.G + n.W + n.F * !i(9383).ABV, { DataView: i(1125).DataView });
            },
            162: function (e, t, i) {
                i(8440)("Float32", 4, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            3834: function (e, t, i) {
                i(8440)("Float64", 8, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            4821: function (e, t, i) {
                i(8440)("Int16", 2, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            1303: function (e, t, i) {
                i(8440)("Int32", 4, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            5368: function (e, t, i) {
                i(8440)("Int8", 1, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            9103: function (e, t, i) {
                i(8440)("Uint16", 2, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            3318: function (e, t, i) {
                i(8440)("Uint32", 4, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            6964: function (e, t, i) {
                i(8440)("Uint8", 1, function (e) {
                    return function (t, i, n) {
                        return e(this, t, i, n);
                    };
                });
            },
            2152: function (e, t, i) {
                i(8440)(
                    "Uint8",
                    1,
                    function (e) {
                        return function (t, i, n) {
                            return e(this, t, i, n);
                        };
                    },
                    !0
                );
            },
            147: function (e, t, i) {
                "use strict";
                var n,
                    r = i(3816),
                    s = i(50)(0),
                    o = i(7234),
                    a = i(4728),
                    l = i(5345),
                    c = i(3657),
                    u = i(5286),
                    d = i(1616),
                    h = i(1616),
                    f = !r.ActiveXObject && "ActiveXObject" in r,
                    p = "WeakMap",
                    m = a.getWeak,
                    g = Object.isExtensible,
                    v = c.ufstore,
                    b = function (e) {
                        return function () {
                            return e(this, arguments.length > 0 ? arguments[0] : void 0);
                        };
                    },
                    y = {
                        get: function (e) {
                            if (u(e)) {
                                var t = m(e);
                                return !0 === t ? v(d(this, p)).get(e) : t ? t[this._i] : void 0;
                            }
                        },
                        set: function (e, t) {
                            return c.def(d(this, p), e, t);
                        },
                    },
                    w = (e.exports = i(5795)(p, b, y, c, !0, !0));
                h &&
                    f &&
                    (l((n = c.getConstructor(b, p)).prototype, y),
                    (a.NEED = !0),
                    s(["delete", "has", "get", "set"], function (e) {
                        var t = w.prototype,
                            i = t[e];
                        o(t, e, function (t, r) {
                            if (u(t) && !g(t)) {
                                this._f || (this._f = new n());
                                var s = this._f[e](t, r);
                                return "set" == e ? this : s;
                            }
                            return i.call(this, t, r);
                        });
                    }));
            },
            9192: function (e, t, i) {
                "use strict";
                var n = i(3657),
                    r = i(1616),
                    s = "WeakSet";
                i(5795)(
                    s,
                    function (e) {
                        return function () {
                            return e(this, arguments.length > 0 ? arguments[0] : void 0);
                        };
                    },
                    {
                        add: function (e) {
                            return n.def(r(this, s), e, !0);
                        },
                    },
                    n,
                    !1,
                    !0
                );
            },
            1268: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(3325),
                    s = i(508),
                    o = i(875),
                    a = i(4963),
                    l = i(6886);
                n(n.P, "Array", {
                    flatMap: function (e) {
                        var t,
                            i,
                            n = s(this);
                        return a(e), (t = o(n.length)), (i = l(n, 0)), r(i, n, n, t, 0, 1, e, arguments[1]), i;
                    },
                }),
                    i(7722)("flatMap");
            },
            2773: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(9315)(!0);
                n(n.P, "Array", {
                    includes: function (e) {
                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    },
                }),
                    i(7722)("includes");
            },
            3276: function (e, t, i) {
                var n = i(2985),
                    r = i(1131)(!0);
                n(n.S, "Object", {
                    entries: function (e) {
                        return r(e);
                    },
                });
            },
            8351: function (e, t, i) {
                var n = i(2985),
                    r = i(7643),
                    s = i(2110),
                    o = i(8693),
                    a = i(2811);
                n(n.S, "Object", {
                    getOwnPropertyDescriptors: function (e) {
                        for (var t, i, n = s(e), l = o.f, c = r(n), u = {}, d = 0; c.length > d; ) void 0 !== (i = l(n, (t = c[d++]))) && a(u, t, i);
                        return u;
                    },
                });
            },
            6409: function (e, t, i) {
                var n = i(2985),
                    r = i(1131)(!1);
                n(n.S, "Object", {
                    values: function (e) {
                        return r(e);
                    },
                });
            },
            9865: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(5645),
                    s = i(3816),
                    o = i(8364),
                    a = i(94);
                n(n.P + n.R, "Promise", {
                    finally: function (e) {
                        var t = o(this, r.Promise || s.Promise),
                            i = "function" == typeof e;
                        return this.then(
                            i
                                ? function (i) {
                                      return a(t, e()).then(function () {
                                          return i;
                                      });
                                  }
                                : e,
                            i
                                ? function (i) {
                                      return a(t, e()).then(function () {
                                          throw i;
                                      });
                                  }
                                : e
                        );
                    },
                });
            },
            2770: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(5442),
                    s = i(575),
                    o = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(s);
                n(n.P + n.F * o, "String", {
                    padEnd: function (e) {
                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0, !1);
                    },
                });
            },
            1784: function (e, t, i) {
                "use strict";
                var n = i(2985),
                    r = i(5442),
                    s = i(575),
                    o = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(s);
                n(n.P + n.F * o, "String", {
                    padStart: function (e) {
                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0, !0);
                    },
                });
            },
            5869: function (e, t, i) {
                "use strict";
                i(9599)(
                    "trimLeft",
                    function (e) {
                        return function () {
                            return e(this, 1);
                        };
                    },
                    "trimStart"
                );
            },
            4325: function (e, t, i) {
                "use strict";
                i(9599)(
                    "trimRight",
                    function (e) {
                        return function () {
                            return e(this, 2);
                        };
                    },
                    "trimEnd"
                );
            },
            9665: function (e, t, i) {
                i(6074)("asyncIterator");
            },
            1181: function (e, t, i) {
                for (
                    var n = i(6997),
                        r = i(7184),
                        s = i(7234),
                        o = i(3816),
                        a = i(7728),
                        l = i(2803),
                        c = i(6314),
                        u = c("iterator"),
                        d = c("toStringTag"),
                        h = l.Array,
                        f = {
                            CSSRuleList: !0,
                            CSSStyleDeclaration: !1,
                            CSSValueList: !1,
                            ClientRectList: !1,
                            DOMRectList: !1,
                            DOMStringList: !1,
                            DOMTokenList: !0,
                            DataTransferItemList: !1,
                            FileList: !1,
                            HTMLAllCollection: !1,
                            HTMLCollection: !1,
                            HTMLFormElement: !1,
                            HTMLSelectElement: !1,
                            MediaList: !0,
                            MimeTypeArray: !1,
                            NamedNodeMap: !1,
                            NodeList: !0,
                            PaintRequestList: !1,
                            Plugin: !1,
                            PluginArray: !1,
                            SVGLengthList: !1,
                            SVGNumberList: !1,
                            SVGPathSegList: !1,
                            SVGPointList: !1,
                            SVGStringList: !1,
                            SVGTransformList: !1,
                            SourceBufferList: !1,
                            StyleSheetList: !0,
                            TextTrackCueList: !1,
                            TextTrackList: !1,
                            TouchList: !1,
                        },
                        p = r(f),
                        m = 0;
                    m < p.length;
                    m++
                ) {
                    var g,
                        v = p[m],
                        b = f[v],
                        y = o[v],
                        w = y && y.prototype;
                    if (w && (w[u] || a(w, u, h), w[d] || a(w, d, v), (l[v] = h), b)) for (g in n) w[g] || s(w, g, n[g], !0);
                }
            },
            4633: function (e, t, i) {
                var n = i(2985),
                    r = i(4193);
                n(n.G + n.B, { setImmediate: r.set, clearImmediate: r.clear });
            },
            2564: function (e, t, i) {
                var n = i(3816),
                    r = i(2985),
                    s = i(575),
                    o = [].slice,
                    a = /MSIE .\./.test(s),
                    l = function (e) {
                        return function (t, i) {
                            var n = arguments.length > 2,
                                r = !!n && o.call(arguments, 2);
                            return e(
                                n
                                    ? function () {
                                          ("function" == typeof t ? t : Function(t)).apply(this, r);
                                      }
                                    : t,
                                i
                            );
                        };
                    };
                r(r.G + r.B + r.F * a, { setTimeout: l(n.setTimeout), setInterval: l(n.setInterval) });
            },
            6337: function (e, t, i) {
                i(2564), i(4633), i(1181), (e.exports = i(5645));
            },
            9092: function (e, t, i) {
                "use strict";
                function n(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                i.r(t),
                    i.d(t, {
                        ScrollTrigger: function () {
                            return si;
                        },
                        default: function () {
                            return si;
                        },
                    });
                var r,
                    s,
                    o,
                    a,
                    l,
                    c,
                    u,
                    d,
                    h,
                    f,
                    p,
                    m,
                    g,
                    v = function () {
                        return r || ("undefined" != typeof window && (r = window.gsap) && r.registerPlugin && r);
                    },
                    b = 1,
                    y = [],
                    w = [],
                    x = [],
                    S = Date.now,
                    E = function (e, t) {
                        return t;
                    },
                    _ = function (e, t) {
                        return ~x.indexOf(e) && x[x.indexOf(e) + 1][t];
                    },
                    T = function (e) {
                        return !!~f.indexOf(e);
                    },
                    M = function (e, t, i, n, r) {
                        return e.addEventListener(t, i, { passive: !n, capture: !!r });
                    },
                    P = function (e, t, i, n) {
                        return e.removeEventListener(t, i, !!n);
                    },
                    C = "scrollLeft",
                    O = "scrollTop",
                    L = function () {
                        return (p && p.isPressed) || w.cache++;
                    },
                    k = function (e, t) {
                        var i = function i(n) {
                            if (n || 0 === n) {
                                b && (o.history.scrollRestoration = "manual");
                                var r = p && p.isPressed;
                                (n = i.v = Math.round(n) || (p && p.iOS ? 1 : 0)), e(n), (i.cacheID = w.cache), r && E("ss", n);
                            } else (t || w.cache !== i.cacheID || E("ref")) && ((i.cacheID = w.cache), (i.v = e()));
                            return i.v + i.offset;
                        };
                        return (i.offset = 0), e && i;
                    },
                    A = {
                        s: C,
                        p: "left",
                        p2: "Left",
                        os: "right",
                        os2: "Right",
                        d: "width",
                        d2: "Width",
                        a: "x",
                        sc: k(function (e) {
                            return arguments.length ? o.scrollTo(e, I.sc()) : o.pageXOffset || a[C] || l[C] || c[C] || 0;
                        }),
                    },
                    I = {
                        s: O,
                        p: "top",
                        p2: "Top",
                        os: "bottom",
                        os2: "Bottom",
                        d: "height",
                        d2: "Height",
                        a: "y",
                        op: A,
                        sc: k(function (e) {
                            return arguments.length ? o.scrollTo(A.sc(), e) : o.pageYOffset || a[O] || l[O] || c[O] || 0;
                        }),
                    },
                    z = function (e, t) {
                        return ((t && t._ctx && t._ctx.selector) || r.utils.toArray)(e)[0] || ("string" == typeof e && !1 !== r.config().nullTargetWarn ? console.warn("Element not found:", e) : null);
                    },
                    D = function (e, t) {
                        var i = t.s,
                            n = t.sc;
                        T(e) && (e = a.scrollingElement || l);
                        var s = w.indexOf(e),
                            o = n === I.sc ? 1 : 2;
                        !~s && (s = w.push(e) - 1), w[s + o] || M(e, "scroll", L);
                        var c = w[s + o],
                            u =
                                c ||
                                (w[s + o] =
                                    k(_(e, i), !0) ||
                                    (T(e)
                                        ? n
                                        : k(function (t) {
                                              return arguments.length ? (e[i] = t) : e[i];
                                          })));
                        return (u.target = e), c || (u.smooth = "smooth" === r.getProperty(e, "scrollBehavior")), u;
                    },
                    j = function (e, t, i) {
                        var n = e,
                            r = e,
                            s = S(),
                            o = s,
                            a = t || 50,
                            l = Math.max(500, 3 * a),
                            c = function (e, t) {
                                var l = S();
                                t || l - s > a ? ((r = n), (n = e), (o = s), (s = l)) : i ? (n += e) : (n = r + ((e - r) / (l - o)) * (s - o));
                            };
                        return {
                            update: c,
                            reset: function () {
                                (r = n = i ? 0 : n), (o = s = 0);
                            },
                            getVelocity: function (e) {
                                var t = o,
                                    a = r,
                                    u = S();
                                return (e || 0 === e) && e !== n && c(e), s === o || u - o > l ? 0 : ((n + (i ? a : -a)) / ((i ? u : s) - t)) * 1e3;
                            },
                        };
                    },
                    R = function (e, t) {
                        return t && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
                    },
                    F = function (e) {
                        var t = Math.max.apply(Math, e),
                            i = Math.min.apply(Math, e);
                        return Math.abs(t) >= Math.abs(i) ? t : i;
                    },
                    $ = function () {
                        var e, t, i, n;
                        (h = r.core.globals().ScrollTrigger) &&
                            h.core &&
                            ((e = h.core),
                            (t = e.bridge || {}),
                            (i = e._scrollers),
                            (n = e._proxies),
                            i.push.apply(i, w),
                            n.push.apply(n, x),
                            (w = i),
                            (x = n),
                            (E = function (e, i) {
                                return t[e](i);
                            }));
                    },
                    N = function (e) {
                        return (
                            (r = e || v()) &&
                                "undefined" != typeof document &&
                                document.body &&
                                ((o = window),
                                (a = document),
                                (l = a.documentElement),
                                (c = a.body),
                                (f = [o, a, l, c]),
                                r.utils.clamp,
                                (g = r.core.context || function () {}),
                                (d = "onpointerenter" in c ? "pointer" : "mouse"),
                                (u = B.isTouch = o.matchMedia && o.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in o || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0),
                                (m = B.eventTypes = ("ontouchstart" in l
                                    ? "touchstart,touchmove,touchcancel,touchend"
                                    : "onpointerdown" in l
                                    ? "pointerdown,pointermove,pointercancel,pointerup"
                                    : "mousedown,mousemove,mouseup,mouseup"
                                ).split(",")),
                                setTimeout(function () {
                                    return (b = 0);
                                }, 500),
                                $(),
                                (s = 1)),
                            s
                        );
                    };
                (A.op = I), (w.cache = 0);
                var B = (function () {
                    function e(e) {
                        this.init(e);
                    }
                    var t, i;
                    return (
                        (e.prototype.init = function (e) {
                            s || N(r) || console.warn("Please gsap.registerPlugin(Observer)"), h || $();
                            var t = e.tolerance,
                                i = e.dragMinimum,
                                n = e.type,
                                f = e.target,
                                v = e.lineHeight,
                                b = e.debounce,
                                w = e.preventDefault,
                                x = e.onStop,
                                E = e.onStopDelay,
                                _ = e.ignore,
                                C = e.wheelSpeed,
                                O = e.event,
                                k = e.onDragStart,
                                B = e.onDragEnd,
                                H = e.onDrag,
                                q = e.onPress,
                                V = e.onRelease,
                                Y = e.onRight,
                                W = e.onLeft,
                                X = e.onUp,
                                G = e.onDown,
                                U = e.onChangeX,
                                Z = e.onChangeY,
                                K = e.onChange,
                                J = e.onToggleX,
                                Q = e.onToggleY,
                                ee = e.onHover,
                                te = e.onHoverEnd,
                                ie = e.onMove,
                                ne = e.ignoreCheck,
                                re = e.isNormalizer,
                                se = e.onGestureStart,
                                oe = e.onGestureEnd,
                                ae = e.onWheel,
                                le = e.onEnable,
                                ce = e.onDisable,
                                ue = e.onClick,
                                de = e.scrollSpeed,
                                he = e.capture,
                                fe = e.allowClicks,
                                pe = e.lockAxis,
                                me = e.onLockAxis;
                            (this.target = f = z(f) || l),
                                (this.vars = e),
                                _ && (_ = r.utils.toArray(_)),
                                (t = t || 1e-9),
                                (i = i || 0),
                                (C = C || 1),
                                (de = de || 1),
                                (n = n || "wheel,touch,pointer"),
                                (b = !1 !== b),
                                v || (v = parseFloat(o.getComputedStyle(c).lineHeight) || 22);
                            var ge,
                                ve,
                                be,
                                ye,
                                we,
                                xe,
                                Se,
                                Ee = this,
                                _e = 0,
                                Te = 0,
                                Me = D(f, A),
                                Pe = D(f, I),
                                Ce = Me(),
                                Oe = Pe(),
                                Le = ~n.indexOf("touch") && !~n.indexOf("pointer") && "pointerdown" === m[0],
                                ke = T(f),
                                Ae = f.ownerDocument || a,
                                Ie = [0, 0, 0],
                                ze = [0, 0, 0],
                                De = 0,
                                je = function () {
                                    return (De = S());
                                },
                                Re = function (e, t) {
                                    return ((Ee.event = e) && _ && ~_.indexOf(e.target)) || (t && Le && "touch" !== e.pointerType) || (ne && ne(e, t));
                                },
                                Fe = function () {
                                    var e = (Ee.deltaX = F(Ie)),
                                        i = (Ee.deltaY = F(ze)),
                                        n = Math.abs(e) >= t,
                                        r = Math.abs(i) >= t;
                                    K && (n || r) && K(Ee, e, i, Ie, ze),
                                        n && (Y && Ee.deltaX > 0 && Y(Ee), W && Ee.deltaX < 0 && W(Ee), U && U(Ee), J && Ee.deltaX < 0 != _e < 0 && J(Ee), (_e = Ee.deltaX), (Ie[0] = Ie[1] = Ie[2] = 0)),
                                        r && (G && Ee.deltaY > 0 && G(Ee), X && Ee.deltaY < 0 && X(Ee), Z && Z(Ee), Q && Ee.deltaY < 0 != Te < 0 && Q(Ee), (Te = Ee.deltaY), (ze[0] = ze[1] = ze[2] = 0)),
                                        (ye || be) && (ie && ie(Ee), be && (H(Ee), (be = !1)), (ye = !1)),
                                        xe && !(xe = !1) && me && me(Ee),
                                        we && (ae(Ee), (we = !1)),
                                        (ge = 0);
                                },
                                $e = function (e, t, i) {
                                    (Ie[i] += e), (ze[i] += t), Ee._vx.update(e), Ee._vy.update(t), b ? ge || (ge = requestAnimationFrame(Fe)) : Fe();
                                },
                                Ne = function (e, t) {
                                    pe && !Se && ((Ee.axis = Se = Math.abs(e) > Math.abs(t) ? "x" : "y"), (xe = !0)),
                                        "y" !== Se && ((Ie[2] += e), Ee._vx.update(e, !0)),
                                        "x" !== Se && ((ze[2] += t), Ee._vy.update(t, !0)),
                                        b ? ge || (ge = requestAnimationFrame(Fe)) : Fe();
                                },
                                Be = function (e) {
                                    if (!Re(e, 1)) {
                                        var t = (e = R(e, w)).clientX,
                                            n = e.clientY,
                                            r = t - Ee.x,
                                            s = n - Ee.y,
                                            o = Ee.isDragging;
                                        (Ee.x = t), (Ee.y = n), (o || Math.abs(Ee.startX - t) >= i || Math.abs(Ee.startY - n) >= i) && (H && (be = !0), o || (Ee.isDragging = !0), Ne(r, s), o || (k && k(Ee)));
                                    }
                                },
                                He = (Ee.onPress = function (e) {
                                    Re(e, 1) ||
                                        (e && e.button) ||
                                        ((Ee.axis = Se = null),
                                        ve.pause(),
                                        (Ee.isPressed = !0),
                                        (e = R(e)),
                                        (_e = Te = 0),
                                        (Ee.startX = Ee.x = e.clientX),
                                        (Ee.startY = Ee.y = e.clientY),
                                        Ee._vx.reset(),
                                        Ee._vy.reset(),
                                        M(re ? f : Ae, m[1], Be, w, !0),
                                        (Ee.deltaX = Ee.deltaY = 0),
                                        q && q(Ee));
                                }),
                                qe = (Ee.onRelease = function (e) {
                                    if (!Re(e, 1)) {
                                        P(re ? f : Ae, m[1], Be, !0);
                                        var t = !isNaN(Ee.y - Ee.startY),
                                            i = Ee.isDragging && (Math.abs(Ee.x - Ee.startX) > 3 || Math.abs(Ee.y - Ee.startY) > 3),
                                            n = R(e);
                                        !i &&
                                            t &&
                                            (Ee._vx.reset(),
                                            Ee._vy.reset(),
                                            w &&
                                                fe &&
                                                r.delayedCall(0.08, function () {
                                                    if (S() - De > 300 && !e.defaultPrevented)
                                                        if (e.target.click) e.target.click();
                                                        else if (Ae.createEvent) {
                                                            var t = Ae.createEvent("MouseEvents");
                                                            t.initMouseEvent("click", !0, !0, o, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t);
                                                        }
                                                })),
                                            (Ee.isDragging = Ee.isGesturing = Ee.isPressed = !1),
                                            x && !re && ve.restart(!0),
                                            B && i && B(Ee),
                                            V && V(Ee, i);
                                    }
                                }),
                                Ve = function (e) {
                                    return e.touches && e.touches.length > 1 && (Ee.isGesturing = !0) && se(e, Ee.isDragging);
                                },
                                Ye = function () {
                                    return (Ee.isGesturing = !1) || oe(Ee);
                                },
                                We = function (e) {
                                    if (!Re(e)) {
                                        var t = Me(),
                                            i = Pe();
                                        $e((t - Ce) * de, (i - Oe) * de, 1), (Ce = t), (Oe = i), x && ve.restart(!0);
                                    }
                                },
                                Xe = function (e) {
                                    if (!Re(e)) {
                                        (e = R(e, w)), ae && (we = !0);
                                        var t = (1 === e.deltaMode ? v : 2 === e.deltaMode ? o.innerHeight : 1) * C;
                                        $e(e.deltaX * t, e.deltaY * t, 0), x && !re && ve.restart(!0);
                                    }
                                },
                                Ge = function (e) {
                                    if (!Re(e)) {
                                        var t = e.clientX,
                                            i = e.clientY,
                                            n = t - Ee.x,
                                            r = i - Ee.y;
                                        (Ee.x = t), (Ee.y = i), (ye = !0), (n || r) && Ne(n, r);
                                    }
                                },
                                Ue = function (e) {
                                    (Ee.event = e), ee(Ee);
                                },
                                Ze = function (e) {
                                    (Ee.event = e), te(Ee);
                                },
                                Ke = function (e) {
                                    return Re(e) || (R(e, w) && ue(Ee));
                                };
                            (ve = Ee._dc = r
                                .delayedCall(E || 0.25, function () {
                                    Ee._vx.reset(), Ee._vy.reset(), ve.pause(), x && x(Ee);
                                })
                                .pause()),
                                (Ee.deltaX = Ee.deltaY = 0),
                                (Ee._vx = j(0, 50, !0)),
                                (Ee._vy = j(0, 50, !0)),
                                (Ee.scrollX = Me),
                                (Ee.scrollY = Pe),
                                (Ee.isDragging = Ee.isGesturing = Ee.isPressed = !1),
                                g(this),
                                (Ee.enable = function (e) {
                                    return (
                                        Ee.isEnabled ||
                                            (M(ke ? Ae : f, "scroll", L),
                                            n.indexOf("scroll") >= 0 && M(ke ? Ae : f, "scroll", We, w, he),
                                            n.indexOf("wheel") >= 0 && M(f, "wheel", Xe, w, he),
                                            ((n.indexOf("touch") >= 0 && u) || n.indexOf("pointer") >= 0) &&
                                                (M(f, m[0], He, w, he),
                                                M(Ae, m[2], qe),
                                                M(Ae, m[3], qe),
                                                fe && M(f, "click", je, !1, !0),
                                                ue && M(f, "click", Ke),
                                                se && M(Ae, "gesturestart", Ve),
                                                oe && M(Ae, "gestureend", Ye),
                                                ee && M(f, d + "enter", Ue),
                                                te && M(f, d + "leave", Ze),
                                                ie && M(f, d + "move", Ge)),
                                            (Ee.isEnabled = !0),
                                            e && e.type && He(e),
                                            le && le(Ee)),
                                        Ee
                                    );
                                }),
                                (Ee.disable = function () {
                                    Ee.isEnabled &&
                                        (y.filter(function (e) {
                                            return e !== Ee && T(e.target);
                                        }).length || P(ke ? Ae : f, "scroll", L),
                                        Ee.isPressed && (Ee._vx.reset(), Ee._vy.reset(), P(re ? f : Ae, m[1], Be, !0)),
                                        P(ke ? Ae : f, "scroll", We, he),
                                        P(f, "wheel", Xe, he),
                                        P(f, m[0], He, he),
                                        P(Ae, m[2], qe),
                                        P(Ae, m[3], qe),
                                        P(f, "click", je, !0),
                                        P(f, "click", Ke),
                                        P(Ae, "gesturestart", Ve),
                                        P(Ae, "gestureend", Ye),
                                        P(f, d + "enter", Ue),
                                        P(f, d + "leave", Ze),
                                        P(f, d + "move", Ge),
                                        (Ee.isEnabled = Ee.isPressed = Ee.isDragging = !1),
                                        ce && ce(Ee));
                                }),
                                (Ee.kill = Ee.revert = function () {
                                    Ee.disable();
                                    var e = y.indexOf(Ee);
                                    e >= 0 && y.splice(e, 1), p === Ee && (p = 0);
                                }),
                                y.push(Ee),
                                re && T(f) && (p = Ee),
                                Ee.enable(O);
                        }),
                        (t = e),
                        (i = [
                            {
                                key: "velocityX",
                                get: function () {
                                    return this._vx.getVelocity();
                                },
                            },
                            {
                                key: "velocityY",
                                get: function () {
                                    return this._vy.getVelocity();
                                },
                            },
                        ]) && n(t.prototype, i),
                        e
                    );
                })();
                (B.version = "3.12.2"),
                    (B.create = function (e) {
                        return new B(e);
                    }),
                    (B.register = N),
                    (B.getAll = function () {
                        return y.slice();
                    }),
                    (B.getById = function (e) {
                        return y.filter(function (t) {
                            return t.vars.id === e;
                        })[0];
                    }),
                    v() && r.registerPlugin(B);
                var H,
                    q,
                    V,
                    Y,
                    W,
                    X,
                    G,
                    U,
                    Z,
                    K,
                    J,
                    Q,
                    ee,
                    te,
                    ie,
                    ne,
                    re,
                    se,
                    oe,
                    ae,
                    le,
                    ce,
                    ue,
                    de,
                    he,
                    fe,
                    pe,
                    me,
                    ge,
                    ve,
                    be,
                    ye,
                    we,
                    xe,
                    Se,
                    Ee,
                    _e = 1,
                    Te = Date.now,
                    Me = Te(),
                    Pe = 0,
                    Ce = 0,
                    Oe = function (e, t, i) {
                        var n = qe(e) && ("clamp(" === e.substr(0, 6) || e.indexOf("max") > -1);
                        return (i["_" + t + "Clamp"] = n), n ? e.substr(6, e.length - 7) : e;
                    },
                    Le = function (e, t) {
                        return !t || (qe(e) && "clamp(" === e.substr(0, 6)) ? e : "clamp(" + e + ")";
                    },
                    ke = function e() {
                        return Ce && requestAnimationFrame(e);
                    },
                    Ae = function () {
                        return (te = 1);
                    },
                    Ie = function () {
                        return (te = 0);
                    },
                    ze = function (e) {
                        return e;
                    },
                    De = function (e) {
                        return Math.round(1e5 * e) / 1e5 || 0;
                    },
                    je = function () {
                        return "undefined" != typeof window;
                    },
                    Re = function () {
                        return H || (je() && (H = window.gsap) && H.registerPlugin && H);
                    },
                    Fe = function (e) {
                        return !!~G.indexOf(e);
                    },
                    $e = function (e) {
                        return ("Height" === e ? be : V["inner" + e]) || W["client" + e] || X["client" + e];
                    },
                    Ne = function (e) {
                        return (
                            _(e, "getBoundingClientRect") ||
                            (Fe(e)
                                ? function () {
                                      return (Jt.width = V.innerWidth), (Jt.height = be), Jt;
                                  }
                                : function () {
                                      return ht(e);
                                  })
                        );
                    },
                    Be = function (e, t) {
                        var i = t.s,
                            n = t.d2,
                            r = t.d,
                            s = t.a;
                        return Math.max(0, (i = "scroll" + n) && (s = _(e, i)) ? s() - Ne(e)()[r] : Fe(e) ? (W[i] || X[i]) - $e(n) : e[i] - e["offset" + n]);
                    },
                    He = function (e, t) {
                        for (var i = 0; i < oe.length; i += 3) (!t || ~t.indexOf(oe[i + 1])) && e(oe[i], oe[i + 1], oe[i + 2]);
                    },
                    qe = function (e) {
                        return "string" == typeof e;
                    },
                    Ve = function (e) {
                        return "function" == typeof e;
                    },
                    Ye = function (e) {
                        return "number" == typeof e;
                    },
                    We = function (e) {
                        return "object" == typeof e;
                    },
                    Xe = function (e, t, i) {
                        return e && e.progress(t ? 0 : 1) && i && e.pause();
                    },
                    Ge = function (e, t) {
                        if (e.enabled) {
                            var i = t(e);
                            i && i.totalTime && (e.callbackAnimation = i);
                        }
                    },
                    Ue = Math.abs,
                    Ze = "left",
                    Ke = "right",
                    Je = "bottom",
                    Qe = "width",
                    et = "height",
                    tt = "Right",
                    it = "Left",
                    nt = "Top",
                    rt = "Bottom",
                    st = "padding",
                    ot = "margin",
                    at = "Width",
                    lt = "Height",
                    ct = "px",
                    ut = function (e) {
                        return V.getComputedStyle(e);
                    },
                    dt = function (e, t) {
                        for (var i in t) i in e || (e[i] = t[i]);
                        return e;
                    },
                    ht = function (e, t) {
                        var i = t && "matrix(1, 0, 0, 1, 0, 0)" !== ut(e)[ie] && H.to(e, { x: 0, y: 0, xPercent: 0, yPercent: 0, rotation: 0, rotationX: 0, rotationY: 0, scale: 1, skewX: 0, skewY: 0 }).progress(1),
                            n = e.getBoundingClientRect();
                        return i && i.progress(0).kill(), n;
                    },
                    ft = function (e, t) {
                        var i = t.d2;
                        return e["offset" + i] || e["client" + i] || 0;
                    },
                    pt = function (e) {
                        var t,
                            i = [],
                            n = e.labels,
                            r = e.duration();
                        for (t in n) i.push(n[t] / r);
                        return i;
                    },
                    mt = function (e) {
                        var t = H.utils.snap(e),
                            i =
                                Array.isArray(e) &&
                                e.slice(0).sort(function (e, t) {
                                    return e - t;
                                });
                        return i
                            ? function (e, n, r) {
                                  var s;
                                  if ((void 0 === r && (r = 0.001), !n)) return t(e);
                                  if (n > 0) {
                                      for (e -= r, s = 0; s < i.length; s++) if (i[s] >= e) return i[s];
                                      return i[s - 1];
                                  }
                                  for (s = i.length, e += r; s--; ) if (i[s] <= e) return i[s];
                                  return i[0];
                              }
                            : function (i, n, r) {
                                  void 0 === r && (r = 0.001);
                                  var s = t(i);
                                  return !n || Math.abs(s - i) < r || s - i < 0 == n < 0 ? s : t(n < 0 ? i - e : i + e);
                              };
                    },
                    gt = function (e, t, i, n) {
                        return i.split(",").forEach(function (i) {
                            return e(t, i, n);
                        });
                    },
                    vt = function (e, t, i, n, r) {
                        return e.addEventListener(t, i, { passive: !n, capture: !!r });
                    },
                    bt = function (e, t, i, n) {
                        return e.removeEventListener(t, i, !!n);
                    },
                    yt = function (e, t, i) {
                        (i = i && i.wheelHandler) && (e(t, "wheel", i), e(t, "touchmove", i));
                    },
                    wt = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" },
                    xt = { toggleActions: "play", anticipatePin: 0 },
                    St = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
                    Et = function (e, t) {
                        if (qe(e)) {
                            var i = e.indexOf("="),
                                n = ~i ? +(e.charAt(i - 1) + 1) * parseFloat(e.substr(i + 1)) : 0;
                            ~i && (e.indexOf("%") > i && (n *= t / 100), (e = e.substr(0, i - 1))), (e = n + (e in St ? St[e] * t : ~e.indexOf("%") ? (parseFloat(e) * t) / 100 : parseFloat(e) || 0));
                        }
                        return e;
                    },
                    _t = function (e, t, i, n, r, s, o, a) {
                        var l = r.startColor,
                            c = r.endColor,
                            u = r.fontSize,
                            d = r.indent,
                            h = r.fontWeight,
                            f = Y.createElement("div"),
                            p = Fe(i) || "fixed" === _(i, "pinType"),
                            m = -1 !== e.indexOf("scroller"),
                            g = p ? X : i,
                            v = -1 !== e.indexOf("start"),
                            b = v ? l : c,
                            y =
                                "border-color:" +
                                b +
                                ";font-size:" +
                                u +
                                ";color:" +
                                b +
                                ";font-weight:" +
                                h +
                                ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
                        return (
                            (y += "position:" + ((m || a) && p ? "fixed;" : "absolute;")),
                            (m || a || !p) && (y += (n === I ? Ke : Je) + ":" + (s + parseFloat(d)) + "px;"),
                            o && (y += "box-sizing:border-box;text-align:left;width:" + o.offsetWidth + "px;"),
                            (f._isStart = v),
                            f.setAttribute("class", "gsap-marker-" + e + (t ? " marker-" + t : "")),
                            (f.style.cssText = y),
                            (f.innerText = t || 0 === t ? e + "-" + t : e),
                            g.children[0] ? g.insertBefore(f, g.children[0]) : g.appendChild(f),
                            (f._offset = f["offset" + n.op.d2]),
                            Tt(f, 0, n, v),
                            f
                        );
                    },
                    Tt = function (e, t, i, n) {
                        var r = { display: "block" },
                            s = i[n ? "os2" : "p2"],
                            o = i[n ? "p2" : "os2"];
                        (e._isFlipped = n), (r[i.a + "Percent"] = n ? -100 : 0), (r[i.a] = n ? "1px" : 0), (r["border" + s + at] = 1), (r["border" + o + at] = 0), (r[i.p] = t + "px"), H.set(e, r);
                    },
                    Mt = [],
                    Pt = {},
                    Ct = function () {
                        return Te() - Pe > 34 && (we || (we = requestAnimationFrame(Yt)));
                    },
                    Ot = function () {
                        (!ue || !ue.isPressed || ue.startX > X.clientWidth) && (w.cache++, ue ? we || (we = requestAnimationFrame(Yt)) : Yt(), Pe || Dt("scrollStart"), (Pe = Te()));
                    },
                    Lt = function () {
                        (fe = V.innerWidth), (he = V.innerHeight);
                    },
                    kt = function () {
                        w.cache++, !ee && !ce && !Y.fullscreenElement && !Y.webkitFullscreenElement && (!de || fe !== V.innerWidth || Math.abs(V.innerHeight - he) > 0.25 * V.innerHeight) && U.restart(!0);
                    },
                    At = {},
                    It = [],
                    zt = function e() {
                        return bt(si, "scrollEnd", e) || Ht(!0);
                    },
                    Dt = function (e) {
                        return (
                            (At[e] &&
                                At[e].map(function (e) {
                                    return e();
                                })) ||
                            It
                        );
                    },
                    jt = [],
                    Rt = function (e) {
                        for (var t = 0; t < jt.length; t += 5) (!e || (jt[t + 4] && jt[t + 4].query === e)) && ((jt[t].style.cssText = jt[t + 1]), jt[t].getBBox && jt[t].setAttribute("transform", jt[t + 2] || ""), (jt[t + 3].uncache = 1));
                    },
                    Ft = function (e, t) {
                        var i;
                        for (ne = 0; ne < Mt.length; ne++) !(i = Mt[ne]) || (t && i._ctx !== t) || (e ? i.kill(1) : i.revert(!0, !0));
                        t && Rt(t), t || Dt("revert");
                    },
                    $t = function (e, t) {
                        w.cache++,
                            (t || !xe) &&
                                w.forEach(function (e) {
                                    return Ve(e) && e.cacheID++ && (e.rec = 0);
                                }),
                            qe(e) && (V.history.scrollRestoration = ge = e);
                    },
                    Nt = 0,
                    Bt = function () {
                        X.appendChild(ve), (be = ve.offsetHeight || V.innerHeight), X.removeChild(ve);
                    },
                    Ht = function (e, t) {
                        if (!Pe || e) {
                            Bt(),
                                (xe = si.isRefreshing = !0),
                                w.forEach(function (e) {
                                    return Ve(e) && ++e.cacheID && (e.rec = e());
                                });
                            var i = Dt("refreshInit");
                            ae && si.sort(),
                                t || Ft(),
                                w.forEach(function (e) {
                                    Ve(e) && (e.smooth && (e.target.style.scrollBehavior = "auto"), e(0));
                                }),
                                Mt.slice(0).forEach(function (e) {
                                    return e.refresh();
                                }),
                                Mt.forEach(function (e, t) {
                                    if (e._subPinOffset && e.pin) {
                                        var i = e.vars.horizontal ? "offsetWidth" : "offsetHeight",
                                            n = e.pin[i];
                                        e.revert(!0, 1), e.adjustPinSpacing(e.pin[i] - n), e.refresh();
                                    }
                                }),
                                Mt.forEach(function (e) {
                                    var t = Be(e.scroller, e._dir);
                                    ("max" === e.vars.end || (e._endClamp && e.end > t)) && e.setPositions(e.start, Math.max(e.start + 1, t), !0);
                                }),
                                i.forEach(function (e) {
                                    return e && e.render && e.render(-1);
                                }),
                                w.forEach(function (e) {
                                    Ve(e) &&
                                        (e.smooth &&
                                            requestAnimationFrame(function () {
                                                return (e.target.style.scrollBehavior = "smooth");
                                            }),
                                        e.rec && e(e.rec));
                                }),
                                $t(ge, 1),
                                U.pause(),
                                Nt++,
                                (xe = 2),
                                Yt(2),
                                Mt.forEach(function (e) {
                                    return Ve(e.vars.onRefresh) && e.vars.onRefresh(e);
                                }),
                                (xe = si.isRefreshing = !1),
                                Dt("refresh");
                        } else vt(si, "scrollEnd", zt);
                    },
                    qt = 0,
                    Vt = 1,
                    Yt = function (e) {
                        if (!xe || 2 === e) {
                            (si.isUpdating = !0), Ee && Ee.update(0);
                            var t = Mt.length,
                                i = Te(),
                                n = i - Me >= 50,
                                r = t && Mt[0].scroll();
                            if (((Vt = qt > r ? -1 : 1), xe || (qt = r), n && (Pe && !te && i - Pe > 200 && ((Pe = 0), Dt("scrollEnd")), (J = Me), (Me = i)), Vt < 0)) {
                                for (ne = t; ne-- > 0; ) Mt[ne] && Mt[ne].update(0, n);
                                Vt = 1;
                            } else for (ne = 0; ne < t; ne++) Mt[ne] && Mt[ne].update(0, n);
                            si.isUpdating = !1;
                        }
                        we = 0;
                    },
                    Wt = [
                        Ze,
                        "top",
                        Je,
                        Ke,
                        ot + rt,
                        ot + tt,
                        ot + nt,
                        ot + it,
                        "display",
                        "flexShrink",
                        "float",
                        "zIndex",
                        "gridColumnStart",
                        "gridColumnEnd",
                        "gridRowStart",
                        "gridRowEnd",
                        "gridArea",
                        "justifySelf",
                        "alignSelf",
                        "placeSelf",
                        "order",
                    ],
                    Xt = Wt.concat([Qe, et, "boxSizing", "max" + at, "max" + lt, "position", ot, st, st + nt, st + tt, st + rt, st + it]),
                    Gt = function (e, t, i, n) {
                        if (!e._gsap.swappedIn) {
                            for (var r, s = Wt.length, o = t.style, a = e.style; s--; ) o[(r = Wt[s])] = i[r];
                            (o.position = "absolute" === i.position ? "absolute" : "relative"),
                                "inline" === i.display && (o.display = "inline-block"),
                                (a[Je] = a[Ke] = "auto"),
                                (o.flexBasis = i.flexBasis || "auto"),
                                (o.overflow = "visible"),
                                (o.boxSizing = "border-box"),
                                (o[Qe] = ft(e, A) + ct),
                                (o[et] = ft(e, I) + ct),
                                (o[st] = a[ot] = a.top = a[Ze] = "0"),
                                Zt(n),
                                (a[Qe] = a["max" + at] = i[Qe]),
                                (a[et] = a["max" + lt] = i[et]),
                                (a[st] = i[st]),
                                e.parentNode !== t && (e.parentNode.insertBefore(t, e), t.appendChild(e)),
                                (e._gsap.swappedIn = !0);
                        }
                    },
                    Ut = /([A-Z])/g,
                    Zt = function (e) {
                        if (e) {
                            var t,
                                i,
                                n = e.t.style,
                                r = e.length,
                                s = 0;
                            for ((e.t._gsap || H.core.getCache(e.t)).uncache = 1; s < r; s += 2) (i = e[s + 1]), (t = e[s]), i ? (n[t] = i) : n[t] && n.removeProperty(t.replace(Ut, "-$1").toLowerCase());
                        }
                    },
                    Kt = function (e) {
                        for (var t = Xt.length, i = e.style, n = [], r = 0; r < t; r++) n.push(Xt[r], i[Xt[r]]);
                        return (n.t = e), n;
                    },
                    Jt = { left: 0, top: 0 },
                    Qt = function (e, t, i, n, r, s, o, a, l, c, u, d, h, f) {
                        Ve(e) && (e = e(a)), qe(e) && "max" === e.substr(0, 3) && (e = d + ("=" === e.charAt(4) ? Et("0" + e.substr(3), i) : 0));
                        var p,
                            m,
                            g,
                            v = h ? h.time() : 0;
                        if ((h && h.seek(0), isNaN(e) || (e = +e), Ye(e))) h && (e = H.utils.mapRange(h.scrollTrigger.start, h.scrollTrigger.end, 0, d, e)), o && Tt(o, i, n, !0);
                        else {
                            Ve(t) && (t = t(a));
                            var b,
                                y,
                                w,
                                x,
                                S = (e || "0").split(" ");
                            (g = z(t, a) || X),
                                ((b = ht(g) || {}) && (b.left || b.top)) || "none" !== ut(g).display || ((x = g.style.display), (g.style.display = "block"), (b = ht(g)), x ? (g.style.display = x) : g.style.removeProperty("display")),
                                (y = Et(S[0], b[n.d])),
                                (w = Et(S[1] || "0", i)),
                                (e = b[n.p] - l[n.p] - c + y + r - w),
                                o && Tt(o, w, n, i - w < 20 || (o._isStart && w > 20)),
                                (i -= i - w);
                        }
                        if ((f && ((a[f] = e || -0.001), e < 0 && (e = 0)), s)) {
                            var E = e + i,
                                _ = s._isStart;
                            (p = "scroll" + n.d2), Tt(s, E, n, (_ && E > 20) || (!_ && (u ? Math.max(X[p], W[p]) : s.parentNode[p]) <= E + 1)), u && ((l = ht(o)), u && (s.style[n.op.p] = l[n.op.p] - n.op.m - s._offset + ct));
                        }
                        return h && g && ((p = ht(g)), h.seek(d), (m = ht(g)), (h._caScrollDist = p[n.p] - m[n.p]), (e = (e / h._caScrollDist) * d)), h && h.seek(v), h ? e : Math.round(e);
                    },
                    ei = /(webkit|moz|length|cssText|inset)/i,
                    ti = function (e, t, i, n) {
                        if (e.parentNode !== t) {
                            var r,
                                s,
                                o = e.style;
                            if (t === X) {
                                for (r in ((e._stOrig = o.cssText), (s = ut(e)))) +r || ei.test(r) || !s[r] || "string" != typeof o[r] || "0" === r || (o[r] = s[r]);
                                (o.top = i), (o.left = n);
                            } else o.cssText = e._stOrig;
                            (H.core.getCache(e).uncache = 1), t.appendChild(e);
                        }
                    },
                    ii = function (e, t, i) {
                        var n = t,
                            r = n;
                        return function (t) {
                            var s = Math.round(e());
                            return s !== n && s !== r && Math.abs(s - n) > 3 && Math.abs(s - r) > 3 && ((t = s), i && i()), (r = n), (n = t), t;
                        };
                    },
                    ni = function (e, t, i) {
                        var n = {};
                        (n[t.p] = "+=" + i), H.set(e, n);
                    },
                    ri = function (e, t) {
                        var i = D(e, t),
                            n = "_scroll" + t.p2,
                            r = function t(r, s, o, a, l) {
                                var c = t.tween,
                                    u = s.onComplete,
                                    d = {};
                                o = o || i();
                                var h = ii(i, o, function () {
                                    c.kill(), (t.tween = 0);
                                });
                                return (
                                    (l = (a && l) || 0),
                                    (a = a || r - o),
                                    c && c.kill(),
                                    (s[n] = r),
                                    (s.modifiers = d),
                                    (d[n] = function () {
                                        return h(o + a * c.ratio + l * c.ratio * c.ratio);
                                    }),
                                    (s.onUpdate = function () {
                                        w.cache++, Yt();
                                    }),
                                    (s.onComplete = function () {
                                        (t.tween = 0), u && u.call(c);
                                    }),
                                    (c = t.tween = H.to(e, s))
                                );
                            };
                        return (
                            (e[n] = i),
                            (i.wheelHandler = function () {
                                return r.tween && r.tween.kill() && (r.tween = 0);
                            }),
                            vt(e, "wheel", i.wheelHandler),
                            si.isTouch && vt(e, "touchmove", i.wheelHandler),
                            r
                        );
                    },
                    si = (function () {
                        function e(t, i) {
                            q || e.register(H) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), me(this), this.init(t, i);
                        }
                        return (
                            (e.prototype.init = function (t, i) {
                                if (((this.progress = this.start = 0), this.vars && this.kill(!0, !0), Ce)) {
                                    var n,
                                        r,
                                        s,
                                        o,
                                        a,
                                        l,
                                        c,
                                        u,
                                        d,
                                        h,
                                        f,
                                        p,
                                        m,
                                        g,
                                        v,
                                        b,
                                        y,
                                        S,
                                        E,
                                        T,
                                        M,
                                        P,
                                        C,
                                        O,
                                        L,
                                        k,
                                        j,
                                        R,
                                        F,
                                        $,
                                        N,
                                        B,
                                        q,
                                        G,
                                        U,
                                        Q,
                                        ie,
                                        re,
                                        se,
                                        oe,
                                        ce,
                                        ue,
                                        de = (t = dt(qe(t) || Ye(t) || t.nodeType ? { trigger: t } : t, xt)),
                                        he = de.onUpdate,
                                        fe = de.toggleClass,
                                        pe = de.id,
                                        me = de.onToggle,
                                        ge = de.onRefresh,
                                        ve = de.scrub,
                                        be = de.trigger,
                                        we = de.pin,
                                        Me = de.pinSpacing,
                                        ke = de.invalidateOnRefresh,
                                        Ae = de.anticipatePin,
                                        Ie = de.onScrubComplete,
                                        je = de.onSnapComplete,
                                        Re = de.once,
                                        He = de.snap,
                                        Ze = de.pinReparent,
                                        Ke = de.pinSpacer,
                                        Je = de.containerAnimation,
                                        gt = de.fastScrollEnd,
                                        yt = de.preventOverlaps,
                                        St = t.horizontal || (t.containerAnimation && !1 !== t.horizontal) ? A : I,
                                        Tt = !ve && 0 !== ve,
                                        Ct = z(t.scroller || V),
                                        Lt = H.core.getCache(Ct),
                                        At = Fe(Ct),
                                        It = "fixed" === ("pinType" in t ? t.pinType : _(Ct, "pinType") || (At && "fixed")),
                                        Dt = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
                                        jt = Tt && t.toggleActions.split(" "),
                                        Rt = "markers" in t ? t.markers : xt.markers,
                                        Ft = At ? 0 : parseFloat(ut(Ct)["border" + St.p2 + at]) || 0,
                                        $t = this,
                                        Bt =
                                            t.onRefreshInit &&
                                            function () {
                                                return t.onRefreshInit($t);
                                            },
                                        qt = (function (e, t, i) {
                                            var n = i.d,
                                                r = i.d2,
                                                s = i.a;
                                            return (s = _(e, "getBoundingClientRect"))
                                                ? function () {
                                                      return s()[n];
                                                  }
                                                : function () {
                                                      return (t ? $e(r) : e["client" + r]) || 0;
                                                  };
                                        })(Ct, At, St),
                                        Yt = (function (e, t) {
                                            return !t || ~x.indexOf(e)
                                                ? Ne(e)
                                                : function () {
                                                      return Jt;
                                                  };
                                        })(Ct, At),
                                        Wt = 0,
                                        Xt = 0,
                                        Ut = 0,
                                        ei = D(Ct, St);
                                    if (
                                        (($t._startClamp = $t._endClamp = !1),
                                        ($t._dir = St),
                                        (Ae *= 45),
                                        ($t.scroller = Ct),
                                        ($t.scroll = Je ? Je.time.bind(Je) : ei),
                                        (o = ei()),
                                        ($t.vars = t),
                                        (i = i || t.animation),
                                        "refreshPriority" in t && ((ae = 1), -9999 === t.refreshPriority && (Ee = $t)),
                                        (Lt.tweenScroll = Lt.tweenScroll || { top: ri(Ct, I), left: ri(Ct, A) }),
                                        ($t.tweenTo = n = Lt.tweenScroll[St.p]),
                                        ($t.scrubDuration = function (e) {
                                            (q = Ye(e) && e)
                                                ? B
                                                    ? B.duration(e)
                                                    : (B = H.to(i, {
                                                          ease: "expo",
                                                          totalProgress: "+=0",
                                                          duration: q,
                                                          paused: !0,
                                                          onComplete: function () {
                                                              return Ie && Ie($t);
                                                          },
                                                      }))
                                                : (B && B.progress(1).kill(), (B = 0));
                                        }),
                                        i &&
                                            ((i.vars.lazy = !1),
                                            (i._initted && !$t.isReverted) || (!1 !== i.vars.immediateRender && !1 !== t.immediateRender && i.duration() && i.render(0, !0, !0)),
                                            ($t.animation = i.pause()),
                                            (i.scrollTrigger = $t),
                                            $t.scrubDuration(ve),
                                            ($ = 0),
                                            pe || (pe = i.vars.id)),
                                        He &&
                                            ((We(He) && !He.push) || (He = { snapTo: He }),
                                            "scrollBehavior" in X.style && H.set(At ? [X, W] : Ct, { scrollBehavior: "auto" }),
                                            w.forEach(function (e) {
                                                return Ve(e) && e.target === (At ? Y.scrollingElement || W : Ct) && (e.smooth = !1);
                                            }),
                                            (s = Ve(He.snapTo)
                                                ? He.snapTo
                                                : "labels" === He.snapTo
                                                ? (function (e) {
                                                      return function (t) {
                                                          return H.utils.snap(pt(e), t);
                                                      };
                                                  })(i)
                                                : "labelsDirectional" === He.snapTo
                                                ? ((oe = i),
                                                  function (e, t) {
                                                      return mt(pt(oe))(e, t.direction);
                                                  })
                                                : !1 !== He.directional
                                                ? function (e, t) {
                                                      return mt(He.snapTo)(e, Te() - Xt < 500 ? 0 : t.direction);
                                                  }
                                                : H.utils.snap(He.snapTo)),
                                            (G = He.duration || { min: 0.1, max: 2 }),
                                            (G = We(G) ? K(G.min, G.max) : K(G, G)),
                                            (U = H.delayedCall(He.delay || q / 2 || 0.1, function () {
                                                var e = ei(),
                                                    t = Te() - Xt < 500,
                                                    r = n.tween;
                                                if (!(t || Math.abs($t.getVelocity()) < 10) || r || te || Wt === e) $t.isActive && Wt !== e && U.restart(!0);
                                                else {
                                                    var o = (e - l) / g,
                                                        a = i && !Tt ? i.totalProgress() : o,
                                                        u = t ? 0 : ((a - N) / (Te() - J)) * 1e3 || 0,
                                                        d = H.utils.clamp(-o, 1 - o, (Ue(u / 2) * u) / 0.185),
                                                        h = o + (!1 === He.inertia ? 0 : d),
                                                        f = K(0, 1, s(h, $t)),
                                                        p = Math.round(l + f * g),
                                                        m = He,
                                                        v = m.onStart,
                                                        b = m.onInterrupt,
                                                        y = m.onComplete;
                                                    if (e <= c && e >= l && p !== e) {
                                                        if (r && !r._initted && r.data <= Ue(p - e)) return;
                                                        !1 === He.inertia && (d = f - o),
                                                            n(
                                                                p,
                                                                {
                                                                    duration: G(Ue((0.185 * Math.max(Ue(h - a), Ue(f - a))) / u / 0.05 || 0)),
                                                                    ease: He.ease || "power3",
                                                                    data: Ue(p - e),
                                                                    onInterrupt: function () {
                                                                        return U.restart(!0) && b && b($t);
                                                                    },
                                                                    onComplete: function () {
                                                                        $t.update(), (Wt = ei()), ($ = N = i && !Tt ? i.totalProgress() : $t.progress), je && je($t), y && y($t);
                                                                    },
                                                                },
                                                                e,
                                                                d * g,
                                                                p - e - d * g
                                                            ),
                                                            v && v($t, n.tween);
                                                    }
                                                }
                                            }).pause())),
                                        pe && (Pt[pe] = $t),
                                        (se = (be = $t.trigger = z(be || (!0 !== we && we))) && be._gsap && be._gsap.stRevert) && (se = se($t)),
                                        (we = !0 === we ? be : z(we)),
                                        qe(fe) && (fe = { targets: be, className: fe }),
                                        we &&
                                            (!1 === Me || Me === ot || (Me = !(!Me && we.parentNode && we.parentNode.style && "flex" === ut(we.parentNode).display) && st),
                                            ($t.pin = we),
                                            (r = H.core.getCache(we)).spacer
                                                ? (v = r.pinState)
                                                : (Ke && ((Ke = z(Ke)) && !Ke.nodeType && (Ke = Ke.current || Ke.nativeElement), (r.spacerIsNative = !!Ke), Ke && (r.spacerState = Kt(Ke))),
                                                  (r.spacer = S = Ke || Y.createElement("div")),
                                                  S.classList.add("pin-spacer"),
                                                  pe && S.classList.add("pin-spacer-" + pe),
                                                  (r.pinState = v = Kt(we))),
                                            !1 !== t.force3D && H.set(we, { force3D: !0 }),
                                            ($t.spacer = S = r.spacer),
                                            (F = ut(we)),
                                            (O = F[Me + St.os2]),
                                            (T = H.getProperty(we)),
                                            (M = H.quickSetter(we, St.a, ct)),
                                            Gt(we, S, F),
                                            (y = Kt(we))),
                                        Rt)
                                    ) {
                                        (p = We(Rt) ? dt(Rt, wt) : wt), (h = _t("scroller-start", pe, Ct, St, p, 0)), (f = _t("scroller-end", pe, Ct, St, p, 0, h)), (E = h["offset" + St.op.d2]);
                                        var ii = z(_(Ct, "content") || Ct);
                                        (u = this.markerStart = _t("start", pe, ii, St, p, E, 0, Je)),
                                            (d = this.markerEnd = _t("end", pe, ii, St, p, E, 0, Je)),
                                            Je && (re = H.quickSetter([u, d], St.a, ct)),
                                            It ||
                                                (x.length && !0 === _(Ct, "fixedMarkers")) ||
                                                ((ue = ut((ce = At ? X : Ct)).position),
                                                (ce.style.position = "absolute" === ue || "fixed" === ue ? ue : "relative"),
                                                H.set([h, f], { force3D: !0 }),
                                                (k = H.quickSetter(h, St.a, ct)),
                                                (R = H.quickSetter(f, St.a, ct)));
                                    }
                                    if (Je) {
                                        var si = Je.vars.onUpdate,
                                            oi = Je.vars.onUpdateParams;
                                        Je.eventCallback("onUpdate", function () {
                                            $t.update(0, 0, 1), si && si.apply(Je, oi || []);
                                        });
                                    }
                                    if (
                                        (($t.previous = function () {
                                            return Mt[Mt.indexOf($t) - 1];
                                        }),
                                        ($t.next = function () {
                                            return Mt[Mt.indexOf($t) + 1];
                                        }),
                                        ($t.revert = function (e, t) {
                                            if (!t) return $t.kill(!0);
                                            var n = !1 !== e || !$t.enabled,
                                                r = ee;
                                            n !== $t.isReverted &&
                                                (n && ((Q = Math.max(ei(), $t.scroll.rec || 0)), (Ut = $t.progress), (ie = i && i.progress())),
                                                u &&
                                                    [u, d, h, f].forEach(function (e) {
                                                        return (e.style.display = n ? "none" : "block");
                                                    }),
                                                n && ((ee = $t), $t.update(n)),
                                                !we ||
                                                    (Ze && $t.isActive) ||
                                                    (n
                                                        ? (function (e, t, i) {
                                                              Zt(i);
                                                              var n = e._gsap;
                                                              if (n.spacerIsNative) Zt(n.spacerState);
                                                              else if (e._gsap.swappedIn) {
                                                                  var r = t.parentNode;
                                                                  r && (r.insertBefore(e, t), r.removeChild(t));
                                                              }
                                                              e._gsap.swappedIn = !1;
                                                          })(we, S, v)
                                                        : Gt(we, S, ut(we), L)),
                                                n || $t.update(n),
                                                (ee = r),
                                                ($t.isReverted = n));
                                        }),
                                        ($t.refresh = function (r, s, p, w) {
                                            if ((!ee && $t.enabled) || s)
                                                if (we && r && Pe) vt(e, "scrollEnd", zt);
                                                else {
                                                    !xe && Bt && Bt($t),
                                                        (ee = $t),
                                                        n.tween && !p && (n.tween.kill(), (n.tween = 0)),
                                                        B && B.pause(),
                                                        ke && i && i.revert({ kill: !1 }).invalidate(),
                                                        $t.isReverted || $t.revert(!0, !0),
                                                        ($t._subPinOffset = !1);
                                                    var x,
                                                        E,
                                                        _,
                                                        M,
                                                        O,
                                                        k,
                                                        R,
                                                        F,
                                                        $,
                                                        N,
                                                        q,
                                                        V,
                                                        G,
                                                        Z = qt(),
                                                        K = Yt(),
                                                        J = Je ? Je.duration() : Be(Ct, St),
                                                        te = g <= 0.01,
                                                        ne = 0,
                                                        re = w || 0,
                                                        se = We(p) ? p.end : t.end,
                                                        oe = t.endTrigger || be,
                                                        ae = We(p) ? p.start : t.start || (0 !== t.start && be ? (we ? "0 0" : "0 100%") : 0),
                                                        ce = ($t.pinnedContainer = t.pinnedContainer && z(t.pinnedContainer, $t)),
                                                        ue = (be && Math.max(0, Mt.indexOf($t))) || 0,
                                                        de = ue;
                                                    for (Rt && We(p) && ((V = H.getProperty(h, St.p)), (G = H.getProperty(f, St.p))); de--; )
                                                        (k = Mt[de]).end || k.refresh(0, 1) || (ee = $t),
                                                            !(R = k.pin) || (R !== be && R !== we && R !== ce) || k.isReverted || (N || (N = []), N.unshift(k), k.revert(!0, !0)),
                                                            k !== Mt[de] && (ue--, de--);
                                                    for (
                                                        Ve(ae) && (ae = ae($t)),
                                                            ae = Oe(ae, "start", $t),
                                                            l = Qt(ae, be, Z, St, ei(), u, h, $t, K, Ft, It, J, Je, $t._startClamp && "_startClamp") || (we ? -0.001 : 0),
                                                            Ve(se) && (se = se($t)),
                                                            qe(se) &&
                                                                !se.indexOf("+=") &&
                                                                (~se.indexOf(" ")
                                                                    ? (se = (qe(ae) ? ae.split(" ")[0] : "") + se)
                                                                    : ((ne = Et(se.substr(2), Z)), (se = qe(ae) ? ae : (Je ? H.utils.mapRange(0, Je.duration(), Je.scrollTrigger.start, Je.scrollTrigger.end, l) : l) + ne), (oe = be))),
                                                            se = Oe(se, "end", $t),
                                                            c = Math.max(l, Qt(se || (oe ? "100% 0" : J), oe, Z, St, ei() + ne, d, f, $t, K, Ft, It, J, Je, $t._endClamp && "_endClamp")) || -0.001,
                                                            ne = 0,
                                                            de = ue;
                                                        de--;

                                                    )
                                                        (R = (k = Mt[de]).pin) &&
                                                            k.start - k._pinPush <= l &&
                                                            !Je &&
                                                            k.end > 0 &&
                                                            ((x = k.end - ($t._startClamp ? Math.max(0, k.start) : k.start)),
                                                            ((R === be && k.start - k._pinPush < l) || R === ce) && isNaN(ae) && (ne += x * (1 - k.progress)),
                                                            R === we && (re += x));
                                                    if (
                                                        ((l += ne),
                                                        (c += ne),
                                                        $t._startClamp && ($t._startClamp += ne),
                                                        $t._endClamp && !xe && (($t._endClamp = c || -0.001), (c = Math.min(c, Be(Ct, St)))),
                                                        (g = c - l || ((l -= 0.01) && 0.001)),
                                                        te && (Ut = H.utils.clamp(0, 1, H.utils.normalize(l, c, Q))),
                                                        ($t._pinPush = re),
                                                        u && ne && (((x = {})[St.a] = "+=" + ne), ce && (x[St.p] = "-=" + ei()), H.set([u, d], x)),
                                                        we)
                                                    )
                                                        (x = ut(we)),
                                                            (M = St === I),
                                                            (_ = ei()),
                                                            (P = parseFloat(T(St.a)) + re),
                                                            !J &&
                                                                c > 1 &&
                                                                ((q = { style: (q = (At ? Y.scrollingElement || W : Ct).style), value: q["overflow" + St.a.toUpperCase()] }),
                                                                At && "scroll" !== ut(X)["overflow" + St.a.toUpperCase()] && (q.style["overflow" + St.a.toUpperCase()] = "scroll")),
                                                            Gt(we, S, x),
                                                            (y = Kt(we)),
                                                            (E = ht(we, !0)),
                                                            (F = It && D(Ct, M ? A : I)()),
                                                            Me &&
                                                                (((L = [Me + St.os2, g + re + ct]).t = S),
                                                                (de = Me === st ? ft(we, St) + g + re : 0) && L.push(St.d, de + ct),
                                                                Zt(L),
                                                                ce &&
                                                                    Mt.forEach(function (e) {
                                                                        e.pin === ce && !1 !== e.vars.pinSpacing && (e._subPinOffset = !0);
                                                                    }),
                                                                It && ei(Q)),
                                                            It &&
                                                                (((O = { top: E.top + (M ? _ - l : F) + ct, left: E.left + (M ? F : _ - l) + ct, boxSizing: "border-box", position: "fixed" })[Qe] = O["max" + at] = Math.ceil(E.width) + ct),
                                                                (O[et] = O["max" + lt] = Math.ceil(E.height) + ct),
                                                                (O[ot] = O[ot + nt] = O[ot + tt] = O[ot + rt] = O[ot + it] = "0"),
                                                                (O[st] = x[st]),
                                                                (O[st + nt] = x[st + nt]),
                                                                (O[st + tt] = x[st + tt]),
                                                                (O[st + rt] = x[st + rt]),
                                                                (O[st + it] = x[st + it]),
                                                                (b = (function (e, t, i) {
                                                                    for (var n, r = [], s = e.length, o = i ? 8 : 0; o < s; o += 2) (n = e[o]), r.push(n, n in t ? t[n] : e[o + 1]);
                                                                    return (r.t = e.t), r;
                                                                })(v, O, Ze)),
                                                                xe && ei(0)),
                                                            i
                                                                ? (($ = i._initted),
                                                                  le(1),
                                                                  i.render(i.duration(), !0, !0),
                                                                  (C = T(St.a) - P + g + re),
                                                                  (j = Math.abs(g - C) > 1),
                                                                  It && j && b.splice(b.length - 2, 2),
                                                                  i.render(0, !0, !0),
                                                                  $ || i.invalidate(!0),
                                                                  i.parent || i.totalTime(i.totalTime()),
                                                                  le(0))
                                                                : (C = g),
                                                            q && (q.value ? (q.style["overflow" + St.a.toUpperCase()] = q.value) : q.style.removeProperty("overflow-" + St.a));
                                                    else if (be && ei() && !Je) for (E = be.parentNode; E && E !== X; ) E._pinOffset && ((l -= E._pinOffset), (c -= E._pinOffset)), (E = E.parentNode);
                                                    N &&
                                                        N.forEach(function (e) {
                                                            return e.revert(!1, !0);
                                                        }),
                                                        ($t.start = l),
                                                        ($t.end = c),
                                                        (o = a = xe ? Q : ei()),
                                                        Je || xe || (o < Q && ei(Q), ($t.scroll.rec = 0)),
                                                        $t.revert(!1, !0),
                                                        (Xt = Te()),
                                                        U && ((Wt = -1), U.restart(!0)),
                                                        (ee = 0),
                                                        i && Tt && (i._initted || ie) && i.progress() !== ie && i.progress(ie || 0, !0).render(i.time(), !0, !0),
                                                        (te || Ut !== $t.progress || Je) && (i && !Tt && i.totalProgress(Je && l < -0.001 && !Ut ? H.utils.normalize(l, c, 0) : Ut, !0), ($t.progress = te || (o - l) / g === Ut ? 0 : Ut)),
                                                        we && Me && (S._pinOffset = Math.round($t.progress * C)),
                                                        B && B.invalidate(),
                                                        isNaN(V) || ((V -= H.getProperty(h, St.p)), (G -= H.getProperty(f, St.p)), ni(h, St, V), ni(u, St, V - (w || 0)), ni(f, St, G), ni(d, St, G - (w || 0))),
                                                        te && !xe && $t.update(),
                                                        !ge || xe || m || ((m = !0), ge($t), (m = !1));
                                                }
                                        }),
                                        ($t.getVelocity = function () {
                                            return ((ei() - a) / (Te() - J)) * 1e3 || 0;
                                        }),
                                        ($t.endAnimation = function () {
                                            Xe($t.callbackAnimation), i && (B ? B.progress(1) : i.paused() ? Tt || Xe(i, $t.direction < 0, 1) : Xe(i, i.reversed()));
                                        }),
                                        ($t.labelToScroll = function (e) {
                                            return (i && i.labels && (l || $t.refresh() || l) + (i.labels[e] / i.duration()) * g) || 0;
                                        }),
                                        ($t.getTrailing = function (e) {
                                            var t = Mt.indexOf($t),
                                                i = $t.direction > 0 ? Mt.slice(0, t).reverse() : Mt.slice(t + 1);
                                            return (qe(e)
                                                ? i.filter(function (t) {
                                                      return t.vars.preventOverlaps === e;
                                                  })
                                                : i
                                            ).filter(function (e) {
                                                return $t.direction > 0 ? e.end <= l : e.start >= c;
                                            });
                                        }),
                                        ($t.update = function (e, t, r) {
                                            if (!Je || r || e) {
                                                var s,
                                                    u,
                                                    d,
                                                    f,
                                                    p,
                                                    m,
                                                    v,
                                                    w = !0 === xe ? Q : $t.scroll(),
                                                    x = e ? 0 : (w - l) / g,
                                                    E = x < 0 ? 0 : x > 1 ? 1 : x || 0,
                                                    _ = $t.progress;
                                                if (
                                                    (t && ((a = o), (o = Je ? ei() : w), He && ((N = $), ($ = i && !Tt ? i.totalProgress() : E))),
                                                    Ae && !E && we && !ee && !_e && Pe && l < w + ((w - a) / (Te() - J)) * Ae && (E = 1e-4),
                                                    E !== _ && $t.enabled)
                                                ) {
                                                    if (
                                                        ((f = (p = (s = $t.isActive = !!E && E < 1) != (!!_ && _ < 1)) || !!E != !!_),
                                                        ($t.direction = E > _ ? 1 : -1),
                                                        ($t.progress = E),
                                                        f &&
                                                            !ee &&
                                                            ((u = E && !_ ? 0 : 1 === E ? 1 : 1 === _ ? 2 : 3), Tt && ((d = (!p && "none" !== jt[u + 1] && jt[u + 1]) || jt[u]), (v = i && ("complete" === d || "reset" === d || d in i)))),
                                                        yt &&
                                                            (p || v) &&
                                                            (v || ve || !i) &&
                                                            (Ve(yt)
                                                                ? yt($t)
                                                                : $t.getTrailing(yt).forEach(function (e) {
                                                                      return e.endAnimation();
                                                                  })),
                                                        Tt ||
                                                            (!B || ee || _e
                                                                ? i && i.totalProgress(E, !(!ee || (!Xt && !e)))
                                                                : (B._dp._time - B._start !== B._time && B.render(B._dp._time - B._start),
                                                                  B.resetTo ? B.resetTo("totalProgress", E, i._tTime / i._tDur) : ((B.vars.totalProgress = E), B.invalidate().restart()))),
                                                        we)
                                                    )
                                                        if ((e && Me && (S.style[Me + St.os2] = O), It)) {
                                                            if (f) {
                                                                if (((m = !e && E > _ && c + 1 > w && w + 1 >= Be(Ct, St)), Ze))
                                                                    if (e || (!s && !m)) ti(we, S);
                                                                    else {
                                                                        var T = ht(we, !0),
                                                                            L = w - l;
                                                                        ti(we, X, T.top + (St === I ? L : 0) + ct, T.left + (St === I ? 0 : L) + ct);
                                                                    }
                                                                Zt(s || m ? b : y), (j && E < 1 && s) || M(P + (1 !== E || m ? 0 : C));
                                                            }
                                                        } else M(De(P + C * E));
                                                    He && !n.tween && !ee && !_e && U.restart(!0),
                                                        fe &&
                                                            (p || (Re && E && (E < 1 || !ye))) &&
                                                            Z(fe.targets).forEach(function (e) {
                                                                return e.classList[s || Re ? "add" : "remove"](fe.className);
                                                            }),
                                                        he && !Tt && !e && he($t),
                                                        f && !ee
                                                            ? (Tt && (v && ("complete" === d ? i.pause().totalProgress(1) : "reset" === d ? i.restart(!0).pause() : "restart" === d ? i.restart(!0) : i[d]()), he && he($t)),
                                                              (!p && ye) || (me && p && Ge($t, me), Dt[u] && Ge($t, Dt[u]), Re && (1 === E ? $t.kill(!1, 1) : (Dt[u] = 0)), p || (Dt[(u = 1 === E ? 1 : 3)] && Ge($t, Dt[u]))),
                                                              gt && !s && Math.abs($t.getVelocity()) > (Ye(gt) ? gt : 2500) && (Xe($t.callbackAnimation), B ? B.progress(1) : Xe(i, "reverse" === d ? 1 : !E, 1)))
                                                            : Tt && he && !ee && he($t);
                                                }
                                                if (R) {
                                                    var A = Je ? (w / Je.duration()) * (Je._caScrollDist || 0) : w;
                                                    k(A + (h._isFlipped ? 1 : 0)), R(A);
                                                }
                                                re && re((-w / Je.duration()) * (Je._caScrollDist || 0));
                                            }
                                        }),
                                        ($t.enable = function (t, i) {
                                            $t.enabled ||
                                                (($t.enabled = !0), vt(Ct, "resize", kt), At || vt(Ct, "scroll", Ot), Bt && vt(e, "refreshInit", Bt), !1 !== t && (($t.progress = Ut = 0), (o = a = Wt = ei())), !1 !== i && $t.refresh());
                                        }),
                                        ($t.getTween = function (e) {
                                            return e && n ? n.tween : B;
                                        }),
                                        ($t.setPositions = function (e, t, i, n) {
                                            if (Je) {
                                                var r = Je.scrollTrigger,
                                                    s = Je.duration(),
                                                    o = r.end - r.start;
                                                (e = r.start + (o * e) / s), (t = r.start + (o * t) / s);
                                            }
                                            $t.refresh(!1, !1, { start: Le(e, i && !!$t._startClamp), end: Le(t, i && !!$t._endClamp) }, n), $t.update();
                                        }),
                                        ($t.adjustPinSpacing = function (e) {
                                            if (L && e) {
                                                var t = L.indexOf(St.d) + 1;
                                                (L[t] = parseFloat(L[t]) + e + ct), (L[1] = parseFloat(L[1]) + e + ct), Zt(L);
                                            }
                                        }),
                                        ($t.disable = function (t, i) {
                                            if (
                                                $t.enabled &&
                                                (!1 !== t && $t.revert(!0, !0),
                                                ($t.enabled = $t.isActive = !1),
                                                i || (B && B.pause()),
                                                (Q = 0),
                                                r && (r.uncache = 1),
                                                Bt && bt(e, "refreshInit", Bt),
                                                U && (U.pause(), n.tween && n.tween.kill() && (n.tween = 0)),
                                                !At)
                                            ) {
                                                for (var s = Mt.length; s--; ) if (Mt[s].scroller === Ct && Mt[s] !== $t) return;
                                                bt(Ct, "resize", kt), At || bt(Ct, "scroll", Ot);
                                            }
                                        }),
                                        ($t.kill = function (e, n) {
                                            $t.disable(e, n), B && !n && B.kill(), pe && delete Pt[pe];
                                            var s = Mt.indexOf($t);
                                            s >= 0 && Mt.splice(s, 1),
                                                s === ne && Vt > 0 && ne--,
                                                (s = 0),
                                                Mt.forEach(function (e) {
                                                    return e.scroller === $t.scroller && (s = 1);
                                                }),
                                                s || xe || ($t.scroll.rec = 0),
                                                i && ((i.scrollTrigger = null), e && i.revert({ kill: !1 }), n || i.kill()),
                                                u &&
                                                    [u, d, h, f].forEach(function (e) {
                                                        return e.parentNode && e.parentNode.removeChild(e);
                                                    }),
                                                Ee === $t && (Ee = 0),
                                                we &&
                                                    (r && (r.uncache = 1),
                                                    (s = 0),
                                                    Mt.forEach(function (e) {
                                                        return e.pin === we && s++;
                                                    }),
                                                    s || (r.spacer = 0)),
                                                t.onKill && t.onKill($t);
                                        }),
                                        Mt.push($t),
                                        $t.enable(!1, !1),
                                        se && se($t),
                                        i && i.add && !g)
                                    ) {
                                        var ai = $t.update;
                                        ($t.update = function () {
                                            ($t.update = ai), l || c || $t.refresh();
                                        }),
                                            H.delayedCall(0.01, $t.update),
                                            (g = 0.01),
                                            (l = c = 0);
                                    } else $t.refresh();
                                    we &&
                                        (function () {
                                            if (Se !== Nt) {
                                                var e = (Se = Nt);
                                                requestAnimationFrame(function () {
                                                    return e === Nt && Ht(!0);
                                                });
                                            }
                                        })();
                                } else this.update = this.refresh = this.kill = ze;
                            }),
                            (e.register = function (t) {
                                return q || ((H = t || Re()), je() && window.document && e.enable(), (q = Ce)), q;
                            }),
                            (e.defaults = function (e) {
                                if (e) for (var t in e) xt[t] = e[t];
                                return xt;
                            }),
                            (e.disable = function (e, t) {
                                (Ce = 0),
                                    Mt.forEach(function (i) {
                                        return i[t ? "kill" : "disable"](e);
                                    }),
                                    bt(V, "wheel", Ot),
                                    bt(Y, "scroll", Ot),
                                    clearInterval(Q),
                                    bt(Y, "touchcancel", ze),
                                    bt(X, "touchstart", ze),
                                    gt(bt, Y, "pointerdown,touchstart,mousedown", Ae),
                                    gt(bt, Y, "pointerup,touchend,mouseup", Ie),
                                    U.kill(),
                                    He(bt);
                                for (var i = 0; i < w.length; i += 3) yt(bt, w[i], w[i + 1]), yt(bt, w[i], w[i + 2]);
                            }),
                            (e.enable = function () {
                                if (
                                    ((V = window),
                                    (Y = document),
                                    (W = Y.documentElement),
                                    (X = Y.body),
                                    H &&
                                        ((Z = H.utils.toArray),
                                        (K = H.utils.clamp),
                                        (me = H.core.context || ze),
                                        (le = H.core.suppressOverwrites || ze),
                                        (ge = V.history.scrollRestoration || "auto"),
                                        (qt = V.pageYOffset),
                                        H.core.globals("ScrollTrigger", e),
                                        X))
                                ) {
                                    (Ce = 1),
                                        ((ve = document.createElement("div")).style.height = "100vh"),
                                        (ve.style.position = "absolute"),
                                        Bt(),
                                        ke(),
                                        B.register(H),
                                        (e.isTouch = B.isTouch),
                                        (pe = B.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                                        vt(V, "wheel", Ot),
                                        (G = [V, Y, W, X]),
                                        H.matchMedia
                                            ? ((e.matchMedia = function (e) {
                                                  var t,
                                                      i = H.matchMedia();
                                                  for (t in e) i.add(t, e[t]);
                                                  return i;
                                              }),
                                              H.addEventListener("matchMediaInit", function () {
                                                  return Ft();
                                              }),
                                              H.addEventListener("matchMediaRevert", function () {
                                                  return Rt();
                                              }),
                                              H.addEventListener("matchMedia", function () {
                                                  Ht(0, 1), Dt("matchMedia");
                                              }),
                                              H.matchMedia("(orientation: portrait)", function () {
                                                  return Lt(), Lt;
                                              }))
                                            : console.warn("Requires GSAP 3.11.0 or later"),
                                        Lt(),
                                        vt(Y, "scroll", Ot);
                                    var t,
                                        i,
                                        n = X.style,
                                        r = n.borderTopStyle,
                                        s = H.core.Animation.prototype;
                                    for (
                                        s.revert ||
                                            Object.defineProperty(s, "revert", {
                                                value: function () {
                                                    return this.time(-0.01, !0);
                                                },
                                            }),
                                            n.borderTopStyle = "solid",
                                            t = ht(X),
                                            I.m = Math.round(t.top + I.sc()) || 0,
                                            A.m = Math.round(t.left + A.sc()) || 0,
                                            r ? (n.borderTopStyle = r) : n.removeProperty("border-top-style"),
                                            Q = setInterval(Ct, 250),
                                            H.delayedCall(0.5, function () {
                                                return (_e = 0);
                                            }),
                                            vt(Y, "touchcancel", ze),
                                            vt(X, "touchstart", ze),
                                            gt(vt, Y, "pointerdown,touchstart,mousedown", Ae),
                                            gt(vt, Y, "pointerup,touchend,mouseup", Ie),
                                            ie = H.utils.checkPrefix("transform"),
                                            Xt.push(ie),
                                            q = Te(),
                                            U = H.delayedCall(0.2, Ht).pause(),
                                            oe = [
                                                Y,
                                                "visibilitychange",
                                                function () {
                                                    var e = V.innerWidth,
                                                        t = V.innerHeight;
                                                    Y.hidden ? ((re = e), (se = t)) : (re === e && se === t) || kt();
                                                },
                                                Y,
                                                "DOMContentLoaded",
                                                Ht,
                                                V,
                                                "load",
                                                Ht,
                                                V,
                                                "resize",
                                                kt,
                                            ],
                                            He(vt),
                                            Mt.forEach(function (e) {
                                                return e.enable(0, 1);
                                            }),
                                            i = 0;
                                        i < w.length;
                                        i += 3
                                    )
                                        yt(bt, w[i], w[i + 1]), yt(bt, w[i], w[i + 2]);
                                }
                            }),
                            (e.config = function (t) {
                                "limitCallbacks" in t && (ye = !!t.limitCallbacks);
                                var i = t.syncInterval;
                                (i && clearInterval(Q)) || ((Q = i) && setInterval(Ct, i)),
                                    "ignoreMobileResize" in t && (de = 1 === e.isTouch && t.ignoreMobileResize),
                                    "autoRefreshEvents" in t && (He(bt) || He(vt, t.autoRefreshEvents || "none"), (ce = -1 === (t.autoRefreshEvents + "").indexOf("resize")));
                            }),
                            (e.scrollerProxy = function (e, t) {
                                var i = z(e),
                                    n = w.indexOf(i),
                                    r = Fe(i);
                                ~n && w.splice(n, r ? 6 : 2), t && (r ? x.unshift(V, t, X, t, W, t) : x.unshift(i, t));
                            }),
                            (e.clearMatchMedia = function (e) {
                                Mt.forEach(function (t) {
                                    return t._ctx && t._ctx.query === e && t._ctx.kill(!0, !0);
                                });
                            }),
                            (e.isInViewport = function (e, t, i) {
                                var n = (qe(e) ? z(e) : e).getBoundingClientRect(),
                                    r = n[i ? Qe : et] * t || 0;
                                return i ? n.right - r > 0 && n.left + r < V.innerWidth : n.bottom - r > 0 && n.top + r < V.innerHeight;
                            }),
                            (e.positionInViewport = function (e, t, i) {
                                qe(e) && (e = z(e));
                                var n = e.getBoundingClientRect(),
                                    r = n[i ? Qe : et],
                                    s = null == t ? r / 2 : t in St ? St[t] * r : ~t.indexOf("%") ? (parseFloat(t) * r) / 100 : parseFloat(t) || 0;
                                return i ? (n.left + s) / V.innerWidth : (n.top + s) / V.innerHeight;
                            }),
                            (e.killAll = function (e) {
                                if (
                                    (Mt.slice(0).forEach(function (e) {
                                        return "ScrollSmoother" !== e.vars.id && e.kill();
                                    }),
                                    !0 !== e)
                                ) {
                                    var t = At.killAll || [];
                                    (At = {}),
                                        t.forEach(function (e) {
                                            return e();
                                        });
                                }
                            }),
                            e
                        );
                    })();
                (si.version = "3.12.2"),
                    (si.saveStyles = function (e) {
                        return e
                            ? Z(e).forEach(function (e) {
                                  if (e && e.style) {
                                      var t = jt.indexOf(e);
                                      t >= 0 && jt.splice(t, 5), jt.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), H.core.getCache(e), me());
                                  }
                              })
                            : jt;
                    }),
                    (si.revert = function (e, t) {
                        return Ft(!e, t);
                    }),
                    (si.create = function (e, t) {
                        return new si(e, t);
                    }),
                    (si.refresh = function (e) {
                        return e ? kt() : (q || si.register()) && Ht(!0);
                    }),
                    (si.update = function (e) {
                        return ++w.cache && Yt(!0 === e ? 2 : 0);
                    }),
                    (si.clearScrollMemory = $t),
                    (si.maxScroll = function (e, t) {
                        return Be(e, t ? A : I);
                    }),
                    (si.getScrollFunc = function (e, t) {
                        return D(z(e), t ? A : I);
                    }),
                    (si.getById = function (e) {
                        return Pt[e];
                    }),
                    (si.getAll = function () {
                        return Mt.filter(function (e) {
                            return "ScrollSmoother" !== e.vars.id;
                        });
                    }),
                    (si.isScrolling = function () {
                        return !!Pe;
                    }),
                    (si.snapDirectional = mt),
                    (si.addEventListener = function (e, t) {
                        var i = At[e] || (At[e] = []);
                        ~i.indexOf(t) || i.push(t);
                    }),
                    (si.removeEventListener = function (e, t) {
                        var i = At[e],
                            n = i && i.indexOf(t);
                        n >= 0 && i.splice(n, 1);
                    }),
                    (si.batch = function (e, t) {
                        var i,
                            n = [],
                            r = {},
                            s = t.interval || 0.016,
                            o = t.batchMax || 1e9,
                            a = function (e, t) {
                                var i = [],
                                    n = [],
                                    r = H.delayedCall(s, function () {
                                        t(i, n), (i = []), (n = []);
                                    }).pause();
                                return function (e) {
                                    i.length || r.restart(!0), i.push(e.trigger), n.push(e), o <= i.length && r.progress(1);
                                };
                            };
                        for (i in t) r[i] = "on" === i.substr(0, 2) && Ve(t[i]) && "onRefreshInit" !== i ? a(0, t[i]) : t[i];
                        return (
                            Ve(o) &&
                                ((o = o()),
                                vt(si, "refresh", function () {
                                    return (o = t.batchMax());
                                })),
                            Z(e).forEach(function (e) {
                                var t = {};
                                for (i in r) t[i] = r[i];
                                (t.trigger = e), n.push(si.create(t));
                            }),
                            n
                        );
                    });
                var oi,
                    ai = function (e, t, i, n) {
                        return t > n ? e(n) : t < 0 && e(0), i > n ? (n - t) / (i - t) : i < 0 ? t / (t - i) : 1;
                    },
                    li = function e(t, i) {
                        !0 === i ? t.style.removeProperty("touch-action") : (t.style.touchAction = !0 === i ? "auto" : i ? "pan-" + i + (B.isTouch ? " pinch-zoom" : "") : "none"), t === W && e(X, i);
                    },
                    ci = { auto: 1, scroll: 1 },
                    ui = function (e) {
                        var t,
                            i = e.event,
                            n = e.target,
                            r = e.axis,
                            s = (i.changedTouches ? i.changedTouches[0] : i).target,
                            o = s._gsap || H.core.getCache(s),
                            a = Te();
                        if (!o._isScrollT || a - o._isScrollT > 2e3) {
                            for (; s && s !== X && ((s.scrollHeight <= s.clientHeight && s.scrollWidth <= s.clientWidth) || (!ci[(t = ut(s)).overflowY] && !ci[t.overflowX])); ) s = s.parentNode;
                            (o._isScroll = s && s !== n && !Fe(s) && (ci[(t = ut(s)).overflowY] || ci[t.overflowX])), (o._isScrollT = a);
                        }
                        (o._isScroll || "x" === r) && (i.stopPropagation(), (i._gsapAllow = !0));
                    },
                    di = function (e, t, i, n) {
                        return B.create({
                            target: e,
                            capture: !0,
                            debounce: !1,
                            lockAxis: !0,
                            type: t,
                            onWheel: (n = n && ui),
                            onPress: n,
                            onDrag: n,
                            onScroll: n,
                            onEnable: function () {
                                return i && vt(Y, B.eventTypes[0], fi, !1, !0);
                            },
                            onDisable: function () {
                                return bt(Y, B.eventTypes[0], fi, !0);
                            },
                        });
                    },
                    hi = /(input|label|select|textarea)/i,
                    fi = function (e) {
                        var t = hi.test(e.target.tagName);
                        (t || oi) && ((e._gsapAllow = !0), (oi = t));
                    };
                (si.sort = function (e) {
                    return Mt.sort(
                        e ||
                            function (e, t) {
                                return -1e6 * (e.vars.refreshPriority || 0) + e.start - (t.start + -1e6 * (t.vars.refreshPriority || 0));
                            }
                    );
                }),
                    (si.observe = function (e) {
                        return new B(e);
                    }),
                    (si.normalizeScroll = function (e) {
                        if (void 0 === e) return ue;
                        if (!0 === e && ue) return ue.enable();
                        if (!1 === e) return ue && ue.kill();
                        var t =
                            e instanceof B
                                ? e
                                : (function (e) {
                                      We(e) || (e = {}), (e.preventDefault = e.isNormalizer = e.allowClicks = !0), e.type || (e.type = "wheel,touch"), (e.debounce = !!e.debounce), (e.id = e.id || "normalizer");
                                      var t,
                                          i,
                                          n,
                                          r,
                                          s,
                                          o,
                                          a,
                                          l,
                                          c = e,
                                          u = c.normalizeScrollX,
                                          d = c.momentum,
                                          h = c.allowNestedScroll,
                                          f = c.onRelease,
                                          p = z(e.target) || W,
                                          m = H.core.globals().ScrollSmoother,
                                          g = m && m.get(),
                                          v = pe && ((e.content && z(e.content)) || (g && !1 !== e.content && !g.smooth() && g.content())),
                                          b = D(p, I),
                                          y = D(p, A),
                                          x = 1,
                                          S = (B.isTouch && V.visualViewport ? V.visualViewport.scale * V.visualViewport.width : V.outerWidth) / V.innerWidth,
                                          E = 0,
                                          _ = Ve(d)
                                              ? function () {
                                                    return d(t);
                                                }
                                              : function () {
                                                    return d || 2.8;
                                                },
                                          T = di(p, e.type, !0, h),
                                          M = function () {
                                              return (r = !1);
                                          },
                                          P = ze,
                                          C = ze,
                                          O = function () {
                                              (i = Be(p, I)), (C = K(pe ? 1 : 0, i)), u && (P = K(0, Be(p, A))), (n = Nt);
                                          },
                                          L = function () {
                                              (v._gsap.y = De(parseFloat(v._gsap.y) + b.offset) + "px"),
                                                  (v.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(v._gsap.y) + ", 0, 1)"),
                                                  (b.offset = b.cacheID = 0);
                                          },
                                          k = function () {
                                              O(), s.isActive() && s.vars.scrollY > i && (b() > i ? s.progress(1) && b(i) : s.resetTo("scrollY", i));
                                          };
                                      return (
                                          v && H.set(v, { y: "+=0" }),
                                          (e.ignoreCheck = function (e) {
                                              return (
                                                  (pe &&
                                                      "touchmove" === e.type &&
                                                      (function () {
                                                          if (r) {
                                                              requestAnimationFrame(M);
                                                              var e = De(t.deltaY / 2),
                                                                  i = C(b.v - e);
                                                              if (v && i !== b.v + b.offset) {
                                                                  b.offset = i - b.v;
                                                                  var n = De((parseFloat(v && v._gsap.y) || 0) - b.offset);
                                                                  (v.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + n + ", 0, 1)"), (v._gsap.y = n + "px"), (b.cacheID = w.cache), Yt();
                                                              }
                                                              return !0;
                                                          }
                                                          b.offset && L(), (r = !0);
                                                      })()) ||
                                                  (x > 1.05 && "touchstart" !== e.type) ||
                                                  t.isGesturing ||
                                                  (e.touches && e.touches.length > 1)
                                              );
                                          }),
                                          (e.onPress = function () {
                                              r = !1;
                                              var e = x;
                                              (x = De(((V.visualViewport && V.visualViewport.scale) || 1) / S)), s.pause(), e !== x && li(p, x > 1.01 || (!u && "x")), (o = y()), (a = b()), O(), (n = Nt);
                                          }),
                                          (e.onRelease = e.onGestureStart = function (e, t) {
                                              if ((b.offset && L(), t)) {
                                                  w.cache++;
                                                  var n,
                                                      r,
                                                      o = _();
                                                  u && ((r = (n = y()) + (0.05 * o * -e.velocityX) / 0.227), (o *= ai(y, n, r, Be(p, A))), (s.vars.scrollX = P(r))),
                                                      (r = (n = b()) + (0.05 * o * -e.velocityY) / 0.227),
                                                      (o *= ai(b, n, r, Be(p, I))),
                                                      (s.vars.scrollY = C(r)),
                                                      s.invalidate().duration(o).play(0.01),
                                                      ((pe && s.vars.scrollY >= i) || n >= i - 1) && H.to({}, { onUpdate: k, duration: o });
                                              } else l.restart(!0);
                                              f && f(e);
                                          }),
                                          (e.onWheel = function () {
                                              s._ts && s.pause(), Te() - E > 1e3 && ((n = 0), (E = Te()));
                                          }),
                                          (e.onChange = function (e, t, i, r, s) {
                                              if ((Nt !== n && O(), t && u && y(P(r[2] === t ? o + (e.startX - e.x) : y() + t - r[1])), i)) {
                                                  b.offset && L();
                                                  var l = s[2] === i,
                                                      c = l ? a + e.startY - e.y : b() + i - s[1],
                                                      d = C(c);
                                                  l && c !== d && (a += d - c), b(d);
                                              }
                                              (i || t) && Yt();
                                          }),
                                          (e.onEnable = function () {
                                              li(p, !u && "x"), si.addEventListener("refresh", k), vt(V, "resize", k), b.smooth && ((b.target.style.scrollBehavior = "auto"), (b.smooth = y.smooth = !1)), T.enable();
                                          }),
                                          (e.onDisable = function () {
                                              li(p, !0), bt(V, "resize", k), si.removeEventListener("refresh", k), T.kill();
                                          }),
                                          (e.lockAxis = !1 !== e.lockAxis),
                                          ((t = new B(e)).iOS = pe),
                                          pe && !b() && b(1),
                                          pe && H.ticker.add(ze),
                                          (l = t._dc),
                                          (s = H.to(t, {
                                              ease: "power4",
                                              paused: !0,
                                              scrollX: u ? "+=0.1" : "+=0",
                                              scrollY: "+=0.1",
                                              modifiers: {
                                                  scrollY: ii(b, b(), function () {
                                                      return s.pause();
                                                  }),
                                              },
                                              onUpdate: Yt,
                                              onComplete: l.vars.onComplete,
                                          })),
                                          t
                                      );
                                  })(e);
                        return ue && ue.target === t.target && ue.kill(), Fe(t.target) && (ue = t), t;
                    }),
                    (si.core = {
                        _getVelocityProp: j,
                        _inputObserver: di,
                        _scrollers: w,
                        _proxies: x,
                        bridge: {
                            ss: function () {
                                Pe || Dt("scrollStart"), (Pe = Te());
                            },
                            ref: function () {
                                return ee;
                            },
                        },
                    }),
                    Re() && H.registerPlugin(si);
            },
            6358: function (e, t, i) {
                "use strict";
                function n(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function r(e, t) {
                    (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), (e.__proto__ = t);
                }
                i.r(t),
                    i.d(t, {
                        Back: function () {
                            return Yi;
                        },
                        Bounce: function () {
                            return Xi;
                        },
                        CSSPlugin: function () {
                            return cr;
                        },
                        Circ: function () {
                            return Zi;
                        },
                        Cubic: function () {
                            return Ni;
                        },
                        Elastic: function () {
                            return Vi;
                        },
                        Expo: function () {
                            return Ui;
                        },
                        Linear: function () {
                            return Fi;
                        },
                        Power0: function () {
                            return Ii;
                        },
                        Power1: function () {
                            return zi;
                        },
                        Power2: function () {
                            return Di;
                        },
                        Power3: function () {
                            return ji;
                        },
                        Power4: function () {
                            return Ri;
                        },
                        Quad: function () {
                            return $i;
                        },
                        Quart: function () {
                            return Bi;
                        },
                        Quint: function () {
                            return Hi;
                        },
                        Sine: function () {
                            return Gi;
                        },
                        SteppedEase: function () {
                            return Wi;
                        },
                        Strong: function () {
                            return qi;
                        },
                        TimelineLite: function () {
                            return Nt;
                        },
                        TimelineMax: function () {
                            return Nt;
                        },
                        TweenLite: function () {
                            return Kt;
                        },
                        TweenMax: function () {
                            return dr;
                        },
                        default: function () {
                            return ur;
                        },
                        gsap: function () {
                            return ur;
                        },
                    });
                var s,
                    o,
                    a,
                    l,
                    c,
                    u,
                    d,
                    h,
                    f,
                    p,
                    m,
                    g,
                    v,
                    b,
                    y,
                    w = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } },
                    x = { duration: 0.5, overwrite: !1, delay: 0 },
                    S = 1e8,
                    E = 1e-8,
                    _ = 2 * Math.PI,
                    T = _ / 4,
                    M = 0,
                    P = Math.sqrt,
                    C = Math.cos,
                    O = Math.sin,
                    L = function (e) {
                        return "string" == typeof e;
                    },
                    k = function (e) {
                        return "function" == typeof e;
                    },
                    A = function (e) {
                        return "number" == typeof e;
                    },
                    I = function (e) {
                        return void 0 === e;
                    },
                    z = function (e) {
                        return "object" == typeof e;
                    },
                    D = function (e) {
                        return !1 !== e;
                    },
                    j = function () {
                        return "undefined" != typeof window;
                    },
                    R = function (e) {
                        return k(e) || L(e);
                    },
                    F = ("function" == typeof ArrayBuffer && ArrayBuffer.isView) || function () {},
                    $ = Array.isArray,
                    N = /(?:-?\.?\d|\.)+/gi,
                    B = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
                    H = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
                    q = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
                    V = /[+-]=-?[.\d]+/,
                    Y = /[^,'"\[\]\s]+/gi,
                    W = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
                    X = {},
                    G = {},
                    U = function (e) {
                        return (G = _e(e, X)) && _i;
                    },
                    Z = function (e, t) {
                        return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
                    },
                    K = function (e, t) {
                        return !t && console.warn(e);
                    },
                    J = function (e, t) {
                        return (e && (X[e] = t) && G && (G[e] = t)) || X;
                    },
                    Q = function () {
                        return 0;
                    },
                    ee = { suppressEvents: !0, isStart: !0, kill: !1 },
                    te = { suppressEvents: !0, kill: !1 },
                    ie = { suppressEvents: !0 },
                    ne = {},
                    re = [],
                    se = {},
                    oe = {},
                    ae = {},
                    le = 30,
                    ce = [],
                    ue = "",
                    de = function (e) {
                        var t,
                            i,
                            n = e[0];
                        if ((z(n) || k(n) || (e = [e]), !(t = (n._gsap || {}).harness))) {
                            for (i = ce.length; i-- && !ce[i].targetTest(n); );
                            t = ce[i];
                        }
                        for (i = e.length; i--; ) (e[i] && (e[i]._gsap || (e[i]._gsap = new Ft(e[i], t)))) || e.splice(i, 1);
                        return e;
                    },
                    he = function (e) {
                        return e._gsap || de(tt(e))[0]._gsap;
                    },
                    fe = function (e, t, i) {
                        return (i = e[t]) && k(i) ? e[t]() : (I(i) && e.getAttribute && e.getAttribute(t)) || i;
                    },
                    pe = function (e, t) {
                        return (e = e.split(",")).forEach(t) || e;
                    },
                    me = function (e) {
                        return Math.round(1e5 * e) / 1e5 || 0;
                    },
                    ge = function (e) {
                        return Math.round(1e7 * e) / 1e7 || 0;
                    },
                    ve = function (e, t) {
                        var i = t.charAt(0),
                            n = parseFloat(t.substr(2));
                        return (e = parseFloat(e)), "+" === i ? e + n : "-" === i ? e - n : "*" === i ? e * n : e / n;
                    },
                    be = function (e, t) {
                        for (var i = t.length, n = 0; e.indexOf(t[n]) < 0 && ++n < i; );
                        return n < i;
                    },
                    ye = function () {
                        var e,
                            t,
                            i = re.length,
                            n = re.slice(0);
                        for (se = {}, re.length = 0, e = 0; e < i; e++) (t = n[e]) && t._lazy && (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
                    },
                    we = function (e, t, i, n) {
                        re.length && !o && ye(), e.render(t, i, n || (o && t < 0 && (e._initted || e._startAt))), re.length && !o && ye();
                    },
                    xe = function (e) {
                        var t = parseFloat(e);
                        return (t || 0 === t) && (e + "").match(Y).length < 2 ? t : L(e) ? e.trim() : e;
                    },
                    Se = function (e) {
                        return e;
                    },
                    Ee = function (e, t) {
                        for (var i in t) i in e || (e[i] = t[i]);
                        return e;
                    },
                    _e = function (e, t) {
                        for (var i in t) e[i] = t[i];
                        return e;
                    },
                    Te = function e(t, i) {
                        for (var n in i) "__proto__" !== n && "constructor" !== n && "prototype" !== n && (t[n] = z(i[n]) ? e(t[n] || (t[n] = {}), i[n]) : i[n]);
                        return t;
                    },
                    Me = function (e, t) {
                        var i,
                            n = {};
                        for (i in e) i in t || (n[i] = e[i]);
                        return n;
                    },
                    Pe = function (e) {
                        var t,
                            i = e.parent || l,
                            n = e.keyframes
                                ? ((t = $(e.keyframes)),
                                  function (e, i) {
                                      for (var n in i) n in e || ("duration" === n && t) || "ease" === n || (e[n] = i[n]);
                                  })
                                : Ee;
                        if (D(e.inherit)) for (; i; ) n(e, i.vars.defaults), (i = i.parent || i._dp);
                        return e;
                    },
                    Ce = function (e, t, i, n, r) {
                        void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
                        var s,
                            o = e[n];
                        if (r) for (s = t[r]; o && o[r] > s; ) o = o._prev;
                        return o ? ((t._next = o._next), (o._next = t)) : ((t._next = e[i]), (e[i] = t)), t._next ? (t._next._prev = t) : (e[n] = t), (t._prev = o), (t.parent = t._dp = e), t;
                    },
                    Oe = function (e, t, i, n) {
                        void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
                        var r = t._prev,
                            s = t._next;
                        r ? (r._next = s) : e[i] === t && (e[i] = s), s ? (s._prev = r) : e[n] === t && (e[n] = r), (t._next = t._prev = t.parent = null);
                    },
                    Le = function (e, t) {
                        e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), (e._act = 0);
                    },
                    ke = function (e, t) {
                        if (e && (!t || t._end > e._dur || t._start < 0)) for (var i = e; i; ) (i._dirty = 1), (i = i.parent);
                        return e;
                    },
                    Ae = function (e, t, i, n) {
                        return e._startAt && (o ? e._startAt.revert(te) : (e.vars.immediateRender && !e.vars.autoRevert) || e._startAt.render(t, !0, n));
                    },
                    Ie = function e(t) {
                        return !t || (t._ts && e(t.parent));
                    },
                    ze = function (e) {
                        return e._repeat ? De(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
                    },
                    De = function (e, t) {
                        var i = Math.floor((e /= t));
                        return e && i === e ? i - 1 : i;
                    },
                    je = function (e, t) {
                        return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
                    },
                    Re = function (e) {
                        return (e._end = ge(e._start + (e._tDur / Math.abs(e._ts || e._rts || E) || 0)));
                    },
                    Fe = function (e, t) {
                        var i = e._dp;
                        return i && i.smoothChildTiming && e._ts && ((e._start = ge(i._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts))), Re(e), i._dirty || ke(i, e)), e;
                    },
                    $e = function (e, t) {
                        var i;
                        if (
                            ((t._time || (!t._dur && t._initted) || (t._start < e._time && (t._dur || !t.add))) && ((i = je(e.rawTime(), t)), (!t._dur || Ke(0, t.totalDuration(), i) - t._tTime > E) && t.render(i, !0)),
                            ke(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
                        ) {
                            if (e._dur < e.duration()) for (i = e; i._dp; ) i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp);
                            e._zTime = -1e-8;
                        }
                    },
                    Ne = function (e, t, i, n) {
                        return (
                            t.parent && Le(t),
                            (t._start = ge((A(i) ? i : i || e !== l ? Ge(e, i, t) : e._time) + t._delay)),
                            (t._end = ge(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0))),
                            Ce(e, t, "_first", "_last", e._sort ? "_start" : 0),
                            Ve(t) || (e._recent = t),
                            n || $e(e, t),
                            e._ts < 0 && Fe(e, e._tTime),
                            e
                        );
                    },
                    Be = function (e, t) {
                        return (X.ScrollTrigger || Z("scrollTrigger", t)) && X.ScrollTrigger.create(t, e);
                    },
                    He = function (e, t, i, n, r) {
                        return Wt(e, t, r), e._initted ? (!i && e._pt && !o && ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) && f !== Tt.frame ? (re.push(e), (e._lazy = [r, n]), 1) : void 0) : 1;
                    },
                    qe = function e(t) {
                        var i = t.parent;
                        return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || e(i));
                    },
                    Ve = function (e) {
                        var t = e.data;
                        return "isFromStart" === t || "isStart" === t;
                    },
                    Ye = function (e, t, i, n) {
                        var r = e._repeat,
                            s = ge(t) || 0,
                            o = e._tTime / e._tDur;
                        return (
                            o && !n && (e._time *= s / e._dur), (e._dur = s), (e._tDur = r ? (r < 0 ? 1e10 : ge(s * (r + 1) + e._rDelay * r)) : s), o > 0 && !n && Fe(e, (e._tTime = e._tDur * o)), e.parent && Re(e), i || ke(e.parent, e), e
                        );
                    },
                    We = function (e) {
                        return e instanceof Nt ? ke(e) : Ye(e, e._dur);
                    },
                    Xe = { _start: 0, endTime: Q, totalDuration: Q },
                    Ge = function e(t, i, n) {
                        var r,
                            s,
                            o,
                            a = t.labels,
                            l = t._recent || Xe,
                            c = t.duration() >= S ? l.endTime(!1) : t._dur;
                        return L(i) && (isNaN(i) || i in a)
                            ? ((s = i.charAt(0)),
                              (o = "%" === i.substr(-1)),
                              (r = i.indexOf("=")),
                              "<" === s || ">" === s
                                  ? (r >= 0 && (i = i.replace(/=/, "")), ("<" === s ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (o ? (r < 0 ? l : n).totalDuration() / 100 : 1))
                                  : r < 0
                                  ? (i in a || (a[i] = c), a[i])
                                  : ((s = parseFloat(i.charAt(r - 1) + i.substr(r + 1))), o && n && (s = (s / 100) * ($(n) ? n[0] : n).totalDuration()), r > 1 ? e(t, i.substr(0, r - 1), n) + s : c + s))
                            : null == i
                            ? c
                            : +i;
                    },
                    Ue = function (e, t, i) {
                        var n,
                            r,
                            s = A(t[1]),
                            o = (s ? 2 : 1) + (e < 2 ? 0 : 1),
                            a = t[o];
                        if ((s && (a.duration = t[1]), (a.parent = i), e)) {
                            for (n = a, r = i; r && !("immediateRender" in n); ) (n = r.vars.defaults || {}), (r = D(r.vars.inherit) && r.parent);
                            (a.immediateRender = D(n.immediateRender)), e < 2 ? (a.runBackwards = 1) : (a.startAt = t[o - 1]);
                        }
                        return new Kt(t[0], a, t[o + 1]);
                    },
                    Ze = function (e, t) {
                        return e || 0 === e ? t(e) : t;
                    },
                    Ke = function (e, t, i) {
                        return i < e ? e : i > t ? t : i;
                    },
                    Je = function (e, t) {
                        return L(e) && (t = W.exec(e)) ? t[1] : "";
                    },
                    Qe = [].slice,
                    et = function (e, t) {
                        return e && z(e) && "length" in e && ((!t && !e.length) || (e.length - 1 in e && z(e[0]))) && !e.nodeType && e !== c;
                    },
                    tt = function (e, t, i) {
                        return a && !t && a.selector
                            ? a.selector(e)
                            : !L(e) || i || (!u && Mt())
                            ? $(e)
                                ? (function (e, t, i) {
                                      return (
                                          void 0 === i && (i = []),
                                          e.forEach(function (e) {
                                              var n;
                                              return (L(e) && !t) || et(e, 1) ? (n = i).push.apply(n, tt(e)) : i.push(e);
                                          }) || i
                                      );
                                  })(e, i)
                                : et(e)
                                ? Qe.call(e, 0)
                                : e
                                ? [e]
                                : []
                            : Qe.call((t || d).querySelectorAll(e), 0);
                    },
                    it = function (e) {
                        return (
                            (e = tt(e)[0] || K("Invalid scope") || {}),
                            function (t) {
                                var i = e.current || e.nativeElement || e;
                                return tt(t, i.querySelectorAll ? i : i === e ? K("Invalid scope") || d.createElement("div") : e);
                            }
                        );
                    },
                    nt = function (e) {
                        return e.sort(function () {
                            return 0.5 - Math.random();
                        });
                    },
                    rt = function (e) {
                        if (k(e)) return e;
                        var t = z(e) ? e : { each: e },
                            i = It(t.ease),
                            n = t.from || 0,
                            r = parseFloat(t.base) || 0,
                            s = {},
                            o = n > 0 && n < 1,
                            a = isNaN(n) || o,
                            l = t.axis,
                            c = n,
                            u = n;
                        return (
                            L(n) ? (c = u = { center: 0.5, edges: 0.5, end: 1 }[n] || 0) : !o && a && ((c = n[0]), (u = n[1])),
                            function (e, o, d) {
                                var h,
                                    f,
                                    p,
                                    m,
                                    g,
                                    v,
                                    b,
                                    y,
                                    w,
                                    x = (d || t).length,
                                    E = s[x];
                                if (!E) {
                                    if (!(w = "auto" === t.grid ? 0 : (t.grid || [1, S])[1])) {
                                        for (b = -S; b < (b = d[w++].getBoundingClientRect().left) && w < x; );
                                        w--;
                                    }
                                    for (E = s[x] = [], h = a ? Math.min(w, x) * c - 0.5 : n % w, f = w === S ? 0 : a ? (x * u) / w - 0.5 : (n / w) | 0, b = 0, y = S, v = 0; v < x; v++)
                                        (p = (v % w) - h), (m = f - ((v / w) | 0)), (E[v] = g = l ? Math.abs("y" === l ? m : p) : P(p * p + m * m)), g > b && (b = g), g < y && (y = g);
                                    "random" === n && nt(E),
                                        (E.max = b - y),
                                        (E.min = y),
                                        (E.v = x = (parseFloat(t.amount) || parseFloat(t.each) * (w > x ? x - 1 : l ? ("y" === l ? x / w : w) : Math.max(w, x / w)) || 0) * ("edges" === n ? -1 : 1)),
                                        (E.b = x < 0 ? r - x : r),
                                        (E.u = Je(t.amount || t.each) || 0),
                                        (i = i && x < 0 ? kt(i) : i);
                                }
                                return (x = (E[e] - E.min) / E.max || 0), ge(E.b + (i ? i(x) : x) * E.v) + E.u;
                            }
                        );
                    },
                    st = function (e) {
                        var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
                        return function (i) {
                            var n = ge(Math.round(parseFloat(i) / e) * e * t);
                            return (n - (n % 1)) / t + (A(i) ? 0 : Je(i));
                        };
                    },
                    ot = function (e, t) {
                        var i,
                            n,
                            r = $(e);
                        return (
                            !r && z(e) && ((i = r = e.radius || S), e.values ? ((e = tt(e.values)), (n = !A(e[0])) && (i *= i)) : (e = st(e.increment))),
                            Ze(
                                t,
                                r
                                    ? k(e)
                                        ? function (t) {
                                              return (n = e(t)), Math.abs(n - t) <= i ? n : t;
                                          }
                                        : function (t) {
                                              for (var r, s, o = parseFloat(n ? t.x : t), a = parseFloat(n ? t.y : 0), l = S, c = 0, u = e.length; u--; )
                                                  (r = n ? (r = e[u].x - o) * r + (s = e[u].y - a) * s : Math.abs(e[u] - o)) < l && ((l = r), (c = u));
                                              return (c = !i || l <= i ? e[c] : t), n || c === t || A(t) ? c : c + Je(t);
                                          }
                                    : st(e)
                            )
                        );
                    },
                    at = function (e, t, i, n) {
                        return Ze($(e) ? !t : !0 === i ? !!(i = 0) : !n, function () {
                            return $(e) ? e[~~(Math.random() * e.length)] : (i = i || 1e-5) && (n = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((e - i / 2 + Math.random() * (t - e + 0.99 * i)) / i) * i * n) / n;
                        });
                    },
                    lt = function (e, t, i) {
                        return Ze(i, function (i) {
                            return e[~~t(i)];
                        });
                    },
                    ct = function (e) {
                        for (var t, i, n, r, s = 0, o = ""; ~(t = e.indexOf("random(", s)); )
                            (n = e.indexOf(")", t)), (r = "[" === e.charAt(t + 7)), (i = e.substr(t + 7, n - t - 7).match(r ? Y : N)), (o += e.substr(s, t - s) + at(r ? i : +i[0], r ? 0 : +i[1], +i[2] || 1e-5)), (s = n + 1);
                        return o + e.substr(s, e.length - s);
                    },
                    ut = function (e, t, i, n, r) {
                        var s = t - e,
                            o = n - i;
                        return Ze(r, function (t) {
                            return i + (((t - e) / s) * o || 0);
                        });
                    },
                    dt = function (e, t, i) {
                        var n,
                            r,
                            s,
                            o = e.labels,
                            a = S;
                        for (n in o) (r = o[n] - t) < 0 == !!i && r && a > (r = Math.abs(r)) && ((s = n), (a = r));
                        return s;
                    },
                    ht = function (e, t, i) {
                        var n,
                            r,
                            s,
                            o = e.vars,
                            l = o[t],
                            c = a,
                            u = e._ctx;
                        if (l) return (n = o[t + "Params"]), (r = o.callbackScope || e), i && re.length && ye(), u && (a = u), (s = n ? l.apply(r, n) : l.call(r)), (a = c), s;
                    },
                    ft = function (e) {
                        return Le(e), e.scrollTrigger && e.scrollTrigger.kill(!!o), e.progress() < 1 && ht(e, "onInterrupt"), e;
                    },
                    pt = [],
                    mt = function (e) {
                        if (j() && e) {
                            var t = (e = (!e.name && e.default) || e).name,
                                i = k(e),
                                n =
                                    t && !i && e.init
                                        ? function () {
                                              this._props = [];
                                          }
                                        : e,
                                r = { init: Q, render: oi, add: Vt, kill: li, modifier: ai, rawVars: 0 },
                                s = { targetTest: 0, get: 0, getSetter: ii, aliases: {}, register: 0 };
                            if ((Mt(), e !== n)) {
                                if (oe[t]) return;
                                Ee(n, Ee(Me(e, r), s)), _e(n.prototype, _e(r, Me(e, s))), (oe[(n.prop = t)] = n), e.targetTest && (ce.push(n), (ne[t] = 1)), (t = ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin");
                            }
                            J(t, n), e.register && e.register(_i, n, di);
                        } else e && pt.push(e);
                    },
                    gt = 255,
                    vt = {
                        aqua: [0, gt, gt],
                        lime: [0, gt, 0],
                        silver: [192, 192, 192],
                        black: [0, 0, 0],
                        maroon: [128, 0, 0],
                        teal: [0, 128, 128],
                        blue: [0, 0, gt],
                        navy: [0, 0, 128],
                        white: [gt, gt, gt],
                        olive: [128, 128, 0],
                        yellow: [gt, gt, 0],
                        orange: [gt, 165, 0],
                        gray: [128, 128, 128],
                        purple: [128, 0, 128],
                        green: [0, 128, 0],
                        red: [gt, 0, 0],
                        pink: [gt, 192, 203],
                        cyan: [0, gt, gt],
                        transparent: [gt, gt, gt, 0],
                    },
                    bt = function (e, t, i) {
                        return ((6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1 ? t + (i - t) * e * 6 : e < 0.5 ? i : 3 * e < 2 ? t + (i - t) * (2 / 3 - e) * 6 : t) * gt + 0.5) | 0;
                    },
                    yt = function (e, t, i) {
                        var n,
                            r,
                            s,
                            o,
                            a,
                            l,
                            c,
                            u,
                            d,
                            h,
                            f = e ? (A(e) ? [e >> 16, (e >> 8) & gt, e & gt] : 0) : vt.black;
                        if (!f) {
                            if (("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), vt[e])) f = vt[e];
                            else if ("#" === e.charAt(0)) {
                                if ((e.length < 6 && ((n = e.charAt(1)), (r = e.charAt(2)), (s = e.charAt(3)), (e = "#" + n + n + r + r + s + s + (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))), 9 === e.length))
                                    return [(f = parseInt(e.substr(1, 6), 16)) >> 16, (f >> 8) & gt, f & gt, parseInt(e.substr(7), 16) / 255];
                                f = [(e = parseInt(e.substr(1), 16)) >> 16, (e >> 8) & gt, e & gt];
                            } else if ("hsl" === e.substr(0, 3))
                                if (((f = h = e.match(N)), t)) {
                                    if (~e.indexOf("=")) return (f = e.match(B)), i && f.length < 4 && (f[3] = 1), f;
                                } else
                                    (o = (+f[0] % 360) / 360),
                                        (a = +f[1] / 100),
                                        (n = 2 * (l = +f[2] / 100) - (r = l <= 0.5 ? l * (a + 1) : l + a - l * a)),
                                        f.length > 3 && (f[3] *= 1),
                                        (f[0] = bt(o + 1 / 3, n, r)),
                                        (f[1] = bt(o, n, r)),
                                        (f[2] = bt(o - 1 / 3, n, r));
                            else f = e.match(N) || vt.transparent;
                            f = f.map(Number);
                        }
                        return (
                            t &&
                                !h &&
                                ((n = f[0] / gt),
                                (r = f[1] / gt),
                                (s = f[2] / gt),
                                (l = ((c = Math.max(n, r, s)) + (u = Math.min(n, r, s))) / 2),
                                c === u ? (o = a = 0) : ((d = c - u), (a = l > 0.5 ? d / (2 - c - u) : d / (c + u)), (o = c === n ? (r - s) / d + (r < s ? 6 : 0) : c === r ? (s - n) / d + 2 : (n - r) / d + 4), (o *= 60)),
                                (f[0] = ~~(o + 0.5)),
                                (f[1] = ~~(100 * a + 0.5)),
                                (f[2] = ~~(100 * l + 0.5))),
                            i && f.length < 4 && (f[3] = 1),
                            f
                        );
                    },
                    wt = function (e) {
                        var t = [],
                            i = [],
                            n = -1;
                        return (
                            e.split(St).forEach(function (e) {
                                var r = e.match(H) || [];
                                t.push.apply(t, r), i.push((n += r.length + 1));
                            }),
                            (t.c = i),
                            t
                        );
                    },
                    xt = function (e, t, i) {
                        var n,
                            r,
                            s,
                            o,
                            a = "",
                            l = (e + a).match(St),
                            c = t ? "hsla(" : "rgba(",
                            u = 0;
                        if (!l) return e;
                        if (
                            ((l = l.map(function (e) {
                                return (e = yt(e, t, 1)) && c + (t ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3] : e.join(",")) + ")";
                            })),
                            i && ((s = wt(e)), (n = i.c).join(a) !== s.c.join(a)))
                        )
                            for (o = (r = e.replace(St, "1").split(H)).length - 1; u < o; u++) a += r[u] + (~n.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (s.length ? s : l.length ? l : i).shift());
                        if (!r) for (o = (r = e.split(St)).length - 1; u < o; u++) a += r[u] + l[u];
                        return a + r[o];
                    },
                    St = (function () {
                        var e,
                            t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
                        for (e in vt) t += "|" + e + "\\b";
                        return new RegExp(t + ")", "gi");
                    })(),
                    Et = /hsl[a]?\(/,
                    _t = function (e) {
                        var t,
                            i = e.join(" ");
                        if (((St.lastIndex = 0), St.test(i))) return (t = Et.test(i)), (e[1] = xt(e[1], t)), (e[0] = xt(e[0], t, wt(e[1]))), !0;
                    },
                    Tt = (function () {
                        var e,
                            t,
                            i,
                            n,
                            r,
                            s,
                            o = Date.now,
                            a = 500,
                            l = 33,
                            f = o(),
                            p = f,
                            g = 1e3 / 240,
                            v = g,
                            b = [],
                            y = function i(c) {
                                var u,
                                    d,
                                    h,
                                    m,
                                    y = o() - p,
                                    w = !0 === c;
                                if ((y > a && (f += y - l), ((u = (h = (p += y) - f) - v) > 0 || w) && ((m = ++n.frame), (r = h - 1e3 * n.time), (n.time = h /= 1e3), (v += u + (u >= g ? 4 : g - u)), (d = 1)), w || (e = t(i)), d))
                                    for (s = 0; s < b.length; s++) b[s](h, r, m, c);
                            };
                        return (n = {
                            time: 0,
                            frame: 0,
                            tick: function () {
                                y(!0);
                            },
                            deltaRatio: function (e) {
                                return r / (1e3 / (e || 60));
                            },
                            wake: function () {
                                h &&
                                    (!u &&
                                        j() &&
                                        ((c = u = window),
                                        (d = c.document || {}),
                                        (X.gsap = _i),
                                        (c.gsapVersions || (c.gsapVersions = [])).push(_i.version),
                                        U(G || c.GreenSockGlobals || (!c.gsap && c) || {}),
                                        (i = c.requestAnimationFrame),
                                        pt.forEach(mt)),
                                    e && n.sleep(),
                                    (t =
                                        i ||
                                        function (e) {
                                            return setTimeout(e, (v - 1e3 * n.time + 1) | 0);
                                        }),
                                    (m = 1),
                                    y(2));
                            },
                            sleep: function () {
                                (i ? c.cancelAnimationFrame : clearTimeout)(e), (m = 0), (t = Q);
                            },
                            lagSmoothing: function (e, t) {
                                (a = e || 1 / 0), (l = Math.min(t || 33, a));
                            },
                            fps: function (e) {
                                (g = 1e3 / (e || 240)), (v = 1e3 * n.time + g);
                            },
                            add: function (e, t, i) {
                                var r = t
                                    ? function (t, i, s, o) {
                                          e(t, i, s, o), n.remove(r);
                                      }
                                    : e;
                                return n.remove(e), b[i ? "unshift" : "push"](r), Mt(), r;
                            },
                            remove: function (e, t) {
                                ~(t = b.indexOf(e)) && b.splice(t, 1) && s >= t && s--;
                            },
                            _listeners: b,
                        });
                    })(),
                    Mt = function () {
                        return !m && Tt.wake();
                    },
                    Pt = {},
                    Ct = /^[\d.\-M][\d.\-,\s]/,
                    Ot = /["']/g,
                    Lt = function (e) {
                        for (var t, i, n, r = {}, s = e.substr(1, e.length - 3).split(":"), o = s[0], a = 1, l = s.length; a < l; a++)
                            (i = s[a]), (t = a !== l - 1 ? i.lastIndexOf(",") : i.length), (n = i.substr(0, t)), (r[o] = isNaN(n) ? n.replace(Ot, "").trim() : +n), (o = i.substr(t + 1).trim());
                        return r;
                    },
                    kt = function (e) {
                        return function (t) {
                            return 1 - e(1 - t);
                        };
                    },
                    At = function e(t, i) {
                        for (var n, r = t._first; r; )
                            r instanceof Nt ? e(r, i) : !r.vars.yoyoEase || (r._yoyo && r._repeat) || r._yoyo === i || (r.timeline ? e(r.timeline, i) : ((n = r._ease), (r._ease = r._yEase), (r._yEase = n), (r._yoyo = i))), (r = r._next);
                    },
                    It = function (e, t) {
                        return (
                            (e &&
                                (k(e)
                                    ? e
                                    : Pt[e] ||
                                      (function (e) {
                                          var t,
                                              i,
                                              n,
                                              r,
                                              s = (e + "").split("("),
                                              o = Pt[s[0]];
                                          return o && s.length > 1 && o.config
                                              ? o.config.apply(
                                                    null,
                                                    ~e.indexOf("{")
                                                        ? [Lt(s[1])]
                                                        : ((t = e), (i = t.indexOf("(") + 1), (n = t.indexOf(")")), (r = t.indexOf("(", i)), t.substring(i, ~r && r < n ? t.indexOf(")", n + 1) : n)).split(",").map(xe)
                                                )
                                              : Pt._CE && Ct.test(e)
                                              ? Pt._CE("", e)
                                              : o;
                                      })(e))) ||
                            t
                        );
                    },
                    zt = function (e, t, i, n) {
                        void 0 === i &&
                            (i = function (e) {
                                return 1 - t(1 - e);
                            }),
                            void 0 === n &&
                                (n = function (e) {
                                    return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
                                });
                        var r,
                            s = { easeIn: t, easeOut: i, easeInOut: n };
                        return (
                            pe(e, function (e) {
                                for (var t in ((Pt[e] = X[e] = s), (Pt[(r = e.toLowerCase())] = i), s)) Pt[r + ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")] = Pt[e + "." + t] = s[t];
                            }),
                            s
                        );
                    },
                    Dt = function (e) {
                        return function (t) {
                            return t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : 0.5 + e(2 * (t - 0.5)) / 2;
                        };
                    },
                    jt = function e(t, i, n) {
                        var r = i >= 1 ? i : 1,
                            s = (n || (t ? 0.3 : 0.45)) / (i < 1 ? i : 1),
                            o = (s / _) * (Math.asin(1 / r) || 0),
                            a = function (e) {
                                return 1 === e ? 1 : r * Math.pow(2, -10 * e) * O((e - o) * s) + 1;
                            },
                            l =
                                "out" === t
                                    ? a
                                    : "in" === t
                                    ? function (e) {
                                          return 1 - a(1 - e);
                                      }
                                    : Dt(a);
                        return (
                            (s = _ / s),
                            (l.config = function (i, n) {
                                return e(t, i, n);
                            }),
                            l
                        );
                    },
                    Rt = function e(t, i) {
                        void 0 === i && (i = 1.70158);
                        var n = function (e) {
                                return e ? --e * e * ((i + 1) * e + i) + 1 : 0;
                            },
                            r =
                                "out" === t
                                    ? n
                                    : "in" === t
                                    ? function (e) {
                                          return 1 - n(1 - e);
                                      }
                                    : Dt(n);
                        return (
                            (r.config = function (i) {
                                return e(t, i);
                            }),
                            r
                        );
                    };
                pe("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
                    var i = t < 5 ? t + 1 : t;
                    zt(
                        e + ",Power" + (i - 1),
                        t
                            ? function (e) {
                                  return Math.pow(e, i);
                              }
                            : function (e) {
                                  return e;
                              },
                        function (e) {
                            return 1 - Math.pow(1 - e, i);
                        },
                        function (e) {
                            return e < 0.5 ? Math.pow(2 * e, i) / 2 : 1 - Math.pow(2 * (1 - e), i) / 2;
                        }
                    );
                }),
                    (Pt.Linear.easeNone = Pt.none = Pt.Linear.easeIn),
                    zt("Elastic", jt("in"), jt("out"), jt()),
                    (g = 7.5625),
                    (b = 1 / (v = 2.75)),
                    zt(
                        "Bounce",
                        function (e) {
                            return 1 - y(1 - e);
                        },
                        (y = function (e) {
                            return e < b ? g * e * e : e < 0.7272727272727273 ? g * Math.pow(e - 1.5 / v, 2) + 0.75 : e < 0.9090909090909092 ? g * (e -= 2.25 / v) * e + 0.9375 : g * Math.pow(e - 2.625 / v, 2) + 0.984375;
                        })
                    ),
                    zt("Expo", function (e) {
                        return e ? Math.pow(2, 10 * (e - 1)) : 0;
                    }),
                    zt("Circ", function (e) {
                        return -(P(1 - e * e) - 1);
                    }),
                    zt("Sine", function (e) {
                        return 1 === e ? 1 : 1 - C(e * T);
                    }),
                    zt("Back", Rt("in"), Rt("out"), Rt()),
                    (Pt.SteppedEase = Pt.steps = X.SteppedEase = {
                        config: function (e, t) {
                            void 0 === e && (e = 1);
                            var i = 1 / e,
                                n = e + (t ? 0 : 1),
                                r = t ? 1 : 0;
                            return function (e) {
                                return (((n * Ke(0, 0.99999999, e)) | 0) + r) * i;
                            };
                        },
                    }),
                    (x.ease = Pt["quad.out"]),
                    pe("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (e) {
                        return (ue += e + "," + e + "Params,");
                    });
                var Ft = function (e, t) {
                        (this.id = M++), (e._gsap = this), (this.target = e), (this.harness = t), (this.get = t ? t.get : fe), (this.set = t ? t.getSetter : ii);
                    },
                    $t = (function () {
                        function e(e) {
                            (this.vars = e),
                                (this._delay = +e.delay || 0),
                                (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && ((this._rDelay = e.repeatDelay || 0), (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
                                (this._ts = 1),
                                Ye(this, +e.duration, 1, 1),
                                (this.data = e.data),
                                a && ((this._ctx = a), a.data.push(this)),
                                m || Tt.wake();
                        }
                        var t = e.prototype;
                        return (
                            (t.delay = function (e) {
                                return e || 0 === e ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e - this._delay), (this._delay = e), this) : this._delay;
                            }),
                            (t.duration = function (e) {
                                return arguments.length ? this.totalDuration(this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e) : this.totalDuration() && this._dur;
                            }),
                            (t.totalDuration = function (e) {
                                return arguments.length ? ((this._dirty = 0), Ye(this, this._repeat < 0 ? e : (e - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
                            }),
                            (t.totalTime = function (e, t) {
                                if ((Mt(), !arguments.length)) return this._tTime;
                                var i = this._dp;
                                if (i && i.smoothChildTiming && this._ts) {
                                    for (Fe(this, e), !i._dp || i.parent || $e(i, this); i && i.parent; )
                                        i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), (i = i.parent);
                                    !this.parent && this._dp.autoRemoveChildren && ((this._ts > 0 && e < this._tDur) || (this._ts < 0 && e > 0) || (!this._tDur && !e)) && Ne(this._dp, this, this._start - this._delay);
                                }
                                return (
                                    (this._tTime !== e || (!this._dur && !t) || (this._initted && Math.abs(this._zTime) === E) || (!e && !this._initted && (this.add || this._ptLookup))) && (this._ts || (this._pTime = e), we(this, e, t)),
                                    this
                                );
                            }),
                            (t.time = function (e, t) {
                                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e + ze(this)) % (this._dur + this._rDelay) || (e ? this._dur : 0), t) : this._time;
                            }),
                            (t.totalProgress = function (e, t) {
                                return arguments.length ? this.totalTime(this.totalDuration() * e, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
                            }),
                            (t.progress = function (e, t) {
                                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? e : 1 - e) + ze(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
                            }),
                            (t.iteration = function (e, t) {
                                var i = this.duration() + this._rDelay;
                                return arguments.length ? this.totalTime(this._time + (e - 1) * i, t) : this._repeat ? De(this._tTime, i) + 1 : 1;
                            }),
                            (t.timeScale = function (e) {
                                if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
                                if (this._rts === e) return this;
                                var t = this.parent && this._ts ? je(this.parent._time, this) : this._tTime;
                                return (
                                    (this._rts = +e || 0),
                                    (this._ts = this._ps || -1e-8 === e ? 0 : this._rts),
                                    this.totalTime(Ke(-Math.abs(this._delay), this._tDur, t), !0),
                                    Re(this),
                                    (function (e) {
                                        for (var t = e.parent; t && t.parent; ) (t._dirty = 1), t.totalDuration(), (t = t.parent);
                                        return e;
                                    })(this)
                                );
                            }),
                            (t.paused = function (e) {
                                return arguments.length
                                    ? (this._ps !== e &&
                                          ((this._ps = e),
                                          e
                                              ? ((this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())), (this._ts = this._act = 0))
                                              : (Mt(),
                                                (this._ts = this._rts),
                                                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== E && (this._tTime -= E)))),
                                      this)
                                    : this._ps;
                            }),
                            (t.startTime = function (e) {
                                if (arguments.length) {
                                    this._start = e;
                                    var t = this.parent || this._dp;
                                    return t && (t._sort || !this.parent) && Ne(t, this, e - this._delay), this;
                                }
                                return this._start;
                            }),
                            (t.endTime = function (e) {
                                return this._start + (D(e) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
                            }),
                            (t.rawTime = function (e) {
                                var t = this.parent || this._dp;
                                return t ? (e && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1)) ? this._tTime % (this._dur + this._rDelay) : this._ts ? je(t.rawTime(e), this) : this._tTime) : this._tTime;
                            }),
                            (t.revert = function (e) {
                                void 0 === e && (e = ie);
                                var t = o;
                                return (o = e), (this._initted || this._startAt) && (this.timeline && this.timeline.revert(e), this.totalTime(-0.01, e.suppressEvents)), "nested" !== this.data && !1 !== e.kill && this.kill(), (o = t), this;
                            }),
                            (t.globalTime = function (e) {
                                for (var t = this, i = arguments.length ? e : t.rawTime(); t; ) (i = t._start + i / (t._ts || 1)), (t = t._dp);
                                return !this.parent && this._sat ? (this._sat.vars.immediateRender ? -1 / 0 : this._sat.globalTime(e)) : i;
                            }),
                            (t.repeat = function (e) {
                                return arguments.length ? ((this._repeat = e === 1 / 0 ? -2 : e), We(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
                            }),
                            (t.repeatDelay = function (e) {
                                if (arguments.length) {
                                    var t = this._time;
                                    return (this._rDelay = e), We(this), t ? this.time(t) : this;
                                }
                                return this._rDelay;
                            }),
                            (t.yoyo = function (e) {
                                return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
                            }),
                            (t.seek = function (e, t) {
                                return this.totalTime(Ge(this, e), D(t));
                            }),
                            (t.restart = function (e, t) {
                                return this.play().totalTime(e ? -this._delay : 0, D(t));
                            }),
                            (t.play = function (e, t) {
                                return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
                            }),
                            (t.reverse = function (e, t) {
                                return null != e && this.seek(e || this.totalDuration(), t), this.reversed(!0).paused(!1);
                            }),
                            (t.pause = function (e, t) {
                                return null != e && this.seek(e, t), this.paused(!0);
                            }),
                            (t.resume = function () {
                                return this.paused(!1);
                            }),
                            (t.reversed = function (e) {
                                return arguments.length ? (!!e !== this.reversed() && this.timeScale(-this._rts || (e ? -1e-8 : 0)), this) : this._rts < 0;
                            }),
                            (t.invalidate = function () {
                                return (this._initted = this._act = 0), (this._zTime = -1e-8), this;
                            }),
                            (t.isActive = function () {
                                var e,
                                    t = this.parent || this._dp,
                                    i = this._start;
                                return !(t && !(this._ts && this._initted && t.isActive() && (e = t.rawTime(!0)) >= i && e < this.endTime(!0) - E));
                            }),
                            (t.eventCallback = function (e, t, i) {
                                var n = this.vars;
                                return arguments.length > 1 ? (t ? ((n[e] = t), i && (n[e + "Params"] = i), "onUpdate" === e && (this._onUpdate = t)) : delete n[e], this) : n[e];
                            }),
                            (t.then = function (e) {
                                var t = this;
                                return new Promise(function (i) {
                                    var n = k(e) ? e : Se,
                                        r = function () {
                                            var e = t.then;
                                            (t.then = null), k(n) && (n = n(t)) && (n.then || n === t) && (t.then = e), i(n), (t.then = e);
                                        };
                                    (t._initted && 1 === t.totalProgress() && t._ts >= 0) || (!t._tTime && t._ts < 0) ? r() : (t._prom = r);
                                });
                            }),
                            (t.kill = function () {
                                ft(this);
                            }),
                            e
                        );
                    })();
                Ee($t.prototype, { _time: 0, _start: 0, _end: 0, _tTime: 0, _tDur: 0, _dirty: 0, _repeat: 0, _yoyo: !1, parent: null, _initted: !1, _rDelay: 0, _ts: 1, _dp: 0, ratio: 0, _zTime: -1e-8, _prom: 0, _ps: !1, _rts: 1 });
                var Nt = (function (e) {
                    function t(t, i) {
                        var r;
                        return (
                            void 0 === t && (t = {}),
                            ((r = e.call(this, t) || this).labels = {}),
                            (r.smoothChildTiming = !!t.smoothChildTiming),
                            (r.autoRemoveChildren = !!t.autoRemoveChildren),
                            (r._sort = D(t.sortChildren)),
                            l && Ne(t.parent || l, n(r), i),
                            t.reversed && r.reverse(),
                            t.paused && r.paused(!0),
                            t.scrollTrigger && Be(n(r), t.scrollTrigger),
                            r
                        );
                    }
                    r(t, e);
                    var i = t.prototype;
                    return (
                        (i.to = function (e, t, i) {
                            return Ue(0, arguments, this), this;
                        }),
                        (i.from = function (e, t, i) {
                            return Ue(1, arguments, this), this;
                        }),
                        (i.fromTo = function (e, t, i, n) {
                            return Ue(2, arguments, this), this;
                        }),
                        (i.set = function (e, t, i) {
                            return (t.duration = 0), (t.parent = this), Pe(t).repeatDelay || (t.repeat = 0), (t.immediateRender = !!t.immediateRender), new Kt(e, t, Ge(this, i), 1), this;
                        }),
                        (i.call = function (e, t, i) {
                            return Ne(this, Kt.delayedCall(0, e, t), i);
                        }),
                        (i.staggerTo = function (e, t, i, n, r, s, o) {
                            return (i.duration = t), (i.stagger = i.stagger || n), (i.onComplete = s), (i.onCompleteParams = o), (i.parent = this), new Kt(e, i, Ge(this, r)), this;
                        }),
                        (i.staggerFrom = function (e, t, i, n, r, s, o) {
                            return (i.runBackwards = 1), (Pe(i).immediateRender = D(i.immediateRender)), this.staggerTo(e, t, i, n, r, s, o);
                        }),
                        (i.staggerFromTo = function (e, t, i, n, r, s, o, a) {
                            return (n.startAt = i), (Pe(n).immediateRender = D(n.immediateRender)), this.staggerTo(e, t, n, r, s, o, a);
                        }),
                        (i.render = function (e, t, i) {
                            var n,
                                r,
                                s,
                                a,
                                c,
                                u,
                                d,
                                h,
                                f,
                                p,
                                m,
                                g,
                                v = this._time,
                                b = this._dirty ? this.totalDuration() : this._tDur,
                                y = this._dur,
                                w = e <= 0 ? 0 : ge(e),
                                x = this._zTime < 0 != e < 0 && (this._initted || !y);
                            if ((this !== l && w > b && e >= 0 && (w = b), w !== this._tTime || i || x)) {
                                if ((v !== this._time && y && ((w += this._time - v), (e += this._time - v)), (n = w), (f = this._start), (u = !(h = this._ts)), x && (y || (v = this._zTime), (e || !t) && (this._zTime = e)), this._repeat)) {
                                    if (((m = this._yoyo), (c = y + this._rDelay), this._repeat < -1 && e < 0)) return this.totalTime(100 * c + e, t, i);
                                    if (
                                        ((n = ge(w % c)),
                                        w === b ? ((a = this._repeat), (n = y)) : ((a = ~~(w / c)) && a === w / c && ((n = y), a--), n > y && (n = y)),
                                        (p = De(this._tTime, c)),
                                        !v && this._tTime && p !== a && this._tTime - p * c - this._dur <= 0 && (p = a),
                                        m && 1 & a && ((n = y - n), (g = 1)),
                                        a !== p && !this._lock)
                                    ) {
                                        var S = m && 1 & p,
                                            _ = S === (m && 1 & a);
                                        if (
                                            (a < p && (S = !S),
                                            (v = S ? 0 : w % y ? y : w),
                                            (this._lock = 1),
                                            (this.render(v || (g ? 0 : ge(a * c)), t, !y)._lock = 0),
                                            (this._tTime = w),
                                            !t && this.parent && ht(this, "onRepeat"),
                                            this.vars.repeatRefresh && !g && (this.invalidate()._lock = 1),
                                            (v && v !== this._time) || u !== !this._ts || (this.vars.onRepeat && !this.parent && !this._act))
                                        )
                                            return this;
                                        if (((y = this._dur), (b = this._tDur), _ && ((this._lock = 2), (v = S ? y : -1e-4), this.render(v, !0), this.vars.repeatRefresh && !g && this.invalidate()), (this._lock = 0), !this._ts && !u))
                                            return this;
                                        At(this, g);
                                    }
                                }
                                if (
                                    (this._hasPause &&
                                        !this._forcing &&
                                        this._lock < 2 &&
                                        ((d = (function (e, t, i) {
                                            var n;
                                            if (i > t)
                                                for (n = e._first; n && n._start <= i; ) {
                                                    if ("isPause" === n.data && n._start > t) return n;
                                                    n = n._next;
                                                }
                                            else
                                                for (n = e._last; n && n._start >= i; ) {
                                                    if ("isPause" === n.data && n._start < t) return n;
                                                    n = n._prev;
                                                }
                                        })(this, ge(v), ge(n))),
                                        d && (w -= n - (n = d._start))),
                                    (this._tTime = w),
                                    (this._time = n),
                                    (this._act = !h),
                                    this._initted || ((this._onUpdate = this.vars.onUpdate), (this._initted = 1), (this._zTime = e), (v = 0)),
                                    !v && n && !t && !a && (ht(this, "onStart"), this._tTime !== w))
                                )
                                    return this;
                                if (n >= v && e >= 0)
                                    for (r = this._first; r; ) {
                                        if (((s = r._next), (r._act || n >= r._start) && r._ts && d !== r)) {
                                            if (r.parent !== this) return this.render(e, t, i);
                                            if ((r.render(r._ts > 0 ? (n - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (n - r._start) * r._ts, t, i), n !== this._time || (!this._ts && !u))) {
                                                (d = 0), s && (w += this._zTime = -1e-8);
                                                break;
                                            }
                                        }
                                        r = s;
                                    }
                                else {
                                    r = this._last;
                                    for (var T = e < 0 ? e : n; r; ) {
                                        if (((s = r._prev), (r._act || T <= r._end) && r._ts && d !== r)) {
                                            if (r.parent !== this) return this.render(e, t, i);
                                            if (
                                                (r.render(r._ts > 0 ? (T - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (T - r._start) * r._ts, t, i || (o && (r._initted || r._startAt))),
                                                n !== this._time || (!this._ts && !u))
                                            ) {
                                                (d = 0), s && (w += this._zTime = T ? -1e-8 : E);
                                                break;
                                            }
                                        }
                                        r = s;
                                    }
                                }
                                if (d && !t && (this.pause(), (d.render(n >= v ? 0 : -1e-8)._zTime = n >= v ? 1 : -1), this._ts)) return (this._start = f), Re(this), this.render(e, t, i);
                                this._onUpdate && !t && ht(this, "onUpdate", !0),
                                    ((w === b && this._tTime >= this.totalDuration()) || (!w && v)) &&
                                        ((f !== this._start && Math.abs(h) === Math.abs(this._ts)) ||
                                            this._lock ||
                                            ((e || !y) && ((w === b && this._ts > 0) || (!w && this._ts < 0)) && Le(this, 1),
                                            t || (e < 0 && !v) || (!w && !v && b) || (ht(this, w === b && e >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(w < b && this.timeScale() > 0) && this._prom())));
                            }
                            return this;
                        }),
                        (i.add = function (e, t) {
                            var i = this;
                            if ((A(t) || (t = Ge(this, t, e)), !(e instanceof $t))) {
                                if ($(e))
                                    return (
                                        e.forEach(function (e) {
                                            return i.add(e, t);
                                        }),
                                        this
                                    );
                                if (L(e)) return this.addLabel(e, t);
                                if (!k(e)) return this;
                                e = Kt.delayedCall(0, e);
                            }
                            return this !== e ? Ne(this, e, t) : this;
                        }),
                        (i.getChildren = function (e, t, i, n) {
                            void 0 === e && (e = !0), void 0 === t && (t = !0), void 0 === i && (i = !0), void 0 === n && (n = -S);
                            for (var r = [], s = this._first; s; ) s._start >= n && (s instanceof Kt ? t && r.push(s) : (i && r.push(s), e && r.push.apply(r, s.getChildren(!0, t, i)))), (s = s._next);
                            return r;
                        }),
                        (i.getById = function (e) {
                            for (var t = this.getChildren(1, 1, 1), i = t.length; i--; ) if (t[i].vars.id === e) return t[i];
                        }),
                        (i.remove = function (e) {
                            return L(e) ? this.removeLabel(e) : k(e) ? this.killTweensOf(e) : (Oe(this, e), e === this._recent && (this._recent = this._last), ke(this));
                        }),
                        (i.totalTime = function (t, i) {
                            return arguments.length
                                ? ((this._forcing = 1),
                                  !this._dp && this._ts && (this._start = ge(Tt.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts))),
                                  e.prototype.totalTime.call(this, t, i),
                                  (this._forcing = 0),
                                  this)
                                : this._tTime;
                        }),
                        (i.addLabel = function (e, t) {
                            return (this.labels[e] = Ge(this, t)), this;
                        }),
                        (i.removeLabel = function (e) {
                            return delete this.labels[e], this;
                        }),
                        (i.addPause = function (e, t, i) {
                            var n = Kt.delayedCall(0, t || Q, i);
                            return (n.data = "isPause"), (this._hasPause = 1), Ne(this, n, Ge(this, e));
                        }),
                        (i.removePause = function (e) {
                            var t = this._first;
                            for (e = Ge(this, e); t; ) t._start === e && "isPause" === t.data && Le(t), (t = t._next);
                        }),
                        (i.killTweensOf = function (e, t, i) {
                            for (var n = this.getTweensOf(e, i), r = n.length; r--; ) Bt !== n[r] && n[r].kill(e, t);
                            return this;
                        }),
                        (i.getTweensOf = function (e, t) {
                            for (var i, n = [], r = tt(e), s = this._first, o = A(t); s; )
                                s instanceof Kt
                                    ? be(s._targets, r) && (o ? (!Bt || (s._initted && s._ts)) && s.globalTime(0) <= t && s.globalTime(s.totalDuration()) > t : !t || s.isActive()) && n.push(s)
                                    : (i = s.getTweensOf(r, t)).length && n.push.apply(n, i),
                                    (s = s._next);
                            return n;
                        }),
                        (i.tweenTo = function (e, t) {
                            t = t || {};
                            var i,
                                n = this,
                                r = Ge(n, e),
                                s = t,
                                o = s.startAt,
                                a = s.onStart,
                                l = s.onStartParams,
                                c = s.immediateRender,
                                u = Kt.to(
                                    n,
                                    Ee(
                                        {
                                            ease: t.ease || "none",
                                            lazy: !1,
                                            immediateRender: !1,
                                            time: r,
                                            overwrite: "auto",
                                            duration: t.duration || Math.abs((r - (o && "time" in o ? o.time : n._time)) / n.timeScale()) || E,
                                            onStart: function () {
                                                if ((n.pause(), !i)) {
                                                    var e = t.duration || Math.abs((r - (o && "time" in o ? o.time : n._time)) / n.timeScale());
                                                    u._dur !== e && Ye(u, e, 0, 1).render(u._time, !0, !0), (i = 1);
                                                }
                                                a && a.apply(u, l || []);
                                            },
                                        },
                                        t
                                    )
                                );
                            return c ? u.render(0) : u;
                        }),
                        (i.tweenFromTo = function (e, t, i) {
                            return this.tweenTo(t, Ee({ startAt: { time: Ge(this, e) } }, i));
                        }),
                        (i.recent = function () {
                            return this._recent;
                        }),
                        (i.nextLabel = function (e) {
                            return void 0 === e && (e = this._time), dt(this, Ge(this, e));
                        }),
                        (i.previousLabel = function (e) {
                            return void 0 === e && (e = this._time), dt(this, Ge(this, e), 1);
                        }),
                        (i.currentLabel = function (e) {
                            return arguments.length ? this.seek(e, !0) : this.previousLabel(this._time + E);
                        }),
                        (i.shiftChildren = function (e, t, i) {
                            void 0 === i && (i = 0);
                            for (var n, r = this._first, s = this.labels; r; ) r._start >= i && ((r._start += e), (r._end += e)), (r = r._next);
                            if (t) for (n in s) s[n] >= i && (s[n] += e);
                            return ke(this);
                        }),
                        (i.invalidate = function (t) {
                            var i = this._first;
                            for (this._lock = 0; i; ) i.invalidate(t), (i = i._next);
                            return e.prototype.invalidate.call(this, t);
                        }),
                        (i.clear = function (e) {
                            void 0 === e && (e = !0);
                            for (var t, i = this._first; i; ) (t = i._next), this.remove(i), (i = t);
                            return this._dp && (this._time = this._tTime = this._pTime = 0), e && (this.labels = {}), ke(this);
                        }),
                        (i.totalDuration = function (e) {
                            var t,
                                i,
                                n,
                                r = 0,
                                s = this,
                                o = s._last,
                                a = S;
                            if (arguments.length) return s.timeScale((s._repeat < 0 ? s.duration() : s.totalDuration()) / (s.reversed() ? -e : e));
                            if (s._dirty) {
                                for (n = s.parent; o; )
                                    (t = o._prev),
                                        o._dirty && o.totalDuration(),
                                        (i = o._start) > a && s._sort && o._ts && !s._lock ? ((s._lock = 1), (Ne(s, o, i - o._delay, 1)._lock = 0)) : (a = i),
                                        i < 0 && o._ts && ((r -= i), ((!n && !s._dp) || (n && n.smoothChildTiming)) && ((s._start += i / s._ts), (s._time -= i), (s._tTime -= i)), s.shiftChildren(-i, !1, -Infinity), (a = 0)),
                                        o._end > r && o._ts && (r = o._end),
                                        (o = t);
                                Ye(s, s === l && s._time > r ? s._time : r, 1, 1), (s._dirty = 0);
                            }
                            return s._tDur;
                        }),
                        (t.updateRoot = function (e) {
                            if ((l._ts && (we(l, je(e, l)), (f = Tt.frame)), Tt.frame >= le)) {
                                le += w.autoSleep || 120;
                                var t = l._first;
                                if ((!t || !t._ts) && w.autoSleep && Tt._listeners.length < 2) {
                                    for (; t && !t._ts; ) t = t._next;
                                    t || Tt.sleep();
                                }
                            }
                        }),
                        t
                    );
                })($t);
                Ee(Nt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
                var Bt,
                    Ht,
                    qt = function (e, t, i, n, r, s, o) {
                        var a,
                            l,
                            c,
                            u,
                            d,
                            h,
                            f,
                            p,
                            m = new di(this._pt, e, t, 0, 1, si, null, r),
                            g = 0,
                            v = 0;
                        for (m.b = i, m.e = n, i += "", (f = ~(n += "").indexOf("random(")) && (n = ct(n)), s && (s((p = [i, n]), e, t), (i = p[0]), (n = p[1])), l = i.match(q) || []; (a = q.exec(n)); )
                            (u = a[0]),
                                (d = n.substring(g, a.index)),
                                c ? (c = (c + 1) % 5) : "rgba(" === d.substr(-5) && (c = 1),
                                u !== l[v++] &&
                                    ((h = parseFloat(l[v - 1]) || 0),
                                    (m._pt = { _next: m._pt, p: d || 1 === v ? d : ",", s: h, c: "=" === u.charAt(1) ? ve(h, u) - h : parseFloat(u) - h, m: c && c < 4 ? Math.round : 0 }),
                                    (g = q.lastIndex));
                        return (m.c = g < n.length ? n.substring(g, n.length) : ""), (m.fp = o), (V.test(n) || f) && (m.e = 0), (this._pt = m), m;
                    },
                    Vt = function (e, t, i, n, r, s, o, a, l, c) {
                        k(n) && (n = n(r || 0, e, s));
                        var u,
                            d = e[t],
                            h = "get" !== i ? i : k(d) ? (l ? e[t.indexOf("set") || !k(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e[t]()) : d,
                            f = k(d) ? (l ? ei : Qt) : Jt;
                        if ((L(n) && (~n.indexOf("random(") && (n = ct(n)), "=" === n.charAt(1) && ((u = ve(h, n) + (Je(h) || 0)) || 0 === u) && (n = u)), !c || h !== n || Ht))
                            return isNaN(h * n) || "" === n
                                ? (!d && !(t in e) && Z(t, n), qt.call(this, e, t, h, n, f, a || w.stringFilter, l))
                                : ((u = new di(this._pt, e, t, +h || 0, n - (h || 0), "boolean" == typeof d ? ri : ni, 0, f)), l && (u.fp = l), o && u.modifier(o, this, e), (this._pt = u));
                    },
                    Yt = function (e, t, i, n, r, s) {
                        var o, a, l, c;
                        if (
                            oe[e] &&
                            !1 !==
                                (o = new oe[e]()).init(
                                    r,
                                    o.rawVars
                                        ? t[e]
                                        : (function (e, t, i, n, r) {
                                              if ((k(e) && (e = Gt(e, r, t, i, n)), !z(e) || (e.style && e.nodeType) || $(e) || F(e))) return L(e) ? Gt(e, r, t, i, n) : e;
                                              var s,
                                                  o = {};
                                              for (s in e) o[s] = Gt(e[s], r, t, i, n);
                                              return o;
                                          })(t[e], n, r, s, i),
                                    i,
                                    n,
                                    s
                                ) &&
                            ((i._pt = a = new di(i._pt, r, e, 0, 1, o.render, o, 0, o.priority)), i !== p)
                        )
                            for (l = i._ptLookup[i._targets.indexOf(r)], c = o._props.length; c--; ) l[o._props[c]] = a;
                        return o;
                    },
                    Wt = function e(t, i, n) {
                        var r,
                            a,
                            c,
                            u,
                            d,
                            h,
                            f,
                            p,
                            m,
                            g,
                            v,
                            b,
                            y,
                            w = t.vars,
                            _ = w.ease,
                            T = w.startAt,
                            M = w.immediateRender,
                            P = w.lazy,
                            C = w.onUpdate,
                            O = w.onUpdateParams,
                            L = w.callbackScope,
                            k = w.runBackwards,
                            A = w.yoyoEase,
                            I = w.keyframes,
                            z = w.autoRevert,
                            j = t._dur,
                            R = t._startAt,
                            F = t._targets,
                            $ = t.parent,
                            N = $ && "nested" === $.data ? $.vars.targets : F,
                            B = "auto" === t._overwrite && !s,
                            H = t.timeline;
                        if (
                            (H && (!I || !_) && (_ = "none"),
                            (t._ease = It(_, x.ease)),
                            (t._yEase = A ? kt(It(!0 === A ? _ : A, x.ease)) : 0),
                            A && t._yoyo && !t._repeat && ((A = t._yEase), (t._yEase = t._ease), (t._ease = A)),
                            (t._from = !H && !!w.runBackwards),
                            !H || (I && !w.stagger))
                        ) {
                            if (((b = (p = F[0] ? he(F[0]).harness : 0) && w[p.prop]), (r = Me(w, ne)), R && (R._zTime < 0 && R.progress(1), i < 0 && k && M && !z ? R.render(-1, !0) : R.revert(k && j ? te : ee), (R._lazy = 0)), T)) {
                                if (
                                    (Le(
                                        (t._startAt = Kt.set(
                                            F,
                                            Ee({ data: "isStart", overwrite: !1, parent: $, immediateRender: !0, lazy: !R && D(P), startAt: null, delay: 0, onUpdate: C, onUpdateParams: O, callbackScope: L, stagger: 0 }, T)
                                        ))
                                    ),
                                    (t._startAt._dp = 0),
                                    (t._startAt._sat = t),
                                    i < 0 && (o || (!M && !z)) && t._startAt.revert(te),
                                    M && j && i <= 0 && n <= 0)
                                )
                                    return void (i && (t._zTime = i));
                            } else if (k && j && !R)
                                if (
                                    (i && (M = !1),
                                    (c = Ee({ overwrite: !1, data: "isFromStart", lazy: M && !R && D(P), immediateRender: M, stagger: 0, parent: $ }, r)),
                                    b && (c[p.prop] = b),
                                    Le((t._startAt = Kt.set(F, c))),
                                    (t._startAt._dp = 0),
                                    (t._startAt._sat = t),
                                    i < 0 && (o ? t._startAt.revert(te) : t._startAt.render(-1, !0)),
                                    (t._zTime = i),
                                    M)
                                ) {
                                    if (!i) return;
                                } else e(t._startAt, E, E);
                            for (t._pt = t._ptCache = 0, P = (j && D(P)) || (P && !j), a = 0; a < F.length; a++) {
                                if (
                                    ((f = (d = F[a])._gsap || de(F)[a]._gsap),
                                    (t._ptLookup[a] = g = {}),
                                    se[f.id] && re.length && ye(),
                                    (v = N === F ? a : N.indexOf(d)),
                                    p &&
                                        !1 !== (m = new p()).init(d, b || r, t, v, N) &&
                                        ((t._pt = u = new di(t._pt, d, m.name, 0, 1, m.render, m, 0, m.priority)),
                                        m._props.forEach(function (e) {
                                            g[e] = u;
                                        }),
                                        m.priority && (h = 1)),
                                    !p || b)
                                )
                                    for (c in r) oe[c] && (m = Yt(c, r, t, v, d, N)) ? m.priority && (h = 1) : (g[c] = u = Vt.call(t, d, c, "get", r[c], v, N, 0, w.stringFilter));
                                t._op && t._op[a] && t.kill(d, t._op[a]), B && t._pt && ((Bt = t), l.killTweensOf(d, g, t.globalTime(i)), (y = !t.parent), (Bt = 0)), t._pt && P && (se[f.id] = 1);
                            }
                            h && ui(t), t._onInit && t._onInit(t);
                        }
                        (t._onUpdate = C), (t._initted = (!t._op || t._pt) && !y), I && i <= 0 && H.render(S, !0, !0);
                    },
                    Xt = function (e, t, i, n) {
                        var r,
                            s,
                            o = t.ease || n || "power1.inOut";
                        if ($(t))
                            (s = i[e] || (i[e] = [])),
                                t.forEach(function (e, i) {
                                    return s.push({ t: (i / (t.length - 1)) * 100, v: e, e: o });
                                });
                        else for (r in t) (s = i[r] || (i[r] = [])), "ease" === r || s.push({ t: parseFloat(e), v: t[r], e: o });
                    },
                    Gt = function (e, t, i, n, r) {
                        return k(e) ? e.call(t, i, n, r) : L(e) && ~e.indexOf("random(") ? ct(e) : e;
                    },
                    Ut = ue + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
                    Zt = {};
                pe(Ut + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
                    return (Zt[e] = 1);
                });
                var Kt = (function (e) {
                    function t(t, i, r, o) {
                        var a;
                        "number" == typeof i && ((r.duration = i), (i = r), (r = null));
                        var c,
                            u,
                            d,
                            h,
                            f,
                            p,
                            m,
                            g,
                            v = (a = e.call(this, o ? i : Pe(i)) || this).vars,
                            b = v.duration,
                            y = v.delay,
                            x = v.immediateRender,
                            S = v.stagger,
                            E = v.overwrite,
                            _ = v.keyframes,
                            T = v.defaults,
                            M = v.scrollTrigger,
                            P = v.yoyoEase,
                            C = i.parent || l,
                            O = ($(t) || F(t) ? A(t[0]) : "length" in i) ? [t] : tt(t);
                        if (((a._targets = O.length ? de(O) : K("GSAP target " + t + " not found. https://greensock.com", !w.nullTargetWarn) || []), (a._ptLookup = []), (a._overwrite = E), _ || S || R(b) || R(y))) {
                            if (((i = a.vars), (c = a.timeline = new Nt({ data: "nested", defaults: T || {}, targets: C && "nested" === C.data ? C.vars.targets : O })).kill(), (c.parent = c._dp = n(a)), (c._start = 0), S || R(b) || R(y))) {
                                if (((h = O.length), (m = S && rt(S)), z(S))) for (f in S) ~Ut.indexOf(f) && (g || (g = {}), (g[f] = S[f]));
                                for (u = 0; u < h; u++)
                                    ((d = Me(i, Zt)).stagger = 0),
                                        P && (d.yoyoEase = P),
                                        g && _e(d, g),
                                        (p = O[u]),
                                        (d.duration = +Gt(b, n(a), u, p, O)),
                                        (d.delay = (+Gt(y, n(a), u, p, O) || 0) - a._delay),
                                        !S && 1 === h && d.delay && ((a._delay = y = d.delay), (a._start += y), (d.delay = 0)),
                                        c.to(p, d, m ? m(u, p, O) : 0),
                                        (c._ease = Pt.none);
                                c.duration() ? (b = y = 0) : (a.timeline = 0);
                            } else if (_) {
                                Pe(Ee(c.vars.defaults, { ease: "none" })), (c._ease = It(_.ease || i.ease || "none"));
                                var L,
                                    k,
                                    I,
                                    j = 0;
                                if ($(_))
                                    _.forEach(function (e) {
                                        return c.to(O, e, ">");
                                    }),
                                        c.duration();
                                else {
                                    for (f in ((d = {}), _)) "ease" === f || "easeEach" === f || Xt(f, _[f], d, _.easeEach);
                                    for (f in d)
                                        for (
                                            L = d[f].sort(function (e, t) {
                                                return e.t - t.t;
                                            }),
                                                j = 0,
                                                u = 0;
                                            u < L.length;
                                            u++
                                        )
                                            ((I = { ease: (k = L[u]).e, duration: ((k.t - (u ? L[u - 1].t : 0)) / 100) * b })[f] = k.v), c.to(O, I, j), (j += I.duration);
                                    c.duration() < b && c.to({}, { duration: b - c.duration() });
                                }
                            }
                            b || a.duration((b = c.duration()));
                        } else a.timeline = 0;
                        return (
                            !0 !== E || s || ((Bt = n(a)), l.killTweensOf(O), (Bt = 0)),
                            Ne(C, n(a), r),
                            i.reversed && a.reverse(),
                            i.paused && a.paused(!0),
                            (x || (!b && !_ && a._start === ge(C._time) && D(x) && Ie(n(a)) && "nested" !== C.data)) && ((a._tTime = -1e-8), a.render(Math.max(0, -y) || 0)),
                            M && Be(n(a), M),
                            a
                        );
                    }
                    r(t, e);
                    var i = t.prototype;
                    return (
                        (i.render = function (e, t, i) {
                            var n,
                                r,
                                s,
                                a,
                                l,
                                c,
                                u,
                                d,
                                h,
                                f = this._time,
                                p = this._tDur,
                                m = this._dur,
                                g = e < 0,
                                v = e > p - E && !g ? p : e < E ? 0 : e;
                            if (m) {
                                if (v !== this._tTime || !e || i || (!this._initted && this._tTime) || (this._startAt && this._zTime < 0 !== g)) {
                                    if (((n = v), (d = this.timeline), this._repeat)) {
                                        if (((a = m + this._rDelay), this._repeat < -1 && g)) return this.totalTime(100 * a + e, t, i);
                                        if (
                                            ((n = ge(v % a)),
                                            v === p ? ((s = this._repeat), (n = m)) : ((s = ~~(v / a)) && s === v / a && ((n = m), s--), n > m && (n = m)),
                                            (c = this._yoyo && 1 & s) && ((h = this._yEase), (n = m - n)),
                                            (l = De(this._tTime, a)),
                                            n === f && !i && this._initted)
                                        )
                                            return (this._tTime = v), this;
                                        s !== l && (d && this._yEase && At(d, c), !this.vars.repeatRefresh || c || this._lock || ((this._lock = i = 1), (this.render(ge(a * s), !0).invalidate()._lock = 0)));
                                    }
                                    if (!this._initted) {
                                        if (He(this, g ? e : n, i, t, v)) return (this._tTime = 0), this;
                                        if (f !== this._time) return this;
                                        if (m !== this._dur) return this.render(e, t, i);
                                    }
                                    if (
                                        ((this._tTime = v),
                                        (this._time = n),
                                        !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                                        (this.ratio = u = (h || this._ease)(n / m)),
                                        this._from && (this.ratio = u = 1 - u),
                                        n && !f && !t && !s && (ht(this, "onStart"), this._tTime !== v))
                                    )
                                        return this;
                                    for (r = this._pt; r; ) r.r(u, r.d), (r = r._next);
                                    (d && d.render(e < 0 ? e : !n && c ? -1e-8 : d._dur * d._ease(n / this._dur), t, i)) || (this._startAt && (this._zTime = e)),
                                        this._onUpdate && !t && (g && Ae(this, e, 0, i), ht(this, "onUpdate")),
                                        this._repeat && s !== l && this.vars.onRepeat && !t && this.parent && ht(this, "onRepeat"),
                                        (v !== this._tDur && v) ||
                                            this._tTime !== v ||
                                            (g && !this._onUpdate && Ae(this, e, 0, !0),
                                            (e || !m) && ((v === this._tDur && this._ts > 0) || (!v && this._ts < 0)) && Le(this, 1),
                                            t || (g && !f) || !(v || f || c) || (ht(this, v === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < p && this.timeScale() > 0) && this._prom()));
                                }
                            } else
                                !(function (e, t, i, n) {
                                    var r,
                                        s,
                                        a,
                                        l = e.ratio,
                                        c = t < 0 || (!t && ((!e._start && qe(e) && (e._initted || !Ve(e))) || ((e._ts < 0 || e._dp._ts < 0) && !Ve(e)))) ? 0 : 1,
                                        u = e._rDelay,
                                        d = 0;
                                    if (
                                        (u && e._repeat && ((d = Ke(0, e._tDur, t)), (s = De(d, u)), e._yoyo && 1 & s && (c = 1 - c), s !== De(e._tTime, u) && ((l = 1 - c), e.vars.repeatRefresh && e._initted && e.invalidate())),
                                        c !== l || o || n || e._zTime === E || (!t && e._zTime))
                                    ) {
                                        if (!e._initted && He(e, t, n, i, d)) return;
                                        for (a = e._zTime, e._zTime = t || (i ? E : 0), i || (i = t && !a), e.ratio = c, e._from && (c = 1 - c), e._time = 0, e._tTime = d, r = e._pt; r; ) r.r(c, r.d), (r = r._next);
                                        t < 0 && Ae(e, t, 0, !0),
                                            e._onUpdate && !i && ht(e, "onUpdate"),
                                            d && e._repeat && !i && e.parent && ht(e, "onRepeat"),
                                            (t >= e._tDur || t < 0) && e.ratio === c && (c && Le(e, 1), i || o || (ht(e, c ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
                                    } else e._zTime || (e._zTime = t);
                                })(this, e, t, i);
                            return this;
                        }),
                        (i.targets = function () {
                            return this._targets;
                        }),
                        (i.invalidate = function (t) {
                            return (
                                (!t || !this.vars.runBackwards) && (this._startAt = 0),
                                (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
                                (this._ptLookup = []),
                                this.timeline && this.timeline.invalidate(t),
                                e.prototype.invalidate.call(this, t)
                            );
                        }),
                        (i.resetTo = function (e, t, i, n) {
                            m || Tt.wake(), this._ts || this.play();
                            var r = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                            return (
                                this._initted || Wt(this, r),
                                (function (e, t, i, n, r, s, o) {
                                    var a,
                                        l,
                                        c,
                                        u,
                                        d = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                                    if (!d)
                                        for (d = e._ptCache[t] = [], c = e._ptLookup, u = e._targets.length; u--; ) {
                                            if ((a = c[u][t]) && a.d && a.d._pt) for (a = a.d._pt; a && a.p !== t && a.fp !== t; ) a = a._next;
                                            if (!a) return (Ht = 1), (e.vars[t] = "+=0"), Wt(e, o), (Ht = 0), 1;
                                            d.push(a);
                                        }
                                    for (u = d.length; u--; ) ((a = (l = d[u])._pt || l).s = (!n && 0 !== n) || r ? a.s + (n || 0) + s * a.c : n), (a.c = i - a.s), l.e && (l.e = me(i) + Je(l.e)), l.b && (l.b = a.s + Je(l.b));
                                })(this, e, t, i, n, this._ease(r / this._dur), r)
                                    ? this.resetTo(e, t, i, n)
                                    : (Fe(this, 0), this.parent || Ce(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0))
                            );
                        }),
                        (i.kill = function (e, t) {
                            if ((void 0 === t && (t = "all"), !(e || (t && "all" !== t)))) return (this._lazy = this._pt = 0), this.parent ? ft(this) : this;
                            if (this.timeline) {
                                var i = this.timeline.totalDuration();
                                return this.timeline.killTweensOf(e, t, Bt && !0 !== Bt.vars.overwrite)._first || ft(this), this.parent && i !== this.timeline.totalDuration() && Ye(this, (this._dur * this.timeline._tDur) / i, 0, 1), this;
                            }
                            var n,
                                r,
                                s,
                                o,
                                a,
                                l,
                                c,
                                u = this._targets,
                                d = e ? tt(e) : u,
                                h = this._ptLookup,
                                f = this._pt;
                            if (
                                (!t || "all" === t) &&
                                (function (e, t) {
                                    for (var i = e.length, n = i === t.length; n && i-- && e[i] === t[i]; );
                                    return i < 0;
                                })(u, d)
                            )
                                return "all" === t && (this._pt = 0), ft(this);
                            for (
                                n = this._op = this._op || [],
                                    "all" !== t &&
                                        (L(t) &&
                                            ((a = {}),
                                            pe(t, function (e) {
                                                return (a[e] = 1);
                                            }),
                                            (t = a)),
                                        (t = (function (e, t) {
                                            var i,
                                                n,
                                                r,
                                                s,
                                                o = e[0] ? he(e[0]).harness : 0,
                                                a = o && o.aliases;
                                            if (!a) return t;
                                            for (n in ((i = _e({}, t)), a)) if ((n in i)) for (r = (s = a[n].split(",")).length; r--; ) i[s[r]] = i[n];
                                            return i;
                                        })(u, t))),
                                    c = u.length;
                                c--;

                            )
                                if (~d.indexOf(u[c]))
                                    for (a in ((r = h[c]), "all" === t ? ((n[c] = t), (o = r), (s = {})) : ((s = n[c] = n[c] || {}), (o = t)), o))
                                        (l = r && r[a]) && (("kill" in l.d && !0 !== l.d.kill(a)) || Oe(this, l, "_pt"), delete r[a]), "all" !== s && (s[a] = 1);
                            return this._initted && !this._pt && f && ft(this), this;
                        }),
                        (t.to = function (e, i) {
                            return new t(e, i, arguments[2]);
                        }),
                        (t.from = function (e, t) {
                            return Ue(1, arguments);
                        }),
                        (t.delayedCall = function (e, i, n, r) {
                            return new t(i, 0, { immediateRender: !1, lazy: !1, overwrite: !1, delay: e, onComplete: i, onReverseComplete: i, onCompleteParams: n, onReverseCompleteParams: n, callbackScope: r });
                        }),
                        (t.fromTo = function (e, t, i) {
                            return Ue(2, arguments);
                        }),
                        (t.set = function (e, i) {
                            return (i.duration = 0), i.repeatDelay || (i.repeat = 0), new t(e, i);
                        }),
                        (t.killTweensOf = function (e, t, i) {
                            return l.killTweensOf(e, t, i);
                        }),
                        t
                    );
                })($t);
                Ee(Kt.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
                    pe("staggerTo,staggerFrom,staggerFromTo", function (e) {
                        Kt[e] = function () {
                            var t = new Nt(),
                                i = Qe.call(arguments, 0);
                            return i.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, i);
                        };
                    });
                var Jt = function (e, t, i) {
                        return (e[t] = i);
                    },
                    Qt = function (e, t, i) {
                        return e[t](i);
                    },
                    ei = function (e, t, i, n) {
                        return e[t](n.fp, i);
                    },
                    ti = function (e, t, i) {
                        return e.setAttribute(t, i);
                    },
                    ii = function (e, t) {
                        return k(e[t]) ? Qt : I(e[t]) && e.setAttribute ? ti : Jt;
                    },
                    ni = function (e, t) {
                        return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
                    },
                    ri = function (e, t) {
                        return t.set(t.t, t.p, !!(t.s + t.c * e), t);
                    },
                    si = function (e, t) {
                        var i = t._pt,
                            n = "";
                        if (!e && t.b) n = t.b;
                        else if (1 === e && t.e) n = t.e;
                        else {
                            for (; i; ) (n = i.p + (i.m ? i.m(i.s + i.c * e) : Math.round(1e4 * (i.s + i.c * e)) / 1e4) + n), (i = i._next);
                            n += t.c;
                        }
                        t.set(t.t, t.p, n, t);
                    },
                    oi = function (e, t) {
                        for (var i = t._pt; i; ) i.r(e, i.d), (i = i._next);
                    },
                    ai = function (e, t, i, n) {
                        for (var r, s = this._pt; s; ) (r = s._next), s.p === n && s.modifier(e, t, i), (s = r);
                    },
                    li = function (e) {
                        for (var t, i, n = this._pt; n; ) (i = n._next), (n.p === e && !n.op) || n.op === e ? Oe(this, n, "_pt") : n.dep || (t = 1), (n = i);
                        return !t;
                    },
                    ci = function (e, t, i, n) {
                        n.mSet(e, t, n.m.call(n.tween, i, n.mt), n);
                    },
                    ui = function (e) {
                        for (var t, i, n, r, s = e._pt; s; ) {
                            for (t = s._next, i = n; i && i.pr > s.pr; ) i = i._next;
                            (s._prev = i ? i._prev : r) ? (s._prev._next = s) : (n = s), (s._next = i) ? (i._prev = s) : (r = s), (s = t);
                        }
                        e._pt = n;
                    },
                    di = (function () {
                        function e(e, t, i, n, r, s, o, a, l) {
                            (this.t = t), (this.s = n), (this.c = r), (this.p = i), (this.r = s || ni), (this.d = o || this), (this.set = a || Jt), (this.pr = l || 0), (this._next = e), e && (e._prev = this);
                        }
                        return (
                            (e.prototype.modifier = function (e, t, i) {
                                (this.mSet = this.mSet || this.set), (this.set = ci), (this.m = e), (this.mt = i), (this.tween = t);
                            }),
                            e
                        );
                    })();
                pe(
                    ue +
                        "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
                    function (e) {
                        return (ne[e] = 1);
                    }
                ),
                    (X.TweenMax = X.TweenLite = Kt),
                    (X.TimelineLite = X.TimelineMax = Nt),
                    (l = new Nt({ sortChildren: !1, defaults: x, autoRemoveChildren: !0, id: "root", smoothChildTiming: !0 })),
                    (w.stringFilter = _t);
                var hi = [],
                    fi = {},
                    pi = [],
                    mi = 0,
                    gi = 0,
                    vi = function (e) {
                        return (fi[e] || pi).map(function (e) {
                            return e();
                        });
                    },
                    bi = function () {
                        var e = Date.now(),
                            t = [];
                        e - mi > 2 &&
                            (vi("matchMediaInit"),
                            hi.forEach(function (e) {
                                var i,
                                    n,
                                    r,
                                    s,
                                    o = e.queries,
                                    a = e.conditions;
                                for (n in o) (i = c.matchMedia(o[n]).matches) && (r = 1), i !== a[n] && ((a[n] = i), (s = 1));
                                s && (e.revert(), r && t.push(e));
                            }),
                            vi("matchMediaRevert"),
                            t.forEach(function (e) {
                                return e.onMatch(e);
                            }),
                            (mi = e),
                            vi("matchMedia"));
                    },
                    yi = (function () {
                        function e(e, t) {
                            (this.selector = t && it(t)), (this.data = []), (this._r = []), (this.isReverted = !1), (this.id = gi++), e && this.add(e);
                        }
                        var t = e.prototype;
                        return (
                            (t.add = function (e, t, i) {
                                k(e) && ((i = t), (t = e), (e = k));
                                var n = this,
                                    r = function () {
                                        var e,
                                            r = a,
                                            s = n.selector;
                                        return r && r !== n && r.data.push(n), i && (n.selector = it(i)), (a = n), (e = t.apply(n, arguments)), k(e) && n._r.push(e), (a = r), (n.selector = s), (n.isReverted = !1), e;
                                    };
                                return (n.last = r), e === k ? r(n) : e ? (n[e] = r) : r;
                            }),
                            (t.ignore = function (e) {
                                var t = a;
                                (a = null), e(this), (a = t);
                            }),
                            (t.getTweens = function () {
                                var t = [];
                                return (
                                    this.data.forEach(function (i) {
                                        return i instanceof e ? t.push.apply(t, i.getTweens()) : i instanceof Kt && !(i.parent && "nested" === i.parent.data) && t.push(i);
                                    }),
                                    t
                                );
                            }),
                            (t.clear = function () {
                                this._r.length = this.data.length = 0;
                            }),
                            (t.kill = function (e, t) {
                                var i = this;
                                if (e) {
                                    var n = this.getTweens();
                                    this.data.forEach(function (e) {
                                        "isFlip" === e.data &&
                                            (e.revert(),
                                            e.getChildren(!0, !0, !1).forEach(function (e) {
                                                return n.splice(n.indexOf(e), 1);
                                            }));
                                    }),
                                        n
                                            .map(function (e) {
                                                return { g: e.globalTime(0), t: e };
                                            })
                                            .sort(function (e, t) {
                                                return t.g - e.g || -1 / 0;
                                            })
                                            .forEach(function (t) {
                                                return t.t.revert(e);
                                            }),
                                        this.data.forEach(function (t) {
                                            return !(t instanceof Kt) && t.revert && t.revert(e);
                                        }),
                                        this._r.forEach(function (t) {
                                            return t(e, i);
                                        }),
                                        (this.isReverted = !0);
                                } else
                                    this.data.forEach(function (e) {
                                        return e.kill && e.kill();
                                    });
                                if ((this.clear(), t)) for (var r = hi.length; r--; ) hi[r].id === this.id && hi.splice(r, 1);
                            }),
                            (t.revert = function (e) {
                                this.kill(e || {});
                            }),
                            e
                        );
                    })(),
                    wi = (function () {
                        function e(e) {
                            (this.contexts = []), (this.scope = e);
                        }
                        var t = e.prototype;
                        return (
                            (t.add = function (e, t, i) {
                                z(e) || (e = { matches: e });
                                var n,
                                    r,
                                    s,
                                    o = new yi(0, i || this.scope),
                                    l = (o.conditions = {});
                                for (r in (a && !o.selector && (o.selector = a.selector), this.contexts.push(o), (t = o.add("onMatch", t)), (o.queries = e), e))
                                    "all" === r ? (s = 1) : (n = c.matchMedia(e[r])) && (hi.indexOf(o) < 0 && hi.push(o), (l[r] = n.matches) && (s = 1), n.addListener ? n.addListener(bi) : n.addEventListener("change", bi));
                                return s && t(o), this;
                            }),
                            (t.revert = function (e) {
                                this.kill(e || {});
                            }),
                            (t.kill = function (e) {
                                this.contexts.forEach(function (t) {
                                    return t.kill(e, !0);
                                });
                            }),
                            e
                        );
                    })(),
                    xi = {
                        registerPlugin: function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            t.forEach(function (e) {
                                return mt(e);
                            });
                        },
                        timeline: function (e) {
                            return new Nt(e);
                        },
                        getTweensOf: function (e, t) {
                            return l.getTweensOf(e, t);
                        },
                        getProperty: function (e, t, i, n) {
                            L(e) && (e = tt(e)[0]);
                            var r = he(e || {}).get,
                                s = i ? Se : xe;
                            return (
                                "native" === i && (i = ""),
                                e
                                    ? t
                                        ? s(((oe[t] && oe[t].get) || r)(e, t, i, n))
                                        : function (t, i, n) {
                                              return s(((oe[t] && oe[t].get) || r)(e, t, i, n));
                                          }
                                    : e
                            );
                        },
                        quickSetter: function (e, t, i) {
                            if ((e = tt(e)).length > 1) {
                                var n = e.map(function (e) {
                                        return _i.quickSetter(e, t, i);
                                    }),
                                    r = n.length;
                                return function (e) {
                                    for (var t = r; t--; ) n[t](e);
                                };
                            }
                            e = e[0] || {};
                            var s = oe[t],
                                o = he(e),
                                a = (o.harness && (o.harness.aliases || {})[t]) || t,
                                l = s
                                    ? function (t) {
                                          var n = new s();
                                          (p._pt = 0), n.init(e, i ? t + i : t, p, 0, [e]), n.render(1, n), p._pt && oi(1, p);
                                      }
                                    : o.set(e, a);
                            return s
                                ? l
                                : function (t) {
                                      return l(e, a, i ? t + i : t, o, 1);
                                  };
                        },
                        quickTo: function (e, t, i) {
                            var n,
                                r = _i.to(e, _e((((n = {})[t] = "+=0.1"), (n.paused = !0), n), i || {})),
                                s = function (e, i, n) {
                                    return r.resetTo(t, e, i, n);
                                };
                            return (s.tween = r), s;
                        },
                        isTweening: function (e) {
                            return l.getTweensOf(e, !0).length > 0;
                        },
                        defaults: function (e) {
                            return e && e.ease && (e.ease = It(e.ease, x.ease)), Te(x, e || {});
                        },
                        config: function (e) {
                            return Te(w, e || {});
                        },
                        registerEffect: function (e) {
                            var t = e.name,
                                i = e.effect,
                                n = e.plugins,
                                r = e.defaults,
                                s = e.extendTimeline;
                            (n || "").split(",").forEach(function (e) {
                                return e && !oe[e] && !X[e] && K(t + " effect requires " + e + " plugin.");
                            }),
                                (ae[t] = function (e, t, n) {
                                    return i(tt(e), Ee(t || {}, r), n);
                                }),
                                s &&
                                    (Nt.prototype[t] = function (e, i, n) {
                                        return this.add(ae[t](e, z(i) ? i : (n = i) && {}, this), n);
                                    });
                        },
                        registerEase: function (e, t) {
                            Pt[e] = It(t);
                        },
                        parseEase: function (e, t) {
                            return arguments.length ? It(e, t) : Pt;
                        },
                        getById: function (e) {
                            return l.getById(e);
                        },
                        exportRoot: function (e, t) {
                            void 0 === e && (e = {});
                            var i,
                                n,
                                r = new Nt(e);
                            for (r.smoothChildTiming = D(e.smoothChildTiming), l.remove(r), r._dp = 0, r._time = r._tTime = l._time, i = l._first; i; )
                                (n = i._next), (!t && !i._dur && i instanceof Kt && i.vars.onComplete === i._targets[0]) || Ne(r, i, i._start - i._delay), (i = n);
                            return Ne(l, r, 0), r;
                        },
                        context: function (e, t) {
                            return e ? new yi(e, t) : a;
                        },
                        matchMedia: function (e) {
                            return new wi(e);
                        },
                        matchMediaRefresh: function () {
                            return (
                                hi.forEach(function (e) {
                                    var t,
                                        i,
                                        n = e.conditions;
                                    for (i in n) n[i] && ((n[i] = !1), (t = 1));
                                    t && e.revert();
                                }) || bi()
                            );
                        },
                        addEventListener: function (e, t) {
                            var i = fi[e] || (fi[e] = []);
                            ~i.indexOf(t) || i.push(t);
                        },
                        removeEventListener: function (e, t) {
                            var i = fi[e],
                                n = i && i.indexOf(t);
                            n >= 0 && i.splice(n, 1);
                        },
                        utils: {
                            wrap: function e(t, i, n) {
                                var r = i - t;
                                return $(t)
                                    ? lt(t, e(0, t.length), i)
                                    : Ze(n, function (e) {
                                          return ((r + ((e - t) % r)) % r) + t;
                                      });
                            },
                            wrapYoyo: function e(t, i, n) {
                                var r = i - t,
                                    s = 2 * r;
                                return $(t)
                                    ? lt(t, e(0, t.length - 1), i)
                                    : Ze(n, function (e) {
                                          return t + ((e = (s + ((e - t) % s)) % s || 0) > r ? s - e : e);
                                      });
                            },
                            distribute: rt,
                            random: at,
                            snap: ot,
                            normalize: function (e, t, i) {
                                return ut(e, t, 0, 1, i);
                            },
                            getUnit: Je,
                            clamp: function (e, t, i) {
                                return Ze(i, function (i) {
                                    return Ke(e, t, i);
                                });
                            },
                            splitColor: yt,
                            toArray: tt,
                            selector: it,
                            mapRange: ut,
                            pipe: function () {
                                for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                                return function (e) {
                                    return t.reduce(function (e, t) {
                                        return t(e);
                                    }, e);
                                };
                            },
                            unitize: function (e, t) {
                                return function (i) {
                                    return e(parseFloat(i)) + (t || Je(i));
                                };
                            },
                            interpolate: function e(t, i, n, r) {
                                var s = isNaN(t + i)
                                    ? 0
                                    : function (e) {
                                          return (1 - e) * t + e * i;
                                      };
                                if (!s) {
                                    var o,
                                        a,
                                        l,
                                        c,
                                        u,
                                        d = L(t),
                                        h = {};
                                    if ((!0 === n && (r = 1) && (n = null), d)) (t = { p: t }), (i = { p: i });
                                    else if ($(t) && !$(i)) {
                                        for (l = [], c = t.length, u = c - 2, a = 1; a < c; a++) l.push(e(t[a - 1], t[a]));
                                        c--,
                                            (s = function (e) {
                                                e *= c;
                                                var t = Math.min(u, ~~e);
                                                return l[t](e - t);
                                            }),
                                            (n = i);
                                    } else r || (t = _e($(t) ? [] : {}, t));
                                    if (!l) {
                                        for (o in i) Vt.call(h, t, o, "get", i[o]);
                                        s = function (e) {
                                            return oi(e, h) || (d ? t.p : t);
                                        };
                                    }
                                }
                                return Ze(n, s);
                            },
                            shuffle: nt,
                        },
                        install: U,
                        effects: ae,
                        ticker: Tt,
                        updateRoot: Nt.updateRoot,
                        plugins: oe,
                        globalTimeline: l,
                        core: {
                            PropTween: di,
                            globals: J,
                            Tween: Kt,
                            Timeline: Nt,
                            Animation: $t,
                            getCache: he,
                            _removeLinkedListItem: Oe,
                            reverting: function () {
                                return o;
                            },
                            context: function (e) {
                                return e && a && (a.data.push(e), (e._ctx = a)), a;
                            },
                            suppressOverwrites: function (e) {
                                return (s = e);
                            },
                        },
                    };
                pe("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
                    return (xi[e] = Kt[e]);
                }),
                    Tt.add(Nt.updateRoot),
                    (p = xi.to({}, { duration: 0 }));
                var Si = function (e, t) {
                        for (var i = e._pt; i && i.p !== t && i.op !== t && i.fp !== t; ) i = i._next;
                        return i;
                    },
                    Ei = function (e, t) {
                        return {
                            name: e,
                            rawVars: 1,
                            init: function (e, i, n) {
                                n._onInit = function (e) {
                                    var n, r;
                                    if (
                                        (L(i) &&
                                            ((n = {}),
                                            pe(i, function (e) {
                                                return (n[e] = 1);
                                            }),
                                            (i = n)),
                                        t)
                                    ) {
                                        for (r in ((n = {}), i)) n[r] = t(i[r]);
                                        i = n;
                                    }
                                    !(function (e, t) {
                                        var i,
                                            n,
                                            r,
                                            s = e._targets;
                                        for (i in t) for (n = s.length; n--; ) (r = e._ptLookup[n][i]) && (r = r.d) && (r._pt && (r = Si(r, i)), r && r.modifier && r.modifier(t[i], e, s[n], i));
                                    })(e, i);
                                };
                            },
                        };
                    },
                    _i =
                        xi.registerPlugin(
                            {
                                name: "attr",
                                init: function (e, t, i, n, r) {
                                    var s, o, a;
                                    for (s in ((this.tween = i), t)) (a = e.getAttribute(s) || ""), ((o = this.add(e, "setAttribute", (a || 0) + "", t[s], n, r, 0, 0, s)).op = s), (o.b = a), this._props.push(s);
                                },
                                render: function (e, t) {
                                    for (var i = t._pt; i; ) o ? i.set(i.t, i.p, i.b, i) : i.r(e, i.d), (i = i._next);
                                },
                            },
                            {
                                name: "endArray",
                                init: function (e, t) {
                                    for (var i = t.length; i--; ) this.add(e, i, e[i] || 0, t[i], 0, 0, 0, 0, 0, 1);
                                },
                            },
                            Ei("roundProps", st),
                            Ei("modifiers"),
                            Ei("snap", ot)
                        ) || xi;
                (Kt.version = Nt.version = _i.version = "3.12.2"), (h = 1), j() && Mt();
                var Ti,
                    Mi,
                    Pi,
                    Ci,
                    Oi,
                    Li,
                    ki,
                    Ai,
                    Ii = Pt.Power0,
                    zi = Pt.Power1,
                    Di = Pt.Power2,
                    ji = Pt.Power3,
                    Ri = Pt.Power4,
                    Fi = Pt.Linear,
                    $i = Pt.Quad,
                    Ni = Pt.Cubic,
                    Bi = Pt.Quart,
                    Hi = Pt.Quint,
                    qi = Pt.Strong,
                    Vi = Pt.Elastic,
                    Yi = Pt.Back,
                    Wi = Pt.SteppedEase,
                    Xi = Pt.Bounce,
                    Gi = Pt.Sine,
                    Ui = Pt.Expo,
                    Zi = Pt.Circ,
                    Ki = {},
                    Ji = 180 / Math.PI,
                    Qi = Math.PI / 180,
                    en = Math.atan2,
                    tn = /([A-Z])/g,
                    nn = /(left|right|width|margin|padding|x)/i,
                    rn = /[\s,\(]\S/,
                    sn = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" },
                    on = function (e, t) {
                        return t.set(t.t, t.p, Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t);
                    },
                    an = function (e, t) {
                        return t.set(t.t, t.p, 1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t);
                    },
                    ln = function (e, t) {
                        return t.set(t.t, t.p, e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b, t);
                    },
                    cn = function (e, t) {
                        var i = t.s + t.c * e;
                        t.set(t.t, t.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + t.u, t);
                    },
                    un = function (e, t) {
                        return t.set(t.t, t.p, e ? t.e : t.b, t);
                    },
                    dn = function (e, t) {
                        return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
                    },
                    hn = function (e, t, i) {
                        return (e.style[t] = i);
                    },
                    fn = function (e, t, i) {
                        return e.style.setProperty(t, i);
                    },
                    pn = function (e, t, i) {
                        return (e._gsap[t] = i);
                    },
                    mn = function (e, t, i) {
                        return (e._gsap.scaleX = e._gsap.scaleY = i);
                    },
                    gn = function (e, t, i, n, r) {
                        var s = e._gsap;
                        (s.scaleX = s.scaleY = i), s.renderTransform(r, s);
                    },
                    vn = function (e, t, i, n, r) {
                        var s = e._gsap;
                        (s[t] = i), s.renderTransform(r, s);
                    },
                    bn = "transform",
                    yn = bn + "Origin",
                    wn = function e(t, i) {
                        var n = this,
                            r = this.target,
                            s = r.style;
                        if (t in Ki && s) {
                            if (((this.tfm = this.tfm || {}), "transform" === t))
                                return sn.transform.split(",").forEach(function (t) {
                                    return e.call(n, t, i);
                                });
                            if (
                                (~(t = sn[t] || t).indexOf(",")
                                    ? t.split(",").forEach(function (e) {
                                          return (n.tfm[e] = Fn(r, e));
                                      })
                                    : (this.tfm[t] = r._gsap.x ? r._gsap[t] : Fn(r, t)),
                                this.props.indexOf(bn) >= 0)
                            )
                                return;
                            r._gsap.svg && ((this.svgo = r.getAttribute("data-svg-origin")), this.props.push(yn, i, "")), (t = bn);
                        }
                        (s || i) && this.props.push(t, i, s[t]);
                    },
                    xn = function (e) {
                        e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
                    },
                    Sn = function () {
                        var e,
                            t,
                            i = this.props,
                            n = this.target,
                            r = n.style,
                            s = n._gsap;
                        for (e = 0; e < i.length; e += 3) i[e + 1] ? (n[i[e]] = i[e + 2]) : i[e + 2] ? (r[i[e]] = i[e + 2]) : r.removeProperty("--" === i[e].substr(0, 2) ? i[e] : i[e].replace(tn, "-$1").toLowerCase());
                        if (this.tfm) {
                            for (t in this.tfm) s[t] = this.tfm[t];
                            s.svg && (s.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), ((e = ki()) && e.isStart) || r[bn] || (xn(r), (s.uncache = 1));
                        }
                    },
                    En = function (e, t) {
                        var i = { target: e, props: [], revert: Sn, save: wn };
                        return (
                            e._gsap || _i.core.getCache(e),
                            t &&
                                t.split(",").forEach(function (e) {
                                    return i.save(e);
                                }),
                            i
                        );
                    },
                    _n = function (e, t) {
                        var i = Mi.createElementNS ? Mi.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Mi.createElement(e);
                        return i.style ? i : Mi.createElement(e);
                    },
                    Tn = function e(t, i, n) {
                        var r = getComputedStyle(t);
                        return r[i] || r.getPropertyValue(i.replace(tn, "-$1").toLowerCase()) || r.getPropertyValue(i) || (!n && e(t, Pn(i) || i, 1)) || "";
                    },
                    Mn = "O,Moz,ms,Ms,Webkit".split(","),
                    Pn = function (e, t, i) {
                        var n = (t || Oi).style,
                            r = 5;
                        if (e in n && !i) return e;
                        for (e = e.charAt(0).toUpperCase() + e.substr(1); r-- && !(Mn[r] + e in n); );
                        return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? Mn[r] : "") + e;
                    },
                    Cn = function () {
                        "undefined" != typeof window &&
                            window.document &&
                            ((Ti = window),
                            (Mi = Ti.document),
                            (Pi = Mi.documentElement),
                            (Oi = _n("div") || { style: {} }),
                            _n("div"),
                            (bn = Pn(bn)),
                            (yn = bn + "Origin"),
                            (Oi.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"),
                            (Ai = !!Pn("perspective")),
                            (ki = _i.core.reverting),
                            (Ci = 1));
                    },
                    On = function e(t) {
                        var i,
                            n = _n("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
                            r = this.parentNode,
                            s = this.nextSibling,
                            o = this.style.cssText;
                        if ((Pi.appendChild(n), n.appendChild(this), (this.style.display = "block"), t))
                            try {
                                (i = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = e);
                            } catch (e) {}
                        else this._gsapBBox && (i = this._gsapBBox());
                        return r && (s ? r.insertBefore(this, s) : r.appendChild(this)), Pi.removeChild(n), (this.style.cssText = o), i;
                    },
                    Ln = function (e, t) {
                        for (var i = t.length; i--; ) if (e.hasAttribute(t[i])) return e.getAttribute(t[i]);
                    },
                    kn = function (e) {
                        var t;
                        try {
                            t = e.getBBox();
                        } catch (i) {
                            t = On.call(e, !0);
                        }
                        return (t && (t.width || t.height)) || e.getBBox === On || (t = On.call(e, !0)), !t || t.width || t.x || t.y ? t : { x: +Ln(e, ["x", "cx", "x1"]) || 0, y: +Ln(e, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
                    },
                    An = function (e) {
                        return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !kn(e));
                    },
                    In = function (e, t) {
                        if (t) {
                            var i = e.style;
                            t in Ki && t !== yn && (t = bn), i.removeProperty ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) || (t = "-" + t), i.removeProperty(t.replace(tn, "-$1").toLowerCase())) : i.removeAttribute(t);
                        }
                    },
                    zn = function (e, t, i, n, r, s) {
                        var o = new di(e._pt, t, i, 0, 1, s ? dn : un);
                        return (e._pt = o), (o.b = n), (o.e = r), e._props.push(i), o;
                    },
                    Dn = { deg: 1, rad: 1, turn: 1 },
                    jn = { grid: 1, flex: 1 },
                    Rn = function e(t, i, n, r) {
                        var s,
                            o,
                            a,
                            l,
                            c = parseFloat(n) || 0,
                            u = (n + "").trim().substr((c + "").length) || "px",
                            d = Oi.style,
                            h = nn.test(i),
                            f = "svg" === t.tagName.toLowerCase(),
                            p = (f ? "client" : "offset") + (h ? "Width" : "Height"),
                            m = 100,
                            g = "px" === r,
                            v = "%" === r;
                        return r === u || !c || Dn[r] || Dn[u]
                            ? c
                            : ("px" !== u && !g && (c = e(t, i, n, "px")),
                              (l = t.getCTM && An(t)),
                              (!v && "%" !== u) || (!Ki[i] && !~i.indexOf("adius"))
                                  ? ((d[h ? "width" : "height"] = m + (g ? u : r)),
                                    (o = ~i.indexOf("adius") || ("em" === r && t.appendChild && !f) ? t : t.parentNode),
                                    l && (o = (t.ownerSVGElement || {}).parentNode),
                                    (o && o !== Mi && o.appendChild) || (o = Mi.body),
                                    (a = o._gsap) && v && a.width && h && a.time === Tt.time && !a.uncache
                                        ? me((c / a.width) * m)
                                        : ((v || "%" === u) && !jn[Tn(o, "display")] && (d.position = Tn(t, "position")),
                                          o === t && (d.position = "static"),
                                          o.appendChild(Oi),
                                          (s = Oi[p]),
                                          o.removeChild(Oi),
                                          (d.position = "absolute"),
                                          h && v && (((a = he(o)).time = Tt.time), (a.width = o[p])),
                                          me(g ? (s * c) / m : s && c ? (m / s) * c : 0)))
                                  : ((s = l ? t.getBBox()[h ? "width" : "height"] : t[p]), me(v ? (c / s) * m : (c / 100) * s)));
                    },
                    Fn = function (e, t, i, n) {
                        var r;
                        return (
                            Ci || Cn(),
                            t in sn && "transform" !== t && ~(t = sn[t]).indexOf(",") && (t = t.split(",")[0]),
                            Ki[t] && "transform" !== t
                                ? ((r = Un(e, n)), (r = "transformOrigin" !== t ? r[t] : r.svg ? r.origin : Zn(Tn(e, yn)) + " " + r.zOrigin + "px"))
                                : (!(r = e.style[t]) || "auto" === r || n || ~(r + "").indexOf("calc(")) && (r = (Hn[t] && Hn[t](e, t, i)) || Tn(e, t) || fe(e, t) || ("opacity" === t ? 1 : 0)),
                            i && !~(r + "").trim().indexOf(" ") ? Rn(e, t, r, i) + i : r
                        );
                    },
                    $n = function (e, t, i, n) {
                        if (!i || "none" === i) {
                            var r = Pn(t, e, 1),
                                s = r && Tn(e, r, 1);
                            s && s !== i ? ((t = r), (i = s)) : "borderColor" === t && (i = Tn(e, "borderTopColor"));
                        }
                        var o,
                            a,
                            l,
                            c,
                            u,
                            d,
                            h,
                            f,
                            p,
                            m,
                            g,
                            v = new di(this._pt, e.style, t, 0, 1, si),
                            b = 0,
                            y = 0;
                        if (((v.b = i), (v.e = n), (i += ""), "auto" == (n += "") && ((e.style[t] = n), (n = Tn(e, t) || n), (e.style[t] = i)), _t((o = [i, n])), (n = o[1]), (l = (i = o[0]).match(H) || []), (n.match(H) || []).length)) {
                            for (; (a = H.exec(n)); )
                                (h = a[0]),
                                    (p = n.substring(b, a.index)),
                                    u ? (u = (u + 1) % 5) : ("rgba(" !== p.substr(-5) && "hsla(" !== p.substr(-5)) || (u = 1),
                                    h !== (d = l[y++] || "") &&
                                        ((c = parseFloat(d) || 0),
                                        (g = d.substr((c + "").length)),
                                        "=" === h.charAt(1) && (h = ve(c, h) + g),
                                        (f = parseFloat(h)),
                                        (m = h.substr((f + "").length)),
                                        (b = H.lastIndex - m.length),
                                        m || ((m = m || w.units[t] || g), b === n.length && ((n += m), (v.e += m))),
                                        g !== m && (c = Rn(e, t, d, m) || 0),
                                        (v._pt = { _next: v._pt, p: p || 1 === y ? p : ",", s: c, c: f - c, m: (u && u < 4) || "zIndex" === t ? Math.round : 0 }));
                            v.c = b < n.length ? n.substring(b, n.length) : "";
                        } else v.r = "display" === t && "none" === n ? dn : un;
                        return V.test(n) && (v.e = 0), (this._pt = v), v;
                    },
                    Nn = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
                    Bn = function (e, t) {
                        if (t.tween && t.tween._time === t.tween._dur) {
                            var i,
                                n,
                                r,
                                s = t.t,
                                o = s.style,
                                a = t.u,
                                l = s._gsap;
                            if ("all" === a || !0 === a) (o.cssText = ""), (n = 1);
                            else for (r = (a = a.split(",")).length; --r > -1; ) (i = a[r]), Ki[i] && ((n = 1), (i = "transformOrigin" === i ? yn : bn)), In(s, i);
                            n && (In(s, bn), l && (l.svg && s.removeAttribute("transform"), Un(s, 1), (l.uncache = 1), xn(o)));
                        }
                    },
                    Hn = {
                        clearProps: function (e, t, i, n, r) {
                            if ("isFromStart" !== r.data) {
                                var s = (e._pt = new di(e._pt, t, i, 0, 0, Bn));
                                return (s.u = n), (s.pr = -10), (s.tween = r), e._props.push(i), 1;
                            }
                        },
                    },
                    qn = [1, 0, 0, 1, 0, 0],
                    Vn = {},
                    Yn = function (e) {
                        return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
                    },
                    Wn = function (e) {
                        var t = Tn(e, bn);
                        return Yn(t) ? qn : t.substr(7).match(B).map(me);
                    },
                    Xn = function (e, t) {
                        var i,
                            n,
                            r,
                            s,
                            o = e._gsap || he(e),
                            a = e.style,
                            l = Wn(e);
                        return o.svg && e.getAttribute("transform")
                            ? "1,0,0,1,0,0" === (l = [(r = e.transform.baseVal.consolidate().matrix).a, r.b, r.c, r.d, r.e, r.f]).join(",")
                                ? qn
                                : l
                            : (l !== qn ||
                                  e.offsetParent ||
                                  e === Pi ||
                                  o.svg ||
                                  ((r = a.display),
                                  (a.display = "block"),
                                  ((i = e.parentNode) && e.offsetParent) || ((s = 1), (n = e.nextElementSibling), Pi.appendChild(e)),
                                  (l = Wn(e)),
                                  r ? (a.display = r) : In(e, "display"),
                                  s && (n ? i.insertBefore(e, n) : i ? i.appendChild(e) : Pi.removeChild(e))),
                              t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
                    },
                    Gn = function (e, t, i, n, r, s) {
                        var o,
                            a,
                            l,
                            c = e._gsap,
                            u = r || Xn(e, !0),
                            d = c.xOrigin || 0,
                            h = c.yOrigin || 0,
                            f = c.xOffset || 0,
                            p = c.yOffset || 0,
                            m = u[0],
                            g = u[1],
                            v = u[2],
                            b = u[3],
                            y = u[4],
                            w = u[5],
                            x = t.split(" "),
                            S = parseFloat(x[0]) || 0,
                            E = parseFloat(x[1]) || 0;
                        i
                            ? u !== qn && (a = m * b - g * v) && ((l = S * (-g / a) + E * (m / a) - (m * w - g * y) / a), (S = S * (b / a) + E * (-v / a) + (v * w - b * y) / a), (E = l))
                            : ((S = (o = kn(e)).x + (~x[0].indexOf("%") ? (S / 100) * o.width : S)), (E = o.y + (~(x[1] || x[0]).indexOf("%") ? (E / 100) * o.height : E))),
                            n || (!1 !== n && c.smooth) ? ((y = S - d), (w = E - h), (c.xOffset = f + (y * m + w * v) - y), (c.yOffset = p + (y * g + w * b) - w)) : (c.xOffset = c.yOffset = 0),
                            (c.xOrigin = S),
                            (c.yOrigin = E),
                            (c.smooth = !!n),
                            (c.origin = t),
                            (c.originIsAbsolute = !!i),
                            (e.style[yn] = "0px 0px"),
                            s && (zn(s, c, "xOrigin", d, S), zn(s, c, "yOrigin", h, E), zn(s, c, "xOffset", f, c.xOffset), zn(s, c, "yOffset", p, c.yOffset)),
                            e.setAttribute("data-svg-origin", S + " " + E);
                    },
                    Un = function (e, t) {
                        var i = e._gsap || new Ft(e);
                        if ("x" in i && !t && !i.uncache) return i;
                        var n,
                            r,
                            s,
                            o,
                            a,
                            l,
                            c,
                            u,
                            d,
                            h,
                            f,
                            p,
                            m,
                            g,
                            v,
                            b,
                            y,
                            x,
                            S,
                            E,
                            _,
                            T,
                            M,
                            P,
                            C,
                            O,
                            L,
                            k,
                            A,
                            I,
                            z,
                            D,
                            j = e.style,
                            R = i.scaleX < 0,
                            F = "px",
                            $ = "deg",
                            N = getComputedStyle(e),
                            B = Tn(e, yn) || "0";
                        return (
                            (n = r = s = l = c = u = d = h = f = 0),
                            (o = a = 1),
                            (i.svg = !(!e.getCTM || !An(e))),
                            N.translate &&
                                (("none" === N.translate && "none" === N.scale && "none" === N.rotate) ||
                                    (j[bn] =
                                        ("none" !== N.translate ? "translate3d(" + (N.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") +
                                        ("none" !== N.rotate ? "rotate(" + N.rotate + ") " : "") +
                                        ("none" !== N.scale ? "scale(" + N.scale.split(" ").join(",") + ") " : "") +
                                        ("none" !== N[bn] ? N[bn] : "")),
                                (j.scale = j.rotate = j.translate = "none")),
                            (g = Xn(e, i.svg)),
                            i.svg &&
                                (i.uncache ? ((C = e.getBBox()), (B = i.xOrigin - C.x + "px " + (i.yOrigin - C.y) + "px"), (P = "")) : (P = !t && e.getAttribute("data-svg-origin")),
                                Gn(e, P || B, !!P || i.originIsAbsolute, !1 !== i.smooth, g)),
                            (p = i.xOrigin || 0),
                            (m = i.yOrigin || 0),
                            g !== qn &&
                                ((x = g[0]),
                                (S = g[1]),
                                (E = g[2]),
                                (_ = g[3]),
                                (n = T = g[4]),
                                (r = M = g[5]),
                                6 === g.length
                                    ? ((o = Math.sqrt(x * x + S * S)),
                                      (a = Math.sqrt(_ * _ + E * E)),
                                      (l = x || S ? en(S, x) * Ji : 0),
                                      (d = E || _ ? en(E, _) * Ji + l : 0) && (a *= Math.abs(Math.cos(d * Qi))),
                                      i.svg && ((n -= p - (p * x + m * E)), (r -= m - (p * S + m * _))))
                                    : ((D = g[6]),
                                      (I = g[7]),
                                      (L = g[8]),
                                      (k = g[9]),
                                      (A = g[10]),
                                      (z = g[11]),
                                      (n = g[12]),
                                      (r = g[13]),
                                      (s = g[14]),
                                      (c = (v = en(D, A)) * Ji),
                                      v &&
                                          ((P = T * (b = Math.cos(-v)) + L * (y = Math.sin(-v))),
                                          (C = M * b + k * y),
                                          (O = D * b + A * y),
                                          (L = T * -y + L * b),
                                          (k = M * -y + k * b),
                                          (A = D * -y + A * b),
                                          (z = I * -y + z * b),
                                          (T = P),
                                          (M = C),
                                          (D = O)),
                                      (u = (v = en(-E, A)) * Ji),
                                      v && ((b = Math.cos(-v)), (z = _ * (y = Math.sin(-v)) + z * b), (x = P = x * b - L * y), (S = C = S * b - k * y), (E = O = E * b - A * y)),
                                      (l = (v = en(S, x)) * Ji),
                                      v && ((P = x * (b = Math.cos(v)) + S * (y = Math.sin(v))), (C = T * b + M * y), (S = S * b - x * y), (M = M * b - T * y), (x = P), (T = C)),
                                      c && Math.abs(c) + Math.abs(l) > 359.9 && ((c = l = 0), (u = 180 - u)),
                                      (o = me(Math.sqrt(x * x + S * S + E * E))),
                                      (a = me(Math.sqrt(M * M + D * D))),
                                      (v = en(T, M)),
                                      (d = Math.abs(v) > 2e-4 ? v * Ji : 0),
                                      (f = z ? 1 / (z < 0 ? -z : z) : 0)),
                                i.svg && ((P = e.getAttribute("transform")), (i.forceCSS = e.setAttribute("transform", "") || !Yn(Tn(e, bn))), P && e.setAttribute("transform", P))),
                            Math.abs(d) > 90 && Math.abs(d) < 270 && (R ? ((o *= -1), (d += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180)) : ((a *= -1), (d += d <= 0 ? 180 : -180))),
                            (t = t || i.uncache),
                            (i.x = n - ((i.xPercent = n && ((!t && i.xPercent) || (Math.round(e.offsetWidth / 2) === Math.round(-n) ? -50 : 0))) ? (e.offsetWidth * i.xPercent) / 100 : 0) + F),
                            (i.y = r - ((i.yPercent = r && ((!t && i.yPercent) || (Math.round(e.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? (e.offsetHeight * i.yPercent) / 100 : 0) + F),
                            (i.z = s + F),
                            (i.scaleX = me(o)),
                            (i.scaleY = me(a)),
                            (i.rotation = me(l) + $),
                            (i.rotationX = me(c) + $),
                            (i.rotationY = me(u) + $),
                            (i.skewX = d + $),
                            (i.skewY = h + $),
                            (i.transformPerspective = f + F),
                            (i.zOrigin = parseFloat(B.split(" ")[2]) || 0) && (j[yn] = Zn(B)),
                            (i.xOffset = i.yOffset = 0),
                            (i.force3D = w.force3D),
                            (i.renderTransform = i.svg ? nr : Ai ? ir : Jn),
                            (i.uncache = 0),
                            i
                        );
                    },
                    Zn = function (e) {
                        return (e = e.split(" "))[0] + " " + e[1];
                    },
                    Kn = function (e, t, i) {
                        var n = Je(t);
                        return me(parseFloat(t) + parseFloat(Rn(e, "x", i + "px", n))) + n;
                    },
                    Jn = function (e, t) {
                        (t.z = "0px"), (t.rotationY = t.rotationX = "0deg"), (t.force3D = 0), ir(e, t);
                    },
                    Qn = "0deg",
                    er = "0px",
                    tr = ") ",
                    ir = function (e, t) {
                        var i = t || this,
                            n = i.xPercent,
                            r = i.yPercent,
                            s = i.x,
                            o = i.y,
                            a = i.z,
                            l = i.rotation,
                            c = i.rotationY,
                            u = i.rotationX,
                            d = i.skewX,
                            h = i.skewY,
                            f = i.scaleX,
                            p = i.scaleY,
                            m = i.transformPerspective,
                            g = i.force3D,
                            v = i.target,
                            b = i.zOrigin,
                            y = "",
                            w = ("auto" === g && e && 1 !== e) || !0 === g;
                        if (b && (u !== Qn || c !== Qn)) {
                            var x,
                                S = parseFloat(c) * Qi,
                                E = Math.sin(S),
                                _ = Math.cos(S);
                            (S = parseFloat(u) * Qi), (x = Math.cos(S)), (s = Kn(v, s, E * x * -b)), (o = Kn(v, o, -Math.sin(S) * -b)), (a = Kn(v, a, _ * x * -b + b));
                        }
                        m !== er && (y += "perspective(" + m + tr),
                            (n || r) && (y += "translate(" + n + "%, " + r + "%) "),
                            (w || s !== er || o !== er || a !== er) && (y += a !== er || w ? "translate3d(" + s + ", " + o + ", " + a + ") " : "translate(" + s + ", " + o + tr),
                            l !== Qn && (y += "rotate(" + l + tr),
                            c !== Qn && (y += "rotateY(" + c + tr),
                            u !== Qn && (y += "rotateX(" + u + tr),
                            (d === Qn && h === Qn) || (y += "skew(" + d + ", " + h + tr),
                            (1 === f && 1 === p) || (y += "scale(" + f + ", " + p + tr),
                            (v.style[bn] = y || "translate(0, 0)");
                    },
                    nr = function (e, t) {
                        var i,
                            n,
                            r,
                            s,
                            o,
                            a = t || this,
                            l = a.xPercent,
                            c = a.yPercent,
                            u = a.x,
                            d = a.y,
                            h = a.rotation,
                            f = a.skewX,
                            p = a.skewY,
                            m = a.scaleX,
                            g = a.scaleY,
                            v = a.target,
                            b = a.xOrigin,
                            y = a.yOrigin,
                            w = a.xOffset,
                            x = a.yOffset,
                            S = a.forceCSS,
                            E = parseFloat(u),
                            _ = parseFloat(d);
                        (h = parseFloat(h)),
                            (f = parseFloat(f)),
                            (p = parseFloat(p)) && ((f += p = parseFloat(p)), (h += p)),
                            h || f
                                ? ((h *= Qi),
                                  (f *= Qi),
                                  (i = Math.cos(h) * m),
                                  (n = Math.sin(h) * m),
                                  (r = Math.sin(h - f) * -g),
                                  (s = Math.cos(h - f) * g),
                                  f && ((p *= Qi), (o = Math.tan(f - p)), (r *= o = Math.sqrt(1 + o * o)), (s *= o), p && ((o = Math.tan(p)), (i *= o = Math.sqrt(1 + o * o)), (n *= o))),
                                  (i = me(i)),
                                  (n = me(n)),
                                  (r = me(r)),
                                  (s = me(s)))
                                : ((i = m), (s = g), (n = r = 0)),
                            ((E && !~(u + "").indexOf("px")) || (_ && !~(d + "").indexOf("px"))) && ((E = Rn(v, "x", u, "px")), (_ = Rn(v, "y", d, "px"))),
                            (b || y || w || x) && ((E = me(E + b - (b * i + y * r) + w)), (_ = me(_ + y - (b * n + y * s) + x))),
                            (l || c) && ((o = v.getBBox()), (E = me(E + (l / 100) * o.width)), (_ = me(_ + (c / 100) * o.height))),
                            (o = "matrix(" + i + "," + n + "," + r + "," + s + "," + E + "," + _ + ")"),
                            v.setAttribute("transform", o),
                            S && (v.style[bn] = o);
                    },
                    rr = function (e, t, i, n, r) {
                        var s,
                            o,
                            a = 360,
                            l = L(r),
                            c = parseFloat(r) * (l && ~r.indexOf("rad") ? Ji : 1) - n,
                            u = n + c + "deg";
                        return (
                            l &&
                                ("short" === (s = r.split("_")[1]) && (c %= a) != c % 180 && (c += c < 0 ? a : -360),
                                "cw" === s && c < 0 ? (c = ((c + 36e9) % a) - ~~(c / a) * a) : "ccw" === s && c > 0 && (c = ((c - 36e9) % a) - ~~(c / a) * a)),
                            (e._pt = o = new di(e._pt, t, i, n, c, an)),
                            (o.e = u),
                            (o.u = "deg"),
                            e._props.push(i),
                            o
                        );
                    },
                    sr = function (e, t) {
                        for (var i in t) e[i] = t[i];
                        return e;
                    },
                    or = function (e, t, i) {
                        var n,
                            r,
                            s,
                            o,
                            a,
                            l,
                            c,
                            u = sr({}, i._gsap),
                            d = i.style;
                        for (r in (u.svg
                            ? ((s = i.getAttribute("transform")), i.setAttribute("transform", ""), (d[bn] = t), (n = Un(i, 1)), In(i, bn), i.setAttribute("transform", s))
                            : ((s = getComputedStyle(i)[bn]), (d[bn] = t), (n = Un(i, 1)), (d[bn] = s)),
                        Ki))
                            (s = u[r]) !== (o = n[r]) &&
                                "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 &&
                                ((a = Je(s) !== (c = Je(o)) ? Rn(i, r, s, c) : parseFloat(s)), (l = parseFloat(o)), (e._pt = new di(e._pt, n, r, a, l - a, on)), (e._pt.u = c || 0), e._props.push(r));
                        sr(n, u);
                    };
                pe("padding,margin,Width,Radius", function (e, t) {
                    var i = "Top",
                        n = "Right",
                        r = "Bottom",
                        s = "Left",
                        o = (t < 3 ? [i, n, r, s] : [i + s, i + n, r + n, r + s]).map(function (i) {
                            return t < 2 ? e + i : "border" + i + e;
                        });
                    Hn[t > 1 ? "border" + e : e] = function (e, t, i, n, r) {
                        var s, a;
                        if (arguments.length < 4)
                            return (
                                (s = o.map(function (t) {
                                    return Fn(e, t, i);
                                })),
                                5 === (a = s.join(" ")).split(s[0]).length ? s[0] : a
                            );
                        (s = (n + "").split(" ")),
                            (a = {}),
                            o.forEach(function (e, t) {
                                return (a[e] = s[t] = s[t] || s[((t - 1) / 2) | 0]);
                            }),
                            e.init(t, a, r);
                    };
                });
                var ar,
                    lr,
                    cr = {
                        name: "css",
                        register: Cn,
                        targetTest: function (e) {
                            return e.style && e.nodeType;
                        },
                        init: function (e, t, i, n, r) {
                            var s,
                                o,
                                a,
                                l,
                                c,
                                u,
                                d,
                                h,
                                f,
                                p,
                                m,
                                g,
                                v,
                                b,
                                y,
                                x,
                                S,
                                E,
                                _,
                                T,
                                M = this._props,
                                P = e.style,
                                C = i.vars.startAt;
                            for (d in (Ci || Cn(), (this.styles = this.styles || En(e)), (x = this.styles.props), (this.tween = i), t))
                                if ("autoRound" !== d && ((o = t[d]), !oe[d] || !Yt(d, t, i, n, e, r)))
                                    if (((c = typeof o), (u = Hn[d]), "function" === c && (c = typeof (o = o.call(i, n, e, r))), "string" === c && ~o.indexOf("random(") && (o = ct(o)), u)) u(this, e, d, o, i) && (y = 1);
                                    else if ("--" === d.substr(0, 2))
                                        (s = (getComputedStyle(e).getPropertyValue(d) + "").trim()),
                                            (o += ""),
                                            (St.lastIndex = 0),
                                            St.test(s) || ((h = Je(s)), (f = Je(o))),
                                            f ? h !== f && (s = Rn(e, d, s, f) + f) : h && (o += h),
                                            this.add(P, "setProperty", s, o, n, r, 0, 0, d),
                                            M.push(d),
                                            x.push(d, 0, P[d]);
                                    else if ("undefined" !== c) {
                                        if (
                                            (C && d in C
                                                ? ((s = "function" == typeof C[d] ? C[d].call(i, n, e, r) : C[d]),
                                                  L(s) && ~s.indexOf("random(") && (s = ct(s)),
                                                  Je(s + "") || (s += w.units[d] || Je(Fn(e, d)) || ""),
                                                  "=" === (s + "").charAt(1) && (s = Fn(e, d)))
                                                : (s = Fn(e, d)),
                                            (l = parseFloat(s)),
                                            (p = "string" === c && "=" === o.charAt(1) && o.substr(0, 2)) && (o = o.substr(2)),
                                            (a = parseFloat(o)),
                                            d in sn &&
                                                ("autoAlpha" === d &&
                                                    (1 === l && "hidden" === Fn(e, "visibility") && a && (l = 0), x.push("visibility", 0, P.visibility), zn(this, P, "visibility", l ? "inherit" : "hidden", a ? "inherit" : "hidden", !a)),
                                                "scale" !== d && "transform" !== d && ~(d = sn[d]).indexOf(",") && (d = d.split(",")[0])),
                                            (m = d in Ki))
                                        )
                                            if (
                                                (this.styles.save(d),
                                                g ||
                                                    (((v = e._gsap).renderTransform && !t.parseTransform) || Un(e, t.parseTransform),
                                                    (b = !1 !== t.smoothOrigin && v.smooth),
                                                    ((g = this._pt = new di(this._pt, P, bn, 0, 1, v.renderTransform, v, 0, -1)).dep = 1)),
                                                "scale" === d)
                                            )
                                                (this._pt = new di(this._pt, v, "scaleY", v.scaleY, (p ? ve(v.scaleY, p + a) : a) - v.scaleY || 0, on)), (this._pt.u = 0), M.push("scaleY", d), (d += "X");
                                            else {
                                                if ("transformOrigin" === d) {
                                                    x.push(yn, 0, P[yn]),
                                                        (E = void 0),
                                                        (_ = void 0),
                                                        (T = void 0),
                                                        (_ = (E = (S = o).split(" "))[0]),
                                                        (T = E[1] || "50%"),
                                                        ("top" !== _ && "bottom" !== _ && "left" !== T && "right" !== T) || ((S = _), (_ = T), (T = S)),
                                                        (E[0] = Nn[_] || _),
                                                        (E[1] = Nn[T] || T),
                                                        (o = E.join(" ")),
                                                        v.svg ? Gn(e, o, 0, b, 0, this) : ((f = parseFloat(o.split(" ")[2]) || 0) !== v.zOrigin && zn(this, v, "zOrigin", v.zOrigin, f), zn(this, P, d, Zn(s), Zn(o)));
                                                    continue;
                                                }
                                                if ("svgOrigin" === d) {
                                                    Gn(e, o, 1, b, 0, this);
                                                    continue;
                                                }
                                                if (d in Vn) {
                                                    rr(this, v, d, l, p ? ve(l, p + o) : o);
                                                    continue;
                                                }
                                                if ("smoothOrigin" === d) {
                                                    zn(this, v, "smooth", v.smooth, o);
                                                    continue;
                                                }
                                                if ("force3D" === d) {
                                                    v[d] = o;
                                                    continue;
                                                }
                                                if ("transform" === d) {
                                                    or(this, o, e);
                                                    continue;
                                                }
                                            }
                                        else d in P || (d = Pn(d) || d);
                                        if (m || ((a || 0 === a) && (l || 0 === l) && !rn.test(o) && d in P))
                                            a || (a = 0),
                                                (h = (s + "").substr((l + "").length)) !== (f = Je(o) || (d in w.units ? w.units[d] : h)) && (l = Rn(e, d, s, f)),
                                                (this._pt = new di(this._pt, m ? v : P, d, l, (p ? ve(l, p + a) : a) - l, m || ("px" !== f && "zIndex" !== d) || !1 === t.autoRound ? on : cn)),
                                                (this._pt.u = f || 0),
                                                h !== f && "%" !== f && ((this._pt.b = s), (this._pt.r = ln));
                                        else if (d in P) $n.call(this, e, d, s, p ? p + o : o);
                                        else if (d in e) this.add(e, d, s || e[d], p ? p + o : o, n, r);
                                        else if ("parseTransform" !== d) {
                                            Z(d, o);
                                            continue;
                                        }
                                        m || (d in P ? x.push(d, 0, P[d]) : x.push(d, 1, s || e[d])), M.push(d);
                                    }
                            y && ui(this);
                        },
                        render: function (e, t) {
                            if (t.tween._time || !ki()) for (var i = t._pt; i; ) i.r(e, i.d), (i = i._next);
                            else t.styles.revert();
                        },
                        get: Fn,
                        aliases: sn,
                        getSetter: function (e, t, i) {
                            var n = sn[t];
                            return (
                                n && n.indexOf(",") < 0 && (t = n),
                                t in Ki && t !== yn && (e._gsap.x || Fn(e, "x")) ? (i && Li === i ? ("scale" === t ? mn : pn) : (Li = i || {}) && ("scale" === t ? gn : vn)) : e.style && !I(e.style[t]) ? hn : ~t.indexOf("-") ? fn : ii(e, t)
                            );
                        },
                        core: { _removeProperty: In, _getMatrix: Xn },
                    };
                (_i.utils.checkPrefix = Pn),
                    (_i.core.getStyleSaver = En),
                    (lr = pe("x,y,z,scale,scaleX,scaleY,xPercent,yPercent" + "," + (ar = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function (e) {
                        Ki[e] = 1;
                    })),
                    pe(ar, function (e) {
                        (w.units[e] = "deg"), (Vn[e] = 1);
                    }),
                    (sn[lr[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + ar),
                    pe("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function (e) {
                        var t = e.split(":");
                        sn[t[1]] = lr[t[0]];
                    }),
                    pe("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (e) {
                        w.units[e] = "px";
                    }),
                    _i.registerPlugin(cr);
                var ur = _i.registerPlugin(cr) || _i,
                    dr = ur.core.Tween;
            },
            5666: function (e) {
                var t = (function (e) {
                    "use strict";
                    var t,
                        i = Object.prototype,
                        n = i.hasOwnProperty,
                        r =
                            Object.defineProperty ||
                            function (e, t, i) {
                                e[t] = i.value;
                            },
                        s = "function" == typeof Symbol ? Symbol : {},
                        o = s.iterator || "@@iterator",
                        a = s.asyncIterator || "@@asyncIterator",
                        l = s.toStringTag || "@@toStringTag";
                    function c(e, t, i) {
                        return Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }), e[t];
                    }
                    try {
                        c({}, "");
                    } catch (e) {
                        c = function (e, t, i) {
                            return (e[t] = i);
                        };
                    }
                    function u(e, t, i, n) {
                        var s = t && t.prototype instanceof v ? t : v,
                            o = Object.create(s.prototype),
                            a = new L(n || []);
                        return r(o, "_invoke", { value: M(e, i, a) }), o;
                    }
                    function d(e, t, i) {
                        try {
                            return { type: "normal", arg: e.call(t, i) };
                        } catch (e) {
                            return { type: "throw", arg: e };
                        }
                    }
                    e.wrap = u;
                    var h = "suspendedStart",
                        f = "suspendedYield",
                        p = "executing",
                        m = "completed",
                        g = {};
                    function v() {}
                    function b() {}
                    function y() {}
                    var w = {};
                    c(w, o, function () {
                        return this;
                    });
                    var x = Object.getPrototypeOf,
                        S = x && x(x(k([])));
                    S && S !== i && n.call(S, o) && (w = S);
                    var E = (y.prototype = v.prototype = Object.create(w));
                    function _(e) {
                        ["next", "throw", "return"].forEach(function (t) {
                            c(e, t, function (e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function T(e, t) {
                        function i(r, s, o, a) {
                            var l = d(e[r], e, s);
                            if ("throw" !== l.type) {
                                var c = l.arg,
                                    u = c.value;
                                return u && "object" == typeof u && n.call(u, "__await")
                                    ? t.resolve(u.__await).then(
                                          function (e) {
                                              i("next", e, o, a);
                                          },
                                          function (e) {
                                              i("throw", e, o, a);
                                          }
                                      )
                                    : t.resolve(u).then(
                                          function (e) {
                                              (c.value = e), o(c);
                                          },
                                          function (e) {
                                              return i("throw", e, o, a);
                                          }
                                      );
                            }
                            a(l.arg);
                        }
                        var s;
                        r(this, "_invoke", {
                            value: function (e, n) {
                                function r() {
                                    return new t(function (t, r) {
                                        i(e, n, t, r);
                                    });
                                }
                                return (s = s ? s.then(r, r) : r());
                            },
                        });
                    }
                    function M(e, t, i) {
                        var n = h;
                        return function (r, s) {
                            if (n === p) throw new Error("Generator is already running");
                            if (n === m) {
                                if ("throw" === r) throw s;
                                return A();
                            }
                            for (i.method = r, i.arg = s; ; ) {
                                var o = i.delegate;
                                if (o) {
                                    var a = P(o, i);
                                    if (a) {
                                        if (a === g) continue;
                                        return a;
                                    }
                                }
                                if ("next" === i.method) i.sent = i._sent = i.arg;
                                else if ("throw" === i.method) {
                                    if (n === h) throw ((n = m), i.arg);
                                    i.dispatchException(i.arg);
                                } else "return" === i.method && i.abrupt("return", i.arg);
                                n = p;
                                var l = d(e, t, i);
                                if ("normal" === l.type) {
                                    if (((n = i.done ? m : f), l.arg === g)) continue;
                                    return { value: l.arg, done: i.done };
                                }
                                "throw" === l.type && ((n = m), (i.method = "throw"), (i.arg = l.arg));
                            }
                        };
                    }
                    function P(e, i) {
                        var n = i.method,
                            r = e.iterator[n];
                        if (r === t)
                            return (
                                (i.delegate = null),
                                ("throw" === n && e.iterator.return && ((i.method = "return"), (i.arg = t), P(e, i), "throw" === i.method)) ||
                                    ("return" !== n && ((i.method = "throw"), (i.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                                g
                            );
                        var s = d(r, e.iterator, i.arg);
                        if ("throw" === s.type) return (i.method = "throw"), (i.arg = s.arg), (i.delegate = null), g;
                        var o = s.arg;
                        return o
                            ? o.done
                                ? ((i[e.resultName] = o.value), (i.next = e.nextLoc), "return" !== i.method && ((i.method = "next"), (i.arg = t)), (i.delegate = null), g)
                                : o
                            : ((i.method = "throw"), (i.arg = new TypeError("iterator result is not an object")), (i.delegate = null), g);
                    }
                    function C(e) {
                        var t = { tryLoc: e[0] };
                        1 in e && (t.catchLoc = e[1]), 2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])), this.tryEntries.push(t);
                    }
                    function O(e) {
                        var t = e.completion || {};
                        (t.type = "normal"), delete t.arg, (e.completion = t);
                    }
                    function L(e) {
                        (this.tryEntries = [{ tryLoc: "root" }]), e.forEach(C, this), this.reset(!0);
                    }
                    function k(e) {
                        if (e) {
                            var i = e[o];
                            if (i) return i.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var r = -1,
                                    s = function i() {
                                        for (; ++r < e.length; ) if (n.call(e, r)) return (i.value = e[r]), (i.done = !1), i;
                                        return (i.value = t), (i.done = !0), i;
                                    };
                                return (s.next = s);
                            }
                        }
                        return { next: A };
                    }
                    function A() {
                        return { value: t, done: !0 };
                    }
                    return (
                        (b.prototype = y),
                        r(E, "constructor", { value: y, configurable: !0 }),
                        r(y, "constructor", { value: b, configurable: !0 }),
                        (b.displayName = c(y, l, "GeneratorFunction")),
                        (e.isGeneratorFunction = function (e) {
                            var t = "function" == typeof e && e.constructor;
                            return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                        }),
                        (e.mark = function (e) {
                            return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : ((e.__proto__ = y), c(e, l, "GeneratorFunction")), (e.prototype = Object.create(E)), e;
                        }),
                        (e.awrap = function (e) {
                            return { __await: e };
                        }),
                        _(T.prototype),
                        c(T.prototype, a, function () {
                            return this;
                        }),
                        (e.AsyncIterator = T),
                        (e.async = function (t, i, n, r, s) {
                            void 0 === s && (s = Promise);
                            var o = new T(u(t, i, n, r), s);
                            return e.isGeneratorFunction(i)
                                ? o
                                : o.next().then(function (e) {
                                      return e.done ? e.value : o.next();
                                  });
                        }),
                        _(E),
                        c(E, l, "Generator"),
                        c(E, o, function () {
                            return this;
                        }),
                        c(E, "toString", function () {
                            return "[object Generator]";
                        }),
                        (e.keys = function (e) {
                            var t = Object(e),
                                i = [];
                            for (var n in t) i.push(n);
                            return (
                                i.reverse(),
                                function e() {
                                    for (; i.length; ) {
                                        var n = i.pop();
                                        if (n in t) return (e.value = n), (e.done = !1), e;
                                    }
                                    return (e.done = !0), e;
                                }
                            );
                        }),
                        (e.values = k),
                        (L.prototype = {
                            constructor: L,
                            reset: function (e) {
                                if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = t), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = t), this.tryEntries.forEach(O), !e))
                                    for (var i in this) "t" === i.charAt(0) && n.call(this, i) && !isNaN(+i.slice(1)) && (this[i] = t);
                            },
                            stop: function () {
                                this.done = !0;
                                var e = this.tryEntries[0].completion;
                                if ("throw" === e.type) throw e.arg;
                                return this.rval;
                            },
                            dispatchException: function (e) {
                                if (this.done) throw e;
                                var i = this;
                                function r(n, r) {
                                    return (a.type = "throw"), (a.arg = e), (i.next = n), r && ((i.method = "next"), (i.arg = t)), !!r;
                                }
                                for (var s = this.tryEntries.length - 1; s >= 0; --s) {
                                    var o = this.tryEntries[s],
                                        a = o.completion;
                                    if ("root" === o.tryLoc) return r("end");
                                    if (o.tryLoc <= this.prev) {
                                        var l = n.call(o, "catchLoc"),
                                            c = n.call(o, "finallyLoc");
                                        if (l && c) {
                                            if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                            if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                        } else if (l) {
                                            if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                        } else {
                                            if (!c) throw new Error("try statement without catch or finally");
                                            if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                        }
                                    }
                                }
                            },
                            abrupt: function (e, t) {
                                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                    var r = this.tryEntries[i];
                                    if (r.tryLoc <= this.prev && n.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                        var s = r;
                                        break;
                                    }
                                }
                                s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                                var o = s ? s.completion : {};
                                return (o.type = e), (o.arg = t), s ? ((this.method = "next"), (this.next = s.finallyLoc), g) : this.complete(o);
                            },
                            complete: function (e, t) {
                                if ("throw" === e.type) throw e.arg;
                                return (
                                    "break" === e.type || "continue" === e.type
                                        ? (this.next = e.arg)
                                        : "return" === e.type
                                        ? ((this.rval = this.arg = e.arg), (this.method = "return"), (this.next = "end"))
                                        : "normal" === e.type && t && (this.next = t),
                                    g
                                );
                            },
                            finish: function (e) {
                                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                    var i = this.tryEntries[t];
                                    if (i.finallyLoc === e) return this.complete(i.completion, i.afterLoc), O(i), g;
                                }
                            },
                            catch: function (e) {
                                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                    var i = this.tryEntries[t];
                                    if (i.tryLoc === e) {
                                        var n = i.completion;
                                        if ("throw" === n.type) {
                                            var r = n.arg;
                                            O(i);
                                        }
                                        return r;
                                    }
                                }
                                throw new Error("illegal catch attempt");
                            },
                            delegateYield: function (e, i, n) {
                                return (this.delegate = { iterator: k(e), resultName: i, nextLoc: n }), "next" === this.method && (this.arg = t), g;
                            },
                        }),
                        e
                    );
                })(e.exports);
                try {
                    regeneratorRuntime = t;
                } catch (e) {
                    "object" == typeof globalThis ? (globalThis.regeneratorRuntime = t) : Function("r", "regeneratorRuntime = r")(t);
                }
            },
            2576: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.AccordionItem = void 0);
                var n = i(5974);
                var r = new WeakSet();
                function s() {
                    return this.$trigger
                        ? this.$content
                            ? void this.$trigger.addEventListener("click", this.toggle.bind(this))
                            : console.warn("Accordion item can not be initialize because ".concat(this.options.itemContentSelector, " not found in"), this)
                        : console.warn("Accordion item can not be initialize because ".concat(this.options.itemTriggerSelector, " not found in"), this);
                }
                t.AccordionItem = class {
                    constructor(e, t, i) {
                        var n, o;
                        (function (e, t) {
                            if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                        })((n = this), (o = r)),
                            o.add(n),
                            (this.options = e.options),
                            (this.accordion = e),
                            (this.$item = t),
                            (this.$trigger = this.$item.querySelector(this.options.itemTriggerSelector)),
                            (this.$content = this.$item.querySelector(this.options.itemContentSelector)),
                            (this.index = i),
                            (this.isOpen = !1),
                            (this.isLocked = !1),
                            (this.onOpenBefore = "function" == typeof this.options.onOpenBefore && this.options.onOpenBefore.bind(this)),
                            (this.onOpenAfter = "function" == typeof this.options.onOpenAfter && this.options.onOpenAfter.bind(this)),
                            (this.onCloseBefore = "function" == typeof this.options.onCloseBefore && this.options.onCloseBefore.bind(this)),
                            (this.onCloseAfter = "function" == typeof this.options.onCloseAfter && this.options.onCloseAfter.bind(this)),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, r, s).call(this);
                    }
                    open() {
                        this.isLocked ||
                            ((this.isLocked = !0),
                            this.onOpenBefore && this.onOpenBefore(this),
                            this.accordion.closeAllBySingleMode(this.index),
                            (0, n.slideDown)(this.$content, this.accordion.duration, () => {
                                (this.isOpen = !0), (this.isLocked = !1), this.$content.classList.add(this.options.activeClass), this.onOpenAfter && this.onOpenAfter(this);
                            }));
                    }
                    close() {
                        this.isLocked ||
                            ((this.isLocked = !0),
                            this.onCloseBefore && this.onCloseBefore(this),
                            (0, n.slideUp)(this.$content, this.accordion.duration, () => {
                                (this.isOpen = !1), (this.isLocked = !1), this.$content.classList.remove(this.options.activeClass), this.onCloseAfter && this.onCloseAfter(this);
                            }));
                    }
                    toggle() {
                        this.isOpen ? this.close() : this.open();
                    }
                };
            },
            869: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Accordion = void 0);
                var n = i(2576),
                    r = i(7171);
                var s = new WeakSet();
                function o() {
                    var e;
                    return this.$container
                        ? null !== (e = this.items) && void 0 !== e && e.length
                            ? void (this.items = [...this.items].map((e, t) => new n.AccordionItem(this, e, t)))
                            : console.warn("Accordion items can not be initialize because ".concat(this.options.itemSelector, " is not defined in"), this)
                        : console.warn("Accordion can not be initialize because ".concat(this.options.containerSelector, " is not found"), this);
                }
                t.Accordion = class {
                    constructor(e) {
                        if (
                            ((function (e, t) {
                                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                            })((t = this), (i = s)),
                            i.add(t),
                            (this.options = { ...r.accordionOptions, ...e }),
                            (this.$container = this.options.containerSelector instanceof HTMLElement ? this.options.containerSelector : document.querySelector(this.options.containerSelector)),
                            !this.$container)
                        )
                            return console.warn("Can not initialize accordion with out container", this);
                        var t, i;
                        (this.duration = this.options.duration),
                            (this.activeIndex = null),
                            (this.type = this.options.type),
                            (this.items = this.$container ? this.$container.querySelectorAll(this.options.itemSelector) : []),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, s, o).call(this);
                    }
                    openByIndex(e) {
                        if (!this.items[e]) return console.warn("Can not open accordion item by index : ".concat(e, ", because the item is not found in"), this);
                        this.items[e].open();
                    }
                    closeAllBySingleMode(e) {
                        "multiply" !== this.type &&
                            ((this.activeIndex = e),
                            this.items.forEach((e, t) => {
                                t !== this.activeIndex && e.close();
                            }));
                    }
                };
            },
            7171: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.accordionOptions = void 0),
                    (t.accordionOptions = {
                        containerSelector: ".js-accordion",
                        itemSelector: ".js-accordion-item",
                        itemTriggerSelector: ".js-accordion-toggler",
                        itemContentSelector: ".js-accordion-content",
                        activeClass: "_active",
                        duration: 500,
                        type: "single",
                        onOpenBefore: null,
                        onOpenAfter: null,
                        onCloseBefore: null,
                        onCloseAfter: null,
                    });
            },
            5005: function (e, t) {
                "use strict";
                function i(e, t, i) {
                    return (
                        (t = (function (e) {
                            var t = (function (e, t) {
                                if ("object" != typeof e || null === e) return e;
                                var i = e[Symbol.toPrimitive];
                                if (void 0 !== i) {
                                    var n = i.call(e, "string");
                                    if ("object" != typeof n) return n;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            })(e);
                            return "symbol" == typeof t ? t : String(t);
                        })(t)) in e
                            ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = i),
                        e
                    );
                }
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.CardPreview = void 0),
                    (t.CardPreview = class {
                        constructor(e) {
                            i(this, "mouseEnterHandle", () => {
                                this.videoPlay();
                            }),
                                i(this, "mouseLeaveHandle", () => {
                                    this.videoPause();
                                }),
                                (this.$card = e instanceof HTMLElement ? e : document.querySelector(e)),
                                (this.$video = this.$card.querySelector(".js-card-video")),
                                (this.hideImageClass = "_hide-image"),
                                this.init();
                        }
                        init() {
                            this.$card.addEventListener("mouseenter", this.mouseEnterHandle), this.$card.addEventListener("mouseleave", this.mouseLeaveHandle);
                        }
                        destroy() {
                            this.$card.removeEventListener("mouseenter", this.mouseEnterHandle), this.$card.removeEventListener("mouseleave", this.mouseLeaveHandle);
                        }
                        videoPlay() {
                            !this.$video ||
                                window.innerWidth <= window.tablet ||
                                this.$video.play().then(
                                    () => {
                                        this.$card.classList.add(this.hideImageClass);
                                    },
                                    (e) => {
                                        console.log(e);
                                    }
                                );
                        }
                        videoPause() {
                            var e;
                            !this.$video || window.innerWidth <= window.tablet || (null === (e = this.$video) || void 0 === e || e.pause(), this.$card.classList.remove(this.hideImageClass));
                        }
                    });
            },
            8452: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Dropdown = void 0);
                var n = i(7311);
                i(6515);
                var r = new WeakSet();
                function s() {
                    this.$trigger.addEventListener("click", this.triggerClickHandle.bind(this)),
                        window.addEventListener("click", (e) => {
                            let { target: t } = e;
                            this.$container.contains(t) || this.$dropdown.contains(t) || this.close();
                        });
                }
                t.Dropdown = class {
                    constructor(e) {
                        if (
                            ((function (e, t) {
                                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                            })((t = this), (i = r)),
                            i.add(t),
                            (this.options = { ...n.dropdownOptions, ...e }),
                            (this.$container = this.options.container instanceof HTMLElement ? this.options.container : document.querySelector(this.options.container)),
                            !this.$container)
                        )
                            return console.warn("Can not initialize dropdown with out container", this);
                        var t, i;
                        (this.$trigger = this.$container.querySelector(this.options.triggerSelector)),
                            (this.$dropdown = this.$container.querySelector(this.options.dropdownItemSelector)),
                            (this.isOpened = !1),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, r, s).call(this);
                    }
                    triggerClickHandle() {
                        this.toggle();
                    }
                    toggle() {
                        this.isOpened ? this.close() : this.open();
                    }
                    open() {
                        this.$container.classList.add("_active"), this.$dropdown.classList.add("_active"), (this.isOpened = !0);
                    }
                    close() {
                        this.$container.classList.remove("_active"), this.$dropdown.classList.remove("_active"), (this.isOpened = !1);
                    }
                };
            },
            7311: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.dropdownOptions = void 0), (t.dropdownOptions = { container: ".js-dropdown", triggerSelector: ".js-dropdown-trigger", dropdownItemSelector: ".js-dropdown-item" });
            },
            4975: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Select = void 0);
                var n = i(8452),
                    r = i(2698);
                var s = new WeakSet();
                class o extends n.Dropdown {
                    constructor(e) {
                        var t, i;
                        super({ ...r.selectOptions, ...e }),
                            (function (e, t) {
                                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                            })((t = this), (i = s)),
                            i.add(t);
                        const n = this.$trigger.querySelector(this.options.triggerValueSelector);
                        (this.$triggerValue = n || this.$trigger),
                            (this.$input = this.$container.querySelector(this.options.inputSelector)),
                            (this.selectOptions = this.$dropdown.querySelectorAll(this.options.dropdownOptionSelector)),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, s, a).call(this);
                    }
                    optionClickHandle(e) {
                        var t;
                        const { currentTarget: i } = e,
                            n = null === (t = i.dataset) || void 0 === t ? void 0 : t.selectValue;
                        if (!n) return console.warn("Cant append new value because value is invalid", this);
                        (this.$input.value = n), (this.$triggerValue.innerHTML = i.innerHTML), this.changeActiveOption(i), this.close();
                    }
                    changeActiveOption(e) {
                        this.selectOptions.forEach((t) => {
                            e === t ? t.classList.add("_active") : t.classList.remove("_active");
                        });
                    }
                }
                function a() {
                    this.selectOptions.forEach((e) => {
                        e.addEventListener("click", this.optionClickHandle.bind(this));
                    });
                }
                t.Select = o;
            },
            2698: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.selectOptions = void 0),
                    (t.selectOptions = {
                        container: ".js-select",
                        inputSelector: ".js-select-input",
                        triggerSelector: ".js-select-trigger",
                        triggerValueSelector: ".js-select-trigger-value",
                        dropdownItemSelector: ".js-select-dropdown",
                        dropdownOptionSelector: ".js-select-option",
                    });
            },
            5590: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.FormCheckbox = void 0);
                var n = i(7291),
                    r = i(6799);
                function s(e, t) {
                    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                var o = new WeakSet(),
                    a = new WeakMap();
                class l extends r.RootField {
                    constructor(e) {
                        var t;
                        super({ ...n.formCheckboxOptions, ...e }),
                            s(this, (t = o)),
                            t.add(this),
                            (function (e, t, i) {
                                s(e, t), t.set(e, i);
                            })(this, a, {
                                writable: !0,
                                value: () => {
                                    (this.isChecked = !!this.$input.checked), this.form.isDirty && this.validate();
                                },
                            }),
                            (this.isChecked = !!this.$input.checked),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, o, c).call(this);
                    }
                    validate() {
                        if (this.isRequired) {
                            if (this.isChecked) return this.setValidStatus();
                            this.setInvalidStatus(), (this.form.isValid = !1);
                        } else this.isChecked = !!this.$input.checked;
                    }
                    reset() {
                        (this.$input.checked = !1), (this.isChecked = !1), this.resetStatus();
                    }
                }
                function c() {
                    var e, t;
                    this.$input.addEventListener(
                        "change",
                        ((t = (function (e, t, i) {
                            if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                            return t.get(e);
                        })((e = this), a)),
                        (function (e, t) {
                            return t.get ? t.get.call(e) : t.value;
                        })(e, t))
                    );
                }
                t.FormCheckbox = l;
            },
            1474: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.FormField = void 0);
                var n = i(9359),
                    r = i(6799),
                    s = i(7291);
                function o(e, t) {
                    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                var a = new WeakSet(),
                    l = new WeakMap();
                class c extends r.RootField {
                    constructor(e) {
                        var t;
                        super({ ...s.formFieldOptions, ...e }),
                            o(this, (t = a)),
                            t.add(this),
                            (function (e, t, i) {
                                o(e, t), t.set(e, i);
                            })(this, l, {
                                writable: !0,
                                value: (e) => {
                                    (this.value = e.target.value.trim()), (this.validationStatus = !!this.value.match(this.validationPattern)), this.form.isDirty && this.validate();
                                },
                            }),
                            (this.validationType = this.$field.dataset.type),
                            (this.validationPattern = (0, n.getValidationPattern)(this.validationType)),
                            (this.validationStatus = !this.isRequired),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, a, u).call(this);
                    }
                    validate() {
                        if (!this.isRequired) return this.resetStatus(), void (this.validationStatus = !0);
                        const e = this.minMaxQuantityValidate(),
                            t = this.minMaxLengthValidate();
                        if (this.validationStatus && e && t) return this.setValidStatus();
                        this.setInvalidStatus(), (this.form.isValid = !1);
                    }
                    reset() {
                        (this.$input.value = ""), (this.value = this.$input.value), (this.validationStatus = !this.isRequired), this.resetStatus();
                    }
                    minMaxQuantityValidate() {
                        const { $input: e } = this,
                            { min: t, max: i } = e,
                            n = !t || +t <= parseInt(e.value),
                            r = !i || +i >= parseInt(e.value);
                        return n && r;
                    }
                    minMaxLengthValidate() {
                        const { $input: e } = this,
                            { minLength: t, maxLength: i } = e,
                            n = !(t >= 0) || +t <= e.value.length,
                            r = !(i >= 0) || +i >= e.value.length;
                        return n && r;
                    }
                }
                function u() {
                    var e, t;
                    this.$input.addEventListener(
                        "input",
                        ((t = (function (e, t, i) {
                            if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                            return t.get(e);
                        })((e = this), l)),
                        (function (e, t) {
                            return t.get ? t.get.call(e) : t.value;
                        })(e, t))
                    );
                }
                t.FormField = c;
            },
            3173: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.FormRadioGroup = void 0);
                var n = i(6799),
                    r = i(7291);
                function s(e, t) {
                    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                var o = new WeakSet(),
                    a = new WeakMap();
                class l extends n.RootField {
                    constructor(e) {
                        var t, i;
                        super({ ...r.formRadioGroupOptions, ...e }),
                            s(this, (i = o)),
                            i.add(this),
                            (function (e, t, i) {
                                s(e, t), t.set(e, i);
                            })(this, a, {
                                writable: !0,
                                value: (e) => {
                                    (this.value = e.target.value), (this.$checkedInput = e.target), (this.isChecked = !0), this.validate();
                                },
                            }),
                            (this.$group = this.$field.querySelector(this.options.groupSelector)),
                            (this.$inputs = this.$group.querySelectorAll(this.options.inputSelector)),
                            (this.$checkedInput = null),
                            (this.isChecked = !(null === (t = this.$checkedInput) || void 0 === t || !t.checked)),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, o, c).call(this);
                    }
                    validate() {
                        return this.isRequired ? (this.isChecked ? this.setValidStatus() : (this.setInvalidStatus(), void (this.form.isValid = !1))) : (this.resetStatus(), void (this.validationStatus = !0));
                    }
                    reset() {
                        (this.$checkedInput = null), (this.isChecked = !!this.isRequired), (this.value = ""), this.resetStatus();
                    }
                }
                function c() {
                    this.$inputs.forEach((e) => {
                        var t, i;
                        e.addEventListener(
                            "input",
                            ((i = (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return t.get(e);
                            })((t = this), a)),
                            (function (e, t) {
                                return t.get ? t.get.call(e) : t.value;
                            })(t, i))
                        );
                    });
                }
                t.FormRadioGroup = l;
            },
            2006: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = i(1474);
                Object.keys(n).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === n[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return n[e];
                                },
                            }));
                });
                var r = i(5590);
                Object.keys(r).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === r[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return r[e];
                                },
                            }));
                });
                var s = i(3173);
                Object.keys(s).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === s[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return s[e];
                                },
                            }));
                });
            },
            6799: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.RootField = void 0),
                    (t.RootField = class {
                        constructor(e) {
                            (this.options = e),
                                (this.form = this.options.form),
                                (this.index = this.options.index),
                                (this.$field = this.options.field),
                                (this.$input = this.$field.querySelector(this.options.inputSelector)),
                                (this.$error = this.$field.querySelector(this.options.errorSelector)),
                                (this.isRequired = this.$field.classList.contains("is-required")),
                                this.$input.name || (console.warn("[name] is required, the input without the attribute will get automatically", this.form, this.$input), this.$input.setAttribute("name", "field_".concat(this.index))),
                                (this.name = this.$input.name),
                                (this.value = this.$input.value);
                        }
                        setValidStatus() {
                            this.$field.classList.remove("_invalid"), this.$field.classList.add("_valid");
                        }
                        setInvalidStatus() {
                            this.$field.classList.remove("_valid"), this.$field.classList.add("_invalid");
                        }
                        resetStatus() {
                            this.$field.classList.remove("_valid"), this.$field.classList.remove("_invalid");
                        }
                    });
            },
            5380: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Form = void 0);
                var n = i(7291),
                    r = i(9359);
                function s(e, t, i) {
                    a(e, t), t.set(e, i);
                }
                function o(e, t) {
                    a(e, t), t.add(e);
                }
                function a(e, t) {
                    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function l(e, t) {
                    var i = (function (e, t, i) {
                        if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                        return t.get(e);
                    })(e, t);
                    return (function (e, t) {
                        return t.get ? t.get.call(e) : t.value;
                    })(e, i);
                }
                function c(e, t, i) {
                    if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                    return i;
                }
                var u = new WeakSet(),
                    d = new WeakSet(),
                    h = new WeakMap(),
                    f = new WeakMap();
                function p() {
                    this.$form.setAttribute("novalidate", "novalidate"), this.$form.addEventListener("submit", l(this, h)), this.$form.addEventListener("input", l(this, f));
                }
                function m() {
                    const e = new XMLHttpRequest();
                    e.open(this.method, this.action),
                        (e.onreadystatechange = () => {
                            e.status >= 400 ? console.error("Request with error") : (console.log("Request is success"), this.reset(), this.$form.classList.add("_submited"));
                        }),
                        (this.data = new FormData(this.$form)),
                        e.send(this.data);
                }
                t.Form = class {
                    constructor(e) {
                        o(this, d),
                            o(this, u),
                            s(this, h, {
                                writable: !0,
                                value: (e) => {
                                    e.preventDefault(),
                                        this.$form.classList.remove("_submited"),
                                        (this.invalidFields = []),
                                        (this.isDirty = !0),
                                        this.validate(),
                                        this.isValid ? c(this, d, m).call(this) : console.warn("Validation error", this.invalidFields);
                                },
                            }),
                            s(this, f, {
                                writable: !0,
                                value: () => {
                                    this.isDirty && this.validate();
                                },
                            }),
                            (this.options = { ...n.defaultFormOptions, ...e }),
                            (this.$form = this.options.form instanceof HTMLElement ? this.options.form : document.querySelector(this.options.form)),
                            (this.$submit = this.$form.querySelector(this.options.formSubmitSelector)),
                            (this.action = this.$form.getAttribute("action")),
                            (this.method = this.$form.getAttribute("method") || "GET"),
                            (this.fields = Array.from(this.$form.querySelectorAll(this.options.fieldSelector)).map((e, t) => (0, r.getFieldType)(this, e, t))),
                            (this.invalidFields = []),
                            (this.isValid = !1),
                            (this.isDirty = !1),
                            (this.data = new FormData()),
                            c(this, u, p).call(this);
                    }
                    setValidStatus() {
                        this.$form.classList.remove("_invalid-form"), this.$form.classList.add("_valid-form"), (this.$submit.disabled = !1);
                    }
                    setInvalidStatus() {
                        this.$form.classList.add("_invalid-form"), this.$form.classList.remove("_valid-form"), (this.$submit.disabled = !0);
                    }
                    resetStatus() {
                        this.$form.classList.remove("_invalid-form"), this.$form.classList.remove("_valid-form"), this.$submit.removeAttribute("disabled");
                    }
                    validate() {
                        (this.isValid = !0), (this.invalidFields = this.fields.filter((e) => (e.validate(), !e.validationStatus))), this.isValid ? this.setValidStatus() : this.setInvalidStatus();
                    }
                    reset() {
                        this.resetStatus(), this.$form.reset(), (this.isDirty = !1), this.fields.forEach((e) => e.reset());
                    }
                };
            },
            7916: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.getFieldType = void 0);
                var n = i(2006);
                t.getFieldType = (e, t, i) =>
                    ["empty", "email", "name", "number", "password", "tel"].includes(t.dataset.type)
                        ? new n.FormField({ form: e, field: t, index: i })
                        : ["checkbox", "radio"].includes(t.dataset.type)
                        ? new n.FormCheckbox({ form: e, field: t, index: i })
                        : "radio-group" === t.dataset.type
                        ? new n.FormRadioGroup({ form: e, field: t, index: i })
                        : (console.warn("[data-type] is required, the field without the attribute will get automatically", e, t), t.setAttribute("data-type", "empty"), new n.FormField({ form: e, field: t, index: i }));
            },
            1405: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.getValidationPattern = void 0),
                    (t.getValidationPattern = (e) => {
                        switch (e) {
                            case "empty":
                                return /./g;
                            case "email":
                                return /^[\w!#$%&'*+\-/=?^`{|}~]+(?:\.[\w!#$%&'*+\-/=?^`{|}~]+)*@(?:([a-z0-9][a-z0-9-]{0,62}[a-z0-9]|[a-z])\.)+[a-z]{2,11}|\d{1,3}(?:\.\d{1,3}){3}(?::\d{1,11})?$/i;
                            case "name":
                                return /^[А-яїЇіІA-z\s]+$/;
                            case "number":
                                return /^\d+$/;
                            case "password":
                                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                            case "tel":
                                return /^\+?[0-9]{1,3}\s?\(?[0-9]{1,3}\)?-?\s?[0-9]{3}-?\s?[0-9]{2}-?\s?[0-9]{2}$/;
                            default:
                                return null;
                        }
                    });
            },
            9359: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = i(7916);
                Object.keys(n).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === n[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return n[e];
                                },
                            }));
                });
                var r = i(1405);
                Object.keys(r).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === r[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return r[e];
                                },
                            }));
                });
            },
            6762: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.formCheckboxOptions = void 0), (t.formCheckboxOptions = { form: null, index: 0, field: null, inputSelector: ".js-checkbox-input", errorSelector: ".js-field-error" });
            },
            8043: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.formFieldOptions = void 0), (t.formFieldOptions = { form: null, index: 0, field: null, inputSelector: ".js-field-input", errorSelector: ".js-field-error" });
            },
            7600: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.defaultFormOptions = void 0), (t.defaultFormOptions = { form: ".js-form", formSubmitSelector: ".js-form-submit", fieldSelector: ".js-field" });
            },
            5225: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.formRadioGroupOptions = void 0),
                    (t.formRadioGroupOptions = { form: null, index: 0, field: null, groupSelector: ".js-radio-group", inputSelector: ".js-radio-input", errorSelector: ".js-field-error" });
            },
            7291: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = i(7600);
                Object.keys(n).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === n[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return n[e];
                                },
                            }));
                });
                var r = i(8043);
                Object.keys(r).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === r[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return r[e];
                                },
                            }));
                });
                var s = i(6762);
                Object.keys(s).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === s[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return s[e];
                                },
                            }));
                });
                var o = i(5225);
                Object.keys(o).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === o[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return o[e];
                                },
                            }));
                });
            },
            5116: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = i(5380);
                Object.keys(n).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === n[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return n[e];
                                },
                            }));
                });
                var r = i(5590);
                Object.keys(r).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === r[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return r[e];
                                },
                            }));
                });
                var s = i(1474);
                Object.keys(s).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === s[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return s[e];
                                },
                            }));
                });
                var o = i(3173);
                Object.keys(o).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === o[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return o[e];
                                },
                            }));
                });
                var a = i(869);
                Object.keys(a).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === a[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return a[e];
                                },
                            }));
                });
                var l = i(2896);
                Object.keys(l).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === l[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return l[e];
                                },
                            }));
                });
                var c = i(8452);
                Object.keys(c).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === c[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return c[e];
                                },
                            }));
                });
                var u = i(4975);
                Object.keys(u).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === u[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return u[e];
                                },
                            }));
                });
                var d = i(791);
                Object.keys(d).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === d[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return d[e];
                                },
                            }));
                });
                var h = i(5005);
                Object.keys(h).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === h[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return h[e];
                                },
                            }));
                });
            },
            4037: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.defaultModalOptions = void 0),
                    (t.defaultModalOptions = {
                        container: ".js-modal",
                        openTriggerSelector: ".js-modal-open-trigger",
                        closeTriggerSelector: ".js-modal-close-trigger",
                        openModalClass: "_show",
                        activeOpenTriggerClass: "_modal-open",
                        onOpen: null,
                        onClose: null,
                    });
            },
            791: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Modal = void 0);
                var n = i(4037),
                    r = i(736);
                var s = new WeakSet();
                function o() {
                    return this.$container
                        ? this.$container.id
                            ? ((this.id = this.$container.id.toLowerCase()),
                              (this.openTriggers = [...this.openTriggers].filter((e) => {
                                  var t;
                                  const i = null === (t = e.dataset.modalId) || void 0 === t ? void 0 : t.toLowerCase();
                                  return e.dataset.modalId
                                      ? this.id === i && (e.addEventListener("click", this.open.bind(this)), !0)
                                      : console.warn("The button has class ".concat(this.options.openTriggerSelector, " but does not have required attribute or value in [data-modal-id]"), e);
                              })),
                              this.closeTriggers.forEach((e) => e.addEventListener("click", this.close.bind(this))),
                              this.$container.addEventListener("click", (e) => {
                                  e.target === e.currentTarget && this.close();
                              }),
                              void window.addEventListener("keydown", (e) => {
                                  "Escape" === e.code && this.close();
                              }))
                            : console.warn("Modal can not be initialize because container does not have required attribute [id] in", this)
                        : console.warn("Modal can not be initialize because ".concat(this.options.container, " is ").concat(!this.$container, " in"), this);
                }
                t.Modal = class {
                    constructor(e) {
                        if (
                            ((function (e, t) {
                                if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                            })((t = this), (i = s)),
                            i.add(t),
                            (this.options = { ...n.defaultModalOptions, ...e }),
                            (this.id = null),
                            (this.$container = this.options.container instanceof HTMLElement ? this.options.container : document.querySelector(this.options.container)),
                            !this.$container)
                        )
                            return console.warn("Can not initialize modal with out container", this);
                        var t, i;
                        (this.openTriggers = document.querySelectorAll(this.options.openTriggerSelector)),
                            (this.isOpen = !1),
                            (this.closeTriggers = this.$container.querySelectorAll(this.options.closeTriggerSelector)),
                            (this.onOpen = "function" == typeof this.options.onOpen && this.options.onOpen.bind(this)),
                            (this.onClose = "function" == typeof this.options.onClose && this.options.onClose.bind(this)),
                            (function (e, t, i) {
                                if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                                return i;
                            })(this, s, o).call(this);
                    }
                    open() {
                        this.isOpen ||
                            (r.ScrollbarLocker.lock(),
                            this.$container.classList.add(this.options.openModalClass),
                            this.openTriggers.forEach((e) => e.classList.add(this.options.activeOpenTriggerClass)),
                            (this.isOpen = !0),
                            this.onOpen && this.onOpen(this));
                    }
                    close() {
                        this.isOpen &&
                            (r.ScrollbarLocker.unLock(),
                            this.$container.classList.remove(this.options.openModalClass),
                            this.openTriggers.forEach((e) => e.classList.remove(this.options.activeOpenTriggerClass)),
                            (this.isOpen = !1),
                            this.onClose && this.onClose(this));
                    }
                };
            },
            2896: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Tabs = void 0);
                var n = i(860),
                    r = i(2918);
                function s(e, t) {
                    !(function (e, t) {
                        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                    })(e, t),
                        t.add(e);
                }
                function o(e, t, i) {
                    if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                    return i;
                }
                var a = new WeakSet(),
                    l = new WeakSet();
                function c() {
                    this.setNewTabByIndex(this.activeIndex),
                        this.triggers.forEach((e) => {
                            var t;
                            const i = null === (t = e.dataset.tabId) || void 0 === t ? void 0 : t.toLowerCase();
                            if (!i) return console.warn("Current tab trigger ".concat(e, " does not have attribute or value [data-tab-id] in"), this);
                            e.addEventListener("click", () => this.setNewTabByID(i));
                        });
                }
                function u(e) {
                    this.currentItem !== e &&
                        (this.currentItem
                            ? (0, n.fadeOut)(this.currentItem, this.duration, () => {
                                  this.currentItem.classList.remove(this.options.activeClass),
                                      (this.currentItem = e),
                                      (0, n.fadeIn)(this.currentItem, this.duration, () => {
                                          this.currentItem.classList.add(this.options.activeClass), this.changeActiveButton(), (this.isLocked = !1);
                                      });
                              })
                            : ((this.currentItem = e),
                              (0, n.fadeIn)(this.currentItem, this.duration, () => {
                                  this.currentItem.classList.add(this.options.activeClass), this.changeActiveButton(), (this.isLocked = !1);
                              })));
                }
                t.Tabs = class {
                    constructor(e) {
                        if (
                            (s(this, l),
                            s(this, a),
                            (this.options = { ...r.defaultTabsOptions, ...e }),
                            (this.$container = this.options.container instanceof HTMLElement ? this.options.container : document.querySelector(this.options.container)),
                            !this.$container)
                        )
                            return console.warn("Can not initialize tabs with out container", this);
                        (this.isLocked = !1),
                            (this.duration = this.options.duration / 2),
                            (this.activeIndex = this.options.activeIndex),
                            (this.triggers = this.$container.querySelectorAll(this.options.itemTriggerSelector)),
                            (this.items = this.$container.querySelectorAll(this.options.itemContentSelector)),
                            (this.currentItemIndex = null),
                            (this.currentTrigger = null),
                            (this.currentItem = null),
                            o(this, a, c).call(this);
                    }
                    setNewTabByID(e) {
                        if (this.isLocked) return;
                        const t = [...this.items].find((t) => {
                            var i;
                            return (null === (i = t.id) || void 0 === i ? void 0 : i.toLowerCase()) === e;
                        });
                        o(this, l, u).call(this, t);
                    }
                    setNewTabByIndex(e) {
                        if (this.isLocked) return;
                        this.isLocked = !0;
                        let t = this.items[e];
                        t ? (this.currentItemIndex = e) : ((this.currentItemIndex = 0), (t = this.items[0]), console.warn("Can not find tab item with index ".concat(e, " in"), this)), (this.isLocked = !0), o(this, l, u).call(this, t);
                    }
                    changeActiveButton() {
                        var e;
                        const t = null === (e = this.currentItem.id) || void 0 === e ? void 0 : e.toLowerCase();
                        this.triggers.forEach((e) => {
                            var i;
                            (null === (i = e.dataset.tabId) || void 0 === i ? void 0 : i.toLowerCase()) === t
                                ? ((this.currentTrigger = e), this.currentTrigger.classList.add(this.options.activeClass))
                                : e.classList.remove(this.options.activeClass);
                        });
                    }
                };
            },
            2918: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.defaultTabsOptions = void 0),
                    (t.defaultTabsOptions = { container: ".js-tabs", itemTriggerSelector: ".js-tab-btn", itemContentSelector: ".js-tabs-item", activeClass: "_active", duration: 500, activeIndex: 0 });
            },
            9565: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.Lodash = void 0),
                    (t.Lodash = new (class {
                        debounce(e, t) {
                            let i = !1;
                            return function () {
                                i || (e.apply(this, arguments), (i = !0), setTimeout(() => (i = !1), t));
                            };
                        }
                        throttle(e, t) {
                            let i,
                                n,
                                r = !1;
                            return function s() {
                                if (r) return (i = arguments), void (n = this);
                                e.apply(this, arguments),
                                    (r = !0),
                                    setTimeout(function () {
                                        (r = !1), i && (s.apply(n, i), (i = n = null));
                                    }, t);
                            };
                        }
                    })());
            },
            736: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.ScrollbarLocker = void 0),
                    (t.ScrollbarLocker = new (class {
                        constructor() {
                            (this.cssVar = "--current-scrollbar-width"), (this.lockClass = "_lock"), (this.scrollbarCurrentWidth = this.getScrollbarWidth()), (this._isLocked = !1);
                        }
                        set isLocked(e) {
                            this._isLocked = e;
                        }
                        get isLocked() {
                            return this._isLocked;
                        }
                        toggle() {
                            this.isLocked ? this.lock() : this.unLock();
                        }
                        getScrollbarWidth() {
                            const e = document.createElement("div"),
                                t = document.createElement("div");
                            e.append(t), document.body.append(e), (e.style.overflow = "scroll"), (e.style.width = "50px"), (t.style.width = "100%");
                            const i = e.offsetWidth - t.offsetWidth;
                            return e.remove(), i;
                        }
                        lock() {
                            const e = this.getScrollbarWidth();
                            document.documentElement.style.setProperty(this.cssVar, "".concat(e, "px")), document.body.classList.add(this.lockClass), (this.isLocked = !0);
                        }
                        unLock() {
                            document.documentElement.style.setProperty(this.cssVar, "0px"), document.body.classList.remove(this.lockClass), (this.isLocked = !1);
                        }
                    })());
            },
            3310: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.VideoResponser = void 0),
                    (t.VideoResponser = class {
                        constructor(e) {
                            const t = document.querySelector(e);
                            (this.options = { selector: e, breakpoints: { default: { src: t.getAttribute("data-src") } } }),
                                t.querySelectorAll("[data-src]").forEach((e) => (this.options.breakpoints[e.getAttribute("data-mw")] = { src: e.getAttribute("data-src") })),
                                (t.innerHTML = ""),
                                this.responseVideo(this.options),
                                this.resizer();
                        }
                        resizer() {
                            window.addEventListener("resize", () => this.responseVideo(this.options));
                        }
                        responseVideo(e) {
                            const { selector: t, breakpoints: i } = e;
                            let n = document.querySelector(t);
                            const r = n.getAttribute("data-width-now") || null,
                                s = Math.max.apply(
                                    Math,
                                    Object.keys(i)
                                        .filter((e) => e <= document.body.clientWidth)
                                        .map(Number)
                                ),
                                o = s > 0 ? s : "default";
                            (r && r == o) || (n.setAttribute("data-width-now", o), (n.src = i[o].src));
                        }
                    });
            },
            4257: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.CollectionsFilter = void 0);
                var n = i(5116);
                function r(e, t, i) {
                    !(function (e, t) {
                        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                    })(e, t),
                        t.set(e, i);
                }
                function s(e, t) {
                    var i = (function (e, t, i) {
                        if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
                        return t.get(e);
                    })(e, t);
                    return (function (e, t) {
                        return t.get ? t.get.call(e) : t.value;
                    })(e, i);
                }
                var o = new WeakMap(),
                    a = new WeakMap(),
                    l = new WeakMap();
                t.CollectionsFilter = class {
                    constructor() {
                        r(this, o, {
                            writable: !0,
                            value: () => {
                                this.close();
                            },
                        }),
                            r(this, a, {
                                writable: !0,
                                value: () => {
                                    this.toggle();
                                },
                            }),
                            r(this, l, {
                                writable: !0,
                                value: (e) => {
                                    this.$container.contains(e.target) || this.close();
                                },
                            }),
                            (this.$container = document.querySelector(".products-filter")),
                            this.$container &&
                                ((this.$toggler = this.$container.querySelector(".products-filter__filters-btn")),
                                (this.$applyButton = this.$container.querySelector(".products-filter__filters-apply-btn")),
                                (this.sort_select = new n.Select({ container: this.$container.querySelector(".js-products-filter-sort-select") })),
                                (this.parametersBlocks = Array.from(this.$container.querySelectorAll(".js-parameters")).map((e) => {
                                    const t = e.querySelectorAll(".js-parameters-btn"),
                                        i = e.querySelector(".js-parameters-value");
                                    return (
                                        t.forEach((e) => {
                                            e.hasAttribute("disabled") ||
                                                e.addEventListener("click", () => {
                                                    e.classList.add("_active"),
                                                        i && (i.innerHTML = e.value),
                                                        t.forEach((t) => {
                                                            t !== e && t.classList.remove("_active");
                                                        });
                                                });
                                        }),
                                        { $parent: e, $valueHolder: i, buttons: t }
                                    );
                                })),
                                (this.isOpened = !1),
                                this.init());
                    }
                    init() {
                        this.$toggler.addEventListener("click", s(this, a)), this.$applyButton.addEventListener("click", s(this, o)), window.addEventListener("click", s(this, l));
                    }
                    toggle() {
                        this.isOpened ? this.close() : this.open();
                    }
                    open() {
                        this.$container.classList.add("_show"), this.$toggler.classList.add("_active"), (this.isOpened = !0);
                    }
                    close() {
                        this.$container.classList.remove("_show"),
                            this.$toggler.classList.remove("_active"),
                            (this.$container.ontransitionend = () => {
                                this.$container.scrollTo({ top: 0, behavior: "smooth" }), (this.$container.ontransitionend = null);
                            }),
                            (this.isOpened = !1);
                    }
                };
            },
            3650: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.FadeElementsAnimation = void 0);
                var n,
                    r = (n = i(6358)) && n.__esModule ? n : { default: n };
                i(9565),
                    (t.FadeElementsAnimation = class {
                        constructor() {
                            (function (e, t, i) {
                                (t = (function (e) {
                                    var t = (function (e, t) {
                                        if ("object" != typeof e || null === e) return e;
                                        var i = e[Symbol.toPrimitive];
                                        if (void 0 !== i) {
                                            var n = i.call(e, "string");
                                            if ("object" != typeof n) return n;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    })(e);
                                    return "symbol" == typeof t ? t : String(t);
                                })(t)) in e
                                    ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                                    : (e[t] = i);
                            })(this, "playAnimation", () => {
                                this.parents.forEach((e) => {
                                    const t = e.querySelectorAll(".js-fade-element");
                                    r.default.fromTo(t, { opacity: 0 }, { opacity: 1, duration: 1, stagger: 0.25, delay: 0.25, scrollTrigger: { trigger: e, start: "top 90%" } });
                                });
                            }),
                                (this.parents = document.querySelectorAll(".js-fade-parent")),
                                this.init();
                        }
                        init() {
                            this.parents.length && (window.innerWidth <= window.tablet || this.playAnimation());
                        }
                    });
            },
            5167: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.FadeTextAnimation = void 0);
                var n,
                    r = (n = i(6358)) && n.__esModule ? n : { default: n };
                t.FadeTextAnimation = class {
                    constructor() {
                        (function (e, t, i) {
                            (t = (function (e) {
                                var t = (function (e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var i = e[Symbol.toPrimitive];
                                    if (void 0 !== i) {
                                        var n = i.call(e, "string");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e);
                                })(e);
                                return "symbol" == typeof t ? t : String(t);
                            })(t)) in e
                                ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                                : (e[t] = i);
                        })(this, "slitText", (e) => {
                            const t = e.innerHTML.trim().split(" ");
                            e.innerHTML = t
                                .map((e) => {
                                    let t = !1;
                                    const i = e
                                        .split("")
                                        .map((e) => ("<" === e && (t = !0), ">" === e && (t = !1), t ? e : '<span class="letter">'.concat(e, "</span>")))
                                        .join("");
                                    return e.includes("<") || e.includes(">") ? e : '<span class="word">'.concat(i, "</span>");
                                })
                                .join(" ");
                        }),
                            (this.nodeItems = document.querySelectorAll(".js-text-animate")),
                            this.nodeItems.forEach((e) => {
                                this.slitText(e);
                            }),
                            this.init();
                    }
                    init() {
                        var e;
                        null !== (e = this.nodeItems) && void 0 !== e && e.length && this.animate();
                    }
                    animate() {
                        this.nodeItems.forEach((e) => {
                            const t = e.querySelectorAll(".word");
                            r.default.fromTo(t, { opacity: 0 }, { opacity: 1, duration: 1, stagger: 0.1, delay: 0.1, scrollTrigger: { trigger: e } });
                        });
                    }
                };
            },
            229: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Header = void 0);
                var n = i(9565);
                function r(e, t, i) {
                    return (
                        (t = (function (e) {
                            var t = (function (e, t) {
                                if ("object" != typeof e || null === e) return e;
                                var i = e[Symbol.toPrimitive];
                                if (void 0 !== i) {
                                    var n = i.call(e, "string");
                                    if ("object" != typeof n) return n;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            })(e);
                            return "symbol" == typeof t ? t : String(t);
                        })(t)) in e
                            ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = i),
                        e
                    );
                }
                t.Header = class {
                    constructor() {
                        r(
                            this,
                            "scrollHandle",
                            n.Lodash.throttle(() => {
                                this.toggleHeaderVisible(), this.toggleScrolledModify();
                            }, 50)
                        ),
                            r(
                                this,
                                "resizeHandle",
                                n.Lodash.throttle(() => {
                                    this.setCssVars();
                                }, 75)
                            ),
                            r(
                                this,
                                "mouseMoveHandle",
                                n.Lodash.throttle((e) => {
                                    e.clientY < this.$header.offsetHeight ? (this.showHeader(), (this.isCursorOverHeader = !0)) : (this.isCursorOverHeader = !1);
                                }, 150)
                            ),
                            (this.$header = document.querySelector(".header")),
                            (this.headerHeightCssVar = "--header-height"),
                            (this.hiddenVisibleVlass = "_hide"),
                            (this.scrolledClass = "_scrolled"),
                            (this.currentScrollPosition = window.scrollY),
                            (this.isCursorOverHeader = !1),
                            (this.isVisible = !0),
                            (this.isInit = !1),
                            (this.isLocked = !1),
                            this.init();
                    }
                    init() {
                        this.setCssVars(),
                            this.toggleHeaderVisible(),
                            this.toggleScrolledModify(),
                            window.addEventListener("scroll", this.scrollHandle),
                            window.addEventListener("mousemove", this.mouseMoveHandle),
                            window.addEventListener("resize", this.resizeHandle),
                            (this.isInit = !0);
                    }
                    destroy() {
                        window.removeEventListener("scroll", this.scrollHandle), window.removeEventListener("mousemove", this.mouseMoveHandle), window.removeEventListener("resize", this.resizeHandle), (this.isInit = !1);
                    }
                    lock() {
                        this.isLocked = !0;
                    }
                    unLock() {
                        this.isLocked = !1;
                    }
                    toggleHeaderVisible() {
                        window.scrollY < this.currentScrollPosition || window.scrollY < this.$header.offsetHeight ? this.showHeader() : this.hideHeader(), (this.currentScrollPosition = window.scrollY);
                    }
                    showHeader() {
                        this.isVisible || this.isCursorOverHeader || this.isLocked || (this.$header.classList.remove(this.hiddenVisibleVlass), (this.isVisible = !0));
                    }
                    hideHeader() {
                        !this.isVisible || this.isCursorOverHeader || this.isLocked || (this.$header.classList.add(this.hiddenVisibleVlass), (this.isVisible = !1));
                    }
                    toggleScrolledModify() {
                        window.scrollY >= this.$header.offsetHeight ? this.$header.classList.add(this.scrolledClass) : this.$header.classList.remove(this.scrolledClass);
                    }
                    setCssVars() {
                        document.documentElement.style.setProperty(this.headerHeightCssVar, "".concat(this.$header.offsetHeight, "px"));
                    }
                };
            },
            4001: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.HeroSection = void 0);
                var n,
                    r = i(9565),
                    s = (n = i(6358)) && n.__esModule ? n : { default: n },
                    o = i(3310);
                t.HeroSection = class {
                    constructor() {
                        (function (e, t, i) {
                            (t = (function (e) {
                                var t = (function (e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var i = e[Symbol.toPrimitive];
                                    if (void 0 !== i) {
                                        var n = i.call(e, "string");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e);
                                })(e);
                                return "symbol" == typeof t ? t : String(t);
                            })(t)) in e
                                ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                                : (e[t] = i);
                        })(
                            this,
                            "scrollHandle",
                            r.Lodash.throttle(() => {
                                this.bgParallaxAnimation();
                            }, 0)
                        ),
                            (this.$section = document.querySelector(".hero")),
                            this.$section && ((this.$bg = this.$section.querySelector(".hero__bg")), (this.videoResponcer = new o.VideoResponser("#hero_bg_video")), console.log(this.videoResponcer), (this.coef = -0.1), this.init());
                    }
                    init() {
                        window.addEventListener("scroll", this.scrollHandle);
                    }
                    bgParallaxAnimation() {
                        this.$bg && (window.innerWidth <= window.tablet || s.default.to(this.$bg, { duration: 0, y: window.scrollY * this.coef }));
                    }
                };
            },
            2213: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.HoverElementAnimation = void 0);
                var n,
                    r = (n = i(6358)) && n.__esModule ? n : { default: n },
                    s = i(9565);
                function o(e, t, i) {
                    return (
                        (t = (function (e) {
                            var t = (function (e, t) {
                                if ("object" != typeof e || null === e) return e;
                                var i = e[Symbol.toPrimitive];
                                if (void 0 !== i) {
                                    var n = i.call(e, "string");
                                    if ("object" != typeof n) return n;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            })(e);
                            return "symbol" == typeof t ? t : String(t);
                        })(t)) in e
                            ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = i),
                        e
                    );
                }
                t.HoverElementAnimation = class {
                    constructor() {
                        o(this, "mouseMoveHandle", (e) => {
                            const { clientX: t, clientY: i, currentTarget: n } = e,
                                { left: s, top: o, width: a, height: l } = n.getBoundingClientRect(),
                                c = (t - (s + a / 2)) * this.coef,
                                u = (i - (o + l / 2)) * this.coef;
                            c > 50 || u > 50 || r.default.to(n, { x: c, y: u });
                        }),
                            o(this, "mouseLeaveHandle", (e) => {
                                r.default.to(e.currentTarget, { x: 0, y: 0 });
                            }),
                            o(this, "resizeHandle", () => {
                                window.innerWidth <= window.tablet ? this.destroy() : this.init();
                            }),
                            (this.links = document.querySelectorAll(".js-hover-element")),
                            (this.isInitialize = !1),
                            (this.coef = 0.25),
                            window.addEventListener("resize", s.Lodash.throttle(this.resizeHandle, 100)),
                            window.innerWidth > window.tablet && this.init();
                    }
                    init() {
                        this.isInitialize ||
                            (this.links.forEach((e) => {
                                e.addEventListener("mousemove", this.mouseMoveHandle), e.addEventListener("mouseleave", this.mouseLeaveHandle);
                            }),
                            (this.isInitialize = !0));
                    }
                    destroy() {
                        this.isInitialize &&
                            (this.links.forEach((e) => {
                                e.removeEventListener("mousemove", this.mouseMoveHandle), e.removeEventListener("mouseleave", this.mouseLeaveHandle);
                            }),
                            (this.isInitialize = !1));
                    }
                };
            },
            393: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = i(229);
                Object.keys(n).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === n[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return n[e];
                                },
                            }));
                });
                var r = i(3099);
                Object.keys(r).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === r[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return r[e];
                                },
                            }));
                });
                var s = i(4257);
                Object.keys(s).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === s[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return s[e];
                                },
                            }));
                });
                var o = i(4001);
                Object.keys(o).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === o[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return o[e];
                                },
                            }));
                });
                var a = i(5167);
                Object.keys(a).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === a[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return a[e];
                                },
                            }));
                });
                var l = i(3650);
                Object.keys(l).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === l[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return l[e];
                                },
                            }));
                });
                var c = i(2213);
                Object.keys(c).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === c[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return c[e];
                                },
                            }));
                });
                var u = i(1573);
                Object.keys(u).forEach(function (e) {
                    "default" !== e &&
                        "__esModule" !== e &&
                        ((e in t && t[e] === u[e]) ||
                            Object.defineProperty(t, e, {
                                enumerable: !0,
                                get: function () {
                                    return u[e];
                                },
                            }));
                });
            },
            3099: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.Navigation = void 0);
                var n = i(736);
                t.Navigation = class {
                    constructor() {
                        var e, t, i;
                        (e = this),
                            (i = () => {
                                this.toggle();
                            }),
                            (t = (function (e) {
                                var t = (function (e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var i = e[Symbol.toPrimitive];
                                    if (void 0 !== i) {
                                        var n = i.call(e, "string");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e);
                                })(e);
                                return "symbol" == typeof t ? t : String(t);
                            })((t = "triggerClickHandle"))) in e
                                ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                                : (e[t] = i),
                            (this.$nav = document.querySelector(".nav")),
                            (this.$header = document.querySelector(".header")),
                            (this.triggers = document.querySelectorAll(".js-nav-trigger")),
                            (this.navOpenClass = "_show"),
                            (this.headerNavOpenClass = "_nav-open"),
                            (this.triggerActiveClass = "_active"),
                            (this.isOpen = !1),
                            this.init();
                    }
                    init() {
                        this.triggers.forEach((e) => {
                            e.addEventListener("click", this.triggerClickHandle);
                        });
                    }
                    toggle() {
                        this.isOpened ? this.close() : this.open();
                    }
                    open() {
                        this.$nav.classList.add(this.navOpenClass),
                            this.triggers.forEach((e) => {
                                e.classList.add(this.triggerActiveClass);
                            }),
                            n.ScrollbarLocker.lock(),
                            (this.isOpened = !0);
                    }
                    close() {
                        this.$nav.classList.remove(this.navOpenClass),
                            this.triggers.forEach((e) => {
                                e.classList.remove(this.triggerActiveClass);
                            }),
                            n.ScrollbarLocker.unLock(),
                            (this.isOpened = !1);
                    }
                };
            },
            1573: function (e, t, i) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.SingleProduct = void 0);
                var n = i(5116),
                    r = i(8252),
                    s = i(736),
                    o = c(i(7652)),
                    a = i(9565),
                    l = c(i(6358));
                function c(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function u(e, t, i) {
                    return (
                        (t = (function (e) {
                            var t = (function (e, t) {
                                if ("object" != typeof e || null === e) return e;
                                var i = e[Symbol.toPrimitive];
                                if (void 0 !== i) {
                                    var n = i.call(e, "string");
                                    if ("object" != typeof n) return n;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            })(e);
                            return "symbol" == typeof t ? t : String(t);
                        })(t)) in e
                            ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = i),
                        e
                    );
                }
                t.SingleProduct = class {
                    constructor(e) {
                        let { header: t } = e;
                        u(this, "changeUnitHandle", (e) => {
                            var t;
                            const { currentTarget: i } = e,
                                n = null === (t = i.dataset) || void 0 === t ? void 0 : t.unit;
                            n
                                ? (this.unitItems.forEach((e) => {
                                      e.dataset[n] ? (e.innerHTML = e.dataset[n]) : console.warn("Not found unit key in:", e);
                                  }),
                                  this.unitButtons.forEach((e) => {
                                      e === i ? e.classList.add("_active") : e.classList.remove("_active");
                                  }))
                                : console.warn("Not found unit key in:", i);
                        }),
                            u(this, "windowResizeHandle", () => {
                                this.initImagesSlider(), this.videoTogglePlay();
                            }),
                            u(this, "windowScrollHandle", () => {
                                this.videoTogglePlay();
                            }),
                            u(this, "toggleSizes", () => {
                                this.isSizesOpen ? this.closeSizes() : this.openSizes();
                            }),
                            u(this, "openSizes", () => {
                                this.sizesTogglers.forEach((e) => e.classList.add("_active")), this.$sizesModal.classList.add("_active"), (this.isSizesOpen = !0), window.innerWidth <= window.tablet && s.ScrollbarLocker.lock();
                            }),
                            u(this, "closeSizes", () => {
                                this.sizesTogglers.forEach((e) => e.classList.remove("_active")), this.$sizesModal.classList.remove("_active"), (this.isSizesOpen = !1), s.ScrollbarLocker.isLocked && s.ScrollbarLocker.unLock();
                            }),
                            (this.$container = document.querySelector(".single-product")),
                            this.$container &&
                                ((this.picturesSlider = null),
                                (this.$picturesWrap = this.$container.querySelector(".single-product-pictures .single-product-pictures__wrapper")),
                                (this.pictures = this.$container.querySelectorAll(".single-product-pictures .single-product-pictures__picture")),
                                (this.$video = this.$container.querySelector(".single-product-pictures__video")),
                                (this.isVideoPlayed = !1),
                                (this.sizesTogglers = this.$container.querySelectorAll(".single-product__show-sizes-btn")),
                                (this.$sizesCloseTrigger = this.$container.querySelector(".single-product-sizes__close-btn")),
                                (this.$sizesModal = this.$container.querySelector(".single-product-sizes")),
                                (this.isSizesOpen = !1),
                                (this.blocks = this.$container.querySelectorAll(".single-product-body__block")),
                                (this.parametersBlocks = Array.from(this.$container.querySelectorAll(".js-parameters")).map((e) => {
                                    const t = e.querySelectorAll(".js-parameters-btn"),
                                        i = e.querySelector(".js-parameters-value");
                                    return (
                                        t.forEach((e) => {
                                            e.hasAttribute("disabled") ||
                                                e.addEventListener("click", () => {
                                                    e.classList.add("_active"),
                                                        i && (i.innerHTML = e.value),
                                                        t.forEach((t) => {
                                                            t !== e && t.classList.remove("_active");
                                                        });
                                                });
                                        }),
                                        { $parent: e, $valueHolder: i, buttons: t }
                                    );
                                })),
                                (this.header = t),
                                (this.tabsDescr = null),
                                (this.tabsSizes = null),
                                (this.unitButtons = this.$container.querySelectorAll(".js-single-product-unit-button")),
                                (this.unitItems = this.$container.querySelectorAll(".js-single-product-unit-item")),
                                (this.tabsSliderOptions = { slidesPerView: "auto", spaceBetween: 45 }),
                                this.init());
                    }
                    init() {
                        window.addEventListener("resize", a.Lodash.throttle(this.windowResizeHandle, 100)),
                            window.addEventListener("scroll", a.Lodash.throttle(this.windowScrollHandle, 100)),
                            this.unitButtons.forEach((e) => {
                                e.addEventListener("click", this.changeUnitHandle);
                            }),
                            this.sizesTogglers.forEach((e) => e.addEventListener("click", this.toggleSizes)),
                            this.$sizesCloseTrigger.addEventListener("click", this.closeSizes),
                            (this.tabsDescr = new n.Tabs({ container: this.$container.querySelector(".js-single-product-tabs") })),
                            (this.tabsSizes = new n.Tabs({ container: this.$container.querySelector(".js-single-product-tabs-sizes") })),
                            (this.tabsHeaderSlider = new o.default(".single-product-tabs__head-slider", this.tabsSliderOptions)),
                            (this.sizesHeaderSlider = new o.default(".single-product-sizes__head-slider", this.tabsSliderOptions)),
                            r.Fancybox.bind("[data-fancybox='gallery']", {
                                hideScrollbar: !1,
                                on: {
                                    done: (e) => {
                                        e.container.classList.add("_product-gallery"), s.ScrollbarLocker.lock(), this.header.hideHeader(), this.header.lock();
                                        const t = e.container.querySelector("video");
                                        t && t.setAttribute("loop", "true"), this.videoPause();
                                    },
                                    close: () => {
                                        s.ScrollbarLocker.unLock(), this.header.unLock(), this.header.showHeader(), this.videoTogglePlay();
                                    },
                                },
                            }),
                            this.initImagesSlider(),
                            this.videoTogglePlay(),
                            l.default.fromTo(this.blocks, { opacity: 0 }, { opacity: 1, duration: 1, stagger: 0.25, delay: 0.25 });
                    }
                    videoTogglePlay() {
                        if (!this.$video) return;
                        const { innerHeight: e, innerWidth: t, tablet: i } = window,
                            { top: n, bottom: r } = this.$video.getBoundingClientRect(),
                            s = !!this.$video.closest(".swiper-slide-active"),
                            o = t <= i,
                            a = o ? e / 3 : e / 6;
                        n <= e - a && r > a ? (!o || (o && s)) && this.videoPlay() : this.videoPause();
                    }
                    videoPlay() {
                        this.$video && !this.isVideoPlayed && this.$video.play().then(() => (this.isVideoPlayed = !0));
                    }
                    videoPause() {
                        this.$video && this.isVideoPlayed && (this.$video.pause(), (this.isVideoPlayed = !1));
                    }
                    initImagesSlider() {
                        var e;
                        const t = window.innerWidth <= window.tablet,
                            i = (e) => {
                                e.slides[e.activeIndex].contains(this.$video) ? this.videoPlay() : this.videoPause();
                            };
                        switch (!0) {
                            case t && (!this.picturesSlider || this.picturesSlider.destroyed):
                                this.$picturesWrap.classList.add("swiper-wrapper"),
                                    (this.picturesSlider = new o.default(".single-product-pictures", { speed: 1e3, slidesPerView: 1, pagination: { el: ".single-product-pictures__pagination" }, on: { init: i, slideChange: i } }));
                                break;
                            case !t:
                                this.$picturesWrap.classList.remove("swiper-wrapper"), null === (e = this.picturesSlider) || void 0 === e || e.destroy(!0, !0);
                        }
                    }
                };
            },
            860: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.fadeOut = t.fadeIn = void 0),
                    (t.fadeIn = (e, t, i) => {
                        (e.style.transition = "opacity ".concat(t, "ms")),
                            (e.style.opacity = "0"),
                            (e.style.display = "block"),
                            setTimeout(() => {
                                (e.style.opacity = "1"), i && i(e);
                            }, t);
                    }),
                    (t.fadeOut = (e, t, i) => {
                        (e.style.transition = "opacity ".concat(t, "ms")),
                            (e.style.opacity = "0"),
                            setTimeout(() => {
                                (e.style.opacity = "1"), (e.style.display = "none"), i && i(e);
                            }, t);
                    });
            },
            6515: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.pad = t.getElementOffset = void 0),
                    (t.getElementOffset = (e) => {
                        const t = e.getBoundingClientRect();
                        return { rect: t, dom: { bottom: t.bottom + window.scrollY, left: t.left + window.scrollX, top: t.top + window.scrollY } };
                    }),
                    (t.pad = function (e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
                            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "00";
                        return e.toString().padStart(t, i);
                    });
            },
            5974: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.slideUp = t.slideToggle = t.slideDown = void 0);
                const i = function (e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                        i = arguments.length > 2 ? arguments[2] : void 0;
                    (e.style.transitionProperty = "height, margin, padding"),
                        (e.style.transitionDuration = t + "ms"),
                        (e.style.boxSizing = "border-box"),
                        (e.style.height = e.offsetHeight + "px"),
                        e.offsetHeight,
                        (e.style.overflow = "hidden"),
                        (e.style.height = "0"),
                        (e.style.paddingTop = "0"),
                        (e.style.paddingBottom = "0"),
                        (e.style.marginTop = "0"),
                        (e.style.marginBottom = "0"),
                        window.setTimeout(() => {
                            (e.style.display = "none"),
                                e.style.removeProperty("height"),
                                e.style.removeProperty("padding-top"),
                                e.style.removeProperty("padding-bottom"),
                                e.style.removeProperty("margin-top"),
                                e.style.removeProperty("margin-bottom"),
                                e.style.removeProperty("overflow"),
                                e.style.removeProperty("transition-duration"),
                                e.style.removeProperty("transition-property"),
                                i && i(e);
                        }, t);
                };
                t.slideUp = i;
                const n = function (e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                        i = arguments.length > 2 ? arguments[2] : void 0;
                    e.style.removeProperty("display");
                    let n = "block";
                    "none" === n && (n = "block"), (e.style.display = n);
                    const r = e.offsetHeight;
                    (e.style.overflow = "hidden"),
                        (e.style.height = "0"),
                        (e.style.paddingTop = "0"),
                        (e.style.paddingBottom = "0"),
                        (e.style.marginTop = "0"),
                        (e.style.marginBottom = "0"),
                        e.offsetHeight,
                        (e.style.boxSizing = "border-box"),
                        (e.style.transitionProperty = "height, margin, padding"),
                        (e.style.transitionDuration = t + "ms"),
                        (e.style.height = r + "px"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        window.setTimeout(() => {
                            e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), i && i(e);
                        }, t);
                };
                (t.slideDown = n),
                    (t.slideToggle = function (e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                            r = arguments.length > 2 ? arguments[2] : void 0;
                        return "none" === window.getComputedStyle(e).display ? n(e, t, r) : i(e, t, r);
                    });
            },
            4097: function (e, t, i) {
                "use strict";
                i.r(t),
                    i.d(t, {
                        A11y: function () {
                            return g;
                        },
                        Autoplay: function () {
                            return y;
                        },
                        Controller: function () {
                            return m;
                        },
                        EffectCards: function () {
                            return F;
                        },
                        EffectCoverflow: function () {
                            return j;
                        },
                        EffectCreative: function () {
                            return R;
                        },
                        EffectCube: function () {
                            return I;
                        },
                        EffectFade: function () {
                            return A;
                        },
                        EffectFlip: function () {
                            return D;
                        },
                        FreeMode: function () {
                            return x;
                        },
                        Grid: function () {
                            return S;
                        },
                        HashNavigation: function () {
                            return b;
                        },
                        History: function () {
                            return v;
                        },
                        Keyboard: function () {
                            return o;
                        },
                        Manipulation: function () {
                            return C;
                        },
                        Mousewheel: function () {
                            return a;
                        },
                        Navigation: function () {
                            return c;
                        },
                        Pagination: function () {
                            return d;
                        },
                        Parallax: function () {
                            return f;
                        },
                        Scrollbar: function () {
                            return h;
                        },
                        Thumbs: function () {
                            return w;
                        },
                        Virtual: function () {
                            return s;
                        },
                        Zoom: function () {
                            return p;
                        },
                    });
                var n = i(3433),
                    r = i(7185);
                function s(e) {
                    let t,
                        { swiper: i, extendParams: s, on: o, emit: a } = e;
                    s({ virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, renderExternalUpdate: !0, addSlidesBefore: 0, addSlidesAfter: 0 } });
                    const l = (0, n.g)();
                    i.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
                    const c = l.createElement("div");
                    function u(e, t) {
                        const n = i.params.virtual;
                        if (n.cache && i.virtual.cache[t]) return i.virtual.cache[t];
                        let s;
                        return (
                            n.renderSlide ? ((s = n.renderSlide.call(i, e, t)), "string" == typeof s && ((c.innerHTML = s), (s = c.children[0]))) : (s = i.isElement ? (0, r.c)("swiper-slide") : (0, r.c)("div", i.params.slideClass)),
                            s.setAttribute("data-swiper-slide-index", t),
                            n.renderSlide || (s.innerHTML = e),
                            n.cache && (i.virtual.cache[t] = s),
                            s
                        );
                    }
                    function d(e) {
                        const { slidesPerView: t, slidesPerGroup: n, centeredSlides: s, loop: o } = i.params,
                            { addSlidesBefore: l, addSlidesAfter: c } = i.params.virtual,
                            { from: d, to: h, slides: f, slidesGrid: p, offset: m } = i.virtual;
                        i.params.cssMode || i.updateActiveIndex();
                        const g = i.activeIndex || 0;
                        let v, b, y;
                        (v = i.rtlTranslate ? "right" : i.isHorizontal() ? "left" : "top"), s ? ((b = Math.floor(t / 2) + n + c), (y = Math.floor(t / 2) + n + l)) : ((b = t + (n - 1) + c), (y = (o ? t : n) + l));
                        let w = g - y,
                            x = g + b;
                        o || ((w = Math.max(w, 0)), (x = Math.min(x, f.length - 1)));
                        let S = (i.slidesGrid[w] || 0) - (i.slidesGrid[0] || 0);
                        function E() {
                            i.updateSlides(), i.updateProgress(), i.updateSlidesClasses(), a("virtualUpdate");
                        }
                        if (
                            (o && g >= y ? ((w -= y), s || (S += i.slidesGrid[0])) : o && g < y && ((w = -y), s && (S += i.slidesGrid[0])),
                            Object.assign(i.virtual, { from: w, to: x, offset: S, slidesGrid: i.slidesGrid, slidesBefore: y, slidesAfter: b }),
                            d === w && h === x && !e)
                        )
                            return (
                                i.slidesGrid !== p &&
                                    S !== m &&
                                    i.slides.forEach((e) => {
                                        e.style[v] = S - Math.abs(i.cssOverflowAdjustment()) + "px";
                                    }),
                                i.updateProgress(),
                                void a("virtualUpdate")
                            );
                        if (i.params.virtual.renderExternal)
                            return (
                                i.params.virtual.renderExternal.call(i, {
                                    offset: S,
                                    from: w,
                                    to: x,
                                    slides: (function () {
                                        const e = [];
                                        for (let t = w; t <= x; t += 1) e.push(f[t]);
                                        return e;
                                    })(),
                                }),
                                void (i.params.virtual.renderExternalUpdate ? E() : a("virtualUpdate"))
                            );
                        const _ = [],
                            T = [],
                            M = (e) => {
                                let t = e;
                                return e < 0 ? (t = f.length + e) : t >= f.length && (t -= f.length), t;
                            };
                        if (e)
                            i.slides
                                .filter((e) => e.matches(`.${i.params.slideClass}, swiper-slide`))
                                .forEach((e) => {
                                    e.remove();
                                });
                        else
                            for (let e = d; e <= h; e += 1)
                                if (e < w || e > x) {
                                    const t = M(e);
                                    i.slides
                                        .filter((e) => e.matches(`.${i.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`))
                                        .forEach((e) => {
                                            e.remove();
                                        });
                                }
                        const P = o ? -f.length : 0,
                            C = o ? 2 * f.length : f.length;
                        for (let t = P; t < C; t += 1)
                            if (t >= w && t <= x) {
                                const i = M(t);
                                void 0 === h || e ? T.push(i) : (t > h && T.push(i), t < d && _.push(i));
                            }
                        if (
                            (T.forEach((e) => {
                                i.slidesEl.append(u(f[e], e));
                            }),
                            o)
                        )
                            for (let e = _.length - 1; e >= 0; e -= 1) {
                                const t = _[e];
                                i.slidesEl.prepend(u(f[t], t));
                            }
                        else
                            _.sort((e, t) => t - e),
                                _.forEach((e) => {
                                    i.slidesEl.prepend(u(f[e], e));
                                });
                        (0, r.e)(i.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
                            e.style[v] = S - Math.abs(i.cssOverflowAdjustment()) + "px";
                        }),
                            E();
                    }
                    o("beforeInit", () => {
                        if (!i.params.virtual.enabled) return;
                        let e;
                        if (void 0 === i.passedParams.virtual.slides) {
                            const t = [...i.slidesEl.children].filter((e) => e.matches(`.${i.params.slideClass}, swiper-slide`));
                            t &&
                                t.length &&
                                ((i.virtual.slides = [...t]),
                                (e = !0),
                                t.forEach((e, t) => {
                                    e.setAttribute("data-swiper-slide-index", t), (i.virtual.cache[t] = e), e.remove();
                                }));
                        }
                        e || (i.virtual.slides = i.params.virtual.slides), i.classNames.push(`${i.params.containerModifierClass}virtual`), (i.params.watchSlidesProgress = !0), (i.originalParams.watchSlidesProgress = !0), d();
                    }),
                        o("setTranslate", () => {
                            i.params.virtual.enabled &&
                                (i.params.cssMode && !i._immediateVirtual
                                    ? (clearTimeout(t),
                                      (t = setTimeout(() => {
                                          d();
                                      }, 100)))
                                    : d());
                        }),
                        o("init update resize", () => {
                            i.params.virtual.enabled && i.params.cssMode && (0, r.s)(i.wrapperEl, "--swiper-virtual-size", `${i.virtualSize}px`);
                        }),
                        Object.assign(i.virtual, {
                            appendSlide: function (e) {
                                if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && i.virtual.slides.push(e[t]);
                                else i.virtual.slides.push(e);
                                d(!0);
                            },
                            prependSlide: function (e) {
                                const t = i.activeIndex;
                                let n = t + 1,
                                    r = 1;
                                if (Array.isArray(e)) {
                                    for (let t = 0; t < e.length; t += 1) e[t] && i.virtual.slides.unshift(e[t]);
                                    (n = t + e.length), (r = e.length);
                                } else i.virtual.slides.unshift(e);
                                if (i.params.virtual.cache) {
                                    const e = i.virtual.cache,
                                        t = {};
                                    Object.keys(e).forEach((i) => {
                                        const n = e[i],
                                            s = n.getAttribute("data-swiper-slide-index");
                                        s && n.setAttribute("data-swiper-slide-index", parseInt(s, 10) + r), (t[parseInt(i, 10) + r] = n);
                                    }),
                                        (i.virtual.cache = t);
                                }
                                d(!0), i.slideTo(n, 0);
                            },
                            removeSlide: function (e) {
                                if (null == e) return;
                                let t = i.activeIndex;
                                if (Array.isArray(e))
                                    for (let n = e.length - 1; n >= 0; n -= 1)
                                        i.params.virtual.cache &&
                                            (delete i.virtual.cache[e[n]],
                                            Object.keys(i.virtual.cache).forEach((t) => {
                                                t > e && ((i.virtual.cache[t - 1] = i.virtual.cache[t]), i.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1), delete i.virtual.cache[t]);
                                            })),
                                            i.virtual.slides.splice(e[n], 1),
                                            e[n] < t && (t -= 1),
                                            (t = Math.max(t, 0));
                                else
                                    i.params.virtual.cache &&
                                        (delete i.virtual.cache[e],
                                        Object.keys(i.virtual.cache).forEach((t) => {
                                            t > e && ((i.virtual.cache[t - 1] = i.virtual.cache[t]), i.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1), delete i.virtual.cache[t]);
                                        })),
                                        i.virtual.slides.splice(e, 1),
                                        e < t && (t -= 1),
                                        (t = Math.max(t, 0));
                                d(!0), i.slideTo(t, 0);
                            },
                            removeAllSlides: function () {
                                (i.virtual.slides = []), i.params.virtual.cache && (i.virtual.cache = {}), d(!0), i.slideTo(0, 0);
                            },
                            update: d,
                        });
                }
                function o(e) {
                    let { swiper: t, extendParams: i, on: s, emit: o } = e;
                    const a = (0, n.g)(),
                        l = (0, n.a)();
                    function c(e) {
                        if (!t.enabled) return;
                        const { rtlTranslate: i } = t;
                        let n = e;
                        n.originalEvent && (n = n.originalEvent);
                        const s = n.keyCode || n.charCode,
                            c = t.params.keyboard.pageUpDown,
                            u = c && 33 === s,
                            d = c && 34 === s,
                            h = 37 === s,
                            f = 39 === s,
                            p = 38 === s,
                            m = 40 === s;
                        if (!t.allowSlideNext && ((t.isHorizontal() && f) || (t.isVertical() && m) || d)) return !1;
                        if (!t.allowSlidePrev && ((t.isHorizontal() && h) || (t.isVertical() && p) || u)) return !1;
                        if (
                            !(
                                n.shiftKey ||
                                n.altKey ||
                                n.ctrlKey ||
                                n.metaKey ||
                                (a.activeElement && a.activeElement.nodeName && ("input" === a.activeElement.nodeName.toLowerCase() || "textarea" === a.activeElement.nodeName.toLowerCase()))
                            )
                        ) {
                            if (t.params.keyboard.onlyInViewport && (u || d || h || f || p || m)) {
                                let e = !1;
                                if ((0, r.a)(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 && 0 === (0, r.a)(t.el, `.${t.params.slideActiveClass}`).length) return;
                                const n = t.el,
                                    s = n.clientWidth,
                                    o = n.clientHeight,
                                    a = l.innerWidth,
                                    c = l.innerHeight,
                                    u = (0, r.b)(n);
                                i && (u.left -= n.scrollLeft);
                                const d = [
                                    [u.left, u.top],
                                    [u.left + s, u.top],
                                    [u.left, u.top + o],
                                    [u.left + s, u.top + o],
                                ];
                                for (let t = 0; t < d.length; t += 1) {
                                    const i = d[t];
                                    if (i[0] >= 0 && i[0] <= a && i[1] >= 0 && i[1] <= c) {
                                        if (0 === i[0] && 0 === i[1]) continue;
                                        e = !0;
                                    }
                                }
                                if (!e) return;
                            }
                            t.isHorizontal()
                                ? ((u || d || h || f) && (n.preventDefault ? n.preventDefault() : (n.returnValue = !1)), (((d || f) && !i) || ((u || h) && i)) && t.slideNext(), (((u || h) && !i) || ((d || f) && i)) && t.slidePrev())
                                : ((u || d || p || m) && (n.preventDefault ? n.preventDefault() : (n.returnValue = !1)), (d || m) && t.slideNext(), (u || p) && t.slidePrev()),
                                o("keyPress", s);
                        }
                    }
                    function u() {
                        t.keyboard.enabled || (a.addEventListener("keydown", c), (t.keyboard.enabled = !0));
                    }
                    function d() {
                        t.keyboard.enabled && (a.removeEventListener("keydown", c), (t.keyboard.enabled = !1));
                    }
                    (t.keyboard = { enabled: !1 }),
                        i({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
                        s("init", () => {
                            t.params.keyboard.enabled && u();
                        }),
                        s("destroy", () => {
                            t.keyboard.enabled && d();
                        }),
                        Object.assign(t.keyboard, { enable: u, disable: d });
                }
                function a(e) {
                    let { swiper: t, extendParams: i, on: s, emit: o } = e;
                    const a = (0, n.a)();
                    let l;
                    i({ mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }),
                        (t.mousewheel = { enabled: !1 });
                    let c,
                        u = (0, r.d)();
                    const d = [];
                    function h() {
                        t.enabled && (t.mouseEntered = !0);
                    }
                    function f() {
                        t.enabled && (t.mouseEntered = !1);
                    }
                    function p(e) {
                        return !(
                            (t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) ||
                            (t.params.mousewheel.thresholdTime && (0, r.d)() - u < t.params.mousewheel.thresholdTime) ||
                            (!(e.delta >= 6 && (0, r.d)() - u < 60) &&
                                (e.direction < 0 ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), o("scroll", e.raw)) : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), o("scroll", e.raw)),
                                (u = new a.Date().getTime()),
                                1))
                        );
                    }
                    function m(e) {
                        let i = e,
                            n = !0;
                        if (!t.enabled) return;
                        if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return;
                        const s = t.params.mousewheel;
                        t.params.cssMode && i.preventDefault();
                        let a = t.el;
                        "container" !== t.params.mousewheel.eventsTarget && (a = document.querySelector(t.params.mousewheel.eventsTarget));
                        const u = a && a.contains(i.target);
                        if (!t.mouseEntered && !u && !s.releaseOnEdges) return !0;
                        i.originalEvent && (i = i.originalEvent);
                        let h = 0;
                        const f = t.rtlTranslate ? -1 : 1,
                            m = (function (e) {
                                let t = 0,
                                    i = 0,
                                    n = 0,
                                    r = 0;
                                return (
                                    "detail" in e && (i = e.detail),
                                    "wheelDelta" in e && (i = -e.wheelDelta / 120),
                                    "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120),
                                    "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                                    "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = i), (i = 0)),
                                    (n = 10 * t),
                                    (r = 10 * i),
                                    "deltaY" in e && (r = e.deltaY),
                                    "deltaX" in e && (n = e.deltaX),
                                    e.shiftKey && !n && ((n = r), (r = 0)),
                                    (n || r) && e.deltaMode && (1 === e.deltaMode ? ((n *= 40), (r *= 40)) : ((n *= 800), (r *= 800))),
                                    n && !t && (t = n < 1 ? -1 : 1),
                                    r && !i && (i = r < 1 ? -1 : 1),
                                    { spinX: t, spinY: i, pixelX: n, pixelY: r }
                                );
                            })(i);
                        if (s.forceToAxis)
                            if (t.isHorizontal()) {
                                if (!(Math.abs(m.pixelX) > Math.abs(m.pixelY))) return !0;
                                h = -m.pixelX * f;
                            } else {
                                if (!(Math.abs(m.pixelY) > Math.abs(m.pixelX))) return !0;
                                h = -m.pixelY;
                            }
                        else h = Math.abs(m.pixelX) > Math.abs(m.pixelY) ? -m.pixelX * f : -m.pixelY;
                        if (0 === h) return !0;
                        s.invert && (h = -h);
                        let g = t.getTranslate() + h * s.sensitivity;
                        if (
                            (g >= t.minTranslate() && (g = t.minTranslate()),
                            g <= t.maxTranslate() && (g = t.maxTranslate()),
                            (n = !!t.params.loop || !(g === t.minTranslate() || g === t.maxTranslate())),
                            n && t.params.nested && i.stopPropagation(),
                            t.params.freeMode && t.params.freeMode.enabled)
                        ) {
                            const e = { time: (0, r.d)(), delta: Math.abs(h), direction: Math.sign(h) },
                                n = c && e.time < c.time + 500 && e.delta <= c.delta && e.direction === c.direction;
                            if (!n) {
                                c = void 0;
                                let a = t.getTranslate() + h * s.sensitivity;
                                const u = t.isBeginning,
                                    f = t.isEnd;
                                if (
                                    (a >= t.minTranslate() && (a = t.minTranslate()),
                                    a <= t.maxTranslate() && (a = t.maxTranslate()),
                                    t.setTransition(0),
                                    t.setTranslate(a),
                                    t.updateProgress(),
                                    t.updateActiveIndex(),
                                    t.updateSlidesClasses(),
                                    ((!u && t.isBeginning) || (!f && t.isEnd)) && t.updateSlidesClasses(),
                                    t.params.loop && t.loopFix({ direction: e.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
                                    t.params.freeMode.sticky)
                                ) {
                                    clearTimeout(l), (l = void 0), d.length >= 15 && d.shift();
                                    const i = d.length ? d[d.length - 1] : void 0,
                                        n = d[0];
                                    if ((d.push(e), i && (e.delta > i.delta || e.direction !== i.direction))) d.splice(0);
                                    else if (d.length >= 15 && e.time - n.time < 500 && n.delta - e.delta >= 1 && e.delta <= 6) {
                                        const i = h > 0 ? 0.8 : 0.2;
                                        (c = e),
                                            d.splice(0),
                                            (l = (0, r.n)(() => {
                                                t.slideToClosest(t.params.speed, !0, void 0, i);
                                            }, 0));
                                    }
                                    l ||
                                        (l = (0, r.n)(() => {
                                            (c = e), d.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                                        }, 500));
                                }
                                if ((n || o("scroll", i), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), s.releaseOnEdges && (a === t.minTranslate() || a === t.maxTranslate()))) return !0;
                            }
                        } else {
                            const i = { time: (0, r.d)(), delta: Math.abs(h), direction: Math.sign(h), raw: e };
                            d.length >= 2 && d.shift();
                            const n = d.length ? d[d.length - 1] : void 0;
                            if (
                                (d.push(i),
                                n ? (i.direction !== n.direction || i.delta > n.delta || i.time > n.time + 150) && p(i) : p(i),
                                (function (e) {
                                    const i = t.params.mousewheel;
                                    if (e.direction < 0) {
                                        if (t.isEnd && !t.params.loop && i.releaseOnEdges) return !0;
                                    } else if (t.isBeginning && !t.params.loop && i.releaseOnEdges) return !0;
                                    return !1;
                                })(i))
                            )
                                return !0;
                        }
                        return i.preventDefault ? i.preventDefault() : (i.returnValue = !1), !1;
                    }
                    function g(e) {
                        let i = t.el;
                        "container" !== t.params.mousewheel.eventsTarget && (i = document.querySelector(t.params.mousewheel.eventsTarget)), i[e]("mouseenter", h), i[e]("mouseleave", f), i[e]("wheel", m);
                    }
                    function v() {
                        return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", m), !0) : !t.mousewheel.enabled && (g("addEventListener"), (t.mousewheel.enabled = !0), !0);
                    }
                    function b() {
                        return t.params.cssMode ? (t.wrapperEl.addEventListener(event, m), !0) : !!t.mousewheel.enabled && (g("removeEventListener"), (t.mousewheel.enabled = !1), !0);
                    }
                    s("init", () => {
                        !t.params.mousewheel.enabled && t.params.cssMode && b(), t.params.mousewheel.enabled && v();
                    }),
                        s("destroy", () => {
                            t.params.cssMode && v(), t.mousewheel.enabled && b();
                        }),
                        Object.assign(t.mousewheel, { enable: v, disable: b });
                }
                function l(e, t, i, n) {
                    return (
                        e.params.createElements &&
                            Object.keys(n).forEach((s) => {
                                if (!i[s] && !0 === i.auto) {
                                    let o = (0, r.e)(e.el, `.${n[s]}`)[0];
                                    o || ((o = (0, r.c)("div", n[s])), (o.className = n[s]), e.el.append(o)), (i[s] = o), (t[s] = o);
                                }
                            }),
                        i
                    );
                }
                function c(e) {
                    let { swiper: t, extendParams: i, on: n, emit: r } = e;
                    i({
                        navigation: {
                            nextEl: null,
                            prevEl: null,
                            hideOnClick: !1,
                            disabledClass: "swiper-button-disabled",
                            hiddenClass: "swiper-button-hidden",
                            lockClass: "swiper-button-lock",
                            navigationDisabledClass: "swiper-navigation-disabled",
                        },
                    }),
                        (t.navigation = { nextEl: null, prevEl: null });
                    const s = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                    function o(e) {
                        let i;
                        return e && "string" == typeof e && t.isElement && ((i = t.el.querySelector(e)), i)
                            ? i
                            : (e &&
                                  ("string" == typeof e && (i = [...document.querySelectorAll(e)]), t.params.uniqueNavElements && "string" == typeof e && i.length > 1 && 1 === t.el.querySelectorAll(e).length && (i = t.el.querySelector(e))),
                              e && !i ? e : i);
                    }
                    function a(e, i) {
                        const n = t.params.navigation;
                        (e = s(e)).forEach((e) => {
                            e && (e.classList[i ? "add" : "remove"](...n.disabledClass.split(" ")), "BUTTON" === e.tagName && (e.disabled = i), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](n.lockClass));
                        });
                    }
                    function c() {
                        const { nextEl: e, prevEl: i } = t.navigation;
                        if (t.params.loop) return a(i, !1), void a(e, !1);
                        a(i, t.isBeginning && !t.params.rewind), a(e, t.isEnd && !t.params.rewind);
                    }
                    function u(e) {
                        e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), r("navigationPrev"));
                    }
                    function d(e) {
                        e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), r("navigationNext"));
                    }
                    function h() {
                        const e = t.params.navigation;
                        if (((t.params.navigation = l(t, t.originalParams.navigation, t.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !e.nextEl && !e.prevEl)) return;
                        let i = o(e.nextEl),
                            n = o(e.prevEl);
                        Object.assign(t.navigation, { nextEl: i, prevEl: n }), (i = s(i)), (n = s(n));
                        const r = (i, n) => {
                            i && i.addEventListener("click", "next" === n ? d : u), !t.enabled && i && i.classList.add(...e.lockClass.split(" "));
                        };
                        i.forEach((e) => r(e, "next")), n.forEach((e) => r(e, "prev"));
                    }
                    function f() {
                        let { nextEl: e, prevEl: i } = t.navigation;
                        (e = s(e)), (i = s(i));
                        const n = (e, i) => {
                            e.removeEventListener("click", "next" === i ? d : u), e.classList.remove(...t.params.navigation.disabledClass.split(" "));
                        };
                        e.forEach((e) => n(e, "next")), i.forEach((e) => n(e, "prev"));
                    }
                    n("init", () => {
                        !1 === t.params.navigation.enabled ? p() : (h(), c());
                    }),
                        n("toEdge fromEdge lock unlock", () => {
                            c();
                        }),
                        n("destroy", () => {
                            f();
                        }),
                        n("enable disable", () => {
                            let { nextEl: e, prevEl: i } = t.navigation;
                            (e = s(e)), (i = s(i)), t.enabled ? c() : [...e, ...i].filter((e) => !!e).forEach((e) => e.classList.add(t.params.navigation.lockClass));
                        }),
                        n("click", (e, i) => {
                            let { nextEl: n, prevEl: o } = t.navigation;
                            (n = s(n)), (o = s(o));
                            const a = i.target;
                            if (t.params.navigation.hideOnClick && !o.includes(a) && !n.includes(a)) {
                                if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === a || t.pagination.el.contains(a))) return;
                                let e;
                                n.length ? (e = n[0].classList.contains(t.params.navigation.hiddenClass)) : o.length && (e = o[0].classList.contains(t.params.navigation.hiddenClass)),
                                    r(!0 === e ? "navigationShow" : "navigationHide"),
                                    [...n, ...o].filter((e) => !!e).forEach((e) => e.classList.toggle(t.params.navigation.hiddenClass));
                            }
                        });
                    const p = () => {
                        t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), f();
                    };
                    Object.assign(t.navigation, {
                        enable: () => {
                            t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), h(), c();
                        },
                        disable: p,
                        update: c,
                        init: h,
                        destroy: f,
                    });
                }
                function u(e) {
                    return (
                        void 0 === e && (e = ""),
                        `.${e
                            .trim()
                            .replace(/([\.:!+\/])/g, "\\$1")
                            .replace(/ /g, ".")}`
                    );
                }
                function d(e) {
                    let { swiper: t, extendParams: i, on: n, emit: s } = e;
                    const o = "swiper-pagination";
                    let a;
                    i({
                        pagination: {
                            el: null,
                            bulletElement: "span",
                            clickable: !1,
                            hideOnClick: !1,
                            renderBullet: null,
                            renderProgressbar: null,
                            renderFraction: null,
                            renderCustom: null,
                            progressbarOpposite: !1,
                            type: "bullets",
                            dynamicBullets: !1,
                            dynamicMainBullets: 1,
                            formatFractionCurrent: (e) => e,
                            formatFractionTotal: (e) => e,
                            bulletClass: `${o}-bullet`,
                            bulletActiveClass: `${o}-bullet-active`,
                            modifierClass: `${o}-`,
                            currentClass: `${o}-current`,
                            totalClass: `${o}-total`,
                            hiddenClass: `${o}-hidden`,
                            progressbarFillClass: `${o}-progressbar-fill`,
                            progressbarOppositeClass: `${o}-progressbar-opposite`,
                            clickableClass: `${o}-clickable`,
                            lockClass: `${o}-lock`,
                            horizontalClass: `${o}-horizontal`,
                            verticalClass: `${o}-vertical`,
                            paginationDisabledClass: `${o}-disabled`,
                        },
                    }),
                        (t.pagination = { el: null, bullets: [] });
                    let c = 0;
                    const d = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                    function h() {
                        return !t.params.pagination.el || !t.pagination.el || (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length);
                    }
                    function f(e, i) {
                        const { bulletActiveClass: n } = t.params.pagination;
                        e && (e = e[("prev" === i ? "previous" : "next") + "ElementSibling"]) && (e.classList.add(`${n}-${i}`), (e = e[("prev" === i ? "previous" : "next") + "ElementSibling"]) && e.classList.add(`${n}-${i}-${i}`));
                    }
                    function p(e) {
                        const i = e.target.closest(u(t.params.pagination.bulletClass));
                        if (!i) return;
                        e.preventDefault();
                        const n = (0, r.g)(i) * t.params.slidesPerGroup;
                        if (t.params.loop) {
                            if (t.realIndex === n) return;
                            t.slideToLoop(n);
                        } else t.slideTo(n);
                    }
                    function m() {
                        const e = t.rtl,
                            i = t.params.pagination;
                        if (h()) return;
                        let n,
                            o,
                            l = t.pagination.el;
                        l = d(l);
                        const p = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                            m = t.params.loop ? Math.ceil(p / t.params.slidesPerGroup) : t.snapGrid.length;
                        if (
                            (t.params.loop
                                ? ((o = t.previousRealIndex || 0), (n = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex))
                                : void 0 !== t.snapIndex
                                ? ((n = t.snapIndex), (o = t.previousSnapIndex))
                                : ((o = t.previousIndex || 0), (n = t.activeIndex || 0)),
                            "bullets" === i.type && t.pagination.bullets && t.pagination.bullets.length > 0)
                        ) {
                            const s = t.pagination.bullets;
                            let u, d, h;
                            if (
                                (i.dynamicBullets &&
                                    ((a = (0, r.f)(s[0], t.isHorizontal() ? "width" : "height", !0)),
                                    l.forEach((e) => {
                                        e.style[t.isHorizontal() ? "width" : "height"] = a * (i.dynamicMainBullets + 4) + "px";
                                    }),
                                    i.dynamicMainBullets > 1 && void 0 !== o && ((c += n - (o || 0)), c > i.dynamicMainBullets - 1 ? (c = i.dynamicMainBullets - 1) : c < 0 && (c = 0)),
                                    (u = Math.max(n - c, 0)),
                                    (d = u + (Math.min(s.length, i.dynamicMainBullets) - 1)),
                                    (h = (d + u) / 2)),
                                s.forEach((e) => {
                                    const t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${i.bulletActiveClass}${e}`)].map((e) => ("string" == typeof e && e.includes(" ") ? e.split(" ") : e)).flat();
                                    e.classList.remove(...t);
                                }),
                                l.length > 1)
                            )
                                s.forEach((e) => {
                                    const s = (0, r.g)(e);
                                    s === n ? e.classList.add(...i.bulletActiveClass.split(" ")) : t.isElement && e.setAttribute("part", "bullet"),
                                        i.dynamicBullets && (s >= u && s <= d && e.classList.add(...`${i.bulletActiveClass}-main`.split(" ")), s === u && f(e, "prev"), s === d && f(e, "next"));
                                });
                            else {
                                const e = s[n];
                                if (
                                    (e && e.classList.add(...i.bulletActiveClass.split(" ")),
                                    t.isElement &&
                                        s.forEach((e, t) => {
                                            e.setAttribute("part", t === n ? "bullet-active" : "bullet");
                                        }),
                                    i.dynamicBullets)
                                ) {
                                    const e = s[u],
                                        t = s[d];
                                    for (let e = u; e <= d; e += 1) s[e] && s[e].classList.add(...`${i.bulletActiveClass}-main`.split(" "));
                                    f(e, "prev"), f(t, "next");
                                }
                            }
                            if (i.dynamicBullets) {
                                const n = Math.min(s.length, i.dynamicMainBullets + 4),
                                    r = (a * n - a) / 2 - h * a,
                                    o = e ? "right" : "left";
                                s.forEach((e) => {
                                    e.style[t.isHorizontal() ? o : "top"] = `${r}px`;
                                });
                            }
                        }
                        l.forEach((e, r) => {
                            if (
                                ("fraction" === i.type &&
                                    (e.querySelectorAll(u(i.currentClass)).forEach((e) => {
                                        e.textContent = i.formatFractionCurrent(n + 1);
                                    }),
                                    e.querySelectorAll(u(i.totalClass)).forEach((e) => {
                                        e.textContent = i.formatFractionTotal(m);
                                    })),
                                "progressbar" === i.type)
                            ) {
                                let r;
                                r = i.progressbarOpposite ? (t.isHorizontal() ? "vertical" : "horizontal") : t.isHorizontal() ? "horizontal" : "vertical";
                                const s = (n + 1) / m;
                                let o = 1,
                                    a = 1;
                                "horizontal" === r ? (o = s) : (a = s),
                                    e.querySelectorAll(u(i.progressbarFillClass)).forEach((e) => {
                                        (e.style.transform = `translate3d(0,0,0) scaleX(${o}) scaleY(${a})`), (e.style.transitionDuration = `${t.params.speed}ms`);
                                    });
                            }
                            "custom" === i.type && i.renderCustom ? ((e.innerHTML = i.renderCustom(t, n + 1, m)), 0 === r && s("paginationRender", e)) : (0 === r && s("paginationRender", e), s("paginationUpdate", e)),
                                t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](i.lockClass);
                        });
                    }
                    function g() {
                        const e = t.params.pagination;
                        if (h()) return;
                        const i = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
                        let n = t.pagination.el;
                        n = d(n);
                        let r = "";
                        if ("bullets" === e.type) {
                            let n = t.params.loop ? Math.ceil(i / t.params.slidesPerGroup) : t.snapGrid.length;
                            t.params.freeMode && t.params.freeMode.enabled && n > i && (n = i);
                            for (let i = 0; i < n; i += 1) e.renderBullet ? (r += e.renderBullet.call(t, i, e.bulletClass)) : (r += `<${e.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`);
                        }
                        "fraction" === e.type && (r = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
                            "progressbar" === e.type && (r = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`),
                            (t.pagination.bullets = []),
                            n.forEach((i) => {
                                "custom" !== e.type && (i.innerHTML = r || ""), "bullets" === e.type && t.pagination.bullets.push(...i.querySelectorAll(u(e.bulletClass)));
                            }),
                            "custom" !== e.type && s("paginationRender", n[0]);
                    }
                    function v() {
                        t.params.pagination = l(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
                        const e = t.params.pagination;
                        if (!e.el) return;
                        let i;
                        "string" == typeof e.el && t.isElement && (i = t.el.querySelector(e.el)),
                            i || "string" != typeof e.el || (i = [...document.querySelectorAll(e.el)]),
                            i || (i = e.el),
                            i &&
                                0 !== i.length &&
                                (t.params.uniqueNavElements &&
                                    "string" == typeof e.el &&
                                    Array.isArray(i) &&
                                    i.length > 1 &&
                                    ((i = [...t.el.querySelectorAll(e.el)]), i.length > 1 && (i = i.filter((e) => (0, r.a)(e, ".swiper")[0] === t.el)[0])),
                                Array.isArray(i) && 1 === i.length && (i = i[0]),
                                Object.assign(t.pagination, { el: i }),
                                (i = d(i)),
                                i.forEach((i) => {
                                    "bullets" === e.type && e.clickable && i.classList.add(...(e.clickableClass || "").split(" ")),
                                        i.classList.add(e.modifierClass + e.type),
                                        i.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                                        "bullets" === e.type && e.dynamicBullets && (i.classList.add(`${e.modifierClass}${e.type}-dynamic`), (c = 0), e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                                        "progressbar" === e.type && e.progressbarOpposite && i.classList.add(e.progressbarOppositeClass),
                                        e.clickable && i.addEventListener("click", p),
                                        t.enabled || i.classList.add(e.lockClass);
                                }));
                    }
                    function b() {
                        const e = t.params.pagination;
                        if (h()) return;
                        let i = t.pagination.el;
                        i &&
                            ((i = d(i)),
                            i.forEach((i) => {
                                i.classList.remove(e.hiddenClass),
                                    i.classList.remove(e.modifierClass + e.type),
                                    i.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                                    e.clickable && (i.classList.remove(...(e.clickableClass || "").split(" ")), i.removeEventListener("click", p));
                            })),
                            t.pagination.bullets && t.pagination.bullets.forEach((t) => t.classList.remove(...e.bulletActiveClass.split(" ")));
                    }
                    n("changeDirection", () => {
                        if (!t.pagination || !t.pagination.el) return;
                        const e = t.params.pagination;
                        let { el: i } = t.pagination;
                        (i = d(i)),
                            i.forEach((i) => {
                                i.classList.remove(e.horizontalClass, e.verticalClass), i.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
                            });
                    }),
                        n("init", () => {
                            !1 === t.params.pagination.enabled ? y() : (v(), g(), m());
                        }),
                        n("activeIndexChange", () => {
                            void 0 === t.snapIndex && m();
                        }),
                        n("snapIndexChange", () => {
                            m();
                        }),
                        n("snapGridLengthChange", () => {
                            g(), m();
                        }),
                        n("destroy", () => {
                            b();
                        }),
                        n("enable disable", () => {
                            let { el: e } = t.pagination;
                            e && ((e = d(e)), e.forEach((e) => e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
                        }),
                        n("lock unlock", () => {
                            m();
                        }),
                        n("click", (e, i) => {
                            const n = i.target,
                                r = d(t.pagination.el);
                            if (t.params.pagination.el && t.params.pagination.hideOnClick && r && r.length > 0 && !n.classList.contains(t.params.pagination.bulletClass)) {
                                if (t.navigation && ((t.navigation.nextEl && n === t.navigation.nextEl) || (t.navigation.prevEl && n === t.navigation.prevEl))) return;
                                const e = r[0].classList.contains(t.params.pagination.hiddenClass);
                                s(!0 === e ? "paginationShow" : "paginationHide"), r.forEach((e) => e.classList.toggle(t.params.pagination.hiddenClass));
                            }
                        });
                    const y = () => {
                        t.el.classList.add(t.params.pagination.paginationDisabledClass);
                        let { el: e } = t.pagination;
                        e && ((e = d(e)), e.forEach((e) => e.classList.add(t.params.pagination.paginationDisabledClass))), b();
                    };
                    Object.assign(t.pagination, {
                        enable: () => {
                            t.el.classList.remove(t.params.pagination.paginationDisabledClass);
                            let { el: e } = t.pagination;
                            e && ((e = d(e)), e.forEach((e) => e.classList.remove(t.params.pagination.paginationDisabledClass))), v(), g(), m();
                        },
                        disable: y,
                        render: g,
                        update: m,
                        init: v,
                        destroy: b,
                    });
                }
                function h(e) {
                    let { swiper: t, extendParams: i, on: s, emit: o } = e;
                    const a = (0, n.g)();
                    let c,
                        d,
                        h,
                        f,
                        p = !1,
                        m = null,
                        g = null;
                    function v() {
                        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
                        const { scrollbar: e, rtlTranslate: i } = t,
                            { dragEl: n, el: r } = e,
                            s = t.params.scrollbar,
                            o = t.params.loop ? t.progressLoop : t.progress;
                        let a = d,
                            l = (h - d) * o;
                        i ? ((l = -l), l > 0 ? ((a = d - l), (l = 0)) : -l + d > h && (a = h + l)) : l < 0 ? ((a = d + l), (l = 0)) : l + d > h && (a = h - l),
                            t.isHorizontal() ? ((n.style.transform = `translate3d(${l}px, 0, 0)`), (n.style.width = `${a}px`)) : ((n.style.transform = `translate3d(0px, ${l}px, 0)`), (n.style.height = `${a}px`)),
                            s.hide &&
                                (clearTimeout(m),
                                (r.style.opacity = 1),
                                (m = setTimeout(() => {
                                    (r.style.opacity = 0), (r.style.transitionDuration = "400ms");
                                }, 1e3)));
                    }
                    function b() {
                        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
                        const { scrollbar: e } = t,
                            { dragEl: i, el: n } = e;
                        (i.style.width = ""),
                            (i.style.height = ""),
                            (h = t.isHorizontal() ? n.offsetWidth : n.offsetHeight),
                            (f = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0))),
                            (d = "auto" === t.params.scrollbar.dragSize ? h * f : parseInt(t.params.scrollbar.dragSize, 10)),
                            t.isHorizontal() ? (i.style.width = `${d}px`) : (i.style.height = `${d}px`),
                            (n.style.display = f >= 1 ? "none" : ""),
                            t.params.scrollbar.hide && (n.style.opacity = 0),
                            t.params.watchOverflow && t.enabled && e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
                    }
                    function y(e) {
                        return t.isHorizontal() ? e.clientX : e.clientY;
                    }
                    function w(e) {
                        const { scrollbar: i, rtlTranslate: n } = t,
                            { el: s } = i;
                        let o;
                        (o = (y(e) - (0, r.b)(s)[t.isHorizontal() ? "left" : "top"] - (null !== c ? c : d / 2)) / (h - d)), (o = Math.max(Math.min(o, 1), 0)), n && (o = 1 - o);
                        const a = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * o;
                        t.updateProgress(a), t.setTranslate(a), t.updateActiveIndex(), t.updateSlidesClasses();
                    }
                    function x(e) {
                        const i = t.params.scrollbar,
                            { scrollbar: n, wrapperEl: r } = t,
                            { el: s, dragEl: a } = n;
                        (p = !0),
                            (c = e.target === a ? y(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
                            e.preventDefault(),
                            e.stopPropagation(),
                            (r.style.transitionDuration = "100ms"),
                            (a.style.transitionDuration = "100ms"),
                            w(e),
                            clearTimeout(g),
                            (s.style.transitionDuration = "0ms"),
                            i.hide && (s.style.opacity = 1),
                            t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
                            o("scrollbarDragStart", e);
                    }
                    function S(e) {
                        const { scrollbar: i, wrapperEl: n } = t,
                            { el: r, dragEl: s } = i;
                        p && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), w(e), (n.style.transitionDuration = "0ms"), (r.style.transitionDuration = "0ms"), (s.style.transitionDuration = "0ms"), o("scrollbarDragMove", e));
                    }
                    function E(e) {
                        const i = t.params.scrollbar,
                            { scrollbar: n, wrapperEl: s } = t,
                            { el: a } = n;
                        p &&
                            ((p = !1),
                            t.params.cssMode && ((t.wrapperEl.style["scroll-snap-type"] = ""), (s.style.transitionDuration = "")),
                            i.hide &&
                                (clearTimeout(g),
                                (g = (0, r.n)(() => {
                                    (a.style.opacity = 0), (a.style.transitionDuration = "400ms");
                                }, 1e3))),
                            o("scrollbarDragEnd", e),
                            i.snapOnRelease && t.slideToClosest());
                    }
                    function _(e) {
                        const { scrollbar: i, params: n } = t,
                            r = i.el;
                        if (!r) return;
                        const s = r,
                            o = !!n.passiveListeners && { passive: !1, capture: !1 },
                            l = !!n.passiveListeners && { passive: !0, capture: !1 };
                        if (!s) return;
                        const c = "on" === e ? "addEventListener" : "removeEventListener";
                        s[c]("pointerdown", x, o), a[c]("pointermove", S, o), a[c]("pointerup", E, l);
                    }
                    function T() {
                        const { scrollbar: e, el: i } = t;
                        t.params.scrollbar = l(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
                        const n = t.params.scrollbar;
                        if (!n.el) return;
                        let s, o;
                        if (("string" == typeof n.el && t.isElement && (s = t.el.querySelector(n.el)), s || "string" != typeof n.el)) s || (s = n.el);
                        else if (((s = a.querySelectorAll(n.el)), !s.length)) return;
                        t.params.uniqueNavElements && "string" == typeof n.el && s.length > 1 && 1 === i.querySelectorAll(n.el).length && (s = i.querySelector(n.el)),
                            s.length > 0 && (s = s[0]),
                            s.classList.add(t.isHorizontal() ? n.horizontalClass : n.verticalClass),
                            s && ((o = s.querySelector(u(t.params.scrollbar.dragClass))), o || ((o = (0, r.c)("div", t.params.scrollbar.dragClass)), s.append(o))),
                            Object.assign(e, { el: s, dragEl: o }),
                            n.draggable && t.params.scrollbar.el && t.scrollbar.el && _("on"),
                            s && s.classList[t.enabled ? "remove" : "add"](...(0, r.h)(t.params.scrollbar.lockClass));
                    }
                    function M() {
                        const e = t.params.scrollbar,
                            i = t.scrollbar.el;
                        i && i.classList.remove(...(0, r.h)(t.isHorizontal() ? e.horizontalClass : e.verticalClass)), t.params.scrollbar.el && t.scrollbar.el && _("off");
                    }
                    i({
                        scrollbar: {
                            el: null,
                            dragSize: "auto",
                            hide: !1,
                            draggable: !1,
                            snapOnRelease: !0,
                            lockClass: "swiper-scrollbar-lock",
                            dragClass: "swiper-scrollbar-drag",
                            scrollbarDisabledClass: "swiper-scrollbar-disabled",
                            horizontalClass: "swiper-scrollbar-horizontal",
                            verticalClass: "swiper-scrollbar-vertical",
                        },
                    }),
                        (t.scrollbar = { el: null, dragEl: null }),
                        s("init", () => {
                            !1 === t.params.scrollbar.enabled ? P() : (T(), b(), v());
                        }),
                        s("update resize observerUpdate lock unlock", () => {
                            b();
                        }),
                        s("setTranslate", () => {
                            v();
                        }),
                        s("setTransition", (e, i) => {
                            !(function (e) {
                                t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
                            })(i);
                        }),
                        s("enable disable", () => {
                            const { el: e } = t.scrollbar;
                            e && e.classList[t.enabled ? "remove" : "add"](...(0, r.h)(t.params.scrollbar.lockClass));
                        }),
                        s("destroy", () => {
                            M();
                        });
                    const P = () => {
                        t.el.classList.add(...(0, r.h)(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.add(...(0, r.h)(t.params.scrollbar.scrollbarDisabledClass)), M();
                    };
                    Object.assign(t.scrollbar, {
                        enable: () => {
                            t.el.classList.remove(...(0, r.h)(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.remove(...(0, r.h)(t.params.scrollbar.scrollbarDisabledClass)), T(), b(), v();
                        },
                        disable: P,
                        updateSize: b,
                        setTranslate: v,
                        init: T,
                        destroy: M,
                    });
                }
                function f(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ parallax: { enabled: !1 } });
                    const s = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
                        o = (e, i) => {
                            const { rtl: n } = t,
                                r = n ? -1 : 1,
                                s = e.getAttribute("data-swiper-parallax") || "0";
                            let o = e.getAttribute("data-swiper-parallax-x"),
                                a = e.getAttribute("data-swiper-parallax-y");
                            const l = e.getAttribute("data-swiper-parallax-scale"),
                                c = e.getAttribute("data-swiper-parallax-opacity"),
                                u = e.getAttribute("data-swiper-parallax-rotate");
                            if (
                                (o || a ? ((o = o || "0"), (a = a || "0")) : t.isHorizontal() ? ((o = s), (a = "0")) : ((a = s), (o = "0")),
                                (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * i * r + "%" : o * i * r + "px"),
                                (a = a.indexOf("%") >= 0 ? parseInt(a, 10) * i + "%" : a * i + "px"),
                                null != c)
                            ) {
                                const t = c - (c - 1) * (1 - Math.abs(i));
                                e.style.opacity = t;
                            }
                            let d = `translate3d(${o}, ${a}, 0px)`;
                            null != l && (d += ` scale(${l - (l - 1) * (1 - Math.abs(i))})`), u && null != u && (d += ` rotate(${u * i * -1}deg)`), (e.style.transform = d);
                        },
                        a = () => {
                            const { el: e, slides: i, progress: n, snapGrid: a, isElement: l } = t,
                                c = (0, r.e)(e, s);
                            t.isElement && c.push(...(0, r.e)(t.hostEl, s)),
                                c.forEach((e) => {
                                    o(e, n);
                                }),
                                i.forEach((e, i) => {
                                    let r = e.progress;
                                    t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (r += Math.ceil(i / 2) - n * (a.length - 1)),
                                        (r = Math.min(Math.max(r, -1), 1)),
                                        e.querySelectorAll(`${s}, [data-swiper-parallax-rotate]`).forEach((e) => {
                                            o(e, r);
                                        });
                                });
                        };
                    n("beforeInit", () => {
                        t.params.parallax.enabled && ((t.params.watchSlidesProgress = !0), (t.originalParams.watchSlidesProgress = !0));
                    }),
                        n("init", () => {
                            t.params.parallax.enabled && a();
                        }),
                        n("setTranslate", () => {
                            t.params.parallax.enabled && a();
                        }),
                        n("setTransition", (e, i) => {
                            t.params.parallax.enabled &&
                                (function (e) {
                                    void 0 === e && (e = t.params.speed);
                                    const { el: i, hostEl: n } = t,
                                        r = [...i.querySelectorAll(s)];
                                    t.isElement && r.push(...n.querySelectorAll(s)),
                                        r.forEach((t) => {
                                            let i = parseInt(t.getAttribute("data-swiper-parallax-duration"), 10) || e;
                                            0 === e && (i = 0), (t.style.transitionDuration = `${i}ms`);
                                        });
                                })(i);
                        });
                }
                function p(e) {
                    let { swiper: t, extendParams: i, on: s, emit: o } = e;
                    const a = (0, n.a)();
                    i({ zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), (t.zoom = { enabled: !1 });
                    let l,
                        c,
                        u = 1,
                        d = !1;
                    const h = [],
                        f = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 },
                        p = {
                            isTouched: void 0,
                            isMoved: void 0,
                            currentX: void 0,
                            currentY: void 0,
                            minX: void 0,
                            minY: void 0,
                            maxX: void 0,
                            maxY: void 0,
                            width: void 0,
                            height: void 0,
                            startX: void 0,
                            startY: void 0,
                            touchesStart: {},
                            touchesCurrent: {},
                        },
                        m = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
                    let g = 1;
                    function v() {
                        if (h.length < 2) return 1;
                        const e = h[0].pageX,
                            t = h[0].pageY,
                            i = h[1].pageX,
                            n = h[1].pageY;
                        return Math.sqrt((i - e) ** 2 + (n - t) ** 2);
                    }
                    function b(e) {
                        const i = t.isElement ? "swiper-slide" : `.${t.params.slideClass}`;
                        return !!e.target.matches(i) || t.slides.filter((t) => t.contains(e.target)).length > 0;
                    }
                    function y(e) {
                        if (("mouse" === e.pointerType && h.splice(0, h.length), !b(e))) return;
                        const i = t.params.zoom;
                        if (((l = !1), (c = !1), h.push(e), !(h.length < 2))) {
                            if (((l = !0), (f.scaleStart = v()), !f.slideEl)) {
                                (f.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)), f.slideEl || (f.slideEl = t.slides[t.activeIndex]);
                                let n = f.slideEl.querySelector(`.${i.containerClass}`);
                                if ((n && (n = n.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (f.imageEl = n), (f.imageWrapEl = n ? (0, r.a)(f.imageEl, `.${i.containerClass}`)[0] : void 0), !f.imageWrapEl))
                                    return void (f.imageEl = void 0);
                                f.maxRatio = f.imageWrapEl.getAttribute("data-swiper-zoom") || i.maxRatio;
                            }
                            if (f.imageEl) {
                                const [e, t] = (function () {
                                    if (h.length < 2) return { x: null, y: null };
                                    const e = f.imageEl.getBoundingClientRect();
                                    return [(h[0].pageX + (h[1].pageX - h[0].pageX) / 2 - e.x - a.scrollX) / u, (h[0].pageY + (h[1].pageY - h[0].pageY) / 2 - e.y - a.scrollY) / u];
                                })();
                                (f.originX = e), (f.originY = t), (f.imageEl.style.transitionDuration = "0ms");
                            }
                            d = !0;
                        }
                    }
                    function w(e) {
                        if (!b(e)) return;
                        const i = t.params.zoom,
                            n = t.zoom,
                            r = h.findIndex((t) => t.pointerId === e.pointerId);
                        r >= 0 && (h[r] = e),
                            h.length < 2 ||
                                ((c = !0),
                                (f.scaleMove = v()),
                                f.imageEl &&
                                    ((n.scale = (f.scaleMove / f.scaleStart) * u),
                                    n.scale > f.maxRatio && (n.scale = f.maxRatio - 1 + (n.scale - f.maxRatio + 1) ** 0.5),
                                    n.scale < i.minRatio && (n.scale = i.minRatio + 1 - (i.minRatio - n.scale + 1) ** 0.5),
                                    (f.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`)));
                    }
                    function x(e) {
                        if (!b(e)) return;
                        if ("mouse" === e.pointerType && "pointerout" === e.type) return;
                        const i = t.params.zoom,
                            n = t.zoom,
                            r = h.findIndex((t) => t.pointerId === e.pointerId);
                        r >= 0 && h.splice(r, 1),
                            l &&
                                c &&
                                ((l = !1),
                                (c = !1),
                                f.imageEl &&
                                    ((n.scale = Math.max(Math.min(n.scale, f.maxRatio), i.minRatio)),
                                    (f.imageEl.style.transitionDuration = `${t.params.speed}ms`),
                                    (f.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`),
                                    (u = n.scale),
                                    (d = !1),
                                    n.scale > 1 && f.slideEl ? f.slideEl.classList.add(`${i.zoomedSlideClass}`) : n.scale <= 1 && f.slideEl && f.slideEl.classList.remove(`${i.zoomedSlideClass}`),
                                    1 === n.scale && ((f.originX = 0), (f.originY = 0), (f.slideEl = void 0))));
                    }
                    function S(e) {
                        if (
                            !b(e) ||
                            !(function (e) {
                                const i = `.${t.params.zoom.containerClass}`;
                                return !!e.target.matches(i) || [...t.hostEl.querySelectorAll(i)].filter((t) => t.contains(e.target)).length > 0;
                            })(e)
                        )
                            return;
                        const i = t.zoom;
                        if (!f.imageEl) return;
                        if (!p.isTouched || !f.slideEl) return;
                        p.isMoved ||
                            ((p.width = f.imageEl.offsetWidth),
                            (p.height = f.imageEl.offsetHeight),
                            (p.startX = (0, r.i)(f.imageWrapEl, "x") || 0),
                            (p.startY = (0, r.i)(f.imageWrapEl, "y") || 0),
                            (f.slideWidth = f.slideEl.offsetWidth),
                            (f.slideHeight = f.slideEl.offsetHeight),
                            (f.imageWrapEl.style.transitionDuration = "0ms"));
                        const n = p.width * i.scale,
                            s = p.height * i.scale;
                        if (n < f.slideWidth && s < f.slideHeight) return;
                        if (
                            ((p.minX = Math.min(f.slideWidth / 2 - n / 2, 0)),
                            (p.maxX = -p.minX),
                            (p.minY = Math.min(f.slideHeight / 2 - s / 2, 0)),
                            (p.maxY = -p.minY),
                            (p.touchesCurrent.x = h.length > 0 ? h[0].pageX : e.pageX),
                            (p.touchesCurrent.y = h.length > 0 ? h[0].pageY : e.pageY),
                            Math.max(Math.abs(p.touchesCurrent.x - p.touchesStart.x), Math.abs(p.touchesCurrent.y - p.touchesStart.y)) > 5 && (t.allowClick = !1),
                            !p.isMoved && !d)
                        ) {
                            if (t.isHorizontal() && ((Math.floor(p.minX) === Math.floor(p.startX) && p.touchesCurrent.x < p.touchesStart.x) || (Math.floor(p.maxX) === Math.floor(p.startX) && p.touchesCurrent.x > p.touchesStart.x)))
                                return void (p.isTouched = !1);
                            if (!t.isHorizontal() && ((Math.floor(p.minY) === Math.floor(p.startY) && p.touchesCurrent.y < p.touchesStart.y) || (Math.floor(p.maxY) === Math.floor(p.startY) && p.touchesCurrent.y > p.touchesStart.y)))
                                return void (p.isTouched = !1);
                        }
                        e.cancelable && e.preventDefault(), e.stopPropagation(), (p.isMoved = !0);
                        const o = (i.scale - u) / (f.maxRatio - t.params.zoom.minRatio),
                            { originX: a, originY: l } = f;
                        (p.currentX = p.touchesCurrent.x - p.touchesStart.x + p.startX + o * (p.width - 2 * a)),
                            (p.currentY = p.touchesCurrent.y - p.touchesStart.y + p.startY + o * (p.height - 2 * l)),
                            p.currentX < p.minX && (p.currentX = p.minX + 1 - (p.minX - p.currentX + 1) ** 0.8),
                            p.currentX > p.maxX && (p.currentX = p.maxX - 1 + (p.currentX - p.maxX + 1) ** 0.8),
                            p.currentY < p.minY && (p.currentY = p.minY + 1 - (p.minY - p.currentY + 1) ** 0.8),
                            p.currentY > p.maxY && (p.currentY = p.maxY - 1 + (p.currentY - p.maxY + 1) ** 0.8),
                            m.prevPositionX || (m.prevPositionX = p.touchesCurrent.x),
                            m.prevPositionY || (m.prevPositionY = p.touchesCurrent.y),
                            m.prevTime || (m.prevTime = Date.now()),
                            (m.x = (p.touchesCurrent.x - m.prevPositionX) / (Date.now() - m.prevTime) / 2),
                            (m.y = (p.touchesCurrent.y - m.prevPositionY) / (Date.now() - m.prevTime) / 2),
                            Math.abs(p.touchesCurrent.x - m.prevPositionX) < 2 && (m.x = 0),
                            Math.abs(p.touchesCurrent.y - m.prevPositionY) < 2 && (m.y = 0),
                            (m.prevPositionX = p.touchesCurrent.x),
                            (m.prevPositionY = p.touchesCurrent.y),
                            (m.prevTime = Date.now()),
                            (f.imageWrapEl.style.transform = `translate3d(${p.currentX}px, ${p.currentY}px,0)`);
                    }
                    function E() {
                        const e = t.zoom;
                        f.slideEl &&
                            t.activeIndex !== t.slides.indexOf(f.slideEl) &&
                            (f.imageEl && (f.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                            f.imageWrapEl && (f.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                            f.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),
                            (e.scale = 1),
                            (u = 1),
                            (f.slideEl = void 0),
                            (f.imageEl = void 0),
                            (f.imageWrapEl = void 0),
                            (f.originX = 0),
                            (f.originY = 0));
                    }
                    function _(e) {
                        const i = t.zoom,
                            n = t.params.zoom;
                        if (!f.slideEl) {
                            e && e.target && (f.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)),
                                f.slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? (f.slideEl = (0, r.e)(t.slidesEl, `.${t.params.slideActiveClass}`)[0]) : (f.slideEl = t.slides[t.activeIndex]));
                            let i = f.slideEl.querySelector(`.${n.containerClass}`);
                            i && (i = i.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (f.imageEl = i), (f.imageWrapEl = i ? (0, r.a)(f.imageEl, `.${n.containerClass}`)[0] : void 0);
                        }
                        if (!f.imageEl || !f.imageWrapEl) return;
                        let s, o, l, c, d, h, m, g, v, b, y, w, x, S, E, _, T, M;
                        t.params.cssMode && ((t.wrapperEl.style.overflow = "hidden"), (t.wrapperEl.style.touchAction = "none")),
                            f.slideEl.classList.add(`${n.zoomedSlideClass}`),
                            void 0 === p.touchesStart.x && e ? ((s = e.pageX), (o = e.pageY)) : ((s = p.touchesStart.x), (o = p.touchesStart.y));
                        const P = "number" == typeof e ? e : null;
                        1 === u && P && ((s = void 0), (o = void 0)),
                            (i.scale = P || f.imageWrapEl.getAttribute("data-swiper-zoom") || n.maxRatio),
                            (u = P || f.imageWrapEl.getAttribute("data-swiper-zoom") || n.maxRatio),
                            !e || (1 === u && P)
                                ? ((m = 0), (g = 0))
                                : ((T = f.slideEl.offsetWidth),
                                  (M = f.slideEl.offsetHeight),
                                  (l = (0, r.b)(f.slideEl).left + a.scrollX),
                                  (c = (0, r.b)(f.slideEl).top + a.scrollY),
                                  (d = l + T / 2 - s),
                                  (h = c + M / 2 - o),
                                  (v = f.imageEl.offsetWidth),
                                  (b = f.imageEl.offsetHeight),
                                  (y = v * i.scale),
                                  (w = b * i.scale),
                                  (x = Math.min(T / 2 - y / 2, 0)),
                                  (S = Math.min(M / 2 - w / 2, 0)),
                                  (E = -x),
                                  (_ = -S),
                                  (m = d * i.scale),
                                  (g = h * i.scale),
                                  m < x && (m = x),
                                  m > E && (m = E),
                                  g < S && (g = S),
                                  g > _ && (g = _)),
                            P && 1 === i.scale && ((f.originX = 0), (f.originY = 0)),
                            (f.imageWrapEl.style.transitionDuration = "300ms"),
                            (f.imageWrapEl.style.transform = `translate3d(${m}px, ${g}px,0)`),
                            (f.imageEl.style.transitionDuration = "300ms"),
                            (f.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`);
                    }
                    function T() {
                        const e = t.zoom,
                            i = t.params.zoom;
                        if (!f.slideEl) {
                            t.params.virtual && t.params.virtual.enabled && t.virtual ? (f.slideEl = (0, r.e)(t.slidesEl, `.${t.params.slideActiveClass}`)[0]) : (f.slideEl = t.slides[t.activeIndex]);
                            let e = f.slideEl.querySelector(`.${i.containerClass}`);
                            e && (e = e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (f.imageEl = e), (f.imageWrapEl = e ? (0, r.a)(f.imageEl, `.${i.containerClass}`)[0] : void 0);
                        }
                        f.imageEl &&
                            f.imageWrapEl &&
                            (t.params.cssMode && ((t.wrapperEl.style.overflow = ""), (t.wrapperEl.style.touchAction = "")),
                            (e.scale = 1),
                            (u = 1),
                            (f.imageWrapEl.style.transitionDuration = "300ms"),
                            (f.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                            (f.imageEl.style.transitionDuration = "300ms"),
                            (f.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                            f.slideEl.classList.remove(`${i.zoomedSlideClass}`),
                            (f.slideEl = void 0),
                            (f.originX = 0),
                            (f.originY = 0));
                    }
                    function M(e) {
                        const i = t.zoom;
                        i.scale && 1 !== i.scale ? T() : _(e);
                    }
                    function P() {
                        return { passiveListener: !!t.params.passiveListeners && { passive: !0, capture: !1 }, activeListenerWithCapture: !t.params.passiveListeners || { passive: !1, capture: !0 } };
                    }
                    function C() {
                        const e = t.zoom;
                        if (e.enabled) return;
                        e.enabled = !0;
                        const { passiveListener: i, activeListenerWithCapture: n } = P();
                        t.wrapperEl.addEventListener("pointerdown", y, i),
                            t.wrapperEl.addEventListener("pointermove", w, n),
                            ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
                                t.wrapperEl.addEventListener(e, x, i);
                            }),
                            t.wrapperEl.addEventListener("pointermove", S, n);
                    }
                    function O() {
                        const e = t.zoom;
                        if (!e.enabled) return;
                        e.enabled = !1;
                        const { passiveListener: i, activeListenerWithCapture: n } = P();
                        t.wrapperEl.removeEventListener("pointerdown", y, i),
                            t.wrapperEl.removeEventListener("pointermove", w, n),
                            ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
                                t.wrapperEl.removeEventListener(e, x, i);
                            }),
                            t.wrapperEl.removeEventListener("pointermove", S, n);
                    }
                    Object.defineProperty(t.zoom, "scale", {
                        get() {
                            return g;
                        },
                        set(e) {
                            if (g !== e) {
                                const t = f.imageEl,
                                    i = f.slideEl;
                                o("zoomChange", e, t, i);
                            }
                            g = e;
                        },
                    }),
                        s("init", () => {
                            t.params.zoom.enabled && C();
                        }),
                        s("destroy", () => {
                            O();
                        }),
                        s("touchStart", (e, i) => {
                            t.zoom.enabled &&
                                (function (e) {
                                    const i = t.device;
                                    if (!f.imageEl) return;
                                    if (p.isTouched) return;
                                    i.android && e.cancelable && e.preventDefault(), (p.isTouched = !0);
                                    const n = h.length > 0 ? h[0] : e;
                                    (p.touchesStart.x = n.pageX), (p.touchesStart.y = n.pageY);
                                })(i);
                        }),
                        s("touchEnd", (e, i) => {
                            t.zoom.enabled &&
                                (function () {
                                    const e = t.zoom;
                                    if (!f.imageEl) return;
                                    if (!p.isTouched || !p.isMoved) return (p.isTouched = !1), void (p.isMoved = !1);
                                    (p.isTouched = !1), (p.isMoved = !1);
                                    let i = 300,
                                        n = 300;
                                    const r = m.x * i,
                                        s = p.currentX + r,
                                        o = m.y * n,
                                        a = p.currentY + o;
                                    0 !== m.x && (i = Math.abs((s - p.currentX) / m.x)), 0 !== m.y && (n = Math.abs((a - p.currentY) / m.y));
                                    const l = Math.max(i, n);
                                    (p.currentX = s), (p.currentY = a);
                                    const c = p.width * e.scale,
                                        u = p.height * e.scale;
                                    (p.minX = Math.min(f.slideWidth / 2 - c / 2, 0)),
                                        (p.maxX = -p.minX),
                                        (p.minY = Math.min(f.slideHeight / 2 - u / 2, 0)),
                                        (p.maxY = -p.minY),
                                        (p.currentX = Math.max(Math.min(p.currentX, p.maxX), p.minX)),
                                        (p.currentY = Math.max(Math.min(p.currentY, p.maxY), p.minY)),
                                        (f.imageWrapEl.style.transitionDuration = `${l}ms`),
                                        (f.imageWrapEl.style.transform = `translate3d(${p.currentX}px, ${p.currentY}px,0)`);
                                })();
                        }),
                        s("doubleTap", (e, i) => {
                            !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && M(i);
                        }),
                        s("transitionEnd", () => {
                            t.zoom.enabled && t.params.zoom.enabled && E();
                        }),
                        s("slideChange", () => {
                            t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && E();
                        }),
                        Object.assign(t.zoom, { enable: C, disable: O, in: _, out: T, toggle: M });
                }
                function m(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    function s(e, t) {
                        const i = (function () {
                            let e, t, i;
                            return (n, r) => {
                                for (t = -1, e = n.length; e - t > 1; ) (i = (e + t) >> 1), n[i] <= r ? (t = i) : (e = i);
                                return e;
                            };
                        })();
                        let n, r;
                        return (
                            (this.x = e),
                            (this.y = t),
                            (this.lastIndex = e.length - 1),
                            (this.interpolate = function (e) {
                                return e ? ((r = i(this.x, e)), (n = r - 1), ((e - this.x[n]) * (this.y[r] - this.y[n])) / (this.x[r] - this.x[n]) + this.y[n]) : 0;
                            }),
                            this
                        );
                    }
                    function o() {
                        t.controller.control && t.controller.spline && ((t.controller.spline = void 0), delete t.controller.spline);
                    }
                    i({ controller: { control: void 0, inverse: !1, by: "slide" } }),
                        (t.controller = { control: void 0 }),
                        n("beforeInit", () => {
                            if ("undefined" != typeof window && ("string" == typeof t.params.controller.control || t.params.controller.control instanceof HTMLElement)) {
                                const e = document.querySelector(t.params.controller.control);
                                if (e && e.swiper) t.controller.control = e.swiper;
                                else if (e) {
                                    const i = (n) => {
                                        (t.controller.control = n.detail[0]), t.update(), e.removeEventListener("init", i);
                                    };
                                    e.addEventListener("init", i);
                                }
                            } else t.controller.control = t.params.controller.control;
                        }),
                        n("update", () => {
                            o();
                        }),
                        n("resize", () => {
                            o();
                        }),
                        n("observerUpdate", () => {
                            o();
                        }),
                        n("setTranslate", (e, i, n) => {
                            t.controller.control && !t.controller.control.destroyed && t.controller.setTranslate(i, n);
                        }),
                        n("setTransition", (e, i, n) => {
                            t.controller.control && !t.controller.control.destroyed && t.controller.setTransition(i, n);
                        }),
                        Object.assign(t.controller, {
                            setTranslate: function (e, i) {
                                const n = t.controller.control;
                                let r, o;
                                const a = t.constructor;
                                function l(e) {
                                    if (e.destroyed) return;
                                    const i = t.rtlTranslate ? -t.translate : t.translate;
                                    "slide" === t.params.controller.by &&
                                        ((function (e) {
                                            t.controller.spline = t.params.loop ? new s(t.slidesGrid, e.slidesGrid) : new s(t.snapGrid, e.snapGrid);
                                        })(e),
                                        (o = -t.controller.spline.interpolate(-i))),
                                        (o && "container" !== t.params.controller.by) ||
                                            ((r = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate())), (!Number.isNaN(r) && Number.isFinite(r)) || (r = 1), (o = (i - t.minTranslate()) * r + e.minTranslate())),
                                        t.params.controller.inverse && (o = e.maxTranslate() - o),
                                        e.updateProgress(o),
                                        e.setTranslate(o, t),
                                        e.updateActiveIndex(),
                                        e.updateSlidesClasses();
                                }
                                if (Array.isArray(n)) for (let e = 0; e < n.length; e += 1) n[e] !== i && n[e] instanceof a && l(n[e]);
                                else n instanceof a && i !== n && l(n);
                            },
                            setTransition: function (e, i) {
                                const n = t.constructor,
                                    s = t.controller.control;
                                let o;
                                function a(i) {
                                    i.destroyed ||
                                        (i.setTransition(e, t),
                                        0 !== e &&
                                            (i.transitionStart(),
                                            i.params.autoHeight &&
                                                (0, r.n)(() => {
                                                    i.updateAutoHeight();
                                                }),
                                            (0, r.j)(i.wrapperEl, () => {
                                                s && i.transitionEnd();
                                            })));
                                }
                                if (Array.isArray(s)) for (o = 0; o < s.length; o += 1) s[o] !== i && s[o] instanceof n && a(s[o]);
                                else s instanceof n && i !== s && a(s);
                            },
                        });
                }
                function g(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({
                        a11y: {
                            enabled: !0,
                            notificationClass: "swiper-notification",
                            prevSlideMessage: "Previous slide",
                            nextSlideMessage: "Next slide",
                            firstSlideMessage: "This is the first slide",
                            lastSlideMessage: "This is the last slide",
                            paginationBulletMessage: "Go to slide {{index}}",
                            slideLabelMessage: "{{index}} / {{slidesLength}}",
                            containerMessage: null,
                            containerRoleDescriptionMessage: null,
                            itemRoleDescriptionMessage: null,
                            slideRole: "group",
                            id: null,
                        },
                    }),
                        (t.a11y = { clicked: !1 });
                    let s = null;
                    function o(e) {
                        const t = s;
                        0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e));
                    }
                    const a = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                    function l(e) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("tabIndex", "0");
                        });
                    }
                    function c(e) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("tabIndex", "-1");
                        });
                    }
                    function d(e, t) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("role", t);
                        });
                    }
                    function h(e, t) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("aria-roledescription", t);
                        });
                    }
                    function f(e, t) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("aria-label", t);
                        });
                    }
                    function p(e) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("aria-disabled", !0);
                        });
                    }
                    function m(e) {
                        (e = a(e)).forEach((e) => {
                            e.setAttribute("aria-disabled", !1);
                        });
                    }
                    function g(e) {
                        if (13 !== e.keyCode && 32 !== e.keyCode) return;
                        const i = t.params.a11y,
                            n = e.target;
                        (t.pagination && t.pagination.el && (n === t.pagination.el || t.pagination.el.contains(e.target)) && !e.target.matches(u(t.params.pagination.bulletClass))) ||
                            (t.navigation && t.navigation.nextEl && n === t.navigation.nextEl && ((t.isEnd && !t.params.loop) || t.slideNext(), t.isEnd ? o(i.lastSlideMessage) : o(i.nextSlideMessage)),
                            t.navigation && t.navigation.prevEl && n === t.navigation.prevEl && ((t.isBeginning && !t.params.loop) || t.slidePrev(), t.isBeginning ? o(i.firstSlideMessage) : o(i.prevSlideMessage)),
                            t.pagination && n.matches(u(t.params.pagination.bulletClass)) && n.click());
                    }
                    function v() {
                        return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
                    }
                    function b() {
                        return v() && t.params.pagination.clickable;
                    }
                    const y = (e, t, i) => {
                            l(e),
                                "BUTTON" !== e.tagName && (d(e, "button"), e.addEventListener("keydown", g)),
                                f(e, i),
                                (function (e, t) {
                                    (e = a(e)).forEach((e) => {
                                        e.setAttribute("aria-controls", t);
                                    });
                                })(e, t);
                        },
                        w = () => {
                            t.a11y.clicked = !0;
                        },
                        x = () => {
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    t.destroyed || (t.a11y.clicked = !1);
                                });
                            });
                        },
                        S = (e) => {
                            if (t.a11y.clicked) return;
                            const i = e.target.closest(`.${t.params.slideClass}, swiper-slide`);
                            if (!i || !t.slides.includes(i)) return;
                            const n = t.slides.indexOf(i) === t.activeIndex,
                                r = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(i);
                            n || r || (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) || (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0), t.slideTo(t.slides.indexOf(i), 0));
                        },
                        E = () => {
                            const e = t.params.a11y;
                            e.itemRoleDescriptionMessage && h(t.slides, e.itemRoleDescriptionMessage), e.slideRole && d(t.slides, e.slideRole);
                            const i = t.slides.length;
                            e.slideLabelMessage &&
                                t.slides.forEach((n, r) => {
                                    const s = t.params.loop ? parseInt(n.getAttribute("data-swiper-slide-index"), 10) : r;
                                    f(n, e.slideLabelMessage.replace(/\{\{index\}\}/, s + 1).replace(/\{\{slidesLength\}\}/, i));
                                });
                        };
                    n("beforeInit", () => {
                        (s = (0, r.c)("span", t.params.a11y.notificationClass)), s.setAttribute("aria-live", "assertive"), s.setAttribute("aria-atomic", "true");
                    }),
                        n("afterInit", () => {
                            t.params.a11y.enabled &&
                                (() => {
                                    const e = t.params.a11y;
                                    t.el.append(s);
                                    const i = t.el;
                                    e.containerRoleDescriptionMessage && h(i, e.containerRoleDescriptionMessage), e.containerMessage && f(i, e.containerMessage);
                                    const n = t.wrapperEl,
                                        r = e.id || n.getAttribute("id") || `swiper-wrapper-${((o = 16), void 0 === o && (o = 16), "x".repeat(o).replace(/x/g, () => Math.round(16 * Math.random()).toString(16)))}`;
                                    var o;
                                    const l = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
                                    var c;
                                    (c = r),
                                        a(n).forEach((e) => {
                                            e.setAttribute("id", c);
                                        }),
                                        (function (e, t) {
                                            (e = a(e)).forEach((e) => {
                                                e.setAttribute("aria-live", t);
                                            });
                                        })(n, l),
                                        E();
                                    let { nextEl: u, prevEl: d } = t.navigation ? t.navigation : {};
                                    (u = a(u)),
                                        (d = a(d)),
                                        u && u.forEach((t) => y(t, r, e.nextSlideMessage)),
                                        d && d.forEach((t) => y(t, r, e.prevSlideMessage)),
                                        b() &&
                                            (Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e) => {
                                                e.addEventListener("keydown", g);
                                            }),
                                        t.el.addEventListener("focus", S, !0),
                                        t.el.addEventListener("pointerdown", w, !0),
                                        t.el.addEventListener("pointerup", x, !0);
                                })();
                        }),
                        n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
                            t.params.a11y.enabled && E();
                        }),
                        n("fromEdge toEdge afterInit lock unlock", () => {
                            t.params.a11y.enabled &&
                                (function () {
                                    if (t.params.loop || t.params.rewind || !t.navigation) return;
                                    const { nextEl: e, prevEl: i } = t.navigation;
                                    i && (t.isBeginning ? (p(i), c(i)) : (m(i), l(i))), e && (t.isEnd ? (p(e), c(e)) : (m(e), l(e)));
                                })();
                        }),
                        n("paginationUpdate", () => {
                            t.params.a11y.enabled &&
                                (function () {
                                    const e = t.params.a11y;
                                    v() &&
                                        t.pagination.bullets.forEach((i) => {
                                            t.params.pagination.clickable && (l(i), t.params.pagination.renderBullet || (d(i, "button"), f(i, e.paginationBulletMessage.replace(/\{\{index\}\}/, (0, r.g)(i) + 1)))),
                                                i.matches(u(t.params.pagination.bulletActiveClass)) ? i.setAttribute("aria-current", "true") : i.removeAttribute("aria-current");
                                        });
                                })();
                        }),
                        n("destroy", () => {
                            t.params.a11y.enabled &&
                                (function () {
                                    s && s.remove();
                                    let { nextEl: e, prevEl: i } = t.navigation ? t.navigation : {};
                                    (e = a(e)),
                                        (i = a(i)),
                                        e && e.forEach((e) => e.removeEventListener("keydown", g)),
                                        i && i.forEach((e) => e.removeEventListener("keydown", g)),
                                        b() &&
                                            (Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e) => {
                                                e.removeEventListener("keydown", g);
                                            }),
                                        t.el.removeEventListener("focus", S, !0),
                                        t.el.removeEventListener("pointerdown", w, !0),
                                        t.el.removeEventListener("pointerup", x, !0);
                                })();
                        });
                }
                function v(e) {
                    let { swiper: t, extendParams: i, on: r } = e;
                    i({ history: { enabled: !1, root: "", replaceState: !1, key: "slides", keepQuery: !1 } });
                    let s = !1,
                        o = {};
                    const a = (e) =>
                            e
                                .toString()
                                .replace(/\s+/g, "-")
                                .replace(/[^\w-]+/g, "")
                                .replace(/--+/g, "-")
                                .replace(/^-+/, "")
                                .replace(/-+$/, ""),
                        l = (e) => {
                            const t = (0, n.a)();
                            let i;
                            i = e ? new URL(e) : t.location;
                            const r = i.pathname
                                    .slice(1)
                                    .split("/")
                                    .filter((e) => "" !== e),
                                s = r.length;
                            return { key: r[s - 2], value: r[s - 1] };
                        },
                        c = (e, i) => {
                            const r = (0, n.a)();
                            if (!s || !t.params.history.enabled) return;
                            let o;
                            o = t.params.url ? new URL(t.params.url) : r.location;
                            const l = t.slides[i];
                            let c = a(l.getAttribute("data-history"));
                            if (t.params.history.root.length > 0) {
                                let i = t.params.history.root;
                                "/" === i[i.length - 1] && (i = i.slice(0, i.length - 1)), (c = `${i}/${e ? `${e}/` : ""}${c}`);
                            } else o.pathname.includes(e) || (c = `${e ? `${e}/` : ""}${c}`);
                            t.params.history.keepQuery && (c += o.search);
                            const u = r.history.state;
                            (u && u.value === c) || (t.params.history.replaceState ? r.history.replaceState({ value: c }, null, c) : r.history.pushState({ value: c }, null, c));
                        },
                        u = (e, i, n) => {
                            if (i)
                                for (let r = 0, s = t.slides.length; r < s; r += 1) {
                                    const s = t.slides[r];
                                    if (a(s.getAttribute("data-history")) === i) {
                                        const i = t.getSlideIndex(s);
                                        t.slideTo(i, e, n);
                                    }
                                }
                            else t.slideTo(0, e, n);
                        },
                        d = () => {
                            (o = l(t.params.url)), u(t.params.speed, o.value, !1);
                        };
                    r("init", () => {
                        t.params.history.enabled &&
                            (() => {
                                const e = (0, n.a)();
                                if (t.params.history) {
                                    if (!e.history || !e.history.pushState) return (t.params.history.enabled = !1), void (t.params.hashNavigation.enabled = !0);
                                    (s = !0),
                                        (o = l(t.params.url)),
                                        o.key || o.value
                                            ? (u(0, o.value, t.params.runCallbacksOnInit), t.params.history.replaceState || e.addEventListener("popstate", d))
                                            : t.params.history.replaceState || e.addEventListener("popstate", d);
                                }
                            })();
                    }),
                        r("destroy", () => {
                            t.params.history.enabled &&
                                (() => {
                                    const e = (0, n.a)();
                                    t.params.history.replaceState || e.removeEventListener("popstate", d);
                                })();
                        }),
                        r("transitionEnd _freeModeNoMomentumRelease", () => {
                            s && c(t.params.history.key, t.activeIndex);
                        }),
                        r("slideChange", () => {
                            s && t.params.cssMode && c(t.params.history.key, t.activeIndex);
                        });
                }
                function b(e) {
                    let { swiper: t, extendParams: i, emit: s, on: o } = e,
                        a = !1;
                    const l = (0, n.g)(),
                        c = (0, n.a)();
                    i({
                        hashNavigation: {
                            enabled: !1,
                            replaceState: !1,
                            watchState: !1,
                            getSlideIndex(e, i) {
                                if (t.virtual && t.params.virtual.enabled) {
                                    const e = t.slides.filter((e) => e.getAttribute("data-hash") === i)[0];
                                    return e ? parseInt(e.getAttribute("data-swiper-slide-index"), 10) : 0;
                                }
                                return t.getSlideIndex((0, r.e)(t.slidesEl, `.${t.params.slideClass}[data-hash="${i}"], swiper-slide[data-hash="${i}"]`)[0]);
                            },
                        },
                    });
                    const u = () => {
                            s("hashChange");
                            const e = l.location.hash.replace("#", ""),
                                i = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex];
                            if (e !== (i ? i.getAttribute("data-hash") : "")) {
                                const i = t.params.hashNavigation.getSlideIndex(t, e);
                                if (void 0 === i || Number.isNaN(i)) return;
                                t.slideTo(i);
                            }
                        },
                        d = () => {
                            if (!a || !t.params.hashNavigation.enabled) return;
                            const e = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex],
                                i = e ? e.getAttribute("data-hash") || e.getAttribute("data-history") : "";
                            t.params.hashNavigation.replaceState && c.history && c.history.replaceState ? (c.history.replaceState(null, null, `#${i}` || ""), s("hashSet")) : ((l.location.hash = i || ""), s("hashSet"));
                        };
                    o("init", () => {
                        t.params.hashNavigation.enabled &&
                            (() => {
                                if (!t.params.hashNavigation.enabled || (t.params.history && t.params.history.enabled)) return;
                                a = !0;
                                const e = l.location.hash.replace("#", "");
                                if (e) {
                                    const i = 0,
                                        n = t.params.hashNavigation.getSlideIndex(t, e);
                                    t.slideTo(n || 0, i, t.params.runCallbacksOnInit, !0);
                                }
                                t.params.hashNavigation.watchState && c.addEventListener("hashchange", u);
                            })();
                    }),
                        o("destroy", () => {
                            t.params.hashNavigation.enabled && t.params.hashNavigation.watchState && c.removeEventListener("hashchange", u);
                        }),
                        o("transitionEnd _freeModeNoMomentumRelease", () => {
                            a && d();
                        }),
                        o("slideChange", () => {
                            a && t.params.cssMode && d();
                        });
                }
                function y(e) {
                    let t,
                        i,
                        { swiper: r, extendParams: s, on: o, emit: a, params: l } = e;
                    (r.autoplay = { running: !1, paused: !1, timeLeft: 0 }), s({ autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !1, stopOnLastSlide: !1, reverseDirection: !1, pauseOnMouseEnter: !1 } });
                    let c,
                        u,
                        d,
                        h,
                        f,
                        p,
                        m,
                        g,
                        v = l && l.autoplay ? l.autoplay.delay : 3e3,
                        b = l && l.autoplay ? l.autoplay.delay : 3e3,
                        y = new Date().getTime();
                    function w(e) {
                        r && !r.destroyed && r.wrapperEl && e.target === r.wrapperEl && (r.wrapperEl.removeEventListener("transitionend", w), g || M());
                    }
                    const x = () => {
                            if (r.destroyed || !r.autoplay.running) return;
                            r.autoplay.paused ? (u = !0) : u && ((b = c), (u = !1));
                            const e = r.autoplay.paused ? c : y + b - new Date().getTime();
                            (r.autoplay.timeLeft = e),
                                a("autoplayTimeLeft", e, e / v),
                                (i = requestAnimationFrame(() => {
                                    x();
                                }));
                        },
                        S = (e) => {
                            if (r.destroyed || !r.autoplay.running) return;
                            cancelAnimationFrame(i), x();
                            let n = void 0 === e ? r.params.autoplay.delay : e;
                            (v = r.params.autoplay.delay), (b = r.params.autoplay.delay);
                            const s = (() => {
                                let e;
                                if (((e = r.virtual && r.params.virtual.enabled ? r.slides.filter((e) => e.classList.contains("swiper-slide-active"))[0] : r.slides[r.activeIndex]), e))
                                    return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
                            })();
                            !Number.isNaN(s) && s > 0 && void 0 === e && ((n = s), (v = s), (b = s)), (c = n);
                            const o = r.params.speed,
                                l = () => {
                                    r &&
                                        !r.destroyed &&
                                        (r.params.autoplay.reverseDirection
                                            ? !r.isBeginning || r.params.loop || r.params.rewind
                                                ? (r.slidePrev(o, !0, !0), a("autoplay"))
                                                : r.params.autoplay.stopOnLastSlide || (r.slideTo(r.slides.length - 1, o, !0, !0), a("autoplay"))
                                            : !r.isEnd || r.params.loop || r.params.rewind
                                            ? (r.slideNext(o, !0, !0), a("autoplay"))
                                            : r.params.autoplay.stopOnLastSlide || (r.slideTo(0, o, !0, !0), a("autoplay")),
                                        r.params.cssMode &&
                                            ((y = new Date().getTime()),
                                            requestAnimationFrame(() => {
                                                S();
                                            })));
                                };
                            return (
                                n > 0
                                    ? (clearTimeout(t),
                                      (t = setTimeout(() => {
                                          l();
                                      }, n)))
                                    : requestAnimationFrame(() => {
                                          l();
                                      }),
                                n
                            );
                        },
                        E = () => {
                            (y = new Date().getTime()), (r.autoplay.running = !0), S(), a("autoplayStart");
                        },
                        _ = () => {
                            (r.autoplay.running = !1), clearTimeout(t), cancelAnimationFrame(i), a("autoplayStop");
                        },
                        T = (e, i) => {
                            if (r.destroyed || !r.autoplay.running) return;
                            clearTimeout(t), e || (m = !0);
                            const n = () => {
                                a("autoplayPause"), r.params.autoplay.waitForTransition ? r.wrapperEl.addEventListener("transitionend", w) : M();
                            };
                            if (((r.autoplay.paused = !0), i)) return p && (c = r.params.autoplay.delay), (p = !1), void n();
                            const s = c || r.params.autoplay.delay;
                            (c = s - (new Date().getTime() - y)), (r.isEnd && c < 0 && !r.params.loop) || (c < 0 && (c = 0), n());
                        },
                        M = () => {
                            (r.isEnd && c < 0 && !r.params.loop) || r.destroyed || !r.autoplay.running || ((y = new Date().getTime()), m ? ((m = !1), S(c)) : S(), (r.autoplay.paused = !1), a("autoplayResume"));
                        },
                        P = () => {
                            if (r.destroyed || !r.autoplay.running) return;
                            const e = (0, n.g)();
                            "hidden" === e.visibilityState && ((m = !0), T(!0)), "visible" === e.visibilityState && M();
                        },
                        C = (e) => {
                            "mouse" === e.pointerType && ((m = !0), (g = !0), r.animating || r.autoplay.paused || T(!0));
                        },
                        O = (e) => {
                            "mouse" === e.pointerType && ((g = !1), r.autoplay.paused && M());
                        };
                    o("init", () => {
                        r.params.autoplay.enabled && (r.params.autoplay.pauseOnMouseEnter && (r.el.addEventListener("pointerenter", C), r.el.addEventListener("pointerleave", O)), (0, n.g)().addEventListener("visibilitychange", P), E());
                    }),
                        o("destroy", () => {
                            r.el.removeEventListener("pointerenter", C), r.el.removeEventListener("pointerleave", O), (0, n.g)().removeEventListener("visibilitychange", P), r.autoplay.running && _();
                        }),
                        o("_freeModeStaticRelease", () => {
                            (h || m) && M();
                        }),
                        o("_freeModeNoMomentumRelease", () => {
                            r.params.autoplay.disableOnInteraction ? _() : T(!0, !0);
                        }),
                        o("beforeTransitionStart", (e, t, i) => {
                            !r.destroyed && r.autoplay.running && (i || !r.params.autoplay.disableOnInteraction ? T(!0, !0) : _());
                        }),
                        o("sliderFirstMove", () => {
                            !r.destroyed &&
                                r.autoplay.running &&
                                (r.params.autoplay.disableOnInteraction
                                    ? _()
                                    : ((d = !0),
                                      (h = !1),
                                      (m = !1),
                                      (f = setTimeout(() => {
                                          (m = !0), (h = !0), T(!0);
                                      }, 200))));
                        }),
                        o("touchEnd", () => {
                            if (!r.destroyed && r.autoplay.running && d) {
                                if ((clearTimeout(f), clearTimeout(t), r.params.autoplay.disableOnInteraction)) return (h = !1), void (d = !1);
                                h && r.params.cssMode && M(), (h = !1), (d = !1);
                            }
                        }),
                        o("slideChange", () => {
                            !r.destroyed && r.autoplay.running && (p = !0);
                        }),
                        Object.assign(r.autoplay, { start: E, stop: _, pause: T, resume: M });
                }
                function w(e) {
                    let { swiper: t, extendParams: i, on: s } = e;
                    i({ thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
                    let o = !1,
                        a = !1;
                    function l() {
                        const e = t.thumbs.swiper;
                        if (!e || e.destroyed) return;
                        const i = e.clickedIndex,
                            n = e.clickedSlide;
                        if (n && n.classList.contains(t.params.thumbs.slideThumbActiveClass)) return;
                        if (null == i) return;
                        let r;
                        (r = e.params.loop ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : i), t.params.loop ? t.slideToLoop(r) : t.slideTo(r);
                    }
                    function c() {
                        const { thumbs: e } = t.params;
                        if (o) return !1;
                        o = !0;
                        const i = t.constructor;
                        if (e.swiper instanceof i)
                            (t.thumbs.swiper = e.swiper),
                                Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                                Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                                t.thumbs.swiper.update();
                        else if ((0, r.k)(e.swiper)) {
                            const n = Object.assign({}, e.swiper);
                            Object.assign(n, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (t.thumbs.swiper = new i(n)), (a = !0);
                        }
                        return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", l), !0;
                    }
                    function u(e) {
                        const i = t.thumbs.swiper;
                        if (!i || i.destroyed) return;
                        const n = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
                        let s = 1;
                        const o = t.params.thumbs.slideThumbActiveClass;
                        if (
                            (t.params.slidesPerView > 1 && !t.params.centeredSlides && (s = t.params.slidesPerView),
                            t.params.thumbs.multipleActiveThumbs || (s = 1),
                            (s = Math.floor(s)),
                            i.slides.forEach((e) => e.classList.remove(o)),
                            i.params.loop || (i.params.virtual && i.params.virtual.enabled))
                        )
                            for (let e = 0; e < s; e += 1)
                                (0, r.e)(i.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach((e) => {
                                    e.classList.add(o);
                                });
                        else for (let e = 0; e < s; e += 1) i.slides[t.realIndex + e] && i.slides[t.realIndex + e].classList.add(o);
                        const a = t.params.thumbs.autoScrollOffset,
                            l = a && !i.params.loop;
                        if (t.realIndex !== i.realIndex || l) {
                            const r = i.activeIndex;
                            let s, o;
                            if (i.params.loop) {
                                const e = i.slides.filter((e) => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`)[0];
                                (s = i.slides.indexOf(e)), (o = t.activeIndex > t.previousIndex ? "next" : "prev");
                            } else (s = t.realIndex), (o = s > t.previousIndex ? "next" : "prev");
                            l && (s += "next" === o ? a : -1 * a),
                                i.visibleSlidesIndexes &&
                                    i.visibleSlidesIndexes.indexOf(s) < 0 &&
                                    (i.params.centeredSlides ? (s = s > r ? s - Math.floor(n / 2) + 1 : s + Math.floor(n / 2) - 1) : s > r && i.params.slidesPerGroup, i.slideTo(s, e ? 0 : void 0));
                        }
                    }
                    (t.thumbs = { swiper: null }),
                        s("beforeInit", () => {
                            const { thumbs: e } = t.params;
                            if (e && e.swiper)
                                if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
                                    const i = (0, n.g)(),
                                        r = () => {
                                            const n = "string" == typeof e.swiper ? i.querySelector(e.swiper) : e.swiper;
                                            if (n && n.swiper) (e.swiper = n.swiper), c(), u(!0);
                                            else if (n) {
                                                const i = (r) => {
                                                    (e.swiper = r.detail[0]), n.removeEventListener("init", i), c(), u(!0), e.swiper.update(), t.update();
                                                };
                                                n.addEventListener("init", i);
                                            }
                                            return n;
                                        },
                                        s = () => {
                                            t.destroyed || r() || requestAnimationFrame(s);
                                        };
                                    requestAnimationFrame(s);
                                } else c(), u(!0);
                        }),
                        s("slideChange update resize observerUpdate", () => {
                            u();
                        }),
                        s("setTransition", (e, i) => {
                            const n = t.thumbs.swiper;
                            n && !n.destroyed && n.setTransition(i);
                        }),
                        s("beforeDestroy", () => {
                            const e = t.thumbs.swiper;
                            e && !e.destroyed && a && e.destroy();
                        }),
                        Object.assign(t.thumbs, { init: c, update: u });
                }
                function x(e) {
                    let { swiper: t, extendParams: i, emit: n, once: s } = e;
                    i({ freeMode: { enabled: !1, momentum: !0, momentumRatio: 1, momentumBounce: !0, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: !1, minimumVelocity: 0.02 } }),
                        Object.assign(t, {
                            freeMode: {
                                onTouchStart: function () {
                                    if (t.params.cssMode) return;
                                    const e = t.getTranslate();
                                    t.setTranslate(e), t.setTransition(0), (t.touchEventsData.velocities.length = 0), t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
                                },
                                onTouchMove: function () {
                                    if (t.params.cssMode) return;
                                    const { touchEventsData: e, touches: i } = t;
                                    0 === e.velocities.length && e.velocities.push({ position: i[t.isHorizontal() ? "startX" : "startY"], time: e.touchStartTime }),
                                        e.velocities.push({ position: i[t.isHorizontal() ? "currentX" : "currentY"], time: (0, r.d)() });
                                },
                                onTouchEnd: function (e) {
                                    let { currentPos: i } = e;
                                    if (t.params.cssMode) return;
                                    const { params: o, wrapperEl: a, rtlTranslate: l, snapGrid: c, touchEventsData: u } = t,
                                        d = (0, r.d)() - u.touchStartTime;
                                    if (i < -t.minTranslate()) t.slideTo(t.activeIndex);
                                    else if (i > -t.maxTranslate()) t.slides.length < c.length ? t.slideTo(c.length - 1) : t.slideTo(t.slides.length - 1);
                                    else {
                                        if (o.freeMode.momentum) {
                                            if (u.velocities.length > 1) {
                                                const e = u.velocities.pop(),
                                                    i = u.velocities.pop(),
                                                    n = e.position - i.position,
                                                    s = e.time - i.time;
                                                (t.velocity = n / s), (t.velocity /= 2), Math.abs(t.velocity) < o.freeMode.minimumVelocity && (t.velocity = 0), (s > 150 || (0, r.d)() - e.time > 300) && (t.velocity = 0);
                                            } else t.velocity = 0;
                                            (t.velocity *= o.freeMode.momentumVelocityRatio), (u.velocities.length = 0);
                                            let e = 1e3 * o.freeMode.momentumRatio;
                                            const i = t.velocity * e;
                                            let d = t.translate + i;
                                            l && (d = -d);
                                            let h,
                                                f = !1;
                                            const p = 20 * Math.abs(t.velocity) * o.freeMode.momentumBounceRatio;
                                            let m;
                                            if (d < t.maxTranslate())
                                                o.freeMode.momentumBounce ? (d + t.maxTranslate() < -p && (d = t.maxTranslate() - p), (h = t.maxTranslate()), (f = !0), (u.allowMomentumBounce = !0)) : (d = t.maxTranslate()),
                                                    o.loop && o.centeredSlides && (m = !0);
                                            else if (d > t.minTranslate())
                                                o.freeMode.momentumBounce ? (d - t.minTranslate() > p && (d = t.minTranslate() + p), (h = t.minTranslate()), (f = !0), (u.allowMomentumBounce = !0)) : (d = t.minTranslate()),
                                                    o.loop && o.centeredSlides && (m = !0);
                                            else if (o.freeMode.sticky) {
                                                let e;
                                                for (let t = 0; t < c.length; t += 1)
                                                    if (c[t] > -d) {
                                                        e = t;
                                                        break;
                                                    }
                                                (d = Math.abs(c[e] - d) < Math.abs(c[e - 1] - d) || "next" === t.swipeDirection ? c[e] : c[e - 1]), (d = -d);
                                            }
                                            if (
                                                (m &&
                                                    s("transitionEnd", () => {
                                                        t.loopFix();
                                                    }),
                                                0 !== t.velocity)
                                            ) {
                                                if (((e = l ? Math.abs((-d - t.translate) / t.velocity) : Math.abs((d - t.translate) / t.velocity)), o.freeMode.sticky)) {
                                                    const i = Math.abs((l ? -d : d) - t.translate),
                                                        n = t.slidesSizesGrid[t.activeIndex];
                                                    e = i < n ? o.speed : i < 2 * n ? 1.5 * o.speed : 2.5 * o.speed;
                                                }
                                            } else if (o.freeMode.sticky) return void t.slideToClosest();
                                            o.freeMode.momentumBounce && f
                                                ? (t.updateProgress(h),
                                                  t.setTransition(e),
                                                  t.setTranslate(d),
                                                  t.transitionStart(!0, t.swipeDirection),
                                                  (t.animating = !0),
                                                  (0, r.j)(a, () => {
                                                      t &&
                                                          !t.destroyed &&
                                                          u.allowMomentumBounce &&
                                                          (n("momentumBounce"),
                                                          t.setTransition(o.speed),
                                                          setTimeout(() => {
                                                              t.setTranslate(h),
                                                                  (0, r.j)(a, () => {
                                                                      t && !t.destroyed && t.transitionEnd();
                                                                  });
                                                          }, 0));
                                                  }))
                                                : t.velocity
                                                ? (n("_freeModeNoMomentumRelease"),
                                                  t.updateProgress(d),
                                                  t.setTransition(e),
                                                  t.setTranslate(d),
                                                  t.transitionStart(!0, t.swipeDirection),
                                                  t.animating ||
                                                      ((t.animating = !0),
                                                      (0, r.j)(a, () => {
                                                          t && !t.destroyed && t.transitionEnd();
                                                      })))
                                                : t.updateProgress(d),
                                                t.updateActiveIndex(),
                                                t.updateSlidesClasses();
                                        } else {
                                            if (o.freeMode.sticky) return void t.slideToClosest();
                                            o.freeMode && n("_freeModeNoMomentumRelease");
                                        }
                                        (!o.freeMode.momentum || d >= o.longSwipesMs) && (n("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                                    }
                                },
                            },
                        });
                }
                function S(e) {
                    let t,
                        i,
                        n,
                        r,
                        { swiper: s, extendParams: o, on: a } = e;
                    o({ grid: { rows: 1, fill: "column" } });
                    const l = () => {
                        let e = s.params.spaceBetween;
                        return "string" == typeof e && e.indexOf("%") >= 0 ? (e = (parseFloat(e.replace("%", "")) / 100) * s.size) : "string" == typeof e && (e = parseFloat(e)), e;
                    };
                    a("init", () => {
                        r = s.params.grid && s.params.grid.rows > 1;
                    }),
                        a("update", () => {
                            const { params: e, el: t } = s,
                                i = e.grid && e.grid.rows > 1;
                            r && !i
                                ? (t.classList.remove(`${e.containerModifierClass}grid`, `${e.containerModifierClass}grid-column`), (n = 1), s.emitContainerClasses())
                                : !r && i && (t.classList.add(`${e.containerModifierClass}grid`), "column" === e.grid.fill && t.classList.add(`${e.containerModifierClass}grid-column`), s.emitContainerClasses()),
                                (r = i);
                        }),
                        (s.grid = {
                            initSlides: (e) => {
                                const { slidesPerView: r } = s.params,
                                    { rows: o, fill: a } = s.params.grid,
                                    l = s.virtual && s.params.virtual.enabled ? s.virtual.slides.length : e.length;
                                (n = Math.floor(l / o)), (t = Math.floor(l / o) === l / o ? l : Math.ceil(l / o) * o), "auto" !== r && "row" === a && (t = Math.max(t, r * o)), (i = t / o);
                            },
                            unsetSlides: () => {
                                s.slides &&
                                    s.slides.forEach((e) => {
                                        e.swiperSlideGridSet && ((e.style.height = ""), (e.style[s.getDirectionLabel("margin-top")] = ""));
                                    });
                            },
                            updateSlide: (e, r, o) => {
                                const { slidesPerGroup: a } = s.params,
                                    c = l(),
                                    { rows: u, fill: d } = s.params.grid,
                                    h = s.virtual && s.params.virtual.enabled ? s.virtual.slides.length : o.length;
                                let f, p, m;
                                if ("row" === d && a > 1) {
                                    const i = Math.floor(e / (a * u)),
                                        n = e - u * a * i,
                                        s = 0 === i ? a : Math.min(Math.ceil((h - i * u * a) / u), a);
                                    (m = Math.floor(n / s)), (p = n - m * s + i * a), (f = p + (m * t) / u), (r.style.order = f);
                                } else "column" === d ? ((p = Math.floor(e / u)), (m = e - p * u), (p > n || (p === n && m === u - 1)) && ((m += 1), m >= u && ((m = 0), (p += 1)))) : ((m = Math.floor(e / i)), (p = e - m * i));
                                (r.row = m), (r.column = p), (r.style.height = `calc((100% - ${(u - 1) * c}px) / ${u})`), (r.style[s.getDirectionLabel("margin-top")] = 0 !== m ? c && `${c}px` : ""), (r.swiperSlideGridSet = !0);
                            },
                            updateWrapperSize: (e, i) => {
                                const { centeredSlides: n, roundLengths: r } = s.params,
                                    o = l(),
                                    { rows: a } = s.params.grid;
                                if (((s.virtualSize = (e + o) * t), (s.virtualSize = Math.ceil(s.virtualSize / a) - o), s.params.cssMode || (s.wrapperEl.style[s.getDirectionLabel("width")] = `${s.virtualSize + o}px`), n)) {
                                    const e = [];
                                    for (let t = 0; t < i.length; t += 1) {
                                        let n = i[t];
                                        r && (n = Math.floor(n)), i[t] < s.virtualSize + i[0] && e.push(n);
                                    }
                                    i.splice(0, i.length), i.push(...e);
                                }
                            },
                        });
                }
                function E(e) {
                    const t = this,
                        { params: i, slidesEl: n } = t;
                    i.loop && t.loopDestroy();
                    const r = (e) => {
                        if ("string" == typeof e) {
                            const t = document.createElement("div");
                            (t.innerHTML = e), n.append(t.children[0]), (t.innerHTML = "");
                        } else n.append(e);
                    };
                    if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && r(e[t]);
                    else r(e);
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update();
                }
                function _(e) {
                    const t = this,
                        { params: i, activeIndex: n, slidesEl: r } = t;
                    i.loop && t.loopDestroy();
                    let s = n + 1;
                    const o = (e) => {
                        if ("string" == typeof e) {
                            const t = document.createElement("div");
                            (t.innerHTML = e), r.prepend(t.children[0]), (t.innerHTML = "");
                        } else r.prepend(e);
                    };
                    if ("object" == typeof e && "length" in e) {
                        for (let t = 0; t < e.length; t += 1) e[t] && o(e[t]);
                        s = n + e.length;
                    } else o(e);
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update(), t.slideTo(s, 0, !1);
                }
                function T(e, t) {
                    const i = this,
                        { params: n, activeIndex: r, slidesEl: s } = i;
                    let o = r;
                    n.loop && ((o -= i.loopedSlides), i.loopDestroy(), i.recalcSlides());
                    const a = i.slides.length;
                    if (e <= 0) return void i.prependSlide(t);
                    if (e >= a) return void i.appendSlide(t);
                    let l = o > e ? o + 1 : o;
                    const c = [];
                    for (let t = a - 1; t >= e; t -= 1) {
                        const e = i.slides[t];
                        e.remove(), c.unshift(e);
                    }
                    if ("object" == typeof t && "length" in t) {
                        for (let e = 0; e < t.length; e += 1) t[e] && s.append(t[e]);
                        l = o > e ? o + t.length : o;
                    } else s.append(t);
                    for (let e = 0; e < c.length; e += 1) s.append(c[e]);
                    i.recalcSlides(), n.loop && i.loopCreate(), (n.observer && !i.isElement) || i.update(), n.loop ? i.slideTo(l + i.loopedSlides, 0, !1) : i.slideTo(l, 0, !1);
                }
                function M(e) {
                    const t = this,
                        { params: i, activeIndex: n } = t;
                    let r = n;
                    i.loop && ((r -= t.loopedSlides), t.loopDestroy());
                    let s,
                        o = r;
                    if ("object" == typeof e && "length" in e) {
                        for (let i = 0; i < e.length; i += 1) (s = e[i]), t.slides[s] && t.slides[s].remove(), s < o && (o -= 1);
                        o = Math.max(o, 0);
                    } else (s = e), t.slides[s] && t.slides[s].remove(), s < o && (o -= 1), (o = Math.max(o, 0));
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update(), i.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
                }
                function P() {
                    const e = this,
                        t = [];
                    for (let i = 0; i < e.slides.length; i += 1) t.push(i);
                    e.removeSlide(t);
                }
                function C(e) {
                    let { swiper: t } = e;
                    Object.assign(t, { appendSlide: E.bind(t), prependSlide: _.bind(t), addSlide: T.bind(t), removeSlide: M.bind(t), removeAllSlides: P.bind(t) });
                }
                function O(e) {
                    const { effect: t, swiper: i, on: n, setTranslate: r, setTransition: s, overwriteParams: o, perspective: a, recreateShadows: l, getEffectParams: c } = e;
                    let u;
                    n("beforeInit", () => {
                        if (i.params.effect !== t) return;
                        i.classNames.push(`${i.params.containerModifierClass}${t}`), a && a() && i.classNames.push(`${i.params.containerModifierClass}3d`);
                        const e = o ? o() : {};
                        Object.assign(i.params, e), Object.assign(i.originalParams, e);
                    }),
                        n("setTranslate", () => {
                            i.params.effect === t && r();
                        }),
                        n("setTransition", (e, n) => {
                            i.params.effect === t && s(n);
                        }),
                        n("transitionEnd", () => {
                            if (i.params.effect === t && l) {
                                if (!c || !c().slideShadows) return;
                                i.slides.forEach((e) => {
                                    e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e) => e.remove());
                                }),
                                    l();
                            }
                        }),
                        n("virtualUpdate", () => {
                            i.params.effect === t &&
                                (i.slides.length || (u = !0),
                                requestAnimationFrame(() => {
                                    u && i.slides && i.slides.length && (r(), (u = !1));
                                }));
                        });
                }
                function L(e, t) {
                    const i = (0, r.l)(t);
                    return i !== t && ((i.style.backfaceVisibility = "hidden"), (i.style["-webkit-backface-visibility"] = "hidden")), i;
                }
                function k(e) {
                    let { swiper: t, duration: i, transformElements: n, allSlides: s } = e;
                    const { activeIndex: o } = t;
                    if (t.params.virtualTranslate && 0 !== i) {
                        let e,
                            i = !1;
                        (e = s
                            ? n
                            : n.filter((e) => {
                                  const i = e.classList.contains("swiper-slide-transform") ? ((e) => (e.parentElement ? e.parentElement : t.slides.filter((t) => t.shadowRoot && t.shadowRoot === e.parentNode)[0]))(e) : e;
                                  return t.getSlideIndex(i) === o;
                              })),
                            e.forEach((e) => {
                                (0, r.j)(e, () => {
                                    if (i) return;
                                    if (!t || t.destroyed) return;
                                    (i = !0), (t.animating = !1);
                                    const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                                    t.wrapperEl.dispatchEvent(e);
                                });
                            });
                    }
                }
                function A(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ fadeEffect: { crossFade: !1 } }),
                        O({
                            effect: "fade",
                            swiper: t,
                            on: n,
                            setTranslate: () => {
                                const { slides: e } = t;
                                t.params.fadeEffect;
                                for (let i = 0; i < e.length; i += 1) {
                                    const e = t.slides[i];
                                    let n = -e.swiperSlideOffset;
                                    t.params.virtualTranslate || (n -= t.translate);
                                    let r = 0;
                                    t.isHorizontal() || ((r = n), (n = 0));
                                    const s = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e.progress), 0) : 1 + Math.min(Math.max(e.progress, -1), 0),
                                        o = L(0, e);
                                    (o.style.opacity = s), (o.style.transform = `translate3d(${n}px, ${r}px, 0px)`);
                                }
                            },
                            setTransition: (e) => {
                                const i = t.slides.map((e) => (0, r.l)(e));
                                i.forEach((t) => {
                                    t.style.transitionDuration = `${e}ms`;
                                }),
                                    k({ swiper: t, duration: e, transformElements: i, allSlides: !0 });
                            },
                            overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !t.params.cssMode }),
                        });
                }
                function I(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } });
                    const s = (e, t, i) => {
                        let n = i ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
                            s = i ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
                        n || ((n = (0, r.c)("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (i ? "left" : "top")).split(" "))), e.append(n)),
                            s || ((s = (0, r.c)("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (i ? "right" : "bottom")).split(" "))), e.append(s)),
                            n && (n.style.opacity = Math.max(-t, 0)),
                            s && (s.style.opacity = Math.max(t, 0));
                    };
                    O({
                        effect: "cube",
                        swiper: t,
                        on: n,
                        setTranslate: () => {
                            const { el: e, wrapperEl: i, slides: n, width: o, height: a, rtlTranslate: l, size: c, browser: u } = t,
                                d = t.params.cubeEffect,
                                h = t.isHorizontal(),
                                f = t.virtual && t.params.virtual.enabled;
                            let p,
                                m = 0;
                            d.shadow &&
                                (h
                                    ? ((p = t.wrapperEl.querySelector(".swiper-cube-shadow")), p || ((p = (0, r.c)("div", "swiper-cube-shadow")), t.wrapperEl.append(p)), (p.style.height = `${o}px`))
                                    : ((p = e.querySelector(".swiper-cube-shadow")), p || ((p = (0, r.c)("div", "swiper-cube-shadow")), e.append(p))));
                            for (let e = 0; e < n.length; e += 1) {
                                const t = n[e];
                                let i = e;
                                f && (i = parseInt(t.getAttribute("data-swiper-slide-index"), 10));
                                let r = 90 * i,
                                    o = Math.floor(r / 360);
                                l && ((r = -r), (o = Math.floor(-r / 360)));
                                const a = Math.max(Math.min(t.progress, 1), -1);
                                let u = 0,
                                    p = 0,
                                    g = 0;
                                i % 4 == 0 ? ((u = 4 * -o * c), (g = 0)) : (i - 1) % 4 == 0 ? ((u = 0), (g = 4 * -o * c)) : (i - 2) % 4 == 0 ? ((u = c + 4 * o * c), (g = c)) : (i - 3) % 4 == 0 && ((u = -c), (g = 3 * c + 4 * c * o)),
                                    l && (u = -u),
                                    h || ((p = u), (u = 0));
                                const v = `rotateX(${h ? 0 : -r}deg) rotateY(${h ? r : 0}deg) translate3d(${u}px, ${p}px, ${g}px)`;
                                a <= 1 && a > -1 && ((m = 90 * i + 90 * a), l && (m = 90 * -i - 90 * a)), (t.style.transform = v), d.slideShadows && s(t, a, h);
                            }
                            if (((i.style.transformOrigin = `50% 50% -${c / 2}px`), (i.style["-webkit-transform-origin"] = `50% 50% -${c / 2}px`), d.shadow))
                                if (h) p.style.transform = `translate3d(0px, ${o / 2 + d.shadowOffset}px, ${-o / 2}px) rotateX(90deg) rotateZ(0deg) scale(${d.shadowScale})`;
                                else {
                                    const e = Math.abs(m) - 90 * Math.floor(Math.abs(m) / 90),
                                        t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                                        i = d.shadowScale,
                                        n = d.shadowScale / t,
                                        r = d.shadowOffset;
                                    p.style.transform = `scale3d(${i}, 1, ${n}) translate3d(0px, ${a / 2 + r}px, ${-a / 2 / n}px) rotateX(-90deg)`;
                                }
                            const g = (u.isSafari || u.isWebView) && u.needPerspectiveFix ? -c / 2 : 0;
                            (i.style.transform = `translate3d(0px,0,${g}px) rotateX(${t.isHorizontal() ? 0 : m}deg) rotateY(${t.isHorizontal() ? -m : 0}deg)`), i.style.setProperty("--swiper-cube-translate-z", `${g}px`);
                        },
                        setTransition: (e) => {
                            const { el: i, slides: n } = t;
                            if (
                                (n.forEach((t) => {
                                    (t.style.transitionDuration = `${e}ms`),
                                        t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                            t.style.transitionDuration = `${e}ms`;
                                        });
                                }),
                                t.params.cubeEffect.shadow && !t.isHorizontal())
                            ) {
                                const t = i.querySelector(".swiper-cube-shadow");
                                t && (t.style.transitionDuration = `${e}ms`);
                            }
                        },
                        recreateShadows: () => {
                            const e = t.isHorizontal();
                            t.slides.forEach((t) => {
                                const i = Math.max(Math.min(t.progress, 1), -1);
                                s(t, i, e);
                            });
                        },
                        getEffectParams: () => t.params.cubeEffect,
                        perspective: () => !0,
                        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 }),
                    });
                }
                function z(e, t, i) {
                    const n = `swiper-slide-shadow${i ? `-${i}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`,
                        s = (0, r.l)(t);
                    let o = s.querySelector(`.${n.split(" ").join(".")}`);
                    return o || ((o = (0, r.c)("div", n.split(" "))), s.append(o)), o;
                }
                function D(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
                    const s = (e, i) => {
                        let n = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
                            r = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
                        n || (n = z("flip", e, t.isHorizontal() ? "left" : "top")), r || (r = z("flip", e, t.isHorizontal() ? "right" : "bottom")), n && (n.style.opacity = Math.max(-i, 0)), r && (r.style.opacity = Math.max(i, 0));
                    };
                    O({
                        effect: "flip",
                        swiper: t,
                        on: n,
                        setTranslate: () => {
                            const { slides: e, rtlTranslate: i } = t,
                                n = t.params.flipEffect;
                            for (let r = 0; r < e.length; r += 1) {
                                const o = e[r];
                                let a = o.progress;
                                t.params.flipEffect.limitRotation && (a = Math.max(Math.min(o.progress, 1), -1));
                                const l = o.swiperSlideOffset;
                                let c = -180 * a,
                                    u = 0,
                                    d = t.params.cssMode ? -l - t.translate : -l,
                                    h = 0;
                                t.isHorizontal() ? i && (c = -c) : ((h = d), (d = 0), (u = -c), (c = 0)), (o.style.zIndex = -Math.abs(Math.round(a)) + e.length), n.slideShadows && s(o, a);
                                const f = `translate3d(${d}px, ${h}px, 0px) rotateX(${u}deg) rotateY(${c}deg)`;
                                L(0, o).style.transform = f;
                            }
                        },
                        setTransition: (e) => {
                            const i = t.slides.map((e) => (0, r.l)(e));
                            i.forEach((t) => {
                                (t.style.transitionDuration = `${e}ms`),
                                    t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                        t.style.transitionDuration = `${e}ms`;
                                    });
                            }),
                                k({ swiper: t, duration: e, transformElements: i });
                        },
                        recreateShadows: () => {
                            t.params.flipEffect,
                                t.slides.forEach((e) => {
                                    let i = e.progress;
                                    t.params.flipEffect.limitRotation && (i = Math.max(Math.min(e.progress, 1), -1)), s(e, i);
                                });
                        },
                        getEffectParams: () => t.params.flipEffect,
                        perspective: () => !0,
                        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !t.params.cssMode }),
                    });
                }
                function j(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }),
                        O({
                            effect: "coverflow",
                            swiper: t,
                            on: n,
                            setTranslate: () => {
                                const { width: e, height: i, slides: n, slidesSizesGrid: r } = t,
                                    s = t.params.coverflowEffect,
                                    o = t.isHorizontal(),
                                    a = t.translate,
                                    l = o ? e / 2 - a : i / 2 - a,
                                    c = o ? s.rotate : -s.rotate,
                                    u = s.depth;
                                for (let e = 0, t = n.length; e < t; e += 1) {
                                    const t = n[e],
                                        i = r[e],
                                        a = (l - t.swiperSlideOffset - i / 2) / i,
                                        d = "function" == typeof s.modifier ? s.modifier(a) : a * s.modifier;
                                    let h = o ? c * d : 0,
                                        f = o ? 0 : c * d,
                                        p = -u * Math.abs(d),
                                        m = s.stretch;
                                    "string" == typeof m && -1 !== m.indexOf("%") && (m = (parseFloat(s.stretch) / 100) * i);
                                    let g = o ? 0 : m * d,
                                        v = o ? m * d : 0,
                                        b = 1 - (1 - s.scale) * Math.abs(d);
                                    Math.abs(v) < 0.001 && (v = 0), Math.abs(g) < 0.001 && (g = 0), Math.abs(p) < 0.001 && (p = 0), Math.abs(h) < 0.001 && (h = 0), Math.abs(f) < 0.001 && (f = 0), Math.abs(b) < 0.001 && (b = 0);
                                    const y = `translate3d(${v}px,${g}px,${p}px)  rotateX(${f}deg) rotateY(${h}deg) scale(${b})`;
                                    if (((L(0, t).style.transform = y), (t.style.zIndex = 1 - Math.abs(Math.round(d))), s.slideShadows)) {
                                        let e = o ? t.querySelector(".swiper-slide-shadow-left") : t.querySelector(".swiper-slide-shadow-top"),
                                            i = o ? t.querySelector(".swiper-slide-shadow-right") : t.querySelector(".swiper-slide-shadow-bottom");
                                        e || (e = z("coverflow", t, o ? "left" : "top")), i || (i = z("coverflow", t, o ? "right" : "bottom")), e && (e.style.opacity = d > 0 ? d : 0), i && (i.style.opacity = -d > 0 ? -d : 0);
                                    }
                                }
                            },
                            setTransition: (e) => {
                                t.slides
                                    .map((e) => (0, r.l)(e))
                                    .forEach((t) => {
                                        (t.style.transitionDuration = `${e}ms`),
                                            t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                                t.style.transitionDuration = `${e}ms`;
                                            });
                                    });
                            },
                            perspective: () => !0,
                            overwriteParams: () => ({ watchSlidesProgress: !0 }),
                        });
                }
                function R(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({
                        creativeEffect: {
                            limitProgress: 1,
                            shadowPerProgress: !1,
                            progressMultiplier: 1,
                            perspective: !0,
                            prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                            next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                        },
                    });
                    const s = (e) => ("string" == typeof e ? e : `${e}px`);
                    O({
                        effect: "creative",
                        swiper: t,
                        on: n,
                        setTranslate: () => {
                            const { slides: e, wrapperEl: i, slidesSizesGrid: n } = t,
                                r = t.params.creativeEffect,
                                { progressMultiplier: o } = r,
                                a = t.params.centeredSlides;
                            if (a) {
                                const e = n[0] / 2 - t.params.slidesOffsetBefore || 0;
                                i.style.transform = `translateX(calc(50% - ${e}px))`;
                            }
                            for (let i = 0; i < e.length; i += 1) {
                                const n = e[i],
                                    l = n.progress,
                                    c = Math.min(Math.max(n.progress, -r.limitProgress), r.limitProgress);
                                let u = c;
                                a || (u = Math.min(Math.max(n.originalProgress, -r.limitProgress), r.limitProgress));
                                const d = n.swiperSlideOffset,
                                    h = [t.params.cssMode ? -d - t.translate : -d, 0, 0],
                                    f = [0, 0, 0];
                                let p = !1;
                                t.isHorizontal() || ((h[1] = h[0]), (h[0] = 0));
                                let m = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                                c < 0 ? ((m = r.next), (p = !0)) : c > 0 && ((m = r.prev), (p = !0)),
                                    h.forEach((e, t) => {
                                        h[t] = `calc(${e}px + (${s(m.translate[t])} * ${Math.abs(c * o)}))`;
                                    }),
                                    f.forEach((e, t) => {
                                        f[t] = m.rotate[t] * Math.abs(c * o);
                                    }),
                                    (n.style.zIndex = -Math.abs(Math.round(l)) + e.length);
                                const g = h.join(", "),
                                    v = `rotateX(${f[0]}deg) rotateY(${f[1]}deg) rotateZ(${f[2]}deg)`,
                                    b = u < 0 ? `scale(${1 + (1 - m.scale) * u * o})` : `scale(${1 - (1 - m.scale) * u * o})`,
                                    y = u < 0 ? 1 + (1 - m.opacity) * u * o : 1 - (1 - m.opacity) * u * o,
                                    w = `translate3d(${g}) ${v} ${b}`;
                                if ((p && m.shadow) || !p) {
                                    let e = n.querySelector(".swiper-slide-shadow");
                                    if ((!e && m.shadow && (e = z("creative", n)), e)) {
                                        const t = r.shadowPerProgress ? c * (1 / r.limitProgress) : c;
                                        e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                                    }
                                }
                                const x = L(0, n);
                                (x.style.transform = w), (x.style.opacity = y), m.origin && (x.style.transformOrigin = m.origin);
                            }
                        },
                        setTransition: (e) => {
                            const i = t.slides.map((e) => (0, r.l)(e));
                            i.forEach((t) => {
                                (t.style.transitionDuration = `${e}ms`),
                                    t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                                        t.style.transitionDuration = `${e}ms`;
                                    });
                            }),
                                k({ swiper: t, duration: e, transformElements: i, allSlides: !0 });
                        },
                        perspective: () => t.params.creativeEffect.perspective,
                        overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
                    });
                }
                function F(e) {
                    let { swiper: t, extendParams: i, on: n } = e;
                    i({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
                        O({
                            effect: "cards",
                            swiper: t,
                            on: n,
                            setTranslate: () => {
                                const { slides: e, activeIndex: i, rtlTranslate: n } = t,
                                    r = t.params.cardsEffect,
                                    { startTranslate: s, isTouched: o } = t.touchEventsData,
                                    a = n ? -t.translate : t.translate;
                                for (let l = 0; l < e.length; l += 1) {
                                    const c = e[l],
                                        u = c.progress,
                                        d = Math.min(Math.max(u, -4), 4);
                                    let h = c.swiperSlideOffset;
                                    t.params.centeredSlides && !t.params.cssMode && (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`), t.params.centeredSlides && t.params.cssMode && (h -= e[0].swiperSlideOffset);
                                    let f = t.params.cssMode ? -h - t.translate : -h,
                                        p = 0;
                                    const m = -100 * Math.abs(d);
                                    let g = 1,
                                        v = -r.perSlideRotate * d,
                                        b = r.perSlideOffset - 0.75 * Math.abs(d);
                                    const y = t.virtual && t.params.virtual.enabled ? t.virtual.from + l : l,
                                        w = (y === i || y === i - 1) && d > 0 && d < 1 && (o || t.params.cssMode) && a < s,
                                        x = (y === i || y === i + 1) && d < 0 && d > -1 && (o || t.params.cssMode) && a > s;
                                    if (w || x) {
                                        const e = (1 - Math.abs((Math.abs(d) - 0.5) / 0.5)) ** 0.5;
                                        (v += -28 * d * e), (g += -0.5 * e), (b += 96 * e), (p = -25 * e * Math.abs(d) + "%");
                                    }
                                    if (((f = d < 0 ? `calc(${f}px ${n ? "-" : "+"} (${b * Math.abs(d)}%))` : d > 0 ? `calc(${f}px ${n ? "-" : "+"} (-${b * Math.abs(d)}%))` : `${f}px`), !t.isHorizontal())) {
                                        const e = p;
                                        (p = f), (f = e);
                                    }
                                    const S = d < 0 ? "" + (1 + (1 - g) * d) : "" + (1 - (1 - g) * d),
                                        E = `\n        translate3d(${f}, ${p}, ${m}px)\n        rotateZ(${r.rotate ? (n ? -v : v) : 0}deg)\n        scale(${S})\n      `;
                                    if (r.slideShadows) {
                                        let e = c.querySelector(".swiper-slide-shadow");
                                        e || (e = z("cards", c)), e && (e.style.opacity = Math.min(Math.max((Math.abs(d) - 0.5) / 0.5, 0), 1));
                                    }
                                    (c.style.zIndex = -Math.abs(Math.round(u)) + e.length), (L(0, c).style.transform = E);
                                }
                            },
                            setTransition: (e) => {
                                const i = t.slides.map((e) => (0, r.l)(e));
                                i.forEach((t) => {
                                    (t.style.transitionDuration = `${e}ms`),
                                        t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                                            t.style.transitionDuration = `${e}ms`;
                                        });
                                }),
                                    k({ swiper: t, duration: e, transformElements: i });
                            },
                            perspective: () => !0,
                            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
                        });
                }
            },
            3433: function (e, t, i) {
                "use strict";
                function n(e) {
                    return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
                }
                function r(e, t) {
                    void 0 === e && (e = {}),
                        void 0 === t && (t = {}),
                        Object.keys(t).forEach((i) => {
                            void 0 === e[i] ? (e[i] = t[i]) : n(t[i]) && n(e[i]) && Object.keys(t[i]).length > 0 && r(e[i], t[i]);
                        });
                }
                i.d(t, {
                    a: function () {
                        return l;
                    },
                    g: function () {
                        return o;
                    },
                });
                const s = {
                    body: {},
                    addEventListener() {},
                    removeEventListener() {},
                    activeElement: { blur() {}, nodeName: "" },
                    querySelector() {
                        return null;
                    },
                    querySelectorAll() {
                        return [];
                    },
                    getElementById() {
                        return null;
                    },
                    createEvent() {
                        return { initEvent() {} };
                    },
                    createElement() {
                        return {
                            children: [],
                            childNodes: [],
                            style: {},
                            setAttribute() {},
                            getElementsByTagName() {
                                return [];
                            },
                        };
                    },
                    createElementNS() {
                        return {};
                    },
                    importNode() {
                        return null;
                    },
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                };
                function o() {
                    const e = "undefined" != typeof document ? document : {};
                    return r(e, s), e;
                }
                const a = {
                    document: s,
                    navigator: { userAgent: "" },
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
                    CustomEvent: function () {
                        return this;
                    },
                    addEventListener() {},
                    removeEventListener() {},
                    getComputedStyle() {
                        return {
                            getPropertyValue() {
                                return "";
                            },
                        };
                    },
                    Image() {},
                    Date() {},
                    screen: {},
                    setTimeout() {},
                    clearTimeout() {},
                    matchMedia() {
                        return {};
                    },
                    requestAnimationFrame(e) {
                        return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
                    },
                    cancelAnimationFrame(e) {
                        "undefined" != typeof setTimeout && clearTimeout(e);
                    },
                };
                function l() {
                    const e = "undefined" != typeof window ? window : {};
                    return r(e, a), e;
                }
            },
            7185: function (e, t, i) {
                "use strict";
                i.d(t, {
                    a: function () {
                        return S;
                    },
                    b: function () {
                        return v;
                    },
                    c: function () {
                        return g;
                    },
                    d: function () {
                        return a;
                    },
                    e: function () {
                        return p;
                    },
                    f: function () {
                        return _;
                    },
                    g: function () {
                        return x;
                    },
                    h: function () {
                        return r;
                    },
                    i: function () {
                        return l;
                    },
                    j: function () {
                        return E;
                    },
                    k: function () {
                        return c;
                    },
                    l: function () {
                        return f;
                    },
                    m: function () {
                        return w;
                    },
                    n: function () {
                        return o;
                    },
                    o: function () {
                        return y;
                    },
                    p: function () {
                        return b;
                    },
                    q: function () {
                        return h;
                    },
                    r: function () {
                        return m;
                    },
                    s: function () {
                        return d;
                    },
                    t: function () {
                        return u;
                    },
                    u: function () {
                        return s;
                    },
                });
                var n = i(3433);
                function r(e) {
                    return (
                        void 0 === e && (e = ""),
                        e
                            .trim()
                            .split(" ")
                            .filter((e) => !!e.trim())
                    );
                }
                function s(e) {
                    const t = e;
                    Object.keys(t).forEach((e) => {
                        try {
                            t[e] = null;
                        } catch (e) {}
                        try {
                            delete t[e];
                        } catch (e) {}
                    });
                }
                function o(e, t) {
                    return void 0 === t && (t = 0), setTimeout(e, t);
                }
                function a() {
                    return Date.now();
                }
                function l(e, t) {
                    void 0 === t && (t = "x");
                    const i = (0, n.a)();
                    let r, s, o;
                    const a = (function (e) {
                        const t = (0, n.a)();
                        let i;
                        return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
                    })(e);
                    return (
                        i.WebKitCSSMatrix
                            ? ((s = a.transform || a.webkitTransform),
                              s.split(",").length > 6 &&
                                  (s = s
                                      .split(", ")
                                      .map((e) => e.replace(",", "."))
                                      .join(", ")),
                              (o = new i.WebKitCSSMatrix("none" === s ? "" : s)))
                            : ((o = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (r = o.toString().split(","))),
                        "x" === t && (s = i.WebKitCSSMatrix ? o.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])),
                        "y" === t && (s = i.WebKitCSSMatrix ? o.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])),
                        s || 0
                    );
                }
                function c(e) {
                    return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
                }
                function u() {
                    const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
                        t = ["__proto__", "constructor", "prototype"];
                    for (let n = 1; n < arguments.length; n += 1) {
                        const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
                        if (null != r && ((i = r), !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
                            const i = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
                            for (let t = 0, n = i.length; t < n; t += 1) {
                                const n = i[t],
                                    s = Object.getOwnPropertyDescriptor(r, n);
                                void 0 !== s && s.enumerable && (c(e[n]) && c(r[n]) ? (r[n].__swiper__ ? (e[n] = r[n]) : u(e[n], r[n])) : !c(e[n]) && c(r[n]) ? ((e[n] = {}), r[n].__swiper__ ? (e[n] = r[n]) : u(e[n], r[n])) : (e[n] = r[n]));
                            }
                        }
                    }
                    var i;
                    return e;
                }
                function d(e, t, i) {
                    e.style.setProperty(t, i);
                }
                function h(e) {
                    let { swiper: t, targetPosition: i, side: r } = e;
                    const s = (0, n.a)(),
                        o = -t.translate;
                    let a,
                        l = null;
                    const c = t.params.speed;
                    (t.wrapperEl.style.scrollSnapType = "none"), s.cancelAnimationFrame(t.cssModeFrameID);
                    const u = i > o ? "next" : "prev",
                        d = (e, t) => ("next" === u && e >= t) || ("prev" === u && e <= t),
                        h = () => {
                            (a = new Date().getTime()), null === l && (l = a);
                            const e = Math.max(Math.min((a - l) / c, 1), 0),
                                n = 0.5 - Math.cos(e * Math.PI) / 2;
                            let u = o + n * (i - o);
                            if ((d(u, i) && (u = i), t.wrapperEl.scrollTo({ [r]: u }), d(u, i)))
                                return (
                                    (t.wrapperEl.style.overflow = "hidden"),
                                    (t.wrapperEl.style.scrollSnapType = ""),
                                    setTimeout(() => {
                                        (t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [r]: u });
                                    }),
                                    void s.cancelAnimationFrame(t.cssModeFrameID)
                                );
                            t.cssModeFrameID = s.requestAnimationFrame(h);
                        };
                    h();
                }
                function f(e) {
                    return e.querySelector(".swiper-slide-transform") || (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) || e;
                }
                function p(e, t) {
                    return void 0 === t && (t = ""), [...e.children].filter((e) => e.matches(t));
                }
                function m(e) {
                    try {
                        return void console.warn(e);
                    } catch (e) {}
                }
                function g(e, t) {
                    void 0 === t && (t = []);
                    const i = document.createElement(e);
                    return i.classList.add(...(Array.isArray(t) ? t : r(t))), i;
                }
                function v(e) {
                    const t = (0, n.a)(),
                        i = (0, n.g)(),
                        r = e.getBoundingClientRect(),
                        s = i.body,
                        o = e.clientTop || s.clientTop || 0,
                        a = e.clientLeft || s.clientLeft || 0,
                        l = e === t ? t.scrollY : e.scrollTop,
                        c = e === t ? t.scrollX : e.scrollLeft;
                    return { top: r.top + l - o, left: r.left + c - a };
                }
                function b(e, t) {
                    const i = [];
                    for (; e.previousElementSibling; ) {
                        const n = e.previousElementSibling;
                        t ? n.matches(t) && i.push(n) : i.push(n), (e = n);
                    }
                    return i;
                }
                function y(e, t) {
                    const i = [];
                    for (; e.nextElementSibling; ) {
                        const n = e.nextElementSibling;
                        t ? n.matches(t) && i.push(n) : i.push(n), (e = n);
                    }
                    return i;
                }
                function w(e, t) {
                    return (0, n.a)().getComputedStyle(e, null).getPropertyValue(t);
                }
                function x(e) {
                    let t,
                        i = e;
                    if (i) {
                        for (t = 0; null !== (i = i.previousSibling); ) 1 === i.nodeType && (t += 1);
                        return t;
                    }
                }
                function S(e, t) {
                    const i = [];
                    let n = e.parentElement;
                    for (; n; ) t ? n.matches(t) && i.push(n) : i.push(n), (n = n.parentElement);
                    return i;
                }
                function E(e, t) {
                    t &&
                        e.addEventListener("transitionend", function i(n) {
                            n.target === e && (t.call(e, n), e.removeEventListener("transitionend", i));
                        });
                }
                function _(e, t, i) {
                    const r = (0, n.a)();
                    return i
                        ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
                              parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) +
                              parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"))
                        : e.offsetWidth;
                }
            },
            7652: function (e, t, i) {
                "use strict";
                i.r(t),
                    i.d(t, {
                        Swiper: function () {
                            return A;
                        },
                        default: function () {
                            return A;
                        },
                    });
                var n = i(3433),
                    r = i(7185);
                let s, o, a;
                function l() {
                    return (
                        s ||
                            (s = (function () {
                                const e = (0, n.a)(),
                                    t = (0, n.g)();
                                return { smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style, touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)) };
                            })()),
                        s
                    );
                }
                var c = {
                    on(e, t, i) {
                        const n = this;
                        if (!n.eventsListeners || n.destroyed) return n;
                        if ("function" != typeof t) return n;
                        const r = i ? "unshift" : "push";
                        return (
                            e.split(" ").forEach((e) => {
                                n.eventsListeners[e] || (n.eventsListeners[e] = []), n.eventsListeners[e][r](t);
                            }),
                            n
                        );
                    },
                    once(e, t, i) {
                        const n = this;
                        if (!n.eventsListeners || n.destroyed) return n;
                        if ("function" != typeof t) return n;
                        function r() {
                            n.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
                            for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
                            t.apply(n, s);
                        }
                        return (r.__emitterProxy = t), n.on(e, r, i);
                    },
                    onAny(e, t) {
                        const i = this;
                        if (!i.eventsListeners || i.destroyed) return i;
                        if ("function" != typeof e) return i;
                        const n = t ? "unshift" : "push";
                        return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e), i;
                    },
                    offAny(e) {
                        const t = this;
                        if (!t.eventsListeners || t.destroyed) return t;
                        if (!t.eventsAnyListeners) return t;
                        const i = t.eventsAnyListeners.indexOf(e);
                        return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
                    },
                    off(e, t) {
                        const i = this;
                        return !i.eventsListeners || i.destroyed
                            ? i
                            : i.eventsListeners
                            ? (e.split(" ").forEach((e) => {
                                  void 0 === t
                                      ? (i.eventsListeners[e] = [])
                                      : i.eventsListeners[e] &&
                                        i.eventsListeners[e].forEach((n, r) => {
                                            (n === t || (n.__emitterProxy && n.__emitterProxy === t)) && i.eventsListeners[e].splice(r, 1);
                                        });
                              }),
                              i)
                            : i;
                    },
                    emit() {
                        const e = this;
                        if (!e.eventsListeners || e.destroyed) return e;
                        if (!e.eventsListeners) return e;
                        let t, i, n;
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            "string" == typeof s[0] || Array.isArray(s[0]) ? ((t = s[0]), (i = s.slice(1, s.length)), (n = e)) : ((t = s[0].events), (i = s[0].data), (n = s[0].context || e)),
                            i.unshift(n),
                            (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                                e.eventsAnyListeners &&
                                    e.eventsAnyListeners.length &&
                                    e.eventsAnyListeners.forEach((e) => {
                                        e.apply(n, [t, ...i]);
                                    }),
                                    e.eventsListeners &&
                                        e.eventsListeners[t] &&
                                        e.eventsListeners[t].forEach((e) => {
                                            e.apply(n, i);
                                        });
                            }),
                            e
                        );
                    },
                };
                const u = (e, t) => {
                        if (!e || e.destroyed || !e.params) return;
                        const i = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
                        if (i) {
                            let t = i.querySelector(`.${e.params.lazyPreloaderClass}`);
                            !t &&
                                e.isElement &&
                                (i.shadowRoot
                                    ? (t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`))
                                    : requestAnimationFrame(() => {
                                          i.shadowRoot && ((t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`)), t && t.remove());
                                      })),
                                t && t.remove();
                        }
                    },
                    d = (e, t) => {
                        if (!e.slides[t]) return;
                        const i = e.slides[t].querySelector('[loading="lazy"]');
                        i && i.removeAttribute("loading");
                    },
                    h = (e) => {
                        if (!e || e.destroyed || !e.params) return;
                        let t = e.params.lazyPreloadPrevNext;
                        const i = e.slides.length;
                        if (!i || !t || t < 0) return;
                        t = Math.min(t, i);
                        const n = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
                            r = e.activeIndex;
                        if (e.params.grid && e.params.grid.rows > 1) {
                            const i = r,
                                s = [i - t];
                            return (
                                s.push(...Array.from({ length: t }).map((e, t) => i + n + t)),
                                void e.slides.forEach((t, i) => {
                                    s.includes(t.column) && d(e, i);
                                })
                            );
                        }
                        const s = r + n - 1;
                        if (e.params.rewind || e.params.loop)
                            for (let n = r - t; n <= s + t; n += 1) {
                                const t = ((n % i) + i) % i;
                                (t < r || t > s) && d(e, t);
                            }
                        else for (let n = Math.max(r - t, 0); n <= Math.min(s + t, i - 1); n += 1) n !== r && (n > s || n < r) && d(e, n);
                    };
                var f = {
                    updateSize: function () {
                        const e = this;
                        let t, i;
                        const n = e.el;
                        (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : n.clientWidth),
                            (i = void 0 !== e.params.height && null !== e.params.height ? e.params.height : n.clientHeight),
                            (0 === t && e.isHorizontal()) ||
                                (0 === i && e.isVertical()) ||
                                ((t = t - parseInt((0, r.m)(n, "padding-left") || 0, 10) - parseInt((0, r.m)(n, "padding-right") || 0, 10)),
                                (i = i - parseInt((0, r.m)(n, "padding-top") || 0, 10) - parseInt((0, r.m)(n, "padding-bottom") || 0, 10)),
                                Number.isNaN(t) && (t = 0),
                                Number.isNaN(i) && (i = 0),
                                Object.assign(e, { width: t, height: i, size: e.isHorizontal() ? t : i }));
                    },
                    updateSlides: function () {
                        const e = this;
                        function t(t, i) {
                            return parseFloat(t.getPropertyValue(e.getDirectionLabel(i)) || 0);
                        }
                        const i = e.params,
                            { wrapperEl: n, slidesEl: s, size: o, rtlTranslate: a, wrongRTL: l } = e,
                            c = e.virtual && i.virtual.enabled,
                            u = c ? e.virtual.slides.length : e.slides.length,
                            d = (0, r.e)(s, `.${e.params.slideClass}, swiper-slide`),
                            h = c ? e.virtual.slides.length : d.length;
                        let f = [];
                        const p = [],
                            m = [];
                        let g = i.slidesOffsetBefore;
                        "function" == typeof g && (g = i.slidesOffsetBefore.call(e));
                        let v = i.slidesOffsetAfter;
                        "function" == typeof v && (v = i.slidesOffsetAfter.call(e));
                        const b = e.snapGrid.length,
                            y = e.slidesGrid.length;
                        let w = i.spaceBetween,
                            x = -g,
                            S = 0,
                            E = 0;
                        if (void 0 === o) return;
                        "string" == typeof w && w.indexOf("%") >= 0 ? (w = (parseFloat(w.replace("%", "")) / 100) * o) : "string" == typeof w && (w = parseFloat(w)),
                            (e.virtualSize = -w),
                            d.forEach((e) => {
                                a ? (e.style.marginLeft = "") : (e.style.marginRight = ""), (e.style.marginBottom = ""), (e.style.marginTop = "");
                            }),
                            i.centeredSlides && i.cssMode && ((0, r.s)(n, "--swiper-centered-offset-before", ""), (0, r.s)(n, "--swiper-centered-offset-after", ""));
                        const _ = i.grid && i.grid.rows > 1 && e.grid;
                        let T;
                        _ ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
                        const M = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView).length > 0;
                        for (let n = 0; n < h; n += 1) {
                            let s;
                            if (((T = 0), d[n] && (s = d[n]), _ && e.grid.updateSlide(n, s, d), !d[n] || "none" !== (0, r.m)(s, "display"))) {
                                if ("auto" === i.slidesPerView) {
                                    M && (d[n].style[e.getDirectionLabel("width")] = "");
                                    const o = getComputedStyle(s),
                                        a = s.style.transform,
                                        l = s.style.webkitTransform;
                                    if ((a && (s.style.transform = "none"), l && (s.style.webkitTransform = "none"), i.roundLengths)) T = e.isHorizontal() ? (0, r.f)(s, "width", !0) : (0, r.f)(s, "height", !0);
                                    else {
                                        const e = t(o, "width"),
                                            i = t(o, "padding-left"),
                                            n = t(o, "padding-right"),
                                            r = t(o, "margin-left"),
                                            a = t(o, "margin-right"),
                                            l = o.getPropertyValue("box-sizing");
                                        if (l && "border-box" === l) T = e + r + a;
                                        else {
                                            const { clientWidth: t, offsetWidth: o } = s;
                                            T = e + i + n + r + a + (o - t);
                                        }
                                    }
                                    a && (s.style.transform = a), l && (s.style.webkitTransform = l), i.roundLengths && (T = Math.floor(T));
                                } else (T = (o - (i.slidesPerView - 1) * w) / i.slidesPerView), i.roundLengths && (T = Math.floor(T)), d[n] && (d[n].style[e.getDirectionLabel("width")] = `${T}px`);
                                d[n] && (d[n].swiperSlideSize = T),
                                    m.push(T),
                                    i.centeredSlides
                                        ? ((x = x + T / 2 + S / 2 + w),
                                          0 === S && 0 !== n && (x = x - o / 2 - w),
                                          0 === n && (x = x - o / 2 - w),
                                          Math.abs(x) < 0.001 && (x = 0),
                                          i.roundLengths && (x = Math.floor(x)),
                                          E % i.slidesPerGroup == 0 && f.push(x),
                                          p.push(x))
                                        : (i.roundLengths && (x = Math.floor(x)), (E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup == 0 && f.push(x), p.push(x), (x = x + T + w)),
                                    (e.virtualSize += T + w),
                                    (S = T),
                                    (E += 1);
                            }
                        }
                        if (
                            ((e.virtualSize = Math.max(e.virtualSize, o) + v),
                            a && l && ("slide" === i.effect || "coverflow" === i.effect) && (n.style.width = `${e.virtualSize + w}px`),
                            i.setWrapperSize && (n.style[e.getDirectionLabel("width")] = `${e.virtualSize + w}px`),
                            _ && e.grid.updateWrapperSize(T, f),
                            !i.centeredSlides)
                        ) {
                            const t = [];
                            for (let n = 0; n < f.length; n += 1) {
                                let r = f[n];
                                i.roundLengths && (r = Math.floor(r)), f[n] <= e.virtualSize - o && t.push(r);
                            }
                            (f = t), Math.floor(e.virtualSize - o) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - o);
                        }
                        if (c && i.loop) {
                            const t = m[0] + w;
                            if (i.slidesPerGroup > 1) {
                                const n = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup),
                                    r = t * i.slidesPerGroup;
                                for (let e = 0; e < n; e += 1) f.push(f[f.length - 1] + r);
                            }
                            for (let n = 0; n < e.virtual.slidesBefore + e.virtual.slidesAfter; n += 1) 1 === i.slidesPerGroup && f.push(f[f.length - 1] + t), p.push(p[p.length - 1] + t), (e.virtualSize += t);
                        }
                        if ((0 === f.length && (f = [0]), 0 !== w)) {
                            const t = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
                            d.filter((e, t) => !(i.cssMode && !i.loop) || t !== d.length - 1).forEach((e) => {
                                e.style[t] = `${w}px`;
                            });
                        }
                        if (i.centeredSlides && i.centeredSlidesBounds) {
                            let e = 0;
                            m.forEach((t) => {
                                e += t + (w || 0);
                            }),
                                (e -= w);
                            const t = e - o;
                            f = f.map((e) => (e <= 0 ? -g : e > t ? t + v : e));
                        }
                        if (i.centerInsufficientSlides) {
                            let e = 0;
                            if (
                                (m.forEach((t) => {
                                    e += t + (w || 0);
                                }),
                                (e -= w),
                                e < o)
                            ) {
                                const t = (o - e) / 2;
                                f.forEach((e, i) => {
                                    f[i] = e - t;
                                }),
                                    p.forEach((e, i) => {
                                        p[i] = e + t;
                                    });
                            }
                        }
                        if ((Object.assign(e, { slides: d, snapGrid: f, slidesGrid: p, slidesSizesGrid: m }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)) {
                            (0, r.s)(n, "--swiper-centered-offset-before", -f[0] + "px"), (0, r.s)(n, "--swiper-centered-offset-after", e.size / 2 - m[m.length - 1] / 2 + "px");
                            const t = -e.snapGrid[0],
                                i = -e.slidesGrid[0];
                            (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + i));
                        }
                        if (
                            (h !== u && e.emit("slidesLengthChange"),
                            f.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                            p.length !== y && e.emit("slidesGridLengthChange"),
                            i.watchSlidesProgress && e.updateSlidesOffset(),
                            !(c || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
                        ) {
                            const t = `${i.containerModifierClass}backface-hidden`,
                                n = e.el.classList.contains(t);
                            h <= i.maxBackfaceHiddenSlides ? n || e.el.classList.add(t) : n && e.el.classList.remove(t);
                        }
                    },
                    updateAutoHeight: function (e) {
                        const t = this,
                            i = [],
                            n = t.virtual && t.params.virtual.enabled;
                        let r,
                            s = 0;
                        "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                        const o = (e) => (n ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
                        if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                            if (t.params.centeredSlides)
                                (t.visibleSlides || []).forEach((e) => {
                                    i.push(e);
                                });
                            else
                                for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                                    const e = t.activeIndex + r;
                                    if (e > t.slides.length && !n) break;
                                    i.push(o(e));
                                }
                        else i.push(o(t.activeIndex));
                        for (r = 0; r < i.length; r += 1)
                            if (void 0 !== i[r]) {
                                const e = i[r].offsetHeight;
                                s = e > s ? e : s;
                            }
                        (s || 0 === s) && (t.wrapperEl.style.height = `${s}px`);
                    },
                    updateSlidesOffset: function () {
                        const e = this,
                            t = e.slides,
                            i = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0;
                        for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = (e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop) - i - e.cssOverflowAdjustment();
                    },
                    updateSlidesProgress: function (e) {
                        void 0 === e && (e = (this && this.translate) || 0);
                        const t = this,
                            i = t.params,
                            { slides: n, rtlTranslate: r, snapGrid: s } = t;
                        if (0 === n.length) return;
                        void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
                        let o = -e;
                        r && (o = e),
                            n.forEach((e) => {
                                e.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass);
                            }),
                            (t.visibleSlidesIndexes = []),
                            (t.visibleSlides = []);
                        let a = i.spaceBetween;
                        "string" == typeof a && a.indexOf("%") >= 0 ? (a = (parseFloat(a.replace("%", "")) / 100) * t.size) : "string" == typeof a && (a = parseFloat(a));
                        for (let e = 0; e < n.length; e += 1) {
                            const l = n[e];
                            let c = l.swiperSlideOffset;
                            i.cssMode && i.centeredSlides && (c -= n[0].swiperSlideOffset);
                            const u = (o + (i.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + a),
                                d = (o - s[0] + (i.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + a),
                                h = -(o - c),
                                f = h + t.slidesSizesGrid[e],
                                p = h >= 0 && h <= t.size - t.slidesSizesGrid[e];
                            ((h >= 0 && h < t.size - 1) || (f > 1 && f <= t.size) || (h <= 0 && f >= t.size)) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(e), n[e].classList.add(i.slideVisibleClass)),
                                p && n[e].classList.add(i.slideFullyVisibleClass),
                                (l.progress = r ? -u : u),
                                (l.originalProgress = r ? -d : d);
                        }
                    },
                    updateProgress: function (e) {
                        const t = this;
                        if (void 0 === e) {
                            const i = t.rtlTranslate ? -1 : 1;
                            e = (t && t.translate && t.translate * i) || 0;
                        }
                        const i = t.params,
                            n = t.maxTranslate() - t.minTranslate();
                        let { progress: r, isBeginning: s, isEnd: o, progressLoop: a } = t;
                        const l = s,
                            c = o;
                        if (0 === n) (r = 0), (s = !0), (o = !0);
                        else {
                            r = (e - t.minTranslate()) / n;
                            const i = Math.abs(e - t.minTranslate()) < 1,
                                a = Math.abs(e - t.maxTranslate()) < 1;
                            (s = i || r <= 0), (o = a || r >= 1), i && (r = 0), a && (r = 1);
                        }
                        if (i.loop) {
                            const i = t.getSlideIndexByData(0),
                                n = t.getSlideIndexByData(t.slides.length - 1),
                                r = t.slidesGrid[i],
                                s = t.slidesGrid[n],
                                o = t.slidesGrid[t.slidesGrid.length - 1],
                                l = Math.abs(e);
                            (a = l >= r ? (l - r) / o : (l + o - s) / o), a > 1 && (a -= 1);
                        }
                        Object.assign(t, { progress: r, progressLoop: a, isBeginning: s, isEnd: o }),
                            (i.watchSlidesProgress || (i.centeredSlides && i.autoHeight)) && t.updateSlidesProgress(e),
                            s && !l && t.emit("reachBeginning toEdge"),
                            o && !c && t.emit("reachEnd toEdge"),
                            ((l && !s) || (c && !o)) && t.emit("fromEdge"),
                            t.emit("progress", r);
                    },
                    updateSlidesClasses: function () {
                        const e = this,
                            { slides: t, params: i, slidesEl: n, activeIndex: s } = e,
                            o = e.virtual && i.virtual.enabled,
                            a = e.grid && i.grid && i.grid.rows > 1,
                            l = (e) => (0, r.e)(n, `.${i.slideClass}${e}, swiper-slide${e}`)[0];
                        let c, u, d;
                        if (
                            (t.forEach((e) => {
                                e.classList.remove(i.slideActiveClass, i.slideNextClass, i.slidePrevClass);
                            }),
                            o)
                        )
                            if (i.loop) {
                                let t = s - e.virtual.slidesBefore;
                                t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), (c = l(`[data-swiper-slide-index="${t}"]`));
                            } else c = l(`[data-swiper-slide-index="${s}"]`);
                        else a ? ((c = t.filter((e) => e.column === s)[0]), (d = t.filter((e) => e.column === s + 1)[0]), (u = t.filter((e) => e.column === s - 1)[0])) : (c = t[s]);
                        c &&
                            (c.classList.add(i.slideActiveClass),
                            a
                                ? (d && d.classList.add(i.slideNextClass), u && u.classList.add(i.slidePrevClass))
                                : ((d = (0, r.o)(c, `.${i.slideClass}, swiper-slide`)[0]),
                                  i.loop && !d && (d = t[0]),
                                  d && d.classList.add(i.slideNextClass),
                                  (u = (0, r.p)(c, `.${i.slideClass}, swiper-slide`)[0]),
                                  i.loop && 0 === !u && (u = t[t.length - 1]),
                                  u && u.classList.add(i.slidePrevClass))),
                            e.emitSlidesClasses();
                    },
                    updateActiveIndex: function (e) {
                        const t = this,
                            i = t.rtlTranslate ? t.translate : -t.translate,
                            { snapGrid: n, params: r, activeIndex: s, realIndex: o, snapIndex: a } = t;
                        let l,
                            c = e;
                        const u = (e) => {
                            let i = e - t.virtual.slidesBefore;
                            return i < 0 && (i = t.virtual.slides.length + i), i >= t.virtual.slides.length && (i -= t.virtual.slides.length), i;
                        };
                        if (
                            (void 0 === c &&
                                (c = (function (e) {
                                    const { slidesGrid: t, params: i } = e,
                                        n = e.rtlTranslate ? e.translate : -e.translate;
                                    let r;
                                    for (let e = 0; e < t.length; e += 1) void 0 !== t[e + 1] ? (n >= t[e] && n < t[e + 1] - (t[e + 1] - t[e]) / 2 ? (r = e) : n >= t[e] && n < t[e + 1] && (r = e + 1)) : n >= t[e] && (r = e);
                                    return i.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r;
                                })(t)),
                            n.indexOf(i) >= 0)
                        )
                            l = n.indexOf(i);
                        else {
                            const e = Math.min(r.slidesPerGroupSkip, c);
                            l = e + Math.floor((c - e) / r.slidesPerGroup);
                        }
                        if ((l >= n.length && (l = n.length - 1), c === s && !t.params.loop)) return void (l !== a && ((t.snapIndex = l), t.emit("snapIndexChange")));
                        if (c === s && t.params.loop && t.virtual && t.params.virtual.enabled) return void (t.realIndex = u(c));
                        const d = t.grid && r.grid && r.grid.rows > 1;
                        let f;
                        if (t.virtual && r.virtual.enabled && r.loop) f = u(c);
                        else if (d) {
                            const e = t.slides.filter((e) => e.column === c)[0];
                            let i = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
                            Number.isNaN(i) && (i = Math.max(t.slides.indexOf(e), 0)), (f = Math.floor(i / r.grid.rows));
                        } else if (t.slides[c]) {
                            const e = t.slides[c].getAttribute("data-swiper-slide-index");
                            f = e ? parseInt(e, 10) : c;
                        } else f = c;
                        Object.assign(t, { previousSnapIndex: a, snapIndex: l, previousRealIndex: o, realIndex: f, previousIndex: s, activeIndex: c }),
                            t.initialized && h(t),
                            t.emit("activeIndexChange"),
                            t.emit("snapIndexChange"),
                            (t.initialized || t.params.runCallbacksOnInit) && (o !== f && t.emit("realIndexChange"), t.emit("slideChange"));
                    },
                    updateClickedSlide: function (e, t) {
                        const i = this,
                            n = i.params;
                        let r = e.closest(`.${n.slideClass}, swiper-slide`);
                        !r &&
                            i.isElement &&
                            t &&
                            t.length > 1 &&
                            t.includes(e) &&
                            [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
                                !r && e.matches && e.matches(`.${n.slideClass}, swiper-slide`) && (r = e);
                            });
                        let s,
                            o = !1;
                        if (r)
                            for (let e = 0; e < i.slides.length; e += 1)
                                if (i.slides[e] === r) {
                                    (o = !0), (s = e);
                                    break;
                                }
                        if (!r || !o) return (i.clickedSlide = void 0), void (i.clickedIndex = void 0);
                        (i.clickedSlide = r),
                            i.virtual && i.params.virtual.enabled ? (i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10)) : (i.clickedIndex = s),
                            n.slideToClickedSlide && void 0 !== i.clickedIndex && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
                    },
                };
                function p(e) {
                    let { swiper: t, runCallbacks: i, direction: n, step: r } = e;
                    const { activeIndex: s, previousIndex: o } = t;
                    let a = n;
                    if ((a || (a = s > o ? "next" : s < o ? "prev" : "reset"), t.emit(`transition${r}`), i && s !== o)) {
                        if ("reset" === a) return void t.emit(`slideResetTransition${r}`);
                        t.emit(`slideChangeTransition${r}`), "next" === a ? t.emit(`slideNextTransition${r}`) : t.emit(`slidePrevTransition${r}`);
                    }
                }
                var m = {
                        slideTo: function (e, t, i, n, s) {
                            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                            const o = this;
                            let a = e;
                            a < 0 && (a = 0);
                            const { params: l, snapGrid: c, slidesGrid: u, previousIndex: d, activeIndex: h, rtlTranslate: f, wrapperEl: p, enabled: m } = o;
                            if ((o.animating && l.preventInteractionOnTransition) || (!m && !n && !s)) return !1;
                            const g = Math.min(o.params.slidesPerGroupSkip, a);
                            let v = g + Math.floor((a - g) / o.params.slidesPerGroup);
                            v >= c.length && (v = c.length - 1);
                            const b = -c[v];
                            if (l.normalizeSlideIndex)
                                for (let e = 0; e < u.length; e += 1) {
                                    const t = -Math.floor(100 * b),
                                        i = Math.floor(100 * u[e]),
                                        n = Math.floor(100 * u[e + 1]);
                                    void 0 !== u[e + 1] ? (t >= i && t < n - (n - i) / 2 ? (a = e) : t >= i && t < n && (a = e + 1)) : t >= i && (a = e);
                                }
                            if (o.initialized && a !== h) {
                                if (!o.allowSlideNext && (f ? b > o.translate && b > o.minTranslate() : b < o.translate && b < o.minTranslate())) return !1;
                                if (!o.allowSlidePrev && b > o.translate && b > o.maxTranslate() && (h || 0) !== a) return !1;
                            }
                            let y;
                            if ((a !== (d || 0) && i && o.emit("beforeSlideChangeStart"), o.updateProgress(b), (y = a > h ? "next" : a < h ? "prev" : "reset"), (f && -b === o.translate) || (!f && b === o.translate)))
                                return o.updateActiveIndex(a), l.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== l.effect && o.setTranslate(b), "reset" !== y && (o.transitionStart(i, y), o.transitionEnd(i, y)), !1;
                            if (l.cssMode) {
                                const e = o.isHorizontal(),
                                    i = f ? b : -b;
                                if (0 === t) {
                                    const t = o.virtual && o.params.virtual.enabled;
                                    t && ((o.wrapperEl.style.scrollSnapType = "none"), (o._immediateVirtual = !0)),
                                        t && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0
                                            ? ((o._cssModeVirtualInitialSet = !0),
                                              requestAnimationFrame(() => {
                                                  p[e ? "scrollLeft" : "scrollTop"] = i;
                                              }))
                                            : (p[e ? "scrollLeft" : "scrollTop"] = i),
                                        t &&
                                            requestAnimationFrame(() => {
                                                (o.wrapperEl.style.scrollSnapType = ""), (o._immediateVirtual = !1);
                                            });
                                } else {
                                    if (!o.support.smoothScroll) return (0, r.q)({ swiper: o, targetPosition: i, side: e ? "left" : "top" }), !0;
                                    p.scrollTo({ [e ? "left" : "top"]: i, behavior: "smooth" });
                                }
                                return !0;
                            }
                            return (
                                o.setTransition(t),
                                o.setTranslate(b),
                                o.updateActiveIndex(a),
                                o.updateSlidesClasses(),
                                o.emit("beforeTransitionStart", t, n),
                                o.transitionStart(i, y),
                                0 === t
                                    ? o.transitionEnd(i, y)
                                    : o.animating ||
                                      ((o.animating = !0),
                                      o.onSlideToWrapperTransitionEnd ||
                                          (o.onSlideToWrapperTransitionEnd = function (e) {
                                              o &&
                                                  !o.destroyed &&
                                                  e.target === this &&
                                                  (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), (o.onSlideToWrapperTransitionEnd = null), delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(i, y));
                                          }),
                                      o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)),
                                !0
                            );
                        },
                        slideToLoop: function (e, t, i, n) {
                            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                            const r = this,
                                s = r.grid && r.params.grid && r.params.grid.rows > 1;
                            let o = e;
                            if (r.params.loop)
                                if (r.virtual && r.params.virtual.enabled) o += r.virtual.slidesBefore;
                                else {
                                    let e;
                                    if (s) {
                                        const t = o * r.params.grid.rows;
                                        e = r.slides.filter((e) => 1 * e.getAttribute("data-swiper-slide-index") === t)[0].column;
                                    } else e = r.getSlideIndexByData(o);
                                    const t = s ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length,
                                        { centeredSlides: i } = r.params;
                                    let n = r.params.slidesPerView;
                                    "auto" === n ? (n = r.slidesPerViewDynamic()) : ((n = Math.ceil(parseFloat(r.params.slidesPerView, 10))), i && n % 2 == 0 && (n += 1));
                                    let a = t - e < n;
                                    if ((i && (a = a || e < Math.ceil(n / 2)), a)) {
                                        const n = i ? (e < r.activeIndex ? "prev" : "next") : e - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
                                        r.loopFix({ direction: n, slideTo: !0, activeSlideIndex: "next" === n ? e + 1 : e - t + 1, slideRealIndex: "next" === n ? r.realIndex : void 0 });
                                    }
                                    if (s) {
                                        const e = o * r.params.grid.rows;
                                        o = r.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0].column;
                                    } else o = r.getSlideIndexByData(o);
                                }
                            return (
                                requestAnimationFrame(() => {
                                    r.slideTo(o, t, i, n);
                                }),
                                r
                            );
                        },
                        slideNext: function (e, t, i) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                            const n = this,
                                { enabled: r, params: s, animating: o } = n;
                            if (!r) return n;
                            let a = s.slidesPerGroup;
                            "auto" === s.slidesPerView && 1 === s.slidesPerGroup && s.slidesPerGroupAuto && (a = Math.max(n.slidesPerViewDynamic("current", !0), 1));
                            const l = n.activeIndex < s.slidesPerGroupSkip ? 1 : a,
                                c = n.virtual && s.virtual.enabled;
                            if (s.loop) {
                                if (o && !c && s.loopPreventsSliding) return !1;
                                if ((n.loopFix({ direction: "next" }), (n._clientLeft = n.wrapperEl.clientLeft), n.activeIndex === n.slides.length - 1 && s.cssMode))
                                    return (
                                        requestAnimationFrame(() => {
                                            n.slideTo(n.activeIndex + l, e, t, i);
                                        }),
                                        !0
                                    );
                            }
                            return s.rewind && n.isEnd ? n.slideTo(0, e, t, i) : n.slideTo(n.activeIndex + l, e, t, i);
                        },
                        slidePrev: function (e, t, i) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                            const n = this,
                                { params: r, snapGrid: s, slidesGrid: o, rtlTranslate: a, enabled: l, animating: c } = n;
                            if (!l) return n;
                            const u = n.virtual && r.virtual.enabled;
                            if (r.loop) {
                                if (c && !u && r.loopPreventsSliding) return !1;
                                n.loopFix({ direction: "prev" }), (n._clientLeft = n.wrapperEl.clientLeft);
                            }
                            function d(e) {
                                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                            }
                            const h = d(a ? n.translate : -n.translate),
                                f = s.map((e) => d(e));
                            let p = s[f.indexOf(h) - 1];
                            if (void 0 === p && r.cssMode) {
                                let e;
                                s.forEach((t, i) => {
                                    h >= t && (e = i);
                                }),
                                    void 0 !== e && (p = s[e > 0 ? e - 1 : e]);
                            }
                            let m = 0;
                            if (
                                (void 0 !== p &&
                                    ((m = o.indexOf(p)),
                                    m < 0 && (m = n.activeIndex - 1),
                                    "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && ((m = m - n.slidesPerViewDynamic("previous", !0) + 1), (m = Math.max(m, 0)))),
                                r.rewind && n.isBeginning)
                            ) {
                                const r = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
                                return n.slideTo(r, e, t, i);
                            }
                            return r.loop && 0 === n.activeIndex && r.cssMode
                                ? (requestAnimationFrame(() => {
                                      n.slideTo(m, e, t, i);
                                  }),
                                  !0)
                                : n.slideTo(m, e, t, i);
                        },
                        slideReset: function (e, t, i) {
                            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i);
                        },
                        slideToClosest: function (e, t, i, n) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === n && (n = 0.5);
                            const r = this;
                            let s = r.activeIndex;
                            const o = Math.min(r.params.slidesPerGroupSkip, s),
                                a = o + Math.floor((s - o) / r.params.slidesPerGroup),
                                l = r.rtlTranslate ? r.translate : -r.translate;
                            if (l >= r.snapGrid[a]) {
                                const e = r.snapGrid[a];
                                l - e > (r.snapGrid[a + 1] - e) * n && (s += r.params.slidesPerGroup);
                            } else {
                                const e = r.snapGrid[a - 1];
                                l - e <= (r.snapGrid[a] - e) * n && (s -= r.params.slidesPerGroup);
                            }
                            return (s = Math.max(s, 0)), (s = Math.min(s, r.slidesGrid.length - 1)), r.slideTo(s, e, t, i);
                        },
                        slideToClickedSlide: function () {
                            const e = this,
                                { params: t, slidesEl: i } = e,
                                n = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                            let s,
                                o = e.clickedIndex;
                            const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
                            if (t.loop) {
                                if (e.animating) return;
                                (s = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
                                    t.centeredSlides
                                        ? o < e.loopedSlides - n / 2 || o > e.slides.length - e.loopedSlides + n / 2
                                            ? (e.loopFix(),
                                              (o = e.getSlideIndex((0, r.e)(i, `${a}[data-swiper-slide-index="${s}"]`)[0])),
                                              (0, r.n)(() => {
                                                  e.slideTo(o);
                                              }))
                                            : e.slideTo(o)
                                        : o > e.slides.length - n
                                        ? (e.loopFix(),
                                          (o = e.getSlideIndex((0, r.e)(i, `${a}[data-swiper-slide-index="${s}"]`)[0])),
                                          (0, r.n)(() => {
                                              e.slideTo(o);
                                          }))
                                        : e.slideTo(o);
                            } else e.slideTo(o);
                        },
                    },
                    g = {
                        loopCreate: function (e) {
                            const t = this,
                                { params: i, slidesEl: n } = t;
                            if (!i.loop || (t.virtual && t.params.virtual.enabled)) return;
                            const s = () => {
                                    (0, r.e)(n, `.${i.slideClass}, swiper-slide`).forEach((e, t) => {
                                        e.setAttribute("data-swiper-slide-index", t);
                                    });
                                },
                                o = t.grid && i.grid && i.grid.rows > 1,
                                a = i.slidesPerGroup * (o ? i.grid.rows : 1),
                                l = t.slides.length % a != 0,
                                c = o && t.slides.length % i.grid.rows != 0,
                                u = (e) => {
                                    for (let n = 0; n < e; n += 1) {
                                        const e = t.isElement ? (0, r.c)("swiper-slide", [i.slideBlankClass]) : (0, r.c)("div", [i.slideClass, i.slideBlankClass]);
                                        t.slidesEl.append(e);
                                    }
                                };
                            l
                                ? (i.loopAddBlankSlides
                                      ? (u(a - (t.slides.length % a)), t.recalcSlides(), t.updateSlides())
                                      : (0, r.r)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"),
                                  s())
                                : c
                                ? (i.loopAddBlankSlides
                                      ? (u(i.grid.rows - (t.slides.length % i.grid.rows)), t.recalcSlides(), t.updateSlides())
                                      : (0, r.r)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"),
                                  s())
                                : s(),
                                t.loopFix({ slideRealIndex: e, direction: i.centeredSlides ? void 0 : "next" });
                        },
                        loopFix: function (e) {
                            let { slideRealIndex: t, slideTo: i = !0, direction: n, setTranslate: s, activeSlideIndex: o, byController: a, byMousewheel: l } = void 0 === e ? {} : e;
                            const c = this;
                            if (!c.params.loop) return;
                            c.emit("beforeLoopFix");
                            const { slides: u, allowSlidePrev: d, allowSlideNext: h, slidesEl: f, params: p } = c,
                                { centeredSlides: m } = p;
                            if (((c.allowSlidePrev = !0), (c.allowSlideNext = !0), c.virtual && p.virtual.enabled))
                                return (
                                    i &&
                                        (p.centeredSlides || 0 !== c.snapIndex
                                            ? p.centeredSlides && c.snapIndex < p.slidesPerView
                                                ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0)
                                                : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)
                                            : c.slideTo(c.virtual.slides.length, 0, !1, !0)),
                                    (c.allowSlidePrev = d),
                                    (c.allowSlideNext = h),
                                    void c.emit("loopFix")
                                );
                            let g = p.slidesPerView;
                            "auto" === g ? (g = c.slidesPerViewDynamic()) : ((g = Math.ceil(parseFloat(p.slidesPerView, 10))), m && g % 2 == 0 && (g += 1));
                            const v = p.slidesPerGroupAuto ? g : p.slidesPerGroup;
                            let b = v;
                            b % v != 0 && (b += v - (b % v)), (b += p.loopAdditionalSlides), (c.loopedSlides = b);
                            const y = c.grid && p.grid && p.grid.rows > 1;
                            u.length < g + b
                                ? (0, r.r)(
                                      "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
                                  )
                                : y && "row" === p.grid.fill && (0, r.r)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
                            const w = [],
                                x = [];
                            let S = c.activeIndex;
                            void 0 === o ? (o = c.getSlideIndex(u.filter((e) => e.classList.contains(p.slideActiveClass))[0])) : (S = o);
                            const E = "next" === n || !n,
                                _ = "prev" === n || !n;
                            let T = 0,
                                M = 0;
                            const P = y ? Math.ceil(u.length / p.grid.rows) : u.length,
                                C = (y ? u[o].column : o) + (m && void 0 === s ? -g / 2 + 0.5 : 0);
                            if (C < b) {
                                T = Math.max(b - C, v);
                                for (let e = 0; e < b - C; e += 1) {
                                    const t = e - Math.floor(e / P) * P;
                                    if (y) {
                                        const e = P - t - 1;
                                        for (let t = u.length - 1; t >= 0; t -= 1) u[t].column === e && w.push(t);
                                    } else w.push(P - t - 1);
                                }
                            } else if (C + g > P - b) {
                                M = Math.max(C - (P - 2 * b), v);
                                for (let e = 0; e < M; e += 1) {
                                    const t = e - Math.floor(e / P) * P;
                                    y
                                        ? u.forEach((e, i) => {
                                              e.column === t && x.push(i);
                                          })
                                        : x.push(t);
                                }
                            }
                            if (
                                ((c.__preventObserver__ = !0),
                                requestAnimationFrame(() => {
                                    c.__preventObserver__ = !1;
                                }),
                                _ &&
                                    w.forEach((e) => {
                                        (u[e].swiperLoopMoveDOM = !0), f.prepend(u[e]), (u[e].swiperLoopMoveDOM = !1);
                                    }),
                                E &&
                                    x.forEach((e) => {
                                        (u[e].swiperLoopMoveDOM = !0), f.append(u[e]), (u[e].swiperLoopMoveDOM = !1);
                                    }),
                                c.recalcSlides(),
                                "auto" === p.slidesPerView
                                    ? c.updateSlides()
                                    : y &&
                                      ((w.length > 0 && _) || (x.length > 0 && E)) &&
                                      c.slides.forEach((e, t) => {
                                          c.grid.updateSlide(t, e, c.slides);
                                      }),
                                p.watchSlidesProgress && c.updateSlidesOffset(),
                                i)
                            )
                                if (w.length > 0 && _) {
                                    if (void 0 === t) {
                                        const e = c.slidesGrid[S],
                                            t = c.slidesGrid[S + T] - e;
                                        l
                                            ? c.setTranslate(c.translate - t)
                                            : (c.slideTo(S + T, 0, !1, !0), s && ((c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t), (c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t)));
                                    } else if (s) {
                                        const e = y ? w.length / p.grid.rows : w.length;
                                        c.slideTo(c.activeIndex + e, 0, !1, !0), (c.touchEventsData.currentTranslate = c.translate);
                                    }
                                } else if (x.length > 0 && E)
                                    if (void 0 === t) {
                                        const e = c.slidesGrid[S],
                                            t = c.slidesGrid[S - M] - e;
                                        l
                                            ? c.setTranslate(c.translate - t)
                                            : (c.slideTo(S - M, 0, !1, !0), s && ((c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t), (c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t)));
                                    } else {
                                        const e = y ? x.length / p.grid.rows : x.length;
                                        c.slideTo(c.activeIndex - e, 0, !1, !0);
                                    }
                            if (((c.allowSlidePrev = d), (c.allowSlideNext = h), c.controller && c.controller.control && !a)) {
                                const e = { slideRealIndex: t, direction: n, setTranslate: s, activeSlideIndex: o, byController: !0 };
                                Array.isArray(c.controller.control)
                                    ? c.controller.control.forEach((t) => {
                                          !t.destroyed && t.params.loop && t.loopFix({ ...e, slideTo: t.params.slidesPerView === p.slidesPerView && i });
                                      })
                                    : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({ ...e, slideTo: c.controller.control.params.slidesPerView === p.slidesPerView && i });
                            }
                            c.emit("loopFix");
                        },
                        loopDestroy: function () {
                            const e = this,
                                { params: t, slidesEl: i } = e;
                            if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
                            e.recalcSlides();
                            const n = [];
                            e.slides.forEach((e) => {
                                const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                                n[t] = e;
                            }),
                                e.slides.forEach((e) => {
                                    e.removeAttribute("data-swiper-slide-index");
                                }),
                                n.forEach((e) => {
                                    i.append(e);
                                }),
                                e.recalcSlides(),
                                e.slideTo(e.realIndex, 0);
                        },
                    };
                function v(e, t, i) {
                    const r = (0, n.a)(),
                        { params: s } = e,
                        o = s.edgeSwipeDetection,
                        a = s.edgeSwipeThreshold;
                    return !o || !(i <= a || i >= r.innerWidth - a) || ("prevent" === o && (t.preventDefault(), !0));
                }
                function b(e) {
                    const t = this,
                        i = (0, n.g)();
                    let s = e;
                    s.originalEvent && (s = s.originalEvent);
                    const o = t.touchEventsData;
                    if ("pointerdown" === s.type) {
                        if (null !== o.pointerId && o.pointerId !== s.pointerId) return;
                        o.pointerId = s.pointerId;
                    } else "touchstart" === s.type && 1 === s.targetTouches.length && (o.touchId = s.targetTouches[0].identifier);
                    if ("touchstart" === s.type) return void v(t, s, s.targetTouches[0].pageX);
                    const { params: a, touches: l, enabled: c } = t;
                    if (!c) return;
                    if (!a.simulateTouch && "mouse" === s.pointerType) return;
                    if (t.animating && a.preventInteractionOnTransition) return;
                    !t.animating && a.cssMode && a.loop && t.loopFix();
                    let u = s.target;
                    if ("wrapper" === a.touchEventsTarget && !t.wrapperEl.contains(u)) return;
                    if ("which" in s && 3 === s.which) return;
                    if ("button" in s && s.button > 0) return;
                    if (o.isTouched && o.isMoved) return;
                    const d = !!a.noSwipingClass && "" !== a.noSwipingClass,
                        h = s.composedPath ? s.composedPath() : s.path;
                    d && s.target && s.target.shadowRoot && h && (u = h[0]);
                    const f = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
                        p = !(!s.target || !s.target.shadowRoot);
                    if (
                        a.noSwiping &&
                        (p
                            ? (function (e, t) {
                                  return (
                                      void 0 === t && (t = this),
                                      (function t(i) {
                                          if (!i || i === (0, n.g)() || i === (0, n.a)()) return null;
                                          i.assignedSlot && (i = i.assignedSlot);
                                          const r = i.closest(e);
                                          return r || i.getRootNode ? r || t(i.getRootNode().host) : null;
                                      })(t)
                                  );
                              })(f, u)
                            : u.closest(f))
                    )
                        return void (t.allowClick = !0);
                    if (a.swipeHandler && !u.closest(a.swipeHandler)) return;
                    (l.currentX = s.pageX), (l.currentY = s.pageY);
                    const m = l.currentX,
                        g = l.currentY;
                    if (!v(t, s, m)) return;
                    Object.assign(o, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                        (l.startX = m),
                        (l.startY = g),
                        (o.touchStartTime = (0, r.d)()),
                        (t.allowClick = !0),
                        t.updateSize(),
                        (t.swipeDirection = void 0),
                        a.threshold > 0 && (o.allowThresholdMove = !1);
                    let b = !0;
                    u.matches(o.focusableElements) && ((b = !1), "SELECT" === u.nodeName && (o.isTouched = !1)), i.activeElement && i.activeElement.matches(o.focusableElements) && i.activeElement !== u && i.activeElement.blur();
                    const y = b && t.allowTouchMove && a.touchStartPreventDefault;
                    (!a.touchStartForcePreventDefault && !y) || u.isContentEditable || s.preventDefault(), a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
                }
                function y(e) {
                    const t = (0, n.g)(),
                        i = this,
                        s = i.touchEventsData,
                        { params: o, touches: a, rtlTranslate: l, enabled: c } = i;
                    if (!c) return;
                    if (!o.simulateTouch && "mouse" === e.pointerType) return;
                    let u,
                        d = e;
                    if ((d.originalEvent && (d = d.originalEvent), "pointermove" === d.type)) {
                        if (null !== s.touchId) return;
                        if (d.pointerId !== s.pointerId) return;
                    }
                    if ("touchmove" === d.type) {
                        if (((u = [...d.changedTouches].filter((e) => e.identifier === s.touchId)[0]), !u || u.identifier !== s.touchId)) return;
                    } else u = d;
                    if (!s.isTouched) return void (s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", d));
                    const h = u.pageX,
                        f = u.pageY;
                    if (d.preventedByNestedSwiper) return (a.startX = h), void (a.startY = f);
                    if (!i.allowTouchMove) return d.target.matches(s.focusableElements) || (i.allowClick = !1), void (s.isTouched && (Object.assign(a, { startX: h, startY: f, currentX: h, currentY: f }), (s.touchStartTime = (0, r.d)())));
                    if (o.touchReleaseOnEdges && !o.loop)
                        if (i.isVertical()) {
                            if ((f < a.startY && i.translate <= i.maxTranslate()) || (f > a.startY && i.translate >= i.minTranslate())) return (s.isTouched = !1), void (s.isMoved = !1);
                        } else if ((h < a.startX && i.translate <= i.maxTranslate()) || (h > a.startX && i.translate >= i.minTranslate())) return;
                    if (t.activeElement && d.target === t.activeElement && d.target.matches(s.focusableElements)) return (s.isMoved = !0), void (i.allowClick = !1);
                    s.allowTouchCallbacks && i.emit("touchMove", d), (a.previousX = a.currentX), (a.previousY = a.currentY), (a.currentX = h), (a.currentY = f);
                    const p = a.currentX - a.startX,
                        m = a.currentY - a.startY;
                    if (i.params.threshold && Math.sqrt(p ** 2 + m ** 2) < i.params.threshold) return;
                    if (void 0 === s.isScrolling) {
                        let e;
                        (i.isHorizontal() && a.currentY === a.startY) || (i.isVertical() && a.currentX === a.startX)
                            ? (s.isScrolling = !1)
                            : p * p + m * m >= 25 && ((e = (180 * Math.atan2(Math.abs(m), Math.abs(p))) / Math.PI), (s.isScrolling = i.isHorizontal() ? e > o.touchAngle : 90 - e > o.touchAngle));
                    }
                    if ((s.isScrolling && i.emit("touchMoveOpposite", d), void 0 === s.startMoving && ((a.currentX === a.startX && a.currentY === a.startY) || (s.startMoving = !0)), s.isScrolling)) return void (s.isTouched = !1);
                    if (!s.startMoving) return;
                    (i.allowClick = !1), !o.cssMode && d.cancelable && d.preventDefault(), o.touchMoveStopPropagation && !o.nested && d.stopPropagation();
                    let g = i.isHorizontal() ? p : m,
                        v = i.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
                    o.oneWayMovement && ((g = Math.abs(g) * (l ? 1 : -1)), (v = Math.abs(v) * (l ? 1 : -1))), (a.diff = g), (g *= o.touchRatio), l && ((g = -g), (v = -v));
                    const b = i.touchesDirection;
                    (i.swipeDirection = g > 0 ? "prev" : "next"), (i.touchesDirection = v > 0 ? "prev" : "next");
                    const y = i.params.loop && !o.cssMode,
                        w = ("next" === i.touchesDirection && i.allowSlideNext) || ("prev" === i.touchesDirection && i.allowSlidePrev);
                    if (!s.isMoved) {
                        if ((y && w && i.loopFix({ direction: i.swipeDirection }), (s.startTranslate = i.getTranslate()), i.setTransition(0), i.animating)) {
                            const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                            i.wrapperEl.dispatchEvent(e);
                        }
                        (s.allowMomentumBounce = !1), !o.grabCursor || (!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) || i.setGrabCursor(!0), i.emit("sliderFirstMove", d);
                    }
                    if ((new Date().getTime(), s.isMoved && s.allowThresholdMove && b !== i.touchesDirection && y && w && Math.abs(g) >= 1))
                        return Object.assign(a, { startX: h, startY: f, currentX: h, currentY: f, startTranslate: s.currentTranslate }), (s.loopSwapReset = !0), void (s.startTranslate = s.currentTranslate);
                    i.emit("sliderMove", d), (s.isMoved = !0), (s.currentTranslate = g + s.startTranslate);
                    let x = !0,
                        S = o.resistanceRatio;
                    if (
                        (o.touchReleaseOnEdges && (S = 0),
                        g > 0
                            ? (y &&
                                  w &&
                                  s.allowThresholdMove &&
                                  s.currentTranslate > (o.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] : i.minTranslate()) &&
                                  i.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
                              s.currentTranslate > i.minTranslate() && ((x = !1), o.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + g) ** S)))
                            : g < 0 &&
                              (y &&
                                  w &&
                                  s.allowThresholdMove &&
                                  s.currentTranslate < (o.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] : i.maxTranslate()) &&
                                  i.loopFix({ direction: "next", setTranslate: !0, activeSlideIndex: i.slides.length - ("auto" === o.slidesPerView ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(o.slidesPerView, 10))) }),
                              s.currentTranslate < i.maxTranslate() && ((x = !1), o.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - g) ** S))),
                        x && (d.preventedByNestedSwiper = !0),
                        !i.allowSlideNext && "next" === i.swipeDirection && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate),
                        !i.allowSlidePrev && "prev" === i.swipeDirection && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate),
                        i.allowSlidePrev || i.allowSlideNext || (s.currentTranslate = s.startTranslate),
                        o.threshold > 0)
                    ) {
                        if (!(Math.abs(g) > o.threshold || s.allowThresholdMove)) return void (s.currentTranslate = s.startTranslate);
                        if (!s.allowThresholdMove)
                            return (s.allowThresholdMove = !0), (a.startX = a.currentX), (a.startY = a.currentY), (s.currentTranslate = s.startTranslate), void (a.diff = i.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY);
                    }
                    o.followFinger &&
                        !o.cssMode &&
                        (((o.freeMode && o.freeMode.enabled && i.freeMode) || o.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()),
                        o.freeMode && o.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(),
                        i.updateProgress(s.currentTranslate),
                        i.setTranslate(s.currentTranslate));
                }
                function w(e) {
                    const t = this,
                        i = t.touchEventsData;
                    let n,
                        s = e;
                    if ((s.originalEvent && (s = s.originalEvent), "touchend" === s.type || "touchcancel" === s.type)) {
                        if (((n = [...s.changedTouches].filter((e) => e.identifier === i.touchId)[0]), !n || n.identifier !== i.touchId)) return;
                    } else {
                        if (null !== i.touchId) return;
                        if (s.pointerId !== i.pointerId) return;
                        n = s;
                    }
                    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && (!["pointercancel", "contextmenu"].includes(s.type) || (!t.browser.isSafari && !t.browser.isWebView))) return;
                    (i.pointerId = null), (i.touchId = null);
                    const { params: o, touches: a, rtlTranslate: l, slidesGrid: c, enabled: u } = t;
                    if (!u) return;
                    if (!o.simulateTouch && "mouse" === s.pointerType) return;
                    if ((i.allowTouchCallbacks && t.emit("touchEnd", s), (i.allowTouchCallbacks = !1), !i.isTouched)) return i.isMoved && o.grabCursor && t.setGrabCursor(!1), (i.isMoved = !1), void (i.startMoving = !1);
                    o.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                    const d = (0, r.d)(),
                        h = d - i.touchStartTime;
                    if (t.allowClick) {
                        const e = s.path || (s.composedPath && s.composedPath());
                        t.updateClickedSlide((e && e[0]) || s.target, e), t.emit("tap click", s), h < 300 && d - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", s);
                    }
                    if (
                        ((i.lastClickTime = (0, r.d)()),
                        (0, r.n)(() => {
                            t.destroyed || (t.allowClick = !0);
                        }),
                        !i.isTouched || !i.isMoved || !t.swipeDirection || (0 === a.diff && !i.loopSwapReset) || (i.currentTranslate === i.startTranslate && !i.loopSwapReset))
                    )
                        return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
                    let f;
                    if (((i.isTouched = !1), (i.isMoved = !1), (i.startMoving = !1), (f = o.followFinger ? (l ? t.translate : -t.translate) : -i.currentTranslate), o.cssMode)) return;
                    if (o.freeMode && o.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: f });
                    let p = 0,
                        m = t.slidesSizesGrid[0];
                    for (let e = 0; e < c.length; e += e < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup) {
                        const t = e < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
                        void 0 !== c[e + t] ? f >= c[e] && f < c[e + t] && ((p = e), (m = c[e + t] - c[e])) : f >= c[e] && ((p = e), (m = c[c.length - 1] - c[c.length - 2]));
                    }
                    let g = null,
                        v = null;
                    o.rewind && (t.isBeginning ? (v = o.virtual && o.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1) : t.isEnd && (g = 0));
                    const b = (f - c[p]) / m,
                        y = p < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
                    if (h > o.longSwipesMs) {
                        if (!o.longSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && (b >= o.longSwipesRatio ? t.slideTo(o.rewind && t.isEnd ? g : p + y) : t.slideTo(p)),
                            "prev" === t.swipeDirection && (b > 1 - o.longSwipesRatio ? t.slideTo(p + y) : null !== v && b < 0 && Math.abs(b) > o.longSwipesRatio ? t.slideTo(v) : t.slideTo(p));
                    } else {
                        if (!o.shortSwipes) return void t.slideTo(t.activeIndex);
                        !t.navigation || (s.target !== t.navigation.nextEl && s.target !== t.navigation.prevEl)
                            ? ("next" === t.swipeDirection && t.slideTo(null !== g ? g : p + y), "prev" === t.swipeDirection && t.slideTo(null !== v ? v : p))
                            : s.target === t.navigation.nextEl
                            ? t.slideTo(p + y)
                            : t.slideTo(p);
                    }
                }
                function x() {
                    const e = this,
                        { params: t, el: i } = e;
                    if (i && 0 === i.offsetWidth) return;
                    t.breakpoints && e.setBreakpoint();
                    const { allowSlideNext: n, allowSlidePrev: r, snapGrid: s } = e,
                        o = e.virtual && e.params.virtual.enabled;
                    (e.allowSlideNext = !0), (e.allowSlidePrev = !0), e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
                    const a = o && t.loop;
                    !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || a
                        ? e.params.loop && !o
                            ? e.slideToLoop(e.realIndex, 0, !1, !0)
                            : e.slideTo(e.activeIndex, 0, !1, !0)
                        : e.slideTo(e.slides.length - 1, 0, !1, !0),
                        e.autoplay &&
                            e.autoplay.running &&
                            e.autoplay.paused &&
                            (clearTimeout(e.autoplay.resizeTimeout),
                            (e.autoplay.resizeTimeout = setTimeout(() => {
                                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
                            }, 500))),
                        (e.allowSlidePrev = r),
                        (e.allowSlideNext = n),
                        e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
                }
                function S(e) {
                    const t = this;
                    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
                }
                function E() {
                    const e = this,
                        { wrapperEl: t, rtlTranslate: i, enabled: n } = e;
                    if (!n) return;
                    let r;
                    (e.previousTranslate = e.translate), e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop), 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
                    const s = e.maxTranslate() - e.minTranslate();
                    (r = 0 === s ? 0 : (e.translate - e.minTranslate()) / s), r !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
                }
                function _(e) {
                    const t = this;
                    u(t, e.target), t.params.cssMode || ("auto" !== t.params.slidesPerView && !t.params.autoHeight) || t.update();
                }
                function T() {
                    const e = this;
                    e.documentTouchHandlerProceeded || ((e.documentTouchHandlerProceeded = !0), e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
                }
                const M = (e, t) => {
                        const i = (0, n.g)(),
                            { params: r, el: s, wrapperEl: o, device: a } = e,
                            l = !!r.nested,
                            c = "on" === t ? "addEventListener" : "removeEventListener",
                            u = t;
                        i[c]("touchstart", e.onDocumentTouchStart, { passive: !1, capture: l }),
                            s[c]("touchstart", e.onTouchStart, { passive: !1 }),
                            s[c]("pointerdown", e.onTouchStart, { passive: !1 }),
                            i[c]("touchmove", e.onTouchMove, { passive: !1, capture: l }),
                            i[c]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
                            i[c]("touchend", e.onTouchEnd, { passive: !0 }),
                            i[c]("pointerup", e.onTouchEnd, { passive: !0 }),
                            i[c]("pointercancel", e.onTouchEnd, { passive: !0 }),
                            i[c]("touchcancel", e.onTouchEnd, { passive: !0 }),
                            i[c]("pointerout", e.onTouchEnd, { passive: !0 }),
                            i[c]("pointerleave", e.onTouchEnd, { passive: !0 }),
                            i[c]("contextmenu", e.onTouchEnd, { passive: !0 }),
                            (r.preventClicks || r.preventClicksPropagation) && s[c]("click", e.onClick, !0),
                            r.cssMode && o[c]("scroll", e.onScroll),
                            r.updateOnWindowResize ? e[u](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", x, !0) : e[u]("observerUpdate", x, !0),
                            s[c]("load", e.onLoad, { capture: !0 });
                    },
                    P = (e, t) => e.grid && t.grid && t.grid.rows > 1;
                var C = {
                    init: !0,
                    direction: "horizontal",
                    oneWayMovement: !1,
                    touchEventsTarget: "wrapper",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    resizeObserver: !0,
                    nested: !1,
                    createElements: !1,
                    eventsPrefix: "swiper",
                    enabled: !0,
                    focusableElements: "input, select, option, textarea, button, video, label",
                    width: null,
                    height: null,
                    preventInteractionOnTransition: !1,
                    userAgent: null,
                    url: null,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    breakpointsBase: "window",
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    slidesPerGroupAuto: !1,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !0,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 5,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    loop: !1,
                    loopAddBlankSlides: !0,
                    loopAdditionalSlides: 0,
                    loopPreventsSliding: !0,
                    rewind: !1,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    maxBackfaceHiddenSlides: 10,
                    containerModifierClass: "swiper-",
                    slideClass: "swiper-slide",
                    slideBlankClass: "swiper-slide-blank",
                    slideActiveClass: "swiper-slide-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideFullyVisibleClass: "swiper-slide-fully-visible",
                    slideNextClass: "swiper-slide-next",
                    slidePrevClass: "swiper-slide-prev",
                    wrapperClass: "swiper-wrapper",
                    lazyPreloaderClass: "swiper-lazy-preloader",
                    lazyPreloadPrevNext: 0,
                    runCallbacksOnInit: !0,
                    _emitClasses: !1,
                };
                function O(e, t) {
                    return function (i) {
                        void 0 === i && (i = {});
                        const n = Object.keys(i)[0],
                            s = i[n];
                        "object" == typeof s && null !== s
                            ? (!0 === e[n] && (e[n] = { enabled: !0 }),
                              "navigation" === n && e[n] && e[n].enabled && !e[n].prevEl && !e[n].nextEl && (e[n].auto = !0),
                              ["pagination", "scrollbar"].indexOf(n) >= 0 && e[n] && e[n].enabled && !e[n].el && (e[n].auto = !0),
                              n in e && "enabled" in s ? ("object" != typeof e[n] || "enabled" in e[n] || (e[n].enabled = !0), e[n] || (e[n] = { enabled: !1 }), (0, r.t)(t, i)) : (0, r.t)(t, i))
                            : (0, r.t)(t, i);
                    };
                }
                const L = {
                        eventsEmitter: c,
                        update: f,
                        translate: {
                            getTranslate: function (e) {
                                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                                const { params: t, rtlTranslate: i, translate: n, wrapperEl: s } = this;
                                if (t.virtualTranslate) return i ? -n : n;
                                if (t.cssMode) return n;
                                let o = (0, r.i)(s, e);
                                return (o += this.cssOverflowAdjustment()), i && (o = -o), o || 0;
                            },
                            setTranslate: function (e, t) {
                                const i = this,
                                    { rtlTranslate: n, params: r, wrapperEl: s, progress: o } = i;
                                let a,
                                    l = 0,
                                    c = 0;
                                i.isHorizontal() ? (l = n ? -e : e) : (c = e),
                                    r.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
                                    (i.previousTranslate = i.translate),
                                    (i.translate = i.isHorizontal() ? l : c),
                                    r.cssMode
                                        ? (s[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -l : -c)
                                        : r.virtualTranslate || (i.isHorizontal() ? (l -= i.cssOverflowAdjustment()) : (c -= i.cssOverflowAdjustment()), (s.style.transform = `translate3d(${l}px, ${c}px, 0px)`));
                                const u = i.maxTranslate() - i.minTranslate();
                                (a = 0 === u ? 0 : (e - i.minTranslate()) / u), a !== o && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
                            },
                            minTranslate: function () {
                                return -this.snapGrid[0];
                            },
                            maxTranslate: function () {
                                return -this.snapGrid[this.snapGrid.length - 1];
                            },
                            translateTo: function (e, t, i, n, s) {
                                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === n && (n = !0);
                                const o = this,
                                    { params: a, wrapperEl: l } = o;
                                if (o.animating && a.preventInteractionOnTransition) return !1;
                                const c = o.minTranslate(),
                                    u = o.maxTranslate();
                                let d;
                                if (((d = n && e > c ? c : n && e < u ? u : e), o.updateProgress(d), a.cssMode)) {
                                    const e = o.isHorizontal();
                                    if (0 === t) l[e ? "scrollLeft" : "scrollTop"] = -d;
                                    else {
                                        if (!o.support.smoothScroll) return (0, r.q)({ swiper: o, targetPosition: -d, side: e ? "left" : "top" }), !0;
                                        l.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" });
                                    }
                                    return !0;
                                }
                                return (
                                    0 === t
                                        ? (o.setTransition(0), o.setTranslate(d), i && (o.emit("beforeTransitionStart", t, s), o.emit("transitionEnd")))
                                        : (o.setTransition(t),
                                          o.setTranslate(d),
                                          i && (o.emit("beforeTransitionStart", t, s), o.emit("transitionStart")),
                                          o.animating ||
                                              ((o.animating = !0),
                                              o.onTranslateToWrapperTransitionEnd ||
                                                  (o.onTranslateToWrapperTransitionEnd = function (e) {
                                                      o &&
                                                          !o.destroyed &&
                                                          e.target === this &&
                                                          (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                                                          (o.onTranslateToWrapperTransitionEnd = null),
                                                          delete o.onTranslateToWrapperTransitionEnd,
                                                          i && o.emit("transitionEnd"));
                                                  }),
                                              o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))),
                                    !0
                                );
                            },
                        },
                        transition: {
                            setTransition: function (e, t) {
                                const i = this;
                                i.params.cssMode || ((i.wrapperEl.style.transitionDuration = `${e}ms`), (i.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")), i.emit("setTransition", e, t);
                            },
                            transitionStart: function (e, t) {
                                void 0 === e && (e = !0);
                                const i = this,
                                    { params: n } = i;
                                n.cssMode || (n.autoHeight && i.updateAutoHeight(), p({ swiper: i, runCallbacks: e, direction: t, step: "Start" }));
                            },
                            transitionEnd: function (e, t) {
                                void 0 === e && (e = !0);
                                const i = this,
                                    { params: n } = i;
                                (i.animating = !1), n.cssMode || (i.setTransition(0), p({ swiper: i, runCallbacks: e, direction: t, step: "End" }));
                            },
                        },
                        slide: m,
                        loop: g,
                        grabCursor: {
                            setGrabCursor: function (e) {
                                const t = this;
                                if (!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
                                const i = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                                t.isElement && (t.__preventObserver__ = !0),
                                    (i.style.cursor = "move"),
                                    (i.style.cursor = e ? "grabbing" : "grab"),
                                    t.isElement &&
                                        requestAnimationFrame(() => {
                                            t.__preventObserver__ = !1;
                                        });
                            },
                            unsetGrabCursor: function () {
                                const e = this;
                                (e.params.watchOverflow && e.isLocked) ||
                                    e.params.cssMode ||
                                    (e.isElement && (e.__preventObserver__ = !0),
                                    (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
                                    e.isElement &&
                                        requestAnimationFrame(() => {
                                            e.__preventObserver__ = !1;
                                        }));
                            },
                        },
                        events: {
                            attachEvents: function () {
                                const e = this,
                                    { params: t } = e;
                                (e.onTouchStart = b.bind(e)),
                                    (e.onTouchMove = y.bind(e)),
                                    (e.onTouchEnd = w.bind(e)),
                                    (e.onDocumentTouchStart = T.bind(e)),
                                    t.cssMode && (e.onScroll = E.bind(e)),
                                    (e.onClick = S.bind(e)),
                                    (e.onLoad = _.bind(e)),
                                    M(e, "on");
                            },
                            detachEvents: function () {
                                M(this, "off");
                            },
                        },
                        breakpoints: {
                            setBreakpoint: function () {
                                const e = this,
                                    { realIndex: t, initialized: i, params: n, el: s } = e,
                                    o = n.breakpoints;
                                if (!o || (o && 0 === Object.keys(o).length)) return;
                                const a = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
                                if (!a || e.currentBreakpoint === a) return;
                                const l = (a in o ? o[a] : void 0) || e.originalParams,
                                    c = P(e, n),
                                    u = P(e, l),
                                    d = n.enabled;
                                c && !u
                                    ? (s.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), e.emitContainerClasses())
                                    : !c &&
                                      u &&
                                      (s.classList.add(`${n.containerModifierClass}grid`),
                                      ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === n.grid.fill)) && s.classList.add(`${n.containerModifierClass}grid-column`),
                                      e.emitContainerClasses()),
                                    ["navigation", "pagination", "scrollbar"].forEach((t) => {
                                        if (void 0 === l[t]) return;
                                        const i = n[t] && n[t].enabled,
                                            r = l[t] && l[t].enabled;
                                        i && !r && e[t].disable(), !i && r && e[t].enable();
                                    });
                                const h = l.direction && l.direction !== n.direction,
                                    f = n.loop && (l.slidesPerView !== n.slidesPerView || h),
                                    p = n.loop;
                                h && i && e.changeDirection(), (0, r.t)(e.params, l);
                                const m = e.params.enabled,
                                    g = e.params.loop;
                                Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                                    d && !m ? e.disable() : !d && m && e.enable(),
                                    (e.currentBreakpoint = a),
                                    e.emit("_beforeBreakpoint", l),
                                    i && (f ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !p && g ? (e.loopCreate(t), e.updateSlides()) : p && !g && e.loopDestroy()),
                                    e.emit("breakpoint", l);
                            },
                            getBreakpoint: function (e, t, i) {
                                if ((void 0 === t && (t = "window"), !e || ("container" === t && !i))) return;
                                let r = !1;
                                const s = (0, n.a)(),
                                    o = "window" === t ? s.innerHeight : i.clientHeight,
                                    a = Object.keys(e).map((e) => {
                                        if ("string" == typeof e && 0 === e.indexOf("@")) {
                                            const t = parseFloat(e.substr(1));
                                            return { value: o * t, point: e };
                                        }
                                        return { value: e, point: e };
                                    });
                                a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                                for (let e = 0; e < a.length; e += 1) {
                                    const { point: n, value: o } = a[e];
                                    "window" === t ? s.matchMedia(`(min-width: ${o}px)`).matches && (r = n) : o <= i.clientWidth && (r = n);
                                }
                                return r || "max";
                            },
                        },
                        checkOverflow: {
                            checkOverflow: function () {
                                const e = this,
                                    { isLocked: t, params: i } = e,
                                    { slidesOffsetBefore: n } = i;
                                if (n) {
                                    const t = e.slides.length - 1,
                                        i = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * n;
                                    e.isLocked = e.size > i;
                                } else e.isLocked = 1 === e.snapGrid.length;
                                !0 === i.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                                    !0 === i.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                                    t && t !== e.isLocked && (e.isEnd = !1),
                                    t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
                            },
                        },
                        classes: {
                            addClasses: function () {
                                const e = this,
                                    { classNames: t, params: i, rtl: n, el: r, device: s } = e,
                                    o = (function (e, t) {
                                        const i = [];
                                        return (
                                            e.forEach((e) => {
                                                "object" == typeof e
                                                    ? Object.keys(e).forEach((n) => {
                                                          e[n] && i.push(t + n);
                                                      })
                                                    : "string" == typeof e && i.push(t + e);
                                            }),
                                            i
                                        );
                                    })(
                                        [
                                            "initialized",
                                            i.direction,
                                            { "free-mode": e.params.freeMode && i.freeMode.enabled },
                                            { autoheight: i.autoHeight },
                                            { rtl: n },
                                            { grid: i.grid && i.grid.rows > 1 },
                                            { "grid-column": i.grid && i.grid.rows > 1 && "column" === i.grid.fill },
                                            { android: s.android },
                                            { ios: s.ios },
                                            { "css-mode": i.cssMode },
                                            { centered: i.cssMode && i.centeredSlides },
                                            { "watch-progress": i.watchSlidesProgress },
                                        ],
                                        i.containerModifierClass
                                    );
                                t.push(...o), r.classList.add(...t), e.emitContainerClasses();
                            },
                            removeClasses: function () {
                                const { el: e, classNames: t } = this;
                                e.classList.remove(...t), this.emitContainerClasses();
                            },
                        },
                    },
                    k = {};
                class A {
                    constructor() {
                        let e, t;
                        for (var i = arguments.length, s = new Array(i), c = 0; c < i; c++) s[c] = arguments[c];
                        1 === s.length && s[0].constructor && "Object" === Object.prototype.toString.call(s[0]).slice(8, -1) ? (t = s[0]) : ([e, t] = s), t || (t = {}), (t = (0, r.t)({}, t)), e && !t.el && (t.el = e);
                        const u = (0, n.g)();
                        if (t.el && "string" == typeof t.el && u.querySelectorAll(t.el).length > 1) {
                            const e = [];
                            return (
                                u.querySelectorAll(t.el).forEach((i) => {
                                    const n = (0, r.t)({}, t, { el: i });
                                    e.push(new A(n));
                                }),
                                e
                            );
                        }
                        const d = this;
                        var h;
                        (d.__swiper__ = !0),
                            (d.support = l()),
                            (d.device =
                                (void 0 === (h = { userAgent: t.userAgent }) && (h = {}),
                                o ||
                                    (o = (function (e) {
                                        let { userAgent: t } = void 0 === e ? {} : e;
                                        const i = l(),
                                            r = (0, n.a)(),
                                            s = r.navigator.platform,
                                            o = t || r.navigator.userAgent,
                                            a = { ios: !1, android: !1 },
                                            c = r.screen.width,
                                            u = r.screen.height,
                                            d = o.match(/(Android);?[\s\/]+([\d.]+)?/);
                                        let h = o.match(/(iPad).*OS\s([\d_]+)/);
                                        const f = o.match(/(iPod)(.*OS\s([\d_]+))?/),
                                            p = !h && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                                            m = "Win32" === s;
                                        let g = "MacIntel" === s;
                                        return (
                                            !h &&
                                                g &&
                                                i.touch &&
                                                ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${c}x${u}`) >= 0 &&
                                                ((h = o.match(/(Version)\/([\d.]+)/)), h || (h = [0, 1, "13_0_0"]), (g = !1)),
                                            d && !m && ((a.os = "android"), (a.android = !0)),
                                            (h || p || f) && ((a.os = "ios"), (a.ios = !0)),
                                            a
                                        );
                                    })(h)),
                                o)),
                            (d.browser =
                                (a ||
                                    (a = (function () {
                                        const e = (0, n.a)();
                                        let t = !1;
                                        function i() {
                                            const t = e.navigator.userAgent.toLowerCase();
                                            return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                                        }
                                        if (i()) {
                                            const i = String(e.navigator.userAgent);
                                            if (i.includes("Version/")) {
                                                const [e, n] = i
                                                    .split("Version/")[1]
                                                    .split(" ")[0]
                                                    .split(".")
                                                    .map((e) => Number(e));
                                                t = e < 16 || (16 === e && n < 2);
                                            }
                                        }
                                        return { isSafari: t || i(), needPerspectiveFix: t, isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent) };
                                    })()),
                                a)),
                            (d.eventsListeners = {}),
                            (d.eventsAnyListeners = []),
                            (d.modules = [...d.__modules__]),
                            t.modules && Array.isArray(t.modules) && d.modules.push(...t.modules);
                        const f = {};
                        d.modules.forEach((e) => {
                            e({ params: t, swiper: d, extendParams: O(t, f), on: d.on.bind(d), once: d.once.bind(d), off: d.off.bind(d), emit: d.emit.bind(d) });
                        });
                        const p = (0, r.t)({}, C, f);
                        return (
                            (d.params = (0, r.t)({}, p, k, t)),
                            (d.originalParams = (0, r.t)({}, d.params)),
                            (d.passedParams = (0, r.t)({}, t)),
                            d.params &&
                                d.params.on &&
                                Object.keys(d.params.on).forEach((e) => {
                                    d.on(e, d.params.on[e]);
                                }),
                            d.params && d.params.onAny && d.onAny(d.params.onAny),
                            Object.assign(d, {
                                enabled: d.params.enabled,
                                el: e,
                                classNames: [],
                                slides: [],
                                slidesGrid: [],
                                snapGrid: [],
                                slidesSizesGrid: [],
                                isHorizontal() {
                                    return "horizontal" === d.params.direction;
                                },
                                isVertical() {
                                    return "vertical" === d.params.direction;
                                },
                                activeIndex: 0,
                                realIndex: 0,
                                isBeginning: !0,
                                isEnd: !1,
                                translate: 0,
                                previousTranslate: 0,
                                progress: 0,
                                velocity: 0,
                                animating: !1,
                                cssOverflowAdjustment() {
                                    return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                                },
                                allowSlideNext: d.params.allowSlideNext,
                                allowSlidePrev: d.params.allowSlidePrev,
                                touchEventsData: {
                                    isTouched: void 0,
                                    isMoved: void 0,
                                    allowTouchCallbacks: void 0,
                                    touchStartTime: void 0,
                                    isScrolling: void 0,
                                    currentTranslate: void 0,
                                    startTranslate: void 0,
                                    allowThresholdMove: void 0,
                                    focusableElements: d.params.focusableElements,
                                    lastClickTime: 0,
                                    clickTimeout: void 0,
                                    velocities: [],
                                    allowMomentumBounce: void 0,
                                    startMoving: void 0,
                                    pointerId: null,
                                    touchId: null,
                                },
                                allowClick: !0,
                                allowTouchMove: d.params.allowTouchMove,
                                touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                                imagesToLoad: [],
                                imagesLoaded: 0,
                            }),
                            d.emit("_swiper"),
                            d.params.init && d.init(),
                            d
                        );
                    }
                    getDirectionLabel(e) {
                        return this.isHorizontal()
                            ? e
                            : {
                                  width: "height",
                                  "margin-top": "margin-left",
                                  "margin-bottom ": "margin-right",
                                  "margin-left": "margin-top",
                                  "margin-right": "margin-bottom",
                                  "padding-left": "padding-top",
                                  "padding-right": "padding-bottom",
                                  marginRight: "marginBottom",
                              }[e];
                    }
                    getSlideIndex(e) {
                        const { slidesEl: t, params: i } = this,
                            n = (0, r.e)(t, `.${i.slideClass}, swiper-slide`),
                            s = (0, r.g)(n[0]);
                        return (0, r.g)(e) - s;
                    }
                    getSlideIndexByData(e) {
                        return this.getSlideIndex(this.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0]);
                    }
                    recalcSlides() {
                        const { slidesEl: e, params: t } = this;
                        this.slides = (0, r.e)(e, `.${t.slideClass}, swiper-slide`);
                    }
                    enable() {
                        const e = this;
                        e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
                    }
                    disable() {
                        const e = this;
                        e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
                    }
                    setProgress(e, t) {
                        const i = this;
                        e = Math.min(Math.max(e, 0), 1);
                        const n = i.minTranslate(),
                            r = (i.maxTranslate() - n) * e + n;
                        i.translateTo(r, void 0 === t ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses();
                    }
                    emitContainerClasses() {
                        const e = this;
                        if (!e.params._emitClasses || !e.el) return;
                        const t = e.el.className.split(" ").filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
                        e.emit("_containerClasses", t.join(" "));
                    }
                    getSlideClasses(e) {
                        const t = this;
                        return t.destroyed
                            ? ""
                            : e.className
                                  .split(" ")
                                  .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
                                  .join(" ");
                    }
                    emitSlidesClasses() {
                        const e = this;
                        if (!e.params._emitClasses || !e.el) return;
                        const t = [];
                        e.slides.forEach((i) => {
                            const n = e.getSlideClasses(i);
                            t.push({ slideEl: i, classNames: n }), e.emit("_slideClass", i, n);
                        }),
                            e.emit("_slideClasses", t);
                    }
                    slidesPerViewDynamic(e, t) {
                        void 0 === e && (e = "current"), void 0 === t && (t = !1);
                        const { params: i, slides: n, slidesGrid: r, slidesSizesGrid: s, size: o, activeIndex: a } = this;
                        let l = 1;
                        if ("number" == typeof i.slidesPerView) return i.slidesPerView;
                        if (i.centeredSlides) {
                            let e,
                                t = n[a] ? n[a].swiperSlideSize : 0;
                            for (let i = a + 1; i < n.length; i += 1) n[i] && !e && ((t += n[i].swiperSlideSize), (l += 1), t > o && (e = !0));
                            for (let i = a - 1; i >= 0; i -= 1) n[i] && !e && ((t += n[i].swiperSlideSize), (l += 1), t > o && (e = !0));
                        } else if ("current" === e) for (let e = a + 1; e < n.length; e += 1) (t ? r[e] + s[e] - r[a] < o : r[e] - r[a] < o) && (l += 1);
                        else for (let e = a - 1; e >= 0; e -= 1) r[a] - r[e] < o && (l += 1);
                        return l;
                    }
                    update() {
                        const e = this;
                        if (!e || e.destroyed) return;
                        const { snapGrid: t, params: i } = e;
                        function n() {
                            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                                i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                            e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
                        }
                        let r;
                        if (
                            (i.breakpoints && e.setBreakpoint(),
                            [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
                                t.complete && u(e, t);
                            }),
                            e.updateSize(),
                            e.updateSlides(),
                            e.updateProgress(),
                            e.updateSlidesClasses(),
                            i.freeMode && i.freeMode.enabled && !i.cssMode)
                        )
                            n(), i.autoHeight && e.updateAutoHeight();
                        else {
                            if (("auto" === i.slidesPerView || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides) {
                                const t = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
                                r = e.slideTo(t.length - 1, 0, !1, !0);
                            } else r = e.slideTo(e.activeIndex, 0, !1, !0);
                            r || n();
                        }
                        i.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
                    }
                    changeDirection(e, t) {
                        void 0 === t && (t = !0);
                        const i = this,
                            n = i.params.direction;
                        return (
                            e || (e = "horizontal" === n ? "vertical" : "horizontal"),
                            e === n ||
                                ("horizontal" !== e && "vertical" !== e) ||
                                (i.el.classList.remove(`${i.params.containerModifierClass}${n}`),
                                i.el.classList.add(`${i.params.containerModifierClass}${e}`),
                                i.emitContainerClasses(),
                                (i.params.direction = e),
                                i.slides.forEach((t) => {
                                    "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                                }),
                                i.emit("changeDirection"),
                                t && i.update()),
                            i
                        );
                    }
                    changeLanguageDirection(e) {
                        const t = this;
                        (t.rtl && "rtl" === e) ||
                            (!t.rtl && "ltr" === e) ||
                            ((t.rtl = "rtl" === e),
                            (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
                            t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl")) : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
                            t.update());
                    }
                    mount(e) {
                        const t = this;
                        if (t.mounted) return !0;
                        let i = e || t.params.el;
                        if (("string" == typeof i && (i = document.querySelector(i)), !i)) return !1;
                        (i.swiper = t), i.parentNode && i.parentNode.host && "SWIPER-CONTAINER" === i.parentNode.host.nodeName && (t.isElement = !0);
                        const n = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                        let s = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(n()) : (0, r.e)(i, n())[0];
                        return (
                            !s &&
                                t.params.createElements &&
                                ((s = (0, r.c)("div", t.params.wrapperClass)),
                                i.append(s),
                                (0, r.e)(i, `.${t.params.slideClass}`).forEach((e) => {
                                    s.append(e);
                                })),
                            Object.assign(t, {
                                el: i,
                                wrapperEl: s,
                                slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : s,
                                hostEl: t.isElement ? i.parentNode.host : i,
                                mounted: !0,
                                rtl: "rtl" === i.dir.toLowerCase() || "rtl" === (0, r.m)(i, "direction"),
                                rtlTranslate: "horizontal" === t.params.direction && ("rtl" === i.dir.toLowerCase() || "rtl" === (0, r.m)(i, "direction")),
                                wrongRTL: "-webkit-box" === (0, r.m)(s, "display"),
                            }),
                            !0
                        );
                    }
                    init(e) {
                        const t = this;
                        if (t.initialized) return t;
                        if (!1 === t.mount(e)) return t;
                        t.emit("beforeInit"),
                            t.params.breakpoints && t.setBreakpoint(),
                            t.addClasses(),
                            t.updateSize(),
                            t.updateSlides(),
                            t.params.watchOverflow && t.checkOverflow(),
                            t.params.grabCursor && t.enabled && t.setGrabCursor(),
                            t.params.loop && t.virtual && t.params.virtual.enabled
                                ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
                                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                            t.params.loop && t.loopCreate(),
                            t.attachEvents();
                        const i = [...t.el.querySelectorAll('[loading="lazy"]')];
                        return (
                            t.isElement && i.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
                            i.forEach((e) => {
                                e.complete
                                    ? u(t, e)
                                    : e.addEventListener("load", (e) => {
                                          u(t, e.target);
                                      });
                            }),
                            h(t),
                            (t.initialized = !0),
                            h(t),
                            t.emit("init"),
                            t.emit("afterInit"),
                            t
                        );
                    }
                    destroy(e, t) {
                        void 0 === e && (e = !0), void 0 === t && (t = !0);
                        const i = this,
                            { params: n, el: s, wrapperEl: o, slides: a } = i;
                        return (
                            void 0 === i.params ||
                                i.destroyed ||
                                (i.emit("beforeDestroy"),
                                (i.initialized = !1),
                                i.detachEvents(),
                                n.loop && i.loopDestroy(),
                                t &&
                                    (i.removeClasses(),
                                    s.removeAttribute("style"),
                                    o.removeAttribute("style"),
                                    a &&
                                        a.length &&
                                        a.forEach((e) => {
                                            e.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
                                        })),
                                i.emit("destroy"),
                                Object.keys(i.eventsListeners).forEach((e) => {
                                    i.off(e);
                                }),
                                !1 !== e && ((i.el.swiper = null), (0, r.u)(i)),
                                (i.destroyed = !0)),
                            null
                        );
                    }
                    static extendDefaults(e) {
                        (0, r.t)(k, e);
                    }
                    static get extendedDefaults() {
                        return k;
                    }
                    static get defaults() {
                        return C;
                    }
                    static installModule(e) {
                        A.prototype.__modules__ || (A.prototype.__modules__ = []);
                        const t = A.prototype.__modules__;
                        "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
                    }
                    static use(e) {
                        return Array.isArray(e) ? (e.forEach((e) => A.installModule(e)), A) : (A.installModule(e), A);
                    }
                }
                Object.keys(L).forEach((e) => {
                    Object.keys(L[e]).forEach((t) => {
                        A.prototype[t] = L[e][t];
                    });
                }),
                    A.use([
                        function (e) {
                            let { swiper: t, on: i, emit: r } = e;
                            const s = (0, n.a)();
                            let o = null,
                                a = null;
                            const l = () => {
                                    t && !t.destroyed && t.initialized && (r("beforeResize"), r("resize"));
                                },
                                c = () => {
                                    t && !t.destroyed && t.initialized && r("orientationchange");
                                };
                            i("init", () => {
                                t.params.resizeObserver && void 0 !== s.ResizeObserver
                                    ? t &&
                                      !t.destroyed &&
                                      t.initialized &&
                                      ((o = new ResizeObserver((e) => {
                                          a = s.requestAnimationFrame(() => {
                                              const { width: i, height: n } = t;
                                              let r = i,
                                                  s = n;
                                              e.forEach((e) => {
                                                  let { contentBoxSize: i, contentRect: n, target: o } = e;
                                                  (o && o !== t.el) || ((r = n ? n.width : (i[0] || i).inlineSize), (s = n ? n.height : (i[0] || i).blockSize));
                                              }),
                                                  (r === i && s === n) || l();
                                          });
                                      })),
                                      o.observe(t.el))
                                    : (s.addEventListener("resize", l), s.addEventListener("orientationchange", c));
                            }),
                                i("destroy", () => {
                                    a && s.cancelAnimationFrame(a), o && o.unobserve && t.el && (o.unobserve(t.el), (o = null)), s.removeEventListener("resize", l), s.removeEventListener("orientationchange", c);
                                });
                        },
                        function (e) {
                            let { swiper: t, extendParams: i, on: s, emit: o } = e;
                            const a = [],
                                l = (0, n.a)(),
                                c = function (e, i) {
                                    void 0 === i && (i = {});
                                    const n = new (l.MutationObserver || l.WebkitMutationObserver)((e) => {
                                        if (t.__preventObserver__) return;
                                        if (1 === e.length) return void o("observerUpdate", e[0]);
                                        const i = function () {
                                            o("observerUpdate", e[0]);
                                        };
                                        l.requestAnimationFrame ? l.requestAnimationFrame(i) : l.setTimeout(i, 0);
                                    });
                                    n.observe(e, { attributes: void 0 === i.attributes || i.attributes, childList: void 0 === i.childList || i.childList, characterData: void 0 === i.characterData || i.characterData }), a.push(n);
                                };
                            i({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                                s("init", () => {
                                    if (t.params.observer) {
                                        if (t.params.observeParents) {
                                            const e = (0, r.a)(t.hostEl);
                                            for (let t = 0; t < e.length; t += 1) c(e[t]);
                                        }
                                        c(t.hostEl, { childList: t.params.observeSlideChildren }), c(t.wrapperEl, { attributes: !1 });
                                    }
                                }),
                                s("destroy", () => {
                                    a.forEach((e) => {
                                        e.disconnect();
                                    }),
                                        a.splice(0, a.length);
                                });
                        },
                    ]);
            },
        },
        t = {};
    function i(n) {
        var r = t[n];
        if (void 0 !== r) return r.exports;
        var s = (t[n] = { exports: {} });
        return e[n](s, s.exports, i), s.exports;
    }
    (i.d = function (e, t) {
        for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
        (i.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (function () {
            "use strict";
            i(1983);
            var e,
                t = (e = i(115)) && e.__esModule ? e : { default: e };
            t.default._babelPolyfill &&
                "undefined" != typeof console &&
                console.warn &&
                console.warn(
                    "@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."
                ),
                (t.default._babelPolyfill = !0);
        })(),
        (function () {
            "use strict";
            var e = a(i(7652)),
                t = i(4097),
                n = a(i(6358)),
                r = i(9092),
                s = i(393),
                o = i(5116);
            function a(e) {
                return e && e.__esModule ? e : { default: e };
            }
            n.default.registerPlugin(r.ScrollTrigger),
                e.default.use([t.Autoplay, t.EffectFade, t.Pagination]),
                (window.tablet = 1024),
                window.addEventListener("load", async () => {
                    var t, i;
                    null === (t = document.querySelectorAll(".important_none")) || void 0 === t || t.forEach((e) => e.classList.remove("important_none")),
                        null === (i = Array.from(document.querySelectorAll(".js-preview-card"))) || void 0 === i || i.map((e) => new o.CardPreview(e)),
                        new s.FadeTextAnimation(),
                        new s.FadeElementsAnimation(),
                        new o.Form({ form: ".js-subscribe-form" }),
                        new e.default(".new-collection .new-collection__bg-slider", { slidesPerView: 1, loop: !0, speed: 1e3, effect: "fade", autoplay: { delay: 3e3 } });
                    const n = new s.Header();
                    new s.Navigation(), new s.HeroSection(), new s.CollectionsFilter(), (window.single = new s.SingleProduct({ header: n }));
                });
        })();
})();

document.addEventListener("DOMContentLoaded", () => {
    const size_container = document.querySelector('.section--page .customize-template .single-product-sizes')

    if (size_container) {
        const tabs_buttons = document.querySelectorAll('.single-product-sizes__tabs-head .js-tab-btn')
        const tabs_tables = document.querySelectorAll('.single-product-sizes__tabs-body .js-tab-tables')
        tabSwitcherListener(tabs_buttons, tabs_tables)
    }
})

function tabSwitcherListener(tabs_buttons, tabs_tables) {
    tabs_buttons[0].classList.add('_active')
    tabs_tables[0].classList.add('_active')
    metricListener(tabs_tables)

    tabs_buttons.forEach(tab_btn => {
        tab_btn.addEventListener("click", () => {
            if (!tab_btn.classList.contains('_active')) {
                resetTabButtons(tabs_buttons)
                resetTabTables(tabs_tables)
                tab_btn.classList.add('_active')
                document.getElementById(tab_btn.getAttribute('data-tab-id')).classList.add('_active')
            }
        })
    })
}

function resetTabButtons(tabs_buttons) {
    tabs_buttons.forEach(tab_btn => {
        tab_btn.classList.remove('_active')
    })
}

function resetTabTables(tabs_tables) {
    tabs_tables.forEach(tab_table => {
        tab_table.classList.remove('_active')
    })
}

function resetMetricBtns(metric_btns) {
    metric_btns.forEach(metric_btn => {
        metric_btn.classList.remove('_active')
    })
}

function metricListener(tabs_tables) {
    const metric_btns = document.querySelectorAll('.single-product-sizes__tabs-row .js-single-product-unit-button')
    const ceils = document.querySelectorAll('.js-single-product-unit-item')
    let active_metric = document.querySelector('.single-product-sizes__tabs-row .js-single-product-unit-button._active').getAttribute('data-unit')
    ceils.forEach(ceil => {
        ceil.innerHTML = ceil.getAttribute(`data-${active_metric}`)
    })

    metric_btns.forEach(metric_btn => {
        metric_btn.addEventListener('click', () => {
            if (!metric_btn.classList.contains('_active')) {
                resetMetricBtns(metric_btns)
                metric_btn.classList.add('_active')
                active_metric = metric_btn.getAttribute('data-unit')

                ceils.forEach(ceil => {
                    ceil.innerHTML = ceil.getAttribute(`data-${active_metric}`)
                })
            }
        })
    })
}